;(function (t) {
  const e = (t['en'] = t['en'] || {})
  e.dictionary = Object.assign(e.dictionary || {}, {
    '%0 of %1': '%0 of %1',
    Aquamarine: 'Aquamarine',
    Black: 'Black',
    'Block quote': 'Block quote',
    Blue: 'Blue',
    Bold: 'Bold',
    'Break text': 'Break text',
    'Bulleted List': 'Bulleted List',
    Cancel: 'Cancel',
    'Cannot determine a category for the uploaded file.':
      'Cannot determine a category for the uploaded file.',
    'Cannot upload file:': 'Cannot upload file:',
    'Caption for image: %0': 'Caption for image: %0',
    'Caption for the image': 'Caption for the image',
    'Centered image': 'Centered image',
    'Change image text alternative': 'Change image text alternative',
    'Choose heading': 'Choose heading',
    Column: 'Column',
    'Decrease indent': 'Decrease indent',
    'Delete column': 'Delete column',
    'Delete row': 'Delete row',
    'Dim grey': 'Dim grey',
    Downloadable: 'Downloadable',
    'Dropdown toolbar': 'Dropdown toolbar',
    'Edit block': 'Edit block',
    'Edit link': 'Edit link',
    'Editor block content toolbar': 'Editor block content toolbar',
    'Editor contextual toolbar': 'Editor contextual toolbar',
    'Editor editing area: %0': 'Editor editing area: %0',
    'Editor toolbar': 'Editor toolbar',
    'Enter image caption': 'Enter image caption',
    'Full size image': 'Full size image',
    Green: 'Green',
    Grey: 'Grey',
    'Header column': 'Header column',
    'Header row': 'Header row',
    Heading: 'Heading',
    'Heading 1': 'Heading 1',
    'Heading 2': 'Heading 2',
    'Heading 3': 'Heading 3',
    'Heading 4': 'Heading 4',
    'Heading 5': 'Heading 5',
    'Heading 6': 'Heading 6',
    'Image toolbar': 'Image toolbar',
    'image widget': 'image widget',
    'In line': 'In line',
    'Increase indent': 'Increase indent',
    'Insert column left': 'Insert column left',
    'Insert column right': 'Insert column right',
    'Insert image': 'Insert image',
    'Insert media': 'Insert media',
    'Insert paragraph after block': 'Insert paragraph after block',
    'Insert paragraph before block': 'Insert paragraph before block',
    'Insert row above': 'Insert row above',
    'Insert row below': 'Insert row below',
    'Insert table': 'Insert table',
    Italic: 'Italic',
    'Left aligned image': 'Left aligned image',
    'Light blue': 'Light blue',
    'Light green': 'Light green',
    'Light grey': 'Light grey',
    Link: 'Link',
    'Link URL': 'Link URL',
    'Media URL': 'Media URL',
    'media widget': 'media widget',
    'Merge cell down': 'Merge cell down',
    'Merge cell left': 'Merge cell left',
    'Merge cell right': 'Merge cell right',
    'Merge cell up': 'Merge cell up',
    'Merge cells': 'Merge cells',
    Next: 'Next',
    'Numbered List': 'Numbered List',
    'Open file manager': 'Open file manager',
    'Open in a new tab': 'Open in a new tab',
    'Open link in new tab': 'Open link in new tab',
    'Open media in new tab': 'Open media in new tab',
    Orange: 'Orange',
    Paragraph: 'Paragraph',
    'Paste the media URL in the input.': 'Paste the media URL in the input.',
    'Press Enter to type after or press Shift + Enter to type before the widget':
      'Press Enter to type after or press Shift + Enter to type before the widget',
    Previous: 'Previous',
    Purple: 'Purple',
    Red: 'Red',
    Redo: 'Redo',
    'Rich Text Editor': 'Rich Text Editor',
    'Right aligned image': 'Right aligned image',
    Row: 'Row',
    Save: 'Save',
    'Select all': 'Select all',
    'Select column': 'Select column',
    'Select row': 'Select row',
    'Show more items': 'Show more items',
    'Side image': 'Side image',
    'Split cell horizontally': 'Split cell horizontally',
    'Split cell vertically': 'Split cell vertically',
    'Table toolbar': 'Table toolbar',
    'Text alternative': 'Text alternative',
    'The URL must not be empty.': 'The URL must not be empty.',
    'This link has no URL': 'This link has no URL',
    'This media URL is not supported.': 'This media URL is not supported.',
    'Tip: Paste the URL into the content to embed faster.':
      'Tip: Paste the URL into the content to embed faster.',
    'Toggle caption off': 'Toggle caption off',
    'Toggle caption on': 'Toggle caption on',
    Turquoise: 'Turquoise',
    Undo: 'Undo',
    Unlink: 'Unlink',
    'Upload failed': 'Upload failed',
    'Upload in progress': 'Upload in progress',
    White: 'White',
    'Widget toolbar': 'Widget toolbar',
    'Wrap text': 'Wrap text',
    Yellow: 'Yellow'
  })
})(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {}))
/*!
 * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */ ;(function t(e, n) {
  if (typeof exports === 'object' && typeof module === 'object')
    module.exports = n()
  else if (typeof define === 'function' && define.amd) define([], n)
  else if (typeof exports === 'object') exports['ClassicEditor'] = n()
  else e['ClassicEditor'] = n()
})(self, () =>
  (() => {
    var __webpack_modules__ = {
      6209: () => {
        'use strict'
        var md5
        var __WEBPACK_DEFAULT_EXPORT__ = md5
        ;(function () {
          var HxOverrides = function () {}
          HxOverrides.__name__ = true
          HxOverrides.dateStr = function (t) {
            var e = t.getMonth() + 1
            var n = t.getDate()
            var i = t.getHours()
            var o = t.getMinutes()
            var r = t.getSeconds()
            return (
              t.getFullYear() +
              '-' +
              (e < 10 ? '0' + e : '' + e) +
              '-' +
              (n < 10 ? '0' + n : '' + n) +
              ' ' +
              (i < 10 ? '0' + i : '' + i) +
              ':' +
              (o < 10 ? '0' + o : '' + o) +
              ':' +
              (r < 10 ? '0' + r : '' + r)
            )
          }
          HxOverrides.strDate = function (t) {
            switch (t.length) {
              case 8:
                var e = t.split(':')
                var n = new Date()
                n.setTime(0)
                n.setUTCHours(e[0])
                n.setUTCMinutes(e[1])
                n.setUTCSeconds(e[2])
                return n
              case 10:
                var e = t.split('-')
                return new Date(e[0], e[1] - 1, e[2], 0, 0, 0)
              case 19:
                var e = t.split(' ')
                var i = e[0].split('-')
                var o = e[1].split(':')
                return new Date(i[0], i[1] - 1, i[2], o[0], o[1], o[2])
              default:
                throw 'Invalid date format : ' + t
            }
          }
          HxOverrides.cca = function (t, e) {
            var n = t.charCodeAt(e)
            if (n != n) return undefined
            return n
          }
          HxOverrides.substr = function (t, e, n) {
            if (e != null && e != 0 && n != null && n < 0) return ''
            if (n == null) n = t.length
            if (e < 0) {
              e = t.length + e
              if (e < 0) e = 0
            } else if (n < 0) n = t.length + n - e
            return t.substr(e, n)
          }
          HxOverrides.remove = function (t, e) {
            var n = 0
            var i = t.length
            while (n < i) {
              if (t[n] == e) {
                t.splice(n, 1)
                return true
              }
              n++
            }
            return false
          }
          HxOverrides.iter = function (t) {
            return {
              cur: 0,
              arr: t,
              hasNext: function () {
                return this.cur < this.arr.length
              },
              next: function () {
                return this.arr[this.cur++]
              }
            }
          }
          var IntIter = function (t, e) {
            this.min = t
            this.max = e
          }
          IntIter.__name__ = true
          IntIter.prototype = {
            next: function () {
              return this.min++
            },
            hasNext: function () {
              return this.min < this.max
            },
            __class__: IntIter
          }
          var Std = function () {}
          Std.__name__ = true
          Std['is'] = function (t, e) {
            return js.Boot.__instanceof(t, e)
          }
          Std.string = function (t) {
            return js.Boot.__string_rec(t, '')
          }
          Std['int'] = function (t) {
            return t | 0
          }
          Std.parseInt = function (t) {
            var e = parseInt(t, 10)
            if (
              e == 0 &&
              (HxOverrides.cca(t, 1) == 120 || HxOverrides.cca(t, 1) == 88)
            )
              e = parseInt(t)
            if (isNaN(e)) return null
            return e
          }
          Std.parseFloat = function (t) {
            return parseFloat(t)
          }
          Std.random = function (t) {
            return Math.floor(Math.random() * t)
          }
          var com = com || {}
          if (!com.wiris) com.wiris = {}
          if (!com.wiris.js) com.wiris.js = {}
          com.wiris.js.JsPluginTools = function () {
            this.tryReady()
          }
          com.wiris.js.JsPluginTools.__name__ = true
          com.wiris.js.JsPluginTools.main = function () {
            var t
            t = com.wiris.js.JsPluginTools.getInstance()
            haxe.Timer.delay($bind(t, t.tryReady), 100)
          }
          com.wiris.js.JsPluginTools.getInstance = function () {
            if (com.wiris.js.JsPluginTools.instance == null)
              com.wiris.js.JsPluginTools.instance =
                new com.wiris.js.JsPluginTools()
            return com.wiris.js.JsPluginTools.instance
          }
          com.wiris.js.JsPluginTools.bypassEncapsulation = function () {
            if (window.com == null) window.com = {}
            if (window.com.wiris == null) window.com.wiris = {}
            if (window.com.wiris.js == null) window.com.wiris.js = {}
            if (window.com.wiris.js.JsPluginTools == null)
              window.com.wiris.js.JsPluginTools =
                com.wiris.js.JsPluginTools.getInstance()
          }
          com.wiris.js.JsPluginTools.prototype = {
            md5encode: function (t) {
              return haxe.Md5.encode(t)
            },
            doLoad: function () {
              this.ready = true
              com.wiris.js.JsPluginTools.instance = this
              com.wiris.js.JsPluginTools.bypassEncapsulation()
            },
            tryReady: function () {
              this.ready = false
              if (js.Lib.document.readyState) {
                this.doLoad()
                this.ready = true
              }
              if (!this.ready) haxe.Timer.delay($bind(this, this.tryReady), 100)
            },
            __class__: com.wiris.js.JsPluginTools
          }
          var haxe = haxe || {}
          haxe.Log = function () {}
          haxe.Log.__name__ = true
          haxe.Log.trace = function (t, e) {
            js.Boot.__trace(t, e)
          }
          haxe.Log.clear = function () {
            js.Boot.__clear_trace()
          }
          haxe.Md5 = function () {}
          haxe.Md5.__name__ = true
          haxe.Md5.encode = function (t) {
            return new haxe.Md5().doEncode(t)
          }
          haxe.Md5.prototype = {
            doEncode: function (t) {
              var e = this.str2blks(t)
              var n = 1732584193
              var i = -271733879
              var o = -1732584194
              var r = 271733878
              var s
              var a = 0
              while (a < e.length) {
                var c = n
                var l = i
                var d = o
                var u = r
                s = 0
                n = this.ff(n, i, o, r, e[a], 7, -680876936)
                r = this.ff(r, n, i, o, e[a + 1], 12, -389564586)
                o = this.ff(o, r, n, i, e[a + 2], 17, 606105819)
                i = this.ff(i, o, r, n, e[a + 3], 22, -1044525330)
                n = this.ff(n, i, o, r, e[a + 4], 7, -176418897)
                r = this.ff(r, n, i, o, e[a + 5], 12, 1200080426)
                o = this.ff(o, r, n, i, e[a + 6], 17, -1473231341)
                i = this.ff(i, o, r, n, e[a + 7], 22, -45705983)
                n = this.ff(n, i, o, r, e[a + 8], 7, 1770035416)
                r = this.ff(r, n, i, o, e[a + 9], 12, -1958414417)
                o = this.ff(o, r, n, i, e[a + 10], 17, -42063)
                i = this.ff(i, o, r, n, e[a + 11], 22, -1990404162)
                n = this.ff(n, i, o, r, e[a + 12], 7, 1804603682)
                r = this.ff(r, n, i, o, e[a + 13], 12, -40341101)
                o = this.ff(o, r, n, i, e[a + 14], 17, -1502002290)
                i = this.ff(i, o, r, n, e[a + 15], 22, 1236535329)
                n = this.gg(n, i, o, r, e[a + 1], 5, -165796510)
                r = this.gg(r, n, i, o, e[a + 6], 9, -1069501632)
                o = this.gg(o, r, n, i, e[a + 11], 14, 643717713)
                i = this.gg(i, o, r, n, e[a], 20, -373897302)
                n = this.gg(n, i, o, r, e[a + 5], 5, -701558691)
                r = this.gg(r, n, i, o, e[a + 10], 9, 38016083)
                o = this.gg(o, r, n, i, e[a + 15], 14, -660478335)
                i = this.gg(i, o, r, n, e[a + 4], 20, -405537848)
                n = this.gg(n, i, o, r, e[a + 9], 5, 568446438)
                r = this.gg(r, n, i, o, e[a + 14], 9, -1019803690)
                o = this.gg(o, r, n, i, e[a + 3], 14, -187363961)
                i = this.gg(i, o, r, n, e[a + 8], 20, 1163531501)
                n = this.gg(n, i, o, r, e[a + 13], 5, -1444681467)
                r = this.gg(r, n, i, o, e[a + 2], 9, -51403784)
                o = this.gg(o, r, n, i, e[a + 7], 14, 1735328473)
                i = this.gg(i, o, r, n, e[a + 12], 20, -1926607734)
                n = this.hh(n, i, o, r, e[a + 5], 4, -378558)
                r = this.hh(r, n, i, o, e[a + 8], 11, -2022574463)
                o = this.hh(o, r, n, i, e[a + 11], 16, 1839030562)
                i = this.hh(i, o, r, n, e[a + 14], 23, -35309556)
                n = this.hh(n, i, o, r, e[a + 1], 4, -1530992060)
                r = this.hh(r, n, i, o, e[a + 4], 11, 1272893353)
                o = this.hh(o, r, n, i, e[a + 7], 16, -155497632)
                i = this.hh(i, o, r, n, e[a + 10], 23, -1094730640)
                n = this.hh(n, i, o, r, e[a + 13], 4, 681279174)
                r = this.hh(r, n, i, o, e[a], 11, -358537222)
                o = this.hh(o, r, n, i, e[a + 3], 16, -722521979)
                i = this.hh(i, o, r, n, e[a + 6], 23, 76029189)
                n = this.hh(n, i, o, r, e[a + 9], 4, -640364487)
                r = this.hh(r, n, i, o, e[a + 12], 11, -421815835)
                o = this.hh(o, r, n, i, e[a + 15], 16, 530742520)
                i = this.hh(i, o, r, n, e[a + 2], 23, -995338651)
                n = this.ii(n, i, o, r, e[a], 6, -198630844)
                r = this.ii(r, n, i, o, e[a + 7], 10, 1126891415)
                o = this.ii(o, r, n, i, e[a + 14], 15, -1416354905)
                i = this.ii(i, o, r, n, e[a + 5], 21, -57434055)
                n = this.ii(n, i, o, r, e[a + 12], 6, 1700485571)
                r = this.ii(r, n, i, o, e[a + 3], 10, -1894986606)
                o = this.ii(o, r, n, i, e[a + 10], 15, -1051523)
                i = this.ii(i, o, r, n, e[a + 1], 21, -2054922799)
                n = this.ii(n, i, o, r, e[a + 8], 6, 1873313359)
                r = this.ii(r, n, i, o, e[a + 15], 10, -30611744)
                o = this.ii(o, r, n, i, e[a + 6], 15, -1560198380)
                i = this.ii(i, o, r, n, e[a + 13], 21, 1309151649)
                n = this.ii(n, i, o, r, e[a + 4], 6, -145523070)
                r = this.ii(r, n, i, o, e[a + 11], 10, -1120210379)
                o = this.ii(o, r, n, i, e[a + 2], 15, 718787259)
                i = this.ii(i, o, r, n, e[a + 9], 21, -343485551)
                n = this.addme(n, c)
                i = this.addme(i, l)
                o = this.addme(o, d)
                r = this.addme(r, u)
                a += 16
              }
              return this.rhex(n) + this.rhex(i) + this.rhex(o) + this.rhex(r)
            },
            ii: function (t, e, n, i, o, r, s) {
              return this.cmn(this.bitXOR(n, this.bitOR(e, ~i)), t, e, o, r, s)
            },
            hh: function (t, e, n, i, o, r, s) {
              return this.cmn(this.bitXOR(this.bitXOR(e, n), i), t, e, o, r, s)
            },
            gg: function (t, e, n, i, o, r, s) {
              return this.cmn(
                this.bitOR(this.bitAND(e, i), this.bitAND(n, ~i)),
                t,
                e,
                o,
                r,
                s
              )
            },
            ff: function (t, e, n, i, o, r, s) {
              return this.cmn(
                this.bitOR(this.bitAND(e, n), this.bitAND(~e, i)),
                t,
                e,
                o,
                r,
                s
              )
            },
            cmn: function (t, e, n, i, o, r) {
              return this.addme(
                this.rol(this.addme(this.addme(e, t), this.addme(i, r)), o),
                n
              )
            },
            rol: function (t, e) {
              return (t << e) | (t >>> (32 - e))
            },
            str2blks: function (t) {
              var e = ((t.length + 8) >> 6) + 1
              var n = new Array()
              var i = 0,
                o = e * 16
              while (i < o) {
                var r = i++
                n[r] = 0
              }
              var r = 0
              while (r < t.length) {
                n[r >> 2] |=
                  HxOverrides.cca(t, r) << (((t.length * 8 + r) % 4) * 8)
                r++
              }
              n[r >> 2] |= 128 << (((t.length * 8 + r) % 4) * 8)
              var s = t.length * 8
              var a = e * 16 - 2
              n[a] = s & 255
              n[a] |= ((s >>> 8) & 255) << 8
              n[a] |= ((s >>> 16) & 255) << 16
              n[a] |= ((s >>> 24) & 255) << 24
              return n
            },
            rhex: function (t) {
              var e = ''
              var n = '0123456789abcdef'
              var i = 0
              while (i < 4) {
                var o = i++
                e +=
                  n.charAt((t >> (o * 8 + 4)) & 15) +
                  n.charAt((t >> (o * 8)) & 15)
              }
              return e
            },
            addme: function (t, e) {
              var n = (t & 65535) + (e & 65535)
              var i = (t >> 16) + (e >> 16) + (n >> 16)
              return (i << 16) | (n & 65535)
            },
            bitAND: function (t, e) {
              var n = t & 1 & (e & 1)
              var i = (t >>> 1) & (e >>> 1)
              return (i << 1) | n
            },
            bitXOR: function (t, e) {
              var n = (t & 1) ^ (e & 1)
              var i = (t >>> 1) ^ (e >>> 1)
              return (i << 1) | n
            },
            bitOR: function (t, e) {
              var n = (t & 1) | (e & 1)
              var i = (t >>> 1) | (e >>> 1)
              return (i << 1) | n
            },
            __class__: haxe.Md5
          }
          haxe.Timer = function (t) {
            var e = this
            this.id = window.setInterval(function () {
              e.run()
            }, t)
          }
          haxe.Timer.__name__ = true
          haxe.Timer.delay = function (t, e) {
            var n = new haxe.Timer(e)
            n.run = function () {
              n.stop()
              t()
            }
            return n
          }
          haxe.Timer.measure = function (t, e) {
            var n = haxe.Timer.stamp()
            var i = t()
            haxe.Log.trace(haxe.Timer.stamp() - n + 's', e)
            return i
          }
          haxe.Timer.stamp = function () {
            return new Date().getTime() / 1e3
          }
          haxe.Timer.prototype = {
            run: function () {},
            stop: function () {
              if (this.id == null) return
              window.clearInterval(this.id)
              this.id = null
            },
            __class__: haxe.Timer
          }
          var js = js || {}
          js.Boot = function () {}
          js.Boot.__name__ = true
          js.Boot.__unhtml = function (t) {
            return t
              .split('&')
              .join('&amp;')
              .split('<')
              .join('&lt;')
              .split('>')
              .join('&gt;')
          }
          js.Boot.__trace = function (t, e) {
            var n = e != null ? e.fileName + ':' + e.lineNumber + ': ' : ''
            n += js.Boot.__string_rec(t, '')
            var i
            if (
              typeof document != 'undefined' &&
              (i = document.getElementById('haxe:trace')) != null
            )
              i.innerHTML += js.Boot.__unhtml(n) + '<br/>'
            else if (typeof console != 'undefined' && console.log != null)
              console.log(n)
          }
          js.Boot.__clear_trace = function () {
            var t = document.getElementById('haxe:trace')
            if (t != null) t.innerHTML = ''
          }
          js.Boot.isClass = function (t) {
            return t.__name__
          }
          js.Boot.isEnum = function (t) {
            return t.__ename__
          }
          js.Boot.getClass = function (t) {
            return t.__class__
          }
          js.Boot.__string_rec = function (t, e) {
            if (t == null) return 'null'
            if (e.length >= 5) return '<...>'
            var n = typeof t
            if (n == 'function' && (t.__name__ || t.__ename__)) n = 'object'
            switch (n) {
              case 'object':
                if (t instanceof Array) {
                  if (t.__enum__) {
                    if (t.length == 2) return t[0]
                    var i = t[0] + '('
                    e += '\t'
                    var o = 2,
                      r = t.length
                    while (o < r) {
                      var s = o++
                      if (s != 2) i += ',' + js.Boot.__string_rec(t[s], e)
                      else i += js.Boot.__string_rec(t[s], e)
                    }
                    return i + ')'
                  }
                  var a = t.length
                  var s
                  var i = '['
                  e += '\t'
                  var r = 0
                  while (r < a) {
                    var c = r++
                    i += (c > 0 ? ',' : '') + js.Boot.__string_rec(t[c], e)
                  }
                  i += ']'
                  return i
                }
                var l
                try {
                  l = t.toString
                } catch (t) {
                  return '???'
                }
                if (l != null && l != Object.toString) {
                  var d = t.toString()
                  if (d != '[object Object]') return d
                }
                var u = null
                var i = '{\n'
                e += '\t'
                var h = t.hasOwnProperty != null
                for (var u in t) {
                  if (h && !t.hasOwnProperty(u)) {
                    continue
                  }
                  if (
                    u == 'prototype' ||
                    u == '__class__' ||
                    u == '__super__' ||
                    u == '__interfaces__' ||
                    u == '__properties__'
                  ) {
                    continue
                  }
                  if (i.length != 2) i += ', \n'
                  i += e + u + ' : ' + js.Boot.__string_rec(t[u], e)
                }
                e = e.substring(1)
                i += '\n' + e + '}'
                return i
              case 'function':
                return '<function>'
              case 'string':
                return t
              default:
                return String(t)
            }
          }
          js.Boot.__interfLoop = function (t, e) {
            if (t == null) return false
            if (t == e) return true
            var n = t.__interfaces__
            if (n != null) {
              var i = 0,
                o = n.length
              while (i < o) {
                var r = i++
                var s = n[r]
                if (s == e || js.Boot.__interfLoop(s, e)) return true
              }
            }
            return js.Boot.__interfLoop(t.__super__, e)
          }
          js.Boot.__instanceof = function (t, e) {
            try {
              if (t instanceof e) {
                if (e == Array) return t.__enum__ == null
                return true
              }
              if (js.Boot.__interfLoop(t.__class__, e)) return true
            } catch (t) {
              if (e == null) return false
            }
            switch (e) {
              case Int:
                return Math.ceil(t % 2147483648) === t
              case Float:
                return typeof t == 'number'
              case Bool:
                return t === true || t === false
              case String:
                return typeof t == 'string'
              case Dynamic:
                return true
              default:
                if (t == null) return false
                if (e == Class && t.__name__ != null) return true
                else null
                if (e == Enum && t.__ename__ != null) return true
                else null
                return t.__enum__ == e
            }
          }
          js.Boot.__cast = function (t, e) {
            if (js.Boot.__instanceof(t, e)) return t
            else throw 'Cannot cast ' + Std.string(t) + ' to ' + Std.string(e)
          }
          js.Lib = function () {}
          js.Lib.__name__ = true
          js.Lib.debug = function () {
            debugger
          }
          js.Lib.alert = function (t) {
            alert(js.Boot.__string_rec(t, ''))
          }
          js.Lib.eval = function (code) {
            return eval(code)
          }
          js.Lib.setErrorHandler = function (t) {
            js.Lib.onerror = t
          }
          var $_
          function $bind(t, e) {
            var n = function () {
              return n.method.apply(n.scope, arguments)
            }
            n.scope = t
            n.method = e
            return n
          }
          if (Array.prototype.indexOf)
            HxOverrides.remove = function (t, e) {
              var n = t.indexOf(e)
              if (n == -1) return false
              t.splice(n, 1)
              return true
            }
          else null
          Math.__name__ = ['Math']
          Math.NaN = Number.NaN
          Math.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY
          Math.POSITIVE_INFINITY = Number.POSITIVE_INFINITY
          Math.isFinite = function (t) {
            return isFinite(t)
          }
          Math.isNaN = function (t) {
            return isNaN(t)
          }
          String.prototype.__class__ = String
          String.__name__ = true
          Array.prototype.__class__ = Array
          Array.__name__ = true
          Date.prototype.__class__ = Date
          Date.__name__ = ['Date']
          var Int = { __name__: ['Int'] }
          var Dynamic = { __name__: ['Dynamic'] }
          var Float = Number
          Float.__name__ = ['Float']
          var Bool = Boolean
          Bool.__ename__ = ['Bool']
          var Class = { __name__: ['Class'] }
          var Enum = {}
          var Void = { __ename__: ['Void'] }
          if (typeof document != 'undefined') js.Lib.document = document
          if (typeof window != 'undefined') {
            js.Lib.window = window
            js.Lib.window.onerror = function (t, e, n) {
              var i = js.Lib.onerror
              if (i == null) return false
              return i(t, [e + ':' + n])
            }
          }
          com.wiris.js.JsPluginTools.main()
          delete Array.prototype.__class__
        })()
        ;(function () {
          var HxOverrides = function () {}
          HxOverrides.__name__ = true
          HxOverrides.dateStr = function (t) {
            var e = t.getMonth() + 1
            var n = t.getDate()
            var i = t.getHours()
            var o = t.getMinutes()
            var r = t.getSeconds()
            return (
              t.getFullYear() +
              '-' +
              (e < 10 ? '0' + e : '' + e) +
              '-' +
              (n < 10 ? '0' + n : '' + n) +
              ' ' +
              (i < 10 ? '0' + i : '' + i) +
              ':' +
              (o < 10 ? '0' + o : '' + o) +
              ':' +
              (r < 10 ? '0' + r : '' + r)
            )
          }
          HxOverrides.strDate = function (t) {
            switch (t.length) {
              case 8:
                var e = t.split(':')
                var n = new Date()
                n.setTime(0)
                n.setUTCHours(e[0])
                n.setUTCMinutes(e[1])
                n.setUTCSeconds(e[2])
                return n
              case 10:
                var e = t.split('-')
                return new Date(e[0], e[1] - 1, e[2], 0, 0, 0)
              case 19:
                var e = t.split(' ')
                var i = e[0].split('-')
                var o = e[1].split(':')
                return new Date(i[0], i[1] - 1, i[2], o[0], o[1], o[2])
              default:
                throw 'Invalid date format : ' + t
            }
          }
          HxOverrides.cca = function (t, e) {
            var n = t.charCodeAt(e)
            if (n != n) return undefined
            return n
          }
          HxOverrides.substr = function (t, e, n) {
            if (e != null && e != 0 && n != null && n < 0) return ''
            if (n == null) n = t.length
            if (e < 0) {
              e = t.length + e
              if (e < 0) e = 0
            } else if (n < 0) n = t.length + n - e
            return t.substr(e, n)
          }
          HxOverrides.remove = function (t, e) {
            var n = 0
            var i = t.length
            while (n < i) {
              if (t[n] == e) {
                t.splice(n, 1)
                return true
              }
              n++
            }
            return false
          }
          HxOverrides.iter = function (t) {
            return {
              cur: 0,
              arr: t,
              hasNext: function () {
                return this.cur < this.arr.length
              },
              next: function () {
                return this.arr[this.cur++]
              }
            }
          }
          var IntIter = function (t, e) {
            this.min = t
            this.max = e
          }
          IntIter.__name__ = true
          IntIter.prototype = {
            next: function () {
              return this.min++
            },
            hasNext: function () {
              return this.min < this.max
            },
            __class__: IntIter
          }
          var Std = function () {}
          Std.__name__ = true
          Std['is'] = function (t, e) {
            return js.Boot.__instanceof(t, e)
          }
          Std.string = function (t) {
            return js.Boot.__string_rec(t, '')
          }
          Std['int'] = function (t) {
            return t | 0
          }
          Std.parseInt = function (t) {
            var e = parseInt(t, 10)
            if (
              e == 0 &&
              (HxOverrides.cca(t, 1) == 120 || HxOverrides.cca(t, 1) == 88)
            )
              e = parseInt(t)
            if (isNaN(e)) return null
            return e
          }
          Std.parseFloat = function (t) {
            return parseFloat(t)
          }
          Std.random = function (t) {
            return Math.floor(Math.random() * t)
          }
          var com = com || {}
          if (!com.wiris) com.wiris = {}
          if (!com.wiris.js) com.wiris.js = {}
          com.wiris.js.JsPluginTools = function () {
            this.tryReady()
          }
          com.wiris.js.JsPluginTools.__name__ = true
          com.wiris.js.JsPluginTools.main = function () {
            var t
            t = com.wiris.js.JsPluginTools.getInstance()
            haxe.Timer.delay($bind(t, t.tryReady), 100)
          }
          com.wiris.js.JsPluginTools.getInstance = function () {
            if (com.wiris.js.JsPluginTools.instance == null)
              com.wiris.js.JsPluginTools.instance =
                new com.wiris.js.JsPluginTools()
            return com.wiris.js.JsPluginTools.instance
          }
          com.wiris.js.JsPluginTools.bypassEncapsulation = function () {
            if (window.com == null) window.com = {}
            if (window.com.wiris == null) window.com.wiris = {}
            if (window.com.wiris.js == null) window.com.wiris.js = {}
            if (window.com.wiris.js.JsPluginTools == null)
              window.com.wiris.js.JsPluginTools =
                com.wiris.js.JsPluginTools.getInstance()
          }
          com.wiris.js.JsPluginTools.prototype = {
            md5encode: function (t) {
              return haxe.Md5.encode(t)
            },
            doLoad: function () {
              this.ready = true
              com.wiris.js.JsPluginTools.instance = this
              com.wiris.js.JsPluginTools.bypassEncapsulation()
            },
            tryReady: function () {
              this.ready = false
              if (js.Lib.document.readyState) {
                this.doLoad()
                this.ready = true
              }
              if (!this.ready) haxe.Timer.delay($bind(this, this.tryReady), 100)
            },
            __class__: com.wiris.js.JsPluginTools
          }
          var haxe = haxe || {}
          haxe.Log = function () {}
          haxe.Log.__name__ = true
          haxe.Log.trace = function (t, e) {
            js.Boot.__trace(t, e)
          }
          haxe.Log.clear = function () {
            js.Boot.__clear_trace()
          }
          haxe.Md5 = function () {}
          haxe.Md5.__name__ = true
          haxe.Md5.encode = function (t) {
            return new haxe.Md5().doEncode(t)
          }
          haxe.Md5.prototype = {
            doEncode: function (t) {
              var e = this.str2blks(t)
              var n = 1732584193
              var i = -271733879
              var o = -1732584194
              var r = 271733878
              var s
              var a = 0
              while (a < e.length) {
                var c = n
                var l = i
                var d = o
                var u = r
                s = 0
                n = this.ff(n, i, o, r, e[a], 7, -680876936)
                r = this.ff(r, n, i, o, e[a + 1], 12, -389564586)
                o = this.ff(o, r, n, i, e[a + 2], 17, 606105819)
                i = this.ff(i, o, r, n, e[a + 3], 22, -1044525330)
                n = this.ff(n, i, o, r, e[a + 4], 7, -176418897)
                r = this.ff(r, n, i, o, e[a + 5], 12, 1200080426)
                o = this.ff(o, r, n, i, e[a + 6], 17, -1473231341)
                i = this.ff(i, o, r, n, e[a + 7], 22, -45705983)
                n = this.ff(n, i, o, r, e[a + 8], 7, 1770035416)
                r = this.ff(r, n, i, o, e[a + 9], 12, -1958414417)
                o = this.ff(o, r, n, i, e[a + 10], 17, -42063)
                i = this.ff(i, o, r, n, e[a + 11], 22, -1990404162)
                n = this.ff(n, i, o, r, e[a + 12], 7, 1804603682)
                r = this.ff(r, n, i, o, e[a + 13], 12, -40341101)
                o = this.ff(o, r, n, i, e[a + 14], 17, -1502002290)
                i = this.ff(i, o, r, n, e[a + 15], 22, 1236535329)
                n = this.gg(n, i, o, r, e[a + 1], 5, -165796510)
                r = this.gg(r, n, i, o, e[a + 6], 9, -1069501632)
                o = this.gg(o, r, n, i, e[a + 11], 14, 643717713)
                i = this.gg(i, o, r, n, e[a], 20, -373897302)
                n = this.gg(n, i, o, r, e[a + 5], 5, -701558691)
                r = this.gg(r, n, i, o, e[a + 10], 9, 38016083)
                o = this.gg(o, r, n, i, e[a + 15], 14, -660478335)
                i = this.gg(i, o, r, n, e[a + 4], 20, -405537848)
                n = this.gg(n, i, o, r, e[a + 9], 5, 568446438)
                r = this.gg(r, n, i, o, e[a + 14], 9, -1019803690)
                o = this.gg(o, r, n, i, e[a + 3], 14, -187363961)
                i = this.gg(i, o, r, n, e[a + 8], 20, 1163531501)
                n = this.gg(n, i, o, r, e[a + 13], 5, -1444681467)
                r = this.gg(r, n, i, o, e[a + 2], 9, -51403784)
                o = this.gg(o, r, n, i, e[a + 7], 14, 1735328473)
                i = this.gg(i, o, r, n, e[a + 12], 20, -1926607734)
                n = this.hh(n, i, o, r, e[a + 5], 4, -378558)
                r = this.hh(r, n, i, o, e[a + 8], 11, -2022574463)
                o = this.hh(o, r, n, i, e[a + 11], 16, 1839030562)
                i = this.hh(i, o, r, n, e[a + 14], 23, -35309556)
                n = this.hh(n, i, o, r, e[a + 1], 4, -1530992060)
                r = this.hh(r, n, i, o, e[a + 4], 11, 1272893353)
                o = this.hh(o, r, n, i, e[a + 7], 16, -155497632)
                i = this.hh(i, o, r, n, e[a + 10], 23, -1094730640)
                n = this.hh(n, i, o, r, e[a + 13], 4, 681279174)
                r = this.hh(r, n, i, o, e[a], 11, -358537222)
                o = this.hh(o, r, n, i, e[a + 3], 16, -722521979)
                i = this.hh(i, o, r, n, e[a + 6], 23, 76029189)
                n = this.hh(n, i, o, r, e[a + 9], 4, -640364487)
                r = this.hh(r, n, i, o, e[a + 12], 11, -421815835)
                o = this.hh(o, r, n, i, e[a + 15], 16, 530742520)
                i = this.hh(i, o, r, n, e[a + 2], 23, -995338651)
                n = this.ii(n, i, o, r, e[a], 6, -198630844)
                r = this.ii(r, n, i, o, e[a + 7], 10, 1126891415)
                o = this.ii(o, r, n, i, e[a + 14], 15, -1416354905)
                i = this.ii(i, o, r, n, e[a + 5], 21, -57434055)
                n = this.ii(n, i, o, r, e[a + 12], 6, 1700485571)
                r = this.ii(r, n, i, o, e[a + 3], 10, -1894986606)
                o = this.ii(o, r, n, i, e[a + 10], 15, -1051523)
                i = this.ii(i, o, r, n, e[a + 1], 21, -2054922799)
                n = this.ii(n, i, o, r, e[a + 8], 6, 1873313359)
                r = this.ii(r, n, i, o, e[a + 15], 10, -30611744)
                o = this.ii(o, r, n, i, e[a + 6], 15, -1560198380)
                i = this.ii(i, o, r, n, e[a + 13], 21, 1309151649)
                n = this.ii(n, i, o, r, e[a + 4], 6, -145523070)
                r = this.ii(r, n, i, o, e[a + 11], 10, -1120210379)
                o = this.ii(o, r, n, i, e[a + 2], 15, 718787259)
                i = this.ii(i, o, r, n, e[a + 9], 21, -343485551)
                n = this.addme(n, c)
                i = this.addme(i, l)
                o = this.addme(o, d)
                r = this.addme(r, u)
                a += 16
              }
              return this.rhex(n) + this.rhex(i) + this.rhex(o) + this.rhex(r)
            },
            ii: function (t, e, n, i, o, r, s) {
              return this.cmn(this.bitXOR(n, this.bitOR(e, ~i)), t, e, o, r, s)
            },
            hh: function (t, e, n, i, o, r, s) {
              return this.cmn(this.bitXOR(this.bitXOR(e, n), i), t, e, o, r, s)
            },
            gg: function (t, e, n, i, o, r, s) {
              return this.cmn(
                this.bitOR(this.bitAND(e, i), this.bitAND(n, ~i)),
                t,
                e,
                o,
                r,
                s
              )
            },
            ff: function (t, e, n, i, o, r, s) {
              return this.cmn(
                this.bitOR(this.bitAND(e, n), this.bitAND(~e, i)),
                t,
                e,
                o,
                r,
                s
              )
            },
            cmn: function (t, e, n, i, o, r) {
              return this.addme(
                this.rol(this.addme(this.addme(e, t), this.addme(i, r)), o),
                n
              )
            },
            rol: function (t, e) {
              return (t << e) | (t >>> (32 - e))
            },
            str2blks: function (t) {
              var e = ((t.length + 8) >> 6) + 1
              var n = new Array()
              var i = 0,
                o = e * 16
              while (i < o) {
                var r = i++
                n[r] = 0
              }
              var r = 0
              while (r < t.length) {
                n[r >> 2] |=
                  HxOverrides.cca(t, r) << (((t.length * 8 + r) % 4) * 8)
                r++
              }
              n[r >> 2] |= 128 << (((t.length * 8 + r) % 4) * 8)
              var s = t.length * 8
              var a = e * 16 - 2
              n[a] = s & 255
              n[a] |= ((s >>> 8) & 255) << 8
              n[a] |= ((s >>> 16) & 255) << 16
              n[a] |= ((s >>> 24) & 255) << 24
              return n
            },
            rhex: function (t) {
              var e = ''
              var n = '0123456789abcdef'
              var i = 0
              while (i < 4) {
                var o = i++
                e +=
                  n.charAt((t >> (o * 8 + 4)) & 15) +
                  n.charAt((t >> (o * 8)) & 15)
              }
              return e
            },
            addme: function (t, e) {
              var n = (t & 65535) + (e & 65535)
              var i = (t >> 16) + (e >> 16) + (n >> 16)
              return (i << 16) | (n & 65535)
            },
            bitAND: function (t, e) {
              var n = t & 1 & (e & 1)
              var i = (t >>> 1) & (e >>> 1)
              return (i << 1) | n
            },
            bitXOR: function (t, e) {
              var n = (t & 1) ^ (e & 1)
              var i = (t >>> 1) ^ (e >>> 1)
              return (i << 1) | n
            },
            bitOR: function (t, e) {
              var n = (t & 1) | (e & 1)
              var i = (t >>> 1) | (e >>> 1)
              return (i << 1) | n
            },
            __class__: haxe.Md5
          }
          haxe.Timer = function (t) {
            var e = this
            this.id = window.setInterval(function () {
              e.run()
            }, t)
          }
          haxe.Timer.__name__ = true
          haxe.Timer.delay = function (t, e) {
            var n = new haxe.Timer(e)
            n.run = function () {
              n.stop()
              t()
            }
            return n
          }
          haxe.Timer.measure = function (t, e) {
            var n = haxe.Timer.stamp()
            var i = t()
            haxe.Log.trace(haxe.Timer.stamp() - n + 's', e)
            return i
          }
          haxe.Timer.stamp = function () {
            return new Date().getTime() / 1e3
          }
          haxe.Timer.prototype = {
            run: function () {},
            stop: function () {
              if (this.id == null) return
              window.clearInterval(this.id)
              this.id = null
            },
            __class__: haxe.Timer
          }
          var js = js || {}
          js.Boot = function () {}
          js.Boot.__name__ = true
          js.Boot.__unhtml = function (t) {
            return t
              .split('&')
              .join('&amp;')
              .split('<')
              .join('&lt;')
              .split('>')
              .join('&gt;')
          }
          js.Boot.__trace = function (t, e) {
            var n = e != null ? e.fileName + ':' + e.lineNumber + ': ' : ''
            n += js.Boot.__string_rec(t, '')
            var i
            if (
              typeof document != 'undefined' &&
              (i = document.getElementById('haxe:trace')) != null
            )
              i.innerHTML += js.Boot.__unhtml(n) + '<br/>'
            else if (typeof console != 'undefined' && console.log != null)
              console.log(n)
          }
          js.Boot.__clear_trace = function () {
            var t = document.getElementById('haxe:trace')
            if (t != null) t.innerHTML = ''
          }
          js.Boot.isClass = function (t) {
            return t.__name__
          }
          js.Boot.isEnum = function (t) {
            return t.__ename__
          }
          js.Boot.getClass = function (t) {
            return t.__class__
          }
          js.Boot.__string_rec = function (t, e) {
            if (t == null) return 'null'
            if (e.length >= 5) return '<...>'
            var n = typeof t
            if (n == 'function' && (t.__name__ || t.__ename__)) n = 'object'
            switch (n) {
              case 'object':
                if (t instanceof Array) {
                  if (t.__enum__) {
                    if (t.length == 2) return t[0]
                    var i = t[0] + '('
                    e += '\t'
                    var o = 2,
                      r = t.length
                    while (o < r) {
                      var s = o++
                      if (s != 2) i += ',' + js.Boot.__string_rec(t[s], e)
                      else i += js.Boot.__string_rec(t[s], e)
                    }
                    return i + ')'
                  }
                  var a = t.length
                  var s
                  var i = '['
                  e += '\t'
                  var r = 0
                  while (r < a) {
                    var c = r++
                    i += (c > 0 ? ',' : '') + js.Boot.__string_rec(t[c], e)
                  }
                  i += ']'
                  return i
                }
                var l
                try {
                  l = t.toString
                } catch (t) {
                  return '???'
                }
                if (l != null && l != Object.toString) {
                  var d = t.toString()
                  if (d != '[object Object]') return d
                }
                var u = null
                var i = '{\n'
                e += '\t'
                var h = t.hasOwnProperty != null
                for (var u in t) {
                  if (h && !t.hasOwnProperty(u)) {
                    continue
                  }
                  if (
                    u == 'prototype' ||
                    u == '__class__' ||
                    u == '__super__' ||
                    u == '__interfaces__' ||
                    u == '__properties__'
                  ) {
                    continue
                  }
                  if (i.length != 2) i += ', \n'
                  i += e + u + ' : ' + js.Boot.__string_rec(t[u], e)
                }
                e = e.substring(1)
                i += '\n' + e + '}'
                return i
              case 'function':
                return '<function>'
              case 'string':
                return t
              default:
                return String(t)
            }
          }
          js.Boot.__interfLoop = function (t, e) {
            if (t == null) return false
            if (t == e) return true
            var n = t.__interfaces__
            if (n != null) {
              var i = 0,
                o = n.length
              while (i < o) {
                var r = i++
                var s = n[r]
                if (s == e || js.Boot.__interfLoop(s, e)) return true
              }
            }
            return js.Boot.__interfLoop(t.__super__, e)
          }
          js.Boot.__instanceof = function (t, e) {
            try {
              if (t instanceof e) {
                if (e == Array) return t.__enum__ == null
                return true
              }
              if (js.Boot.__interfLoop(t.__class__, e)) return true
            } catch (t) {
              if (e == null) return false
            }
            switch (e) {
              case Int:
                return Math.ceil(t % 2147483648) === t
              case Float:
                return typeof t == 'number'
              case Bool:
                return t === true || t === false
              case String:
                return typeof t == 'string'
              case Dynamic:
                return true
              default:
                if (t == null) return false
                if (e == Class && t.__name__ != null) return true
                else null
                if (e == Enum && t.__ename__ != null) return true
                else null
                return t.__enum__ == e
            }
          }
          js.Boot.__cast = function (t, e) {
            if (js.Boot.__instanceof(t, e)) return t
            else throw 'Cannot cast ' + Std.string(t) + ' to ' + Std.string(e)
          }
          js.Lib = function () {}
          js.Lib.__name__ = true
          js.Lib.debug = function () {
            debugger
          }
          js.Lib.alert = function (t) {
            alert(js.Boot.__string_rec(t, ''))
          }
          js.Lib.eval = function (code) {
            return eval(code)
          }
          js.Lib.setErrorHandler = function (t) {
            js.Lib.onerror = t
          }
          var $_
          function $bind(t, e) {
            var n = function () {
              return n.method.apply(n.scope, arguments)
            }
            n.scope = t
            n.method = e
            return n
          }
          if (Array.prototype.indexOf)
            HxOverrides.remove = function (t, e) {
              var n = t.indexOf(e)
              if (n == -1) return false
              t.splice(n, 1)
              return true
            }
          else null
          Math.__name__ = ['Math']
          Math.NaN = Number.NaN
          Math.NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY
          Math.POSITIVE_INFINITY = Number.POSITIVE_INFINITY
          Math.isFinite = function (t) {
            return isFinite(t)
          }
          Math.isNaN = function (t) {
            return isNaN(t)
          }
          String.prototype.__class__ = String
          String.__name__ = true
          Array.prototype.__class__ = Array
          Array.__name__ = true
          Date.prototype.__class__ = Date
          Date.__name__ = ['Date']
          var Int = { __name__: ['Int'] }
          var Dynamic = { __name__: ['Dynamic'] }
          var Float = Number
          Float.__name__ = ['Float']
          var Bool = Boolean
          Bool.__ename__ = ['Bool']
          var Class = { __name__: ['Class'] }
          var Enum = {}
          var Void = { __ename__: ['Void'] }
          if (typeof document != 'undefined') js.Lib.document = document
          if (typeof window != 'undefined') {
            js.Lib.window = window
            js.Lib.window.onerror = function (t, e, n) {
              var i = js.Lib.onerror
              if (i == null) return false
              return i(t, [e + ':' + n])
            }
          }
          com.wiris.js.JsPluginTools.main()
        })()
        delete Array.prototype.__class__
      },
      636: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-block-quote/theme/blockquote.css'
            ],
            names: [],
            mappings:
              'AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n\t/* See #12 */\n\toverflow: hidden;\n\n\t/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n\tpadding-right: 1.5em;\n\tpadding-left: 1.5em;\n\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tfont-style: italic;\n\tborder-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n\tborder-left: 0;\n\tborder-right: solid 5px hsl(0, 0%, 80%);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      390: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) transparent transparent transparent;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-clipboard/theme/clipboard.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css'
            ],
            names: [],
            mappings:
              'AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CCzBF,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,sFAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CA2DF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: inline;\n\t\tposition: relative;\n\t\tpointer-events: none;\n\n\t\t& span {\n\t\t\tposition: absolute;\n\t\t\twidth: 0;\n\t\t}\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\t& > .ck-widget__selection-handle {\n\t\t\tdisplay: none;\n\t\t}\n\n\t\t& > .ck-widget__type-around {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-clipboard-drop-target-dot-width: 12px;\n\t--ck-clipboard-drop-target-dot-height: 8px;\n\t--ck-clipboard-drop-target-color: var(--ck-color-focus-border)\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Vertical drop target (in text).\n\t */\n\t& .ck.ck-clipboard-drop-target-position {\n\t\t& span {\n\t\t\tbottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\ttop: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tbackground: var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-left: -1px;\n\n\t\t\t/* The triangle above the marker */\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: 50%;\n\t\t\t\ttop: calc(var(--ck-clipboard-drop-target-dot-height) * -.5);\n\n\t\t\t\ttransform: translateX(-50%);\n\t\t\t\tborder-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;\n\t\t\t\tborder-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t// Horizontal drop target (between blocks).\n\t& .ck.ck-clipboard-drop-target-position {\n\t\tdisplay: block;\n\t\tposition: relative;\n\t\twidth: 100%;\n\t\theight: 0;\n\t\tmargin: 0;\n\t\ttext-align: initial;\n\n\t\t& .ck-clipboard-drop-target__line {\n\t\t\tposition: absolute;\n\t\t\twidth: 100%;\n\t\t\theight: 0;\n\t\t\tborder: 1px solid var(--ck-clipboard-drop-target-color);\n\t\t\tmargin-top: -1px;\n\n\t\t\t&::before {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tleft: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) 0 var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\theight: 0;\n\n\t\t\t\tdisplay: block;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: calc(-1 * var(--ck-clipboard-drop-target-dot-size));\n\t\t\t\ttop: 0;\n\n\t\t\t\ttransform: translateY(-50%);\n\t\t\t\tborder-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;\n\t\t\t\tborder-width: var(--ck-clipboard-drop-target-dot-size) calc(2 * var(--ck-clipboard-drop-target-dot-size)) var(--ck-clipboard-drop-target-dot-size) 0;\n\t\t\t\tborder-style: solid;\n\t\t\t}\n\t\t}\n\t}\n\t*/\n\n\t/*\n\t * Styles of the widget that it a drop target.\n\t */\n\t& .ck-widget.ck-clipboard-drop-target-range {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;\n\t}\n\n\t/*\n\t * Styles of the widget being dragged (its preview).\n\t */\n\t& .ck-widget:-webkit-drag {\n\t\tzoom: 0.6;\n\t\toutline: none !important;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      3638: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-editor-classic/theme/classiceditor.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css'
            ],
            names: [],
            mappings:
              'AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n\t/* All the elements within `.ck-editor` are positioned relatively to it.\n\t If any element needs to be positioned with respect to the <body>, etc.,\n\t it must land outside of the `.ck-editor` in DOM. */\n\tposition: relative;\n\n\t& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n\t\t/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n\t\tz-index: var(--ck-z-modal);\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n.ck.ck-editor__top {\n\t& .ck-sticky-panel {\n\t\t& .ck-toolbar {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\n\t\t\tborder-bottom-width: 0;\n\t\t}\n\n\t\t& .ck-sticky-panel__content_sticky .ck-toolbar {\n\t\t\tborder-bottom-width: 1px;\n\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* Note: Use ck-editor__main to make sure these styles don\'t apply to other editor types */\n.ck.ck-editor__main > .ck-editor__editable {\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */\n\tbackground: var(--ck-color-base-background);\n\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&:not(.ck-focused) {\n\t\tborder-color: var(--ck-color-base-border);\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      8894: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text);cursor:text}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/placeholder.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css'
            ],
            names: [],
            mappings:
              'AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC5BC,qDAEC,6CAA8C,CAD9C,WAED',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n\tposition: relative;\n\n\t&::before {\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tcontent: attr(data-placeholder);\n\n\t\t/* See ckeditor/ckeditor5#469. */\n\t\tpointer-events: none;\n\t}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n\tposition: relative;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n\t&::before {\n\t\tcursor: text;\n\t\tcolor: var(--ck-color-engine-placeholder-text);\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4401: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-engine/theme/renderer.css'
            ],
            names: [],
            mappings: 'AAMA,qDACC,YACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n\tdisplay: none;\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      3230: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-heading/theme/heading.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css'
            ],
            names: [],
            mappings:
              'AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n\tfont-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n\tfont-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n\tfont-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n\tfont-weight: bold;\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n\t& .ck-dropdown__button .ck-button__label {\n\t\twidth: 8em;\n\t}\n\n\t& .ck-dropdown__panel .ck-list__item {\n\t\tmin-width: 18em;\n\t}\n}\n"
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      9048: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image-inline.ck-widget_selected,.ck.ck-editor__editable .image.ck-widget_selected{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/image.css'
            ],
            names: [],
            mappings:
              'AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBAuBD,CAbC,uBAEC,aAAc,CAGd,aAAc,CAGd,cAAe,CAGf,cACD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAWA,2GACC,SAUD,CAHC,qEACC,YACD,CAOA,0FACC,cACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n\t& .image {\n\t\tdisplay: table;\n\t\tclear: both;\n\t\ttext-align: center;\n\n\t\t/* Make sure there is some space between the content and the image. Center image by default. */\n\t\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\t \tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\t\tmargin: 0.9em auto;\n\n\t\t/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n\t\tmin-width: 50px;\n\n\t\t& img {\n\t\t\t/* Prevent unnecessary margins caused by line-height (see #44). */\n\t\t\tdisplay: block;\n\n\t\t\t/* Center the image if its width is smaller than the content\'s width. */\n\t\t\tmargin: 0 auto;\n\n\t\t\t/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n\t\t\tmax-width: 100%;\n\n\t\t\t/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n\t\t\tmin-width: 100%\n\t\t}\n\t}\n\n\t& .image-inline {\n\t\t/*\n\t\t * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n\t\t * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n\t\t * This strange behavior does not happen with inline-flex.\n\t\t */\n\t\tdisplay: inline-flex;\n\n\t\t/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n\t\tmax-width: 100%;\n\n\t\t/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n\t\talign-items: flex-start;\n\n\t\t/* When the picture is present it must act as a flex container to let the img resize properly */\n\t\t& picture {\n\t\t\tdisplay: flex;\n\t\t}\n\n\t\t/* When the picture is present, it must act like a resizable img. */\n\t\t& picture,\n\t\t& img {\n\t\t\t/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n\t\t\tflex-grow: 1;\n\t\t\tflex-shrink: 1;\n\n\t\t\t/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n\t\t\tmax-width: 100%;\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable {\n\t/*\n\t * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n\t * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n\t * caret does, and not at the edge of <figcaption>.\n\t */\n\t& .image > figcaption.ck-placeholder::before {\n\t\tpadding-left: inherit;\n\t\tpadding-right: inherit;\n\n\t\t/*\n\t\t * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9162.\n\t\t */\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\n\t/*\n\t * Make sure the selected inline image always stays on top of its siblings.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9108.\n\t */\n\t& .image.ck-widget_selected {\n\t\tz-index: 1;\n\t}\n\n\t& .image-inline.ck-widget_selected {\n\t\tz-index: 1;\n\n\t\t/*\n\t\t * Make sure the native browser selection style is not displayed.\n\t\t * Inline image widgets have their own styles for the selected state and\n\t\t * leaving this up to the browser is asking for a visual collision.\n\t\t */\n\t\t& ::selection {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t/* The inline image nested in the table should have its original size if not resized.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9117. */\n\t& td,\n\t& th {\n\t\t& .image-inline img {\n\t\t\tmax-width: none;\n\t\t}\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      8662: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagecaption.css'
            ],
            names: [],
            mappings:
              'AAKA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,mDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAMD,CAGA,qEACC,iDACD,CAEA,sCACC,GACC,oEACD,CAEA,GACC,yDACD,CACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-caption-background: hsl(0, 0%, 97%);\n\t--ck-color-image-caption-text: hsl(0, 0%, 20%);\n\t--ck-color-image-caption-highligted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n\tdisplay: table-caption;\n\tcaption-side: bottom;\n\tword-break: break-word;\n\tcolor: var(--ck-color-image-caption-text);\n\tbackground-color: var(--ck-color-image-caption-background);\n\tpadding: .6em;\n\tfont-size: .75em;\n\toutline-offset: -1px;\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n\tanimation: ck-image-caption-highlight .6s ease-out;\n}\n\n@keyframes ck-image-caption-highlight {\n\t0% {\n\t\tbackground-color: var(--ck-color-image-caption-highligted-background);\n\t}\n\n\t100% {\n\t\tbackground-color: var(--ck-color-image-caption-background);\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4622: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imagestyle.css'
            ],
            names: [],
            mappings:
              'AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD',
            sourcesContent: [
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-image-style-spacing: 1.5em;\n\t--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n\t/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n\tconfirming successful application of the style if image width exceeds the editor's size.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9342 */\n\t& .image-style-block-align-left,\n\t& .image-style-block-align-right {\n\t\tmax-width: calc(100% - var(--ck-image-style-spacing));\n\t}\n\n\t/* Allows displaying multiple floating images in the same line.\n\tSee https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n\t& .image-style-align-left,\n\t& .image-style-align-right {\n\t\tclear: none;\n\t}\n\n\t& .image-style-side {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t\tmax-width: 50%;\n\t}\n\n\t& .image-style-align-left {\n\t\tfloat: left;\n\t\tmargin-right: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-align-center {\n\t\tmargin-left: auto;\n\t\tmargin-right: auto;\n\t}\n\n\t& .image-style-align-right {\n\t\tfloat: right;\n\t\tmargin-left: var(--ck-image-style-spacing);\n\t}\n\n\t& .image-style-block-align-right {\n\t\tmargin-right: 0;\n\t\tmargin-left: auto;\n\t}\n\n\t& .image-style-block-align-left {\n\t\tmargin-left: 0;\n\t\tmargin-right: auto;\n\t}\n\n\t/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n\t& p + .image-style-align-left,\n\t& p + .image-style-align-right,\n\t& p + .image-style-side {\n\t\tmargin-top: 0;\n\t}\n\n\t& .image-inline {\n\t\t&.image-style-align-left,\n\t\t&.image-style-align-right {\n\t\t\tmargin-top: var(--ck-inline-image-style-spacing);\n\t\t\tmargin-bottom: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-left {\n\t\t\tmargin-right: var(--ck-inline-image-style-spacing);\n\t\t}\n\n\t\t&.image-style-align-right {\n\t\t\tmargin-left: var(--ck-inline-image-style-spacing);\n\t\t}\n\t}\n}\n\n.ck.ck-splitbutton {\n\t/* The button should display as a regular drop-down if the action button\n\tis forced to fire the same action as the arrow button. */\n\t&.ck-splitbutton_flatten {\n\t\t&:hover,\n\t\t&.ck-splitbutton_open {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-background);\n\n\t\t\t\t&::after {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t&.ck-splitbutton_open:hover {\n\t\t\t& > .ck-splitbutton__action:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled),\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n\t\t\t\tbackground-color: var(--ck-color-button-on-hover-background);\n\t\t\t}\n\t\t}\n\t}\n}\n"
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      9899: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadicon.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css'
            ],
            names: [],
            mappings:
              'AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFA0BD,CAtBC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n\tdisplay: block;\n\tposition: absolute;\n\n\t/*\n\t * Smaller images should have the icon closer to the border.\n\t * Match the icon position with the linked image indicator brought by the link image feature.\n\t */\n\ttop: min(var(--ck-spacing-medium), 6%);\n\tright: min(var(--ck-spacing-medium), 6%);\n\tborder-radius: 50%;\n\tz-index: 1;\n\n\t&::after {\n\t\tcontent: "";\n\t\tposition: absolute;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n\t--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n\t/* Match the icon size with the linked image indicator brought by the link image feature. */\n\t--ck-image-upload-icon-size: 20;\n\t--ck-image-upload-icon-width: 2px;\n\t--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n\topacity: 0;\n\tbackground: var(--ck-color-image-upload-icon-background);\n\tanimation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n\tanimation-fill-mode: forwards, forwards;\n\tanimation-duration: 500ms, 500ms;\n\n\t/* To make animation scalable. */\n\tfont-size: calc(1px * var(--ck-image-upload-icon-size));\n\n\t/* Hide completed upload icon after 3 seconds. */\n\tanimation-delay: 0ms, 3000ms;\n\n\t/*\n\t * Use CSS math to simulate container queries.\n\t * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n\t */\n\toverflow: hidden;\n\twidth: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\theight: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n\t/* This is check icon element made from border-width mixed with animations. */\n\t&::after {\n\t\t/* Because of border transformation we need to "hard code" left position. */\n\t\tleft: 25%;\n\n\t\ttop: 50%;\n\t\topacity: 0;\n\t\theight: 0;\n\t\twidth: 0;\n\n\t\ttransform: scaleX(-1) rotate(135deg);\n\t\ttransform-origin: left top;\n\t\tborder-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\t\tborder-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n\t\tanimation-name: ck-upload-complete-icon-check;\n\t\tanimation-duration: 500ms;\n\t\tanimation-delay: 500ms;\n\t\tanimation-fill-mode: forwards;\n\n\t\t/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n\t\tbox-sizing: border-box;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-show {\n\tfrom {\n\t\topacity: 0;\n\t}\n\n\tto {\n\t\topacity: 1;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n\tfrom {\n\t\topacity: 1;\n\t}\n\n\tto {\n\t\topacity: 0;\n\t}\n}\n\n@keyframes ck-upload-complete-icon-check {\n\t0% {\n\t\topacity: 1;\n\t\twidth: 0;\n\t\theight: 0;\n\t}\n\t33% {\n\t\twidth: 0.3em;\n\t\theight: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t\twidth: 0.3em;\n\t\theight: 0.45em;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      9825: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid transparent;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadloader.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css'
            ],
            names: [],
            mappings:
              'AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,kCAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD',
            sourcesContent: [
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n\tposition: absolute;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttop: 0;\n\tleft: 0;\n\n\t&::before {\n\t\tcontent: '';\n\t\tposition: relative;\n\t}\n}\n",
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n\t--ck-upload-placeholder-loader-size: 32px;\n\t--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n\t/* We need to control the full width of the SVG gray background. */\n\twidth: 100%;\n\tmargin: 0;\n\n\t&.image-inline {\n\t\twidth: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n\t}\n\n\t& img {\n\t\t/*\n\t\t * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n\t\t * There's nothing special about this number except that it should make the image placeholder look like\n\t\t * a real image during this short period after the upload started and before the image was read from the\n\t\t * file system (and a rich preview was loaded).\n\t\t */\n\t\taspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n\t}\n}\n\n.ck .ck-upload-placeholder-loader {\n\twidth: 100%;\n\theight: 100%;\n\n\t&::before {\n\t\twidth: var(--ck-upload-placeholder-loader-size);\n\t\theight: var(--ck-upload-placeholder-loader-size);\n\t\tborder-radius: 50%;\n\t\tborder-top: 3px solid var(--ck-color-upload-placeholder-loader);\n\t\tborder-right: 2px solid transparent;\n\t\tanimation: ck-upload-placeholder-loader 1s linear infinite;\n\t}\n}\n\n@keyframes ck-upload-placeholder-loader {\n\tto {\n\t\ttransform: rotate( 360deg );\n\t}\n}\n"
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      5870: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/imageuploadprogress.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css'
            ],
            names: [],
            mappings:
              'AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBACD,CAID,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\tposition: relative;\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n\t& .image,\n\t& .image-inline {\n\t\t/* Showing animation. */\n\t\t&.ck-appear {\n\t\t\tanimation: fadeIn 700ms;\n\t\t}\n\t}\n\n\t/* Upload progress bar. */\n\t& .image .ck-progress-bar,\n\t& .image-inline .ck-progress-bar {\n\t\theight: 2px;\n\t\twidth: 0;\n\t\tbackground: var(--ck-color-upload-bar-background);\n\t\ttransition: width 100ms;\n\t}\n}\n\n@keyframes fadeIn {\n\tfrom { opacity: 0; }\n\tto   { opacity: 1; }\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      6831: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-image/theme/textalternativeform.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css'
            ],
            names: [],
            mappings:
              'AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      399: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/link.css'
            ],
            names: [],
            mappings:
              'AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,oCACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n\tbackground: var(--ck-color-link-selected-background);\n\n\t/* Give linked inline images some outline to let the user know they are also part of the link. */\n\t& span.image-inline {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n\t}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n\tbackground: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n\theight: 100%;\n\tborder-right: 1px solid var(--ck-color-base-text);\n\tmargin-right: -1px;\n\toutline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      9465: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkactions.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css'
            ],
            names: [],
            mappings:
              'AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-link-actions__preview {\n\t\tdisplay: inline-block;\n\n\t\t& .ck-button__label {\n\t\t\toverflow: hidden;\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-link-actions__preview {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n\t& .ck-button.ck-link-actions__preview {\n\t\tpadding-left: 0;\n\t\tpadding-right: 0;\n\n\t\t& .ck-button__label {\n\t\t\tpadding: 0 var(--ck-spacing-medium);\n\t\t\tcolor: var(--ck-color-link-default);\n\t\t\ttext-overflow: ellipsis;\n\t\t\tcursor: pointer;\n\n\t\t\t/* Match the box model of the link editor form\'s input so the balloon\n\t\t\tdoes not change width when moving between actions and the form. */\n\t\t\tmax-width: var(--ck-input-width);\n\t\t\tmin-width: 3em;\n\t\t\ttext-align: center;\n\n\t\t\t&:hover {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\n\t\t&,\n\t\t&:hover,\n\t\t&:focus,\n\t\t&:active {\n\t\t\tbackground: none;\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&:focus {\n\t\t\t& .ck-button__label {\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-button:not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-button:not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\t& .ck-button.ck-link-actions__preview {\n\t\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;\n\n\t\t\t& .ck-button__label {\n\t\t\t\tmin-width: 0;\n\t\t\t\tmax-width: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-button:not(.ck-link-actions__preview) {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4827: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-link/theme/linkform.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css'
            ],
            names: [],
            mappings:
              'AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n\tdisplay: flex;\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tdisplay: block;\n\n\t/*\n\t * Whether the form is in the responsive mode or not, if there are decorator buttons\n\t * keep the top margin of action buttons medium.\n\t */\n\t& .ck-button {\n\t\t&.ck-button-save,\n\t\t&.ck-button-cancel {\n\t\t\tmargin-top: var(--ck-spacing-medium);\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n\tpadding: 0;\n\tmin-width: var(--ck-input-width);\n\n\t& .ck-labeled-field-view {\n\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n\t\t& .ck-input-text {\n\t\t\tmin-width: 0;\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t& > .ck-button {\n\t\tpadding: var(--ck-spacing-standard);\n\t\tmargin: 0;\n\t\twidth: 50%;\n\t\tborder-radius: 0;\n\n\t\t&:not(:focus) {\n\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t}\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: 0;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-left: 0;\n\n\t\t\t&:last-of-type {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n\t& .ck.ck-list {\n\t\tmargin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n\t\t& .ck-button.ck-switchbutton {\n\t\t\tpadding: 0;\n\t\t\twidth: 100%;\n\n\t\t\t&:hover {\n\t\t\t\tbackground: none;\n\t\t\t}\n\t\t}\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      9989: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-content ol{list-style-type:decimal}.ck-content ol ol{list-style-type:lower-latin}.ck-content ol ol ol{list-style-type:lower-roman}.ck-content ol ol ol ol{list-style-type:upper-latin}.ck-content ol ol ol ol ol{list-style-type:upper-roman}.ck-content ul{list-style-type:disc}.ck-content ul ul{list-style-type:circle}.ck-content ul ul ul,.ck-content ul ul ul ul{list-style-type:square}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-list/theme/list.css'
            ],
            names: [],
            mappings:
              'AAKA,eACC,uBAiBD,CAfC,kBACC,2BAaD,CAXC,qBACC,2BASD,CAPC,wBACC,2BAKD,CAHC,2BACC,2BACD,CAMJ,eACC,oBAaD,CAXC,kBACC,sBASD,CAJE,6CACC,sBACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content ol {\n\tlist-style-type: decimal;\n\n\t& ol {\n\t\tlist-style-type: lower-latin;\n\n\t\t& ol {\n\t\t\tlist-style-type: lower-roman;\n\n\t\t\t& ol {\n\t\t\t\tlist-style-type: upper-latin;\n\n\t\t\t\t& ol {\n\t\t\t\t\tlist-style-type: upper-roman;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck-content ul {\n\tlist-style-type: disc;\n\n\t& ul {\n\t\tlist-style-type: circle;\n\n\t\t& ul {\n\t\t\tlist-style-type: square;\n\n\t\t\t& ul {\n\t\t\t\tlist-style-type: square;\n\t\t\t}\n\t\t}\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      5777: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembed.css'
            ],
            names: [],
            mappings: 'AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n\t/* Don\'t allow floated content overlap the media.\n\thttps://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n\tclear: both;\n\n\t/* Make sure there is some space between the content and the media. */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em 0;\n\n\t/* Make sure media is not overriden with Bootstrap default `flex` value.\n\tSee: https://github.com/ckeditor/ckeditor5/issues/1373. */\n\tdisplay: block;\n\n\t/* Give the media some minimal width in the content to prevent them\n\tfrom being "squashed" in tight spaces, e.g. in table cells (#44) */\n\tmin-width: 15em;\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      952: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgNDAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaembedediting.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css'
            ],
            names: [],
            mappings:
              'AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,wvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,wiCACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-media__wrapper {\n\t& .ck-media__placeholder {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\n\t\t& .ck-media__placeholder__url {\n\t\t\t/* Otherwise the URL will overflow when the content is very narrow. */\n\t\t\tmax-width: 100%;\n\n\t\t\tposition: relative;\n\n\t\t\t& .ck-media__placeholder__url__text {\n\t\t\t\toverflow: hidden;\n\t\t\t\tdisplay: block;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"],\n\t&[data-oembed-url*="google.com/maps"],\n\t&[data-oembed-url*="goo.gl/maps"],\n\t&[data-oembed-url*="maps.google.com"],\n\t&[data-oembed-url*="maps.app.goo.gl"],\n\t&[data-oembed-url*="facebook.com"],\n\t&[data-oembed-url*="instagram.com"] {\n\t\t& .ck-media__placeholder__icon * {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n\n/* Disable all mouse interaction as long as the editor is not read–only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n\tpointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n\tpointer-events: none;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-media-embed-placeholder-icon-size: 3em;\n\n\t--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n\t--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n\tmargin: 0 auto;\n\n\t& .ck-media__placeholder {\n\t\tpadding: calc( 3 * var(--ck-spacing-standard) );\n\t\tbackground: var(--ck-color-base-foreground);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tmin-width: var(--ck-media-embed-placeholder-icon-size);\n\t\t\theight: var(--ck-media-embed-placeholder-icon-size);\n\t\t\tmargin-bottom: var(--ck-spacing-large);\n\t\t\tbackground-position: center;\n\t\t\tbackground-size: cover;\n\n\t\t\t& .ck-icon {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t}\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text);\n\t\t\twhite-space: nowrap;\n\t\t\ttext-align: center;\n\t\t\tfont-style: italic;\n\t\t\ttext-overflow: ellipsis;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: var(--ck-color-media-embed-placeholder-url-text-hover);\n\t\t\t\tcursor: pointer;\n\t\t\t\ttext-decoration: underline;\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="open.spotify.com"] {\n\t\tmax-width: 300px;\n\t\tmax-height: 380px;\n\t}\n\n\t&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n\t&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t}\n\n\t&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n\t\tbackground: hsl(220, 46%, 48%);\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(220, 100%, 90%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n\t\tbackground: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,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);\n\t\t}\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(302, 100%, 94%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n\n\t&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n\t\t/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n\t\tbackground: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n\t\t& .ck-media__placeholder__icon {\n\t\t\tbackground-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n\t\t}\n\n\t\t& .ck-media__placeholder__url__text {\n\t\t\tcolor: hsl(201, 100%, 86%);\n\n\t\t\t&:hover {\n\t\t\t\tcolor: hsl(0, 0%, 100%);\n\t\t\t}\n\t\t}\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      3525: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-media-embed/theme/mediaform.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css'
            ],
            names: [],
            mappings:
              'AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n\tdisplay: flex;\n\talign-items: flex-start;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\n\t& .ck-labeled-field-view {\n\t\tdisplay: inline-block;\n\t}\n\n\t& .ck-label {\n\t\tdisplay: none;\n\t}\n\n\t@mixin ck-media-phone {\n\t\tflex-wrap: wrap;\n\n\t\t& .ck-labeled-field-view {\n\t\t\tflex-basis: 100%;\n\t\t}\n\n\t\t& .ck-button {\n\t\t\tflex-basis: 50%;\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      8085: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label,.ck[dir=rtl] .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;margin:var(--ck-insert-table-dropdown-box-margin);min-height:var(--ck-insert-table-dropdown-box-height);min-width:var(--ck-insert-table-dropdown-box-width);outline:none;transition:none}.ck .ck-insert-table-dropdown-grid-box:focus{box-shadow:none}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/inserttable.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css'
            ],
            names: [],
            mappings:
              'AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,mFAEC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAFlB,iDAAkD,CADlD,qDAAsD,CADtD,mDAAoD,CAKpD,YAAa,CACb,eAUD,CARC,6CACC,eACD,CAEA,6CAEC,6CAA8C,CAD9C,yCAED',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: wrap;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-insert-table-dropdown-padding: 10px;\n\t--ck-insert-table-dropdown-box-height: 11px;\n\t--ck-insert-table-dropdown-box-width: 12px;\n\t--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n\t/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n\twidth: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n\tpadding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label,\n.ck[dir=rtl] .ck-insert-table-dropdown__label {\n\ttext-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n\tmin-width: var(--ck-insert-table-dropdown-box-width);\n\tmin-height: var(--ck-insert-table-dropdown-box-height);\n\tmargin: var(--ck-insert-table-dropdown-box-margin);\n\tborder: 1px solid var(--ck-color-base-border);\n\tborder-radius: 1px;\n\toutline: none;\n\ttransition: none;\n\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n\n\t&.ck-on {\n\t\tborder-color: var(--ck-color-focus-border);\n\t\tbackground: var(--ck-color-focus-outer-shadow);\n\t}\n}\n\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4104: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:rgba(0,0,0,.05);font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-table/theme/table.css'
            ],
            names: [],
            mappings:
              'AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,0BAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .table {\n\t/* Give the table widget some air and center it horizontally */\n\t/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n\tto avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n\tmargin: 0.9em auto;\n\tdisplay: table;\n\n\t& table {\n\t\t/* The table cells should have slight borders */\n\t\tborder-collapse: collapse;\n\t\tborder-spacing: 0;\n\n\t\t/* Table width and height are set on the parent <figure>. Make sure the table inside stretches\n\t\tto the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\t/* The outer border of the table should be slightly darker than the inner lines.\n\t\tAlso see https://github.com/ckeditor/ckeditor5-table/issues/50. */\n\t\tborder: 1px double hsl(0, 0%, 70%);\n\n\t\t& td,\n\t\t& th {\n\t\t\tmin-width: 2em;\n\t\t\tpadding: .4em;\n\n\t\t\t/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it\'s not necessary here.\n\t\t\tHowever, the border is a content style, so it should use .ck-content (so it works outside the editor).\n\t\t\tHence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */\n\t\t\tborder: 1px solid hsl(0, 0%, 75%);\n\t\t}\n\n\t\t& th {\n\t\t\tfont-weight: bold;\n\t\t\tbackground: hsla(0, 0%, 0%, 5%);\n\t\t}\n\t}\n}\n\n/* Text alignment of the table header should match the editor settings and override the native browser styling,\nwhen content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */\n.ck-content[dir="rtl"] .table th {\n\ttext-align: right;\n}\n\n.ck-content[dir="ltr"] .table th {\n\ttext-align: left;\n}\n\n.ck-editor__editable .ck-table-bogus-paragraph {\n\t/*\n\t * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.\n\t * See https://github.com/ckeditor/ckeditor5/issues/6062.\n\t */\n\tdisplay: inline-block;\n\n\t/*\n\t * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.\n\t * See https://github.com/ckeditor/ckeditor5/issues/9117.\n\t */\n\twidth: 100%;\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4777: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-color-table-focused-cell-background:rgba(158,201,250,.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-table-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css'
            ],
            names: [],
            mappings:
              'AAKA,MACC,6DACD,CAKE,8QAGC,wDAAyD,CAKzD,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD',
            sourcesContent: [
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-table-focused-cell-background: hsla(212, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n\t& td,\n\t& th {\n\t\t&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n\t\t&.ck-editor__nested-editable:focus {\n\t\t\t/* A very slight background to highlight the focused cell */\n\t\t\tbackground: var(--ck-color-table-focused-cell-background);\n\n\t\t\t/* Fixes the problem where surrounding cells cover the focused cell's border.\n\t\t\tIt does not fix the problem in all places but the UX is improved.\n\t\t\tSee https://github.com/ckeditor/ckeditor5-table/issues/29. */\n\t\t\tborder-style: none;\n\t\t\toutline: 1px solid var(--ck-color-focus-border);\n\t\t\toutline-offset: -1px; /* progressive enhancement - no IE support */\n\t\t}\n\t}\n}\n"
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      5593: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-table-selected-cell-background:rgba(158,207,250,.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:transparent;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css'
            ],
            names: [],
            mappings:
              'AAKA,MACC,wDACD,CAGC,0IAKC,gBAAiB,CAFjB,uBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,4BACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD',
            sourcesContent: [
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n\t& td.ck-editor__editable_selected,\n\t& th.ck-editor__editable_selected {\n\t\tposition: relative;\n\t\tcaret-color: transparent;\n\t\toutline: unset;\n\t\tbox-shadow: unset;\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n\t\t&:after {\n\t\t\tcontent: '';\n\t\t\tpointer-events: none;\n\t\t\tbackground-color: var(--ck-table-selected-cell-background);\n\t\t\tposition: absolute;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tbottom: 0;\n\t\t}\n\n\t\t& ::selection,\n\t\t&:focus {\n\t\t\tbackground-color: transparent;\n\t\t}\n\n\t\t/*\n\t\t * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/9491.\n\t\t */\n\t\t& .ck-widget {\n\t\t\toutline: unset;\n\n\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n"
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4499: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;justify-content:left;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid transparent;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/button.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css'
            ],
            names: [],
            mappings:
              'AAOA,6BAMC,kBAAmB,CADnB,mBAAoB,CAEpB,oBAAqB,CAHrB,iBAAkB,CCFlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDkBD,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEjBD,6BCAC,oDD4ID,CCzIE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eF6ID,CA5IA,wIEGE,qCFyIF,CA5IA,6BA6BC,uBAAwB,CANxB,4BAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBAuID,CA7GC,oFGhCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHqCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAOA,gLKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDmIA,CChIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDgHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC/IC,mDDoJD,CCjJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDgID,2CAIC,wCACD,CAEA,uCAEC,eACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-unselectable;\n\n\tposition: relative;\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: left;\n\n\t& .ck-button__label {\n\t\tdisplay: none;\n\t}\n\n\t&.ck-button_with-text {\n\t\t& .ck-button__label {\n\t\t\tdisplay: inline-block;\n\t\t}\n\t}\n\n\t/* Center the icon horizontally in a button without text. */\n\t&:not(.ck-button_with-text)  {\n\t\tjustify-content: center;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../mixins/_button.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n\t@mixin ck-button-colors --ck-color-button-default;\n\t@mixin ck-rounded-corners;\n\n\twhite-space: nowrap;\n\tcursor: default;\n\tvertical-align: middle;\n\tpadding: var(--ck-spacing-tiny);\n\ttext-align: center;\n\n\t/* A very important piece of styling. Go to variable declaration to learn more. */\n\tmin-width: var(--ck-ui-component-min-height);\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Normalize the height of the line. Removing this will break consistent height\n\tamong text and text-less buttons (with icons). */\n\tline-height: 1;\n\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t/* Avoid flickering when the foucs border shows up. */\n\tborder: 1px solid transparent;\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .2s ease-in-out, border .2s ease-in-out;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */\n\t-webkit-appearance: none;\n\n\t&:active,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t/* Allow icon coloring using the text "color" property. */\n\t& .ck-button__icon {\n\t\t& use,\n\t\t& use * {\n\t\t\tcolor: inherit;\n\t\t}\n\t}\n\n\t& .ck-button__label {\n\t\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\t\tfont-size: inherit;\n\t\tfont-weight: inherit;\n\t\tcolor: inherit;\n\t\tcursor: inherit;\n\n\t\t/* Must be consistent with .ck-icon\'s vertical align. Otherwise, buttons with and\n\t\twithout labels (but with icons) have different sizes in Chrome */\n\t\tvertical-align: middle;\n\n\t\t@mixin ck-dir ltr {\n\t\t\ttext-align: left;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttext-align: right;\n\t\t}\n\t}\n\n\t& .ck-button__keystroke {\n\t\tcolor: inherit;\n\n\t\t@mixin ck-dir ltr {\n\t\t\tmargin-left: var(--ck-spacing-large);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\tmargin-right: var(--ck-spacing-large);\n\t\t}\n\n\t\tfont-weight: bold;\n\t\topacity: .7;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t&.ck-disabled {\n\t\t&:active,\n\t\t&:focus {\n\t\t\t/* The disabled button should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t\t& .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t& .ck-button__keystroke {\n\t\t\topacity: .3;\n\t\t}\n\t}\n\n\t&.ck-button_with-text {\n\t\tpadding: var(--ck-spacing-tiny) var(--ck-spacing-standard);\n\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__icon {\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-right: calc(-1 * var(--ck-spacing-small));\n\t\t\t\tmargin-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-button_with-keystroke {\n\t\t/* stylelint-disable-next-line no-descending-specificity */\n\t\t& .ck-button__label {\n\t\t\tflex-grow: 1;\n\t\t}\n\t}\n\n\t/* A style of the button which is currently on, e.g. its feature is active. */\n\t&.ck-on {\n\t\t@mixin ck-button-colors --ck-color-button-on;\n\n\t\tcolor: var(--ck-color-button-on-color);\n\t}\n\n\t&.ck-button-save {\n\t\tcolor: var(--ck-color-button-save);\n\t}\n\n\t&.ck-button-cancel {\n\t\tcolor: var(--ck-color-button-cancel);\n\t}\n}\n\n/* A style of the button which handles the primary action. */\n.ck.ck-button-action,\na.ck.ck-button-action {\n\t@mixin ck-button-colors --ck-color-button-action;\n\n\tcolor: var(--ck-color-button-action-text);\n}\n\n.ck.ck-button-bold,\na.ck.ck-button-bold {\n\tfont-weight: bold;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n\tbackground: var($(prefix)-background);\n\n\t&:not(.ck-disabled) {\n\t\t&:hover {\n\t\t\tbackground: var($(prefix)-hover-background);\n\t\t}\n\n\t\t&:active {\n\t\t\tbackground: var($(prefix)-active-background);\n\t\t}\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n\t&.ck-disabled {\n\t\tbackground: var($(prefix)-disabled-background);\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      9681: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:transparent;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid transparent;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:transparent;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/button/switchbutton.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css'
            ],
            names: [],
            mappings:
              'AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,sBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eD4EA,CAxCA,yIChCC,qCDwED,CAxCA,2DAKE,gBAmCF,CAxCA,2DAUE,iBA8BF,CAxCA,iDAkBC,uDAAwD,CAFxD,4BAA6B,CAD7B,iFAAsF,CAEtF,0CAuBD,CApBC,2ECxDD,eDmEC,CAXA,6LCpDA,qCAAsC,CDsDpC,8CASF,CAXA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAMD,CAEA,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEhFA,kCFkFA,CAGA,oCACC,wBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n\t& .ck-button__toggle {\n\t\tdisplay: block;\n\n\t\t& .ck-button__toggle__inner {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating–point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n\t/* 34px at 13px font-size */\n\t--ck-switch-button-toggle-width: 2.6153846154em;\n\t/* 14px at 13px font-size */\n\t--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n\t--ck-switch-button-translation: calc(\n\t\tvar(--ck-switch-button-toggle-width) -\n\t\tvar(--ck-switch-button-toggle-inner-size) -\n\t\t2px /* Border */\n\t);\n\t--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n\t/* Unlike a regular button, the switch button text color and background should never change.\n\t * Changing toggle switch (background, outline) is enough to carry the information about the\n\t * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)\n\t */\n\t&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {\n\t\tcolor: inherit;\n\t\tbackground: transparent;\n\t}\n\n\t& .ck-button__label {\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-right: calc(2 * var(--ck-spacing-large));\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Separate the label from the switch */\n\t\t\tmargin-left: calc(2 * var(--ck-spacing-large));\n\t\t}\n\t}\n\n\t& .ck-button__toggle {\n\t\t@mixin ck-rounded-corners;\n\n\t\t@mixin ck-dir ltr {\n\t\t\t/* Make sure the toggle is always to the right as far as possible. */\n\t\t\tmargin-left: auto;\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t/* Make sure the toggle is always to the left as far as possible. */\n\t\t\tmargin-right: auto;\n\t\t}\n\n\t\t/* Apply some smooth transition to the box-shadow and border. */\n\t\t/* Gently animate the background color of the toggle switch */\n\t\ttransition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n\t\tborder: 1px solid transparent;\n\t\twidth: var(--ck-switch-button-toggle-width);\n\t\tbackground: var(--ck-color-switch-button-off-background);\n\n\t\t& .ck-button__toggle__inner {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-radius: calc(.5 * var(--ck-border-radius));\n\t\t\t}\n\n\t\t\twidth: var(--ck-switch-button-toggle-inner-size);\n\t\t\theight: var(--ck-switch-button-toggle-inner-size);\n\t\t\tbackground: var(--ck-color-switch-button-inner-background);\n\n\t\t\t/* Gently animate the inner part of the toggle switch */\n\t\t\ttransition: all 300ms ease;\n\t\t}\n\n\t\t&:hover {\n\t\t\tbackground: var(--ck-color-switch-button-off-hover-background);\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\tbox-shadow: var(--ck-switch-button-inner-hover-shadow);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-button__toggle {\n\t\t@mixin ck-disabled;\n\t}\n\n\t/* Overriding default .ck-button:focus styles + an outline around the toogle */\n\t&:focus {\n\t\tborder-color: transparent;\n\t\toutline: none;\n\t\tbox-shadow: none;\n\n\t\t& .ck-button__toggle {\n\t\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n\t\t\toutline-offset: 1px;\n\t\t\toutline: var(--ck-focus-ring);\n\t\t}\n\t}\n\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-on {\n\t\t& .ck-button__toggle {\n\t\t\tbackground: var(--ck-color-switch-button-on-background);\n\n\t\t\t&:hover {\n\t\t\t\tbackground: var(--ck-color-switch-button-on-hover-background);\n\t\t\t}\n\n\t\t\t& .ck-button__toggle__inner {\n\t\t\t\t/*\n\t\t\t\t* Move the toggle switch to the right. It will be animated.\n\t\t\t\t*/\n\t\t\t\t@mixin ck-dir ltr {\n\t\t\t\t\ttransform: translateX( var( --ck-switch-button-translation ) );\n\t\t\t\t}\n\n\t\t\t\t@mixin ck-dir rtl {\n\t\t\t\t\ttransform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4923: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-table__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/colorgrid/colorgrid.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css'
            ],
            names: [],
            mappings:
              'AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBAOC,QAAS,CALT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CACV,8BAA+B,CAL/B,oCAyCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,4DACC,gDACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n\tdisplay: grid;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-grid-tile-size: 24px;\n\n\t/* Not using global colors here because these may change but some colors in a pallette\n\t * require special treatment. For instance, this ensures no matter what the UI text color is,\n\t * the check icon will look good on the black color tile. */\n\t--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);\n}\n\n.ck.ck-color-grid {\n\tgrid-gap: 5px;\n\tpadding: 8px;\n}\n\n.ck.ck-color-grid__tile {\n\twidth: var(--ck-color-grid-tile-size);\n\theight: var(--ck-color-grid-tile-size);\n\tmin-width: var(--ck-color-grid-tile-size);\n\tmin-height: var(--ck-color-grid-tile-size);\n\tpadding: 0;\n\ttransition: .2s ease box-shadow;\n\tborder: 0;\n\n\t&.ck-disabled {\n\t\tcursor: unset;\n\t\ttransition: unset;\n\t}\n\n\t&.ck-color-table__color-tile_bordered {\n\t\tbox-shadow: 0 0 0 1px var(--ck-color-base-border);\n\t}\n\n\t& .ck.ck-icon {\n\t\tdisplay: none;\n\t\tcolor: var(--ck-color-color-grid-check-icon);\n\t}\n\n\t&.ck-on {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);\n\n\t\t& .ck.ck-icon {\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t&.ck-on,\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\t/* Disable the default .ck-button\'s border ring. */\n\t\tborder: 0;\n\t}\n\n\t&:focus:not( .ck-disabled ),\n\t&:hover:not( .ck-disabled ) {\n\t\tbox-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);\n\t}\n}\n\n.ck.ck-color-grid__label {\n\tpadding: 0 var(--ck-spacing-standard);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      3488: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-modal)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/dropdown.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_disabled.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css'
            ],
            names: [],
            mappings:
              'AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eH8GD,CA5BA,qFG9EE,qCH0GF,CA5BA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAmBD,CAfC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD',
            sourcesContent: [
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n\tdisplay: inline-block;\n\tposition: relative;\n\n\t& .ck-dropdown__arrow {\n\t\tpointer-events: none;\n\t\tz-index: var(--ck-z-default);\n\t}\n\n\t/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n\t& .ck-button.ck-dropdown__button {\n\t\twidth: 100%;\n\t}\n\n\t& .ck-dropdown__panel {\n\t\tdisplay: none;\n\t\tz-index: var(--ck-z-modal);\n\t\tmax-width: var(--ck-dropdown-max-width);\n\n\t\tposition: absolute;\n\n\t\t&.ck-dropdown__panel-visible {\n\t\t\tdisplay: inline-block;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_n,\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_nme {\n\t\t\tbottom: 100%;\n\t\t}\n\n\t\t&.ck-dropdown__panel_se,\n\t\t&.ck-dropdown__panel_sw,\n\t\t&.ck-dropdown__panel_smw,\n\t\t&.ck-dropdown__panel_sme,\n\t\t&.ck-dropdown__panel_s {\n\t\t\t/*\n\t\t\t * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n\t\t\t * See https://github.com/ckeditor/ckeditor5/issues/1053.\n\t\t\t */\n\t\t\ttop: 100%;\n\t\t\tbottom: auto;\n\t\t}\n\n\t\t&.ck-dropdown__panel_ne,\n\t\t&.ck-dropdown__panel_se {\n\t\t\tleft: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_nw,\n\t\t&.ck-dropdown__panel_sw {\n\t\t\tright: 0px;\n\t\t}\n\n\t\t&.ck-dropdown__panel_s,\n\t\t&.ck-dropdown__panel_n {\n\t\t\t/* Positioning panels relative to the center of the button */\n\t\t\tleft: 50%;\n\t\t\ttransform: translateX(-50%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nmw,\n\t\t&.ck-dropdown__panel_smw {\n\t\t\t/* Positioning panels relative to the middle-west of the button */\n\t\t\tleft: 75%;\n\t\t\ttransform: translateX(-75%);\n\t\t}\n\n\t\t&.ck-dropdown__panel_nme,\n\t\t&.ck-dropdown__panel_sme {\n\t\t\t/* Positioning panels relative to the middle-east of the button */\n\t\t\tleft: 25%;\n\t\t\ttransform: translateX(-25%);\n\t\t}\n\t}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n\tz-index: calc( var(--ck-z-modal) + 1 );\n}\n",
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n\t--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-dropdown {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-dropdown__arrow {\n\t\twidth: var(--ck-dropdown-arrow-size);\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& .ck-dropdown__arrow {\n\t\t\tright: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& .ck-dropdown__arrow {\n\t\t\tleft: var(--ck-spacing-standard);\n\n\t\t\t/* A space to accommodate the triangle. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\t}\n\n\t&.ck-disabled .ck-dropdown__arrow {\n\t\t@mixin ck-disabled;\n\t}\n\n\t& .ck-button.ck-dropdown__button {\n\t\t@mixin ck-dir ltr {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-left: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\t&:not(.ck-button_with-text) {\n\t\t\t\t/* Make sure dropdowns with just an icon have the right inner spacing */\n\t\t\t\tpadding-right: var(--ck-spacing-small);\n\t\t\t}\n\t\t}\n\n\t\t/* #23 */\n\t\t& .ck-button__label {\n\t\t\twidth: 7em;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */\n\t\t&.ck-disabled .ck-button__label {\n\t\t\t@mixin ck-disabled;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/816 */\n\t\t&.ck-on {\n\t\t\tborder-bottom-left-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&.ck-dropdown__button_label-width_auto .ck-button__label {\n\t\t\twidth: auto;\n\t\t}\n\n\t\t/* https://github.com/ckeditor/ckeditor5/issues/8699 */\n\t\t&.ck-off:active,\n\t\t&.ck-on:active {\n\t\t\tbox-shadow: none;\n\t\t\t\n\t\t\t&:focus {\n\t\t\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-dropdown__panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tbackground: var(--ck-color-dropdown-panel-background);\n\tborder: 1px solid var(--ck-color-dropdown-panel-border);\n\tbottom: 0;\n\n\t/* Make sure the panel is at least as wide as the drop-down\'s button. */\n\tmin-width: 100%;\n\n\t/* Disabled corner border radius to be consistent with the .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-dropdown__panel_se {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_sw {\n\t\tborder-top-right-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_ne {\n\t\tborder-bottom-left-radius: 0;\n\t}\n\n\t&.ck-dropdown__panel_nw {\n\t\tborder-bottom-right-radius: 0;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n\topacity: var(--ck-disabled-opacity);\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      6875: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css'
            ],
            names: [],
            mappings:
              'AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n\t/* Disabled radius of top-left border to be consistent with .dropdown__button\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t@mixin ck-rounded-corners {\n\t\tborder-top-left-radius: 0;\n\t}\n\n\t/* Make sure the button belonging to the first/last child of the list goes well with the\n\tborder radius of the entire panel. */\n\t& .ck-list__item {\n\t\t&:first-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\n\t\t&:last-child .ck-button {\n\t\t\t@mixin ck-rounded-corners {\n\t\t\t\tborder-top-left-radius: 0;\n\t\t\t\tborder-top-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      66: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton>.ck-splitbutton__arrow:not(:focus){border-bottom-width:0;border-top-width:0}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:focus:after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:focus:after{--ck-color-split-button-hover-border:var(--ck-color-focus-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/splitbutton.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css'
            ],
            names: [],
            mappings:
              'AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CAKD,sDAEC,qBAAwB,CADxB,kBAED,CAQC,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGA,sIACC,iEACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCCzFA,eDmGA,CAVA,qHCrFC,qCD+FD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n\t/* Enable font size inheritance, which allows fluid UI scaling. */\n\tfont-size: inherit;\n\n\t& .ck-splitbutton__action:focus {\n\t\tz-index: calc(var(--ck-z-default) + 1);\n\t}\n}\n\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-color-split-button-hover-background: hsl(0, 0%, 92%);\n\t--ck-color-split-button-hover-border: hsl(0, 0%, 70%);\n}\n\n.ck.ck-splitbutton {\n\t/*\n\t * Note: ck-rounded and ck-dir mixins don\'t go together (because they both use @nest).\n\t */\n\t&:hover > .ck-splitbutton__action,\n\t&.ck-splitbutton_open > .ck-splitbutton__action {\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the action button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the action button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\t}\n\n\t& > .ck-splitbutton__arrow {\n\t\t/* It\'s a text-less button and since the icon is positioned absolutely in such situation,\n\t\tit must get some arbitrary min-width. */\n\t\tmin-width: unset;\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t/* Don\'t round the arrow button on the left side */\n\t\t\tborder-top-left-radius: unset;\n\t\t\tborder-bottom-left-radius: unset;\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t/* Don\'t round the arrow button on the right side */\n\t\t\tborder-top-right-radius: unset;\n\t\t\tborder-bottom-right-radius: unset;\n\t\t}\n\n\t\t& svg {\n\t\t\twidth: var(--ck-dropdown-arrow-size);\n\t\t}\n\t}\n\n\t/* Make sure the divider stretches 100% height of the button\n\thttps://github.com/ckeditor/ckeditor5/issues/10936 */\n\t& > .ck-splitbutton__arrow:not(:focus) {\n\t\tborder-top-width: 0px;\n\t\tborder-bottom-width: 0px;\n\t}\n\n\t/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling\n\tas a whole. The background of both buttons should stand out and there should be a visual\n\tseparation between both buttons. */\n\t&.ck-splitbutton_open,\n\t&:hover {\n\t\t/* When the split button hovered as a whole, not as individual buttons. */\n\t\t& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {\n\t\t\tbackground: var(--ck-color-split-button-hover-background);\n\t\t}\n\n\t\t/* Splitbutton separator needs to be set with the ::after pseudoselector\n\t\tto display properly the borders on focus */\n\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\tcontent: \'\';\n\t\t\tposition: absolute;\n\t\t\twidth: 1px;\n\t\t\theight: 100%;\n\t\t\tbackground-color: var(--ck-color-split-button-hover-border);\n\t\t}\n\n\t\t/* Make sure the divider between the buttons looks fine when the button is focused */\n\t\t& > .ck-splitbutton__arrow:focus::after {\n\t\t\t--ck-color-split-button-hover-border: var(--ck-color-focus-border);\n\t\t}\n\n\t\t@nest [dir="ltr"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tleft: -1px;\n\t\t\t}\n\t\t}\n\n\t\t@nest [dir="rtl"] & {\n\t\t\t& > .ck-splitbutton__arrow:not(.ck-disabled)::after {\n\t\t\t\tright: -1px;\n\t\t\t}\n\t\t}\n\t}\n\n\t/* Don\'t round the bottom left and right corners of the buttons when "open"\n\thttps://github.com/ckeditor/ckeditor5/issues/816 */\n\t&.ck-splitbutton_open {\n\t\t@mixin ck-rounded-corners {\n\t\t\t& > .ck-splitbutton__action {\n\t\t\t\tborder-bottom-left-radius: 0;\n\t\t\t}\n\n\t\t\t& > .ck-splitbutton__arrow {\n\t\t\t\tborder-bottom-right-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      5075: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/dropdown/toolbardropdown.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css'
            ],
            names: [],
            mappings:
              'AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n\t/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n\twidth: max-content;\n\tmax-width: var(--ck-toolbar-dropdown-max-width);\n\n\t& .ck-button {\n\t\t&:focus {\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n\tborder: 0;\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      4547: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid transparent;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-base-foreground)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-base-foreground)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css'
            ],
            names: [],
            mappings:
              'AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,4BAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,mDACD,CAIA,gEACC,gDACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n\t--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n\t@mixin ck-rounded-corners;\n\n\t&.ck-focused {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\t}\n}\n\n.ck.ck-editor__editable_inline {\n\toverflow: auto;\n\tpadding: 0 var(--ck-spacing-standard);\n\tborder: 1px solid transparent;\n\n\t&[dir="ltr"] {\n\t\ttext-align: left;\n\t}\n\n\t&[dir="rtl"] {\n\t\ttext-align: right;\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n\t& > *:first-child {\n\t\tmargin-top: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/847 */\n\t& > *:last-child {\n\t\t/*\n\t\t * This value should match with the default margins of the block elements (like .media or .image)\n\t\t * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n\t\t */\n\t\tmargin-bottom: var(--ck-spacing-large);\n\t}\n\n\t/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n\t&.ck-blurred ::selection {\n\t\tbackground: var(--ck-color-editable-blur-selection);\n\t}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n\t&::after {\n\t\tborder-bottom-color: var(--ck-color-base-foreground);\n\t}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n\t&::after {\n\t\tborder-top-color: var(--ck-color-base-foreground);\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      5523: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}:root{--ck-form-header-height:38px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}.ck.ck-form__header .ck-form__header__label{font-weight:700}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/formheader/formheader.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css'
            ],
            names: [],
            mappings:
              'AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BACD,CCNA,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAQD,CAHC,4CACC,eACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n\tdisplay: flex;\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\talign-items: center;\n\tjustify-content: space-between;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n\tpadding: var(--ck-spacing-small) var(--ck-spacing-large);\n\theight: var(--ck-form-header-height);\n\tline-height: var(--ck-form-header-height);\n\tborder-bottom: 1px solid var(--ck-color-base-border);\n\n\t& .ck-form__header__label {\n\t\tfont-weight: bold;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      1174: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/icon/icon.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css'
            ],
            names: [],
            mappings:
              'AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n\tvertical-align: middle;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n\twidth: var(--ck-icon-size);\n\theight: var(--ck-icon-size);\n\n\t/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n\tfont-size: .8333350694em;\n\n\t/* Inherit cursor style (#5). */\n\tcursor: inherit;\n\n\t/* This will prevent blurry icons on Firefox. See #340. */\n\twill-change: transform;\n\n\t& * {\n\t\t/* Inherit cursor style (#5). */\n\t\tcursor: inherit;\n\t}\n\n\t/* Allows dynamic coloring of an icon by inheriting its color from the parent. */\n\t&.ck-icon_inherit-color {\n\t\tcolor: inherit;\n\n\t\t& * {\n\t\t\tcolor: inherit;\n\n\t\t\t&:not([fill]) {\n\t\t\t\t/* Needed by FF. */\n\t\t\t\tfill: currentColor;\n\t\t\t}\n\t\t}\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      6985: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css'
            ],
            names: [],
            mappings:
              'AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eD2CD,CAtCA,iECDE,qCDuCF,CAtCA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DA0BD,CAxBC,mBEnBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YFuBA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BG/BD,oDHkCC,CAGD,sBAEC,sCAAuC,CADvC,+CAMD,CAHC,4BGzCD,iDH2CC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-input-width: 18em;\n\n\t/* Backward compatibility. */\n\t--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-input-background);\n\tborder: 1px solid var(--ck-color-input-border);\n\tpadding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n\tmin-width: var(--ck-input-width);\n\n\t/* This is important to stay of the same height as surrounding buttons */\n\tmin-height: var(--ck-ui-component-min-height);\n\n\t/* Apply some smooth transition to the box-shadow and border. */\n\ttransition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n\t}\n\n\t&[readonly] {\n\t\tborder: 1px solid var(--ck-color-input-disabled-border);\n\t\tbackground: var(--ck-color-input-disabled-background);\n\t\tcolor: var(--ck-color-input-disabled-text);\n\n\t\t&:focus {\n\t\t\t/* The read-only input should have a slightly less visible shadow when focused. */\n\t\t\t@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\tborder-color: var(--ck-color-input-error-border);\n\t\tanimation: ck-input-shake .3s ease both;\n\n\t\t&:focus {\n\t\t\t@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n\t\t}\n\t}\n}\n\n@keyframes ck-input-shake {\n\t20% {\n\t\ttransform: translateX(-2px);\n\t}\n\n\t40% {\n\t\ttransform: translateX(2px);\n\t}\n\n\t60% {\n\t\ttransform: translateX(-1px);\n\t}\n\n\t80% {\n\t\ttransform: translateX(1px);\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      2751: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/label/label.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css'
            ],
            names: [],
            mappings: 'AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tdisplay: block;\n}\n\n.ck.ck-voice-label {\n\tdisplay: none;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n\tfont-weight: bold;\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      8111: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:transparent;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css'
            ],
            names: [],
            mappings:
              'AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eD8GD,CAzGA,2FCDE,qCD0GF,CAtGC,mEACC,UAmCD,CAjCC,gFACC,KA+BD,CAhCA,0FAIE,MA4BF,CAhCA,0FAQE,OAwBF,CAhCA,gFAiBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAP9C,mBAAoB,CAYpB,sBAAuB,CARvB,6DAA+D,CAH/D,oBAAqB,CAgBrB,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,oUAGE,+HAYF,CAfA,oUAOE,wIAQF,CAfA,gTAaC,sBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\tdisplay: flex;\n\t\tposition: relative;\n\t}\n\n\t& .ck.ck-label {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../../../mixins/_rounded.css";\n\n:root {\n\t--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);\n\t--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);\n\t--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));\n\t--ck-color-labeled-field-label-background: var(--ck-color-base-background);\n}\n\n.ck.ck-labeled-field-view {\n\t@mixin ck-rounded-corners;\n\n\t& > .ck.ck-labeled-field-view__input-wrapper {\n\t\twidth: 100%;\n\n\t\t& > .ck.ck-label {\n\t\t\ttop: 0px;\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tleft: 0px;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tright: 0px;\n\t\t\t}\n\n\t\t\tpointer-events: none;\n\t\t\ttransform-origin: 0 0;\n\n\t\t\t/* By default, display the label scaled down above the field. */\n\t\t\ttransform: translate(var(--ck-spacing-medium), -6px) scale(.75);\n\n\t\t\tbackground: var(--ck-color-labeled-field-label-background);\n\t\t\tpadding: 0 calc(.5 * var(--ck-font-size-tiny));\n\t\t\tline-height: initial;\n\t\t\tfont-weight: normal;\n\n\t\t\t/* Prevent overflow when the label is longer than the input */\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\n\t\t\tmax-width: 100%;\n\n\t\t\ttransition:\n\t\t\t\ttransform var(--ck-labeled-field-view-transition),\n\t\t\t\tpadding var(--ck-labeled-field-view-transition),\n\t\t\t\tbackground var(--ck-labeled-field-view-transition);\n\t\t}\n\t}\n\n\t&.ck-error {\n\t\t& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\n\t\t& .ck-input:not([readonly]) + .ck.ck-label {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t& .ck-labeled-field-view__status {\n\t\tfont-size: var(--ck-font-size-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\n\t\t/* Let the info wrap to the next line to avoid stretching the layout horizontally.\n\t\tThe status could be very long. */\n\t\twhite-space: normal;\n\n\t\t&.ck-labeled-field-view__status_error {\n\t\t\tcolor: var(--ck-color-base-error);\n\t\t}\n\t}\n\n\t/* Disabled fields and fields that have no focus should fade out. */\n\t&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\tcolor: var(--ck-color-input-disabled-text);\n\t}\n\n\t/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */\n\t/* stylelint-disable-next-line no-descending-specificity */\n\t&.ck-disabled.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {\n\t\t@mixin ck-dir ltr {\n\t\t\ttransform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t@mixin ck-dir rtl {\n\t\t\ttransform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);\n\t\t}\n\n\t\t/* Compensate for the default translate position. */\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));\n\n\t\tbackground: transparent;\n\t\tpadding: 0;\n\t}\n\n\t/*------ DropdownView integration ----------------------------------------------------------------------------------- */\n\n\t/* Make sure dropdown\' background color in any of dropdown\'s state does not collide with labeled field. */\n\t& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {\n\t\tbackground: transparent;\n\t}\n\n\t/* When the dropdown is "empty", the labeled field label replaces its label. */\n\t&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {\n\t\topacity: 0;\n\t}\n\n\t/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */\n\t&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {\n\t\tmax-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      1162: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{border-radius:0;min-height:unset;padding:calc(var(--ck-line-height-base)*.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*.4*var(--ck-font-size-base));text-align:left;width:100%}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/list/list.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css'
            ],
            names: [],
            mappings:
              'AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEfD,YCEC,eDGD,CALA,+DCME,qCDDF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cA2DD,CAzDC,6BAIC,eAAgB,CAHhB,gBAAiB,CAQjB,iIAEiE,CARjE,eAAgB,CADhB,UAwCD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\n\t& .ck-list__item,\n\t& .ck-list__separator {\n\t\tdisplay: block;\n\t}\n\n\t/* Make sure that whatever child of the list item gets focus, it remains on the\n\ttop. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n\tadjacent list items. */\n\t& .ck-list__item > *:focus {\n\t\tposition: relative;\n\t\tz-index: var(--ck-z-default);\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-list {\n\t@mixin ck-rounded-corners;\n\n\tlist-style-type: none;\n\tbackground: var(--ck-color-list-background);\n}\n\n.ck.ck-list__item {\n\tcursor: default;\n\tmin-width: 12em;\n\n\t& .ck-button {\n\t\tmin-height: unset;\n\t\twidth: 100%;\n\t\ttext-align: left;\n\t\tborder-radius: 0;\n\n\t\t/* List items should have the same height. Use absolute units to make sure it is so\n\t\t   because e.g. different heading styles may have different height\n\t\t   https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\tpadding:\n\t\t\tcalc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))\n\t\t\tcalc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\n\t\t& .ck-button__label {\n\t\t\t/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */\n\t\t\tline-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));\n\t\t}\n\n\t\t&:active {\n\t\t\tbox-shadow: none;\n\t\t}\n\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-button-on-background);\n\t\t\tcolor: var(--ck-color-list-button-on-text);\n\n\t\t\t&:active {\n\t\t\t\tbox-shadow: none;\n\t\t\t}\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-on-background-focus);\n\t\t\t}\n\n\t\t\t&:focus:not(.ck-switchbutton):not(.ck-disabled) {\n\t\t\t\tborder-color: var(--ck-color-base-background);\n\t\t\t}\n\t\t}\n\n\t\t&:hover:not(.ck-disabled) {\n\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t}\n\t}\n\n\t/* It\'s unnecessary to change the background/text of a switch toggle; it has different ways\n\tof conveying its state (like the switcher) */\n\t& .ck-switchbutton {\n\t\t&.ck-on {\n\t\t\tbackground: var(--ck-color-list-background);\n\t\t\tcolor: inherit;\n\n\t\t\t&:hover:not(.ck-disabled) {\n\t\t\t\tbackground: var(--ck-color-list-button-hover-background);\n\t\t\t\tcolor: inherit;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-list__separator {\n\theight: 1px;\n\twidth: 100%;\n\tbackground: var(--ck-color-base-border);\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      8245: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:transparent transparent var(--ck-color-panel-border) transparent;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:transparent transparent var(--ck-color-panel-background) transparent;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) transparent transparent;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) transparent transparent transparent;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:transparent transparent transparent var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:transparent transparent transparent var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:transparent var(--ck-color-panel-border) transparent transparent;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:transparent var(--ck-color-panel-background) transparent transparent;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonpanel.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css'
            ],
            names: [],
            mappings:
              'AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,kDACD,CAEA,2CACC,iFAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,iEAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,iFAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,oDACD,CAEA,2CACC,iFAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,mDACD,CAEA,2CACC,iFAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* Make sure the balloon arrow does not float over its children. */\n\t--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n\tdisplay: none;\n\tposition: absolute;\n\n\tz-index: var(--ck-z-modal);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tposition: absolute;\n\t\t}\n\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before {\n\t\t\tz-index: var(--ck-balloon-panel-arrow-z-index);\n\t\t}\n\n\t\t&::after {\n\t\t\tz-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_visible {\n\t\tdisplay: block;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-border-width: 1px;\n\t--ck-balloon-arrow-offset: 2px;\n\t--ck-balloon-arrow-height: 10px;\n\t--ck-balloon-arrow-half-width: 8px;\n\t--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n\t@mixin ck-rounded-corners;\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n\t&.ck-balloon-panel_with-arrow {\n\t\t&::before,\n\t\t&::after {\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t\tborder-style: solid;\n\t\t}\n\t}\n\n\t&[class*="arrow_n"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-border) transparent;\n\t\t\tmargin-top: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent var(--ck-color-panel-background) transparent;\n\t\t\tmargin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_s"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: var(--ck-color-panel-border) transparent transparent;\n\t\t\tfilter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n\t\t\tmargin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: var(--ck-color-panel-background) transparent transparent transparent;\n\t\t\tmargin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_e"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-border);\n\t\t\tmargin-right: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent transparent transparent var(--ck-color-panel-background);\n\t\t\tmargin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&[class*="arrow_w"] {\n\t\t&::before,\n\t\t&::after {\n\t\t\tborder-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n\t\t}\n\n\t\t&::before {\n\t\t\tborder-color: transparent var(--ck-color-panel-border) transparent transparent;\n\t\t\tmargin-left: calc( -1 * var(--ck-balloon-border-width) );\n\t\t}\n\n\t\t&::after {\n\t\t\tborder-color: transparent var(--ck-color-panel-background) transparent transparent;\n\t\t\tmargin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_n {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_ne {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_s {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 50%;\n\t\t\tmargin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_se {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_sme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_smw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\tbottom: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nme {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: 25%;\n\t\t\tmargin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_nmw {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: 25%;\n\t\t\tmargin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_e {\n\t\t&::before,\n\t\t&::after {\n\t\t\tright: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n\n\t&.ck-balloon-panel_arrow_w {\n\t\t&::before,\n\t\t&::after {\n\t\t\tleft: calc(-1 * var(--ck-balloon-arrow-height));\n\t\t\tmargin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n\t\t\ttop: 50%;\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      1757: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/balloonrotator.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css'
            ],
            names: [],
            mappings:
              'AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n\tjustify-content: center;\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n\tbackground: var(--ck-color-toolbar-background);\n\tborder-bottom: 1px solid var(--ck-color-toolbar-border);\n\tpadding: 0 var(--ck-spacing-small);\n\n\t/* Let's keep similar appearance to `ck-toolbar`. */\n\t& > * {\n\t\tmargin-right: var(--ck-spacing-small);\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t/* Gives counter more breath than buttons. */\n\t& .ck-balloon-rotator__counter {\n\t\tmargin-right: var(--ck-spacing-standard);\n\n\t\t/* We need to use smaller margin because of previous button's right margin. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n.ck .ck-balloon-rotator__content {\n\n\t/* Disable default annotation shadow inside rotator with fake panels. */\n\t& .ck.ck-annotation-wrapper {\n\t\tbox-shadow: none;\n\t}\n}\n"
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      3553: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/fakepanel.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css'
            ],
            names: [],
            mappings:
              'AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n\tposition: absolute;\n\n\t/* Fake panels should be placed under main balloon content. */\n\tz-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n\tposition: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tz-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tz-index: 1;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n\t--ck-balloon-fake-panel-offset-horizontal: 6px;\n\t--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n\t@mixin ck-drop-shadow;\n\n\tmin-height: 15px;\n\n\tbackground: var(--ck-color-panel-background);\n\tborder: 1px solid var(--ck-color-panel-border);\n\tborder-radius: var(--ck-border-radius);\n\n\twidth: 100%;\n\theight: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n\tmargin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n\tmargin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n\tmargin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n\tmargin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n\t--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      3609: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-modal)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/panel/stickypanel.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css'
            ],
            names: [],
            mappings:
              'AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\tz-index: var(--ck-z-modal); /* #315 */\n\t\tposition: fixed;\n\t\ttop: 0;\n\t}\n\n\t& .ck-sticky-panel__content_sticky_bottom-limit {\n\t\ttop: auto;\n\t\tposition: absolute;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n\t& .ck-sticky-panel__content_sticky {\n\t\t@mixin ck-drop-shadow;\n\n\t\tborder-width: 0 1px 1px;\n\t\tborder-top-left-radius: 0;\n\t\tborder-top-right-radius: 0;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      1590: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/responsive-form/responsiveform.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css'
            ],
            names: [],
            mappings:
              'AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAmED,CAjEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA8CF,CA5CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDpEH',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n\t&::after {\n\t\tcontent: "";\n\t\twidth: 0;\n\t\tposition: absolute;\n\t\tright: -1px;\n\t\ttop: -1px;\n\t\tbottom: -1px;\n\t\tz-index: 1;\n\t}\n\n\t&:focus::after {\n\t\tdisplay: none;\n\t}\n}\n\n.ck.ck-responsive-form {\n\t@mixin ck-media-phone {\n\t\t& .ck-button {\n\t\t\t&::after {\n\t\t\t\tcontent: "";\n\t\t\t\twidth: 0;\n\t\t\t\tposition: absolute;\n\t\t\t\tright: -1px;\n\t\t\t\ttop: -1px;\n\t\t\t\tbottom: -1px;\n\t\t\t\tz-index: 1;\n\t\t\t}\n\n\t\t\t&:focus::after {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n\t@media screen and (max-width: 600px) {\n\t\t@mixin-content;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n\tborder-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n\tpadding: var(--ck-spacing-large);\n\n\t&:focus {\n\t\t/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n\t\toutline: none;\n\t}\n\n\t@mixin ck-dir ltr {\n\t\t& > :not(:first-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-dir rtl {\n\t\t& > :not(:last-child) {\n\t\t\tmargin-left: var(--ck-spacing-standard);\n\t\t}\n\t}\n\n\t@mixin ck-media-phone {\n\t\tpadding: 0;\n\t\twidth: calc(.8 * var(--ck-input-width));\n\n\t\t& .ck-labeled-field-view {\n\t\t\tmargin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n\t\t\t& .ck-input-text {\n\t\t\t\tmin-width: 0;\n\t\t\t\twidth: 100%;\n\t\t\t}\n\n\t\t\t/* Let the long error messages wrap in the narrow form. */\n\t\t\t& .ck-labeled-field-view__error {\n\t\t\t\twhite-space: normal;\n\t\t\t}\n\t\t}\n\n\t\t/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\t&::after {\n\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\t\t}\n\n\t\t& > .ck-button:nth-last-child(1),\n\t\t& > .ck-button:nth-last-child(2) {\n\t\t\tpadding: var(--ck-spacing-standard);\n\t\t\tmargin-top: var(--ck-spacing-large);\n\t\t\tborder-radius: 0;\n\n\t\t\t&:not(:focus) {\n\t\t\t\tborder-top: 1px solid var(--ck-color-base-border);\n\t\t\t}\n\n\t\t\t@mixin ck-dir ltr {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\n\t\t\t@mixin ck-dir rtl {\n\t\t\t\tmargin-left: 0;\n\n\t\t\t\t&:last-of-type {\n\t\t\t\t\tborder-right: 1px solid var(--ck-color-base-border);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      6706: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/blocktoolbar.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css'
            ],
            names: [],
            mappings:
              'AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n\tposition: absolute;\n\tz-index: var(--ck-z-default);\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-block-toolbar-button: var(--ck-color-text);\n\t--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n\tcolor: var(--ck-color-block-toolbar-button);\n\tfont-size: var(--ck-block-toolbar-size);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      5571: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/toolbar/toolbar.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css'
            ],
            names: [],
            mappings:
              'AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDoGD,CAvGA,qECOE,qCDgGF,CAvGA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAmGD,CAhGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAjGF,qCAqGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-unselectable;\n\n\tdisplay: flex;\n\tflex-flow: row nowrap;\n\talign-items: center;\n\n\t& > .ck-toolbar__items {\n\t\tdisplay: flex;\n\t\tflex-flow: row wrap;\n\t\talign-items: center;\n\t\tflex-grow: 1;\n\n\t}\n\n\t& .ck.ck-toolbar__separator {\n\t\tdisplay: inline-block;\n\n\t\t/*\n\t\t * A leading or trailing separator makes no sense (separates from nothing on one side).\n\t\t * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n\t\t * moved to another toolbar in the dropdown.\n\t\t */\n\t\t&:first-child,\n\t\t&:last-child {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\tflex-basis: 100%;\n\t}\n\n\t&.ck-toolbar_grouping > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t&.ck-toolbar_vertical > .ck-toolbar__items {\n\t\tflex-direction: column;\n\t}\n\n\t&.ck-toolbar_floating > .ck-toolbar__items {\n\t\tflex-wrap: nowrap;\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t& > .ck-dropdown__button .ck-dropdown__arrow {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n\t-moz-user-select: none;\n\t-webkit-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-toolbar {\n\t@mixin ck-rounded-corners;\n\n\tbackground: var(--ck-color-toolbar-background);\n\tpadding: 0 var(--ck-spacing-small);\n\tborder: 1px solid var(--ck-color-toolbar-border);\n\n\t& .ck.ck-toolbar__separator {\n\t\talign-self: stretch;\n\t\twidth: 1px;\n\t\tmin-width: 1px;\n\t\tbackground: var(--ck-color-toolbar-border);\n\n\t\t/*\n\t\t * These margins make the separators look better in balloon toolbars (when aligned with the "tip").\n\t\t * See https://github.com/ckeditor/ckeditor5/issues/7493.\n\t\t */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t& .ck-toolbar__line-break {\n\t\theight: 0;\n\t}\n\n\t& > .ck-toolbar__items {\n\t\t& > *:not(.ck-toolbar__line-break) {\n\t\t\t/* (#11) Separate toolbar items. */\n\t\t\tmargin-right: var(--ck-spacing-small);\n\t\t}\n\n\t\t/* Don\'t display a separator after an empty items container, for instance,\n\t\twhen all items were grouped */\n\t\t&:empty + .ck.ck-toolbar__separator {\n\t\t\tdisplay: none;\n\t\t}\n\t}\n\n\t& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/* Make sure items wrapped to the next line have v-spacing */\n\t\tmargin-top: var(--ck-spacing-small);\n\t\tmargin-bottom: var(--ck-spacing-small);\n\t}\n\n\t&.ck-toolbar_vertical {\n\t\t/* Items in a vertical toolbar span the entire width. */\n\t\tpadding: 0;\n\n\t\t/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */\n\t\t& > .ck-toolbar__items > .ck {\n\t\t\t/* Items in a vertical toolbar should span the horizontal space. */\n\t\t\twidth: 100%;\n\n\t\t\t/* Items in a vertical toolbar should have no margin. */\n\t\t\tmargin: 0;\n\n\t\t\t/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */\n\t\t\tborder-radius: 0;\n\t\t}\n\t}\n\n\t&.ck-toolbar_compact {\n\t\t/* No spacing around items. */\n\t\tpadding: 0;\n\n\t\t& > .ck-toolbar__items > * {\n\t\t\t/* Compact toolbar items have no spacing between them. */\n\t\t\tmargin: 0;\n\n\t\t\t/* "Middle" children should have no rounded corners. */\n\t\t\t&:not(:first-child):not(:last-child) {\n\t\t\t\tborder-radius: 0;\n\t\t\t}\n\t\t}\n\t}\n\n\t& > .ck.ck-toolbar__grouped-dropdown {\n\t\t/*\n\t\t * Dropdown button has asymmetric padding to fit the arrow.\n\t\t * This button has no arrow so let\'s revert that padding back to normal.\n\t\t */\n\t\t& > .ck.ck-button.ck-dropdown__button {\n\t\t\tpadding-left: var(--ck-spacing-tiny);\n\t\t}\n\t}\n\n\t/* A drop-down containing the nested toolbar with configured items. */\n\t& .ck-toolbar__nested-toolbar-dropdown {\n\t\t/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */\n\t\t& > .ck-dropdown__panel {\n\t\t\tmin-width: auto;\n\t\t}\n\n\t\t& > .ck-button > .ck-button__label {\n\t\t\tmax-width: 7em;\n\t\t\twidth: auto;\n\t\t}\n\t}\n\n\t@nest .ck-toolbar-container & {\n\t\tborder: 0;\n\t}\n}\n\n/* stylelint-disable */\n\n/*\n * Styles for RTL toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="rtl"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="rtl"] {\n\t& > .ck-toolbar__items > .ck {\n\t\tmargin-right: 0;\n\t}\n\n\t&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {\n\t\t/* (#11) Separate toolbar items. */\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-left: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-left: var(--ck-spacing-small);\n\t}\n}\n\n/*\n * Styles for LTR toolbars.\n *\n * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"\n * because its parent is not controlled by the editor framework.\n */\n[dir="ltr"] .ck.ck-toolbar,\n.ck.ck-toolbar[dir="ltr"] {\n\t& > .ck-toolbar__items > .ck:last-child {\n\t\tmargin-right: 0;\n\t}\n\n\t&.ck-toolbar_compact > .ck-toolbar__items > .ck {\n\t\t/* No rounded corners on the right side of the first child. */\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t/* No rounded corners on the left side of the last child. */\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\t}\n\n\t/* Separate the the separator form the grouping dropdown when some items are grouped. */\n\t& > .ck.ck-toolbar__separator {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n\n\t/* Some spacing between the items and the separator before the grouped items dropdown. */\n\t&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {\n\t\tmargin-right: var(--ck-spacing-small);\n\t}\n}\n\n/* stylelint-enable */\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n\tborder-radius: 0;\n\n\t@nest .ck-rounded-corners &,\n\t&.ck-rounded-corners {\n\t\tborder-radius: var(--ck-border-radius);\n\t\t@mixin-content;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      9948: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck.ck-balloon-panel.ck-tooltip{--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium);pointer-events:none;z-index:calc(var(--ck-z-modal) + 100)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/components/tooltip/tooltip.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css'
            ],
            names: [],
            mappings:
              'AAKA,gCCGC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,8DAA+D,CAE/D,kCAAmC,CDPnC,mBAAoB,CAEpB,qCACD,CCMC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAbD,gCAgBC,eAMD,CAHC,uCACC,YACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t/* Keep tooltips transparent for any interactions. */\n\tpointer-events: none;\n\n\tz-index: calc( var(--ck-z-modal) + 100 );\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n\t--ck-balloon-border-width: 0px;\n\t--ck-balloon-arrow-offset: 0px;\n\t--ck-balloon-arrow-half-width: 4px;\n\t--ck-balloon-arrow-height: 4px;\n\t--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n\tpadding: 0 var(--ck-spacing-medium);\n\n\t& .ck-tooltip__text {\n\t\tfont-size: .9em;\n\t\tline-height: 1.5;\n\t\tcolor: var(--ck-color-tooltip-text);\n\t}\n\n\t/* Reset balloon panel styles */\n\tbox-shadow: none;\n\n\t/* Hide the default shadow of the .ck-balloon-panel tip */\n\t&::before {\n\t\tdisplay: none;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      6150: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck-hidden{display:none!important}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{box-sizing:border-box;height:auto;position:static;width:auto}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:rgba(119,186,248,.3);--ck-color-focus-error-shadow:rgba(255,64,31,.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,.15);--ck-color-shadow-drop-active:rgba(0,0,0,.2);--ck-color-shadow-inner:rgba(0,0,0,.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,176,255,.1);--ck-color-link-fake-selection:rgba(31,176,255,.3);--ck-color-highlight-background:#ff0;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{word-wrap:break-word;background:transparent;border:0;margin:0;padding:0;text-decoration:none;transition:none;vertical-align:middle}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_hidden.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_reset.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_zindex.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-ui/theme/globals/_transition.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css'
            ],
            names: [],
            mappings:
              'AAQA,WAGC,sBACD,CCPA,2EAGC,qBAAsB,CAEtB,WAAY,CACZ,eAAgB,CAFhB,UAGD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,qDAA8D,CAC9D,gDAAyD,CACzD,yCAAqD,CACrD,sCAAsD,CACtD,4CAA0D,CAC1D,sCAAsD,CAItD,gDAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,yDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,oDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,uDAAmE,CACnE,kDAAgE,CAIhE,oCAAwD,CCvGxD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJuGD,CIjGA,2EAaC,oBAAqB,CANrB,sBAAuB,CADvB,QAAS,CAFT,QAAS,CACT,SAAU,CAGV,oBAAqB,CAErB,eAAgB,CADhB,qBAKD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n\t/* Override selector specificity. Otherwise, all elements with some display\n\tstyle defined will override this one, which is not a desired result. */\n\tdisplay: none !important;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\tbox-sizing: border-box;\n\twidth: auto;\n\theight: auto;\n\tposition: static;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-z-default: 1;\n\t--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n\ttransition: none !important;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-base-foreground: \t\t\t\t\t\t\t\thsl(0, 0%, 98%);\n\t--ck-color-base-background: \t\t\t\t\t\t\t\thsl(0, 0%, 100%);\n\t--ck-color-base-border: \t\t\t\t\t\t\t\t\thsl(220, 6%, 81%);\n\t--ck-color-base-action: \t\t\t\t\t\t\t\t\thsl(104, 50.2%, 42.5%);\n\t--ck-color-base-focus: \t\t\t\t\t\t\t\t\t\thsl(209, 92%, 70%);\n\t--ck-color-base-text: \t\t\t\t\t\t\t\t\t\thsl(0, 0%, 20%);\n\t--ck-color-base-active: \t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\t--ck-color-base-active-focus:\t\t\t\t\t\t\t\thsl(218.2, 100%, 52.5%);\n\t--ck-color-base-error:\t\t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t/* -- Generic colors ------------------------------------------------------------------------ */\n\n\t--ck-color-focus-border-coordinates: \t\t\t\t\t\t218, 81.8%, 56.9%;\n\t--ck-color-focus-border: \t\t\t\t\t\t\t\t\thsl(var(--ck-color-focus-border-coordinates));\n\t--ck-color-focus-outer-shadow:\t\t\t\t\t\t\t\thsl(212.4, 89.3%, 89%);\n\t--ck-color-focus-disabled-shadow:\t\t\t\t\t\t\thsla(209, 90%, 72%,.3);\n\t--ck-color-focus-error-shadow:\t\t\t\t\t\t\t\thsla(9,100%,56%,.3);\n\t--ck-color-text: \t\t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-shadow-drop: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.15);\n\t--ck-color-shadow-drop-active:\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.2);\n\t--ck-color-shadow-inner: \t\t\t\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Buttons ------------------------------------------------------------------------------- */\n\n\t--ck-color-button-default-background: \t\t\t\t\t\ttransparent;\n\t--ck-color-button-default-hover-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-active-background: \t\t\t\thsl(0, 0%, 94.1%);\n\t--ck-color-button-default-disabled-background: \t\t\t\ttransparent;\n\n\t--ck-color-button-on-background: \t\t\t\t\t\t\thsl(212, 100%, 97.1%);\n\t--ck-color-button-on-hover-background: \t\t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-active-background: \t\t\t\t\thsl(211.7, 100%, 92.9%);\n\t--ck-color-button-on-disabled-background: \t\t\t\t\thsl(211, 15%, 95%);\n\t--ck-color-button-on-color:\t\t\t\t\t\t\t\t\thsl(218.1, 100%, 58%);\n\n\n\t--ck-color-button-action-background: \t\t\t\t\t\tvar(--ck-color-base-action);\n\t--ck-color-button-action-hover-background: \t\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-active-background: \t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-button-action-disabled-background: \t\t\t\thsl(104, 44%, 58%);\n\t--ck-color-button-action-text: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t--ck-color-button-save: \t\t\t\t\t\t\t\t\thsl(120, 100%, 27%);\n\t--ck-color-button-cancel: \t\t\t\t\t\t\t\t\thsl(15, 100%, 43%);\n\n\t--ck-color-switch-button-off-background:\t\t\t\t\thsl(0, 0%, 57.6%);\n\t--ck-color-switch-button-off-hover-background:\t\t\t\thsl(0, 0%, 49%);\n\t--ck-color-switch-button-on-background:\t\t\t\t\t\tvar(--ck-color-button-action-background);\n\t--ck-color-switch-button-on-hover-background:\t\t\t\thsl(104, 53.2%, 40.2%);\n\t--ck-color-switch-button-inner-background:\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-switch-button-inner-shadow:\t\t\t\t\t\thsla(0, 0%, 0%, 0.1);\n\n\t/* -- Dropdown ------------------------------------------------------------------------------ */\n\n\t--ck-color-dropdown-panel-background: \t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-dropdown-panel-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Input --------------------------------------------------------------------------------- */\n\n\t--ck-color-input-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-input-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-error-border:\t\t\t\t\t\t\t\tvar(--ck-color-base-error);\n\t--ck-color-input-text: \t\t\t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-input-disabled-background: \t\t\t\t\t\thsl(0, 0%, 95%);\n\t--ck-color-input-disabled-border: \t\t\t\t\t\t\tvar(--ck-color-base-border);\n\t--ck-color-input-disabled-text: \t\t\t\t\t\t\thsl(0, 0%, 46%);\n\n\t/* -- List ---------------------------------------------------------------------------------- */\n\n\t--ck-color-list-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-list-button-hover-background: \t\t\t\t\tvar(--ck-color-button-default-hover-background);\n\t--ck-color-list-button-on-background: \t\t\t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-background-focus: \t\t\t\tvar(--ck-color-button-on-color);\n\t--ck-color-list-button-on-text:\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Panel --------------------------------------------------------------------------------- */\n\n\t--ck-color-panel-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-panel-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Toolbar ------------------------------------------------------------------------------- */\n\n\t--ck-color-toolbar-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\t--ck-color-toolbar-border: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-border);\n\n\t/* -- Tooltip ------------------------------------------------------------------------------- */\n\n\t--ck-color-tooltip-background: \t\t\t\t\t\t\t\tvar(--ck-color-base-text);\n\t--ck-color-tooltip-text: \t\t\t\t\t\t\t\t\tvar(--ck-color-base-background);\n\n\t/* -- Engine -------------------------------------------------------------------------------- */\n\n\t--ck-color-engine-placeholder-text: \t\t\t\t\t\thsl(0, 0%, 44%);\n\n\t/* -- Upload -------------------------------------------------------------------------------- */\n\n\t--ck-color-upload-bar-background:\t\t \t\t\t\t\thsl(209, 92%, 70%);\n\n\t/* -- Link -------------------------------------------------------------------------------- */\n\n\t--ck-color-link-default:\t\t\t\t\t\t\t\t\thsl(240, 100%, 47%);\n\t--ck-color-link-selected-background:\t\t\t\t\t\thsla(201, 100%, 56%, 0.1);\n\t--ck-color-link-fake-selection:\t\t\t\t\t\t\t\thsla(201, 100%, 56%, 0.3);\n\n\t/* -- Search result highlight ---------------------------------------------------------------- */\n\n\t--ck-color-highlight-background:\t\t\t\t\t\t\thsl(60, 100%, 50%)\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * An opacity value of disabled UI item.\n\t */\n\t--ck-disabled-opacity: .5;\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * The geometry of the of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n\t/**\n\t * A visual style of focused element's outer shadow.\n\t */\n\t--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when disabled).\n\t */\n\t--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n\t/**\n\t * A visual style of focused element's outer shadow (when has errors).\n\t */\n\t--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n\t/**\n\t * A visual style of focused element's border or outline.\n\t */\n\t--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n",
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-font-size-base: 13px;\n\t--ck-line-height-base: 1.84615;\n\t--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n\t--ck-font-size-tiny: 0.7em;\n\t--ck-font-size-small: 0.75em;\n\t--ck-font-size-normal: 1em;\n\t--ck-font-size-big: 1.4em;\n\t--ck-font-size-large: 1.8em;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/* This is super-important. This is **manually** adjusted so a button without an icon\n\tis never smaller than a button with icon, additionally making sure that text-less buttons\n\tare perfect squares. The value is also shared by other components which should stay "in-line"\n\twith buttons. */\n\t--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* Do not include inheritable rules here. */\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tbackground: transparent;\n\ttext-decoration: none;\n\tvertical-align: middle;\n\ttransition: none;\n\n\t/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n\tword-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n\t/* These are rule inherited by all children elements. */\n\tborder-collapse: collapse;\n\tfont: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n\tcolor: var(--ck-color-text);\n\ttext-align: left;\n\twhite-space: nowrap;\n\tcursor: auto;\n\tfloat: none;\n}\n\n.ck-reset_all {\n\t& .ck-rtl *:not(.ck-reset_all-excluded *) {\n\t\ttext-align: right;\n\t}\n\n\t& iframe:not(.ck-reset_all-excluded *) {\n\t\t/* For IE */\n\t\tvertical-align: inherit;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *) {\n\t\twhite-space: pre-wrap;\n\t}\n\n\t& textarea:not(.ck-reset_all-excluded *),\n\t& input[type="text"]:not(.ck-reset_all-excluded *),\n\t& input[type="password"]:not(.ck-reset_all-excluded *) {\n\t\tcursor: text;\n\t}\n\n\t& textarea[disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n\t& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n\t\tcursor: default;\n\t}\n\n\t& fieldset:not(.ck-reset_all-excluded *) {\n\t\tpadding: 10px;\n\t\tborder: 2px groove hsl(255, 7%, 88%);\n\t}\n\n\t& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n\t\t/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n\t\tpadding: 0;\n\t\tborder: 0\n\t}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n\ttext-align: right;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n\t--ck-border-radius: 2px;\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t/**\n\t * A visual style of element's inner shadow (i.e. input).\n\t */\n\t--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n\t/**\n\t * A visual style of element's drop shadow (i.e. panel).\n\t */\n\t--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n\t/**\n\t * A visual style of element's active shadow (i.e. comment or suggestion).\n\t */\n\t--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n",
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-spacing-unit: \t\t\t\t\t\t0.6em;\n\t--ck-spacing-large: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 1.5);\n\t--ck-spacing-standard: \t\t\t\t\tvar(--ck-spacing-unit);\n\t--ck-spacing-medium: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.8);\n\t--ck-spacing-small: \t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.5);\n\t--ck-spacing-tiny: \t\t\t\t\t\tcalc(var(--ck-spacing-unit) * 0.3);\n\t--ck-spacing-extra-tiny: \t\t\t\tcalc(var(--ck-spacing-unit) * 0.16);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      6507: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          ':root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:transparent;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background);border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:transparent;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widget.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_focus.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css'
            ],
            names: [],
            mappings:
              'AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,yBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGAKC,iEAAkE,CCnCnE,2BAA2B,CCF3B,qCAA8B,CDC9B,YDqCA,CAIA,4EAKC,4BAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAgCD,CAnBC,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAWD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-color-resizer: var(--ck-color-focus-border);\n\t--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n\t--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n\t--ck-resizer-border-radius: var(--ck-border-radius);\n\t--ck-resizer-tooltip-offset: 10px;\n\t--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n\t/* This is neccessary for type around UI to be positioned properly. */\n\tposition: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n\n\t& .ck-widget__selection-handle {\n\t\tposition: absolute;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the icon in not a subject to font-size or line-height to avoid\n\t\t\tunnecessary spacing around it. */\n\t\t\tdisplay: block;\n\t\t}\n\t}\n\n\t/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n\n\t/* Show the selection handle when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected > .ck-widget__selection-handle {\n\t\tvisibility: visible;\n\t}\n}\n\n.ck .ck-size-view {\n\tbackground: var(--ck-color-resizer-tooltip-background);\n\tcolor: var(--ck-color-resizer-tooltip-text);\n\tborder: 1px solid var(--ck-color-resizer-tooltip-text);\n\tborder-radius: var(--ck-resizer-border-radius);\n\tfont-size: var(--ck-font-size-tiny);\n\tdisplay: block;\n\tpadding: 0 var(--ck-spacing-small);\n\theight: var(--ck-resizer-tooltip-height);\n\tline-height: var(--ck-resizer-tooltip-height);\n\n\t&.ck-orientation-top-left,\n\t&.ck-orientation-top-right,\n\t&.ck-orientation-bottom-right,\n\t&.ck-orientation-bottom-left,\n\t&.ck-orientation-above-center {\n\t\tposition: absolute;\n\t}\n\n\t&.ck-orientation-top-left {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-top-right {\n\t\ttop: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-right {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tright: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t&.ck-orientation-bottom-left {\n\t\tbottom: var(--ck-resizer-tooltip-offset);\n\t\tleft: var(--ck-resizer-tooltip-offset);\n\t}\n\n\t/* Class applied if the widget is too small to contain the size label */\n\t&.ck-orientation-above-center {\n\t\ttop: calc(var(--ck-resizer-tooltip-height) * -1);\n\t\tleft: 50%;\n\t\ttransform: translate(-50%);\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n\t--ck-widget-outline-thickness: 3px;\n\t--ck-widget-handler-icon-size: 16px;\n\t--ck-widget-handler-animation-duration: 200ms;\n\t--ck-widget-handler-animation-curve: ease;\n\n\t--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n\t--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n\t--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n\t--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n\toutline-width: var(--ck-widget-outline-thickness);\n\toutline-style: solid;\n\toutline-color: transparent;\n\ttransition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n\t}\n\n\t&:hover {\n\t\toutline-color: var(--ck-color-widget-hover-border);\n\t}\n}\n\n.ck .ck-editor__nested-editable {\n\tborder: 1px solid transparent;\n\n\t/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n\tThese styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n\t&.ck-editor__nested-editable_focused,\n\t&:focus {\n\t\t@mixin ck-focus-ring;\n\t\t@mixin ck-box-shadow var(--ck-inner-shadow);\n\n\t\tbackground-color: var(--ck-color-widget-editable-focus-background);\n\t}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n\t& .ck-widget__selection-handle {\n\t\tpadding: 4px;\n\t\tbox-sizing: border-box;\n\n\t\t/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n\t\tbackground-color: transparent;\n\t\topacity: 0;\n\n\t\t/* Transition:\n\t\t   * background-color for the .ck-widget_selected state change,\n\t\t   * visibility for hiding the handler,\n\t\t   * opacity for the proper look of the icon when the handler disappears. */\n\t\ttransition:\n\t\t\tbackground-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\tvisibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n\t\t\topacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t/* Make only top corners round. */\n\t\tborder-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n\t\t/* Place the drag handler outside the widget wrapper. */\n\t\ttransform: translateY(-100%);\n\t\tleft: calc(0px - var(--ck-widget-outline-thickness));\n\t\ttop: 0;\n\n\t\t& .ck-icon {\n\t\t\t/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n\t\t\twidth: var(--ck-widget-handler-icon-size);\n\t\t\theight: var(--ck-widget-handler-icon-size);\n\t\t\tcolor: var(--ck-color-widget-drag-handler-icon-color);\n\n\t\t\t/* The "selected" part of the icon is invisible by default */\n\t\t\t& .ck-icon__selected-indicator {\n\t\t\t\topacity: 0;\n\n\t\t\t\t/* Note: The animation is longer on purpose. Simply feels better. */\n\t\t\t\ttransition: opacity 300ms var(--ck-widget-handler-animation-curve);\n\t\t\t}\n\t\t}\n\n\t\t/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n\t\t&:hover .ck-icon .ck-icon__selected-indicator {\n\t\t\topacity: 1;\n\t\t}\n\t}\n\n\t/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n\t&:hover > .ck-widget__selection-handle {\n\t\topacity: 1;\n\t\tbackground-color: var(--ck-color-widget-hover-border);\n\t}\n\n\t/* Show the selection handler when the widget is selected, but not for nested widgets. */\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\t& > .ck-widget__selection-handle {\n\t\t\topacity: 1;\n\t\t\tbackground-color: var(--ck-color-focus-border);\n\n\t\t\t/* When the widget is selected, notify the user using the proper look of the icon. */\n\t\t\t& .ck-icon .ck-icon__selected-indicator {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n\tleft: auto;\n\tright: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n\t/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n\ttransition: none;\n\n\t&:not(.ck-widget_selected) {\n\t\t/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/1261\n\t\t *\n\t\t * Leave the unit because this custom property is used in calc() by other features.\n\t\t * See: https://github.com/ckeditor/ckeditor5/issues/6775\n\t\t */\n\t\t--ck-widget-outline-thickness: 0px;\n\t}\n\n\t&.ck-widget_with-selection-handle {\n\t\t& .ck-widget__selection-handle,\n\t\t& .ck-widget__selection-handle:hover {\n\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t}\n\t}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n\t&.ck-widget_selected,\n\t&.ck-widget_selected:hover {\n\t\toutline-color: var(--ck-color-widget-blurred-border);\n\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t& > .ck-widget__selection-handle,\n\t\t\t& > .ck-widget__selection-handle:hover {\n\t\t\t\tbackground: var(--ck-color-widget-blurred-border);\n\t\t\t}\n\t\t}\n\t}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n\t/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n\tIn fact, anything with overflow: hidden.\n\thttps://github.com/ckeditor/ckeditor5-block-quote/issues/28\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/44\n\thttps://github.com/ckeditor/ckeditor5-widget/issues/66 */\n\tmargin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n',
              "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n\t/* Disable native outline. */\n\toutline: none;\n\tborder: var(--ck-focus-ring)\n}\n",
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n\tbox-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n\t@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      2263: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgetresize.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css'
            ],
            names: [],
            mappings:
              'AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n\t/* Make the widget wrapper a relative positioning container for the drag handle. */\n\tposition: relative;\n}\n\n.ck .ck-widget__resizer {\n\tdisplay: none;\n\tposition: absolute;\n\n\t/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n\tpointer-events: none;\n\n\tleft: 0;\n\ttop: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n\t& > .ck-widget__resizer {\n\t\tdisplay: block;\n\t}\n}\n\n.ck .ck-widget__resizer__handle {\n\tposition: absolute;\n\n\t/* Resizers are the only UI elements that should interfere with a pointer device. */\n\tpointer-events: all;\n\n\t&.ck-widget__resizer__handle-top-left,\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tcursor: nwse-resize;\n\t}\n\n\t&.ck-widget__resizer__handle-top-right,\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tcursor: nesw-resize;\n\t}\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-resizer-size: 10px;\n\n\t/* Set the resizer with a 50% offset. */\n\t--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n\t--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n\toutline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n\twidth: var(--ck-resizer-size);\n\theight: var(--ck-resizer-size);\n\tbackground: var(--ck-color-focus-border);\n\tborder: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n\tborder-radius: var(--ck-resizer-border-radius);\n\n\t&.ck-widget__resizer__handle-top-left {\n\t\ttop: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-top-right {\n\t\ttop: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-right {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tright: var(--ck-resizer-offset);\n\t}\n\n\t&.ck-widget__resizer__handle-bottom-left {\n\t\tbottom: var(--ck-resizer-offset);\n\t\tleft: var(--ck-resizer-offset);\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      5137: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3));border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid hsla(0,0%,100%,.5);pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@ckeditor/ckeditor5-widget/theme/widgettypearound.css',
              'webpack://./node_modules/@ckeditor/ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css'
            ],
            names: [],
            mappings:
              'AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAkDD,CA1CC,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAoBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,uEAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,oCAAwC,CARxC,mBAUD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD',
            sourcesContent: [
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\tdisplay: block;\n\t\tposition: absolute;\n\t\toverflow: hidden;\n\t\tz-index: var(--ck-z-default);\n\n\t\t& svg {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\tleft: 50%;\n\t\t\tz-index: calc(var(--ck-z-default) + 2);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_before {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\ttop: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tleft: min(10%, 30px);\n\n\t\t\ttransform: translateY(-50%);\n\t\t}\n\n\t\t&.ck-widget__type-around__button_after {\n\t\t\t/* Place it in the middle of the outline */\n\t\t\tbottom: calc(-0.5 * var(--ck-widget-outline-thickness));\n\t\t\tright: min(10%, 30px);\n\n\t\t\ttransform: translateY(50%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\t&::after {\n\t\t\tcontent: "";\n\t\t\tdisplay: block;\n\t\t\tposition: absolute;\n\t\t\ttop: 1px;\n\t\t\tleft: 1px;\n\t\t\tz-index: calc(var(--ck-z-default) + 1);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tdisplay: none;\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\tright: 0;\n\t}\n\n\t/*\n\t * When the widget is hovered the "fake caret" would normally be narrower than the\n\t * extra outline displayed around the widget. Let\'s extend the "fake caret" to match\n\t * the full width of the widget.\n\t */\n\t&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tleft: calc( -1 * var(--ck-widget-outline-thickness) );\n\t\tright: calc( -1 * var(--ck-widget-outline-thickness) );\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\ttop: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).\n\t */\n\t&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {\n\t\tbottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );\n\t\tdisplay: block;\n\t}\n}\n\n/*\n * Integration with the read-only mode of the editor.\n */\n.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the restricted editing mode (feature) of the editor.\n */\n.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {\n\tdisplay: none;\n}\n\n/*\n * Integration with the #isEnabled property of the WidgetTypeAround plugin.\n */\n.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {\n\tdisplay: none;\n}\n',
              '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n\t--ck-widget-type-around-button-size: 20px;\n\t--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);\n\t--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);\n\t--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);\n\t--ck-color-widget-type-around-button-radar-start-alpha: 0;\n\t--ck-color-widget-type-around-button-radar-end-alpha: .3;\n\t--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);\n}\n\n@define-mixin ck-widget-type-around-button-visible {\n\topacity: 1;\n\tpointer-events: auto;\n}\n\n@define-mixin ck-widget-type-around-button-hidden {\n\topacity: 0;\n\tpointer-events: none;\n}\n\n.ck .ck-widget {\n\t/*\n\t * Styles of the type around buttons\n\t */\n\t& .ck-widget__type-around__button {\n\t\twidth: var(--ck-widget-type-around-button-size);\n\t\theight: var(--ck-widget-type-around-button-size);\n\t\tbackground: var(--ck-color-widget-type-around-button);\n\t\tborder-radius: 100px;\n\t\ttransition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n\t\t@mixin ck-widget-type-around-button-hidden;\n\n\t\t& svg {\n\t\t\twidth: 10px;\n\t\t\theight: 8px;\n\t\t\ttransform: translate(-50%,-50%);\n\t\t\ttransition: transform .5s ease;\n\t\t\tmargin-top: 1px;\n\n\t\t\t& * {\n\t\t\t\tstroke-dasharray: 10;\n\t\t\t\tstroke-dashoffset: 0;\n\n\t\t\t\tfill: none;\n\t\t\t\tstroke: var(--ck-color-widget-type-around-button-icon);\n\t\t\t\tstroke-width: 1.5px;\n\t\t\t\tstroke-linecap: round;\n\t\t\t\tstroke-linejoin: round;\n\t\t\t}\n\n\t\t\t& line {\n\t\t\t\tstroke-dasharray: 7;\n\t\t\t}\n\t\t}\n\n\t\t&:hover {\n\t\t\t/*\n\t\t\t * Display the "sonar" around the button when hovered.\n\t\t\t */\n\t\t\tanimation: ck-widget-type-around-button-sonar 1s ease infinite;\n\n\t\t\t/*\n\t\t\t * Animate active button\'s icon.\n\t\t\t */\n\t\t\t& svg {\n\t\t\t\t& polyline {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-dash 2s linear;\n\t\t\t\t}\n\n\t\t\t\t& line {\n\t\t\t\t\tanimation: ck-widget-type-around-arrow-tip-dash 2s linear;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n\t/*\n\t * Show type around buttons when the widget gets selected or being hovered.\n\t */\n\t&.ck-widget_selected,\n\t&:hover {\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-visible;\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the buttons when the widget is NOT selected (but the buttons are visible\n\t * and still can be hovered).\n\t */\n\t&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\tbackground: var(--ck-color-widget-type-around-button-hover);\n\t}\n\n\t/*\n\t * Styles for the buttons when:\n\t * - the widget is selected,\n\t * - or the button is being hovered (regardless of the widget state).\n\t */\n\t&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,\n\t& > .ck-widget__type-around > .ck-widget__type-around__button:hover {\n\t\tbackground: var(--ck-color-widget-type-around-button-active);\n\n\t\t&::after {\n\t\t\twidth: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\theight: calc(var(--ck-widget-type-around-button-size) - 2px);\n\t\t\tborder-radius: 100px;\n\t\t\tbackground: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);\n\t\t}\n\t}\n\n\t/*\n\t * Styles for the "before" button when the widget has a selection handle. Because some space\n\t * is consumed by the handle, the button must be moved slightly to the right to let it breathe.\n\t */\n\t&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {\n\t\tmargin-left: 20px;\n\t}\n\n\t/*\n\t * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.\n\t */\n\t& .ck-widget__type-around__fake-caret {\n\t\tpointer-events: none;\n\t\theight: 1px;\n\t\tanimation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;\n\n\t\t/*\n\t\t * The semi-transparent-outline+background combo improves the contrast\n\t\t * when the background underneath the fake caret is dark.\n\t\t */\n\t\toutline: solid 1px hsla(0, 0%, 100%, .5);\n\t\tbackground: var(--ck-color-base-text);\n\t}\n\n\t/*\n\t * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t * Despite the widget being physically selected in the model, its outline should disappear.\n\t */\n\t&.ck-widget_selected {\n\t\t&.ck-widget_type-around_show-fake-caret_before,\n\t\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t\toutline-color: transparent;\n\t\t}\n\t}\n\n\t&.ck-widget_type-around_show-fake-caret_before,\n\t&.ck-widget_type-around_show-fake-caret_after {\n\t\t/*\n\t\t * When the "fake caret" is visible we simulate that the widget is not selected\n\t\t * (despite being physically selected), so the outline color should be for the\n\t\t * unselected widget.\n\t\t */\n\t\t&.ck-widget_selected:hover {\n\t\t\toutline-color: var(--ck-color-widget-hover-border);\n\t\t}\n\n\t\t/*\n\t\t * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).\n\t\t * In this state, the type around buttons would collide with the fake carets so they should disappear.\n\t\t */\n\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the selection handle. When the caret is visible, simply\n\t\t * hide the handle because it intersects with the caret (and does not make much sense anyway).\n\t\t */\n\t\t&.ck-widget_with-selection-handle {\n\t\t\t&.ck-widget_selected,\n\t\t\t&.ck-widget_selected:hover {\n\t\t\t\t& > .ck-widget__selection-handle {\n\t\t\t\t\topacity: 0\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t/*\n\t\t * Fake horizontal caret integration with the resize UI. When the caret is visible, simply\n\t\t * hide the resize UI because it creates too much noise. It can be visible when the user\n\t\t * hovers the widget, though.\n\t\t */\n\t\t&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {\n\t\t\topacity: 0\n\t\t}\n\t}\n}\n\n/*\n * Styles for the "before" button when the widget has a selection handle in an RTL environment.\n * The selection handler is aligned to the right side of the widget so there is no need to create\n * additional space for it next to the "before" button.\n */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {\n\tmargin-left: 0;\n\tmargin-right: 20px;\n}\n\n/*\n * Hide type around buttons when the widget is selected as a child of a selected\n * nested editable (e.g. mulit-cell table selection).\n *\n * See https://github.com/ckeditor/ckeditor5/issues/7263.\n */\n.ck-editor__nested-editable.ck-editor__editable_selected {\n\t& .ck-widget {\n\t\t&.ck-widget_selected,\n\t\t&:hover {\n\t\t\t& > .ck-widget__type-around > .ck-widget__type-around__button {\n\t\t\t\t@mixin ck-widget-type-around-button-hidden;\n\t\t\t}\n\t\t}\n\t}\n}\n\n/*\n * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).\n */\n.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {\n\tbackground: var(--ck-color-widget-type-around-button-blurred-editable);\n\n\t& svg * {\n\t\tstroke: hsl(0,0%,60%);\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-dash {\n\t0% {\n\t\tstroke-dashoffset: 10;\n\t}\n\t20%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-arrow-tip-dash {\n\t0%, 20% {\n\t\tstroke-dashoffset: 7;\n\t}\n\t40%, 100% {\n\t\tstroke-dashoffset: 0;\n\t}\n}\n\n@keyframes ck-widget-type-around-button-sonar {\n\t0% {\n\t\tbox-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n\t50% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));\n\t}\n\t100% {\n\t\tbox-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));\n\t}\n}\n\n@keyframes ck-widget-type-around-fake-caret-pulse {\n\t0% {\n\t\topacity: 1;\n\t}\n\t49% {\n\t\topacity: 1;\n\t}\n\t50% {\n\t\topacity: 0;\n\t}\n\t99% {\n\t\topacity: 0;\n\t}\n\t100% {\n\t\topacity: 1;\n\t}\n}\n'
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      7546: (t, e, n) => {
        'use strict'
        n.d(e, { Z: () => c })
        var i = n(4015)
        var o = n.n(i)
        var r = n(3645)
        var s = n.n(r)
        var a = s()(o())
        a.push([
          t.id,
          '.wrs_modal_overlay{background:rgba(0,0,0,.8);bottom:0;font-family:arial,sans-serif;left:0;opacity:.65;pointer-events:auto;position:fixed;right:0;top:0;z-index:999998}.wrs_modal_overlay.wrs_modal_android,.wrs_modal_overlay.wrs_modal_ios{display:none;visibility:hidden}.wrs_modal_overlay.wrs_modal_ios.moodle{position:fixed}.wrs_modal_overlay.wrs_modal_desktop.wrs_stack{background:transparent;display:none}.wrs_modal_overlay.wrs_modal_desktop.wrs_maximized{background:rgba(0,0,0,.8)}.wrs_modal_overlay.wrs_modal_desktop.wrs_closed,.wrs_modal_overlay.wrs_modal_desktop.wrs_minimized{background:transparent;display:none}.wrs_modal_title{color:#fff;padding:5px 0 5px 10px;text-align:left;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.wrs_modal_close_button{background-repeat:no-repeat}.wrs_modal_close_button,.wrs_modal_minimize_button{color:#fff;cursor:pointer;float:right;margin:10px 7px 0 0;padding:5px 10px 5px 0}.wrs_modal_minimize_button{top:inherit}.wrs_modal_stack_button{color:#fff;cursor:pointer;float:right;margin:10px 7px 0 0;padding:5px 10px 5px 0;top:inherit}.wrs_modal_stack_button.wrs_minimized,.wrs_modal_stack_button.wrs_stack{margin:0;padding:0;visibility:hidden}.wrs_modal_maximize_button{color:#fff;cursor:pointer;float:right;margin:10px 7px 0 0;padding:5px 10px 5px 0;top:inherit}.wrs_modal_maximize_button.wrs_maximized{margin:0;padding:0;visibility:hidden}.wrs_modal_title_bar{background-color:#778e9a;display:block}.wrs_modal_dialogContainer{background:#fafafa;border:none;z-index:999999}.wrs_modal_dialogContainer.wrs_modal_desktop{font-size:14px}.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_maximized{position:fixed}.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_minimized{margin:0 10px 0 0;position:fixed;top:inherit}.wrs_modal_dialogContainer.wrs_closed{display:none;opacity:0;visibility:hidden}.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_stack{bottom:0;box-shadow:0 2px 8px rgba(0,0,0,.5);position:fixed;right:0}.wrs_modal_dialogContainer.wrs_drag,.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_drag{box-shadow:0 2px 8px rgba(0,0,0,.5)}.wrs_modal_dialogContainer.wrs_modal_android{height:99%;width:99%}.wrs_modal_dialogContainer.wrs_modal_android,.wrs_modal_dialogContainer.wrs_modal_ios{margin:auto;overflow:hidden;position:fixed;right:50%!important;top:50%;transform:translate(50%,-50%)}.wrs_modal_dialogContainer.wrs_modal_ios{height:100%;width:100%}.wrs_content_container.wrs_minimized{display:none}.wrs_content_container.wrs_modal_android{display:flex;flex-direction:column;flex-grow:1;height:0;width:100%}.wrs_content_container.wrs_modal_android>div:first-child,.wrs_content_container.wrs_modal_desktop>div:first-child,.wrs_content_container.wrs_modal_ios>div:first-child{flex-grow:1}.wrs_modal_wrapper.wrs_modal_android{display:flex;flex-direction:column;height:100%;margin:auto;width:100%}.wrs_content_container.wrs_modal_desktop,.wrs_content_container.wrs_modal_ios{display:flex;flex-direction:column;flex-grow:1;width:100%}.wrs_content_container.wrs_modal_ios{height:0}.wrs_modal_wrapper.wrs_modal_ios{display:flex;flex-direction:column;height:100%;margin:auto;width:100%}.wrs_virtual_keyboard{height:100%;left:50%;top:0;transform:translate(-50%);width:100%}@media (orientation:portrait){.wrs_modal_dialogContainer.wrs_modal_mobile{border-width:0;height:100vmin;margin:auto;width:100vmin}.wrs_modal_wrapper.wrs_modal_mobile{height:100vmin;margin:auto;width:100vmin}}@media (orientation:landscape){.wrs_modal_dialogContainer.wrs_modal_mobile{border-width:0;height:100vmin;margin:auto;width:100vmin}.wrs_modal_wrapper.wrs_modal_mobile{height:100vmin;margin:auto;width:100vmin}}.wrs_modal_dialogContainer.wrs_modal_badStock,.wrs_modal_wrapper.wrs_modal_badStock{border-width:0;height:280px;margin:0 auto;width:100%}.wrs_noselect{-moz-user-select:none;-khtml-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.wrs_bottom_right_resizer{bottom:8px;color:#778e9a;cursor:se-resize;height:10px;position:absolute;right:4px;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none;width:10px}.wrs_bottom_left_resizer{color:#778e9a;cursor:se-resize;height:15px;left:0;position:absolute;top:0;width:15px}.wrs_modal_controls{height:42px;line-height:normal;margin:3px 0;overflow:hidden}.wrs_modal_links{display:inline;float:right;font-family:arial,sans-serif;margin:10px auto 0;padding:6px;text-align:right}.wrs_modal_links>a{color:#778e9a;font-size:16px;text-decoration:none}.wrs_modal_button_cancel,.wrs_modal_button_cancel:active,.wrs_modal_button_cancel:focus,.wrs_modal_button_cancel:hover,.wrs_modal_button_cancel:visited{background-color:#ddd;border:1px solid #778e9a;border-radius:3px;cursor:pointer;font-family:arial,sans-serif;font-size:14px;height:32px;margin:10px auto 0 5px;min-width:80px;padding:6px 8px}.wrs_modal_button_accept,.wrs_modal_button_accept:active,.wrs_modal_button_accept:focus,.wrs_modal_button_accept:hover,.wrs_modal_button_accept:visited{background:#778e9a;border:1px solid #778e9a;border-radius:3px;color:#fff;cursor:pointer;font-family:arial,sans-serif;font-size:14px;height:32px;margin:10px 5px 0 auto;min-width:80px;padding:6px 8px}.wrs_editor_vertical_bar{background:none;cursor:pointer;float:right;height:20px;width:20px}.wrs_modal_buttons_container{display:inline;float:left}.wrs_modal_buttons_container.wrs_modalAndroid{padding-left:6px}.wrs_modal_buttons_container.wrs_modalDesktop{padding-left:0}.wrs_modal_buttons_container>button{background-image:none;line-height:normal}.wrs_modal_wrapper{display:flex;flex-direction:column;margin:6px}.wrs_modal_wrapper.wrs_modal_desktop.wrs_minimized{display:none}@media only screen and (max-device-width:480px) and (orientation:portrait){#wrs_modal_wrapper{width:140%}}.wrs_popupmessage_overlay_envolture{display:none;width:100%}.wrs_popupmessage_overlay{background-color:rgba(0,0,0,.5);bottom:0;cursor:pointer;height:100%;left:0;position:absolute;right:0;top:0;width:100%;z-index:4}.wrs_popupmessage_panel{background:#fff;border-radius:2px;color:#2e2e2e;font-family:sans-serif;font-size:15px;left:50%;max-height:75%;max-width:500px;overflow:auto;padding:20px;position:absolute;text-align:left;top:50%;transform:translate(-50%,-50%);width:75%;z-index:5}.wrs_popupmessage_button_area{margin:10px 0 0}.wrs_panelContainer *{border:0}.wrs_button_cancel,.wrs_button_cancel:active,.wrs_button_cancel:focus,.wrs_button_cancel:hover,.wrs_button_cancel:visited{background-color:#ddd;background-image:none;border:1px solid #778e9a;border-radius:3px;cursor:pointer;font-family:arial,sans-serif;font-size:14px;height:32px;margin:10px auto 0 5px;min-width:80px;padding:6px 8px}.wrs_button_accept,.wrs_button_accept:active,.wrs_button_accept:focus,.wrs_button_accept:hover,.wrs_button_accept:visited{background:#778e9a;border:1px solid #778e9a;border-radius:3px;color:#fff;cursor:pointer;font-family:arial,sans-serif;font-size:14px;height:32px;margin:10px 5px 0 auto;min-width:80px;padding:6px 8px}.wrs_editor button{box-shadow:none}.wrs_editor .wrs_header button{border-bottom:none;border-bottom-left-radius:0;border-bottom-right-radius:0}.wrs_modal_overlay.wrs_modal_desktop.wrs_stack.wrs_overlay_active{display:block}.wrs_toolbar tr:focus,.wrs_toolbar tr:hover{background:none}.wrs_modal_rtl .wrs_modal_button_cancel{margin-left:0;margin-right:5px}.wrs_modal_rtl .wrs_modal_button_accept{margin-left:5px;margin-right:0}.wrs_modal_rtl .wrs_button_cancel{margin-left:0;margin-right:5px}.wrs_modal_rtl .wrs_button_accept{margin-left:5px;margin-right:0}',
          '',
          {
            version: 3,
            sources: [
              'webpack://./node_modules/@wiris/mathtype-html-integration-devkit/styles/styles.css'
            ],
            names: [],
            mappings:
              'AAAA,mBAOE,yBAA8B,CAD9B,QAAS,CAJT,4BAA8B,CAG9B,MAAO,CAIP,WAAa,CACb,mBAAoB,CATpB,cAAe,CAGf,OAAQ,CADR,KAAM,CAKN,cAGF,CAOA,sEAEE,YAAa,CADb,iBAEF,CAEA,wCACE,cACF,CAEA,+CACE,sBAA4B,CAC5B,YACF,CAEA,mDACE,yBACF,CAOA,mGACE,sBAA4B,CAC5B,YACF,CAEA,iBACE,UAAW,CACX,sBAAuB,CAKvB,eAAgB,CAJhB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAEF,CAEA,wBAME,2BACF,CAEA,mDANE,UAAW,CADX,cAAe,CADf,WAAY,CAIZ,mBAAoB,CADpB,sBAYF,CAPA,2BAKE,WAEF,CAEA,wBAGE,UAAW,CADX,cAAe,CADf,WAAY,CAGZ,mBAAoB,CACpB,sBAAuB,CACvB,WACF,CAQA,wEAEE,QAAS,CACT,SAAU,CAFV,iBAGF,CAEA,2BAGE,UAAW,CADX,cAAe,CADf,WAAY,CAGZ,mBAAoB,CACpB,sBAAuB,CACvB,WACF,CAEA,yCAEE,QAAS,CACT,SAAU,CAFV,iBAGF,CAEA,qBAEE,wBAAyB,CADzB,aAEF,CAEA,2BAEE,kBAAmB,CADnB,WAAY,CAEZ,cACF,CAEA,6CACE,cACF,CAEA,2DACE,cACF,CAEA,2DAIE,iBAAkB,CAHlB,cAAe,CACf,WAGF,CAEA,sCAEE,YAAa,CACb,SAAU,CAFV,iBAGF,CAKA,uDAEE,QAAS,CAET,mCAAwC,CAHxC,cAAe,CAEf,OAEF,CAMA,0FACE,mCACF,CAEA,6CAIE,UAAW,CADX,SAMF,CAEA,sFAVE,WAAY,CAIZ,eAAgB,CAHhB,cAAe,CAMf,mBAAqB,CADrB,OAAQ,CADR,6BAcF,CATA,yCAIE,WAAY,CADZ,UAMF,CAKA,qCACE,YACF,CAMA,yCAIE,YAAa,CACb,qBAAsB,CAFtB,WAAY,CADZ,QAAU,CADV,UAKF,CAUA,uKACE,WACF,CAEA,qCAEE,YAAa,CACb,qBAAsB,CACtB,WAAY,CAHZ,WAAY,CAIZ,UACF,CASA,8EAJE,YAAa,CACb,qBAAsB,CAFtB,WAAY,CADZ,UAYF,CANA,qCAEE,QAIF,CAEA,iCAEE,YAAa,CACb,qBAAsB,CACtB,WAAY,CAHZ,WAAY,CAIZ,UACF,CAEA,sBACE,WAAY,CAGZ,QAAS,CADT,KAAM,CAEN,yBAA8B,CAH9B,UAIF,CAEA,8BACE,4CAIE,cAAe,CAFf,cAAe,CACf,WAAY,CAFZ,aAIF,CAEA,oCAEE,cAAe,CACf,WAAY,CAFZ,aAGF,CACF,CAEA,+BACE,4CAIE,cAAe,CAFf,cAAe,CACf,WAAY,CAFZ,aAIF,CAEA,oCAEE,cAAe,CACf,WAAY,CAFZ,aAGF,CACF,CASA,oFAIE,cAAe,CAFf,YAAa,CACb,aAAc,CAFd,UAIF,CAEA,cACE,qBAAsB,CACtB,uBAAwB,CACxB,wBAAyB,CACzB,oBAAqB,CACrB,gBACF,CAEA,0BAME,UAAW,CAHX,aAAc,CAId,gBAAiB,CALjB,WAAY,CAEZ,iBAAkB,CAClB,SAAU,CAGV,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBAAiB,CAVjB,UAWF,CAEA,yBAGE,aAAc,CAId,gBAAiB,CALjB,WAAY,CAGZ,MAAO,CADP,iBAAkB,CAElB,KAAM,CALN,UAOF,CAEA,oBACE,WAAY,CAGZ,kBAAmB,CAFnB,YAAa,CACb,eAEF,CAEA,iBAKE,cAAe,CACf,WAAY,CAHZ,4BAA8B,CAD9B,kBAAgB,CAEhB,WAAY,CAGZ,gBACF,CAEA,mBAEE,aAAc,CACd,cAAe,CAFf,oBAGF,CAEA,wJAeE,qBAAsB,CAPtB,wBAAyB,CADzB,iBAAkB,CAMlB,cAAe,CACf,4BAA8B,CAR9B,cAAe,CAUf,WAAY,CAJZ,sBAAgB,CAPhB,cAAe,CAIf,eAQF,CAEA,wJAcE,kBAAmB,CANnB,wBAAyB,CADzB,iBAAkB,CAMlB,UAAW,CAEX,cAAe,CACf,4BAA8B,CAV9B,cAAe,CAWf,WAAY,CALZ,sBAAgB,CAPhB,cAAe,CAIf,eASF,CAEA,yBAGE,eAAgB,CAEhB,cAAe,CAHf,WAAY,CADZ,WAAY,CAGZ,UAEF,CAEA,6BACE,cAAe,CACf,UACF,CAEA,8CACE,gBACF,CAEA,8CACE,cACF,CAEA,oCAEE,qBAAsB,CADtB,kBAEF,CAEA,mBAEE,YAAa,CACb,qBAAsB,CAFtB,UAGF,CAEA,mDACE,YACF,CAEA,2EACE,mBACE,UACF,CACF,CAEA,oCACE,YAAa,CACb,UACF,CAEA,0BAQE,+BAAoC,CADpC,QAAS,CAGT,cAAe,CAPf,WAAY,CAEZ,MAAO,CAJP,iBAAkB,CAKlB,OAAQ,CAFR,KAAM,CAFN,UAAW,CAOX,SAEF,CAEA,wBAKE,eAAiB,CAGjB,iBAAkB,CAKlB,aAAc,CAHd,sBAAuB,CACvB,cAAe,CATf,QAAS,CAaT,cAAe,CATf,eAAgB,CAUhB,aAAc,CAPd,YAAa,CALb,iBAAkB,CAQlB,eAAgB,CAXhB,OAAQ,CAER,8BAAgC,CAIhC,SAAU,CAOV,SAGF,CAEA,8BACE,eACF,CAEA,sBACE,QACF,CAEA,0HAeE,qBAAsB,CACtB,qBAAsB,CARtB,wBAAyB,CADzB,iBAAkB,CAMlB,cAAe,CACf,4BAA8B,CAR9B,cAAe,CAWf,WAAY,CALZ,sBAAgB,CAPhB,cAAe,CAIf,eASF,CAEA,0HAcE,kBAAmB,CANnB,wBAAyB,CADzB,iBAAkB,CAMlB,UAAW,CAEX,cAAe,CACf,4BAA8B,CAV9B,cAAe,CAWf,WAAY,CALZ,sBAAgB,CAPhB,cAAe,CAIf,eASF,CAEA,mBACE,eACF,CAEA,+BACE,kBAAmB,CACnB,2BAA4B,CAC5B,4BACF,CAEA,kEACE,aACF,CAOA,4CACE,eACF,CAGA,wCAEE,aAAc,CADd,gBAEF,CAEA,wCAEE,eAAgB,CADhB,cAEF,CAEA,kCAEE,aAAc,CADd,gBAEF,CAEA,kCAEE,eAAgB,CADhB,cAEF',
            sourcesContent: [
              ".wrs_modal_overlay {\n  position: fixed;\n  font-family: arial, sans-serif;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  z-index: 999998;\n  opacity: 0.65;\n  pointer-events: auto;\n}\n\n.wrs_modal_overlay.wrs_modal_ios {\n  visibility: hidden;\n  display: none;\n}\n\n.wrs_modal_overlay.wrs_modal_android {\n  visibility: hidden;\n  display: none;\n}\n\n.wrs_modal_overlay.wrs_modal_ios.moodle {\n  position: fixed;\n}\n\n.wrs_modal_overlay.wrs_modal_desktop.wrs_stack {\n  background: rgba(0, 0, 0, 0);\n  display: none;\n}\n\n.wrs_modal_overlay.wrs_modal_desktop.wrs_maximized {\n  background: rgba(0, 0, 0, 0.8);\n}\n\n.wrs_modal_overlay.wrs_modal_desktop.wrs_minimized {\n  background: rgba(0, 0, 0, 0);\n  display: none;\n}\n\n.wrs_modal_overlay.wrs_modal_desktop.wrs_closed {\n  background: rgba(0, 0, 0, 0);\n  display: none;\n}\n\n.wrs_modal_title {\n  color: #fff;\n  padding: 5px 0 5px 10px;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  text-align: left;\n}\n\n.wrs_modal_close_button {\n  float: right;\n  cursor: pointer;\n  color: #fff;\n  padding: 5px 10px 5px 0;\n  margin: 10px 7px 0 0;\n  background-repeat: no-repeat;\n}\n\n.wrs_modal_minimize_button {\n  float: right;\n  cursor: pointer;\n  color: #fff;\n  padding: 5px 10px 5px 0;\n  top: inherit;\n  margin: 10px 7px 0 0;\n}\n\n.wrs_modal_stack_button {\n  float: right;\n  cursor: pointer;\n  color: #fff;\n  margin: 10px 7px 0 0;\n  padding: 5px 10px 5px 0;\n  top: inherit;\n}\n\n.wrs_modal_stack_button.wrs_stack {\n  visibility: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n.wrs_modal_stack_button.wrs_minimized {\n  visibility: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n.wrs_modal_maximize_button {\n  float: right;\n  cursor: pointer;\n  color: #fff;\n  margin: 10px 7px 0 0;\n  padding: 5px 10px 5px 0;\n  top: inherit;\n}\n\n.wrs_modal_maximize_button.wrs_maximized {\n  visibility: hidden;\n  margin: 0;\n  padding: 0;\n}\n\n.wrs_modal_title_bar {\n  display: block;\n  background-color: #778e9a;\n}\n\n.wrs_modal_dialogContainer {\n  border: none;\n  background: #fafafa;\n  z-index: 999999;\n}\n\n.wrs_modal_dialogContainer.wrs_modal_desktop {\n  font-size: 14px;\n}\n\n.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_maximized {\n  position: fixed;\n}\n\n.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_minimized {\n  position: fixed;\n  top: inherit;\n  margin: 0;\n  margin-right: 10px;\n}\n\n.wrs_modal_dialogContainer.wrs_closed {\n  visibility: hidden;\n  display: none;\n  opacity: 0;\n}\n\n/* Class that exists but hasn't got css properties defined\n.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_minimized.wrs_drag {} */\n\n.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_stack {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  box-shadow: rgba(0, 0, 0, 0.5) 0 2px 8px;\n}\n\n.wrs_modal_dialogContainer.wrs_drag {\n  box-shadow: rgba(0, 0, 0, 0.5) 0 2px 8px;\n}\n\n.wrs_modal_dialogContainer.wrs_modal_desktop.wrs_drag {\n  box-shadow: rgba(0, 0, 0, 0.5) 0 2px 8px;\n}\n\n.wrs_modal_dialogContainer.wrs_modal_android {\n  margin: auto;\n  position: fixed;\n  width: 99%;\n  height: 99%;\n  overflow: hidden;\n  transform: translate(50%, -50%);\n  top: 50%;\n  right: 50% !important;\n}\n\n.wrs_modal_dialogContainer.wrs_modal_ios {\n  margin: auto;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  transform: translate(50%, -50%);\n  top: 50%;\n  right: 50% !important;\n}\n\n/* Class that exists but hasn't got css properties defined\n.wrs_content_container.wrs_maximized {} */\n\n.wrs_content_container.wrs_minimized {\n  display: none;\n}\n\n/* .wrs_editor {\n    flex-grow: 1;\n} */\n\n.wrs_content_container.wrs_modal_android {\n  width: 100%;\n  height: 0%;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.wrs_content_container.wrs_modal_android > div:first-child {\n  flex-grow: 1;\n}\n\n.wrs_content_container.wrs_modal_ios > div:first-child {\n  flex-grow: 1;\n}\n\n.wrs_content_container.wrs_modal_desktop > div:first-child {\n  flex-grow: 1;\n}\n\n.wrs_modal_wrapper.wrs_modal_android {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.wrs_content_container.wrs_modal_desktop {\n  width: 100%;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.wrs_content_container.wrs_modal_ios {\n  width: 100%;\n  height: 0%;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.wrs_modal_wrapper.wrs_modal_ios {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n}\n\n.wrs_virtual_keyboard {\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 50%;\n  transform: translate(-50%, 0%);\n}\n\n@media all and (orientation: portrait) {\n  .wrs_modal_dialogContainer.wrs_modal_mobile {\n    width: 100vmin;\n    height: 100vmin;\n    margin: auto;\n    border-width: 0;\n  }\n\n  .wrs_modal_wrapper.wrs_modal_mobile {\n    width: 100vmin;\n    height: 100vmin;\n    margin: auto;\n  }\n}\n\n@media all and (orientation: landscape) {\n  .wrs_modal_dialogContainer.wrs_modal_mobile {\n    width: 100vmin;\n    height: 100vmin;\n    margin: auto;\n    border-width: 0;\n  }\n\n  .wrs_modal_wrapper.wrs_modal_mobile {\n    width: 100vmin;\n    height: 100vmin;\n    margin: auto;\n  }\n}\n\n.wrs_modal_dialogContainer.wrs_modal_badStock {\n  width: 100%;\n  height: 280px;\n  margin: 0 auto;\n  border-width: 0;\n}\n\n.wrs_modal_wrapper.wrs_modal_badStock {\n  width: 100%;\n  height: 280px;\n  margin: 0 auto;\n  border-width: 0;\n}\n\n.wrs_noselect {\n  -moz-user-select: none;\n  -khtml-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.wrs_bottom_right_resizer {\n  width: 10px;\n  height: 10px;\n  color: #778e9a;\n  position: absolute;\n  right: 4px;\n  bottom: 8px;\n  cursor: se-resize;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.wrs_bottom_left_resizer {\n  width: 15px;\n  height: 15px;\n  color: #778e9a;\n  position: absolute;\n  left: 0;\n  top: 0;\n  cursor: se-resize;\n}\n\n.wrs_modal_controls {\n  height: 42px;\n  margin: 3px 0;\n  overflow: hidden;\n  line-height: normal;\n}\n\n.wrs_modal_links {\n  margin: 10px auto;\n  margin-bottom: 0;\n  font-family: arial, sans-serif;\n  padding: 6px;\n  display: inline;\n  float: right;\n  text-align: right;\n}\n\n.wrs_modal_links > a {\n  text-decoration: none;\n  color: #778e9a;\n  font-size: 16px;\n}\n\n.wrs_modal_button_cancel,\n.wrs_modal_button_cancel:hover,\n.wrs_modal_button_cancel:visited,\n.wrs_modal_button_cancel:active,\n.wrs_modal_button_cancel:focus {\n  min-width: 80px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 1px solid #778e9a;\n  padding: 6px 8px;\n  margin: 10px auto;\n  margin-left: 5px;\n  margin-bottom: 0;\n  cursor: pointer;\n  font-family: arial, sans-serif;\n  background-color: #ddd;\n  height: 32px;\n}\n\n.wrs_modal_button_accept,\n.wrs_modal_button_accept:hover,\n.wrs_modal_button_accept:visited,\n.wrs_modal_button_accept:active,\n.wrs_modal_button_accept:focus {\n  min-width: 80px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 1px solid #778e9a;\n  padding: 6px 8px;\n  margin: 10px auto;\n  margin-right: 5px;\n  margin-bottom: 0;\n  color: #fff;\n  background: #778e9a;\n  cursor: pointer;\n  font-family: arial, sans-serif;\n  height: 32px;\n}\n\n.wrs_editor_vertical_bar {\n  height: 20px;\n  float: right;\n  background: none;\n  width: 20px;\n  cursor: pointer;\n}\n\n.wrs_modal_buttons_container {\n  display: inline;\n  float: left;\n}\n\n.wrs_modal_buttons_container.wrs_modalAndroid {\n  padding-left: 6px;\n}\n\n.wrs_modal_buttons_container.wrs_modalDesktop {\n  padding-left: 0;\n}\n\n.wrs_modal_buttons_container > button {\n  line-height: normal;\n  background-image: none;\n}\n\n.wrs_modal_wrapper {\n  margin: 6px;\n  display: flex;\n  flex-direction: column;\n}\n\n.wrs_modal_wrapper.wrs_modal_desktop.wrs_minimized {\n  display: none;\n}\n\n@media only screen and (max-device-width: 480px) and (orientation: portrait) {\n  #wrs_modal_wrapper {\n    width: 140%;\n  }\n}\n\n.wrs_popupmessage_overlay_envolture {\n  display: none;\n  width: 100%;\n}\n\n.wrs_popupmessage_overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 4;\n  cursor: pointer;\n}\n\n.wrs_popupmessage_panel {\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  position: absolute;\n  background: white;\n  max-width: 500px;\n  width: 75%;\n  border-radius: 2px;\n  padding: 20px;\n  font-family: sans-serif;\n  font-size: 15px;\n  text-align: left;\n  color: #2e2e2e;\n  z-index: 5;\n  max-height: 75%;\n  overflow: auto;\n}\n\n.wrs_popupmessage_button_area {\n  margin: 10px 0 0 0;\n}\n\n.wrs_panelContainer * {\n  border: 0;\n}\n\n.wrs_button_cancel,\n.wrs_button_cancel:hover,\n.wrs_button_cancel:visited,\n.wrs_button_cancel:active,\n.wrs_button_cancel:focus {\n  min-width: 80px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 1px solid #778e9a;\n  padding: 6px 8px;\n  margin: 10px auto;\n  margin-left: 5px;\n  margin-bottom: 0;\n  cursor: pointer;\n  font-family: arial, sans-serif;\n  background-color: #ddd;\n  background-image: none;\n  height: 32px;\n}\n\n.wrs_button_accept,\n.wrs_button_accept:hover,\n.wrs_button_accept:visited,\n.wrs_button_accept:active,\n.wrs_button_accept:focus {\n  min-width: 80px;\n  font-size: 14px;\n  border-radius: 3px;\n  border: 1px solid #778e9a;\n  padding: 6px 8px;\n  margin: 10px auto;\n  margin-right: 5px;\n  margin-bottom: 0;\n  color: #fff;\n  background: #778e9a;\n  cursor: pointer;\n  font-family: arial, sans-serif;\n  height: 32px;\n}\n\n.wrs_editor button {\n  box-shadow: none;\n}\n\n.wrs_editor .wrs_header button {\n  border-bottom: none;\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.wrs_modal_overlay.wrs_modal_desktop.wrs_stack.wrs_overlay_active {\n  display: block;\n}\n\n/* Fix selection in drupal style */\n.wrs_toolbar tr:focus {\n  background: none;\n}\n\n.wrs_toolbar tr:hover {\n  background: none;\n}\n\n/* End of fix drupal */\n.wrs_modal_rtl .wrs_modal_button_cancel {\n  margin-right: 5px;\n  margin-left: 0;\n}\n\n.wrs_modal_rtl .wrs_modal_button_accept {\n  margin-right: 0;\n  margin-left: 5px;\n}\n\n.wrs_modal_rtl .wrs_button_cancel {\n  margin-right: 5px;\n  margin-left: 0;\n}\n\n.wrs_modal_rtl .wrs_button_accept {\n  margin-right: 0;\n  margin-left: 5px;\n}\n"
            ],
            sourceRoot: ''
          }
        ])
        const c = a
      },
      3645: (t) => {
        'use strict'
        t.exports = function (t) {
          var e = []
          e.toString = function e() {
            return this.map(function (e) {
              var n = t(e)
              if (e[2]) {
                return '@media '.concat(e[2], ' {').concat(n, '}')
              }
              return n
            }).join('')
          }
          e.i = function (t, n, i) {
            if (typeof t === 'string') {
              t = [[null, t, '']]
            }
            var o = {}
            if (i) {
              for (var r = 0; r < this.length; r++) {
                var s = this[r][0]
                if (s != null) {
                  o[s] = true
                }
              }
            }
            for (var a = 0; a < t.length; a++) {
              var c = [].concat(t[a])
              if (i && o[c[0]]) {
                continue
              }
              if (n) {
                if (!c[2]) {
                  c[2] = n
                } else {
                  c[2] = ''.concat(n, ' and ').concat(c[2])
                }
              }
              e.push(c)
            }
          }
          return e
        }
      },
      4015: (t) => {
        'use strict'
        function e(t, e) {
          return s(t) || r(t, e) || i(t, e) || n()
        }
        function n() {
          throw new TypeError(
            'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
          )
        }
        function i(t, e) {
          if (!t) return
          if (typeof t === 'string') return o(t, e)
          var n = Object.prototype.toString.call(t).slice(8, -1)
          if (n === 'Object' && t.constructor) n = t.constructor.name
          if (n === 'Map' || n === 'Set') return Array.from(t)
          if (
            n === 'Arguments' ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return o(t, e)
        }
        function o(t, e) {
          if (e == null || e > t.length) e = t.length
          for (var n = 0, i = new Array(e); n < e; n++) {
            i[n] = t[n]
          }
          return i
        }
        function r(t, e) {
          var n =
            t &&
            ((typeof Symbol !== 'undefined' && t[Symbol.iterator]) ||
              t['@@iterator'])
          if (n == null) return
          var i = []
          var o = true
          var r = false
          var s, a
          try {
            for (n = n.call(t); !(o = (s = n.next()).done); o = true) {
              i.push(s.value)
              if (e && i.length === e) break
            }
          } catch (t) {
            r = true
            a = t
          } finally {
            try {
              if (!o && n['return'] != null) n['return']()
            } finally {
              if (r) throw a
            }
          }
          return i
        }
        function s(t) {
          if (Array.isArray(t)) return t
        }
        t.exports = function t(n) {
          var i = e(n, 4),
            o = i[1],
            r = i[3]
          if (!r) {
            return o
          }
          if (typeof btoa === 'function') {
            var s = btoa(unescape(encodeURIComponent(JSON.stringify(r))))
            var a =
              'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(
                s
              )
            var c = '/*# '.concat(a, ' */')
            var l = r.sources.map(function (t) {
              return '/*# sourceURL='
                .concat(r.sourceRoot || '')
                .concat(t, ' */')
            })
            return [o].concat(l).concat([c]).join('\n')
          }
          return [o].join('\n')
        }
      },
      7856: function (t) {
        /*! @license DOMPurify 2.4.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.4.3/LICENSE */
        ;(function (e, n) {
          true ? (t.exports = n()) : 0
        })(this, function () {
          'use strict'
          function t(e) {
            '@babel/helpers - typeof'
            return (
              (t =
                'function' == typeof Symbol &&
                'symbol' == typeof Symbol.iterator
                  ? function (t) {
                      return typeof t
                    }
                  : function (t) {
                      return t &&
                        'function' == typeof Symbol &&
                        t.constructor === Symbol &&
                        t !== Symbol.prototype
                        ? 'symbol'
                        : typeof t
                    }),
              t(e)
            )
          }
          function e(t, n) {
            e =
              Object.setPrototypeOf ||
              function t(e, n) {
                e.__proto__ = n
                return e
              }
            return e(t, n)
          }
          function n() {
            if (typeof Reflect === 'undefined' || !Reflect.construct)
              return false
            if (Reflect.construct.sham) return false
            if (typeof Proxy === 'function') return true
            try {
              Boolean.prototype.valueOf.call(
                Reflect.construct(Boolean, [], function () {})
              )
              return true
            } catch (t) {
              return false
            }
          }
          function i(t, o, r) {
            if (n()) {
              i = Reflect.construct
            } else {
              i = function t(n, i, o) {
                var r = [null]
                r.push.apply(r, i)
                var s = Function.bind.apply(n, r)
                var a = new s()
                if (o) e(a, o.prototype)
                return a
              }
            }
            return i.apply(null, arguments)
          }
          function o(t) {
            return r(t) || s(t) || a(t) || l()
          }
          function r(t) {
            if (Array.isArray(t)) return c(t)
          }
          function s(t) {
            if (
              (typeof Symbol !== 'undefined' && t[Symbol.iterator] != null) ||
              t['@@iterator'] != null
            )
              return Array.from(t)
          }
          function a(t, e) {
            if (!t) return
            if (typeof t === 'string') return c(t, e)
            var n = Object.prototype.toString.call(t).slice(8, -1)
            if (n === 'Object' && t.constructor) n = t.constructor.name
            if (n === 'Map' || n === 'Set') return Array.from(t)
            if (
              n === 'Arguments' ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
            )
              return c(t, e)
          }
          function c(t, e) {
            if (e == null || e > t.length) e = t.length
            for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n]
            return i
          }
          function l() {
            throw new TypeError(
              'Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
            )
          }
          var d = Object.hasOwnProperty,
            u = Object.setPrototypeOf,
            h = Object.isFrozen,
            f = Object.getPrototypeOf,
            m = Object.getOwnPropertyDescriptor
          var g = Object.freeze,
            p = Object.seal,
            b = Object.create
          var k = typeof Reflect !== 'undefined' && Reflect,
            w = k.apply,
            _ = k.construct
          if (!w) {
            w = function t(e, n, i) {
              return e.apply(n, i)
            }
          }
          if (!g) {
            g = function t(e) {
              return e
            }
          }
          if (!p) {
            p = function t(e) {
              return e
            }
          }
          if (!_) {
            _ = function t(e, n) {
              return i(e, o(n))
            }
          }
          var A = B(Array.prototype.forEach)
          var v = B(Array.prototype.pop)
          var C = B(Array.prototype.push)
          var y = B(String.prototype.toLowerCase)
          var x = B(String.prototype.toString)
          var E = B(String.prototype.match)
          var D = B(String.prototype.replace)
          var T = B(String.prototype.indexOf)
          var M = B(String.prototype.trim)
          var I = B(RegExp.prototype.test)
          var S = N(TypeError)
          function B(t) {
            return function (e) {
              for (
                var n = arguments.length,
                  i = new Array(n > 1 ? n - 1 : 0),
                  o = 1;
                o < n;
                o++
              ) {
                i[o - 1] = arguments[o]
              }
              return w(t, e, i)
            }
          }
          function N(t) {
            return function () {
              for (
                var e = arguments.length, n = new Array(e), i = 0;
                i < e;
                i++
              ) {
                n[i] = arguments[i]
              }
              return _(t, n)
            }
          }
          function P(t, e, n) {
            n = n ? n : y
            if (u) {
              u(t, null)
            }
            var i = e.length
            while (i--) {
              var o = e[i]
              if (typeof o === 'string') {
                var r = n(o)
                if (r !== o) {
                  if (!h(e)) {
                    e[i] = r
                  }
                  o = r
                }
              }
              t[o] = true
            }
            return t
          }
          function z(t) {
            var e = b(null)
            var n
            for (n in t) {
              if (w(d, t, [n]) === true) {
                e[n] = t[n]
              }
            }
            return e
          }
          function L(t, e) {
            while (t !== null) {
              var n = m(t, e)
              if (n) {
                if (n.get) {
                  return B(n.get)
                }
                if (typeof n.value === 'function') {
                  return B(n.value)
                }
              }
              t = f(t)
            }
            function i(t) {
              console.warn('fallback value for', t)
              return null
            }
            return i
          }
          var O = g([
            'a',
            'abbr',
            'acronym',
            'address',
            'area',
            'article',
            'aside',
            'audio',
            'b',
            'bdi',
            'bdo',
            'big',
            'blink',
            'blockquote',
            'body',
            'br',
            'button',
            'canvas',
            'caption',
            'center',
            'cite',
            'code',
            'col',
            'colgroup',
            'content',
            'data',
            'datalist',
            'dd',
            'decorator',
            'del',
            'details',
            'dfn',
            'dialog',
            'dir',
            'div',
            'dl',
            'dt',
            'element',
            'em',
            'fieldset',
            'figcaption',
            'figure',
            'font',
            'footer',
            'form',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'head',
            'header',
            'hgroup',
            'hr',
            'html',
            'i',
            'img',
            'input',
            'ins',
            'kbd',
            'label',
            'legend',
            'li',
            'main',
            'map',
            'mark',
            'marquee',
            'menu',
            'menuitem',
            'meter',
            'nav',
            'nobr',
            'ol',
            'optgroup',
            'option',
            'output',
            'p',
            'picture',
            'pre',
            'progress',
            'q',
            'rp',
            'rt',
            'ruby',
            's',
            'samp',
            'section',
            'select',
            'shadow',
            'small',
            'source',
            'spacer',
            'span',
            'strike',
            'strong',
            'style',
            'sub',
            'summary',
            'sup',
            'table',
            'tbody',
            'td',
            'template',
            'textarea',
            'tfoot',
            'th',
            'thead',
            'time',
            'tr',
            'track',
            'tt',
            'u',
            'ul',
            'var',
            'video',
            'wbr'
          ])
          var R = g([
            'svg',
            'a',
            'altglyph',
            'altglyphdef',
            'altglyphitem',
            'animatecolor',
            'animatemotion',
            'animatetransform',
            'circle',
            'clippath',
            'defs',
            'desc',
            'ellipse',
            'filter',
            'font',
            'g',
            'glyph',
            'glyphref',
            'hkern',
            'image',
            'line',
            'lineargradient',
            'marker',
            'mask',
            'metadata',
            'mpath',
            'path',
            'pattern',
            'polygon',
            'polyline',
            'radialgradient',
            'rect',
            'stop',
            'style',
            'switch',
            'symbol',
            'text',
            'textpath',
            'title',
            'tref',
            'tspan',
            'view',
            'vkern'
          ])
          var j = g([
            'feBlend',
            'feColorMatrix',
            'feComponentTransfer',
            'feComposite',
            'feConvolveMatrix',
            'feDiffuseLighting',
            'feDisplacementMap',
            'feDistantLight',
            'feFlood',
            'feFuncA',
            'feFuncB',
            'feFuncG',
            'feFuncR',
            'feGaussianBlur',
            'feImage',
            'feMerge',
            'feMergeNode',
            'feMorphology',
            'feOffset',
            'fePointLight',
            'feSpecularLighting',
            'feSpotLight',
            'feTile',
            'feTurbulence'
          ])
          var F = g([
            'animate',
            'color-profile',
            'cursor',
            'discard',
            'fedropshadow',
            'font-face',
            'font-face-format',
            'font-face-name',
            'font-face-src',
            'font-face-uri',
            'foreignobject',
            'hatch',
            'hatchpath',
            'mesh',
            'meshgradient',
            'meshpatch',
            'meshrow',
            'missing-glyph',
            'script',
            'set',
            'solidcolor',
            'unknown',
            'use'
          ])
          var V = g([
            'math',
            'menclose',
            'merror',
            'mfenced',
            'mfrac',
            'mglyph',
            'mi',
            'mlabeledtr',
            'mmultiscripts',
            'mn',
            'mo',
            'mover',
            'mpadded',
            'mphantom',
            'mroot',
            'mrow',
            'ms',
            'mspace',
            'msqrt',
            'mstyle',
            'msub',
            'msup',
            'msubsup',
            'mtable',
            'mtd',
            'mtext',
            'mtr',
            'munder',
            'munderover'
          ])
          var H = g([
            'maction',
            'maligngroup',
            'malignmark',
            'mlongdiv',
            'mscarries',
            'mscarry',
            'msgroup',
            'mstack',
            'msline',
            'msrow',
            'semantics',
            'annotation',
            'annotation-xml',
            'mprescripts',
            'none'
          ])
          var U = g(['#text'])
          var W = g([
            'accept',
            'action',
            'align',
            'alt',
            'autocapitalize',
            'autocomplete',
            'autopictureinpicture',
            'autoplay',
            'background',
            'bgcolor',
            'border',
            'capture',
            'cellpadding',
            'cellspacing',
            'checked',
            'cite',
            'class',
            'clear',
            'color',
            'cols',
            'colspan',
            'controls',
            'controlslist',
            'coords',
            'crossorigin',
            'datetime',
            'decoding',
            'default',
            'dir',
            'disabled',
            'disablepictureinpicture',
            'disableremoteplayback',
            'download',
            'draggable',
            'enctype',
            'enterkeyhint',
            'face',
            'for',
            'headers',
            'height',
            'hidden',
            'high',
            'href',
            'hreflang',
            'id',
            'inputmode',
            'integrity',
            'ismap',
            'kind',
            'label',
            'lang',
            'list',
            'loading',
            'loop',
            'low',
            'max',
            'maxlength',
            'media',
            'method',
            'min',
            'minlength',
            'multiple',
            'muted',
            'name',
            'nonce',
            'noshade',
            'novalidate',
            'nowrap',
            'open',
            'optimum',
            'pattern',
            'placeholder',
            'playsinline',
            'poster',
            'preload',
            'pubdate',
            'radiogroup',
            'readonly',
            'rel',
            'required',
            'rev',
            'reversed',
            'role',
            'rows',
            'rowspan',
            'spellcheck',
            'scope',
            'selected',
            'shape',
            'size',
            'sizes',
            'span',
            'srclang',
            'start',
            'src',
            'srcset',
            'step',
            'style',
            'summary',
            'tabindex',
            'title',
            'translate',
            'type',
            'usemap',
            'valign',
            'value',
            'width',
            'xmlns',
            'slot'
          ])
          var q = g([
            'accent-height',
            'accumulate',
            'additive',
            'alignment-baseline',
            'ascent',
            'attributename',
            'attributetype',
            'azimuth',
            'basefrequency',
            'baseline-shift',
            'begin',
            'bias',
            'by',
            'class',
            'clip',
            'clippathunits',
            'clip-path',
            'clip-rule',
            'color',
            'color-interpolation',
            'color-interpolation-filters',
            'color-profile',
            'color-rendering',
            'cx',
            'cy',
            'd',
            'dx',
            'dy',
            'diffuseconstant',
            'direction',
            'display',
            'divisor',
            'dur',
            'edgemode',
            'elevation',
            'end',
            'fill',
            'fill-opacity',
            'fill-rule',
            'filter',
            'filterunits',
            'flood-color',
            'flood-opacity',
            'font-family',
            'font-size',
            'font-size-adjust',
            'font-stretch',
            'font-style',
            'font-variant',
            'font-weight',
            'fx',
            'fy',
            'g1',
            'g2',
            'glyph-name',
            'glyphref',
            'gradientunits',
            'gradienttransform',
            'height',
            'href',
            'id',
            'image-rendering',
            'in',
            'in2',
            'k',
            'k1',
            'k2',
            'k3',
            'k4',
            'kerning',
            'keypoints',
            'keysplines',
            'keytimes',
            'lang',
            'lengthadjust',
            'letter-spacing',
            'kernelmatrix',
            'kernelunitlength',
            'lighting-color',
            'local',
            'marker-end',
            'marker-mid',
            'marker-start',
            'markerheight',
            'markerunits',
            'markerwidth',
            'maskcontentunits',
            'maskunits',
            'max',
            'mask',
            'media',
            'method',
            'mode',
            'min',
            'name',
            'numoctaves',
            'offset',
            'operator',
            'opacity',
            'order',
            'orient',
            'orientation',
            'origin',
            'overflow',
            'paint-order',
            'path',
            'pathlength',
            'patterncontentunits',
            'patterntransform',
            'patternunits',
            'points',
            'preservealpha',
            'preserveaspectratio',
            'primitiveunits',
            'r',
            'rx',
            'ry',
            'radius',
            'refx',
            'refy',
            'repeatcount',
            'repeatdur',
            'restart',
            'result',
            'rotate',
            'scale',
            'seed',
            'shape-rendering',
            'specularconstant',
            'specularexponent',
            'spreadmethod',
            'startoffset',
            'stddeviation',
            'stitchtiles',
            'stop-color',
            'stop-opacity',
            'stroke-dasharray',
            'stroke-dashoffset',
            'stroke-linecap',
            'stroke-linejoin',
            'stroke-miterlimit',
            'stroke-opacity',
            'stroke',
            'stroke-width',
            'style',
            'surfacescale',
            'systemlanguage',
            'tabindex',
            'targetx',
            'targety',
            'transform',
            'transform-origin',
            'text-anchor',
            'text-decoration',
            'text-rendering',
            'textlength',
            'type',
            'u1',
            'u2',
            'unicode',
            'values',
            'viewbox',
            'visibility',
            'version',
            'vert-adv-y',
            'vert-origin-x',
            'vert-origin-y',
            'width',
            'word-spacing',
            'wrap',
            'writing-mode',
            'xchannelselector',
            'ychannelselector',
            'x',
            'x1',
            'x2',
            'xmlns',
            'y',
            'y1',
            'y2',
            'z',
            'zoomandpan'
          ])
          var $ = g([
            'accent',
            'accentunder',
            'align',
            'bevelled',
            'close',
            'columnsalign',
            'columnlines',
            'columnspan',
            'denomalign',
            'depth',
            'dir',
            'display',
            'displaystyle',
            'encoding',
            'fence',
            'frame',
            'height',
            'href',
            'id',
            'largeop',
            'length',
            'linethickness',
            'lspace',
            'lquote',
            'mathbackground',
            'mathcolor',
            'mathsize',
            'mathvariant',
            'maxsize',
            'minsize',
            'movablelimits',
            'notation',
            'numalign',
            'open',
            'rowalign',
            'rowlines',
            'rowspacing',
            'rowspan',
            'rspace',
            'rquote',
            'scriptlevel',
            'scriptminsize',
            'scriptsizemultiplier',
            'selection',
            'separator',
            'separators',
            'stretchy',
            'subscriptshift',
            'supscriptshift',
            'symmetric',
            'voffset',
            'width',
            'xmlns'
          ])
          var G = g([
            'xlink:href',
            'xml:id',
            'xlink:title',
            'xml:space',
            'xmlns:xlink'
          ])
          var Y = p(/\{\{[\w\W]*|[\w\W]*\}\}/gm)
          var K = p(/<%[\w\W]*|[\w\W]*%>/gm)
          var Q = p(/\${[\w\W]*}/gm)
          var Z = p(/^data-[\-\w.\u00B7-\uFFFF]/)
          var J = p(/^aria-[\-\w]+$/)
          var X = p(
            /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
          )
          var tt = p(/^(?:\w+script|data):/i)
          var et = p(
            /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
          )
          var nt = p(/^html$/i)
          var it = function t() {
            return typeof window === 'undefined' ? null : window
          }
          var ot = function e(n, i) {
            if (t(n) !== 'object' || typeof n.createPolicy !== 'function') {
              return null
            }
            var o = null
            var r = 'data-tt-policy-suffix'
            if (i.currentScript && i.currentScript.hasAttribute(r)) {
              o = i.currentScript.getAttribute(r)
            }
            var s = 'dompurify' + (o ? '#' + o : '')
            try {
              return n.createPolicy(s, {
                createHTML: function t(e) {
                  return e
                },
                createScriptURL: function t(e) {
                  return e
                }
              })
            } catch (t) {
              console.warn(
                'TrustedTypes policy ' + s + ' could not be created.'
              )
              return null
            }
          }
          function rt() {
            var e =
              arguments.length > 0 && arguments[0] !== undefined
                ? arguments[0]
                : it()
            var n = function t(e) {
              return rt(e)
            }
            n.version = '2.4.3'
            n.removed = []
            if (!e || !e.document || e.document.nodeType !== 9) {
              n.isSupported = false
              return n
            }
            var i = e.document
            var r = e.document
            var s = e.DocumentFragment,
              a = e.HTMLTemplateElement,
              c = e.Node,
              l = e.Element,
              d = e.NodeFilter,
              u = e.NamedNodeMap,
              h = u === void 0 ? e.NamedNodeMap || e.MozNamedAttrMap : u,
              f = e.HTMLFormElement,
              m = e.DOMParser,
              p = e.trustedTypes
            var b = l.prototype
            var k = L(b, 'cloneNode')
            var w = L(b, 'nextSibling')
            var _ = L(b, 'childNodes')
            var B = L(b, 'parentNode')
            if (typeof a === 'function') {
              var N = r.createElement('template')
              if (N.content && N.content.ownerDocument) {
                r = N.content.ownerDocument
              }
            }
            var st = ot(p, i)
            var at = st ? st.createHTML('') : ''
            var ct = r,
              lt = ct.implementation,
              dt = ct.createNodeIterator,
              ut = ct.createDocumentFragment,
              ht = ct.getElementsByTagName
            var ft = i.importNode
            var mt = {}
            try {
              mt = z(r).documentMode ? r.documentMode : {}
            } catch (t) {}
            var gt = {}
            n.isSupported =
              typeof B === 'function' &&
              lt &&
              typeof lt.createHTMLDocument !== 'undefined' &&
              mt !== 9
            var pt = Y,
              bt = K,
              kt = Q,
              wt = Z,
              _t = J,
              At = tt,
              vt = et
            var Ct = X
            var yt = null
            var xt = P({}, [].concat(o(O), o(R), o(j), o(V), o(U)))
            var Et = null
            var Dt = P({}, [].concat(o(W), o(q), o($), o(G)))
            var Tt = Object.seal(
              Object.create(null, {
                tagNameCheck: {
                  writable: true,
                  configurable: false,
                  enumerable: true,
                  value: null
                },
                attributeNameCheck: {
                  writable: true,
                  configurable: false,
                  enumerable: true,
                  value: null
                },
                allowCustomizedBuiltInElements: {
                  writable: true,
                  configurable: false,
                  enumerable: true,
                  value: false
                }
              })
            )
            var Mt = null
            var It = null
            var St = true
            var Bt = true
            var Nt = false
            var Pt = false
            var zt = false
            var Lt = false
            var Ot = false
            var Rt = false
            var jt = false
            var Ft = false
            var Vt = true
            var Ht = false
            var Ut = 'user-content-'
            var Wt = true
            var qt = false
            var $t = {}
            var Gt = null
            var Yt = P({}, [
              'annotation-xml',
              'audio',
              'colgroup',
              'desc',
              'foreignobject',
              'head',
              'iframe',
              'math',
              'mi',
              'mn',
              'mo',
              'ms',
              'mtext',
              'noembed',
              'noframes',
              'noscript',
              'plaintext',
              'script',
              'style',
              'svg',
              'template',
              'thead',
              'title',
              'video',
              'xmp'
            ])
            var Kt = null
            var Qt = P({}, [
              'audio',
              'video',
              'img',
              'source',
              'image',
              'track'
            ])
            var Zt = null
            var Jt = P({}, [
              'alt',
              'class',
              'for',
              'id',
              'label',
              'name',
              'pattern',
              'placeholder',
              'role',
              'summary',
              'title',
              'value',
              'style',
              'xmlns'
            ])
            var Xt = 'http://www.w3.org/1998/Math/MathML'
            var te = 'http://www.w3.org/2000/svg'
            var ee = 'http://www.w3.org/1999/xhtml'
            var ne = ee
            var ie = false
            var oe = null
            var re = P({}, [Xt, te, ee], x)
            var se
            var ae = ['application/xhtml+xml', 'text/html']
            var ce = 'text/html'
            var le
            var de = null
            var ue = r.createElement('form')
            var he = function t(e) {
              return e instanceof RegExp || e instanceof Function
            }
            var fe = function e(n) {
              if (de && de === n) {
                return
              }
              if (!n || t(n) !== 'object') {
                n = {}
              }
              n = z(n)
              se =
                ae.indexOf(n.PARSER_MEDIA_TYPE) === -1
                  ? (se = ce)
                  : (se = n.PARSER_MEDIA_TYPE)
              le = se === 'application/xhtml+xml' ? x : y
              yt = 'ALLOWED_TAGS' in n ? P({}, n.ALLOWED_TAGS, le) : xt
              Et = 'ALLOWED_ATTR' in n ? P({}, n.ALLOWED_ATTR, le) : Dt
              oe =
                'ALLOWED_NAMESPACES' in n ? P({}, n.ALLOWED_NAMESPACES, x) : re
              Zt =
                'ADD_URI_SAFE_ATTR' in n
                  ? P(z(Jt), n.ADD_URI_SAFE_ATTR, le)
                  : Jt
              Kt =
                'ADD_DATA_URI_TAGS' in n
                  ? P(z(Qt), n.ADD_DATA_URI_TAGS, le)
                  : Qt
              Gt = 'FORBID_CONTENTS' in n ? P({}, n.FORBID_CONTENTS, le) : Yt
              Mt = 'FORBID_TAGS' in n ? P({}, n.FORBID_TAGS, le) : {}
              It = 'FORBID_ATTR' in n ? P({}, n.FORBID_ATTR, le) : {}
              $t = 'USE_PROFILES' in n ? n.USE_PROFILES : false
              St = n.ALLOW_ARIA_ATTR !== false
              Bt = n.ALLOW_DATA_ATTR !== false
              Nt = n.ALLOW_UNKNOWN_PROTOCOLS || false
              Pt = n.SAFE_FOR_TEMPLATES || false
              zt = n.WHOLE_DOCUMENT || false
              Rt = n.RETURN_DOM || false
              jt = n.RETURN_DOM_FRAGMENT || false
              Ft = n.RETURN_TRUSTED_TYPE || false
              Ot = n.FORCE_BODY || false
              Vt = n.SANITIZE_DOM !== false
              Ht = n.SANITIZE_NAMED_PROPS || false
              Wt = n.KEEP_CONTENT !== false
              qt = n.IN_PLACE || false
              Ct = n.ALLOWED_URI_REGEXP || Ct
              ne = n.NAMESPACE || ee
              if (
                n.CUSTOM_ELEMENT_HANDLING &&
                he(n.CUSTOM_ELEMENT_HANDLING.tagNameCheck)
              ) {
                Tt.tagNameCheck = n.CUSTOM_ELEMENT_HANDLING.tagNameCheck
              }
              if (
                n.CUSTOM_ELEMENT_HANDLING &&
                he(n.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)
              ) {
                Tt.attributeNameCheck =
                  n.CUSTOM_ELEMENT_HANDLING.attributeNameCheck
              }
              if (
                n.CUSTOM_ELEMENT_HANDLING &&
                typeof n.CUSTOM_ELEMENT_HANDLING
                  .allowCustomizedBuiltInElements === 'boolean'
              ) {
                Tt.allowCustomizedBuiltInElements =
                  n.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements
              }
              if (Pt) {
                Bt = false
              }
              if (jt) {
                Rt = true
              }
              if ($t) {
                yt = P({}, o(U))
                Et = []
                if ($t.html === true) {
                  P(yt, O)
                  P(Et, W)
                }
                if ($t.svg === true) {
                  P(yt, R)
                  P(Et, q)
                  P(Et, G)
                }
                if ($t.svgFilters === true) {
                  P(yt, j)
                  P(Et, q)
                  P(Et, G)
                }
                if ($t.mathMl === true) {
                  P(yt, V)
                  P(Et, $)
                  P(Et, G)
                }
              }
              if (n.ADD_TAGS) {
                if (yt === xt) {
                  yt = z(yt)
                }
                P(yt, n.ADD_TAGS, le)
              }
              if (n.ADD_ATTR) {
                if (Et === Dt) {
                  Et = z(Et)
                }
                P(Et, n.ADD_ATTR, le)
              }
              if (n.ADD_URI_SAFE_ATTR) {
                P(Zt, n.ADD_URI_SAFE_ATTR, le)
              }
              if (n.FORBID_CONTENTS) {
                if (Gt === Yt) {
                  Gt = z(Gt)
                }
                P(Gt, n.FORBID_CONTENTS, le)
              }
              if (Wt) {
                yt['#text'] = true
              }
              if (zt) {
                P(yt, ['html', 'head', 'body'])
              }
              if (yt.table) {
                P(yt, ['tbody'])
                delete Mt.tbody
              }
              if (g) {
                g(n)
              }
              de = n
            }
            var me = P({}, ['mi', 'mo', 'mn', 'ms', 'mtext'])
            var ge = P({}, ['foreignobject', 'desc', 'title', 'annotation-xml'])
            var pe = P({}, ['title', 'style', 'font', 'a', 'script'])
            var be = P({}, R)
            P(be, j)
            P(be, F)
            var ke = P({}, V)
            P(ke, H)
            var we = function t(e) {
              var n = B(e)
              if (!n || !n.tagName) {
                n = { namespaceURI: ne, tagName: 'template' }
              }
              var i = y(e.tagName)
              var o = y(n.tagName)
              if (!oe[e.namespaceURI]) {
                return false
              }
              if (e.namespaceURI === te) {
                if (n.namespaceURI === ee) {
                  return i === 'svg'
                }
                if (n.namespaceURI === Xt) {
                  return i === 'svg' && (o === 'annotation-xml' || me[o])
                }
                return Boolean(be[i])
              }
              if (e.namespaceURI === Xt) {
                if (n.namespaceURI === ee) {
                  return i === 'math'
                }
                if (n.namespaceURI === te) {
                  return i === 'math' && ge[o]
                }
                return Boolean(ke[i])
              }
              if (e.namespaceURI === ee) {
                if (n.namespaceURI === te && !ge[o]) {
                  return false
                }
                if (n.namespaceURI === Xt && !me[o]) {
                  return false
                }
                return !ke[i] && (pe[i] || !be[i])
              }
              if (se === 'application/xhtml+xml' && oe[e.namespaceURI]) {
                return true
              }
              return false
            }
            var _e = function t(e) {
              C(n.removed, { element: e })
              try {
                e.parentNode.removeChild(e)
              } catch (t) {
                try {
                  e.outerHTML = at
                } catch (t) {
                  e.remove()
                }
              }
            }
            var Ae = function t(e, i) {
              try {
                C(n.removed, { attribute: i.getAttributeNode(e), from: i })
              } catch (t) {
                C(n.removed, { attribute: null, from: i })
              }
              i.removeAttribute(e)
              if (e === 'is' && !Et[e]) {
                if (Rt || jt) {
                  try {
                    _e(i)
                  } catch (t) {}
                } else {
                  try {
                    i.setAttribute(e, '')
                  } catch (t) {}
                }
              }
            }
            var ve = function t(e) {
              var n
              var i
              if (Ot) {
                e = '<remove></remove>' + e
              } else {
                var o = E(e, /^[\r\n\t ]+/)
                i = o && o[0]
              }
              if (se === 'application/xhtml+xml' && ne === ee) {
                e =
                  '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' +
                  e +
                  '</body></html>'
              }
              var s = st ? st.createHTML(e) : e
              if (ne === ee) {
                try {
                  n = new m().parseFromString(s, se)
                } catch (t) {}
              }
              if (!n || !n.documentElement) {
                n = lt.createDocument(ne, 'template', null)
                try {
                  n.documentElement.innerHTML = ie ? at : s
                } catch (t) {}
              }
              var a = n.body || n.documentElement
              if (e && i) {
                a.insertBefore(r.createTextNode(i), a.childNodes[0] || null)
              }
              if (ne === ee) {
                return ht.call(n, zt ? 'html' : 'body')[0]
              }
              return zt ? n.documentElement : a
            }
            var Ce = function t(e) {
              return dt.call(
                e.ownerDocument || e,
                e,
                d.SHOW_ELEMENT | d.SHOW_COMMENT | d.SHOW_TEXT,
                null,
                false
              )
            }
            var ye = function t(e) {
              return (
                e instanceof f &&
                (typeof e.nodeName !== 'string' ||
                  typeof e.textContent !== 'string' ||
                  typeof e.removeChild !== 'function' ||
                  !(e.attributes instanceof h) ||
                  typeof e.removeAttribute !== 'function' ||
                  typeof e.setAttribute !== 'function' ||
                  typeof e.namespaceURI !== 'string' ||
                  typeof e.insertBefore !== 'function' ||
                  typeof e.hasChildNodes !== 'function')
              )
            }
            var xe = function e(n) {
              return t(c) === 'object'
                ? n instanceof c
                : n &&
                    t(n) === 'object' &&
                    typeof n.nodeType === 'number' &&
                    typeof n.nodeName === 'string'
            }
            var Ee = function t(e, i, o) {
              if (!gt[e]) {
                return
              }
              A(gt[e], function (t) {
                t.call(n, i, o, de)
              })
            }
            var De = function t(e) {
              var i
              Ee('beforeSanitizeElements', e, null)
              if (ye(e)) {
                _e(e)
                return true
              }
              if (I(/[\u0080-\uFFFF]/, e.nodeName)) {
                _e(e)
                return true
              }
              var o = le(e.nodeName)
              Ee('uponSanitizeElement', e, { tagName: o, allowedTags: yt })
              if (
                e.hasChildNodes() &&
                !xe(e.firstElementChild) &&
                (!xe(e.content) || !xe(e.content.firstElementChild)) &&
                I(/<[/\w]/g, e.innerHTML) &&
                I(/<[/\w]/g, e.textContent)
              ) {
                _e(e)
                return true
              }
              if (o === 'select' && I(/<template/i, e.innerHTML)) {
                _e(e)
                return true
              }
              if (!yt[o] || Mt[o]) {
                if (!Mt[o] && Me(o)) {
                  if (
                    Tt.tagNameCheck instanceof RegExp &&
                    I(Tt.tagNameCheck, o)
                  )
                    return false
                  if (Tt.tagNameCheck instanceof Function && Tt.tagNameCheck(o))
                    return false
                }
                if (Wt && !Gt[o]) {
                  var r = B(e) || e.parentNode
                  var s = _(e) || e.childNodes
                  if (s && r) {
                    var a = s.length
                    for (var c = a - 1; c >= 0; --c) {
                      r.insertBefore(k(s[c], true), w(e))
                    }
                  }
                }
                _e(e)
                return true
              }
              if (e instanceof l && !we(e)) {
                _e(e)
                return true
              }
              if (
                (o === 'noscript' || o === 'noembed') &&
                I(/<\/no(script|embed)/i, e.innerHTML)
              ) {
                _e(e)
                return true
              }
              if (Pt && e.nodeType === 3) {
                i = e.textContent
                i = D(i, pt, ' ')
                i = D(i, bt, ' ')
                i = D(i, kt, ' ')
                if (e.textContent !== i) {
                  C(n.removed, { element: e.cloneNode() })
                  e.textContent = i
                }
              }
              Ee('afterSanitizeElements', e, null)
              return false
            }
            var Te = function t(e, n, i) {
              if (Vt && (n === 'id' || n === 'name') && (i in r || i in ue)) {
                return false
              }
              if (Bt && !It[n] && I(wt, n));
              else if (St && I(_t, n));
              else if (!Et[n] || It[n]) {
                if (
                  (Me(e) &&
                    ((Tt.tagNameCheck instanceof RegExp &&
                      I(Tt.tagNameCheck, e)) ||
                      (Tt.tagNameCheck instanceof Function &&
                        Tt.tagNameCheck(e))) &&
                    ((Tt.attributeNameCheck instanceof RegExp &&
                      I(Tt.attributeNameCheck, n)) ||
                      (Tt.attributeNameCheck instanceof Function &&
                        Tt.attributeNameCheck(n)))) ||
                  (n === 'is' &&
                    Tt.allowCustomizedBuiltInElements &&
                    ((Tt.tagNameCheck instanceof RegExp &&
                      I(Tt.tagNameCheck, i)) ||
                      (Tt.tagNameCheck instanceof Function &&
                        Tt.tagNameCheck(i))))
                );
                else {
                  return false
                }
              } else if (Zt[n]);
              else if (I(Ct, D(i, vt, '')));
              else if (
                (n === 'src' || n === 'xlink:href' || n === 'href') &&
                e !== 'script' &&
                T(i, 'data:') === 0 &&
                Kt[e]
              );
              else if (Nt && !I(At, D(i, vt, '')));
              else if (!i);
              else {
                return false
              }
              return true
            }
            var Me = function t(e) {
              return e.indexOf('-') > 0
            }
            var Ie = function e(i) {
              var o
              var r
              var s
              var a
              Ee('beforeSanitizeAttributes', i, null)
              var c = i.attributes
              if (!c) {
                return
              }
              var l = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: Et
              }
              a = c.length
              while (a--) {
                o = c[a]
                var d = o,
                  u = d.name,
                  h = d.namespaceURI
                r = u === 'value' ? o.value : M(o.value)
                s = le(u)
                l.attrName = s
                l.attrValue = r
                l.keepAttr = true
                l.forceKeepAttr = undefined
                Ee('uponSanitizeAttribute', i, l)
                r = l.attrValue
                if (l.forceKeepAttr) {
                  continue
                }
                Ae(u, i)
                if (!l.keepAttr) {
                  continue
                }
                if (I(/\/>/i, r)) {
                  Ae(u, i)
                  continue
                }
                if (Pt) {
                  r = D(r, pt, ' ')
                  r = D(r, bt, ' ')
                  r = D(r, kt, ' ')
                }
                var f = le(i.nodeName)
                if (!Te(f, s, r)) {
                  continue
                }
                if (Ht && (s === 'id' || s === 'name')) {
                  Ae(u, i)
                  r = Ut + r
                }
                if (
                  st &&
                  t(p) === 'object' &&
                  typeof p.getAttributeType === 'function'
                ) {
                  if (h);
                  else {
                    switch (p.getAttributeType(f, s)) {
                      case 'TrustedHTML':
                        r = st.createHTML(r)
                        break
                      case 'TrustedScriptURL':
                        r = st.createScriptURL(r)
                        break
                    }
                  }
                }
                try {
                  if (h) {
                    i.setAttributeNS(h, u, r)
                  } else {
                    i.setAttribute(u, r)
                  }
                  v(n.removed)
                } catch (t) {}
              }
              Ee('afterSanitizeAttributes', i, null)
            }
            var Se = function t(e) {
              var n
              var i = Ce(e)
              Ee('beforeSanitizeShadowDOM', e, null)
              while ((n = i.nextNode())) {
                Ee('uponSanitizeShadowNode', n, null)
                if (De(n)) {
                  continue
                }
                if (n.content instanceof s) {
                  t(n.content)
                }
                Ie(n)
              }
              Ee('afterSanitizeShadowDOM', e, null)
            }
            n.sanitize = function (o) {
              var r =
                arguments.length > 1 && arguments[1] !== undefined
                  ? arguments[1]
                  : {}
              var a
              var l
              var d
              var u
              var h
              ie = !o
              if (ie) {
                o = '\x3c!--\x3e'
              }
              if (typeof o !== 'string' && !xe(o)) {
                if (typeof o.toString !== 'function') {
                  throw S('toString is not a function')
                } else {
                  o = o.toString()
                  if (typeof o !== 'string') {
                    throw S('dirty is not a string, aborting')
                  }
                }
              }
              if (!n.isSupported) {
                if (
                  t(e.toStaticHTML) === 'object' ||
                  typeof e.toStaticHTML === 'function'
                ) {
                  if (typeof o === 'string') {
                    return e.toStaticHTML(o)
                  }
                  if (xe(o)) {
                    return e.toStaticHTML(o.outerHTML)
                  }
                }
                return o
              }
              if (!Lt) {
                fe(r)
              }
              n.removed = []
              if (typeof o === 'string') {
                qt = false
              }
              if (qt) {
                if (o.nodeName) {
                  var f = le(o.nodeName)
                  if (!yt[f] || Mt[f]) {
                    throw S(
                      'root node is forbidden and cannot be sanitized in-place'
                    )
                  }
                }
              } else if (o instanceof c) {
                a = ve('\x3c!----\x3e')
                l = a.ownerDocument.importNode(o, true)
                if (l.nodeType === 1 && l.nodeName === 'BODY') {
                  a = l
                } else if (l.nodeName === 'HTML') {
                  a = l
                } else {
                  a.appendChild(l)
                }
              } else {
                if (!Rt && !Pt && !zt && o.indexOf('<') === -1) {
                  return st && Ft ? st.createHTML(o) : o
                }
                a = ve(o)
                if (!a) {
                  return Rt ? null : Ft ? at : ''
                }
              }
              if (a && Ot) {
                _e(a.firstChild)
              }
              var m = Ce(qt ? o : a)
              while ((d = m.nextNode())) {
                if (d.nodeType === 3 && d === u) {
                  continue
                }
                if (De(d)) {
                  continue
                }
                if (d.content instanceof s) {
                  Se(d.content)
                }
                Ie(d)
                u = d
              }
              u = null
              if (qt) {
                return o
              }
              if (Rt) {
                if (jt) {
                  h = ut.call(a.ownerDocument)
                  while (a.firstChild) {
                    h.appendChild(a.firstChild)
                  }
                } else {
                  h = a
                }
                if (Et.shadowroot) {
                  h = ft.call(i, h, true)
                }
                return h
              }
              var g = zt ? a.outerHTML : a.innerHTML
              if (
                zt &&
                yt['!doctype'] &&
                a.ownerDocument &&
                a.ownerDocument.doctype &&
                a.ownerDocument.doctype.name &&
                I(nt, a.ownerDocument.doctype.name)
              ) {
                g = '<!DOCTYPE ' + a.ownerDocument.doctype.name + '>\n' + g
              }
              if (Pt) {
                g = D(g, pt, ' ')
                g = D(g, bt, ' ')
                g = D(g, kt, ' ')
              }
              return st && Ft ? st.createHTML(g) : g
            }
            n.setConfig = function (t) {
              fe(t)
              Lt = true
            }
            n.clearConfig = function () {
              de = null
              Lt = false
            }
            n.isValidAttribute = function (t, e, n) {
              if (!de) {
                fe({})
              }
              var i = le(t)
              var o = le(e)
              return Te(i, o, n)
            }
            n.addHook = function (t, e) {
              if (typeof e !== 'function') {
                return
              }
              gt[t] = gt[t] || []
              C(gt[t], e)
            }
            n.removeHook = function (t) {
              if (gt[t]) {
                return v(gt[t])
              }
            }
            n.removeHooks = function (t) {
              if (gt[t]) {
                gt[t] = []
              }
            }
            n.removeAllHooks = function () {
              gt = {}
            }
            return n
          }
          var st = rt()
          return st
        })
      },
      3379: (t, e, n) => {
        'use strict'
        var i = (function t() {
          var e
          return function t() {
            if (typeof e === 'undefined') {
              e = Boolean(window && document && document.all && !window.atob)
            }
            return e
          }
        })()
        var o = (function t() {
          var e = {}
          return function t(n) {
            if (typeof e[n] === 'undefined') {
              var i = document.querySelector(n)
              if (
                window.HTMLIFrameElement &&
                i instanceof window.HTMLIFrameElement
              ) {
                try {
                  i = i.contentDocument.head
                } catch (t) {
                  i = null
                }
              }
              e[n] = i
            }
            return e[n]
          }
        })()
        var r = []
        function s(t) {
          var e = -1
          for (var n = 0; n < r.length; n++) {
            if (r[n].identifier === t) {
              e = n
              break
            }
          }
          return e
        }
        function a(t, e) {
          var n = {}
          var i = []
          for (var o = 0; o < t.length; o++) {
            var a = t[o]
            var c = e.base ? a[0] + e.base : a[0]
            var l = n[c] || 0
            var d = ''.concat(c, ' ').concat(l)
            n[c] = l + 1
            var u = s(d)
            var h = { css: a[1], media: a[2], sourceMap: a[3] }
            if (u !== -1) {
              r[u].references++
              r[u].updater(h)
            } else {
              r.push({ identifier: d, updater: g(h, e), references: 1 })
            }
            i.push(d)
          }
          return i
        }
        function c(t) {
          var e = document.createElement('style')
          var i = t.attributes || {}
          if (typeof i.nonce === 'undefined') {
            var r = true ? n.nc : 0
            if (r) {
              i.nonce = r
            }
          }
          Object.keys(i).forEach(function (t) {
            e.setAttribute(t, i[t])
          })
          if (typeof t.insert === 'function') {
            t.insert(e)
          } else {
            var s = o(t.insert || 'head')
            if (!s) {
              throw new Error(
                "Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."
              )
            }
            s.appendChild(e)
          }
          return e
        }
        function l(t) {
          if (t.parentNode === null) {
            return false
          }
          t.parentNode.removeChild(t)
        }
        var d = (function t() {
          var e = []
          return function t(n, i) {
            e[n] = i
            return e.filter(Boolean).join('\n')
          }
        })()
        function u(t, e, n, i) {
          var o = n
            ? ''
            : i.media
            ? '@media '.concat(i.media, ' {').concat(i.css, '}')
            : i.css
          if (t.styleSheet) {
            t.styleSheet.cssText = d(e, o)
          } else {
            var r = document.createTextNode(o)
            var s = t.childNodes
            if (s[e]) {
              t.removeChild(s[e])
            }
            if (s.length) {
              t.insertBefore(r, s[e])
            } else {
              t.appendChild(r)
            }
          }
        }
        function h(t, e, n) {
          var i = n.css
          var o = n.media
          var r = n.sourceMap
          if (o) {
            t.setAttribute('media', o)
          } else {
            t.removeAttribute('media')
          }
          if (r && typeof btoa !== 'undefined') {
            i += '\n/*# sourceMappingURL=data:application/json;base64,'.concat(
              btoa(unescape(encodeURIComponent(JSON.stringify(r)))),
              ' */'
            )
          }
          if (t.styleSheet) {
            t.styleSheet.cssText = i
          } else {
            while (t.firstChild) {
              t.removeChild(t.firstChild)
            }
            t.appendChild(document.createTextNode(i))
          }
        }
        var f = null
        var m = 0
        function g(t, e) {
          var n
          var i
          var o
          if (e.singleton) {
            var r = m++
            n = f || (f = c(e))
            i = u.bind(null, n, r, false)
            o = u.bind(null, n, r, true)
          } else {
            n = c(e)
            i = h.bind(null, n, e)
            o = function t() {
              l(n)
            }
          }
          i(t)
          return function e(n) {
            if (n) {
              if (
                n.css === t.css &&
                n.media === t.media &&
                n.sourceMap === t.sourceMap
              ) {
                return
              }
              i((t = n))
            } else {
              o()
            }
          }
        }
        t.exports = function (t, e) {
          e = e || {}
          if (!e.singleton && typeof e.singleton !== 'boolean') {
            e.singleton = i()
          }
          t = t || []
          var n = a(t, e)
          return function t(i) {
            i = i || []
            if (Object.prototype.toString.call(i) !== '[object Array]') {
              return
            }
            for (var o = 0; o < n.length; o++) {
              var c = n[o]
              var l = s(c)
              r[l].references--
            }
            var d = a(i, e)
            for (var u = 0; u < n.length; u++) {
              var h = n[u]
              var f = s(h)
              if (r[f].references === 0) {
                r[f].updater()
                r.splice(f, 1)
              }
            }
            n = d
          }
        }
      }
    }
    var __webpack_module_cache__ = {}
    function __webpack_require__(t) {
      var e = __webpack_module_cache__[t]
      if (e !== undefined) {
        return e.exports
      }
      var n = (__webpack_module_cache__[t] = { id: t, exports: {} })
      __webpack_modules__[t].call(n.exports, n, n.exports, __webpack_require__)
      return n.exports
    }
    ;(() => {
      __webpack_require__.n = (t) => {
        var e = t && t.__esModule ? () => t['default'] : () => t
        __webpack_require__.d(e, { a: e })
        return e
      }
    })()
    ;(() => {
      __webpack_require__.d = (t, e) => {
        for (var n in e) {
          if (__webpack_require__.o(e, n) && !__webpack_require__.o(t, n)) {
            Object.defineProperty(t, n, { enumerable: true, get: e[n] })
          }
        }
      }
    })()
    ;(() => {
      __webpack_require__.g = (function () {
        if (typeof globalThis === 'object') return globalThis
        try {
          return this || new Function('return this')()
        } catch (t) {
          if (typeof window === 'object') return window
        }
      })()
    })()
    ;(() => {
      __webpack_require__.o = (t, e) =>
        Object.prototype.hasOwnProperty.call(t, e)
    })()
    ;(() => {
      __webpack_require__.nc = undefined
    })()
    var __webpack_exports__ = {}
    ;(() => {
      'use strict'
      __webpack_require__.d(__webpack_exports__, { default: () => kF })
      function t({
        emitter: t,
        activator: e,
        callback: n,
        contextElements: i
      }) {
        t.listenTo(document, 'mousedown', (t, o) => {
          if (!e()) {
            return
          }
          const r = typeof o.composedPath == 'function' ? o.composedPath() : []
          const s = typeof i == 'function' ? i() : i
          for (const t of s) {
            if (t.contains(o.target) || r.includes(t)) {
              return
            }
          }
          n()
        })
      }
      function e(t) {
        const e = t
        e.set('_isCssTransitionsDisabled', false)
        e.disableCssTransitions = () => {
          e._isCssTransitionsDisabled = true
        }
        e.enableCssTransitions = () => {
          e._isCssTransitionsDisabled = false
        }
        e.extendTemplate({
          attributes: {
            class: [
              e.bindTemplate.if(
                '_isCssTransitionsDisabled',
                'ck-transitions-disabled'
              )
            ]
          }
        })
      }
      function n({ view: t }) {
        t.listenTo(
          t.element,
          'submit',
          (e, n) => {
            n.preventDefault()
            t.fire('submit')
          },
          { useCapture: true }
        )
      }
      function i({
        keystrokeHandler: t,
        focusTracker: e,
        gridItems: n,
        numberOfColumns: i,
        uiLanguageDirection: o
      }) {
        const r = typeof i === 'number' ? () => i : i
        t.set(
          'arrowright',
          s((t, e) => (o === 'rtl' ? c(t, e.length) : a(t, e.length)))
        )
        t.set(
          'arrowleft',
          s((t, e) => (o === 'rtl' ? a(t, e.length) : c(t, e.length)))
        )
        t.set(
          'arrowup',
          s((t, e) => {
            let n = t - r()
            if (n < 0) {
              n = t + r() * Math.floor(e.length / r())
              if (n > e.length - 1) {
                n -= r()
              }
            }
            return n
          })
        )
        t.set(
          'arrowdown',
          s((t, e) => {
            let n = t + r()
            if (n > e.length - 1) {
              n = t % r()
            }
            return n
          })
        )
        function s(t) {
          return (i) => {
            const o = n.find((t) => t.element === e.focusedElement)
            const r = n.getIndex(o)
            const s = t(r, n)
            n.get(s).focus()
            i.stopPropagation()
            i.preventDefault()
          }
        }
        function a(t, e) {
          if (t === e - 1) {
            return 0
          } else {
            return t + 1
          }
        }
        function c(t, e) {
          if (t === 0) {
            return e - 1
          } else {
            return t - 1
          }
        }
      }
      function o() {
        try {
          return navigator.userAgent.toLowerCase()
        } catch (t) {
          return ''
        }
      }
      const r = o()
      const s = {
        isMac: c(r),
        isWindows: l(r),
        isGecko: d(r),
        isSafari: u(r),
        isiOS: h(r),
        isAndroid: f(r),
        isBlink: m(r),
        features: { isRegExpUnicodePropertySupported: g() }
      }
      const a = s
      function c(t) {
        return t.indexOf('macintosh') > -1
      }
      function l(t) {
        return t.indexOf('windows') > -1
      }
      function d(t) {
        return !!t.match(/gecko\/\d+/)
      }
      function u(t) {
        return t.indexOf(' applewebkit/') > -1 && t.indexOf('chrome') === -1
      }
      function h(t) {
        return (
          !!t.match(/iphone|ipad/i) || (c(t) && navigator.maxTouchPoints > 0)
        )
      }
      function f(t) {
        return t.indexOf('android') > -1
      }
      function m(t) {
        return t.indexOf('chrome/') > -1 && t.indexOf('edge/') < 0
      }
      function g() {
        let t = false
        try {
          t = 'ć'.search(new RegExp('[\\p{L}]', 'u')) === 0
        } catch (t) {}
        return t
      }
      function p(t, e, n, i) {
        n =
          n ||
          function (t, e) {
            return t === e
          }
        const o = Array.isArray(t) ? t : Array.prototype.slice.call(t)
        const r = Array.isArray(e) ? e : Array.prototype.slice.call(e)
        const s = b(o, r, n)
        const a = i ? A(s, r.length) : _(r, s)
        return a
      }
      function b(t, e, n) {
        const i = k(t, e, n)
        if (i === -1) {
          return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 }
        }
        const o = w(t, i)
        const r = w(e, i)
        const s = k(o, r, n)
        const a = t.length - s
        const c = e.length - s
        return { firstIndex: i, lastIndexOld: a, lastIndexNew: c }
      }
      function k(t, e, n) {
        for (let i = 0; i < Math.max(t.length, e.length); i++) {
          if (t[i] === undefined || e[i] === undefined || !n(t[i], e[i])) {
            return i
          }
        }
        return -1
      }
      function w(t, e) {
        return t.slice(e).reverse()
      }
      function _(t, e) {
        const n = []
        const { firstIndex: i, lastIndexOld: o, lastIndexNew: r } = e
        if (r - i > 0) {
          n.push({ index: i, type: 'insert', values: t.slice(i, r) })
        }
        if (o - i > 0) {
          n.push({ index: i + (r - i), type: 'delete', howMany: o - i })
        }
        return n
      }
      function A(t, e) {
        const { firstIndex: n, lastIndexOld: i, lastIndexNew: o } = t
        if (n === -1) {
          return Array(e).fill('equal')
        }
        let r = []
        if (n > 0) {
          r = r.concat(Array(n).fill('equal'))
        }
        if (o - n > 0) {
          r = r.concat(Array(o - n).fill('insert'))
        }
        if (i - n > 0) {
          r = r.concat(Array(i - n).fill('delete'))
        }
        if (o < e) {
          r = r.concat(Array(e - o).fill('equal'))
        }
        return r
      }
      function v(t, e, n) {
        n =
          n ||
          function (t, e) {
            return t === e
          }
        const i = t.length
        const o = e.length
        if (i > 200 || o > 200 || i + o > 300) {
          return v.fastDiff(t, e, n, true)
        }
        let r, s
        if (o < i) {
          const n = t
          t = e
          e = n
          r = 'delete'
          s = 'insert'
        } else {
          r = 'insert'
          s = 'delete'
        }
        const a = t.length
        const c = e.length
        const l = c - a
        const d = {}
        const u = {}
        function h(i) {
          const o = (u[i - 1] !== undefined ? u[i - 1] : -1) + 1
          const l = u[i + 1] !== undefined ? u[i + 1] : -1
          const h = o > l ? -1 : 1
          if (d[i + h]) {
            d[i] = d[i + h].slice(0)
          }
          if (!d[i]) {
            d[i] = []
          }
          d[i].push(o > l ? r : s)
          let f = Math.max(o, l)
          let m = f - i
          while (m < a && f < c && n(t[m], e[f])) {
            m++
            f++
            d[i].push('equal')
          }
          return f
        }
        let f = 0
        let m
        do {
          for (m = -f; m < l; m++) {
            u[m] = h(m)
          }
          for (m = l + f; m > l; m--) {
            u[m] = h(m)
          }
          u[l] = h(l)
          f++
        } while (u[l] !== c)
        return d[l].slice(1)
      }
      v.fastDiff = p
      function C(t, ...e) {
        e.forEach((e) => {
          const n = Object.getOwnPropertyNames(e)
          const i = Object.getOwnPropertySymbols(e)
          n.concat(i).forEach((n) => {
            if (n in t.prototype) {
              return
            }
            if (
              typeof e == 'function' &&
              (n == 'length' || n == 'name' || n == 'prototype')
            ) {
              return
            }
            const i = Object.getOwnPropertyDescriptor(e, n)
            i.enumerable = false
            Object.defineProperty(t.prototype, n, i)
          })
        })
      }
      function y() {
        return function t() {
          t.called = true
        }
      }
      const x = y
      class E {
        constructor(t, e) {
          this.source = t
          this.name = e
          this.path = []
          this.stop = x()
          this.off = x()
        }
      }
      const D = new Array(256)
        .fill('')
        .map((t, e) => ('0' + e.toString(16)).slice(-2))
      function T() {
        const t = (Math.random() * 4294967296) >>> 0
        const e = (Math.random() * 4294967296) >>> 0
        const n = (Math.random() * 4294967296) >>> 0
        const i = (Math.random() * 4294967296) >>> 0
        return (
          'e' +
          D[(t >> 0) & 255] +
          D[(t >> 8) & 255] +
          D[(t >> 16) & 255] +
          D[(t >> 24) & 255] +
          D[(e >> 0) & 255] +
          D[(e >> 8) & 255] +
          D[(e >> 16) & 255] +
          D[(e >> 24) & 255] +
          D[(n >> 0) & 255] +
          D[(n >> 8) & 255] +
          D[(n >> 16) & 255] +
          D[(n >> 24) & 255] +
          D[(i >> 0) & 255] +
          D[(i >> 8) & 255] +
          D[(i >> 16) & 255] +
          D[(i >> 24) & 255]
        )
      }
      const M = {
        get(t = 'normal') {
          if (typeof t != 'number') {
            return this[t] || this.normal
          } else {
            return t
          }
        },
        highest: 1e5,
        high: 1e3,
        normal: 0,
        low: -1e3,
        lowest: -1e5
      }
      const I = M
      function S(t, e) {
        const n = I.get(e.priority)
        for (let i = 0; i < t.length; i++) {
          if (I.get(t[i].priority) < n) {
            t.splice(i, 0, e)
            return
          }
        }
        t.push(e)
      }
      const B =
        'https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html'
      class N extends Error {
        constructor(t, e, n) {
          super(O(t, n))
          this.name = 'CKEditorError'
          this.context = e
          this.data = n
        }
        is(t) {
          return t === 'CKEditorError'
        }
        static rethrowUnexpectedError(t, e) {
          if (t.is && t.is('CKEditorError')) {
            throw t
          }
          const n = new N(t.message, e)
          n.stack = t.stack
          throw n
        }
      }
      function P(t, e) {
        console.warn(...R(t, e))
      }
      function z(t, e) {
        console.error(...R(t, e))
      }
      function L(t) {
        return `\nRead more: ${B}#error-${t}`
      }
      function O(t, e) {
        const n = new WeakSet()
        const i = (t, e) => {
          if (typeof e === 'object' && e !== null) {
            if (n.has(e)) {
              return `[object ${e.constructor.name}]`
            }
            n.add(e)
          }
          return e
        }
        const o = e ? ` ${JSON.stringify(e, i)}` : ''
        const r = L(t)
        return t + o + r
      }
      function R(t, e) {
        const n = L(t)
        return e ? [t, e, n] : [t, n]
      }
      const j = '36.0.0'
      const F = null && j
      const V = typeof window === 'object' ? window : __webpack_require__.g
      if (V.CKEDITOR_VERSION) {
        throw new N('ckeditor-duplicated-modules', null)
      } else {
        V.CKEDITOR_VERSION = j
      }
      const H = Symbol('listeningTo')
      const U = Symbol('emitterId')
      const W = Symbol('delegations')
      const q = $(Object)
      function $(t) {
        if (!t) {
          return q
        }
        class e extends t {
          on(t, e, n) {
            this.listenTo(this, t, e, n)
          }
          once(t, e, n) {
            let i = false
            const o = (t, ...n) => {
              if (!i) {
                i = true
                t.off()
                e.call(this, t, ...n)
              }
            }
            this.listenTo(this, t, o, n)
          }
          off(t, e) {
            this.stopListening(this, t, e)
          }
          listenTo(t, e, n, i = {}) {
            let o, r
            if (!this[H]) {
              this[H] = {}
            }
            const s = this[H]
            if (!K(t)) {
              Y(t)
            }
            const a = K(t)
            if (!(o = s[a])) {
              o = s[a] = { emitter: t, callbacks: {} }
            }
            if (!(r = o.callbacks[e])) {
              r = o.callbacks[e] = []
            }
            r.push(n)
            nt(this, t, e, n, i)
          }
          stopListening(t, e, n) {
            const i = this[H]
            let o = t && K(t)
            const r = i && o ? i[o] : undefined
            const s = r && e ? r.callbacks[e] : undefined
            if (!i || (t && !r) || (e && !s)) {
              return
            }
            if (n) {
              it(this, t, e, n)
              const i = s.indexOf(n)
              if (i !== -1) {
                if (s.length === 1) {
                  delete r.callbacks[e]
                } else {
                  it(this, t, e, n)
                }
              }
            } else if (s) {
              while ((n = s.pop())) {
                it(this, t, e, n)
              }
              delete r.callbacks[e]
            } else if (r) {
              for (e in r.callbacks) {
                this.stopListening(t, e)
              }
              delete i[o]
            } else {
              for (o in i) {
                this.stopListening(i[o].emitter)
              }
              delete this[H]
            }
          }
          fire(t, ...e) {
            try {
              const n = t instanceof E ? t : new E(this, t)
              const i = n.name
              let o = tt(this, i)
              n.path.push(this)
              if (o) {
                const t = [n, ...e]
                o = Array.from(o)
                for (let e = 0; e < o.length; e++) {
                  o[e].callback.apply(this, t)
                  if (n.off.called) {
                    delete n.off.called
                    this._removeEventListener(i, o[e].callback)
                  }
                  if (n.stop.called) {
                    break
                  }
                }
              }
              const r = this[W]
              if (r) {
                const t = r.get(i)
                const o = r.get('*')
                if (t) {
                  et(t, n, e)
                }
                if (o) {
                  et(o, n, e)
                }
              }
              return n.return
            } catch (t) {
              N.rethrowUnexpectedError(t, this)
            }
          }
          delegate(...t) {
            return {
              to: (e, n) => {
                if (!this[W]) {
                  this[W] = new Map()
                }
                t.forEach((t) => {
                  const i = this[W].get(t)
                  if (!i) {
                    this[W].set(t, new Map([[e, n]]))
                  } else {
                    i.set(e, n)
                  }
                })
              }
            }
          }
          stopDelegating(t, e) {
            if (!this[W]) {
              return
            }
            if (!t) {
              this[W].clear()
            } else if (!e) {
              this[W].delete(t)
            } else {
              const n = this[W].get(t)
              if (n) {
                n.delete(e)
              }
            }
          }
          _addEventListener(t, e, n) {
            J(this, t)
            const i = X(this, t)
            const o = I.get(n.priority)
            const r = { callback: e, priority: o }
            for (const t of i) {
              S(t, r)
            }
          }
          _removeEventListener(t, e) {
            const n = X(this, t)
            for (const t of n) {
              for (let n = 0; n < t.length; n++) {
                if (t[n].callback == e) {
                  t.splice(n, 1)
                  n--
                }
              }
            }
          }
        }
        return e
      }
      ;[
        'on',
        'once',
        'off',
        'listenTo',
        'stopListening',
        'fire',
        'delegate',
        'stopDelegating',
        '_addEventListener',
        '_removeEventListener'
      ].forEach((t) => {
        $[t] = q.prototype[t]
      })
      function G(t, e) {
        const n = t[H]
        if (n && n[e]) {
          return n[e].emitter
        }
        return null
      }
      function Y(t, e) {
        if (!t[U]) {
          t[U] = e || T()
        }
      }
      function K(t) {
        return t[U]
      }
      function Q(t) {
        if (!t._events) {
          Object.defineProperty(t, '_events', { value: {} })
        }
        return t._events
      }
      function Z() {
        return { callbacks: [], childEvents: [] }
      }
      function J(t, e) {
        const n = Q(t)
        if (n[e]) {
          return
        }
        let i = e
        let o = null
        const r = []
        while (i !== '') {
          if (n[i]) {
            break
          }
          n[i] = Z()
          r.push(n[i])
          if (o) {
            n[i].childEvents.push(o)
          }
          o = i
          i = i.substr(0, i.lastIndexOf(':'))
        }
        if (i !== '') {
          for (const t of r) {
            t.callbacks = n[i].callbacks.slice()
          }
          n[i].childEvents.push(o)
        }
      }
      function X(t, e) {
        const n = Q(t)[e]
        if (!n) {
          return []
        }
        let i = [n.callbacks]
        for (let e = 0; e < n.childEvents.length; e++) {
          const o = X(t, n.childEvents[e])
          i = i.concat(o)
        }
        return i
      }
      function tt(t, e) {
        let n
        if (!t._events || !(n = t._events[e]) || !n.callbacks.length) {
          if (e.indexOf(':') > -1) {
            return tt(t, e.substr(0, e.lastIndexOf(':')))
          } else {
            return null
          }
        }
        return n.callbacks
      }
      function et(t, e, n) {
        for (let [i, o] of t) {
          if (!o) {
            o = e.name
          } else if (typeof o == 'function') {
            o = o(e.name)
          }
          const t = new E(e.source, o)
          t.path = [...e.path]
          i.fire(t, ...n)
        }
      }
      function nt(t, e, n, i, o) {
        if (e._addEventListener) {
          e._addEventListener(n, i, o)
        } else {
          t._addEventListener.call(e, n, i, o)
        }
      }
      function it(t, e, n, i) {
        if (e._removeEventListener) {
          e._removeEventListener(n, i)
        } else {
          t._removeEventListener.call(e, n, i)
        }
      }
      function ot(t) {
        var e = typeof t
        return t != null && (e == 'object' || e == 'function')
      }
      const rt = ot
      const st = Symbol('observableProperties')
      const at = Symbol('boundObservables')
      const ct = Symbol('boundProperties')
      const lt = Symbol('decoratedMethods')
      const dt = Symbol('decoratedOriginal')
      const ut = ht($())
      function ht(t) {
        if (!t) {
          return ut
        }
        class e extends t {
          set(t, e) {
            if (rt(t)) {
              Object.keys(t).forEach((e) => {
                this.set(e, t[e])
              }, this)
              return
            }
            ft(this)
            const n = this[st]
            if (t in this && !n.has(t)) {
              throw new N('observable-set-cannot-override', this)
            }
            Object.defineProperty(this, t, {
              enumerable: true,
              configurable: true,
              get() {
                return n.get(t)
              },
              set(e) {
                const i = n.get(t)
                let o = this.fire(`set:${t}`, t, e, i)
                if (o === undefined) {
                  o = e
                }
                if (i !== o || !n.has(t)) {
                  n.set(t, o)
                  this.fire(`change:${t}`, t, o, i)
                }
              }
            })
            this[t] = e
          }
          bind(...t) {
            if (!t.length || !bt(t)) {
              throw new N('observable-bind-wrong-properties', this)
            }
            if (new Set(t).size !== t.length) {
              throw new N('observable-bind-duplicate-properties', this)
            }
            ft(this)
            const e = this[ct]
            t.forEach((t) => {
              if (e.has(t)) {
                throw new N('observable-bind-rebind', this)
              }
            })
            const n = new Map()
            t.forEach((t) => {
              const i = { property: t, to: [] }
              e.set(t, i)
              n.set(t, i)
            })
            return {
              to: mt,
              toMany: gt,
              _observable: this,
              _bindProperties: t,
              _to: [],
              _bindings: n
            }
          }
          unbind(...t) {
            if (!this[st]) {
              return
            }
            const e = this[ct]
            const n = this[at]
            if (t.length) {
              if (!bt(t)) {
                throw new N('observable-unbind-wrong-properties', this)
              }
              t.forEach((t) => {
                const i = e.get(t)
                if (!i) {
                  return
                }
                i.to.forEach(([t, e]) => {
                  const o = n.get(t)
                  const r = o[e]
                  r.delete(i)
                  if (!r.size) {
                    delete o[e]
                  }
                  if (!Object.keys(o).length) {
                    n.delete(t)
                    this.stopListening(t, 'change')
                  }
                })
                e.delete(t)
              })
            } else {
              n.forEach((t, e) => {
                this.stopListening(e, 'change')
              })
              n.clear()
              e.clear()
            }
          }
          decorate(t) {
            ft(this)
            const e = this[t]
            if (!e) {
              throw new N('observablemixin-cannot-decorate-undefined', this, {
                object: this,
                methodName: t
              })
            }
            this.on(t, (t, n) => {
              t.return = e.apply(this, n)
            })
            this[t] = function (...e) {
              return this.fire(t, e)
            }
            this[t][dt] = e
            if (!this[lt]) {
              this[lt] = []
            }
            this[lt].push(t)
          }
          stopListening(t, e, n) {
            if (!t && this[lt]) {
              for (const t of this[lt]) {
                this[t] = this[t][dt]
              }
              delete this[lt]
            }
            super.stopListening(t, e, n)
          }
        }
        return e
      }
      ;[
        'set',
        'bind',
        'unbind',
        'decorate',
        'on',
        'once',
        'off',
        'listenTo',
        'stopListening',
        'fire',
        'delegate',
        'stopDelegating',
        '_addEventListener',
        '_removeEventListener'
      ].forEach((t) => {
        ht[t] = ut.prototype[t]
      })
      function ft(t) {
        if (t[st]) {
          return
        }
        Object.defineProperty(t, st, { value: new Map() })
        Object.defineProperty(t, at, { value: new Map() })
        Object.defineProperty(t, ct, { value: new Map() })
      }
      function mt(...t) {
        const e = kt(...t)
        const n = Array.from(this._bindings.keys())
        const i = n.length
        if (!e.callback && e.to.length > 1) {
          throw new N('observable-bind-to-no-callback', this)
        }
        if (i > 1 && e.callback) {
          throw new N('observable-bind-to-extra-callback', this)
        }
        e.to.forEach((t) => {
          if (t.properties.length && t.properties.length !== i) {
            throw new N('observable-bind-to-properties-length', this)
          }
          if (!t.properties.length) {
            t.properties = this._bindProperties
          }
        })
        this._to = e.to
        if (e.callback) {
          this._bindings.get(n[0]).callback = e.callback
        }
        vt(this._observable, this._to)
        _t(this)
        this._bindProperties.forEach((t) => {
          At(this._observable, t)
        })
      }
      function gt(t, e, n) {
        if (this._bindings.size > 1) {
          throw new N('observable-bind-to-many-not-one-binding', this)
        }
        this.to(...pt(t, e), n)
      }
      function pt(t, e) {
        const n = t.map((t) => [t, e])
        return Array.prototype.concat.apply([], n)
      }
      function bt(t) {
        return t.every((t) => typeof t == 'string')
      }
      function kt(...t) {
        if (!t.length) {
          throw new N('observable-bind-to-parse-error', null)
        }
        const e = { to: [] }
        let n
        if (typeof t[t.length - 1] == 'function') {
          e.callback = t.pop()
        }
        t.forEach((t) => {
          if (typeof t == 'string') {
            n.properties.push(t)
          } else if (typeof t == 'object') {
            n = { observable: t, properties: [] }
            e.to.push(n)
          } else {
            throw new N('observable-bind-to-parse-error', null)
          }
        })
        return e
      }
      function wt(t, e, n, i) {
        const o = t[at]
        const r = o.get(n)
        const s = r || {}
        if (!s[i]) {
          s[i] = new Set()
        }
        s[i].add(e)
        if (!r) {
          o.set(n, s)
        }
      }
      function _t(t) {
        let e
        t._bindings.forEach((n, i) => {
          t._to.forEach((o) => {
            e = o.properties[n.callback ? 0 : t._bindProperties.indexOf(i)]
            n.to.push([o.observable, e])
            wt(t._observable, n, o.observable, e)
          })
        })
      }
      function At(t, e) {
        const n = t[ct]
        const i = n.get(e)
        let o
        if (i.callback) {
          o = i.callback.apply(
            t,
            i.to.map((t) => t[0][t[1]])
          )
        } else {
          o = i.to[0]
          o = o[0][o[1]]
        }
        if (Object.prototype.hasOwnProperty.call(t, e)) {
          t[e] = o
        } else {
          t.set(e, o)
        }
      }
      function vt(t, e) {
        e.forEach((e) => {
          const n = t[at]
          let i
          if (!n.get(e.observable)) {
            t.listenTo(e.observable, 'change', (o, r) => {
              i = n.get(e.observable)[r]
              if (i) {
                i.forEach((e) => {
                  At(t, e.property)
                })
              }
            })
          }
        })
      }
      class Ct {
        constructor() {
          this._replacedElements = []
        }
        replace(t, e) {
          this._replacedElements.push({ element: t, newElement: e })
          t.style.display = 'none'
          if (e) {
            t.parentNode.insertBefore(e, t.nextSibling)
          }
        }
        restore() {
          this._replacedElements.forEach(({ element: t, newElement: e }) => {
            t.style.display = ''
            if (e) {
              e.remove()
            }
          })
          this._replacedElements = []
        }
      }
      function yt(t) {
        let e = 0
        for (const n of t) {
          e++
        }
        return e
      }
      function xt(t, e) {
        const n = Math.min(t.length, e.length)
        for (let i = 0; i < n; i++) {
          if (t[i] != e[i]) {
            return i
          }
        }
        if (t.length == e.length) {
          return 'same'
        } else if (t.length < e.length) {
          return 'prefix'
        } else {
          return 'extension'
        }
      }
      function Et(t) {
        return !!(t && t[Symbol.iterator])
      }
      var Dt =
        typeof global == 'object' &&
        global &&
        global.Object === Object &&
        global
      const Tt = Dt
      var Mt = typeof self == 'object' && self && self.Object === Object && self
      var It = Tt || Mt || Function('return this')()
      const St = It
      var Bt = St.Symbol
      const Nt = Bt
      var Pt = Object.prototype
      var zt = Pt.hasOwnProperty
      var Lt = Pt.toString
      var Ot = Nt ? Nt.toStringTag : undefined
      function Rt(t) {
        var e = zt.call(t, Ot),
          n = t[Ot]
        try {
          t[Ot] = undefined
          var i = true
        } catch (t) {}
        var o = Lt.call(t)
        if (i) {
          if (e) {
            t[Ot] = n
          } else {
            delete t[Ot]
          }
        }
        return o
      }
      const jt = Rt
      var Ft = Object.prototype
      var Vt = Ft.toString
      function Ht(t) {
        return Vt.call(t)
      }
      const Ut = Ht
      var Wt = '[object Null]',
        qt = '[object Undefined]'
      var $t = Nt ? Nt.toStringTag : undefined
      function Gt(t) {
        if (t == null) {
          return t === undefined ? qt : Wt
        }
        return $t && $t in Object(t) ? jt(t) : Ut(t)
      }
      const Yt = Gt
      var Kt = Array.isArray
      const Qt = Kt
      function Zt(t) {
        return t != null && typeof t == 'object'
      }
      const Jt = Zt
      var Xt = '[object String]'
      function te(t) {
        return typeof t == 'string' || (!Qt(t) && Jt(t) && Yt(t) == Xt)
      }
      const ee = te
      function ne(t, e, n = {}, i = []) {
        const o = n && n.xmlns
        const r = o ? t.createElementNS(o, e) : t.createElement(e)
        for (const t in n) {
          r.setAttribute(t, n[t])
        }
        if (ee(i) || !Et(i)) {
          i = [i]
        }
        for (let e of i) {
          if (ee(e)) {
            e = t.createTextNode(e)
          }
          r.appendChild(e)
        }
        return r
      }
      function ie(t, e) {
        return function (n) {
          return t(e(n))
        }
      }
      const oe = ie
      var re = oe(Object.getPrototypeOf, Object)
      const se = re
      var ae = '[object Object]'
      var ce = Function.prototype,
        le = Object.prototype
      var de = ce.toString
      var ue = le.hasOwnProperty
      var he = de.call(Object)
      function fe(t) {
        if (!Jt(t) || Yt(t) != ae) {
          return false
        }
        var e = se(t)
        if (e === null) {
          return true
        }
        var n = ue.call(e, 'constructor') && e.constructor
        return typeof n == 'function' && n instanceof n && de.call(n) == he
      }
      const me = fe
      function ge() {
        this.__data__ = []
        this.size = 0
      }
      const pe = ge
      function be(t, e) {
        return t === e || (t !== t && e !== e)
      }
      const ke = be
      function we(t, e) {
        var n = t.length
        while (n--) {
          if (ke(t[n][0], e)) {
            return n
          }
        }
        return -1
      }
      const _e = we
      var Ae = Array.prototype
      var ve = Ae.splice
      function Ce(t) {
        var e = this.__data__,
          n = _e(e, t)
        if (n < 0) {
          return false
        }
        var i = e.length - 1
        if (n == i) {
          e.pop()
        } else {
          ve.call(e, n, 1)
        }
        --this.size
        return true
      }
      const ye = Ce
      function xe(t) {
        var e = this.__data__,
          n = _e(e, t)
        return n < 0 ? undefined : e[n][1]
      }
      const Ee = xe
      function De(t) {
        return _e(this.__data__, t) > -1
      }
      const Te = De
      function Me(t, e) {
        var n = this.__data__,
          i = _e(n, t)
        if (i < 0) {
          ++this.size
          n.push([t, e])
        } else {
          n[i][1] = e
        }
        return this
      }
      const Ie = Me
      function Se(t) {
        var e = -1,
          n = t == null ? 0 : t.length
        this.clear()
        while (++e < n) {
          var i = t[e]
          this.set(i[0], i[1])
        }
      }
      Se.prototype.clear = pe
      Se.prototype['delete'] = ye
      Se.prototype.get = Ee
      Se.prototype.has = Te
      Se.prototype.set = Ie
      const Be = Se
      function Ne() {
        this.__data__ = new Be()
        this.size = 0
      }
      const Pe = Ne
      function ze(t) {
        var e = this.__data__,
          n = e['delete'](t)
        this.size = e.size
        return n
      }
      const Le = ze
      function Oe(t) {
        return this.__data__.get(t)
      }
      const Re = Oe
      function je(t) {
        return this.__data__.has(t)
      }
      const Fe = je
      var Ve = '[object AsyncFunction]',
        He = '[object Function]',
        Ue = '[object GeneratorFunction]',
        We = '[object Proxy]'
      function qe(t) {
        if (!rt(t)) {
          return false
        }
        var e = Yt(t)
        return e == He || e == Ue || e == Ve || e == We
      }
      const $e = qe
      var Ge = St['__core-js_shared__']
      const Ye = Ge
      var Ke = (function () {
        var t = /[^.]+$/.exec((Ye && Ye.keys && Ye.keys.IE_PROTO) || '')
        return t ? 'Symbol(src)_1.' + t : ''
      })()
      function Qe(t) {
        return !!Ke && Ke in t
      }
      const Ze = Qe
      var Je = Function.prototype
      var Xe = Je.toString
      function tn(t) {
        if (t != null) {
          try {
            return Xe.call(t)
          } catch (t) {}
          try {
            return t + ''
          } catch (t) {}
        }
        return ''
      }
      const en = tn
      var nn = /[\\^$.*+?()[\]{}|]/g
      var on = /^\[object .+?Constructor\]$/
      var rn = Function.prototype,
        sn = Object.prototype
      var an = rn.toString
      var cn = sn.hasOwnProperty
      var ln = RegExp(
        '^' +
          an
            .call(cn)
            .replace(nn, '\\$&')
            .replace(
              /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
              '$1.*?'
            ) +
          '$'
      )
      function dn(t) {
        if (!rt(t) || Ze(t)) {
          return false
        }
        var e = $e(t) ? ln : on
        return e.test(en(t))
      }
      const un = dn
      function hn(t, e) {
        return t == null ? undefined : t[e]
      }
      const fn = hn
      function mn(t, e) {
        var n = fn(t, e)
        return un(n) ? n : undefined
      }
      const gn = mn
      var pn = gn(St, 'Map')
      const bn = pn
      var kn = gn(Object, 'create')
      const wn = kn
      function _n() {
        this.__data__ = wn ? wn(null) : {}
        this.size = 0
      }
      const An = _n
      function vn(t) {
        var e = this.has(t) && delete this.__data__[t]
        this.size -= e ? 1 : 0
        return e
      }
      const Cn = vn
      var yn = '__lodash_hash_undefined__'
      var xn = Object.prototype
      var En = xn.hasOwnProperty
      function Dn(t) {
        var e = this.__data__
        if (wn) {
          var n = e[t]
          return n === yn ? undefined : n
        }
        return En.call(e, t) ? e[t] : undefined
      }
      const Tn = Dn
      var Mn = Object.prototype
      var In = Mn.hasOwnProperty
      function Sn(t) {
        var e = this.__data__
        return wn ? e[t] !== undefined : In.call(e, t)
      }
      const Bn = Sn
      var Nn = '__lodash_hash_undefined__'
      function Pn(t, e) {
        var n = this.__data__
        this.size += this.has(t) ? 0 : 1
        n[t] = wn && e === undefined ? Nn : e
        return this
      }
      const zn = Pn
      function Ln(t) {
        var e = -1,
          n = t == null ? 0 : t.length
        this.clear()
        while (++e < n) {
          var i = t[e]
          this.set(i[0], i[1])
        }
      }
      Ln.prototype.clear = An
      Ln.prototype['delete'] = Cn
      Ln.prototype.get = Tn
      Ln.prototype.has = Bn
      Ln.prototype.set = zn
      const On = Ln
      function Rn() {
        this.size = 0
        this.__data__ = {
          hash: new On(),
          map: new (bn || Be)(),
          string: new On()
        }
      }
      const jn = Rn
      function Fn(t) {
        var e = typeof t
        return e == 'string' || e == 'number' || e == 'symbol' || e == 'boolean'
          ? t !== '__proto__'
          : t === null
      }
      const Vn = Fn
      function Hn(t, e) {
        var n = t.__data__
        return Vn(e) ? n[typeof e == 'string' ? 'string' : 'hash'] : n.map
      }
      const Un = Hn
      function Wn(t) {
        var e = Un(this, t)['delete'](t)
        this.size -= e ? 1 : 0
        return e
      }
      const qn = Wn
      function $n(t) {
        return Un(this, t).get(t)
      }
      const Gn = $n
      function Yn(t) {
        return Un(this, t).has(t)
      }
      const Kn = Yn
      function Qn(t, e) {
        var n = Un(this, t),
          i = n.size
        n.set(t, e)
        this.size += n.size == i ? 0 : 1
        return this
      }
      const Zn = Qn
      function Jn(t) {
        var e = -1,
          n = t == null ? 0 : t.length
        this.clear()
        while (++e < n) {
          var i = t[e]
          this.set(i[0], i[1])
        }
      }
      Jn.prototype.clear = jn
      Jn.prototype['delete'] = qn
      Jn.prototype.get = Gn
      Jn.prototype.has = Kn
      Jn.prototype.set = Zn
      const Xn = Jn
      var ti = 200
      function ei(t, e) {
        var n = this.__data__
        if (n instanceof Be) {
          var i = n.__data__
          if (!bn || i.length < ti - 1) {
            i.push([t, e])
            this.size = ++n.size
            return this
          }
          n = this.__data__ = new Xn(i)
        }
        n.set(t, e)
        this.size = n.size
        return this
      }
      const ni = ei
      function ii(t) {
        var e = (this.__data__ = new Be(t))
        this.size = e.size
      }
      ii.prototype.clear = Pe
      ii.prototype['delete'] = Le
      ii.prototype.get = Re
      ii.prototype.has = Fe
      ii.prototype.set = ni
      const oi = ii
      function ri(t, e) {
        var n = -1,
          i = t == null ? 0 : t.length
        while (++n < i) {
          if (e(t[n], n, t) === false) {
            break
          }
        }
        return t
      }
      const si = ri
      var ai = (function () {
        try {
          var t = gn(Object, 'defineProperty')
          t({}, '', {})
          return t
        } catch (t) {}
      })()
      const ci = ai
      function li(t, e, n) {
        if (e == '__proto__' && ci) {
          ci(t, e, {
            configurable: true,
            enumerable: true,
            value: n,
            writable: true
          })
        } else {
          t[e] = n
        }
      }
      const di = li
      var ui = Object.prototype
      var hi = ui.hasOwnProperty
      function fi(t, e, n) {
        var i = t[e]
        if (!(hi.call(t, e) && ke(i, n)) || (n === undefined && !(e in t))) {
          di(t, e, n)
        }
      }
      const mi = fi
      function gi(t, e, n, i) {
        var o = !n
        n || (n = {})
        var r = -1,
          s = e.length
        while (++r < s) {
          var a = e[r]
          var c = i ? i(n[a], t[a], a, n, t) : undefined
          if (c === undefined) {
            c = t[a]
          }
          if (o) {
            di(n, a, c)
          } else {
            mi(n, a, c)
          }
        }
        return n
      }
      const pi = gi
      function bi(t, e) {
        var n = -1,
          i = Array(t)
        while (++n < t) {
          i[n] = e(n)
        }
        return i
      }
      const ki = bi
      var wi = '[object Arguments]'
      function _i(t) {
        return Jt(t) && Yt(t) == wi
      }
      const Ai = _i
      var vi = Object.prototype
      var Ci = vi.hasOwnProperty
      var yi = vi.propertyIsEnumerable
      var xi = Ai(
        (function () {
          return arguments
        })()
      )
        ? Ai
        : function (t) {
            return Jt(t) && Ci.call(t, 'callee') && !yi.call(t, 'callee')
          }
      const Ei = xi
      function Di() {
        return false
      }
      const Ti = Di
      var Mi =
        typeof exports == 'object' && exports && !exports.nodeType && exports
      var Ii =
        Mi && typeof module == 'object' && module && !module.nodeType && module
      var Si = Ii && Ii.exports === Mi
      var Bi = Si ? St.Buffer : undefined
      var Ni = Bi ? Bi.isBuffer : undefined
      var Pi = Ni || Ti
      const zi = Pi
      var Li = 9007199254740991
      var Oi = /^(?:0|[1-9]\d*)$/
      function Ri(t, e) {
        var n = typeof t
        e = e == null ? Li : e
        return (
          !!e &&
          (n == 'number' || (n != 'symbol' && Oi.test(t))) &&
          t > -1 &&
          t % 1 == 0 &&
          t < e
        )
      }
      const ji = Ri
      var Fi = 9007199254740991
      function Vi(t) {
        return typeof t == 'number' && t > -1 && t % 1 == 0 && t <= Fi
      }
      const Hi = Vi
      var Ui = '[object Arguments]',
        Wi = '[object Array]',
        qi = '[object Boolean]',
        $i = '[object Date]',
        Gi = '[object Error]',
        Yi = '[object Function]',
        Ki = '[object Map]',
        Qi = '[object Number]',
        Zi = '[object Object]',
        Ji = '[object RegExp]',
        Xi = '[object Set]',
        to = '[object String]',
        eo = '[object WeakMap]'
      var no = '[object ArrayBuffer]',
        io = '[object DataView]',
        oo = '[object Float32Array]',
        ro = '[object Float64Array]',
        so = '[object Int8Array]',
        ao = '[object Int16Array]',
        co = '[object Int32Array]',
        lo = '[object Uint8Array]',
        uo = '[object Uint8ClampedArray]',
        ho = '[object Uint16Array]',
        fo = '[object Uint32Array]'
      var mo = {}
      mo[oo] =
        mo[ro] =
        mo[so] =
        mo[ao] =
        mo[co] =
        mo[lo] =
        mo[uo] =
        mo[ho] =
        mo[fo] =
          true
      mo[Ui] =
        mo[Wi] =
        mo[no] =
        mo[qi] =
        mo[io] =
        mo[$i] =
        mo[Gi] =
        mo[Yi] =
        mo[Ki] =
        mo[Qi] =
        mo[Zi] =
        mo[Ji] =
        mo[Xi] =
        mo[to] =
        mo[eo] =
          false
      function go(t) {
        return Jt(t) && Hi(t.length) && !!mo[Yt(t)]
      }
      const po = go
      function bo(t) {
        return function (e) {
          return t(e)
        }
      }
      const ko = bo
      var wo =
        typeof exports == 'object' && exports && !exports.nodeType && exports
      var _o =
        wo && typeof module == 'object' && module && !module.nodeType && module
      var Ao = _o && _o.exports === wo
      var vo = Ao && Tt.process
      var Co = (function () {
        try {
          var t = _o && _o.require && _o.require('util').types
          if (t) {
            return t
          }
          return vo && vo.binding && vo.binding('util')
        } catch (t) {}
      })()
      const yo = Co
      var xo = yo && yo.isTypedArray
      var Eo = xo ? ko(xo) : po
      const Do = Eo
      var To = Object.prototype
      var Mo = To.hasOwnProperty
      function Io(t, e) {
        var n = Qt(t),
          i = !n && Ei(t),
          o = !n && !i && zi(t),
          r = !n && !i && !o && Do(t),
          s = n || i || o || r,
          a = s ? ki(t.length, String) : [],
          c = a.length
        for (var l in t) {
          if (
            (e || Mo.call(t, l)) &&
            !(
              s &&
              (l == 'length' ||
                (o && (l == 'offset' || l == 'parent')) ||
                (r &&
                  (l == 'buffer' || l == 'byteLength' || l == 'byteOffset')) ||
                ji(l, c))
            )
          ) {
            a.push(l)
          }
        }
        return a
      }
      const So = Io
      var Bo = Object.prototype
      function No(t) {
        var e = t && t.constructor,
          n = (typeof e == 'function' && e.prototype) || Bo
        return t === n
      }
      const Po = No
      var zo = oe(Object.keys, Object)
      const Lo = zo
      var Oo = Object.prototype
      var Ro = Oo.hasOwnProperty
      function jo(t) {
        if (!Po(t)) {
          return Lo(t)
        }
        var e = []
        for (var n in Object(t)) {
          if (Ro.call(t, n) && n != 'constructor') {
            e.push(n)
          }
        }
        return e
      }
      const Fo = jo
      function Vo(t) {
        return t != null && Hi(t.length) && !$e(t)
      }
      const Ho = Vo
      function Uo(t) {
        return Ho(t) ? So(t) : Fo(t)
      }
      const Wo = Uo
      function qo(t, e) {
        return t && pi(e, Wo(e), t)
      }
      const $o = qo
      function Go(t) {
        var e = []
        if (t != null) {
          for (var n in Object(t)) {
            e.push(n)
          }
        }
        return e
      }
      const Yo = Go
      var Ko = Object.prototype
      var Qo = Ko.hasOwnProperty
      function Zo(t) {
        if (!rt(t)) {
          return Yo(t)
        }
        var e = Po(t),
          n = []
        for (var i in t) {
          if (!(i == 'constructor' && (e || !Qo.call(t, i)))) {
            n.push(i)
          }
        }
        return n
      }
      const Jo = Zo
      function Xo(t) {
        return Ho(t) ? So(t, true) : Jo(t)
      }
      const tr = Xo
      function er(t, e) {
        return t && pi(e, tr(e), t)
      }
      const nr = er
      var ir =
        typeof exports == 'object' && exports && !exports.nodeType && exports
      var or =
        ir && typeof module == 'object' && module && !module.nodeType && module
      var rr = or && or.exports === ir
      var sr = rr ? St.Buffer : undefined,
        ar = sr ? sr.allocUnsafe : undefined
      function cr(t, e) {
        if (e) {
          return t.slice()
        }
        var n = t.length,
          i = ar ? ar(n) : new t.constructor(n)
        t.copy(i)
        return i
      }
      const lr = cr
      function dr(t, e) {
        var n = -1,
          i = t.length
        e || (e = Array(i))
        while (++n < i) {
          e[n] = t[n]
        }
        return e
      }
      const ur = dr
      function hr(t, e) {
        var n = -1,
          i = t == null ? 0 : t.length,
          o = 0,
          r = []
        while (++n < i) {
          var s = t[n]
          if (e(s, n, t)) {
            r[o++] = s
          }
        }
        return r
      }
      const fr = hr
      function mr() {
        return []
      }
      const gr = mr
      var pr = Object.prototype
      var br = pr.propertyIsEnumerable
      var kr = Object.getOwnPropertySymbols
      var wr = !kr
        ? gr
        : function (t) {
            if (t == null) {
              return []
            }
            t = Object(t)
            return fr(kr(t), function (e) {
              return br.call(t, e)
            })
          }
      const _r = wr
      function Ar(t, e) {
        return pi(t, _r(t), e)
      }
      const vr = Ar
      function Cr(t, e) {
        var n = -1,
          i = e.length,
          o = t.length
        while (++n < i) {
          t[o + n] = e[n]
        }
        return t
      }
      const yr = Cr
      var xr = Object.getOwnPropertySymbols
      var Er = !xr
        ? gr
        : function (t) {
            var e = []
            while (t) {
              yr(e, _r(t))
              t = se(t)
            }
            return e
          }
      const Dr = Er
      function Tr(t, e) {
        return pi(t, Dr(t), e)
      }
      const Mr = Tr
      function Ir(t, e, n) {
        var i = e(t)
        return Qt(t) ? i : yr(i, n(t))
      }
      const Sr = Ir
      function Br(t) {
        return Sr(t, Wo, _r)
      }
      const Nr = Br
      function Pr(t) {
        return Sr(t, tr, Dr)
      }
      const zr = Pr
      var Lr = gn(St, 'DataView')
      const Or = Lr
      var Rr = gn(St, 'Promise')
      const jr = Rr
      var Fr = gn(St, 'Set')
      const Vr = Fr
      var Hr = gn(St, 'WeakMap')
      const Ur = Hr
      var Wr = '[object Map]',
        qr = '[object Object]',
        $r = '[object Promise]',
        Gr = '[object Set]',
        Yr = '[object WeakMap]'
      var Kr = '[object DataView]'
      var Qr = en(Or),
        Zr = en(bn),
        Jr = en(jr),
        Xr = en(Vr),
        ts = en(Ur)
      var es = Yt
      if (
        (Or && es(new Or(new ArrayBuffer(1))) != Kr) ||
        (bn && es(new bn()) != Wr) ||
        (jr && es(jr.resolve()) != $r) ||
        (Vr && es(new Vr()) != Gr) ||
        (Ur && es(new Ur()) != Yr)
      ) {
        es = function (t) {
          var e = Yt(t),
            n = e == qr ? t.constructor : undefined,
            i = n ? en(n) : ''
          if (i) {
            switch (i) {
              case Qr:
                return Kr
              case Zr:
                return Wr
              case Jr:
                return $r
              case Xr:
                return Gr
              case ts:
                return Yr
            }
          }
          return e
        }
      }
      const ns = es
      var is = Object.prototype
      var os = is.hasOwnProperty
      function rs(t) {
        var e = t.length,
          n = new t.constructor(e)
        if (e && typeof t[0] == 'string' && os.call(t, 'index')) {
          n.index = t.index
          n.input = t.input
        }
        return n
      }
      const ss = rs
      var as = St.Uint8Array
      const cs = as
      function ls(t) {
        var e = new t.constructor(t.byteLength)
        new cs(e).set(new cs(t))
        return e
      }
      const ds = ls
      function us(t, e) {
        var n = e ? ds(t.buffer) : t.buffer
        return new t.constructor(n, t.byteOffset, t.byteLength)
      }
      const hs = us
      var fs = /\w*$/
      function ms(t) {
        var e = new t.constructor(t.source, fs.exec(t))
        e.lastIndex = t.lastIndex
        return e
      }
      const gs = ms
      var ps = Nt ? Nt.prototype : undefined,
        bs = ps ? ps.valueOf : undefined
      function ks(t) {
        return bs ? Object(bs.call(t)) : {}
      }
      const ws = ks
      function _s(t, e) {
        var n = e ? ds(t.buffer) : t.buffer
        return new t.constructor(n, t.byteOffset, t.length)
      }
      const As = _s
      var vs = '[object Boolean]',
        Cs = '[object Date]',
        ys = '[object Map]',
        xs = '[object Number]',
        Es = '[object RegExp]',
        Ds = '[object Set]',
        Ts = '[object String]',
        Ms = '[object Symbol]'
      var Is = '[object ArrayBuffer]',
        Ss = '[object DataView]',
        Bs = '[object Float32Array]',
        Ns = '[object Float64Array]',
        Ps = '[object Int8Array]',
        zs = '[object Int16Array]',
        Ls = '[object Int32Array]',
        Os = '[object Uint8Array]',
        Rs = '[object Uint8ClampedArray]',
        js = '[object Uint16Array]',
        Fs = '[object Uint32Array]'
      function Vs(t, e, n) {
        var i = t.constructor
        switch (e) {
          case Is:
            return ds(t)
          case vs:
          case Cs:
            return new i(+t)
          case Ss:
            return hs(t, n)
          case Bs:
          case Ns:
          case Ps:
          case zs:
          case Ls:
          case Os:
          case Rs:
          case js:
          case Fs:
            return As(t, n)
          case ys:
            return new i()
          case xs:
          case Ts:
            return new i(t)
          case Es:
            return gs(t)
          case Ds:
            return new i()
          case Ms:
            return ws(t)
        }
      }
      const Hs = Vs
      var Us = Object.create
      var Ws = (function () {
        function t() {}
        return function (e) {
          if (!rt(e)) {
            return {}
          }
          if (Us) {
            return Us(e)
          }
          t.prototype = e
          var n = new t()
          t.prototype = undefined
          return n
        }
      })()
      const qs = Ws
      function $s(t) {
        return typeof t.constructor == 'function' && !Po(t) ? qs(se(t)) : {}
      }
      const Gs = $s
      var Ys = '[object Map]'
      function Ks(t) {
        return Jt(t) && ns(t) == Ys
      }
      const Qs = Ks
      var Zs = yo && yo.isMap
      var Js = Zs ? ko(Zs) : Qs
      const Xs = Js
      var ta = '[object Set]'
      function ea(t) {
        return Jt(t) && ns(t) == ta
      }
      const na = ea
      var ia = yo && yo.isSet
      var oa = ia ? ko(ia) : na
      const ra = oa
      var sa = 1,
        aa = 2,
        ca = 4
      var la = '[object Arguments]',
        da = '[object Array]',
        ua = '[object Boolean]',
        ha = '[object Date]',
        fa = '[object Error]',
        ma = '[object Function]',
        ga = '[object GeneratorFunction]',
        pa = '[object Map]',
        ba = '[object Number]',
        ka = '[object Object]',
        wa = '[object RegExp]',
        _a = '[object Set]',
        Aa = '[object String]',
        va = '[object Symbol]',
        Ca = '[object WeakMap]'
      var ya = '[object ArrayBuffer]',
        xa = '[object DataView]',
        Ea = '[object Float32Array]',
        Da = '[object Float64Array]',
        Ta = '[object Int8Array]',
        Ma = '[object Int16Array]',
        Ia = '[object Int32Array]',
        Sa = '[object Uint8Array]',
        Ba = '[object Uint8ClampedArray]',
        Na = '[object Uint16Array]',
        Pa = '[object Uint32Array]'
      var za = {}
      za[la] =
        za[da] =
        za[ya] =
        za[xa] =
        za[ua] =
        za[ha] =
        za[Ea] =
        za[Da] =
        za[Ta] =
        za[Ma] =
        za[Ia] =
        za[pa] =
        za[ba] =
        za[ka] =
        za[wa] =
        za[_a] =
        za[Aa] =
        za[va] =
        za[Sa] =
        za[Ba] =
        za[Na] =
        za[Pa] =
          true
      za[fa] = za[ma] = za[Ca] = false
      function La(t, e, n, i, o, r) {
        var s,
          a = e & sa,
          c = e & aa,
          l = e & ca
        if (n) {
          s = o ? n(t, i, o, r) : n(t)
        }
        if (s !== undefined) {
          return s
        }
        if (!rt(t)) {
          return t
        }
        var d = Qt(t)
        if (d) {
          s = ss(t)
          if (!a) {
            return ur(t, s)
          }
        } else {
          var u = ns(t),
            h = u == ma || u == ga
          if (zi(t)) {
            return lr(t, a)
          }
          if (u == ka || u == la || (h && !o)) {
            s = c || h ? {} : Gs(t)
            if (!a) {
              return c ? Mr(t, nr(s, t)) : vr(t, $o(s, t))
            }
          } else {
            if (!za[u]) {
              return o ? t : {}
            }
            s = Hs(t, u, a)
          }
        }
        r || (r = new oi())
        var f = r.get(t)
        if (f) {
          return f
        }
        r.set(t, s)
        if (ra(t)) {
          t.forEach(function (i) {
            s.add(La(i, e, n, i, t, r))
          })
        } else if (Xs(t)) {
          t.forEach(function (i, o) {
            s.set(o, La(i, e, n, o, t, r))
          })
        }
        var m = l ? (c ? zr : Nr) : c ? tr : Wo
        var g = d ? undefined : m(t)
        si(g || t, function (i, o) {
          if (g) {
            o = i
            i = t[o]
          }
          mi(s, o, La(i, e, n, o, t, r))
        })
        return s
      }
      const Oa = La
      var Ra = 1,
        ja = 4
      function Fa(t, e) {
        e = typeof e == 'function' ? e : undefined
        return Oa(t, Ra | ja, e)
      }
      const Va = Fa
      function Ha(t) {
        return Jt(t) && t.nodeType === 1 && !me(t)
      }
      const Ua = Ha
      class Wa {
        constructor(t, e) {
          this._config = {}
          if (e) {
            this.define(qa(e))
          }
          if (t) {
            this._setObjectToTarget(this._config, t)
          }
        }
        set(t, e) {
          this._setToTarget(this._config, t, e)
        }
        define(t, e) {
          const n = true
          this._setToTarget(this._config, t, e, n)
        }
        get(t) {
          return this._getFromSource(this._config, t)
        }
        *names() {
          for (const t of Object.keys(this._config)) {
            yield t
          }
        }
        _setToTarget(t, e, n, i = false) {
          if (me(e)) {
            this._setObjectToTarget(t, e, i)
            return
          }
          const o = e.split('.')
          e = o.pop()
          for (const e of o) {
            if (!me(t[e])) {
              t[e] = {}
            }
            t = t[e]
          }
          if (me(n)) {
            if (!me(t[e])) {
              t[e] = {}
            }
            t = t[e]
            this._setObjectToTarget(t, n, i)
            return
          }
          if (i && typeof t[e] != 'undefined') {
            return
          }
          t[e] = n
        }
        _getFromSource(t, e) {
          const n = e.split('.')
          e = n.pop()
          for (const e of n) {
            if (!me(t[e])) {
              t = null
              break
            }
            t = t[e]
          }
          return t ? qa(t[e]) : undefined
        }
        _setObjectToTarget(t, e, n) {
          Object.keys(e).forEach((i) => {
            this._setToTarget(t, i, e[i], n)
          })
        }
      }
      function qa(t) {
        return Va(t, $a)
      }
      function $a(t) {
        return Ua(t) ? t : undefined
      }
      function Ga(t) {
        if (t) {
          if (t.defaultView) {
            return t instanceof t.defaultView.Document
          } else if (t.ownerDocument && t.ownerDocument.defaultView) {
            return t instanceof t.ownerDocument.defaultView.Node
          }
        }
        return false
      }
      function Ya(t) {
        const e = Object.prototype.toString.apply(t)
        if (e == '[object Window]') {
          return true
        }
        if (e == '[object global]') {
          return true
        }
        return false
      }
      const Ka = Qa($())
      function Qa(t) {
        if (!t) {
          return Ka
        }
        class e extends t {
          listenTo(t, e, n, i = {}) {
            if (Ga(t) || Ya(t)) {
              const o = { capture: !!i.useCapture, passive: !!i.usePassive }
              const r = this._getProxyEmitter(t, o) || new Za(t, o)
              this.listenTo(r, e, n, i)
            } else {
              super.listenTo(t, e, n, i)
            }
          }
          stopListening(t, e, n) {
            if (Ga(t) || Ya(t)) {
              const i = this._getAllProxyEmitters(t)
              for (const t of i) {
                this.stopListening(t, e, n)
              }
            } else {
              super.stopListening(t, e, n)
            }
          }
          _getProxyEmitter(t, e) {
            return G(this, Xa(t, e))
          }
          _getAllProxyEmitters(t) {
            return [
              { capture: false, passive: false },
              { capture: false, passive: true },
              { capture: true, passive: false },
              { capture: true, passive: true }
            ]
              .map((e) => this._getProxyEmitter(t, e))
              .filter((t) => !!t)
          }
        }
        return e
      }
      ;[
        '_getProxyEmitter',
        '_getAllProxyEmitters',
        'on',
        'once',
        'off',
        'listenTo',
        'stopListening',
        'fire',
        'delegate',
        'stopDelegating',
        '_addEventListener',
        '_removeEventListener'
      ].forEach((t) => {
        Qa[t] = Ka.prototype[t]
      })
      class Za extends $() {
        constructor(t, e) {
          super()
          Y(this, Xa(t, e))
          this._domNode = t
          this._options = e
        }
        attach(t) {
          if (this._domListeners && this._domListeners[t]) {
            return
          }
          const e = this._createDomListener(t)
          this._domNode.addEventListener(t, e, this._options)
          if (!this._domListeners) {
            this._domListeners = {}
          }
          this._domListeners[t] = e
        }
        detach(t) {
          let e
          if (
            this._domListeners[t] &&
            (!(e = this._events[t]) || !e.callbacks.length)
          ) {
            this._domListeners[t].removeListener()
          }
        }
        _addEventListener(t, e, n) {
          this.attach(t)
          $().prototype._addEventListener.call(this, t, e, n)
        }
        _removeEventListener(t, e) {
          $().prototype._removeEventListener.call(this, t, e)
          this.detach(t)
        }
        _createDomListener(t) {
          const e = (e) => {
            this.fire(t, e)
          }
          e.removeListener = () => {
            this._domNode.removeEventListener(t, e, this._options)
            delete this._domListeners[t]
          }
          return e
        }
      }
      function Ja(t) {
        return t['data-ck-expando'] || (t['data-ck-expando'] = T())
      }
      function Xa(t, e) {
        let n = Ja(t)
        for (const t of Object.keys(e).sort()) {
          if (e[t]) {
            n += '-' + t
          }
        }
        return n
      }
      let tc
      try {
        tc = { window, document }
      } catch (t) {
        tc = { window: {}, document: {} }
      }
      const ec = tc
      function nc(t) {
        const e = []
        let n = t
        while (n && n.nodeType != Node.DOCUMENT_NODE) {
          e.unshift(n)
          n = n.parentNode
        }
        return e
      }
      function ic(t) {
        if (t instanceof HTMLTextAreaElement) {
          return t.value
        }
        return t.innerHTML
      }
      function oc(t) {
        return Object.prototype.toString.call(t) == '[object Text]'
      }
      function rc(t) {
        return Object.prototype.toString.apply(t) == '[object Range]'
      }
      function sc(t) {
        const e = t.ownerDocument.defaultView.getComputedStyle(t)
        return {
          top: parseInt(e.borderTopWidth, 10),
          right: parseInt(e.borderRightWidth, 10),
          bottom: parseInt(e.borderBottomWidth, 10),
          left: parseInt(e.borderLeftWidth, 10)
        }
      }
      const ac = ['top', 'right', 'bottom', 'left', 'width', 'height']
      class cc {
        constructor(t) {
          const e = rc(t)
          Object.defineProperty(this, '_source', {
            value: t._source || t,
            writable: true,
            enumerable: false
          })
          if (uc(t) || e) {
            if (e) {
              const e = cc.getDomRangeRects(t)
              lc(this, cc.getBoundingRect(e))
            } else {
              lc(this, t.getBoundingClientRect())
            }
          } else if (Ya(t)) {
            const { innerWidth: e, innerHeight: n } = t
            lc(this, {
              top: 0,
              right: e,
              bottom: n,
              left: 0,
              width: e,
              height: n
            })
          } else {
            lc(this, t)
          }
        }
        clone() {
          return new cc(this)
        }
        moveTo(t, e) {
          this.top = e
          this.right = t + this.width
          this.bottom = e + this.height
          this.left = t
          return this
        }
        moveBy(t, e) {
          this.top += e
          this.right += t
          this.left += t
          this.bottom += e
          return this
        }
        getIntersection(t) {
          const e = {
            top: Math.max(this.top, t.top),
            right: Math.min(this.right, t.right),
            bottom: Math.min(this.bottom, t.bottom),
            left: Math.max(this.left, t.left),
            width: 0,
            height: 0
          }
          e.width = e.right - e.left
          e.height = e.bottom - e.top
          if (e.width < 0 || e.height < 0) {
            return null
          } else {
            return new cc(e)
          }
        }
        getIntersectionArea(t) {
          const e = this.getIntersection(t)
          if (e) {
            return e.getArea()
          } else {
            return 0
          }
        }
        getArea() {
          return this.width * this.height
        }
        getVisible() {
          const t = this._source
          let e = this.clone()
          if (!dc(t)) {
            let n = t.parentNode || t.commonAncestorContainer
            while (n && !dc(n)) {
              const t = new cc(n)
              const i = e.getIntersection(t)
              if (i) {
                if (i.getArea() < e.getArea()) {
                  e = i
                }
              } else {
                return null
              }
              n = n.parentNode
            }
          }
          return e
        }
        isEqual(t) {
          for (const e of ac) {
            if (this[e] !== t[e]) {
              return false
            }
          }
          return true
        }
        contains(t) {
          const e = this.getIntersection(t)
          return !!(e && e.isEqual(t))
        }
        excludeScrollbarsAndBorders() {
          const t = this._source
          let e, n, i
          if (Ya(t)) {
            e = t.innerWidth - t.document.documentElement.clientWidth
            n = t.innerHeight - t.document.documentElement.clientHeight
            i = t.getComputedStyle(t.document.documentElement).direction
          } else {
            const o = sc(t)
            e = t.offsetWidth - t.clientWidth - o.left - o.right
            n = t.offsetHeight - t.clientHeight - o.top - o.bottom
            i = t.ownerDocument.defaultView.getComputedStyle(t).direction
            this.left += o.left
            this.top += o.top
            this.right -= o.right
            this.bottom -= o.bottom
            this.width = this.right - this.left
            this.height = this.bottom - this.top
          }
          this.width -= e
          if (i === 'ltr') {
            this.right -= e
          } else {
            this.left += e
          }
          this.height -= n
          this.bottom -= n
          return this
        }
        static getDomRangeRects(t) {
          const e = []
          const n = Array.from(t.getClientRects())
          if (n.length) {
            for (const t of n) {
              e.push(new cc(t))
            }
          } else {
            let n = t.startContainer
            if (oc(n)) {
              n = n.parentNode
            }
            const i = new cc(n.getBoundingClientRect())
            i.right = i.left
            i.width = 0
            e.push(i)
          }
          return e
        }
        static getBoundingRect(t) {
          const e = {
            left: Number.POSITIVE_INFINITY,
            top: Number.POSITIVE_INFINITY,
            right: Number.NEGATIVE_INFINITY,
            bottom: Number.NEGATIVE_INFINITY,
            width: 0,
            height: 0
          }
          let n = 0
          for (const i of t) {
            n++
            e.left = Math.min(e.left, i.left)
            e.top = Math.min(e.top, i.top)
            e.right = Math.max(e.right, i.right)
            e.bottom = Math.max(e.bottom, i.bottom)
          }
          if (n == 0) {
            return null
          }
          e.width = e.right - e.left
          e.height = e.bottom - e.top
          return new cc(e)
        }
      }
      function lc(t, e) {
        for (const n of ac) {
          t[n] = e[n]
        }
      }
      function dc(t) {
        if (!uc(t)) {
          return false
        }
        return t === t.ownerDocument.body
      }
      function uc(t) {
        return (
          t !== null &&
          typeof t === 'object' &&
          t.nodeType === 1 &&
          typeof t.getBoundingClientRect === 'function'
        )
      }
      class hc {
        constructor(t, e) {
          if (!hc._observerInstance) {
            hc._createObserver()
          }
          this._element = t
          this._callback = e
          hc._addElementCallback(t, e)
          hc._observerInstance.observe(t)
        }
        destroy() {
          hc._deleteElementCallback(this._element, this._callback)
        }
        static _addElementCallback(t, e) {
          if (!hc._elementCallbacks) {
            hc._elementCallbacks = new Map()
          }
          let n = hc._elementCallbacks.get(t)
          if (!n) {
            n = new Set()
            hc._elementCallbacks.set(t, n)
          }
          n.add(e)
        }
        static _deleteElementCallback(t, e) {
          const n = hc._getElementCallbacks(t)
          if (n) {
            n.delete(e)
            if (!n.size) {
              hc._elementCallbacks.delete(t)
              hc._observerInstance.unobserve(t)
            }
          }
          if (hc._elementCallbacks && !hc._elementCallbacks.size) {
            hc._observerInstance = null
            hc._elementCallbacks = null
          }
        }
        static _getElementCallbacks(t) {
          if (!hc._elementCallbacks) {
            return null
          }
          return hc._elementCallbacks.get(t)
        }
        static _createObserver() {
          hc._observerInstance = new ec.window.ResizeObserver((t) => {
            for (const e of t) {
              const t = hc._getElementCallbacks(e.target)
              if (t) {
                for (const n of t) {
                  n(e)
                }
              }
            }
          })
        }
      }
      hc._observerInstance = null
      hc._elementCallbacks = null
      function fc(t, e) {
        if (t instanceof HTMLTextAreaElement) {
          t.value = e
        }
        t.innerHTML = e
      }
      function mc(t) {
        return (e) => e + t
      }
      function gc(t) {
        let e = 0
        while (t.previousSibling) {
          t = t.previousSibling
          e++
        }
        return e
      }
      function pc(t, e, n) {
        t.insertBefore(n, t.childNodes[e] || null)
      }
      function bc(t) {
        return t && t.nodeType === Node.COMMENT_NODE
      }
      function kc(t) {
        return !!(t && t.getClientRects && t.getClientRects().length)
      }
      function wc(t) {
        if (!t || !t.parentNode) {
          return null
        }
        if (t.offsetParent === ec.document.body) {
          return null
        }
        return t.offsetParent
      }
      function _c({
        element: t,
        target: e,
        positions: n,
        limiter: i,
        fitInViewport: o,
        viewportOffsetConfig: r
      }) {
        if ($e(e)) {
          e = e()
        }
        if ($e(i)) {
          i = i()
        }
        const s = wc(t)
        const a = new cc(t)
        const c = new cc(e)
        let l
        const d = (o && Ac(r)) || null
        const u = {
          targetRect: c,
          elementRect: a,
          positionedElementAncestor: s,
          viewportRect: d
        }
        if (!i && !o) {
          l = new xc(n[0], u)
        } else {
          const t = i && new cc(i).getVisible()
          Object.assign(u, { limiterRect: t, viewportRect: d })
          l = vc(n, u) || new xc(n[0], u)
        }
        return l
      }
      function Ac(t) {
        t = Object.assign({ top: 0, bottom: 0, left: 0, right: 0 }, t)
        const e = new cc(ec.window)
        e.top += t.top
        e.height -= t.top
        e.bottom -= t.bottom
        e.height -= t.bottom
        return e
      }
      function vc(t, e) {
        const { elementRect: n } = e
        const i = n.getArea()
        const o = t.map((t) => new xc(t, e)).filter((t) => !!t.name)
        let r = 0
        let s = null
        for (const t of o) {
          const { limiterIntersectionArea: e, viewportIntersectionArea: n } = t
          if (e === i) {
            return t
          }
          const o = n ** 2 + e ** 2
          if (o > r) {
            r = o
            s = t
          }
        }
        return s
      }
      function Cc(t, e) {
        const n = yc(new cc(e))
        const i = sc(e)
        let o = 0
        let r = 0
        o -= n.left
        r -= n.top
        o += e.scrollLeft
        r += e.scrollTop
        o -= i.left
        r -= i.top
        t.moveBy(o, r)
      }
      function yc(t) {
        const { scrollX: e, scrollY: n } = ec.window
        return t.clone().moveBy(e, n)
      }
      class xc {
        constructor(t, e) {
          const n = t(e.targetRect, e.elementRect, e.viewportRect)
          if (!n) {
            return
          }
          const { left: i, top: o, name: r, config: s } = n
          this.name = r
          this.config = s
          this._positioningFunctionCorrdinates = { left: i, top: o }
          this._options = e
        }
        get left() {
          return this._absoluteRect.left
        }
        get top() {
          return this._absoluteRect.top
        }
        get limiterIntersectionArea() {
          const t = this._options.limiterRect
          if (t) {
            const e = this._options.viewportRect
            if (e) {
              const n = t.getIntersection(e)
              if (n) {
                return n.getIntersectionArea(this._rect)
              }
            } else {
              return t.getIntersectionArea(this._rect)
            }
          }
          return 0
        }
        get viewportIntersectionArea() {
          const t = this._options.viewportRect
          if (t) {
            return t.getIntersectionArea(this._rect)
          }
          return 0
        }
        get _rect() {
          if (this._cachedRect) {
            return this._cachedRect
          }
          this._cachedRect = this._options.elementRect
            .clone()
            .moveTo(
              this._positioningFunctionCorrdinates.left,
              this._positioningFunctionCorrdinates.top
            )
          return this._cachedRect
        }
        get _absoluteRect() {
          if (this._cachedAbsoluteRect) {
            return this._cachedAbsoluteRect
          }
          this._cachedAbsoluteRect = yc(this._rect)
          if (this._options.positionedElementAncestor) {
            Cc(
              this._cachedAbsoluteRect,
              this._options.positionedElementAncestor
            )
          }
          return this._cachedAbsoluteRect
        }
      }
      function Ec(t) {
        const e = t.parentNode
        if (e) {
          e.removeChild(t)
        }
      }
      function Dc({ target: t, viewportOffset: e = 0 }) {
        const n = zc(t)
        let i = n
        let o = null
        while (i) {
          let r
          if (i == n) {
            r = Lc(t)
          } else {
            r = Lc(o)
          }
          Ic(r, () => Oc(t, i))
          const s = Oc(t, i)
          Mc(i, s, e)
          if (i.parent != i) {
            o = i.frameElement
            i = i.parent
            if (!o) {
              return
            }
          } else {
            i = null
          }
        }
      }
      function Tc(t) {
        const e = Lc(t)
        Ic(e, () => new Rect(t))
      }
      function Mc(t, e, n) {
        const i = e.clone().moveBy(0, n)
        const o = e.clone().moveBy(0, -n)
        const r = new cc(t).excludeScrollbarsAndBorders()
        const s = [o, i]
        if (!s.every((t) => r.contains(t))) {
          let { scrollX: s, scrollY: a } = t
          if (Bc(o, r)) {
            a -= r.top - e.top + n
          } else if (Sc(i, r)) {
            a += e.bottom - r.bottom + n
          }
          if (Nc(e, r)) {
            s -= r.left - e.left + n
          } else if (Pc(e, r)) {
            s += e.right - r.right + n
          }
          t.scrollTo(s, a)
        }
      }
      function Ic(t, e) {
        const n = zc(t)
        let i, o
        while (t != n.document.body) {
          o = e()
          i = new cc(t).excludeScrollbarsAndBorders()
          if (!i.contains(o)) {
            if (Bc(o, i)) {
              t.scrollTop -= i.top - o.top
            } else if (Sc(o, i)) {
              t.scrollTop += o.bottom - i.bottom
            }
            if (Nc(o, i)) {
              t.scrollLeft -= i.left - o.left
            } else if (Pc(o, i)) {
              t.scrollLeft += o.right - i.right
            }
          }
          t = t.parentNode
        }
      }
      function Sc(t, e) {
        return t.bottom > e.bottom
      }
      function Bc(t, e) {
        return t.top < e.top
      }
      function Nc(t, e) {
        return t.left < e.left
      }
      function Pc(t, e) {
        return t.right > e.right
      }
      function zc(t) {
        if (rc(t)) {
          return t.startContainer.ownerDocument.defaultView
        } else {
          return t.ownerDocument.defaultView
        }
      }
      function Lc(t) {
        if (rc(t)) {
          let e = t.commonAncestorContainer
          if (oc(e)) {
            e = e.parentNode
          }
          return e
        } else {
          return t.parentNode
        }
      }
      function Oc(t, e) {
        const n = zc(t)
        const i = new cc(t)
        if (n === e) {
          return i
        } else {
          let t = n
          while (t != e) {
            const e = t.frameElement
            const n = new cc(e).excludeScrollbarsAndBorders()
            i.moveBy(n.left, n.top)
            t = t.parent
          }
        }
        return i
      }
      const Rc = { ctrl: '⌃', cmd: '⌘', alt: '⌥', shift: '⇧' }
      const jc = { ctrl: 'Ctrl+', alt: 'Alt+', shift: 'Shift+' }
      const Fc = Kc()
      const Vc = Object.fromEntries(
        Object.entries(Fc).map(([t, e]) => [
          e,
          t.charAt(0).toUpperCase() + t.slice(1)
        ])
      )
      function Hc(t) {
        let e
        if (typeof t == 'string') {
          e = Fc[t.toLowerCase()]
          if (!e) {
            throw new N('keyboard-unknown-key', null, { key: t })
          }
        } else {
          e =
            t.keyCode +
            (t.altKey ? Fc.alt : 0) +
            (t.ctrlKey ? Fc.ctrl : 0) +
            (t.shiftKey ? Fc.shift : 0) +
            (t.metaKey ? Fc.cmd : 0)
        }
        return e
      }
      function Uc(t) {
        if (typeof t == 'string') {
          t = Qc(t)
        }
        return t
          .map((t) => (typeof t == 'string' ? Gc(t) : t))
          .reduce((t, e) => e + t, 0)
      }
      function Wc(t) {
        let e = Uc(t)
        const n = Object.entries(a.isMac ? Rc : jc)
        const i = n.reduce((t, [n, i]) => {
          if ((e & Fc[n]) != 0) {
            e &= ~Fc[n]
            t += i
          }
          return t
        }, '')
        return i + (e ? Vc[e] : '')
      }
      function qc(t) {
        return (
          t == Fc.arrowright ||
          t == Fc.arrowleft ||
          t == Fc.arrowup ||
          t == Fc.arrowdown
        )
      }
      function $c(t, e) {
        const n = e === 'ltr'
        switch (t) {
          case Fc.arrowleft:
            return n ? 'left' : 'right'
          case Fc.arrowright:
            return n ? 'right' : 'left'
          case Fc.arrowup:
            return 'up'
          case Fc.arrowdown:
            return 'down'
        }
      }
      function Gc(t) {
        if (t.endsWith('!')) {
          return Hc(t.slice(0, -1))
        }
        const e = Hc(t)
        return a.isMac && e == Fc.ctrl ? Fc.cmd : e
      }
      function Yc(t, e) {
        const n = $c(t, e)
        return n === 'down' || n === 'right'
      }
      function Kc() {
        const t = {
          arrowleft: 37,
          arrowup: 38,
          arrowright: 39,
          arrowdown: 40,
          backspace: 8,
          delete: 46,
          enter: 13,
          space: 32,
          esc: 27,
          tab: 9,
          ctrl: 1114112,
          shift: 2228224,
          alt: 4456448,
          cmd: 8912896
        }
        for (let e = 65; e <= 90; e++) {
          const n = String.fromCharCode(e)
          t[n.toLowerCase()] = e
        }
        for (let e = 48; e <= 57; e++) {
          t[e - 48] = e
        }
        for (let e = 112; e <= 123; e++) {
          t['f' + (e - 111)] = e
        }
        for (const e of "`-=[];',./\\") {
          t[e] = e.charCodeAt(0)
        }
        return t
      }
      function Qc(t) {
        return t.split('+').map((t) => t.trim())
      }
      function Zc(t) {
        return Array.isArray(t) ? t : [t]
      }
      if (!ec.window.CKEDITOR_TRANSLATIONS) {
        ec.window.CKEDITOR_TRANSLATIONS = {}
      }
      function Jc(t, e, n) {
        if (!global.window.CKEDITOR_TRANSLATIONS[t]) {
          global.window.CKEDITOR_TRANSLATIONS[t] = {}
        }
        const i = global.window.CKEDITOR_TRANSLATIONS[t]
        i.dictionary = i.dictionary || {}
        i.getPluralForm = n || i.getPluralForm
        Object.assign(i.dictionary, e)
      }
      function Xc(t, e, n = 1) {
        if (typeof n !== 'number') {
          throw new N('translation-service-quantity-not-a-number', null, {
            quantity: n
          })
        }
        const i = nl()
        if (i === 1) {
          t = Object.keys(ec.window.CKEDITOR_TRANSLATIONS)[0]
        }
        const o = e.id || e.string
        if (i === 0 || !el(t, o)) {
          if (n !== 1) {
            return e.plural
          }
          return e.string
        }
        const r = ec.window.CKEDITOR_TRANSLATIONS[t].dictionary
        const s =
          ec.window.CKEDITOR_TRANSLATIONS[t].getPluralForm ||
          ((t) => (t === 1 ? 0 : 1))
        const a = r[o]
        if (typeof a === 'string') {
          return a
        }
        const c = Number(s(n))
        return a[c]
      }
      function tl() {
        global.window.CKEDITOR_TRANSLATIONS = {}
      }
      function el(t, e) {
        return (
          !!ec.window.CKEDITOR_TRANSLATIONS[t] &&
          !!ec.window.CKEDITOR_TRANSLATIONS[t].dictionary[e]
        )
      }
      function nl() {
        return Object.keys(ec.window.CKEDITOR_TRANSLATIONS).length
      }
      const il = [
        'ar',
        'ara',
        'fa',
        'per',
        'fas',
        'he',
        'heb',
        'ku',
        'kur',
        'ug',
        'uig'
      ]
      function ol(t) {
        return il.includes(t) ? 'rtl' : 'ltr'
      }
      class rl {
        constructor({ uiLanguage: t = 'en', contentLanguage: e } = {}) {
          this.uiLanguage = t
          this.contentLanguage = e || this.uiLanguage
          this.uiLanguageDirection = ol(this.uiLanguage)
          this.contentLanguageDirection = ol(this.contentLanguage)
          this.t = (t, e) => this._t(t, e)
        }
        get language() {
          console.warn(
            'locale-deprecated-language-property: ' +
              'The Locale#language property has been deprecated and will be removed in the near future. ' +
              'Please use #uiLanguage and #contentLanguage properties instead.'
          )
          return this.uiLanguage
        }
        _t(t, e = []) {
          e = Zc(e)
          if (typeof t === 'string') {
            t = { string: t }
          }
          const n = !!t.plural
          const i = n ? e[0] : 1
          const o = Xc(this.uiLanguage, t, i)
          return sl(o, e)
        }
      }
      function sl(t, e) {
        return t.replace(/%(\d+)/g, (t, n) => (n < e.length ? e[n] : t))
      }
      class al extends $() {
        constructor(t = {}, e = {}) {
          super()
          const n = Et(t)
          if (!n) {
            e = t
          }
          this._items = []
          this._itemMap = new Map()
          this._idProperty = e.idProperty || 'id'
          this._bindToExternalToInternalMap = new WeakMap()
          this._bindToInternalToExternalMap = new WeakMap()
          this._skippedIndexesFromExternal = []
          if (n) {
            for (const e of t) {
              this._items.push(e)
              this._itemMap.set(this._getItemIdBeforeAdding(e), e)
            }
          }
        }
        get length() {
          return this._items.length
        }
        get first() {
          return this._items[0] || null
        }
        get last() {
          return this._items[this.length - 1] || null
        }
        add(t, e) {
          return this.addMany([t], e)
        }
        addMany(t, e) {
          if (e === undefined) {
            e = this._items.length
          } else if (e > this._items.length || e < 0) {
            throw new N('collection-add-item-invalid-index', this)
          }
          let n = 0
          for (const i of t) {
            const t = this._getItemIdBeforeAdding(i)
            const o = e + n
            this._items.splice(o, 0, i)
            this._itemMap.set(t, i)
            this.fire('add', i, o)
            n++
          }
          this.fire('change', { added: t, removed: [], index: e })
          return this
        }
        get(t) {
          let e
          if (typeof t == 'string') {
            e = this._itemMap.get(t)
          } else if (typeof t == 'number') {
            e = this._items[t]
          } else {
            throw new N('collection-get-invalid-arg', this)
          }
          return e || null
        }
        has(t) {
          if (typeof t == 'string') {
            return this._itemMap.has(t)
          } else {
            const e = this._idProperty
            const n = t[e]
            return n && this._itemMap.has(n)
          }
        }
        getIndex(t) {
          let e
          if (typeof t == 'string') {
            e = this._itemMap.get(t)
          } else {
            e = t
          }
          return e ? this._items.indexOf(e) : -1
        }
        remove(t) {
          const [e, n] = this._remove(t)
          this.fire('change', { added: [], removed: [e], index: n })
          return e
        }
        map(t, e) {
          return this._items.map(t, e)
        }
        find(t, e) {
          return this._items.find(t, e)
        }
        filter(t, e) {
          return this._items.filter(t, e)
        }
        clear() {
          if (this._bindToCollection) {
            this.stopListening(this._bindToCollection)
            this._bindToCollection = null
          }
          const t = Array.from(this._items)
          while (this.length) {
            this._remove(0)
          }
          this.fire('change', { added: [], removed: t, index: 0 })
        }
        bindTo(t) {
          if (this._bindToCollection) {
            throw new N('collection-bind-to-rebind', this)
          }
          this._bindToCollection = t
          return {
            as: (t) => {
              this._setUpBindToBinding((e) => new t(e))
            },
            using: (t) => {
              if (typeof t == 'function') {
                this._setUpBindToBinding(t)
              } else {
                this._setUpBindToBinding((e) => e[t])
              }
            }
          }
        }
        _setUpBindToBinding(t) {
          const e = this._bindToCollection
          const n = (n, i, o) => {
            const r = e._bindToCollection == this
            const s = e._bindToInternalToExternalMap.get(i)
            if (r && s) {
              this._bindToExternalToInternalMap.set(i, s)
              this._bindToInternalToExternalMap.set(s, i)
            } else {
              const n = t(i)
              if (!n) {
                this._skippedIndexesFromExternal.push(o)
                return
              }
              let r = o
              for (const t of this._skippedIndexesFromExternal) {
                if (o > t) {
                  r--
                }
              }
              for (const t of e._skippedIndexesFromExternal) {
                if (r >= t) {
                  r++
                }
              }
              this._bindToExternalToInternalMap.set(i, n)
              this._bindToInternalToExternalMap.set(n, i)
              this.add(n, r)
              for (let t = 0; t < e._skippedIndexesFromExternal.length; t++) {
                if (r <= e._skippedIndexesFromExternal[t]) {
                  e._skippedIndexesFromExternal[t]++
                }
              }
            }
          }
          for (const t of e) {
            n(null, t, e.getIndex(t))
          }
          this.listenTo(e, 'add', n)
          this.listenTo(e, 'remove', (t, e, n) => {
            const i = this._bindToExternalToInternalMap.get(e)
            if (i) {
              this.remove(i)
            }
            this._skippedIndexesFromExternal =
              this._skippedIndexesFromExternal.reduce((t, e) => {
                if (n < e) {
                  t.push(e - 1)
                }
                if (n > e) {
                  t.push(e)
                }
                return t
              }, [])
          })
        }
        _getItemIdBeforeAdding(t) {
          const e = this._idProperty
          let n
          if (e in t) {
            n = t[e]
            if (typeof n != 'string') {
              throw new N('collection-add-invalid-id', this)
            }
            if (this.get(n)) {
              throw new N('collection-add-item-already-exists', this)
            }
          } else {
            t[e] = n = T()
          }
          return n
        }
        _remove(t) {
          let e, n, i
          let o = false
          const r = this._idProperty
          if (typeof t == 'string') {
            n = t
            i = this._itemMap.get(n)
            o = !i
            if (i) {
              e = this._items.indexOf(i)
            }
          } else if (typeof t == 'number') {
            e = t
            i = this._items[e]
            o = !i
            if (i) {
              n = i[r]
            }
          } else {
            i = t
            n = i[r]
            e = this._items.indexOf(i)
            o = e == -1 || !this._itemMap.get(n)
          }
          if (o) {
            throw new N('collection-remove-404', this)
          }
          this._items.splice(e, 1)
          this._itemMap.delete(n)
          const s = this._bindToInternalToExternalMap.get(i)
          this._bindToInternalToExternalMap.delete(i)
          this._bindToExternalToInternalMap.delete(s)
          this.fire('remove', i, e)
          return [i, e]
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]()
        }
      }
      function cl(t) {
        const e = t.next()
        if (e.done) {
          return null
        }
        return e.value
      }
      class ll extends Qa(ht()) {
        constructor() {
          super()
          this._elements = new Set()
          this._nextEventLoopTimeout = null
          this.set('isFocused', false)
          this.set('focusedElement', null)
        }
        add(t) {
          if (this._elements.has(t)) {
            throw new N('focustracker-add-element-already-exist', this)
          }
          this.listenTo(t, 'focus', () => this._focus(t), { useCapture: true })
          this.listenTo(t, 'blur', () => this._blur(), { useCapture: true })
          this._elements.add(t)
        }
        remove(t) {
          if (t === this.focusedElement) {
            this._blur()
          }
          if (this._elements.has(t)) {
            this.stopListening(t)
            this._elements.delete(t)
          }
        }
        destroy() {
          this.stopListening()
        }
        _focus(t) {
          clearTimeout(this._nextEventLoopTimeout)
          this.focusedElement = t
          this.isFocused = true
        }
        _blur() {
          clearTimeout(this._nextEventLoopTimeout)
          this._nextEventLoopTimeout = setTimeout(() => {
            this.focusedElement = null
            this.isFocused = false
          }, 0)
        }
      }
      class dl {
        constructor() {
          this._listener = new (Qa())()
        }
        listenTo(t) {
          this._listener.listenTo(t, 'keydown', (t, e) => {
            this._listener.fire('_keydown:' + Hc(e), e)
          })
        }
        set(t, e, n = {}) {
          const i = Uc(t)
          const o = n.priority
          this._listener.listenTo(
            this._listener,
            '_keydown:' + i,
            (t, n) => {
              e(n, () => {
                n.preventDefault()
                n.stopPropagation()
                t.stop()
              })
              t.return = true
            },
            { priority: o }
          )
        }
        press(t) {
          return !!this._listener.fire('_keydown:' + Hc(t), t)
        }
        destroy() {
          this._listener.stopListening()
        }
      }
      function ul(t) {
        const e = new Map()
        for (const n in t) {
          e.set(n, t[n])
        }
        return e
      }
      function hl(t) {
        if (Et(t)) {
          return new Map(t)
        } else {
          return ul(t)
        }
      }
      const fl = 1e4
      function ml(t, e, n, i) {
        if (Math.max(e.length, t.length) > fl) {
          return t
            .slice(0, n)
            .concat(e)
            .concat(t.slice(n + i, t.length))
        } else {
          const o = Array.from(t)
          o.splice(n, i, ...e)
          return o
        }
      }
      function gl(t) {
        return (
          !!t &&
          t.length == 1 &&
          /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(
            t
          )
        )
      }
      function pl(t) {
        return !!t && t.length == 1 && /[\ud800-\udbff]/.test(t)
      }
      function bl(t) {
        return !!t && t.length == 1 && /[\udc00-\udfff]/.test(t)
      }
      function kl(t, e) {
        return pl(t.charAt(e - 1)) && bl(t.charAt(e))
      }
      function wl(t, e) {
        return gl(t.charAt(e))
      }
      const _l = vl()
      function Al(t, e) {
        const n = String(t).matchAll(_l)
        return Array.from(n).some(
          (t) => t.index < e && e < t.index + t[0].length
        )
      }
      function vl() {
        const t = [
          /\p{Emoji}[\u{E0020}-\u{E007E}]+\u{E007F}/u,
          /\p{Emoji}\u{FE0F}?\u{20E3}/u,
          /\p{Emoji}\u{FE0F}/u,
          /(?=\p{General_Category=Other_Symbol})\p{Emoji}\p{Emoji_Modifier}*/u
        ]
        const e = /\p{Regional_Indicator}{2}/u.source
        const n = '(?:' + t.map((t) => t.source).join('|') + ')'
        const i = `${e}|${n}(?:‍${n})*`
        return new RegExp(i, 'ug')
      }
      class Cl extends al {
        constructor(t = []) {
          super(t, { idProperty: 'viewUid' })
          this.on('add', (t, e, n) => {
            this._renderViewIntoCollectionParent(e, n)
          })
          this.on('remove', (t, e) => {
            if (e.element && this._parentElement) {
              e.element.remove()
            }
          })
          this._parentElement = null
        }
        destroy() {
          this.map((t) => t.destroy())
        }
        setParent(t) {
          this._parentElement = t
          for (const t of this) {
            this._renderViewIntoCollectionParent(t)
          }
        }
        delegate(...t) {
          if (!t.length || !yl(t)) {
            throw new N('ui-viewcollection-delegate-wrong-events', this)
          }
          return {
            to: (e) => {
              for (const n of this) {
                for (const i of t) {
                  n.delegate(i).to(e)
                }
              }
              this.on('add', (n, i) => {
                for (const n of t) {
                  i.delegate(n).to(e)
                }
              })
              this.on('remove', (n, i) => {
                for (const n of t) {
                  i.stopDelegating(n, e)
                }
              })
            }
          }
        }
        _renderViewIntoCollectionParent(t, e) {
          if (!t.isRendered) {
            t.render()
          }
          if (t.element && this._parentElement) {
            this._parentElement.insertBefore(
              t.element,
              this._parentElement.children[e]
            )
          }
        }
      }
      function yl(t) {
        return t.every((t) => typeof t == 'string')
      }
      var xl = __webpack_require__(3379)
      var El = __webpack_require__.n(xl)
      var Dl = __webpack_require__(6150)
      var Tl = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Tl.insert = 'head'
      Tl.singleton = true
      var Ml = El()(Dl.Z, Tl)
      const Il = Dl.Z.locals || {}
      class Sl extends Qa(ht()) {
        constructor(t) {
          super()
          this.element = null
          this.isRendered = false
          this.locale = t
          this.t = t && t.t
          this._viewCollections = new al()
          this._unboundChildren = this.createCollection()
          this._viewCollections.on('add', (e, n) => {
            n.locale = t
            n.t = t && t.t
          })
          this.decorate('render')
        }
        get bindTemplate() {
          if (this._bindTemplate) {
            return this._bindTemplate
          }
          return (this._bindTemplate = Nl.bind(this, this))
        }
        createCollection(t) {
          const e = new Cl(t)
          this._viewCollections.add(e)
          return e
        }
        registerChild(t) {
          if (!Et(t)) {
            t = [t]
          }
          for (const e of t) {
            this._unboundChildren.add(e)
          }
        }
        deregisterChild(t) {
          if (!Et(t)) {
            t = [t]
          }
          for (const e of t) {
            this._unboundChildren.remove(e)
          }
        }
        setTemplate(t) {
          this.template = new Nl(t)
        }
        extendTemplate(t) {
          Nl.extend(this.template, t)
        }
        render() {
          if (this.isRendered) {
            throw new N('ui-view-render-already-rendered', this)
          }
          if (this.template) {
            this.element = this.template.render()
            this.registerChild(this.template.getViews())
          }
          this.isRendered = true
        }
        destroy() {
          this.stopListening()
          this._viewCollections.map((t) => t.destroy())
          if (this.template && this.template._revertData) {
            this.template.revert(this.element)
          }
        }
      }
      const Bl = 'http://www.w3.org/1999/xhtml'
      class Nl extends $() {
        constructor(t) {
          super()
          Object.assign(this, Wl(Ul(t)))
          this._isRendered = false
          this._revertData = null
        }
        render() {
          const t = this._renderNode({ intoFragment: true })
          this._isRendered = true
          return t
        }
        apply(t) {
          this._revertData = od()
          this._renderNode({
            node: t,
            intoFragment: false,
            isApplying: true,
            revertData: this._revertData
          })
          return t
        }
        revert(t) {
          if (!this._revertData) {
            throw new N('ui-template-revert-not-applied', [this, t])
          }
          this._revertTemplateFromNode(t, this._revertData)
        }
        *getViews() {
          function* t(e) {
            if (e.children) {
              for (const n of e.children) {
                if (td(n)) {
                  yield n
                } else if (ed(n)) {
                  yield* t(n)
                }
              }
            }
          }
          yield* t(this)
        }
        static bind(t, e) {
          return {
            to(n, i) {
              return new zl({
                eventNameOrFunction: n,
                attribute: n,
                observable: t,
                emitter: e,
                callback: i
              })
            },
            if(n, i, o) {
              return new Ll({
                observable: t,
                emitter: e,
                attribute: n,
                valueIfTrue: i,
                callback: o
              })
            }
          }
        }
        static extend(t, e) {
          if (t._isRendered) {
            throw new N('template-extend-render', [this, t])
          }
          Jl(t, Wl(Ul(e)))
        }
        _renderNode(t) {
          let e
          if (t.node) {
            e = this.tag && this.text
          } else {
            e = this.tag ? this.text : !this.text
          }
          if (e) {
            throw new N('ui-template-wrong-syntax', this)
          }
          if (this.text) {
            return this._renderText(t)
          } else {
            return this._renderElement(t)
          }
        }
        _renderElement(t) {
          let e = t.node
          if (!e) {
            e = t.node = document.createElementNS(this.ns || Bl, this.tag)
          }
          this._renderAttributes(t)
          this._renderElementChildren(t)
          this._setUpListeners(t)
          return e
        }
        _renderText(t) {
          let e = t.node
          if (e) {
            t.revertData.text = e.textContent
          } else {
            e = t.node = document.createTextNode('')
          }
          if (Ol(this.text)) {
            this._bindToObservable({
              schema: this.text,
              updater: Fl(e),
              data: t
            })
          } else {
            e.textContent = this.text.join('')
          }
          return e
        }
        _renderAttributes(t) {
          if (!this.attributes) {
            return
          }
          const e = t.node
          const n = t.revertData
          for (const i in this.attributes) {
            const o = e.getAttribute(i)
            const r = this.attributes[i]
            if (n) {
              n.attributes[i] = o
            }
            const s = id(r) ? r[0].ns : null
            if (Ol(r)) {
              const a = id(r) ? r[0].value : r
              if (n && rd(i)) {
                a.unshift(o)
              }
              this._bindToObservable({
                schema: a,
                updater: Vl(e, i, s),
                data: t
              })
            } else if (i == 'style' && typeof r[0] !== 'string') {
              this._renderStyleAttribute(r[0], t)
            } else {
              if (n && o && rd(i)) {
                r.unshift(o)
              }
              const t = r
                .map((t) => (t ? t.value || t : t))
                .reduce((t, e) => t.concat(e), [])
                .reduce(Ql, '')
              if (!Xl(t)) {
                e.setAttributeNS(s, i, t)
              }
            }
          }
        }
        _renderStyleAttribute(t, e) {
          const n = e.node
          for (const i in t) {
            const o = t[i]
            if (Ol(o)) {
              this._bindToObservable({
                schema: [o],
                updater: Hl(n, i),
                data: e
              })
            } else {
              n.style[i] = o
            }
          }
        }
        _renderElementChildren(t) {
          const e = t.node
          const n = t.intoFragment ? document.createDocumentFragment() : e
          const i = t.isApplying
          let o = 0
          for (const r of this.children) {
            if (nd(r)) {
              if (!i) {
                r.setParent(e)
                for (const t of r) {
                  n.appendChild(t.element)
                }
              }
            } else if (td(r)) {
              if (!i) {
                if (!r.isRendered) {
                  r.render()
                }
                n.appendChild(r.element)
              }
            } else if (Ga(r)) {
              n.appendChild(r)
            } else {
              if (i) {
                const e = t.revertData
                const i = od()
                e.children.push(i)
                r._renderNode({
                  intoFragment: false,
                  node: n.childNodes[o++],
                  isApplying: true,
                  revertData: i
                })
              } else {
                n.appendChild(r.render())
              }
            }
          }
          if (t.intoFragment) {
            e.appendChild(n)
          }
        }
        _setUpListeners(t) {
          if (!this.eventListeners) {
            return
          }
          for (const e in this.eventListeners) {
            const n = this.eventListeners[e].map((n) => {
              const [i, o] = e.split('@')
              return n.activateDomEventListener(i, o, t)
            })
            if (t.revertData) {
              t.revertData.bindings.push(n)
            }
          }
        }
        _bindToObservable({ schema: t, updater: e, data: n }) {
          const i = n.revertData
          jl(t, e, n)
          const o = t
            .filter((t) => !Xl(t))
            .filter((t) => t.observable)
            .map((i) => i.activateAttributeListener(t, e, n))
          if (i) {
            i.bindings.push(o)
          }
        }
        _revertTemplateFromNode(t, e) {
          for (const t of e.bindings) {
            for (const e of t) {
              e()
            }
          }
          if (e.text) {
            t.textContent = e.text
            return
          }
          const n = t
          for (const t in e.attributes) {
            const i = e.attributes[t]
            if (i === null) {
              n.removeAttribute(t)
            } else {
              n.setAttribute(t, i)
            }
          }
          for (let t = 0; t < e.children.length; ++t) {
            this._revertTemplateFromNode(n.childNodes[t], e.children[t])
          }
        }
      }
      class Pl {
        constructor(t) {
          this.attribute = t.attribute
          this.observable = t.observable
          this.emitter = t.emitter
          this.callback = t.callback
        }
        getValue(t) {
          const e = this.observable[this.attribute]
          return this.callback ? this.callback(e, t) : e
        }
        activateAttributeListener(t, e, n) {
          const i = () => jl(t, e, n)
          this.emitter.listenTo(this.observable, `change:${this.attribute}`, i)
          return () => {
            this.emitter.stopListening(
              this.observable,
              `change:${this.attribute}`,
              i
            )
          }
        }
      }
      class zl extends Pl {
        constructor(t) {
          super(t)
          this.eventNameOrFunction = t.eventNameOrFunction
        }
        activateDomEventListener(t, e, n) {
          const i = (t, n) => {
            if (!e || n.target.matches(e)) {
              if (typeof this.eventNameOrFunction == 'function') {
                this.eventNameOrFunction(n)
              } else {
                this.observable.fire(this.eventNameOrFunction, n)
              }
            }
          }
          this.emitter.listenTo(n.node, t, i)
          return () => {
            this.emitter.stopListening(n.node, t, i)
          }
        }
      }
      class Ll extends Pl {
        constructor(t) {
          super(t)
          this.valueIfTrue = t.valueIfTrue
        }
        getValue(t) {
          const e = super.getValue(t)
          return Xl(e) ? false : this.valueIfTrue || true
        }
      }
      function Ol(t) {
        if (!t) {
          return false
        }
        if (t.value) {
          t = t.value
        }
        if (Array.isArray(t)) {
          return t.some(Ol)
        } else if (t instanceof Pl) {
          return true
        }
        return false
      }
      function Rl(t, e) {
        return t.map((t) => {
          if (t instanceof Pl) {
            return t.getValue(e)
          }
          return t
        })
      }
      function jl(t, e, { node: n }) {
        const i = Rl(t, n)
        let o
        if (t.length == 1 && t[0] instanceof Ll) {
          o = i[0]
        } else {
          o = i.reduce(Ql, '')
        }
        if (Xl(o)) {
          e.remove()
        } else {
          e.set(o)
        }
      }
      function Fl(t) {
        return {
          set(e) {
            t.textContent = e
          },
          remove() {
            t.textContent = ''
          }
        }
      }
      function Vl(t, e, n) {
        return {
          set(i) {
            t.setAttributeNS(n, e, i)
          },
          remove() {
            t.removeAttributeNS(n, e)
          }
        }
      }
      function Hl(t, e) {
        return {
          set(n) {
            t.style[e] = n
          },
          remove() {
            t.style[e] = null
          }
        }
      }
      function Ul(t) {
        const e = Va(t, (t) => {
          if (t && (t instanceof Pl || ed(t) || td(t) || nd(t))) {
            return t
          }
        })
        return e
      }
      function Wl(t) {
        if (typeof t == 'string') {
          t = Gl(t)
        } else if (t.text) {
          Yl(t)
        }
        if (t.on) {
          t.eventListeners = $l(t.on)
          delete t.on
        }
        if (!t.text) {
          if (t.attributes) {
            ql(t.attributes)
          }
          const e = []
          if (t.children) {
            if (nd(t.children)) {
              e.push(t.children)
            } else {
              for (const n of t.children) {
                if (ed(n) || td(n) || Ga(n)) {
                  e.push(n)
                } else {
                  e.push(new Nl(n))
                }
              }
            }
          }
          t.children = e
        }
        return t
      }
      function ql(t) {
        for (const e in t) {
          if (t[e].value) {
            t[e].value = Zc(t[e].value)
          }
          Kl(t, e)
        }
      }
      function $l(t) {
        for (const e in t) {
          Kl(t, e)
        }
        return t
      }
      function Gl(t) {
        return { text: [t] }
      }
      function Yl(t) {
        t.text = Zc(t.text)
      }
      function Kl(t, e) {
        t[e] = Zc(t[e])
      }
      function Ql(t, e) {
        if (Xl(e)) {
          return t
        } else if (Xl(t)) {
          return e
        } else {
          return `${t} ${e}`
        }
      }
      function Zl(t, e) {
        for (const n in e) {
          if (t[n]) {
            t[n].push(...e[n])
          } else {
            t[n] = e[n]
          }
        }
      }
      function Jl(t, e) {
        if (e.attributes) {
          if (!t.attributes) {
            t.attributes = {}
          }
          Zl(t.attributes, e.attributes)
        }
        if (e.eventListeners) {
          if (!t.eventListeners) {
            t.eventListeners = {}
          }
          Zl(t.eventListeners, e.eventListeners)
        }
        if (e.text) {
          t.text.push(...e.text)
        }
        if (e.children && e.children.length) {
          if (t.children.length != e.children.length) {
            throw new N('ui-template-extend-children-mismatch', t)
          }
          let n = 0
          for (const i of e.children) {
            Jl(t.children[n++], i)
          }
        }
      }
      function Xl(t) {
        return !t && t !== 0
      }
      function td(t) {
        return t instanceof Sl
      }
      function ed(t) {
        return t instanceof Nl
      }
      function nd(t) {
        return t instanceof Cl
      }
      function id(t) {
        return rt(t[0]) && t[0].ns
      }
      function od() {
        return { children: [], bindings: [], attributes: {} }
      }
      function rd(t) {
        return t == 'class' || t == 'style'
      }
      class sd extends Cl {
        constructor(t, e = []) {
          super(e)
          this.locale = t
        }
        attachToDom() {
          this._bodyCollectionContainer = new Nl({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-reset_all', 'ck-body', 'ck-rounded-corners'],
              dir: this.locale.uiLanguageDirection
            },
            children: this
          }).render()
          let t = document.querySelector('.ck-body-wrapper')
          if (!t) {
            t = ne(document, 'div', { class: 'ck-body-wrapper' })
            document.body.appendChild(t)
          }
          t.appendChild(this._bodyCollectionContainer)
        }
        detachFromDom() {
          super.destroy()
          if (this._bodyCollectionContainer) {
            this._bodyCollectionContainer.remove()
          }
          const t = document.querySelector('.ck-body-wrapper')
          if (t && t.childElementCount == 0) {
            t.remove()
          }
        }
      }
      var ad = __webpack_require__(1174)
      var cd = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      cd.insert = 'head'
      cd.singleton = true
      var ld = El()(ad.Z, cd)
      const dd = ad.Z.locals || {}
      class ud extends Sl {
        constructor() {
          super()
          const t = this.bindTemplate
          this.set('content', '')
          this.set('viewBox', '0 0 20 20')
          this.set('fillColor', '')
          this.set('isColorInherited', true)
          this.setTemplate({
            tag: 'svg',
            ns: 'http://www.w3.org/2000/svg',
            attributes: {
              class: [
                'ck',
                'ck-icon',
                'ck-reset_all-excluded',
                t.if('isColorInherited', 'ck-icon_inherit-color')
              ],
              viewBox: t.to('viewBox')
            }
          })
        }
        render() {
          super.render()
          this._updateXMLContent()
          this._colorFillPaths()
          this.on('change:content', () => {
            this._updateXMLContent()
            this._colorFillPaths()
          })
          this.on('change:fillColor', () => {
            this._colorFillPaths()
          })
        }
        _updateXMLContent() {
          if (this.content) {
            const t = new DOMParser().parseFromString(
              this.content.trim(),
              'image/svg+xml'
            )
            const e = t.querySelector('svg')
            const n = e.getAttribute('viewBox')
            if (n) {
              this.viewBox = n
            }
            for (const { name: t, value: n } of Array.from(e.attributes)) {
              if (ud.presentationalAttributeNames.includes(t)) {
                this.element.setAttribute(t, n)
              }
            }
            while (this.element.firstChild) {
              this.element.removeChild(this.element.firstChild)
            }
            while (e.childNodes.length > 0) {
              this.element.appendChild(e.childNodes[0])
            }
          }
        }
        _colorFillPaths() {
          if (this.fillColor) {
            this.element.querySelectorAll('.ck-icon__fill').forEach((t) => {
              t.style.fill = this.fillColor
            })
          }
        }
      }
      ud.presentationalAttributeNames = [
        'alignment-baseline',
        'baseline-shift',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-rendering',
        'cursor',
        'direction',
        'display',
        'dominant-baseline',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'image-rendering',
        'letter-spacing',
        'lighting-color',
        'marker-end',
        'marker-mid',
        'marker-start',
        'mask',
        'opacity',
        'overflow',
        'paint-order',
        'pointer-events',
        'shape-rendering',
        'stop-color',
        'stop-opacity',
        'stroke',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke-width',
        'text-anchor',
        'text-decoration',
        'text-overflow',
        'text-rendering',
        'transform',
        'unicode-bidi',
        'vector-effect',
        'visibility',
        'white-space',
        'word-spacing',
        'writing-mode'
      ]
      var hd = __webpack_require__(4499)
      var fd = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      fd.insert = 'head'
      fd.singleton = true
      var md = El()(hd.Z, fd)
      const gd = hd.Z.locals || {}
      class pd extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          const n = T()
          this.set('class', undefined)
          this.set('labelStyle', undefined)
          this.set('icon', undefined)
          this.set('isEnabled', true)
          this.set('isOn', false)
          this.set('isVisible', true)
          this.set('isToggleable', false)
          this.set('keystroke', undefined)
          this.set('label', undefined)
          this.set('tabindex', -1)
          this.set('tooltip', false)
          this.set('tooltipPosition', 's')
          this.set('type', 'button')
          this.set('withText', false)
          this.set('withKeystroke', false)
          this.children = this.createCollection()
          this.labelView = this._createLabelView(n)
          this.iconView = new ud()
          this.iconView.extendTemplate({
            attributes: { class: 'ck-button__icon' }
          })
          this.keystrokeView = this._createKeystrokeView()
          this.bind('_tooltipString').to(
            this,
            'tooltip',
            this,
            'label',
            this,
            'keystroke',
            this._getTooltipString.bind(this)
          )
          const i = {
            tag: 'button',
            attributes: {
              class: [
                'ck',
                'ck-button',
                e.to('class'),
                e.if('isEnabled', 'ck-disabled', (t) => !t),
                e.if('isVisible', 'ck-hidden', (t) => !t),
                e.to('isOn', (t) => (t ? 'ck-on' : 'ck-off')),
                e.if('withText', 'ck-button_with-text'),
                e.if('withKeystroke', 'ck-button_with-keystroke')
              ],
              type: e.to('type', (t) => (t ? t : 'button')),
              tabindex: e.to('tabindex'),
              'aria-labelledby': `ck-editor__aria-label_${n}`,
              'aria-disabled': e.if('isEnabled', true, (t) => !t),
              'aria-pressed': e.to('isOn', (t) =>
                this.isToggleable ? String(!!t) : false
              ),
              'data-cke-tooltip-text': e.to('_tooltipString'),
              'data-cke-tooltip-position': e.to('tooltipPosition')
            },
            children: this.children,
            on: {
              click: e.to((t) => {
                if (this.isEnabled) {
                  this.fire('execute')
                } else {
                  t.preventDefault()
                }
              })
            }
          }
          if (a.isSafari) {
            i.on.mousedown = e.to((t) => {
              this.focus()
              t.preventDefault()
            })
          }
          this.setTemplate(i)
        }
        render() {
          super.render()
          if (this.icon) {
            this.iconView.bind('content').to(this, 'icon')
            this.children.add(this.iconView)
          }
          this.children.add(this.labelView)
          if (this.withKeystroke && this.keystroke) {
            this.children.add(this.keystrokeView)
          }
        }
        focus() {
          this.element.focus()
        }
        _createLabelView(t) {
          const e = new Sl()
          const n = this.bindTemplate
          e.setTemplate({
            tag: 'span',
            attributes: {
              class: ['ck', 'ck-button__label'],
              style: n.to('labelStyle'),
              id: `ck-editor__aria-label_${t}`
            },
            children: [{ text: this.bindTemplate.to('label') }]
          })
          return e
        }
        _createKeystrokeView() {
          const t = new Sl()
          t.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-button__keystroke'] },
            children: [
              { text: this.bindTemplate.to('keystroke', (t) => Wc(t)) }
            ]
          })
          return t
        }
        _getTooltipString(t, e, n) {
          if (t) {
            if (typeof t == 'string') {
              return t
            } else {
              if (n) {
                n = Wc(n)
              }
              if (t instanceof Function) {
                return t(e, n)
              } else {
                return `${e}${n ? ` (${n})` : ''}`
              }
            }
          }
          return ''
        }
      }
      var bd = __webpack_require__(9681)
      var kd = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      kd.insert = 'head'
      kd.singleton = true
      var wd = El()(bd.Z, kd)
      const _d = bd.Z.locals || {}
      class Ad extends pd {
        constructor(t) {
          super(t)
          this.isToggleable = true
          this.toggleSwitchView = this._createToggleView()
          this.extendTemplate({ attributes: { class: 'ck-switchbutton' } })
        }
        render() {
          super.render()
          this.children.add(this.toggleSwitchView)
        }
        _createToggleView() {
          const t = new Sl()
          t.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-button__toggle'] },
            children: [
              {
                tag: 'span',
                attributes: { class: ['ck', 'ck-button__toggle__inner'] }
              }
            ]
          })
          return t
        }
      }
      class vd extends (null && ButtonView) {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.set('color', undefined)
          this.set('hasBorder', false)
          this.icon = checkIcon
          this.extendTemplate({
            attributes: {
              style: { backgroundColor: e.to('color') },
              class: [
                'ck',
                'ck-color-grid__tile',
                e.if('hasBorder', 'ck-color-table__color-tile_bordered')
              ]
            }
          })
        }
        render() {
          super.render()
          this.iconView.fillColor = 'hsl(0, 0%, 100%)'
        }
      }
      var Cd = __webpack_require__(4923)
      var yd = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      yd.insert = 'head'
      yd.singleton = true
      var xd = El()(Cd.Z, yd)
      const Ed = Cd.Z.locals || {}
      class Dd extends (null && View) {
        constructor(t, e) {
          super(t)
          const n = (e && e.colorDefinitions) || []
          this.columns = e && e.columns ? e.columns : 5
          const i = { gridTemplateColumns: `repeat( ${this.columns}, 1fr)` }
          this.set('selectedColor', undefined)
          this.items = this.createCollection()
          this.focusTracker = new FocusTracker()
          this.keystrokes = new KeystrokeHandler()
          this.items.on('add', (t, e) => {
            e.isOn = e.color === this.selectedColor
          })
          n.forEach((t) => {
            const e = new ColorTileView()
            e.set({
              color: t.color,
              label: t.label,
              tooltip: true,
              hasBorder: t.options.hasBorder
            })
            e.on('execute', () => {
              this.fire('execute', {
                value: t.color,
                hasBorder: t.options.hasBorder,
                label: t.label
              })
            })
            this.items.add(e)
          })
          this.setTemplate({
            tag: 'div',
            children: this.items,
            attributes: { class: ['ck', 'ck-color-grid'], style: i }
          })
          this.on('change:selectedColor', (t, e, n) => {
            for (const t of this.items) {
              t.isOn = t.color === n
            }
          })
        }
        focus() {
          if (this.items.length) {
            this.items.first.focus()
          }
        }
        focusLast() {
          if (this.items.length) {
            this.items.last.focus()
          }
        }
        render() {
          super.render()
          for (const t of this.items) {
            this.focusTracker.add(t.element)
          }
          this.items.on('add', (t, e) => {
            this.focusTracker.add(e.element)
          })
          this.items.on('remove', (t, e) => {
            this.focusTracker.remove(e.element)
          })
          this.keystrokes.listenTo(this.element)
          addKeyboardHandlingForGrid({
            keystrokeHandler: this.keystrokes,
            focusTracker: this.focusTracker,
            gridItems: this.items,
            numberOfColumns: this.columns,
            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
          })
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
        }
      }
      class Td {
        constructor(t) {
          this.editor = t
          this._components = new Map()
        }
        *names() {
          for (const t of this._components.values()) {
            yield t.originalName
          }
        }
        add(t, e) {
          this._components.set(Md(t), { callback: e, originalName: t })
        }
        create(t) {
          if (!this.has(t)) {
            throw new N('componentfactory-item-missing', this, { name: t })
          }
          return this._components.get(Md(t)).callback(this.editor.locale)
        }
        has(t) {
          return this._components.has(Md(t))
        }
      }
      function Md(t) {
        return String(t).toLowerCase()
      }
      var Id = __webpack_require__(3488)
      var Sd = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Sd.insert = 'head'
      Sd.singleton = true
      var Bd = El()(Id.Z, Sd)
      const Nd = Id.Z.locals || {}
      class Pd extends Sl {
        constructor(t, e, n) {
          super(t)
          const i = this.bindTemplate
          this.buttonView = e
          this.panelView = n
          this.set('isOpen', false)
          this.set('isEnabled', true)
          this.set('class', undefined)
          this.set('id', undefined)
          this.set('panelPosition', 'auto')
          this.keystrokes = new dl()
          this.focusTracker = new ll()
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-dropdown',
                i.to('class'),
                i.if('isEnabled', 'ck-disabled', (t) => !t)
              ],
              id: i.to('id'),
              'aria-describedby': i.to('ariaDescribedById')
            },
            children: [e, n]
          })
          e.extendTemplate({
            attributes: {
              class: ['ck-dropdown__button'],
              'data-cke-tooltip-disabled': i.to('isOpen')
            }
          })
        }
        render() {
          super.render()
          this.focusTracker.add(this.buttonView.element)
          this.focusTracker.add(this.panelView.element)
          this.listenTo(this.buttonView, 'open', () => {
            this.isOpen = !this.isOpen
          })
          this.panelView.bind('isVisible').to(this, 'isOpen')
          this.on('change:isOpen', (t, e, n) => {
            if (!n) {
              return
            }
            if (this.panelPosition === 'auto') {
              this.panelView.position = Pd._getOptimalPosition({
                element: this.panelView.element,
                target: this.buttonView.element,
                fitInViewport: true,
                positions: this._panelPositions
              }).name
            } else {
              this.panelView.position = this.panelPosition
            }
          })
          this.keystrokes.listenTo(this.element)
          const t = (t, e) => {
            if (this.isOpen) {
              this.isOpen = false
              e()
            }
          }
          this.keystrokes.set('arrowdown', (t, e) => {
            if (this.buttonView.isEnabled && !this.isOpen) {
              this.isOpen = true
              e()
            }
          })
          this.keystrokes.set('arrowright', (t, e) => {
            if (this.isOpen) {
              e()
            }
          })
          this.keystrokes.set('arrowleft', t)
          this.keystrokes.set('esc', t)
        }
        focus() {
          this.buttonView.focus()
        }
        get _panelPositions() {
          const {
            south: t,
            north: e,
            southEast: n,
            southWest: i,
            northEast: o,
            northWest: r,
            southMiddleEast: s,
            southMiddleWest: a,
            northMiddleEast: c,
            northMiddleWest: l
          } = Pd.defaultPanelPositions
          if (this.locale.uiLanguageDirection !== 'rtl') {
            return [n, i, s, a, t, o, r, c, l, e]
          } else {
            return [i, n, a, s, t, r, o, l, c, e]
          }
        }
      }
      Pd.defaultPanelPositions = {
        south: (t, e) => ({
          top: t.bottom,
          left: t.left - (e.width - t.width) / 2,
          name: 's'
        }),
        southEast: (t) => ({ top: t.bottom, left: t.left, name: 'se' }),
        southWest: (t, e) => ({
          top: t.bottom,
          left: t.left - e.width + t.width,
          name: 'sw'
        }),
        southMiddleEast: (t, e) => ({
          top: t.bottom,
          left: t.left - (e.width - t.width) / 4,
          name: 'sme'
        }),
        southMiddleWest: (t, e) => ({
          top: t.bottom,
          left: t.left - ((e.width - t.width) * 3) / 4,
          name: 'smw'
        }),
        north: (t, e) => ({
          top: t.top - e.height,
          left: t.left - (e.width - t.width) / 2,
          name: 'n'
        }),
        northEast: (t, e) => ({
          top: t.top - e.height,
          left: t.left,
          name: 'ne'
        }),
        northWest: (t, e) => ({
          top: t.top - e.height,
          left: t.left - e.width + t.width,
          name: 'nw'
        }),
        northMiddleEast: (t, e) => ({
          top: t.top - e.height,
          left: t.left - (e.width - t.width) / 4,
          name: 'nme'
        }),
        northMiddleWest: (t, e) => ({
          top: t.top - e.height,
          left: t.left - ((e.width - t.width) * 3) / 4,
          name: 'nmw'
        })
      }
      Pd._getOptimalPosition = _c
      const zd =
        '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>'
      class Ld extends pd {
        constructor(t) {
          super(t)
          this.arrowView = this._createArrowView()
          this.extendTemplate({
            attributes: {
              'aria-haspopup': true,
              'aria-expanded': this.bindTemplate.to('isOn', (t) => String(t))
            }
          })
          this.delegate('execute').to(this, 'open')
        }
        render() {
          super.render()
          this.children.add(this.arrowView)
        }
        _createArrowView() {
          const t = new ud()
          t.content = zd
          t.extendTemplate({ attributes: { class: 'ck-dropdown__arrow' } })
          return t
        }
      }
      var Od = __webpack_require__(66)
      var Rd = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Rd.insert = 'head'
      Rd.singleton = true
      var jd = El()(Od.Z, Rd)
      const Fd = Od.Z.locals || {}
      class Vd extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.set('class', undefined)
          this.set('labelStyle', undefined)
          this.set('icon', undefined)
          this.set('isEnabled', true)
          this.set('isOn', false)
          this.set('isToggleable', false)
          this.set('isVisible', true)
          this.set('keystroke', undefined)
          this.set('withKeystroke', false)
          this.set('label', undefined)
          this.set('tabindex', -1)
          this.set('tooltip', false)
          this.set('tooltipPosition', 's')
          this.set('type', 'button')
          this.set('withText', false)
          this.children = this.createCollection()
          this.actionView = this._createActionView()
          this.arrowView = this._createArrowView()
          this.keystrokes = new dl()
          this.focusTracker = new ll()
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-splitbutton',
                e.to('class'),
                e.if('isVisible', 'ck-hidden', (t) => !t),
                this.arrowView.bindTemplate.if('isOn', 'ck-splitbutton_open')
              ]
            },
            children: this.children
          })
        }
        render() {
          super.render()
          this.children.add(this.actionView)
          this.children.add(this.arrowView)
          this.focusTracker.add(this.actionView.element)
          this.focusTracker.add(this.arrowView.element)
          this.keystrokes.listenTo(this.element)
          this.keystrokes.set('arrowright', (t, e) => {
            if (this.focusTracker.focusedElement === this.actionView.element) {
              this.arrowView.focus()
              e()
            }
          })
          this.keystrokes.set('arrowleft', (t, e) => {
            if (this.focusTracker.focusedElement === this.arrowView.element) {
              this.actionView.focus()
              e()
            }
          })
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
        }
        focus() {
          this.actionView.focus()
        }
        _createActionView() {
          const t = new pd()
          t.bind(
            'icon',
            'isEnabled',
            'isOn',
            'isToggleable',
            'keystroke',
            'label',
            'tabindex',
            'tooltip',
            'tooltipPosition',
            'type',
            'withText'
          ).to(this)
          t.extendTemplate({ attributes: { class: 'ck-splitbutton__action' } })
          t.delegate('execute').to(this)
          return t
        }
        _createArrowView() {
          const t = new pd()
          const e = t.bindTemplate
          t.icon = zd
          t.extendTemplate({
            attributes: {
              class: ['ck-splitbutton__arrow'],
              'data-cke-tooltip-disabled': e.to('isOn'),
              'aria-haspopup': true,
              'aria-expanded': e.to('isOn', (t) => String(t))
            }
          })
          t.bind('isEnabled').to(this)
          t.bind('label').to(this)
          t.bind('tooltip').to(this)
          t.delegate('execute').to(this, 'open')
          return t
        }
      }
      class Hd extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.set('isVisible', false)
          this.set('position', 'se')
          this.children = this.createCollection()
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-reset',
                'ck-dropdown__panel',
                e.to('position', (t) => `ck-dropdown__panel_${t}`),
                e.if('isVisible', 'ck-dropdown__panel-visible')
              ]
            },
            children: this.children,
            on: { selectstart: e.to((t) => t.preventDefault()) }
          })
        }
        focus() {
          if (this.children.length) {
            const t = this.children.first
            if (typeof t.focus === 'function') {
              t.focus()
            } else {
              P('ui-dropdown-panel-focus-child-missing-focus', {
                childView: this.children.first,
                dropdownPanel: this
              })
            }
          }
        }
        focusLast() {
          if (this.children.length) {
            const t = this.children.last
            if (typeof t.focusLast === 'function') {
              t.focusLast()
            } else {
              t.focus()
            }
          }
        }
      }
      class Ud {
        constructor(t) {
          this.focusables = t.focusables
          this.focusTracker = t.focusTracker
          this.keystrokeHandler = t.keystrokeHandler
          this.actions = t.actions
          if (t.actions && t.keystrokeHandler) {
            for (const e in t.actions) {
              let n = t.actions[e]
              if (typeof n == 'string') {
                n = [n]
              }
              for (const i of n) {
                t.keystrokeHandler.set(i, (t, n) => {
                  this[e]()
                  n()
                })
              }
            }
          }
        }
        get first() {
          return this.focusables.find(Wd) || null
        }
        get last() {
          return this.focusables.filter(Wd).slice(-1)[0] || null
        }
        get next() {
          return this._getFocusableItem(1)
        }
        get previous() {
          return this._getFocusableItem(-1)
        }
        get current() {
          let t = null
          if (this.focusTracker.focusedElement === null) {
            return null
          }
          this.focusables.find((e, n) => {
            const i = e.element === this.focusTracker.focusedElement
            if (i) {
              t = n
            }
            return i
          })
          return t
        }
        focusFirst() {
          this._focus(this.first)
        }
        focusLast() {
          this._focus(this.last)
        }
        focusNext() {
          this._focus(this.next)
        }
        focusPrevious() {
          this._focus(this.previous)
        }
        _focus(t) {
          if (t) {
            t.focus()
          }
        }
        _getFocusableItem(t) {
          const e = this.current
          const n = this.focusables.length
          if (!n) {
            return null
          }
          if (e === null) {
            return this[t === 1 ? 'first' : 'last']
          }
          let i = (e + n + t) % n
          do {
            const e = this.focusables.get(i)
            if (Wd(e)) {
              return e
            }
            i = (i + n + t) % n
          } while (i !== e)
          return null
        }
      }
      function Wd(t) {
        return !!(t.focus && kc(t.element))
      }
      class qd extends Sl {
        constructor(t) {
          super(t)
          this.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-toolbar__separator'] }
          })
        }
      }
      class $d extends Sl {
        constructor(t) {
          super(t)
          this.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-toolbar__line-break'] }
          })
        }
      }
      function Gd(t) {
        return t.bindTemplate.to((e) => {
          if (e.target === t.element) {
            e.preventDefault()
          }
        })
      }
      function Yd(t) {
        if (Array.isArray(t)) {
          return { items: t, removeItems: [] }
        }
        if (!t) {
          return { items: [], removeItems: [] }
        }
        return Object.assign({ items: [], removeItems: [] }, t)
      }
      class Kd extends ht() {
        constructor(t) {
          super()
          this.editor = t
          this.set('isEnabled', true)
          this._disableStack = new Set()
        }
        forceDisabled(t) {
          this._disableStack.add(t)
          if (this._disableStack.size == 1) {
            this.on('set:isEnabled', Qd, { priority: 'highest' })
            this.isEnabled = false
          }
        }
        clearForceDisabled(t) {
          this._disableStack.delete(t)
          if (this._disableStack.size == 0) {
            this.off('set:isEnabled', Qd)
            this.isEnabled = true
          }
        }
        destroy() {
          this.stopListening()
        }
        static get isContextPlugin() {
          return false
        }
      }
      function Qd(t) {
        t.return = false
        t.stop()
      }
      class Zd extends ht() {
        constructor(t) {
          super()
          this.editor = t
          this.set('value', undefined)
          this.set('isEnabled', false)
          this._affectsData = true
          this._disableStack = new Set()
          this.decorate('execute')
          this.listenTo(this.editor.model.document, 'change', () => {
            this.refresh()
          })
          this.on(
            'execute',
            (t) => {
              if (!this.isEnabled) {
                t.stop()
              }
            },
            { priority: 'high' }
          )
          this.listenTo(t, 'change:isReadOnly', (t, e, n) => {
            if (n && this.affectsData) {
              this.forceDisabled('readOnlyMode')
            } else {
              this.clearForceDisabled('readOnlyMode')
            }
          })
        }
        get affectsData() {
          return this._affectsData
        }
        set affectsData(t) {
          this._affectsData = t
        }
        refresh() {
          this.isEnabled = true
        }
        forceDisabled(t) {
          this._disableStack.add(t)
          if (this._disableStack.size == 1) {
            this.on('set:isEnabled', Jd, { priority: 'highest' })
            this.isEnabled = false
          }
        }
        clearForceDisabled(t) {
          this._disableStack.delete(t)
          if (this._disableStack.size == 0) {
            this.off('set:isEnabled', Jd)
            this.refresh()
          }
        }
        execute(...t) {
          return undefined
        }
        destroy() {
          this.stopListening()
        }
      }
      function Jd(t) {
        t.return = false
        t.stop()
      }
      class Xd extends Zd {
        constructor(t) {
          super(t)
          this._childCommandsDefinitions = []
        }
        refresh() {}
        execute(...t) {
          const e = this._getFirstEnabledCommand()
          return !!e && e.execute(t)
        }
        registerChildCommand(t, e = {}) {
          S(this._childCommandsDefinitions, {
            command: t,
            priority: e.priority || 'normal'
          })
          t.on('change:isEnabled', () => this._checkEnabled())
          this._checkEnabled()
        }
        _checkEnabled() {
          this.isEnabled = !!this._getFirstEnabledCommand()
        }
        _getFirstEnabledCommand() {
          const t = this._childCommandsDefinitions.find(
            ({ command: t }) => t.isEnabled
          )
          return t && t.command
        }
      }
      class tu extends $() {
        constructor(t, e = [], n = []) {
          super()
          this._context = t
          this._plugins = new Map()
          this._availablePlugins = new Map()
          for (const t of e) {
            if (t.pluginName) {
              this._availablePlugins.set(t.pluginName, t)
            }
          }
          this._contextPlugins = new Map()
          for (const [t, e] of n) {
            this._contextPlugins.set(t, e)
            this._contextPlugins.set(e, t)
            if (t.pluginName) {
              this._availablePlugins.set(t.pluginName, t)
            }
          }
        }
        *[Symbol.iterator]() {
          for (const t of this._plugins) {
            if (typeof t[0] == 'function') {
              yield t
            }
          }
        }
        get(t) {
          const e = this._plugins.get(t)
          if (!e) {
            let e = t
            if (typeof t == 'function') {
              e = t.pluginName || t.name
            }
            throw new N('plugincollection-plugin-not-loaded', this._context, {
              plugin: e
            })
          }
          return e
        }
        has(t) {
          return this._plugins.has(t)
        }
        init(t, e = [], n = []) {
          const i = this
          const o = this._context
          h(t)
          m(t)
          const r = t.filter((t) => !d(t, e))
          const s = [...f(r)]
          _(s, n)
          const a = k(s)
          return w(a, 'init')
            .then(() => w(a, 'afterInit'))
            .then(() => a)
          function c(t) {
            return typeof t === 'function'
          }
          function l(t) {
            return c(t) && t.isContextPlugin
          }
          function d(t, e) {
            return e.some((e) => {
              if (e === t) {
                return true
              }
              if (u(t) === e) {
                return true
              }
              if (u(e) === t) {
                return true
              }
              return false
            })
          }
          function u(t) {
            return c(t) ? t.pluginName || t.name : t
          }
          function h(t, e = new Set()) {
            t.forEach((t) => {
              if (!c(t)) {
                return
              }
              if (e.has(t)) {
                return
              }
              e.add(t)
              if (t.pluginName && !i._availablePlugins.has(t.pluginName)) {
                i._availablePlugins.set(t.pluginName, t)
              }
              if (t.requires) {
                h(t.requires, e)
              }
            })
          }
          function f(t, e = new Set()) {
            return t
              .map((t) => (c(t) ? t : i._availablePlugins.get(t)))
              .reduce((t, n) => {
                if (e.has(n)) {
                  return t
                }
                e.add(n)
                if (n.requires) {
                  m(n.requires, n)
                  f(n.requires, e).forEach((e) => t.add(e))
                }
                return t.add(n)
              }, new Set())
          }
          function m(t, e = null) {
            t.map((t) => (c(t) ? t : i._availablePlugins.get(t) || t)).forEach(
              (t) => {
                g(t, e)
                p(t, e)
                b(t, e)
              }
            )
          }
          function g(t, e) {
            if (c(t)) {
              return
            }
            if (e) {
              throw new N('plugincollection-soft-required', o, {
                missingPlugin: t,
                requiredBy: u(e)
              })
            }
            throw new N('plugincollection-plugin-not-found', o, { plugin: t })
          }
          function p(t, e) {
            if (!l(e)) {
              return
            }
            if (l(t)) {
              return
            }
            throw new N('plugincollection-context-required', o, {
              plugin: u(t),
              requiredBy: u(e)
            })
          }
          function b(t, n) {
            if (!n) {
              return
            }
            if (!d(t, e)) {
              return
            }
            throw new N('plugincollection-required', o, {
              plugin: u(t),
              requiredBy: u(n)
            })
          }
          function k(t) {
            return t.map((t) => {
              let e = i._contextPlugins.get(t)
              e = e || new t(o)
              i._add(t, e)
              return e
            })
          }
          function w(t, e) {
            return t.reduce((t, n) => {
              if (!n[e]) {
                return t
              }
              if (i._contextPlugins.has(n)) {
                return t
              }
              return t.then(n[e].bind(n))
            }, Promise.resolve())
          }
          function _(t, e) {
            for (const n of e) {
              if (typeof n != 'function') {
                throw new N(
                  'plugincollection-replace-plugin-invalid-type',
                  null,
                  { pluginItem: n }
                )
              }
              const e = n.pluginName
              if (!e) {
                throw new N(
                  'plugincollection-replace-plugin-missing-name',
                  null,
                  { pluginItem: n }
                )
              }
              if (n.requires && n.requires.length) {
                throw new N(
                  'plugincollection-plugin-for-replacing-cannot-have-dependencies',
                  null,
                  { pluginName: e }
                )
              }
              const o = i._availablePlugins.get(e)
              if (!o) {
                throw new N(
                  'plugincollection-plugin-for-replacing-not-exist',
                  null,
                  { pluginName: e }
                )
              }
              const r = t.indexOf(o)
              if (r === -1) {
                if (i._contextPlugins.has(o)) {
                  return
                }
                throw new N(
                  'plugincollection-plugin-for-replacing-not-loaded',
                  null,
                  { pluginName: e }
                )
              }
              if (o.requires && o.requires.length) {
                throw new N(
                  'plugincollection-replaced-plugin-cannot-have-dependencies',
                  null,
                  { pluginName: e }
                )
              }
              t.splice(r, 1, n)
              i._availablePlugins.set(e, n)
            }
          }
        }
        destroy() {
          const t = []
          for (const [, e] of this) {
            if (
              typeof e.destroy == 'function' &&
              !this._contextPlugins.has(e)
            ) {
              t.push(e.destroy())
            }
          }
          return Promise.all(t)
        }
        _add(t, e) {
          this._plugins.set(t, e)
          const n = t.pluginName
          if (!n) {
            return
          }
          if (this._plugins.has(n)) {
            throw new N('plugincollection-plugin-name-conflict', null, {
              pluginName: n,
              plugin1: this._plugins.get(n).constructor,
              plugin2: t
            })
          }
          this._plugins.set(n, e)
        }
      }
      class eu {
        constructor(t) {
          this.config = new Wa(t, this.constructor.defaultConfig)
          const e = this.constructor.builtinPlugins
          this.config.define('plugins', e)
          this.plugins = new tu(this, e)
          const n = this.config.get('language') || {}
          this.locale = new rl({
            uiLanguage: typeof n === 'string' ? n : n.ui,
            contentLanguage: this.config.get('language.content')
          })
          this.t = this.locale.t
          this.editors = new al()
          this._contextOwner = null
        }
        initPlugins() {
          const t = this.config.get('plugins') || []
          const e = this.config.get('substitutePlugins') || []
          for (const n of t.concat(e)) {
            if (typeof n != 'function') {
              throw new N('context-initplugins-constructor-only', null, {
                Plugin: n
              })
            }
            if (n.isContextPlugin !== true) {
              throw new N('context-initplugins-invalid-plugin', null, {
                Plugin: n
              })
            }
          }
          return this.plugins.init(t, [], e)
        }
        destroy() {
          return Promise.all(Array.from(this.editors, (t) => t.destroy())).then(
            () => this.plugins.destroy()
          )
        }
        _addEditor(t, e) {
          if (this._contextOwner) {
            throw new N('context-addeditor-private-context')
          }
          this.editors.add(t)
          if (e) {
            this._contextOwner = t
          }
        }
        _removeEditor(t) {
          if (this.editors.has(t)) {
            this.editors.remove(t)
          }
          if (this._contextOwner === t) {
            return this.destroy()
          }
          return Promise.resolve()
        }
        _getEditorConfig() {
          const t = {}
          for (const e of this.config.names()) {
            if (!['plugins', 'removePlugins', 'extraPlugins'].includes(e)) {
              t[e] = this.config.get(e)
            }
          }
          return t
        }
        static create(t) {
          return new Promise((e) => {
            const n = new this(t)
            e(n.initPlugins().then(() => n))
          })
        }
      }
      class nu extends ht() {
        constructor(t) {
          super()
          this.context = t
        }
        destroy() {
          this.stopListening()
        }
        static get isContextPlugin() {
          return true
        }
      }
      var iu = __webpack_require__(8894)
      var ou = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      ou.insert = 'head'
      ou.singleton = true
      var ru = El()(iu.Z, ou)
      const su = iu.Z.locals || {}
      const au = new WeakMap()
      function cu(t) {
        const {
          view: e,
          element: n,
          text: i,
          isDirectHost: o = true,
          keepOnFocus: r = false
        } = t
        const s = e.document
        if (!au.has(s)) {
          au.set(s, new Map())
          s.registerPostFixer((t) => fu(s, t))
          s.on(
            'change:isComposing',
            () => {
              e.change((t) => fu(s, t))
            },
            { priority: 'high' }
          )
        }
        au.get(s).set(n, {
          text: i,
          isDirectHost: o,
          keepOnFocus: r,
          hostElement: o ? n : null
        })
        e.change((t) => fu(s, t))
      }
      function lu(t, e) {
        const n = e.document
        t.change((t) => {
          if (!au.has(n)) {
            return
          }
          const i = au.get(n)
          const o = i.get(e)
          t.removeAttribute('data-placeholder', o.hostElement)
          uu(t, o.hostElement)
          i.delete(e)
        })
      }
      function du(t, e) {
        if (!e.hasClass('ck-placeholder')) {
          t.addClass('ck-placeholder', e)
          return true
        }
        return false
      }
      function uu(t, e) {
        if (e.hasClass('ck-placeholder')) {
          t.removeClass('ck-placeholder', e)
          return true
        }
        return false
      }
      function hu(t, e) {
        if (!t.isAttached()) {
          return false
        }
        const n = Array.from(t.getChildren()).some((t) => !t.is('uiElement'))
        if (n) {
          return false
        }
        const i = t.document
        const o = i.selection
        const r = o.anchor
        if (i.isComposing && r && r.parent === t) {
          return false
        }
        if (e) {
          return true
        }
        if (!i.isFocused) {
          return true
        }
        return !!r && r.parent !== t
      }
      function fu(t, e) {
        const n = au.get(t)
        const i = []
        let o = false
        for (const [t, r] of n) {
          if (r.isDirectHost) {
            i.push(t)
            if (mu(e, t, r)) {
              o = true
            }
          }
        }
        for (const [t, r] of n) {
          if (r.isDirectHost) {
            continue
          }
          const n = gu(t)
          if (!n) {
            continue
          }
          if (i.includes(n)) {
            continue
          }
          r.hostElement = n
          if (mu(e, t, r)) {
            o = true
          }
        }
        return o
      }
      function mu(t, e, n) {
        const { text: i, isDirectHost: o, hostElement: r } = n
        let s = false
        if (r.getAttribute('data-placeholder') !== i) {
          t.setAttribute('data-placeholder', i, r)
          s = true
        }
        const a = o || e.childCount == 1
        if (a && hu(r, n.keepOnFocus)) {
          if (du(t, r)) {
            s = true
          }
        } else if (uu(t, r)) {
          s = true
        }
        return s
      }
      function gu(t) {
        if (t.childCount) {
          const e = t.getChild(0)
          if (
            e.is('element') &&
            !e.is('uiElement') &&
            !e.is('attributeElement')
          ) {
            return e
          }
        }
        return null
      }
      class pu {
        is() {
          throw new Error('is() method is abstract')
        }
      }
      var bu = 4
      function ku(t) {
        return Oa(t, bu)
      }
      const wu = ku
      class _u extends $(pu) {
        constructor(t) {
          super()
          this.document = t
          this.parent = null
        }
        get index() {
          let t
          if (!this.parent) {
            return null
          }
          if ((t = this.parent.getChildIndex(this)) == -1) {
            throw new N('view-node-not-found-in-parent', this)
          }
          return t
        }
        get nextSibling() {
          const t = this.index
          return (t !== null && this.parent.getChild(t + 1)) || null
        }
        get previousSibling() {
          const t = this.index
          return (t !== null && this.parent.getChild(t - 1)) || null
        }
        get root() {
          let t = this
          while (t.parent) {
            t = t.parent
          }
          return t
        }
        isAttached() {
          return this.root.is('rootElement')
        }
        getPath() {
          const t = []
          let e = this
          while (e.parent) {
            t.unshift(e.index)
            e = e.parent
          }
          return t
        }
        getAncestors(t = {}) {
          const e = []
          let n = t.includeSelf ? this : this.parent
          while (n) {
            e[t.parentFirst ? 'push' : 'unshift'](n)
            n = n.parent
          }
          return e
        }
        getCommonAncestor(t, e = {}) {
          const n = this.getAncestors(e)
          const i = t.getAncestors(e)
          let o = 0
          while (n[o] == i[o] && n[o]) {
            o++
          }
          return o === 0 ? null : n[o - 1]
        }
        isBefore(t) {
          if (this == t) {
            return false
          }
          if (this.root !== t.root) {
            return false
          }
          const e = this.getPath()
          const n = t.getPath()
          const i = xt(e, n)
          switch (i) {
            case 'prefix':
              return true
            case 'extension':
              return false
            default:
              return e[i] < n[i]
          }
        }
        isAfter(t) {
          if (this == t) {
            return false
          }
          if (this.root !== t.root) {
            return false
          }
          return !this.isBefore(t)
        }
        _remove() {
          this.parent._removeChildren(this.index)
        }
        _fireChange(t, e) {
          this.fire(`change:${t}`, e)
          if (this.parent) {
            this.parent._fireChange(t, e)
          }
        }
        toJSON() {
          const t = wu(this)
          delete t.parent
          return t
        }
      }
      _u.prototype.is = function (t) {
        return t === 'node' || t === 'view:node'
      }
      class Au extends _u {
        constructor(t, e) {
          super(t)
          this._textData = e
        }
        get data() {
          return this._textData
        }
        get _data() {
          return this.data
        }
        set _data(t) {
          this._fireChange('text', this)
          this._textData = t
        }
        isSimilar(t) {
          if (!(t instanceof Au)) {
            return false
          }
          return this === t || this.data === t.data
        }
        _clone() {
          return new Au(this.document, this.data)
        }
      }
      Au.prototype.is = function (t) {
        return (
          t === '$text' ||
          t === 'view:$text' ||
          t === 'text' ||
          t === 'view:text' ||
          t === 'node' ||
          t === 'view:node'
        )
      }
      class vu extends pu {
        constructor(t, e, n) {
          super()
          this.textNode = t
          if (e < 0 || e > t.data.length) {
            throw new N('view-textproxy-wrong-offsetintext', this)
          }
          if (n < 0 || e + n > t.data.length) {
            throw new N('view-textproxy-wrong-length', this)
          }
          this.data = t.data.substring(e, e + n)
          this.offsetInText = e
        }
        get offsetSize() {
          return this.data.length
        }
        get isPartial() {
          return this.data.length !== this.textNode.data.length
        }
        get parent() {
          return this.textNode.parent
        }
        get root() {
          return this.textNode.root
        }
        get document() {
          return this.textNode.document
        }
        getAncestors(t = {}) {
          const e = []
          let n = t.includeSelf ? this.textNode : this.parent
          while (n !== null) {
            e[t.parentFirst ? 'push' : 'unshift'](n)
            n = n.parent
          }
          return e
        }
      }
      vu.prototype.is = function (t) {
        return (
          t === '$textProxy' ||
          t === 'view:$textProxy' ||
          t === 'textProxy' ||
          t === 'view:textProxy'
        )
      }
      class Cu {
        constructor(...t) {
          this._patterns = []
          this.add(...t)
        }
        add(...t) {
          for (let e of t) {
            if (typeof e == 'string' || e instanceof RegExp) {
              e = { name: e }
            }
            this._patterns.push(e)
          }
        }
        match(...t) {
          for (const e of t) {
            for (const t of this._patterns) {
              const n = yu(e, t)
              if (n) {
                return { element: e, pattern: t, match: n }
              }
            }
          }
          return null
        }
        matchAll(...t) {
          const e = []
          for (const n of t) {
            for (const t of this._patterns) {
              const i = yu(n, t)
              if (i) {
                e.push({ element: n, pattern: t, match: i })
              }
            }
          }
          return e.length > 0 ? e : null
        }
        getElementName() {
          if (this._patterns.length !== 1) {
            return null
          }
          const t = this._patterns[0]
          const e = t.name
          return typeof t != 'function' && e && !(e instanceof RegExp)
            ? e
            : null
        }
      }
      function yu(t, e) {
        if (typeof e == 'function') {
          return e(t)
        }
        const n = {}
        if (e.name) {
          n.name = xu(e.name, t.name)
          if (!n.name) {
            return null
          }
        }
        if (e.attributes) {
          n.attributes = Iu(e.attributes, t)
          if (!n.attributes) {
            return null
          }
        }
        if (e.classes) {
          n.classes = Su(e.classes, t)
          if (!n.classes) {
            return null
          }
        }
        if (e.styles) {
          n.styles = Bu(e.styles, t)
          if (!n.styles) {
            return null
          }
        }
        return n
      }
      function xu(t, e) {
        if (t instanceof RegExp) {
          return !!e.match(t)
        }
        return t === e
      }
      function Eu(t, e, n) {
        const i = Du(t)
        const o = Array.from(e)
        const r = []
        i.forEach(([t, e]) => {
          o.forEach((i) => {
            if (Tu(t, i) && Mu(e, i, n)) {
              r.push(i)
            }
          })
        })
        if (!i.length || r.length < i.length) {
          return undefined
        }
        return r
      }
      function Du(t) {
        if (Array.isArray(t)) {
          return t.map((t) => {
            if (me(t)) {
              if (t.key === undefined || t.value === undefined) {
                P('matcher-pattern-missing-key-or-value', t)
              }
              return [t.key, t.value]
            }
            return [t, true]
          })
        }
        if (me(t)) {
          return Object.entries(t)
        }
        return [[t, true]]
      }
      function Tu(t, e) {
        return t === true || t === e || (t instanceof RegExp && e.match(t))
      }
      function Mu(t, e, n) {
        if (t === true) {
          return true
        }
        const i = n(e)
        return t === i || (t instanceof RegExp && !!String(i).match(t))
      }
      function Iu(t, e) {
        const n = new Set(e.getAttributeKeys())
        if (me(t)) {
          if (t.style !== undefined) {
            P('matcher-pattern-deprecated-attributes-style-key', t)
          }
          if (t.class !== undefined) {
            P('matcher-pattern-deprecated-attributes-class-key', t)
          }
        } else {
          n.delete('style')
          n.delete('class')
        }
        return Eu(t, n, (t) => e.getAttribute(t))
      }
      function Su(t, e) {
        return Eu(t, e.getClassNames(), () => {})
      }
      function Bu(t, e) {
        return Eu(t, e.getStyleNames(true), (t) => e.getStyle(t))
      }
      var Nu = '[object Symbol]'
      function Pu(t) {
        return typeof t == 'symbol' || (Jt(t) && Yt(t) == Nu)
      }
      const zu = Pu
      var Lu = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        Ou = /^\w*$/
      function Ru(t, e) {
        if (Qt(t)) {
          return false
        }
        var n = typeof t
        if (
          n == 'number' ||
          n == 'symbol' ||
          n == 'boolean' ||
          t == null ||
          zu(t)
        ) {
          return true
        }
        return Ou.test(t) || !Lu.test(t) || (e != null && t in Object(e))
      }
      const ju = Ru
      var Fu = 'Expected a function'
      function Vu(t, e) {
        if (typeof t != 'function' || (e != null && typeof e != 'function')) {
          throw new TypeError(Fu)
        }
        var n = function () {
          var i = arguments,
            o = e ? e.apply(this, i) : i[0],
            r = n.cache
          if (r.has(o)) {
            return r.get(o)
          }
          var s = t.apply(this, i)
          n.cache = r.set(o, s) || r
          return s
        }
        n.cache = new (Vu.Cache || Xn)()
        return n
      }
      Vu.Cache = Xn
      const Hu = Vu
      var Uu = 500
      function Wu(t) {
        var e = Hu(t, function (t) {
          if (n.size === Uu) {
            n.clear()
          }
          return t
        })
        var n = e.cache
        return e
      }
      const qu = Wu
      var $u =
        /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g
      var Gu = /\\(\\)?/g
      var Yu = qu(function (t) {
        var e = []
        if (t.charCodeAt(0) === 46) {
          e.push('')
        }
        t.replace($u, function (t, n, i, o) {
          e.push(i ? o.replace(Gu, '$1') : n || t)
        })
        return e
      })
      const Ku = Yu
      function Qu(t, e) {
        var n = -1,
          i = t == null ? 0 : t.length,
          o = Array(i)
        while (++n < i) {
          o[n] = e(t[n], n, t)
        }
        return o
      }
      const Zu = Qu
      var Ju = 1 / 0
      var Xu = Nt ? Nt.prototype : undefined,
        th = Xu ? Xu.toString : undefined
      function eh(t) {
        if (typeof t == 'string') {
          return t
        }
        if (Qt(t)) {
          return Zu(t, eh) + ''
        }
        if (zu(t)) {
          return th ? th.call(t) : ''
        }
        var e = t + ''
        return e == '0' && 1 / t == -Ju ? '-0' : e
      }
      const nh = eh
      function ih(t) {
        return t == null ? '' : nh(t)
      }
      const oh = ih
      function rh(t, e) {
        if (Qt(t)) {
          return t
        }
        return ju(t, e) ? [t] : Ku(oh(t))
      }
      const sh = rh
      function ah(t) {
        var e = t == null ? 0 : t.length
        return e ? t[e - 1] : undefined
      }
      const ch = ah
      var lh = 1 / 0
      function dh(t) {
        if (typeof t == 'string' || zu(t)) {
          return t
        }
        var e = t + ''
        return e == '0' && 1 / t == -lh ? '-0' : e
      }
      const uh = dh
      function hh(t, e) {
        e = sh(e, t)
        var n = 0,
          i = e.length
        while (t != null && n < i) {
          t = t[uh(e[n++])]
        }
        return n && n == i ? t : undefined
      }
      const fh = hh
      function mh(t, e, n) {
        var i = -1,
          o = t.length
        if (e < 0) {
          e = -e > o ? 0 : o + e
        }
        n = n > o ? o : n
        if (n < 0) {
          n += o
        }
        o = e > n ? 0 : (n - e) >>> 0
        e >>>= 0
        var r = Array(o)
        while (++i < o) {
          r[i] = t[i + e]
        }
        return r
      }
      const gh = mh
      function ph(t, e) {
        return e.length < 2 ? t : fh(t, gh(e, 0, -1))
      }
      const bh = ph
      function kh(t, e) {
        e = sh(e, t)
        t = bh(t, e)
        return t == null || delete t[uh(ch(e))]
      }
      const wh = kh
      function _h(t, e) {
        return t == null ? true : wh(t, e)
      }
      const Ah = _h
      function vh(t, e, n) {
        var i = t == null ? undefined : fh(t, e)
        return i === undefined ? n : i
      }
      const Ch = vh
      function yh(t, e, n) {
        if (
          (n !== undefined && !ke(t[e], n)) ||
          (n === undefined && !(e in t))
        ) {
          di(t, e, n)
        }
      }
      const xh = yh
      function Eh(t) {
        return function (e, n, i) {
          var o = -1,
            r = Object(e),
            s = i(e),
            a = s.length
          while (a--) {
            var c = s[t ? a : ++o]
            if (n(r[c], c, r) === false) {
              break
            }
          }
          return e
        }
      }
      const Dh = Eh
      var Th = Dh()
      const Mh = Th
      function Ih(t) {
        return Jt(t) && Ho(t)
      }
      const Sh = Ih
      function Bh(t, e) {
        if (e === 'constructor' && typeof t[e] === 'function') {
          return
        }
        if (e == '__proto__') {
          return
        }
        return t[e]
      }
      const Nh = Bh
      function Ph(t) {
        return pi(t, tr(t))
      }
      const zh = Ph
      function Lh(t, e, n, i, o, r, s) {
        var a = Nh(t, n),
          c = Nh(e, n),
          l = s.get(c)
        if (l) {
          xh(t, n, l)
          return
        }
        var d = r ? r(a, c, n + '', t, e, s) : undefined
        var u = d === undefined
        if (u) {
          var h = Qt(c),
            f = !h && zi(c),
            m = !h && !f && Do(c)
          d = c
          if (h || f || m) {
            if (Qt(a)) {
              d = a
            } else if (Sh(a)) {
              d = ur(a)
            } else if (f) {
              u = false
              d = lr(c, true)
            } else if (m) {
              u = false
              d = As(c, true)
            } else {
              d = []
            }
          } else if (me(c) || Ei(c)) {
            d = a
            if (Ei(a)) {
              d = zh(a)
            } else if (!rt(a) || $e(a)) {
              d = Gs(c)
            }
          } else {
            u = false
          }
        }
        if (u) {
          s.set(c, d)
          o(d, c, i, r, s)
          s['delete'](c)
        }
        xh(t, n, d)
      }
      const Oh = Lh
      function Rh(t, e, n, i, o) {
        if (t === e) {
          return
        }
        Mh(
          e,
          function (r, s) {
            o || (o = new oi())
            if (rt(r)) {
              Oh(t, e, s, n, Rh, i, o)
            } else {
              var a = i ? i(Nh(t, s), r, s + '', t, e, o) : undefined
              if (a === undefined) {
                a = r
              }
              xh(t, s, a)
            }
          },
          tr
        )
      }
      const jh = Rh
      function Fh(t) {
        return t
      }
      const Vh = Fh
      function Hh(t, e, n) {
        switch (n.length) {
          case 0:
            return t.call(e)
          case 1:
            return t.call(e, n[0])
          case 2:
            return t.call(e, n[0], n[1])
          case 3:
            return t.call(e, n[0], n[1], n[2])
        }
        return t.apply(e, n)
      }
      const Uh = Hh
      var Wh = Math.max
      function qh(t, e, n) {
        e = Wh(e === undefined ? t.length - 1 : e, 0)
        return function () {
          var i = arguments,
            o = -1,
            r = Wh(i.length - e, 0),
            s = Array(r)
          while (++o < r) {
            s[o] = i[e + o]
          }
          o = -1
          var a = Array(e + 1)
          while (++o < e) {
            a[o] = i[o]
          }
          a[e] = n(s)
          return Uh(t, this, a)
        }
      }
      const $h = qh
      function Gh(t) {
        return function () {
          return t
        }
      }
      const Yh = Gh
      var Kh = !ci
        ? Vh
        : function (t, e) {
            return ci(t, 'toString', {
              configurable: true,
              enumerable: false,
              value: Yh(e),
              writable: true
            })
          }
      const Qh = Kh
      var Zh = 800,
        Jh = 16
      var Xh = Date.now
      function tf(t) {
        var e = 0,
          n = 0
        return function () {
          var i = Xh(),
            o = Jh - (i - n)
          n = i
          if (o > 0) {
            if (++e >= Zh) {
              return arguments[0]
            }
          } else {
            e = 0
          }
          return t.apply(undefined, arguments)
        }
      }
      const ef = tf
      var nf = ef(Qh)
      const of = nf
      function rf(t, e) {
        return of($h(t, e, Vh), t + '')
      }
      const sf = rf
      function af(t, e, n) {
        if (!rt(n)) {
          return false
        }
        var i = typeof e
        if (
          i == 'number' ? Ho(n) && ji(e, n.length) : i == 'string' && e in n
        ) {
          return ke(n[e], t)
        }
        return false
      }
      const cf = af
      function lf(t) {
        return sf(function (e, n) {
          var i = -1,
            o = n.length,
            r = o > 1 ? n[o - 1] : undefined,
            s = o > 2 ? n[2] : undefined
          r = t.length > 3 && typeof r == 'function' ? (o--, r) : undefined
          if (s && cf(n[0], n[1], s)) {
            r = o < 3 ? undefined : r
            o = 1
          }
          e = Object(e)
          while (++i < o) {
            var a = n[i]
            if (a) {
              t(e, a, i, r)
            }
          }
          return e
        })
      }
      const df = lf
      var uf = df(function (t, e, n) {
        jh(t, e, n)
      })
      const hf = uf
      function ff(t, e, n, i) {
        if (!rt(t)) {
          return t
        }
        e = sh(e, t)
        var o = -1,
          r = e.length,
          s = r - 1,
          a = t
        while (a != null && ++o < r) {
          var c = uh(e[o]),
            l = n
          if (c === '__proto__' || c === 'constructor' || c === 'prototype') {
            return t
          }
          if (o != s) {
            var d = a[c]
            l = i ? i(d, c, a) : undefined
            if (l === undefined) {
              l = rt(d) ? d : ji(e[o + 1]) ? [] : {}
            }
          }
          mi(a, c, l)
          a = a[c]
        }
        return t
      }
      const mf = ff
      function gf(t, e, n) {
        return t == null ? t : mf(t, e, n)
      }
      const pf = gf
      class bf {
        constructor(t) {
          this._styles = {}
          this._styleProcessor = t
        }
        get isEmpty() {
          const t = Object.entries(this._styles)
          const e = Array.from(t)
          return !e.length
        }
        get size() {
          if (this.isEmpty) {
            return 0
          }
          return this.getStyleNames().length
        }
        setTo(t) {
          this.clear()
          const e = Array.from(wf(t).entries())
          for (const [t, n] of e) {
            this._styleProcessor.toNormalizedForm(t, n, this._styles)
          }
        }
        has(t) {
          if (this.isEmpty) {
            return false
          }
          const e = this._styleProcessor.getReducedForm(t, this._styles)
          const n = e.find(([e]) => e === t)
          return Array.isArray(n)
        }
        set(t, e) {
          if (rt(t)) {
            for (const [e, n] of Object.entries(t)) {
              this._styleProcessor.toNormalizedForm(e, n, this._styles)
            }
          } else {
            this._styleProcessor.toNormalizedForm(t, e, this._styles)
          }
        }
        remove(t) {
          const e = _f(t)
          Ah(this._styles, e)
          delete this._styles[t]
          this._cleanEmptyObjectsOnPath(e)
        }
        getNormalized(t) {
          return this._styleProcessor.getNormalized(t, this._styles)
        }
        toString() {
          if (this.isEmpty) {
            return ''
          }
          return (
            this._getStylesEntries()
              .map((t) => t.join(':'))
              .sort()
              .join(';') + ';'
          )
        }
        getAsString(t) {
          if (this.isEmpty) {
            return
          }
          if (this._styles[t] && !rt(this._styles[t])) {
            return this._styles[t]
          }
          const e = this._styleProcessor.getReducedForm(t, this._styles)
          const n = e.find(([e]) => e === t)
          if (Array.isArray(n)) {
            return n[1]
          }
        }
        getStyleNames(t = false) {
          if (this.isEmpty) {
            return []
          }
          if (t) {
            return this._styleProcessor.getStyleNames(this._styles)
          }
          const e = this._getStylesEntries()
          return e.map(([t]) => t)
        }
        clear() {
          this._styles = {}
        }
        _getStylesEntries() {
          const t = []
          const e = Object.keys(this._styles)
          for (const n of e) {
            t.push(...this._styleProcessor.getReducedForm(n, this._styles))
          }
          return t
        }
        _cleanEmptyObjectsOnPath(t) {
          const e = t.split('.')
          const n = e.length > 1
          if (!n) {
            return
          }
          const i = e.splice(0, e.length - 1).join('.')
          const o = Ch(this._styles, i)
          if (!o) {
            return
          }
          const r = !Array.from(Object.keys(o)).length
          if (r) {
            this.remove(i)
          }
        }
      }
      class kf {
        constructor() {
          this._normalizers = new Map()
          this._extractors = new Map()
          this._reducers = new Map()
          this._consumables = new Map()
        }
        toNormalizedForm(t, e, n) {
          if (rt(e)) {
            Af(n, _f(t), e)
            return
          }
          if (this._normalizers.has(t)) {
            const i = this._normalizers.get(t)
            const { path: o, value: r } = i(e)
            Af(n, o, r)
          } else {
            Af(n, t, e)
          }
        }
        getNormalized(t, e) {
          if (!t) {
            return hf({}, e)
          }
          if (e[t] !== undefined) {
            return e[t]
          }
          if (this._extractors.has(t)) {
            const n = this._extractors.get(t)
            if (typeof n === 'string') {
              return Ch(e, n)
            }
            const i = n(t, e)
            if (i) {
              return i
            }
          }
          return Ch(e, _f(t))
        }
        getReducedForm(t, e) {
          const n = this.getNormalized(t, e)
          if (n === undefined) {
            return []
          }
          if (this._reducers.has(t)) {
            const e = this._reducers.get(t)
            return e(n)
          }
          return [[t, n]]
        }
        getStyleNames(t) {
          const e = Array.from(this._consumables.keys()).filter((e) => {
            const n = this.getNormalized(e, t)
            if (n && typeof n == 'object') {
              return Object.keys(n).length
            }
            return n
          })
          const n = new Set([...e, ...Object.keys(t)])
          return Array.from(n.values())
        }
        getRelatedStyles(t) {
          return this._consumables.get(t) || []
        }
        setNormalizer(t, e) {
          this._normalizers.set(t, e)
        }
        setExtractor(t, e) {
          this._extractors.set(t, e)
        }
        setReducer(t, e) {
          this._reducers.set(t, e)
        }
        setStyleRelation(t, e) {
          this._mapStyleNames(t, e)
          for (const n of e) {
            this._mapStyleNames(n, [t])
          }
        }
        _mapStyleNames(t, e) {
          if (!this._consumables.has(t)) {
            this._consumables.set(t, [])
          }
          this._consumables.get(t).push(...e)
        }
      }
      function wf(t) {
        let e = null
        let n = 0
        let i = 0
        let o = null
        const r = new Map()
        if (t === '') {
          return r
        }
        if (t.charAt(t.length - 1) != ';') {
          t = t + ';'
        }
        for (let s = 0; s < t.length; s++) {
          const a = t.charAt(s)
          if (e === null) {
            switch (a) {
              case ':':
                if (!o) {
                  o = t.substr(n, s - n)
                  i = s + 1
                }
                break
              case '"':
              case "'":
                e = a
                break
              case ';': {
                const e = t.substr(i, s - i)
                if (o) {
                  r.set(o.trim(), e.trim())
                }
                o = null
                n = s + 1
                break
              }
            }
          } else if (a === e) {
            e = null
          }
        }
        return r
      }
      function _f(t) {
        return t.replace('-', '.')
      }
      function Af(t, e, n) {
        let i = n
        if (rt(n)) {
          i = hf({}, Ch(t, e), n)
        }
        pf(t, e, i)
      }
      class vf extends _u {
        constructor(t, e, n, i) {
          super(t)
          this.name = e
          this._attrs = Cf(n)
          this._children = []
          if (i) {
            this._insertChild(0, i)
          }
          this._classes = new Set()
          if (this._attrs.has('class')) {
            const t = this._attrs.get('class')
            yf(this._classes, t)
            this._attrs.delete('class')
          }
          this._styles = new bf(this.document.stylesProcessor)
          if (this._attrs.has('style')) {
            this._styles.setTo(this._attrs.get('style'))
            this._attrs.delete('style')
          }
          this._customProperties = new Map()
          this._unsafeAttributesToRender = []
        }
        get childCount() {
          return this._children.length
        }
        get isEmpty() {
          return this._children.length === 0
        }
        getChild(t) {
          return this._children[t]
        }
        getChildIndex(t) {
          return this._children.indexOf(t)
        }
        getChildren() {
          return this._children[Symbol.iterator]()
        }
        *getAttributeKeys() {
          if (this._classes.size > 0) {
            yield 'class'
          }
          if (!this._styles.isEmpty) {
            yield 'style'
          }
          yield* this._attrs.keys()
        }
        *getAttributes() {
          yield* this._attrs.entries()
          if (this._classes.size > 0) {
            yield ['class', this.getAttribute('class')]
          }
          if (!this._styles.isEmpty) {
            yield ['style', this.getAttribute('style')]
          }
        }
        getAttribute(t) {
          if (t == 'class') {
            if (this._classes.size > 0) {
              return [...this._classes].join(' ')
            }
            return undefined
          }
          if (t == 'style') {
            const t = this._styles.toString()
            return t == '' ? undefined : t
          }
          return this._attrs.get(t)
        }
        hasAttribute(t) {
          if (t == 'class') {
            return this._classes.size > 0
          }
          if (t == 'style') {
            return !this._styles.isEmpty
          }
          return this._attrs.has(t)
        }
        isSimilar(t) {
          if (!(t instanceof vf)) {
            return false
          }
          if (this === t) {
            return true
          }
          if (this.name != t.name) {
            return false
          }
          if (
            this._attrs.size !== t._attrs.size ||
            this._classes.size !== t._classes.size ||
            this._styles.size !== t._styles.size
          ) {
            return false
          }
          for (const [e, n] of this._attrs) {
            if (!t._attrs.has(e) || t._attrs.get(e) !== n) {
              return false
            }
          }
          for (const e of this._classes) {
            if (!t._classes.has(e)) {
              return false
            }
          }
          for (const e of this._styles.getStyleNames()) {
            if (
              !t._styles.has(e) ||
              t._styles.getAsString(e) !== this._styles.getAsString(e)
            ) {
              return false
            }
          }
          return true
        }
        hasClass(...t) {
          for (const e of t) {
            if (!this._classes.has(e)) {
              return false
            }
          }
          return true
        }
        getClassNames() {
          return this._classes.keys()
        }
        getStyle(t) {
          return this._styles.getAsString(t)
        }
        getNormalizedStyle(t) {
          return this._styles.getNormalized(t)
        }
        getStyleNames(t) {
          return this._styles.getStyleNames(t)
        }
        hasStyle(...t) {
          for (const e of t) {
            if (!this._styles.has(e)) {
              return false
            }
          }
          return true
        }
        findAncestor(...t) {
          const e = new Cu(...t)
          let n = this.parent
          while (n && !n.is('documentFragment')) {
            if (e.match(n)) {
              return n
            }
            n = n.parent
          }
          return null
        }
        getCustomProperty(t) {
          return this._customProperties.get(t)
        }
        *getCustomProperties() {
          yield* this._customProperties.entries()
        }
        getIdentity() {
          const t = Array.from(this._classes).sort().join(',')
          const e = this._styles.toString()
          const n = Array.from(this._attrs)
            .map((t) => `${t[0]}="${t[1]}"`)
            .sort()
            .join(' ')
          return (
            this.name +
            (t == '' ? '' : ` class="${t}"`) +
            (!e ? '' : ` style="${e}"`) +
            (n == '' ? '' : ` ${n}`)
          )
        }
        shouldRenderUnsafeAttribute(t) {
          return this._unsafeAttributesToRender.includes(t)
        }
        _clone(t = false) {
          const e = []
          if (t) {
            for (const n of this.getChildren()) {
              e.push(n._clone(t))
            }
          }
          const n = new this.constructor(
            this.document,
            this.name,
            this._attrs,
            e
          )
          n._classes = new Set(this._classes)
          n._styles.set(this._styles.getNormalized())
          n._customProperties = new Map(this._customProperties)
          n.getFillerOffset = this.getFillerOffset
          n._unsafeAttributesToRender = this._unsafeAttributesToRender
          return n
        }
        _appendChild(t) {
          return this._insertChild(this.childCount, t)
        }
        _insertChild(t, e) {
          this._fireChange('children', this)
          let n = 0
          const i = xf(this.document, e)
          for (const e of i) {
            if (e.parent !== null) {
              e._remove()
            }
            e.parent = this
            e.document = this.document
            this._children.splice(t, 0, e)
            t++
            n++
          }
          return n
        }
        _removeChildren(t, e = 1) {
          this._fireChange('children', this)
          for (let n = t; n < t + e; n++) {
            this._children[n].parent = null
          }
          return this._children.splice(t, e)
        }
        _setAttribute(t, e) {
          const n = String(e)
          this._fireChange('attributes', this)
          if (t == 'class') {
            yf(this._classes, n)
          } else if (t == 'style') {
            this._styles.setTo(n)
          } else {
            this._attrs.set(t, n)
          }
        }
        _removeAttribute(t) {
          this._fireChange('attributes', this)
          if (t == 'class') {
            if (this._classes.size > 0) {
              this._classes.clear()
              return true
            }
            return false
          }
          if (t == 'style') {
            if (!this._styles.isEmpty) {
              this._styles.clear()
              return true
            }
            return false
          }
          return this._attrs.delete(t)
        }
        _addClass(t) {
          this._fireChange('attributes', this)
          for (const e of Zc(t)) {
            this._classes.add(e)
          }
        }
        _removeClass(t) {
          this._fireChange('attributes', this)
          for (const e of Zc(t)) {
            this._classes.delete(e)
          }
        }
        _setStyle(t, e) {
          this._fireChange('attributes', this)
          if (me(t)) {
            this._styles.set(t)
          } else {
            this._styles.set(t, e)
          }
        }
        _removeStyle(t) {
          this._fireChange('attributes', this)
          for (const e of Zc(t)) {
            this._styles.remove(e)
          }
        }
        _setCustomProperty(t, e) {
          this._customProperties.set(t, e)
        }
        _removeCustomProperty(t) {
          return this._customProperties.delete(t)
        }
      }
      vf.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return e === this.name && (t === 'element' || t === 'view:element')
        }
      }
      function Cf(t) {
        const e = hl(t)
        for (const [t, n] of e) {
          if (n === null) {
            e.delete(t)
          } else if (typeof n != 'string') {
            e.set(t, String(n))
          }
        }
        return e
      }
      function yf(t, e) {
        const n = e.split(/\s+/)
        t.clear()
        n.forEach((e) => t.add(e))
      }
      function xf(t, e) {
        if (typeof e == 'string') {
          return [new Au(t, e)]
        }
        if (!Et(e)) {
          e = [e]
        }
        return Array.from(e).map((e) => {
          if (typeof e == 'string') {
            return new Au(t, e)
          }
          if (e instanceof vu) {
            return new Au(t, e.data)
          }
          return e
        })
      }
      class Ef extends vf {
        constructor(...t) {
          super(...t)
          this.getFillerOffset = Df
        }
      }
      Ef.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'containerElement' ||
            t === 'view:containerElement' ||
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return (
            e === this.name &&
            (t === 'containerElement' ||
              t === 'view:containerElement' ||
              t === 'element' ||
              t === 'view:element')
          )
        }
      }
      function Df() {
        const t = [...this.getChildren()]
        const e = t[this.childCount - 1]
        if (e && e.is('element', 'br')) {
          return this.childCount
        }
        for (const e of t) {
          if (!e.is('uiElement')) {
            return null
          }
        }
        return this.childCount
      }
      class Tf extends ht(Ef) {
        constructor(...t) {
          super(...t)
          const e = t[0]
          this.set('isReadOnly', false)
          this.set('isFocused', false)
          this.bind('isReadOnly').to(e)
          this.bind('isFocused').to(
            e,
            'isFocused',
            (t) => t && e.selection.editableElement == this
          )
          this.listenTo(e.selection, 'change', () => {
            this.isFocused = e.isFocused && e.selection.editableElement == this
          })
        }
        destroy() {
          this.stopListening()
        }
      }
      Tf.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'editableElement' ||
            t === 'view:editableElement' ||
            t === 'containerElement' ||
            t === 'view:containerElement' ||
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return (
            e === this.name &&
            (t === 'editableElement' ||
              t === 'view:editableElement' ||
              t === 'containerElement' ||
              t === 'view:containerElement' ||
              t === 'element' ||
              t === 'view:element')
          )
        }
      }
      const Mf = Symbol('rootName')
      class If extends Tf {
        constructor(t, e) {
          super(t, e)
          this.rootName = 'main'
        }
        get rootName() {
          return this.getCustomProperty(Mf)
        }
        set rootName(t) {
          this._setCustomProperty(Mf, t)
        }
        set _name(t) {
          this.name = t
        }
      }
      If.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'rootElement' ||
            t === 'view:rootElement' ||
            t === 'editableElement' ||
            t === 'view:editableElement' ||
            t === 'containerElement' ||
            t === 'view:containerElement' ||
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return (
            e === this.name &&
            (t === 'rootElement' ||
              t === 'view:rootElement' ||
              t === 'editableElement' ||
              t === 'view:editableElement' ||
              t === 'containerElement' ||
              t === 'view:containerElement' ||
              t === 'element' ||
              t === 'view:element')
          )
        }
      }
      class Sf {
        constructor(t = {}) {
          if (!t.boundaries && !t.startPosition) {
            throw new N('view-tree-walker-no-start-position', null)
          }
          if (
            t.direction &&
            t.direction != 'forward' &&
            t.direction != 'backward'
          ) {
            throw new N('view-tree-walker-unknown-direction', t.startPosition, {
              direction: t.direction
            })
          }
          this.boundaries = t.boundaries || null
          if (t.startPosition) {
            this.position = Bf._createAt(t.startPosition)
          } else {
            this.position = Bf._createAt(
              t.boundaries[t.direction == 'backward' ? 'end' : 'start']
            )
          }
          this.direction = t.direction || 'forward'
          this.singleCharacters = !!t.singleCharacters
          this.shallow = !!t.shallow
          this.ignoreElementEnd = !!t.ignoreElementEnd
          this._boundaryStartParent = this.boundaries
            ? this.boundaries.start.parent
            : null
          this._boundaryEndParent = this.boundaries
            ? this.boundaries.end.parent
            : null
        }
        [Symbol.iterator]() {
          return this
        }
        skip(t) {
          let e, n, i
          do {
            i = this.position
            ;({ done: e, value: n } = this.next())
          } while (!e && t(n))
          if (!e) {
            this.position = i
          }
        }
        next() {
          if (this.direction == 'forward') {
            return this._next()
          } else {
            return this._previous()
          }
        }
        _next() {
          let t = this.position.clone()
          const e = this.position
          const n = t.parent
          if (n.parent === null && t.offset === n.childCount) {
            return { done: true, value: undefined }
          }
          if (
            n === this._boundaryEndParent &&
            t.offset == this.boundaries.end.offset
          ) {
            return { done: true, value: undefined }
          }
          let i
          if (n instanceof Au) {
            if (t.isAtEnd) {
              this.position = Bf._createAfter(n)
              return this._next()
            }
            i = n.data[t.offset]
          } else {
            i = n.getChild(t.offset)
          }
          if (i instanceof vf) {
            if (!this.shallow) {
              t = new Bf(i, 0)
            } else {
              t.offset++
            }
            this.position = t
            return this._formatReturnValue('elementStart', i, e, t, 1)
          } else if (i instanceof Au) {
            if (this.singleCharacters) {
              t = new Bf(i, 0)
              this.position = t
              return this._next()
            } else {
              let n = i.data.length
              let o
              if (i == this._boundaryEndParent) {
                n = this.boundaries.end.offset
                o = new vu(i, 0, n)
                t = Bf._createAfter(o)
              } else {
                o = new vu(i, 0, i.data.length)
                t.offset++
              }
              this.position = t
              return this._formatReturnValue('text', o, e, t, n)
            }
          } else if (typeof i == 'string') {
            let i
            if (this.singleCharacters) {
              i = 1
            } else {
              const e =
                n === this._boundaryEndParent
                  ? this.boundaries.end.offset
                  : n.data.length
              i = e - t.offset
            }
            const o = new vu(n, t.offset, i)
            t.offset += i
            this.position = t
            return this._formatReturnValue('text', o, e, t, i)
          } else {
            t = Bf._createAfter(n)
            this.position = t
            if (this.ignoreElementEnd) {
              return this._next()
            } else {
              return this._formatReturnValue('elementEnd', n, e, t)
            }
          }
        }
        _previous() {
          let t = this.position.clone()
          const e = this.position
          const n = t.parent
          if (n.parent === null && t.offset === 0) {
            return { done: true, value: undefined }
          }
          if (
            n == this._boundaryStartParent &&
            t.offset == this.boundaries.start.offset
          ) {
            return { done: true, value: undefined }
          }
          let i
          if (n instanceof Au) {
            if (t.isAtStart) {
              this.position = Bf._createBefore(n)
              return this._previous()
            }
            i = n.data[t.offset - 1]
          } else {
            i = n.getChild(t.offset - 1)
          }
          if (i instanceof vf) {
            if (!this.shallow) {
              t = new Bf(i, i.childCount)
              this.position = t
              if (this.ignoreElementEnd) {
                return this._previous()
              } else {
                return this._formatReturnValue('elementEnd', i, e, t)
              }
            } else {
              t.offset--
              this.position = t
              return this._formatReturnValue('elementStart', i, e, t, 1)
            }
          } else if (i instanceof Au) {
            if (this.singleCharacters) {
              t = new Bf(i, i.data.length)
              this.position = t
              return this._previous()
            } else {
              let n = i.data.length
              let o
              if (i == this._boundaryStartParent) {
                const e = this.boundaries.start.offset
                o = new vu(i, e, i.data.length - e)
                n = o.data.length
                t = Bf._createBefore(o)
              } else {
                o = new vu(i, 0, i.data.length)
                t.offset--
              }
              this.position = t
              return this._formatReturnValue('text', o, e, t, n)
            }
          } else if (typeof i == 'string') {
            let i
            if (!this.singleCharacters) {
              const e =
                n === this._boundaryStartParent
                  ? this.boundaries.start.offset
                  : 0
              i = t.offset - e
            } else {
              i = 1
            }
            t.offset -= i
            const o = new vu(n, t.offset, i)
            this.position = t
            return this._formatReturnValue('text', o, e, t, i)
          } else {
            t = Bf._createBefore(n)
            this.position = t
            return this._formatReturnValue('elementStart', n, e, t, 1)
          }
        }
        _formatReturnValue(t, e, n, i, o) {
          if (e instanceof vu) {
            if (e.offsetInText + e.data.length == e.textNode.data.length) {
              if (
                this.direction == 'forward' &&
                !(this.boundaries && this.boundaries.end.isEqual(this.position))
              ) {
                i = Bf._createAfter(e.textNode)
                this.position = i
              } else {
                n = Bf._createAfter(e.textNode)
              }
            }
            if (e.offsetInText === 0) {
              if (
                this.direction == 'backward' &&
                !(
                  this.boundaries &&
                  this.boundaries.start.isEqual(this.position)
                )
              ) {
                i = Bf._createBefore(e.textNode)
                this.position = i
              } else {
                n = Bf._createBefore(e.textNode)
              }
            }
          }
          return {
            done: false,
            value: {
              type: t,
              item: e,
              previousPosition: n,
              nextPosition: i,
              length: o
            }
          }
        }
      }
      class Bf extends pu {
        constructor(t, e) {
          super()
          this.parent = t
          this.offset = e
        }
        get nodeAfter() {
          if (this.parent.is('$text')) {
            return null
          }
          return this.parent.getChild(this.offset) || null
        }
        get nodeBefore() {
          if (this.parent.is('$text')) {
            return null
          }
          return this.parent.getChild(this.offset - 1) || null
        }
        get isAtStart() {
          return this.offset === 0
        }
        get isAtEnd() {
          const t = this.parent.is('$text')
            ? this.parent.data.length
            : this.parent.childCount
          return this.offset === t
        }
        get root() {
          return this.parent.root
        }
        get editableElement() {
          let t = this.parent
          while (!(t instanceof Tf)) {
            if (t.parent) {
              t = t.parent
            } else {
              return null
            }
          }
          return t
        }
        getShiftedBy(t) {
          const e = Bf._createAt(this)
          const n = e.offset + t
          e.offset = n < 0 ? 0 : n
          return e
        }
        getLastMatchingPosition(t, e = {}) {
          e.startPosition = this
          const n = new Sf(e)
          n.skip(t)
          return n.position
        }
        getAncestors() {
          if (this.parent.is('documentFragment')) {
            return [this.parent]
          } else {
            return this.parent.getAncestors({ includeSelf: true })
          }
        }
        getCommonAncestor(t) {
          const e = this.getAncestors()
          const n = t.getAncestors()
          let i = 0
          while (e[i] == n[i] && e[i]) {
            i++
          }
          return i === 0 ? null : e[i - 1]
        }
        isEqual(t) {
          return this.parent == t.parent && this.offset == t.offset
        }
        isBefore(t) {
          return this.compareWith(t) == 'before'
        }
        isAfter(t) {
          return this.compareWith(t) == 'after'
        }
        compareWith(t) {
          if (this.root !== t.root) {
            return 'different'
          }
          if (this.isEqual(t)) {
            return 'same'
          }
          const e = this.parent.is('node') ? this.parent.getPath() : []
          const n = t.parent.is('node') ? t.parent.getPath() : []
          e.push(this.offset)
          n.push(t.offset)
          const i = xt(e, n)
          switch (i) {
            case 'prefix':
              return 'before'
            case 'extension':
              return 'after'
            default:
              return e[i] < n[i] ? 'before' : 'after'
          }
        }
        getWalker(t = {}) {
          t.startPosition = this
          return new Sf(t)
        }
        clone() {
          return new Bf(this.parent, this.offset)
        }
        static _createAt(t, e) {
          if (t instanceof Bf) {
            return new this(t.parent, t.offset)
          } else {
            const n = t
            if (e == 'end') {
              e = n.is('$text') ? n.data.length : n.childCount
            } else if (e == 'before') {
              return this._createBefore(n)
            } else if (e == 'after') {
              return this._createAfter(n)
            } else if (e !== 0 && !e) {
              throw new N('view-createpositionat-offset-required', n)
            }
            return new Bf(n, e)
          }
        }
        static _createAfter(t) {
          if (t.is('$textProxy')) {
            return new Bf(t.textNode, t.offsetInText + t.data.length)
          }
          if (!t.parent) {
            throw new N('view-position-after-root', t, { root: t })
          }
          return new Bf(t.parent, t.index + 1)
        }
        static _createBefore(t) {
          if (t.is('$textProxy')) {
            return new Bf(t.textNode, t.offsetInText)
          }
          if (!t.parent) {
            throw new N('view-position-before-root', t, { root: t })
          }
          return new Bf(t.parent, t.index)
        }
      }
      Bf.prototype.is = function (t) {
        return t === 'position' || t === 'view:position'
      }
      class Nf extends pu {
        constructor(t, e = null) {
          super()
          this.start = t.clone()
          this.end = e ? e.clone() : t.clone()
        }
        *[Symbol.iterator]() {
          yield* new Sf({ boundaries: this, ignoreElementEnd: true })
        }
        get isCollapsed() {
          return this.start.isEqual(this.end)
        }
        get isFlat() {
          return this.start.parent === this.end.parent
        }
        get root() {
          return this.start.root
        }
        getEnlarged() {
          let t = this.start.getLastMatchingPosition(Pf, {
            direction: 'backward'
          })
          let e = this.end.getLastMatchingPosition(Pf)
          if (t.parent.is('$text') && t.isAtStart) {
            t = Bf._createBefore(t.parent)
          }
          if (e.parent.is('$text') && e.isAtEnd) {
            e = Bf._createAfter(e.parent)
          }
          return new Nf(t, e)
        }
        getTrimmed() {
          let t = this.start.getLastMatchingPosition(Pf)
          if (t.isAfter(this.end) || t.isEqual(this.end)) {
            return new Nf(t, t)
          }
          let e = this.end.getLastMatchingPosition(Pf, {
            direction: 'backward'
          })
          const n = t.nodeAfter
          const i = e.nodeBefore
          if (n && n.is('$text')) {
            t = new Bf(n, 0)
          }
          if (i && i.is('$text')) {
            e = new Bf(i, i.data.length)
          }
          return new Nf(t, e)
        }
        isEqual(t) {
          return (
            this == t ||
            (this.start.isEqual(t.start) && this.end.isEqual(t.end))
          )
        }
        containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end)
        }
        containsRange(t, e = false) {
          if (t.isCollapsed) {
            e = false
          }
          const n =
            this.containsPosition(t.start) || (e && this.start.isEqual(t.start))
          const i =
            this.containsPosition(t.end) || (e && this.end.isEqual(t.end))
          return n && i
        }
        getDifference(t) {
          const e = []
          if (this.isIntersecting(t)) {
            if (this.containsPosition(t.start)) {
              e.push(new Nf(this.start, t.start))
            }
            if (this.containsPosition(t.end)) {
              e.push(new Nf(t.end, this.end))
            }
          } else {
            e.push(this.clone())
          }
          return e
        }
        getIntersection(t) {
          if (this.isIntersecting(t)) {
            let e = this.start
            let n = this.end
            if (this.containsPosition(t.start)) {
              e = t.start
            }
            if (this.containsPosition(t.end)) {
              n = t.end
            }
            return new Nf(e, n)
          }
          return null
        }
        getWalker(t = {}) {
          t.boundaries = this
          return new Sf(t)
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end)
        }
        getContainedElement() {
          if (this.isCollapsed) {
            return null
          }
          let t = this.start.nodeAfter
          let e = this.end.nodeBefore
          if (
            this.start.parent.is('$text') &&
            this.start.isAtEnd &&
            this.start.parent.nextSibling
          ) {
            t = this.start.parent.nextSibling
          }
          if (
            this.end.parent.is('$text') &&
            this.end.isAtStart &&
            this.end.parent.previousSibling
          ) {
            e = this.end.parent.previousSibling
          }
          if (t && t.is('element') && t === e) {
            return t
          }
          return null
        }
        clone() {
          return new Nf(this.start, this.end)
        }
        *getItems(t = {}) {
          t.boundaries = this
          t.ignoreElementEnd = true
          const e = new Sf(t)
          for (const t of e) {
            yield t.item
          }
        }
        *getPositions(t = {}) {
          t.boundaries = this
          const e = new Sf(t)
          yield e.position
          for (const t of e) {
            yield t.nextPosition
          }
        }
        isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start)
        }
        static _createFromParentsAndOffsets(t, e, n, i) {
          return new this(new Bf(t, e), new Bf(n, i))
        }
        static _createFromPositionAndShift(t, e) {
          const n = t
          const i = t.getShiftedBy(e)
          return e > 0 ? new this(n, i) : new this(i, n)
        }
        static _createIn(t) {
          return this._createFromParentsAndOffsets(t, 0, t, t.childCount)
        }
        static _createOn(t) {
          const e = t.is('$textProxy') ? t.offsetSize : 1
          return this._createFromPositionAndShift(Bf._createBefore(t), e)
        }
      }
      Nf.prototype.is = function (t) {
        return t === 'range' || t === 'view:range'
      }
      function Pf(t) {
        if (t.item.is('attributeElement') || t.item.is('uiElement')) {
          return true
        }
        return false
      }
      class zf extends $(pu) {
        constructor(...t) {
          super()
          this._ranges = []
          this._lastRangeBackward = false
          this._isFake = false
          this._fakeSelectionLabel = ''
          if (t.length) {
            this.setTo(...t)
          }
        }
        get isFake() {
          return this._isFake
        }
        get fakeSelectionLabel() {
          return this._fakeSelectionLabel
        }
        get anchor() {
          if (!this._ranges.length) {
            return null
          }
          const t = this._ranges[this._ranges.length - 1]
          const e = this._lastRangeBackward ? t.end : t.start
          return e.clone()
        }
        get focus() {
          if (!this._ranges.length) {
            return null
          }
          const t = this._ranges[this._ranges.length - 1]
          const e = this._lastRangeBackward ? t.start : t.end
          return e.clone()
        }
        get isCollapsed() {
          return this.rangeCount === 1 && this._ranges[0].isCollapsed
        }
        get rangeCount() {
          return this._ranges.length
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward
        }
        get editableElement() {
          if (this.anchor) {
            return this.anchor.editableElement
          }
          return null
        }
        *getRanges() {
          for (const t of this._ranges) {
            yield t.clone()
          }
        }
        getFirstRange() {
          let t = null
          for (const e of this._ranges) {
            if (!t || e.start.isBefore(t.start)) {
              t = e
            }
          }
          return t ? t.clone() : null
        }
        getLastRange() {
          let t = null
          for (const e of this._ranges) {
            if (!t || e.end.isAfter(t.end)) {
              t = e
            }
          }
          return t ? t.clone() : null
        }
        getFirstPosition() {
          const t = this.getFirstRange()
          return t ? t.start.clone() : null
        }
        getLastPosition() {
          const t = this.getLastRange()
          return t ? t.end.clone() : null
        }
        isEqual(t) {
          if (this.isFake != t.isFake) {
            return false
          }
          if (this.isFake && this.fakeSelectionLabel != t.fakeSelectionLabel) {
            return false
          }
          if (this.rangeCount != t.rangeCount) {
            return false
          } else if (this.rangeCount === 0) {
            return true
          }
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) {
            return false
          }
          for (const e of this._ranges) {
            let n = false
            for (const i of t._ranges) {
              if (e.isEqual(i)) {
                n = true
                break
              }
            }
            if (!n) {
              return false
            }
          }
          return true
        }
        isSimilar(t) {
          if (this.isBackward != t.isBackward) {
            return false
          }
          const e = yt(this.getRanges())
          const n = yt(t.getRanges())
          if (e != n) {
            return false
          }
          if (e == 0) {
            return true
          }
          for (let e of this.getRanges()) {
            e = e.getTrimmed()
            let n = false
            for (let i of t.getRanges()) {
              i = i.getTrimmed()
              if (e.start.isEqual(i.start) && e.end.isEqual(i.end)) {
                n = true
                break
              }
            }
            if (!n) {
              return false
            }
          }
          return true
        }
        getSelectedElement() {
          if (this.rangeCount !== 1) {
            return null
          }
          return this.getFirstRange().getContainedElement()
        }
        setTo(...t) {
          let [e, n, i] = t
          if (typeof n == 'object') {
            i = n
            n = undefined
          }
          if (e === null) {
            this._setRanges([])
            this._setFakeOptions(i)
          } else if (e instanceof zf || e instanceof Lf) {
            this._setRanges(e.getRanges(), e.isBackward)
            this._setFakeOptions({
              fake: e.isFake,
              label: e.fakeSelectionLabel
            })
          } else if (e instanceof Nf) {
            this._setRanges([e], i && i.backward)
            this._setFakeOptions(i)
          } else if (e instanceof Bf) {
            this._setRanges([new Nf(e)])
            this._setFakeOptions(i)
          } else if (e instanceof _u) {
            const t = !!i && !!i.backward
            let o
            if (n === undefined) {
              throw new N(
                'view-selection-setto-required-second-parameter',
                this
              )
            } else if (n == 'in') {
              o = Nf._createIn(e)
            } else if (n == 'on') {
              o = Nf._createOn(e)
            } else {
              o = new Nf(Bf._createAt(e, n))
            }
            this._setRanges([o], t)
            this._setFakeOptions(i)
          } else if (Et(e)) {
            this._setRanges(e, i && i.backward)
            this._setFakeOptions(i)
          } else {
            throw new N('view-selection-setto-not-selectable', this)
          }
          this.fire('change')
        }
        setFocus(t, e) {
          if (this.anchor === null) {
            throw new N('view-selection-setfocus-no-ranges', this)
          }
          const n = Bf._createAt(t, e)
          if (n.compareWith(this.focus) == 'same') {
            return
          }
          const i = this.anchor
          this._ranges.pop()
          if (n.compareWith(i) == 'before') {
            this._addRange(new Nf(n, i), true)
          } else {
            this._addRange(new Nf(i, n))
          }
          this.fire('change')
        }
        _setRanges(t, e = false) {
          t = Array.from(t)
          this._ranges = []
          for (const e of t) {
            this._addRange(e)
          }
          this._lastRangeBackward = !!e
        }
        _setFakeOptions(t = {}) {
          this._isFake = !!t.fake
          this._fakeSelectionLabel = t.fake ? t.label || '' : ''
        }
        _addRange(t, e = false) {
          if (!(t instanceof Nf)) {
            throw new N('view-selection-add-range-not-range', this)
          }
          this._pushRange(t)
          this._lastRangeBackward = !!e
        }
        _pushRange(t) {
          for (const e of this._ranges) {
            if (t.isIntersecting(e)) {
              throw new N('view-selection-range-intersects', this, {
                addedRange: t,
                intersectingRange: e
              })
            }
          }
          this._ranges.push(new Nf(t.start, t.end))
        }
      }
      zf.prototype.is = function (t) {
        return t === 'selection' || t === 'view:selection'
      }
      class Lf extends $(pu) {
        constructor(...t) {
          super()
          this._selection = new zf()
          this._selection.delegate('change').to(this)
          if (t.length) {
            this._selection.setTo(...t)
          }
        }
        get isFake() {
          return this._selection.isFake
        }
        get fakeSelectionLabel() {
          return this._selection.fakeSelectionLabel
        }
        get anchor() {
          return this._selection.anchor
        }
        get focus() {
          return this._selection.focus
        }
        get isCollapsed() {
          return this._selection.isCollapsed
        }
        get rangeCount() {
          return this._selection.rangeCount
        }
        get isBackward() {
          return this._selection.isBackward
        }
        get editableElement() {
          return this._selection.editableElement
        }
        get _ranges() {
          return this._selection._ranges
        }
        *getRanges() {
          yield* this._selection.getRanges()
        }
        getFirstRange() {
          return this._selection.getFirstRange()
        }
        getLastRange() {
          return this._selection.getLastRange()
        }
        getFirstPosition() {
          return this._selection.getFirstPosition()
        }
        getLastPosition() {
          return this._selection.getLastPosition()
        }
        getSelectedElement() {
          return this._selection.getSelectedElement()
        }
        isEqual(t) {
          return this._selection.isEqual(t)
        }
        isSimilar(t) {
          return this._selection.isSimilar(t)
        }
        _setTo(...t) {
          this._selection.setTo(...t)
        }
        _setFocus(t, e) {
          this._selection.setFocus(t, e)
        }
      }
      Lf.prototype.is = function (t) {
        return (
          t === 'selection' ||
          t == 'documentSelection' ||
          t == 'view:selection' ||
          t == 'view:documentSelection'
        )
      }
      class Of extends E {
        constructor(t, e, n) {
          super(t, e)
          this.startRange = n
          this._eventPhase = 'none'
          this._currentTarget = null
        }
        get eventPhase() {
          return this._eventPhase
        }
        get currentTarget() {
          return this._currentTarget
        }
      }
      const Rf = Symbol('bubbling contexts')
      function jf(t) {
        class e extends t {
          fire(t, ...e) {
            try {
              const n = t instanceof E ? t : new E(this, t)
              const i = Uf(this)
              if (!i.size) {
                return
              }
              Ff(n, 'capturing', this)
              if (Vf(i, '$capture', n, ...e)) {
                return n.return
              }
              const o = n.startRange || this.selection.getFirstRange()
              const r = o ? o.getContainedElement() : null
              const s = r ? Boolean(Hf(i, r)) : false
              let a = r || Wf(o)
              Ff(n, 'atTarget', a)
              if (!s) {
                if (Vf(i, '$text', n, ...e)) {
                  return n.return
                }
                Ff(n, 'bubbling', a)
              }
              while (a) {
                if (a.is('rootElement')) {
                  if (Vf(i, '$root', n, ...e)) {
                    return n.return
                  }
                } else if (a.is('element')) {
                  if (Vf(i, a.name, n, ...e)) {
                    return n.return
                  }
                }
                if (Vf(i, a, n, ...e)) {
                  return n.return
                }
                a = a.parent
                Ff(n, 'bubbling', a)
              }
              Ff(n, 'bubbling', this)
              Vf(i, '$document', n, ...e)
              return n.return
            } catch (t) {
              N.rethrowUnexpectedError(t, this)
            }
          }
          _addEventListener(t, e, n) {
            const i = Zc(n.context || '$document')
            const o = Uf(this)
            for (const r of i) {
              let i = o.get(r)
              if (!i) {
                i = new ($())()
                o.set(r, i)
              }
              this.listenTo(i, t, e, n)
            }
          }
          _removeEventListener(t, e) {
            const n = Uf(this)
            for (const i of n.values()) {
              this.stopListening(i, t, e)
            }
          }
        }
        return e
      }
      {
        const t = jf(Object)
        ;['fire', '_addEventListener', '_removeEventListener'].forEach((e) => {
          jf[e] = t.prototype[e]
        })
      }
      function Ff(t, e, n) {
        if (t instanceof Of) {
          t._eventPhase = e
          t._currentTarget = n
        }
      }
      function Vf(t, e, n, ...i) {
        const o = typeof e == 'string' ? t.get(e) : Hf(t, e)
        if (!o) {
          return false
        }
        o.fire(n, ...i)
        return n.stop.called
      }
      function Hf(t, e) {
        for (const [n, i] of t) {
          if (typeof n == 'function' && n(e)) {
            return i
          }
        }
        return null
      }
      function Uf(t) {
        if (!t[Rf]) {
          t[Rf] = new Map()
        }
        return t[Rf]
      }
      function Wf(t) {
        if (!t) {
          return null
        }
        const e = t.start.parent
        const n = t.end.parent
        const i = e.getPath()
        const o = n.getPath()
        return i.length > o.length ? e : n
      }
      class qf extends jf(ht()) {
        constructor(t) {
          super()
          this.selection = new Lf()
          this.roots = new al({ idProperty: 'rootName' })
          this.stylesProcessor = t
          this.set('isReadOnly', false)
          this.set('isFocused', false)
          this.set('isSelecting', false)
          this.set('isComposing', false)
          this._postFixers = new Set()
        }
        getRoot(t = 'main') {
          return this.roots.get(t)
        }
        registerPostFixer(t) {
          this._postFixers.add(t)
        }
        destroy() {
          this.roots.map((t) => t.destroy())
          this.stopListening()
        }
        _callPostFixers(t) {
          let e = false
          do {
            for (const n of this._postFixers) {
              e = n(t)
              if (e) {
                break
              }
            }
          } while (e)
        }
      }
      const $f = 10
      class Gf extends vf {
        constructor(...t) {
          super(...t)
          this.getFillerOffset = Yf
          this._priority = $f
          this._id = null
          this._clonesGroup = null
        }
        get priority() {
          return this._priority
        }
        get id() {
          return this._id
        }
        getElementsWithSameId() {
          if (this.id === null) {
            throw new N(
              'attribute-element-get-elements-with-same-id-no-id',
              this
            )
          }
          return new Set(this._clonesGroup)
        }
        isSimilar(t) {
          if (this.id !== null || t.id !== null) {
            return this.id === t.id
          }
          return super.isSimilar(t) && this.priority == t.priority
        }
        _clone(t = false) {
          const e = super._clone(t)
          e._priority = this._priority
          e._id = this._id
          return e
        }
      }
      Gf.DEFAULT_PRIORITY = $f
      Gf.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'attributeElement' ||
            t === 'view:attributeElement' ||
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return (
            e === this.name &&
            (t === 'attributeElement' ||
              t === 'view:attributeElement' ||
              t === 'element' ||
              t === 'view:element')
          )
        }
      }
      function Yf() {
        if (Kf(this)) {
          return null
        }
        let t = this.parent
        while (t && t.is('attributeElement')) {
          if (Kf(t) > 1) {
            return null
          }
          t = t.parent
        }
        if (!t || Kf(t) > 1) {
          return null
        }
        return this.childCount
      }
      function Kf(t) {
        return Array.from(t.getChildren()).filter((t) => !t.is('uiElement'))
          .length
      }
      class Qf extends vf {
        constructor(t, e, n, i) {
          super(t, e, n, i)
          this.getFillerOffset = Zf
        }
        _insertChild(t, e) {
          if (e && (e instanceof _u || Array.from(e).length > 0)) {
            throw new N('view-emptyelement-cannot-add', [this, e])
          }
          return 0
        }
      }
      Qf.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'emptyElement' ||
            t === 'view:emptyElement' ||
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return (
            e === this.name &&
            (t === 'emptyElement' ||
              t === 'view:emptyElement' ||
              t === 'element' ||
              t === 'view:element')
          )
        }
      }
      function Zf() {
        return null
      }
      class Jf extends vf {
        constructor(...t) {
          super(...t)
          this.getFillerOffset = tm
        }
        _insertChild(t, e) {
          if (e && (e instanceof _u || Array.from(e).length > 0)) {
            throw new N('view-uielement-cannot-add', [this, e])
          }
          return 0
        }
        render(t, e) {
          return this.toDomElement(t)
        }
        toDomElement(t) {
          const e = t.createElement(this.name)
          for (const t of this.getAttributeKeys()) {
            e.setAttribute(t, this.getAttribute(t))
          }
          return e
        }
      }
      Jf.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'uiElement' ||
            t === 'view:uiElement' ||
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return (
            e === this.name &&
            (t === 'uiElement' ||
              t === 'view:uiElement' ||
              t === 'element' ||
              t === 'view:element')
          )
        }
      }
      function Xf(t) {
        t.document.on('arrowKey', (e, n) => em(e, n, t.domConverter), {
          priority: 'low'
        })
      }
      function tm() {
        return null
      }
      function em(t, e, n) {
        if (e.keyCode == Fc.arrowright) {
          const t = e.domTarget.ownerDocument.defaultView.getSelection()
          const i = t.rangeCount == 1 && t.getRangeAt(0).collapsed
          if (i || e.shiftKey) {
            const e = t.focusNode
            const o = t.focusOffset
            const r = n.domPositionToView(e, o)
            if (r === null) {
              return
            }
            let s = false
            const a = r.getLastMatchingPosition((t) => {
              if (t.item.is('uiElement')) {
                s = true
              }
              if (t.item.is('uiElement') || t.item.is('attributeElement')) {
                return true
              }
              return false
            })
            if (s) {
              const e = n.viewPositionToDom(a)
              if (i) {
                t.collapse(e.parent, e.offset)
              } else {
                t.extend(e.parent, e.offset)
              }
            }
          }
        }
      }
      class nm extends vf {
        constructor(...t) {
          super(...t)
          this.getFillerOffset = im
        }
        _insertChild(t, e) {
          if (e && (e instanceof _u || Array.from(e).length > 0)) {
            throw new N('view-rawelement-cannot-add', [this, e])
          }
          return 0
        }
        render() {}
      }
      nm.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'rawElement' ||
            t === 'view:rawElement' ||
            t === this.name ||
            t === 'view:' + this.name ||
            t === 'element' ||
            t === 'view:element' ||
            t === 'node' ||
            t === 'view:node'
          )
        } else {
          return (
            e === this.name &&
            (t === 'rawElement' ||
              t === 'view:rawElement' ||
              t === 'element' ||
              t === 'view:element')
          )
        }
      }
      function im() {
        return null
      }
      class om extends $(pu) {
        constructor(t, e) {
          super()
          this.document = t
          this._children = []
          if (e) {
            this._insertChild(0, e)
          }
          this._customProperties = new Map()
        }
        [Symbol.iterator]() {
          return this._children[Symbol.iterator]()
        }
        get childCount() {
          return this._children.length
        }
        get isEmpty() {
          return this.childCount === 0
        }
        get root() {
          return this
        }
        get parent() {
          return null
        }
        getCustomProperty(t) {
          return this._customProperties.get(t)
        }
        *getCustomProperties() {
          yield* this._customProperties.entries()
        }
        _appendChild(t) {
          return this._insertChild(this.childCount, t)
        }
        getChild(t) {
          return this._children[t]
        }
        getChildIndex(t) {
          return this._children.indexOf(t)
        }
        getChildren() {
          return this._children[Symbol.iterator]()
        }
        _insertChild(t, e) {
          this._fireChange('children', this)
          let n = 0
          const i = rm(this.document, e)
          for (const e of i) {
            if (e.parent !== null) {
              e._remove()
            }
            e.parent = this
            this._children.splice(t, 0, e)
            t++
            n++
          }
          return n
        }
        _removeChildren(t, e = 1) {
          this._fireChange('children', this)
          for (let n = t; n < t + e; n++) {
            this._children[n].parent = null
          }
          return this._children.splice(t, e)
        }
        _fireChange(t, e) {
          this.fire('change:' + t, e)
        }
        _setCustomProperty(t, e) {
          this._customProperties.set(t, e)
        }
        _removeCustomProperty(t) {
          return this._customProperties.delete(t)
        }
      }
      om.prototype.is = function (t) {
        return t === 'documentFragment' || t === 'view:documentFragment'
      }
      function rm(t, e) {
        if (typeof e == 'string') {
          return [new Au(t, e)]
        }
        if (!Et(e)) {
          e = [e]
        }
        return Array.from(e).map((e) => {
          if (typeof e == 'string') {
            return new Au(t, e)
          }
          if (e instanceof vu) {
            return new Au(t, e.data)
          }
          return e
        })
      }
      class sm {
        constructor(t) {
          this.document = t
          this._cloneGroups = new Map()
          this._slotFactory = null
        }
        setSelection(...t) {
          this.document.selection._setTo(...t)
        }
        setSelectionFocus(...t) {
          this.document.selection._setFocus(...t)
        }
        createDocumentFragment(t) {
          return new om(this.document, t)
        }
        createText(t) {
          return new Au(this.document, t)
        }
        createAttributeElement(t, e, n = {}) {
          const i = new Gf(this.document, t, e)
          if (typeof n.priority === 'number') {
            i._priority = n.priority
          }
          if (n.id) {
            i._id = n.id
          }
          if (n.renderUnsafeAttributes) {
            i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes)
          }
          return i
        }
        createContainerElement(t, e, n = {}, i = {}) {
          let o = null
          if (me(n)) {
            i = n
          } else {
            o = n
          }
          const r = new Ef(this.document, t, e, o)
          if (i.renderUnsafeAttributes) {
            r._unsafeAttributesToRender.push(...i.renderUnsafeAttributes)
          }
          return r
        }
        createEditableElement(t, e, n = {}) {
          const i = new Tf(this.document, t, e)
          if (n.renderUnsafeAttributes) {
            i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes)
          }
          return i
        }
        createEmptyElement(t, e, n = {}) {
          const i = new Qf(this.document, t, e)
          if (n.renderUnsafeAttributes) {
            i._unsafeAttributesToRender.push(...n.renderUnsafeAttributes)
          }
          return i
        }
        createUIElement(t, e, n) {
          const i = new Jf(this.document, t, e)
          if (n) {
            i.render = n
          }
          return i
        }
        createRawElement(t, e, n, i = {}) {
          const o = new nm(this.document, t, e)
          if (n) {
            o.render = n
          }
          if (i.renderUnsafeAttributes) {
            o._unsafeAttributesToRender.push(...i.renderUnsafeAttributes)
          }
          return o
        }
        setAttribute(t, e, n) {
          n._setAttribute(t, e)
        }
        removeAttribute(t, e) {
          e._removeAttribute(t)
        }
        addClass(t, e) {
          e._addClass(t)
        }
        removeClass(t, e) {
          e._removeClass(t)
        }
        setStyle(t, e, n) {
          if (me(t) && n === undefined) {
            e._setStyle(t)
          } else {
            n._setStyle(t, e)
          }
        }
        removeStyle(t, e) {
          e._removeStyle(t)
        }
        setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e)
        }
        removeCustomProperty(t, e) {
          return e._removeCustomProperty(t)
        }
        breakAttributes(t) {
          if (t instanceof Bf) {
            return this._breakAttributes(t)
          } else {
            return this._breakAttributesRange(t)
          }
        }
        breakContainer(t) {
          const e = t.parent
          if (!e.is('containerElement')) {
            throw new N(
              'view-writer-break-non-container-element',
              this.document
            )
          }
          if (!e.parent) {
            throw new N('view-writer-break-root', this.document)
          }
          if (t.isAtStart) {
            return Bf._createBefore(e)
          } else if (!t.isAtEnd) {
            const n = e._clone(false)
            this.insert(Bf._createAfter(e), n)
            const i = new Nf(t, Bf._createAt(e, 'end'))
            const o = new Bf(n, 0)
            this.move(i, o)
          }
          return Bf._createAfter(e)
        }
        mergeAttributes(t) {
          const e = t.offset
          const n = t.parent
          if (n.is('$text')) {
            return t
          }
          if (n.is('attributeElement') && n.childCount === 0) {
            const t = n.parent
            const e = n.index
            n._remove()
            this._removeFromClonedElementsGroup(n)
            return this.mergeAttributes(new Bf(t, e))
          }
          const i = n.getChild(e - 1)
          const o = n.getChild(e)
          if (!i || !o) {
            return t
          }
          if (i.is('$text') && o.is('$text')) {
            return hm(i, o)
          } else if (
            i.is('attributeElement') &&
            o.is('attributeElement') &&
            i.isSimilar(o)
          ) {
            const t = i.childCount
            i._appendChild(o.getChildren())
            o._remove()
            this._removeFromClonedElementsGroup(o)
            return this.mergeAttributes(new Bf(i, t))
          }
          return t
        }
        mergeContainers(t) {
          const e = t.nodeBefore
          const n = t.nodeAfter
          if (
            !e ||
            !n ||
            !e.is('containerElement') ||
            !n.is('containerElement')
          ) {
            throw new N(
              'view-writer-merge-containers-invalid-position',
              this.document
            )
          }
          const i = e.getChild(e.childCount - 1)
          const o =
            i instanceof Au ? Bf._createAt(i, 'end') : Bf._createAt(e, 'end')
          this.move(Nf._createIn(n), Bf._createAt(e, 'end'))
          this.remove(Nf._createOn(n))
          return o
        }
        insert(t, e) {
          e = Et(e) ? [...e] : [e]
          mm(e, this.document)
          const n = e.reduce((t, e) => {
            const n = t[t.length - 1]
            const i = !e.is('uiElement')
            if (!n || n.breakAttributes != i) {
              t.push({ breakAttributes: i, nodes: [e] })
            } else {
              n.nodes.push(e)
            }
            return t
          }, [])
          let i = null
          let o = t
          for (const { nodes: t, breakAttributes: e } of n) {
            const n = this._insertNodes(o, t, e)
            if (!i) {
              i = n.start
            }
            o = n.end
          }
          if (!i) {
            return new Nf(t)
          }
          return new Nf(i, o)
        }
        remove(t) {
          const e = t instanceof Nf ? t : Nf._createOn(t)
          pm(e, this.document)
          if (e.isCollapsed) {
            return new om(this.document)
          }
          const { start: n, end: i } = this._breakAttributesRange(e, true)
          const o = n.parent
          const r = i.offset - n.offset
          const s = o._removeChildren(n.offset, r)
          for (const t of s) {
            this._removeFromClonedElementsGroup(t)
          }
          const a = this.mergeAttributes(n)
          e.start = a
          e.end = a.clone()
          return new om(this.document, s)
        }
        clear(t, e) {
          pm(t, this.document)
          const n = t.getWalker({
            direction: 'backward',
            ignoreElementEnd: true
          })
          for (const i of n) {
            const n = i.item
            let o
            if (n.is('element') && e.isSimilar(n)) {
              o = Nf._createOn(n)
            } else if (!i.nextPosition.isAfter(t.start) && n.is('$textProxy')) {
              const t = n
                .getAncestors()
                .find((t) => t.is('element') && e.isSimilar(t))
              if (t) {
                o = Nf._createIn(t)
              }
            }
            if (o) {
              if (o.end.isAfter(t.end)) {
                o.end = t.end
              }
              if (o.start.isBefore(t.start)) {
                o.start = t.start
              }
              this.remove(o)
            }
          }
        }
        move(t, e) {
          let n
          if (e.isAfter(t.end)) {
            e = this._breakAttributes(e, true)
            const i = e.parent
            const o = i.childCount
            t = this._breakAttributesRange(t, true)
            n = this.remove(t)
            e.offset += i.childCount - o
          } else {
            n = this.remove(t)
          }
          return this.insert(e, n)
        }
        wrap(t, e) {
          if (!(e instanceof Gf)) {
            throw new N('view-writer-wrap-invalid-attribute', this.document)
          }
          pm(t, this.document)
          if (!t.isCollapsed) {
            return this._wrapRange(t, e)
          } else {
            let n = t.start
            if (n.parent.is('element') && !am(n.parent)) {
              n = n.getLastMatchingPosition((t) => t.item.is('uiElement'))
            }
            n = this._wrapPosition(n, e)
            const i = this.document.selection
            if (i.isCollapsed && i.getFirstPosition().isEqual(t.start)) {
              this.setSelection(n)
            }
            return new Nf(n)
          }
        }
        unwrap(t, e) {
          if (!(e instanceof Gf)) {
            throw new N('view-writer-unwrap-invalid-attribute', this.document)
          }
          pm(t, this.document)
          if (t.isCollapsed) {
            return t
          }
          const { start: n, end: i } = this._breakAttributesRange(t, true)
          const o = n.parent
          const r = this._unwrapChildren(o, n.offset, i.offset, e)
          const s = this.mergeAttributes(r.start)
          if (!s.isEqual(r.start)) {
            r.end.offset--
          }
          const a = this.mergeAttributes(r.end)
          return new Nf(s, a)
        }
        rename(t, e) {
          const n = new Ef(this.document, t, e.getAttributes())
          this.insert(Bf._createAfter(e), n)
          this.move(Nf._createIn(e), Bf._createAt(n, 0))
          this.remove(Nf._createOn(e))
          return n
        }
        clearClonedElementsGroup(t) {
          this._cloneGroups.delete(t)
        }
        createPositionAt(t, e) {
          return Bf._createAt(t, e)
        }
        createPositionAfter(t) {
          return Bf._createAfter(t)
        }
        createPositionBefore(t) {
          return Bf._createBefore(t)
        }
        createRange(...t) {
          return new Nf(...t)
        }
        createRangeOn(t) {
          return Nf._createOn(t)
        }
        createRangeIn(t) {
          return Nf._createIn(t)
        }
        createSelection(...t) {
          return new zf(...t)
        }
        createSlot(t) {
          if (!this._slotFactory) {
            throw new N(
              'view-writer-invalid-create-slot-context',
              this.document
            )
          }
          return this._slotFactory(this, t)
        }
        _registerSlotFactory(t) {
          this._slotFactory = t
        }
        _clearSlotFactory() {
          this._slotFactory = null
        }
        _insertNodes(t, e, n) {
          let i
          if (n) {
            i = cm(t)
          } else {
            i = t.parent.is('$text') ? t.parent.parent : t.parent
          }
          if (!i) {
            throw new N('view-writer-invalid-position-container', this.document)
          }
          let o
          if (n) {
            o = this._breakAttributes(t, true)
          } else {
            o = t.parent.is('$text') ? um(t) : t
          }
          const r = i._insertChild(o.offset, e)
          for (const t of e) {
            this._addToClonedElementsGroup(t)
          }
          const s = o.getShiftedBy(r)
          const a = this.mergeAttributes(o)
          if (!a.isEqual(o)) {
            s.offset--
          }
          const c = this.mergeAttributes(s)
          return new Nf(a, c)
        }
        _wrapChildren(t, e, n, i) {
          let o = e
          const r = []
          while (o < n) {
            const e = t.getChild(o)
            const n = e.is('$text')
            const s = e.is('attributeElement')
            if (s && this._wrapAttributeElement(i, e)) {
              r.push(new Bf(t, o))
            } else if (n || !s || lm(i, e)) {
              const n = i._clone()
              e._remove()
              n._appendChild(e)
              t._insertChild(o, n)
              this._addToClonedElementsGroup(n)
              r.push(new Bf(t, o))
            } else {
              this._wrapChildren(e, 0, e.childCount, i)
            }
            o++
          }
          let s = 0
          for (const t of r) {
            t.offset -= s
            if (t.offset == e) {
              continue
            }
            const i = this.mergeAttributes(t)
            if (!i.isEqual(t)) {
              s++
              n--
            }
          }
          return Nf._createFromParentsAndOffsets(t, e, t, n)
        }
        _unwrapChildren(t, e, n, i) {
          let o = e
          const r = []
          while (o < n) {
            const e = t.getChild(o)
            if (!e.is('attributeElement')) {
              o++
              continue
            }
            if (e.isSimilar(i)) {
              const i = e.getChildren()
              const s = e.childCount
              e._remove()
              t._insertChild(o, i)
              this._removeFromClonedElementsGroup(e)
              r.push(new Bf(t, o), new Bf(t, o + s))
              o += s
              n += s - 1
              continue
            }
            if (this._unwrapAttributeElement(i, e)) {
              r.push(new Bf(t, o), new Bf(t, o + 1))
              o++
              continue
            }
            this._unwrapChildren(e, 0, e.childCount, i)
            o++
          }
          let s = 0
          for (const t of r) {
            t.offset -= s
            if (t.offset == e || t.offset == n) {
              continue
            }
            const i = this.mergeAttributes(t)
            if (!i.isEqual(t)) {
              s++
              n--
            }
          }
          return Nf._createFromParentsAndOffsets(t, e, t, n)
        }
        _wrapRange(t, e) {
          const { start: n, end: i } = this._breakAttributesRange(t, true)
          const o = n.parent
          const r = this._wrapChildren(o, n.offset, i.offset, e)
          const s = this.mergeAttributes(r.start)
          if (!s.isEqual(r.start)) {
            r.end.offset--
          }
          const a = this.mergeAttributes(r.end)
          return new Nf(s, a)
        }
        _wrapPosition(t, e) {
          if (e.isSimilar(t.parent)) {
            return dm(t.clone())
          }
          if (t.parent.is('$text')) {
            t = um(t)
          }
          const n = this.createAttributeElement('_wrapPosition-fake-element')
          n._priority = Number.POSITIVE_INFINITY
          n.isSimilar = () => false
          t.parent._insertChild(t.offset, n)
          const i = new Nf(t, t.getShiftedBy(1))
          this.wrap(i, e)
          const o = new Bf(n.parent, n.index)
          n._remove()
          const r = o.nodeBefore
          const s = o.nodeAfter
          if (r instanceof Au && s instanceof Au) {
            return hm(r, s)
          }
          return dm(o)
        }
        _wrapAttributeElement(t, e) {
          if (!bm(t, e)) {
            return false
          }
          if (t.name !== e.name || t.priority !== e.priority) {
            return false
          }
          for (const n of t.getAttributeKeys()) {
            if (n === 'class' || n === 'style') {
              continue
            }
            if (e.hasAttribute(n) && e.getAttribute(n) !== t.getAttribute(n)) {
              return false
            }
          }
          for (const n of t.getStyleNames()) {
            if (e.hasStyle(n) && e.getStyle(n) !== t.getStyle(n)) {
              return false
            }
          }
          for (const n of t.getAttributeKeys()) {
            if (n === 'class' || n === 'style') {
              continue
            }
            if (!e.hasAttribute(n)) {
              this.setAttribute(n, t.getAttribute(n), e)
            }
          }
          for (const n of t.getStyleNames()) {
            if (!e.hasStyle(n)) {
              this.setStyle(n, t.getStyle(n), e)
            }
          }
          for (const n of t.getClassNames()) {
            if (!e.hasClass(n)) {
              this.addClass(n, e)
            }
          }
          return true
        }
        _unwrapAttributeElement(t, e) {
          if (!bm(t, e)) {
            return false
          }
          if (t.name !== e.name || t.priority !== e.priority) {
            return false
          }
          for (const n of t.getAttributeKeys()) {
            if (n === 'class' || n === 'style') {
              continue
            }
            if (!e.hasAttribute(n) || e.getAttribute(n) !== t.getAttribute(n)) {
              return false
            }
          }
          if (!e.hasClass(...t.getClassNames())) {
            return false
          }
          for (const n of t.getStyleNames()) {
            if (!e.hasStyle(n) || e.getStyle(n) !== t.getStyle(n)) {
              return false
            }
          }
          for (const n of t.getAttributeKeys()) {
            if (n === 'class' || n === 'style') {
              continue
            }
            this.removeAttribute(n, e)
          }
          this.removeClass(Array.from(t.getClassNames()), e)
          this.removeStyle(Array.from(t.getStyleNames()), e)
          return true
        }
        _breakAttributesRange(t, e = false) {
          const n = t.start
          const i = t.end
          pm(t, this.document)
          if (t.isCollapsed) {
            const n = this._breakAttributes(t.start, e)
            return new Nf(n, n)
          }
          const o = this._breakAttributes(i, e)
          const r = o.parent.childCount
          const s = this._breakAttributes(n, e)
          o.offset += o.parent.childCount - r
          return new Nf(s, o)
        }
        _breakAttributes(t, e = false) {
          const n = t.offset
          const i = t.parent
          if (t.parent.is('emptyElement')) {
            throw new N('view-writer-cannot-break-empty-element', this.document)
          }
          if (t.parent.is('uiElement')) {
            throw new N('view-writer-cannot-break-ui-element', this.document)
          }
          if (t.parent.is('rawElement')) {
            throw new N('view-writer-cannot-break-raw-element', this.document)
          }
          if (!e && i.is('$text') && gm(i.parent)) {
            return t.clone()
          }
          if (gm(i)) {
            return t.clone()
          }
          if (i.is('$text')) {
            return this._breakAttributes(um(t), e)
          }
          const o = i.childCount
          if (n == o) {
            const t = new Bf(i.parent, i.index + 1)
            return this._breakAttributes(t, e)
          } else {
            if (n === 0) {
              const t = new Bf(i.parent, i.index)
              return this._breakAttributes(t, e)
            } else {
              const t = i.index + 1
              const o = i._clone()
              i.parent._insertChild(t, o)
              this._addToClonedElementsGroup(o)
              const r = i.childCount - n
              const s = i._removeChildren(n, r)
              o._appendChild(s)
              const a = new Bf(i.parent, t)
              return this._breakAttributes(a, e)
            }
          }
        }
        _addToClonedElementsGroup(t) {
          if (!t.root.is('rootElement')) {
            return
          }
          if (t.is('element')) {
            for (const e of t.getChildren()) {
              this._addToClonedElementsGroup(e)
            }
          }
          const e = t.id
          if (!e) {
            return
          }
          let n = this._cloneGroups.get(e)
          if (!n) {
            n = new Set()
            this._cloneGroups.set(e, n)
          }
          n.add(t)
          t._clonesGroup = n
        }
        _removeFromClonedElementsGroup(t) {
          if (t.is('element')) {
            for (const e of t.getChildren()) {
              this._removeFromClonedElementsGroup(e)
            }
          }
          const e = t.id
          if (!e) {
            return
          }
          const n = this._cloneGroups.get(e)
          if (!n) {
            return
          }
          n.delete(t)
        }
      }
      function am(t) {
        return Array.from(t.getChildren()).some((t) => !t.is('uiElement'))
      }
      function cm(t) {
        let e = t.parent
        while (!gm(e)) {
          if (!e) {
            return undefined
          }
          e = e.parent
        }
        return e
      }
      function lm(t, e) {
        if (t.priority < e.priority) {
          return true
        } else if (t.priority > e.priority) {
          return false
        }
        return t.getIdentity() < e.getIdentity()
      }
      function dm(t) {
        const e = t.nodeBefore
        if (e && e.is('$text')) {
          return new Bf(e, e.data.length)
        }
        const n = t.nodeAfter
        if (n && n.is('$text')) {
          return new Bf(n, 0)
        }
        return t
      }
      function um(t) {
        if (t.offset == t.parent.data.length) {
          return new Bf(t.parent.parent, t.parent.index + 1)
        }
        if (t.offset === 0) {
          return new Bf(t.parent.parent, t.parent.index)
        }
        const e = t.parent.data.slice(t.offset)
        t.parent._data = t.parent.data.slice(0, t.offset)
        t.parent.parent._insertChild(
          t.parent.index + 1,
          new Au(t.root.document, e)
        )
        return new Bf(t.parent.parent, t.parent.index + 1)
      }
      function hm(t, e) {
        const n = t.data.length
        t._data += e.data
        e._remove()
        return new Bf(t, n)
      }
      const fm = [Au, Gf, Ef, Qf, nm, Jf]
      function mm(t, e) {
        for (const n of t) {
          if (!fm.some((t) => n instanceof t)) {
            throw new N('view-writer-insert-invalid-node-type', e)
          }
          if (!n.is('$text')) {
            mm(n.getChildren(), e)
          }
        }
      }
      function gm(t) {
        return t && (t.is('containerElement') || t.is('documentFragment'))
      }
      function pm(t, e) {
        const n = cm(t.start)
        const i = cm(t.end)
        if (!n || !i || n !== i) {
          throw new N('view-writer-invalid-range-container', e)
        }
      }
      function bm(t, e) {
        return t.id === null && e.id === null
      }
      const km = (t) => t.createTextNode(' ')
      const wm = (t) => {
        const e = t.createElement('span')
        e.dataset.ckeFiller = 'true'
        e.innerText = ' '
        return e
      }
      const _m = (t) => {
        const e = t.createElement('br')
        e.dataset.ckeFiller = 'true'
        return e
      }
      const Am = 7
      const vm = '⁠'.repeat(Am)
      function Cm(t) {
        return oc(t) && t.data.substr(0, Am) === vm
      }
      function ym(t) {
        return t.data.length == Am && Cm(t)
      }
      function xm(t) {
        if (Cm(t)) {
          return t.data.slice(Am)
        } else {
          return t.data
        }
      }
      function Em(t) {
        t.document.on('arrowKey', Dm, { priority: 'low' })
      }
      function Dm(t, e) {
        if (e.keyCode == Fc.arrowleft) {
          const t = e.domTarget.ownerDocument.defaultView.getSelection()
          if (t.rangeCount == 1 && t.getRangeAt(0).collapsed) {
            const e = t.getRangeAt(0).startContainer
            const n = t.getRangeAt(0).startOffset
            if (Cm(e) && n <= Am) {
              t.collapse(e, 0)
            }
          }
        }
      }
      var Tm = __webpack_require__(4401)
      var Mm = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Mm.insert = 'head'
      Mm.singleton = true
      var Im = El()(Tm.Z, Mm)
      const Sm = Tm.Z.locals || {}
      class Bm extends ht() {
        constructor(t, e) {
          super()
          this.domDocuments = new Set()
          this.domConverter = t
          this.markedAttributes = new Set()
          this.markedChildren = new Set()
          this.markedTexts = new Set()
          this.selection = e
          this.set('isFocused', false)
          this.set('isSelecting', false)
          if (a.isBlink && !a.isAndroid) {
            this.on('change:isSelecting', () => {
              if (!this.isSelecting) {
                this.render()
              }
            })
          }
          this.set('isComposing', false)
          this.on('change:isComposing', () => {
            if (!this.isComposing) {
              this.render()
            }
          })
          this._inlineFiller = null
          this._fakeSelectionContainer = null
        }
        markToSync(t, e) {
          if (t === 'text') {
            if (this.domConverter.mapViewToDom(e.parent)) {
              this.markedTexts.add(e)
            }
          } else {
            if (!this.domConverter.mapViewToDom(e)) {
              return
            }
            if (t === 'attributes') {
              this.markedAttributes.add(e)
            } else if (t === 'children') {
              this.markedChildren.add(e)
            } else {
              throw new N('view-renderer-unknown-type', this)
            }
          }
        }
        render() {
          if (this.isComposing && !a.isAndroid) {
            return
          }
          let t = null
          const e = a.isBlink && !a.isAndroid ? !this.isSelecting : true
          for (const t of this.markedChildren) {
            this._updateChildrenMappings(t)
          }
          if (e) {
            if (this._inlineFiller && !this._isSelectionInInlineFiller()) {
              this._removeInlineFiller()
            }
            if (this._inlineFiller) {
              t = this._getInlineFillerPosition()
            } else if (this._needsInlineFillerAtSelection()) {
              t = this.selection.getFirstPosition()
              this.markedChildren.add(t.parent)
            }
          } else if (this._inlineFiller && this._inlineFiller.parentNode) {
            t = this.domConverter.domPositionToView(this._inlineFiller)
            if (t && t.parent.is('$text')) {
              t = Bf._createBefore(t.parent)
            }
          }
          for (const t of this.markedAttributes) {
            this._updateAttrs(t)
          }
          for (const e of this.markedChildren) {
            this._updateChildren(e, { inlineFillerPosition: t })
          }
          for (const e of this.markedTexts) {
            if (
              !this.markedChildren.has(e.parent) &&
              this.domConverter.mapViewToDom(e.parent)
            ) {
              this._updateText(e, { inlineFillerPosition: t })
            }
          }
          if (e) {
            if (t) {
              const e = this.domConverter.viewPositionToDom(t)
              const n = e.parent.ownerDocument
              if (!Cm(e.parent)) {
                this._inlineFiller = Pm(n, e.parent, e.offset)
              } else {
                this._inlineFiller = e.parent
              }
            } else {
              this._inlineFiller = null
            }
          }
          this._updateFocus()
          this._updateSelection()
          this.markedTexts.clear()
          this.markedAttributes.clear()
          this.markedChildren.clear()
        }
        _updateChildrenMappings(t) {
          const e = this.domConverter.mapViewToDom(t)
          if (!e) {
            return
          }
          const n = Array.from(this.domConverter.mapViewToDom(t).childNodes)
          const i = Array.from(
            this.domConverter.viewChildrenToDom(t, { withChildren: false })
          )
          const o = this._diffNodeLists(n, i)
          const r = this._findReplaceActions(o, n, i)
          if (r.indexOf('replace') !== -1) {
            const e = { equal: 0, insert: 0, delete: 0 }
            for (const o of r) {
              if (o === 'replace') {
                const o = e.equal + e.insert
                const r = e.equal + e.delete
                const s = t.getChild(o)
                if (s && !(s.is('uiElement') || s.is('rawElement'))) {
                  this._updateElementMappings(s, n[r])
                }
                Ec(i[o])
                e.equal++
              } else {
                e[o]++
              }
            }
          }
        }
        _updateElementMappings(t, e) {
          this.domConverter.unbindDomElement(e)
          this.domConverter.bindElements(e, t)
          this.markedChildren.add(t)
          this.markedAttributes.add(t)
        }
        _getInlineFillerPosition() {
          const t = this.selection.getFirstPosition()
          if (t.parent.is('$text')) {
            return Bf._createBefore(t.parent)
          } else {
            return t
          }
        }
        _isSelectionInInlineFiller() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
            return false
          }
          const t = this.selection.getFirstPosition()
          const e = this.domConverter.viewPositionToDom(t)
          if (e && oc(e.parent) && Cm(e.parent)) {
            return true
          }
          return false
        }
        _removeInlineFiller() {
          const t = this._inlineFiller
          if (!Cm(t)) {
            throw new N('view-renderer-filler-was-lost', this)
          }
          if (ym(t)) {
            t.remove()
          } else {
            t.data = t.data.substr(Am)
          }
          this._inlineFiller = null
        }
        _needsInlineFillerAtSelection() {
          if (this.selection.rangeCount != 1 || !this.selection.isCollapsed) {
            return false
          }
          const t = this.selection.getFirstPosition()
          const e = t.parent
          const n = t.offset
          if (!this.domConverter.mapViewToDom(e.root)) {
            return false
          }
          if (!e.is('element')) {
            return false
          }
          if (!Nm(e)) {
            return false
          }
          if (n === e.getFillerOffset()) {
            return false
          }
          const i = t.nodeBefore
          const o = t.nodeAfter
          if (i instanceof Au || o instanceof Au) {
            return false
          }
          if (a.isAndroid && (i || o)) {
            return false
          }
          return true
        }
        _updateText(t, e) {
          const n = this.domConverter.findCorrespondingDomText(t)
          const i = this.domConverter.viewToDom(t)
          let o = i.data
          const r = e.inlineFillerPosition
          if (r && r.parent == t.parent && r.offset == t.index) {
            o = vm + o
          }
          Vm(n, o)
        }
        _updateAttrs(t) {
          const e = this.domConverter.mapViewToDom(t)
          if (!e) {
            return
          }
          const n = Array.from(e.attributes).map((t) => t.name)
          const i = t.getAttributeKeys()
          for (const n of i) {
            this.domConverter.setDomElementAttribute(e, n, t.getAttribute(n), t)
          }
          for (const i of n) {
            if (!t.hasAttribute(i)) {
              this.domConverter.removeDomElementAttribute(e, i)
            }
          }
        }
        _updateChildren(t, e) {
          const n = this.domConverter.mapViewToDom(t)
          if (!n) {
            return
          }
          if (a.isAndroid) {
            let t = null
            for (const e of Array.from(n.childNodes)) {
              if (t && oc(t) && oc(e)) {
                n.normalize()
                break
              }
              t = e
            }
          }
          const i = e.inlineFillerPosition
          const o = n.childNodes
          const r = Array.from(
            this.domConverter.viewChildrenToDom(t, { bind: true })
          )
          if (i && i.parent === t) {
            Pm(n.ownerDocument, r, i.offset)
          }
          const s = this._diffNodeLists(o, r)
          const c = a.isAndroid
            ? this._findReplaceActions(s, o, r, { replaceText: true })
            : s
          let l = 0
          const d = new Set()
          for (const t of c) {
            if (t === 'delete') {
              d.add(o[l])
              Ec(o[l])
            } else if (t === 'equal' || t === 'replace') {
              l++
            }
          }
          l = 0
          for (const t of c) {
            if (t === 'insert') {
              pc(n, l, r[l])
              l++
            } else if (t === 'replace') {
              Vm(o[l], r[l].data)
              l++
            } else if (t === 'equal') {
              this._markDescendantTextToSync(this.domConverter.domToView(r[l]))
              l++
            }
          }
          for (const t of d) {
            if (!t.parentNode) {
              this.domConverter.unbindDomElement(t)
            }
          }
        }
        _diffNodeLists(t, e) {
          t = jm(t, this._fakeSelectionContainer)
          return v(t, e, Om.bind(null, this.domConverter))
        }
        _findReplaceActions(t, e, n, i = {}) {
          if (t.indexOf('insert') === -1 || t.indexOf('delete') === -1) {
            return t
          }
          let o = []
          let r = []
          let s = []
          const a = { equal: 0, insert: 0, delete: 0 }
          for (const c of t) {
            if (c === 'insert') {
              s.push(n[a.equal + a.insert])
            } else if (c === 'delete') {
              r.push(e[a.equal + a.delete])
            } else {
              o = o.concat(
                v(r, s, i.replaceText ? Lm : zm).map((t) =>
                  t === 'equal' ? 'replace' : t
                )
              )
              o.push('equal')
              r = []
              s = []
            }
            a[c]++
          }
          return o.concat(
            v(r, s, i.replaceText ? Lm : zm).map((t) =>
              t === 'equal' ? 'replace' : t
            )
          )
        }
        _markDescendantTextToSync(t) {
          if (!t) {
            return
          }
          if (t.is('$text')) {
            this.markedTexts.add(t)
          } else if (t.is('element')) {
            for (const e of t.getChildren()) {
              this._markDescendantTextToSync(e)
            }
          }
        }
        _updateSelection() {
          if (
            a.isBlink &&
            !a.isAndroid &&
            this.isSelecting &&
            !this.markedChildren.size
          ) {
            return
          }
          if (this.selection.rangeCount === 0) {
            this._removeDomSelection()
            this._removeFakeSelection()
            return
          }
          const t = this.domConverter.mapViewToDom(
            this.selection.editableElement
          )
          if (!this.isFocused || !t) {
            return
          }
          if (this.selection.isFake) {
            this._updateFakeSelection(t)
          } else if (
            this._fakeSelectionContainer &&
            this._fakeSelectionContainer.isConnected
          ) {
            this._removeFakeSelection()
            this._updateDomSelection(t)
          } else if (!(this.isComposing && a.isAndroid)) {
            this._updateDomSelection(t)
          }
        }
        _updateFakeSelection(t) {
          const e = t.ownerDocument
          if (!this._fakeSelectionContainer) {
            this._fakeSelectionContainer = Fm(e)
          }
          const n = this._fakeSelectionContainer
          this.domConverter.bindFakeSelection(n, this.selection)
          if (!this._fakeSelectionNeedsUpdate(t)) {
            return
          }
          if (!n.parentElement || n.parentElement != t) {
            t.appendChild(n)
          }
          n.textContent = this.selection.fakeSelectionLabel || ' '
          const i = e.getSelection()
          const o = e.createRange()
          i.removeAllRanges()
          o.selectNodeContents(n)
          i.addRange(o)
        }
        _updateDomSelection(t) {
          const e = t.ownerDocument.defaultView.getSelection()
          if (!this._domSelectionNeedsUpdate(e)) {
            return
          }
          const n = this.domConverter.viewPositionToDom(this.selection.anchor)
          const i = this.domConverter.viewPositionToDom(this.selection.focus)
          e.collapse(n.parent, n.offset)
          e.extend(i.parent, i.offset)
          if (a.isGecko) {
            Rm(i, e)
          }
        }
        _domSelectionNeedsUpdate(t) {
          if (!this.domConverter.isDomSelectionCorrect(t)) {
            return true
          }
          const e = t && this.domConverter.domSelectionToView(t)
          if (e && this.selection.isEqual(e)) {
            return false
          }
          if (!this.selection.isCollapsed && this.selection.isSimilar(e)) {
            return false
          }
          return true
        }
        _fakeSelectionNeedsUpdate(t) {
          const e = this._fakeSelectionContainer
          const n = t.ownerDocument.getSelection()
          if (!e || e.parentElement !== t) {
            return true
          }
          if (n.anchorNode !== e && !e.contains(n.anchorNode)) {
            return true
          }
          return e.textContent !== this.selection.fakeSelectionLabel
        }
        _removeDomSelection() {
          for (const t of this.domDocuments) {
            const e = t.getSelection()
            if (e.rangeCount) {
              const n = t.activeElement
              const i = this.domConverter.mapDomToView(n)
              if (n && i) {
                e.removeAllRanges()
              }
            }
          }
        }
        _removeFakeSelection() {
          const t = this._fakeSelectionContainer
          if (t) {
            t.remove()
          }
        }
        _updateFocus() {
          if (this.isFocused) {
            const t = this.selection.editableElement
            if (t) {
              this.domConverter.focus(t)
            }
          }
        }
      }
      function Nm(t) {
        if (t.getAttribute('contenteditable') == 'false') {
          return false
        }
        const e = t.findAncestor((t) => t.hasAttribute('contenteditable'))
        return !e || e.getAttribute('contenteditable') == 'true'
      }
      function Pm(t, e, n) {
        const i = e instanceof Array ? e : e.childNodes
        const o = i[n]
        if (oc(o)) {
          o.data = vm + o.data
          return o
        } else {
          const o = t.createTextNode(vm)
          if (Array.isArray(e)) {
            i.splice(n, 0, o)
          } else {
            pc(e, n, o)
          }
          return o
        }
      }
      function zm(t, e) {
        return (
          Ga(t) &&
          Ga(e) &&
          !oc(t) &&
          !oc(e) &&
          !bc(t) &&
          !bc(e) &&
          t.tagName.toLowerCase() === e.tagName.toLowerCase()
        )
      }
      function Lm(t, e) {
        return Ga(t) && Ga(e) && oc(t) && oc(e)
      }
      function Om(t, e, n) {
        if (e === n) {
          return true
        } else if (oc(e) && oc(n)) {
          return e.data === n.data
        } else if (t.isBlockFiller(e) && t.isBlockFiller(n)) {
          return true
        }
        return false
      }
      function Rm(t, e) {
        const n = t.parent
        if (
          n.nodeType != Node.ELEMENT_NODE ||
          t.offset != n.childNodes.length - 1
        ) {
          return
        }
        const i = n.childNodes[t.offset]
        if (i && i.tagName == 'BR') {
          e.addRange(e.getRangeAt(0))
        }
      }
      function jm(t, e) {
        const n = Array.from(t)
        if (n.length == 0 || !e) {
          return n
        }
        const i = n[n.length - 1]
        if (i == e) {
          n.pop()
        }
        return n
      }
      function Fm(t) {
        const e = t.createElement('div')
        e.className = 'ck-fake-selection-container'
        Object.assign(e.style, {
          position: 'fixed',
          top: 0,
          left: '-9999px',
          width: '42px'
        })
        e.textContent = ' '
        return e
      }
      function Vm(t, e) {
        const n = t.data
        if (n == e) {
          return
        }
        const i = p(n, e)
        for (const e of i) {
          if (e.type === 'insert') {
            t.insertData(e.index, e.values.join(''))
          } else {
            t.deleteData(e.index, e.howMany)
          }
        }
      }
      const Hm = _m(ec.document)
      const Um = km(ec.document)
      const Wm = wm(ec.document)
      const qm = 'data-ck-unsafe-attribute-'
      const $m = 'data-ck-unsafe-element'
      class Gm {
        constructor(t, e = {}) {
          this.document = t
          this.renderingMode = e.renderingMode || 'editing'
          this.blockFillerMode =
            e.blockFillerMode ||
            (this.renderingMode === 'editing' ? 'br' : 'nbsp')
          this.preElements = ['pre']
          this.blockElements = [
            'address',
            'article',
            'aside',
            'blockquote',
            'caption',
            'center',
            'dd',
            'details',
            'dir',
            'div',
            'dl',
            'dt',
            'fieldset',
            'figcaption',
            'figure',
            'footer',
            'form',
            'h1',
            'h2',
            'h3',
            'h4',
            'h5',
            'h6',
            'header',
            'hgroup',
            'legend',
            'li',
            'main',
            'menu',
            'nav',
            'ol',
            'p',
            'pre',
            'section',
            'summary',
            'table',
            'tbody',
            'td',
            'tfoot',
            'th',
            'thead',
            'tr',
            'ul'
          ]
          this.inlineObjectElements = [
            'object',
            'iframe',
            'input',
            'button',
            'textarea',
            'select',
            'option',
            'video',
            'embed',
            'audio',
            'img',
            'canvas'
          ]
          this.unsafeElements = ['script', 'style']
          this._domDocument =
            this.renderingMode === 'editing'
              ? ec.document
              : ec.document.implementation.createHTMLDocument('')
          this._domToViewMapping = new WeakMap()
          this._viewToDomMapping = new WeakMap()
          this._fakeSelectionMapping = new WeakMap()
          this._rawContentElementMatcher = new Cu()
          this._encounteredRawContentDomNodes = new WeakSet()
        }
        bindFakeSelection(t, e) {
          this._fakeSelectionMapping.set(t, new zf(e))
        }
        fakeSelectionToView(t) {
          return this._fakeSelectionMapping.get(t)
        }
        bindElements(t, e) {
          this._domToViewMapping.set(t, e)
          this._viewToDomMapping.set(e, t)
        }
        unbindDomElement(t) {
          const e = this._domToViewMapping.get(t)
          if (e) {
            this._domToViewMapping.delete(t)
            this._viewToDomMapping.delete(e)
            for (const e of Array.from(t.children)) {
              this.unbindDomElement(e)
            }
          }
        }
        bindDocumentFragments(t, e) {
          this._domToViewMapping.set(t, e)
          this._viewToDomMapping.set(e, t)
        }
        shouldRenderAttribute(t, e, n) {
          if (this.renderingMode === 'data') {
            return true
          }
          t = t.toLowerCase()
          if (t.startsWith('on')) {
            return false
          }
          if (
            t === 'srcdoc' &&
            e.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)
          ) {
            return false
          }
          if (n === 'img' && (t === 'src' || t === 'srcset')) {
            return true
          }
          if (n === 'source' && t === 'srcset') {
            return true
          }
          if (e.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i)) {
            return false
          }
          return true
        }
        setContentOf(t, e) {
          if (this.renderingMode === 'data') {
            t.innerHTML = e
            return
          }
          const n = new DOMParser().parseFromString(e, 'text/html')
          const i = n.createDocumentFragment()
          const o = n.body.childNodes
          while (o.length > 0) {
            i.appendChild(o[0])
          }
          const r = n.createTreeWalker(i, NodeFilter.SHOW_ELEMENT)
          const s = []
          let a
          while ((a = r.nextNode())) {
            s.push(a)
          }
          for (const t of s) {
            for (const e of t.getAttributeNames()) {
              this.setDomElementAttribute(t, e, t.getAttribute(e))
            }
            const e = t.tagName.toLowerCase()
            if (this._shouldRenameElement(e)) {
              Jm(e)
              t.replaceWith(this._createReplacementDomElement(e, t))
            }
          }
          while (t.firstChild) {
            t.firstChild.remove()
          }
          t.append(i)
        }
        viewToDom(t, e = {}) {
          if (t.is('$text')) {
            const e = this._processDataFromViewText(t)
            return this._domDocument.createTextNode(e)
          } else {
            if (this.mapViewToDom(t)) {
              return this.mapViewToDom(t)
            }
            let n
            if (t.is('documentFragment')) {
              n = this._domDocument.createDocumentFragment()
              if (e.bind) {
                this.bindDocumentFragments(n, t)
              }
            } else if (t.is('uiElement')) {
              if (t.name === '$comment') {
                n = this._domDocument.createComment(
                  t.getCustomProperty('$rawContent')
                )
              } else {
                n = t.render(this._domDocument, this)
              }
              if (e.bind) {
                this.bindElements(n, t)
              }
              return n
            } else {
              if (this._shouldRenameElement(t.name)) {
                Jm(t.name)
                n = this._createReplacementDomElement(t.name)
              } else if (t.hasAttribute('xmlns')) {
                n = this._domDocument.createElementNS(
                  t.getAttribute('xmlns'),
                  t.name
                )
              } else {
                n = this._domDocument.createElement(t.name)
              }
              if (t.is('rawElement')) {
                t.render(n, this)
              }
              if (e.bind) {
                this.bindElements(n, t)
              }
              for (const e of t.getAttributeKeys()) {
                this.setDomElementAttribute(n, e, t.getAttribute(e), t)
              }
            }
            if (e.withChildren !== false) {
              for (const i of this.viewChildrenToDom(t, e)) {
                n.appendChild(i)
              }
            }
            return n
          }
        }
        setDomElementAttribute(t, e, n, i) {
          const o =
            this.shouldRenderAttribute(e, n, t.tagName.toLowerCase()) ||
            (i && i.shouldRenderUnsafeAttribute(e))
          if (!o) {
            P('domconverter-unsafe-attribute-detected', {
              domElement: t,
              key: e,
              value: n
            })
          }
          if (t.hasAttribute(e) && !o) {
            t.removeAttribute(e)
          } else if (t.hasAttribute(qm + e) && o) {
            t.removeAttribute(qm + e)
          }
          t.setAttribute(o ? e : qm + e, n)
        }
        removeDomElementAttribute(t, e) {
          if (e == $m) {
            return
          }
          t.removeAttribute(e)
          t.removeAttribute(qm + e)
        }
        *viewChildrenToDom(t, e = {}) {
          const n = t.getFillerOffset && t.getFillerOffset()
          let i = 0
          for (const o of t.getChildren()) {
            if (n === i) {
              yield this._getBlockFiller()
            }
            const t =
              o.is('element') &&
              !!o.getCustomProperty('dataPipeline:transparentRendering') &&
              !cl(o.getAttributes())
            if (t && this.renderingMode == 'data') {
              yield* this.viewChildrenToDom(o, e)
            } else {
              if (t) {
                P(
                  'domconverter-transparent-rendering-unsupported-in-editing-pipeline',
                  { viewElement: o }
                )
              }
              yield this.viewToDom(o, e)
            }
            i++
          }
          if (n === i) {
            yield this._getBlockFiller()
          }
        }
        viewRangeToDom(t) {
          const e = this.viewPositionToDom(t.start)
          const n = this.viewPositionToDom(t.end)
          const i = this._domDocument.createRange()
          i.setStart(e.parent, e.offset)
          i.setEnd(n.parent, n.offset)
          return i
        }
        viewPositionToDom(t) {
          const e = t.parent
          if (e.is('$text')) {
            const n = this.findCorrespondingDomText(e)
            if (!n) {
              return null
            }
            let i = t.offset
            if (Cm(n)) {
              i += Am
            }
            return { parent: n, offset: i }
          } else {
            let n, i, o
            if (t.offset === 0) {
              n = this.mapViewToDom(e)
              if (!n) {
                return null
              }
              o = n.childNodes[0]
            } else {
              const e = t.nodeBefore
              i = e.is('$text')
                ? this.findCorrespondingDomText(e)
                : this.mapViewToDom(e)
              if (!i) {
                return null
              }
              n = i.parentNode
              o = i.nextSibling
            }
            if (oc(o) && Cm(o)) {
              return { parent: o, offset: Am }
            }
            const r = i ? gc(i) + 1 : 0
            return { parent: n, offset: r }
          }
        }
        domToView(t, e = {}) {
          if (this.isBlockFiller(t)) {
            return null
          }
          const n = this.getHostViewElement(t)
          if (n) {
            return n
          }
          if (bc(t) && e.skipComments) {
            return null
          }
          if (oc(t)) {
            if (ym(t)) {
              return null
            } else {
              const e = this._processDataFromDomText(t)
              return e === '' ? null : new Au(this.document, e)
            }
          } else {
            if (this.mapDomToView(t)) {
              return this.mapDomToView(t)
            }
            let n
            if (this.isDocumentFragment(t)) {
              n = new om(this.document)
              if (e.bind) {
                this.bindDocumentFragments(t, n)
              }
            } else {
              n = this._createViewElement(t, e)
              if (e.bind) {
                this.bindElements(t, n)
              }
              const i = t.attributes
              if (i) {
                for (let t = i.length, e = 0; e < t; e++) {
                  n._setAttribute(i[e].name, i[e].value)
                }
              }
              if (this._isViewElementWithRawContent(n, e) || bc(t)) {
                const e = bc(t) ? t.data : t.innerHTML
                n._setCustomProperty('$rawContent', e)
                this._encounteredRawContentDomNodes.add(t)
                return n
              }
            }
            if (e.withChildren !== false) {
              for (const i of this.domChildrenToView(t, e)) {
                n._appendChild(i)
              }
            }
            return n
          }
        }
        *domChildrenToView(t, e) {
          for (let n = 0; n < t.childNodes.length; n++) {
            const i = t.childNodes[n]
            const o = this.domToView(i, e)
            if (o !== null) {
              yield o
            }
          }
        }
        domSelectionToView(t) {
          if (t.rangeCount === 1) {
            let e = t.getRangeAt(0).startContainer
            if (oc(e)) {
              e = e.parentNode
            }
            const n = this.fakeSelectionToView(e)
            if (n) {
              return n
            }
          }
          const e = this.isDomSelectionBackward(t)
          const n = []
          for (let e = 0; e < t.rangeCount; e++) {
            const i = t.getRangeAt(e)
            const o = this.domRangeToView(i)
            if (o) {
              n.push(o)
            }
          }
          return new zf(n, { backward: e })
        }
        domRangeToView(t) {
          const e = this.domPositionToView(t.startContainer, t.startOffset)
          const n = this.domPositionToView(t.endContainer, t.endOffset)
          if (e && n) {
            return new Nf(e, n)
          }
          return null
        }
        domPositionToView(t, e = 0) {
          if (this.isBlockFiller(t)) {
            return this.domPositionToView(t.parentNode, gc(t))
          }
          const n = this.mapDomToView(t)
          if (n && (n.is('uiElement') || n.is('rawElement'))) {
            return Bf._createBefore(n)
          }
          if (oc(t)) {
            if (ym(t)) {
              return this.domPositionToView(t.parentNode, gc(t))
            }
            const n = this.findCorrespondingViewText(t)
            let i = e
            if (!n) {
              return null
            }
            if (Cm(t)) {
              i -= Am
              i = i < 0 ? 0 : i
            }
            return new Bf(n, i)
          } else {
            if (e === 0) {
              const e = this.mapDomToView(t)
              if (e) {
                return new Bf(e, 0)
              }
            } else {
              const n = t.childNodes[e - 1]
              if (oc(n) && ym(n)) {
                return this.domPositionToView(n.parentNode, gc(n))
              }
              const i = oc(n)
                ? this.findCorrespondingViewText(n)
                : this.mapDomToView(n)
              if (i && i.parent) {
                return new Bf(i.parent, i.index + 1)
              }
            }
            return null
          }
        }
        mapDomToView(t) {
          const e = this.getHostViewElement(t)
          return e || this._domToViewMapping.get(t)
        }
        findCorrespondingViewText(t) {
          if (ym(t)) {
            return null
          }
          const e = this.getHostViewElement(t)
          if (e) {
            return e
          }
          const n = t.previousSibling
          if (n) {
            if (!this.isElement(n)) {
              return null
            }
            const t = this.mapDomToView(n)
            if (t) {
              const e = t.nextSibling
              if (e instanceof Au) {
                return e
              } else {
                return null
              }
            }
          } else {
            const e = this.mapDomToView(t.parentNode)
            if (e) {
              const t = e.getChild(0)
              if (t instanceof Au) {
                return t
              } else {
                return null
              }
            }
          }
          return null
        }
        mapViewToDom(t) {
          return this._viewToDomMapping.get(t)
        }
        findCorrespondingDomText(t) {
          const e = t.previousSibling
          if (e && this.mapViewToDom(e)) {
            return this.mapViewToDom(e).nextSibling
          }
          if (!e && t.parent && this.mapViewToDom(t.parent)) {
            return this.mapViewToDom(t.parent).childNodes[0]
          }
          return null
        }
        focus(t) {
          const e = this.mapViewToDom(t)
          if (e && e.ownerDocument.activeElement !== e) {
            const { scrollX: t, scrollY: n } = ec.window
            const i = []
            Km(e, (t) => {
              const { scrollLeft: e, scrollTop: n } = t
              i.push([e, n])
            })
            e.focus()
            Km(e, (t) => {
              const [e, n] = i.shift()
              t.scrollLeft = e
              t.scrollTop = n
            })
            ec.window.scrollTo(t, n)
          }
        }
        isElement(t) {
          return t && t.nodeType == Node.ELEMENT_NODE
        }
        isDocumentFragment(t) {
          return t && t.nodeType == Node.DOCUMENT_FRAGMENT_NODE
        }
        isBlockFiller(t) {
          if (this.blockFillerMode == 'br') {
            return t.isEqualNode(Hm)
          }
          if (
            t.tagName === 'BR' &&
            Zm(t, this.blockElements) &&
            t.parentNode.childNodes.length === 1
          ) {
            return true
          }
          return t.isEqualNode(Wm) || Qm(t, this.blockElements)
        }
        isDomSelectionBackward(t) {
          if (t.isCollapsed) {
            return false
          }
          const e = this._domDocument.createRange()
          try {
            e.setStart(t.anchorNode, t.anchorOffset)
            e.setEnd(t.focusNode, t.focusOffset)
          } catch (t) {
            return false
          }
          const n = e.collapsed
          e.detach()
          return n
        }
        getHostViewElement(t) {
          const e = nc(t)
          e.pop()
          while (e.length) {
            const t = e.pop()
            const n = this._domToViewMapping.get(t)
            if (n && (n.is('uiElement') || n.is('rawElement'))) {
              return n
            }
          }
          return null
        }
        isDomSelectionCorrect(t) {
          return (
            this._isDomSelectionPositionCorrect(t.anchorNode, t.anchorOffset) &&
            this._isDomSelectionPositionCorrect(t.focusNode, t.focusOffset)
          )
        }
        registerRawContentMatcher(t) {
          this._rawContentElementMatcher.add(t)
        }
        _getBlockFiller() {
          switch (this.blockFillerMode) {
            case 'nbsp':
              return km(this._domDocument)
            case 'markedNbsp':
              return wm(this._domDocument)
            case 'br':
              return _m(this._domDocument)
          }
        }
        _isDomSelectionPositionCorrect(t, e) {
          if (oc(t) && Cm(t) && e < Am) {
            return false
          }
          if (this.isElement(t) && Cm(t.childNodes[e])) {
            return false
          }
          const n = this.mapDomToView(t)
          if (n && (n.is('uiElement') || n.is('rawElement'))) {
            return false
          }
          return true
        }
        _processDataFromViewText(t) {
          let e = t.data
          if (t.getAncestors().some((t) => this.preElements.includes(t.name))) {
            return e
          }
          if (e.charAt(0) == ' ') {
            const n = this._getTouchingInlineViewNode(t, false)
            const i = n && n.is('$textProxy') && this._nodeEndsWithSpace(n)
            if (i || !n) {
              e = ' ' + e.substr(1)
            }
          }
          if (e.charAt(e.length - 1) == ' ') {
            const n = this._getTouchingInlineViewNode(t, true)
            const i = n && n.is('$textProxy') && n.data.charAt(0) == ' '
            if (e.charAt(e.length - 2) == ' ' || !n || i) {
              e = e.substr(0, e.length - 1) + ' '
            }
          }
          return e.replace(/ {2}/g, '  ')
        }
        _nodeEndsWithSpace(t) {
          if (t.getAncestors().some((t) => this.preElements.includes(t.name))) {
            return false
          }
          const e = this._processDataFromViewText(t)
          return e.charAt(e.length - 1) == ' '
        }
        _processDataFromDomText(t) {
          let e = t.data
          if (Ym(t, this.preElements)) {
            return xm(t)
          }
          e = e.replace(/[ \n\t\r]{1,}/g, ' ')
          const n = this._getTouchingInlineDomNode(t, false)
          const i = this._getTouchingInlineDomNode(t, true)
          const o = this._checkShouldLeftTrimDomText(t, n)
          const r = this._checkShouldRightTrimDomText(t, i)
          if (o) {
            e = e.replace(/^ /, '')
          }
          if (r) {
            e = e.replace(/ $/, '')
          }
          e = xm(new Text(e))
          e = e.replace(/ \u00A0/g, '  ')
          const s = i && this.isElement(i) && i.tagName != 'BR'
          const a = i && oc(i) && i.data.charAt(0) == ' '
          if (/( |\u00A0)\u00A0$/.test(e) || !i || s || a) {
            e = e.replace(/\u00A0$/, ' ')
          }
          if (o || (n && this.isElement(n) && n.tagName != 'BR')) {
            e = e.replace(/^\u00A0/, ' ')
          }
          return e
        }
        _checkShouldLeftTrimDomText(t, e) {
          if (!e) {
            return true
          }
          if (this.isElement(e)) {
            return e.tagName === 'BR'
          }
          if (this._encounteredRawContentDomNodes.has(t.previousSibling)) {
            return false
          }
          return /[^\S\u00A0]/.test(e.data.charAt(e.data.length - 1))
        }
        _checkShouldRightTrimDomText(t, e) {
          if (e) {
            return false
          }
          return !Cm(t)
        }
        _getTouchingInlineViewNode(t, e) {
          const n = new Sf({
            startPosition: e ? Bf._createAfter(t) : Bf._createBefore(t),
            direction: e ? 'forward' : 'backward'
          })
          for (const t of n) {
            if (
              t.item.is('element') &&
              this.inlineObjectElements.includes(t.item.name)
            ) {
              return t.item
            } else if (t.item.is('containerElement')) {
              return null
            } else if (t.item.is('element', 'br')) {
              return null
            } else if (t.item.is('$textProxy')) {
              return t.item
            }
          }
          return null
        }
        _getTouchingInlineDomNode(t, e) {
          if (!t.parentNode) {
            return null
          }
          const n = e ? 'firstChild' : 'lastChild'
          const i = e ? 'nextSibling' : 'previousSibling'
          let o = true
          let r = t
          do {
            if (!o && r[n]) {
              r = r[n]
            } else if (r[i]) {
              r = r[i]
              o = false
            } else {
              r = r.parentNode
              o = true
            }
            if (!r || this._isBlockElement(r)) {
              return null
            }
          } while (
            !(oc(r) || r.tagName == 'BR' || this._isInlineObjectElement(r))
          )
          return r
        }
        _isBlockElement(t) {
          return (
            this.isElement(t) &&
            this.blockElements.includes(t.tagName.toLowerCase())
          )
        }
        _isInlineObjectElement(t) {
          return (
            this.isElement(t) &&
            this.inlineObjectElements.includes(t.tagName.toLowerCase())
          )
        }
        _createViewElement(t, e) {
          if (bc(t)) {
            return new Jf(this.document, '$comment')
          }
          const n = e.keepOriginalCase ? t.tagName : t.tagName.toLowerCase()
          return new vf(this.document, n)
        }
        _isViewElementWithRawContent(t, e) {
          return (
            e.withChildren !== false &&
            !!this._rawContentElementMatcher.match(t)
          )
        }
        _shouldRenameElement(t) {
          const e = t.toLowerCase()
          return (
            this.renderingMode === 'editing' && this.unsafeElements.includes(e)
          )
        }
        _createReplacementDomElement(t, e) {
          const n = this._domDocument.createElement('span')
          n.setAttribute($m, t)
          if (e) {
            while (e.firstChild) {
              n.appendChild(e.firstChild)
            }
            for (const t of e.getAttributeNames()) {
              n.setAttribute(t, e.getAttribute(t))
            }
          }
          return n
        }
      }
      function Ym(t, e) {
        const n = nc(t)
        return n.some((t) => t.tagName && e.includes(t.tagName.toLowerCase()))
      }
      function Km(t, e) {
        let n = t
        while (n) {
          e(n)
          n = n.parentElement
        }
      }
      function Qm(t, e) {
        const n = t.isEqualNode(Um)
        return n && Zm(t, e) && t.parentNode.childNodes.length === 1
      }
      function Zm(t, e) {
        const n = t.parentNode
        return !!n && !!n.tagName && e.includes(n.tagName.toLowerCase())
      }
      function Jm(t) {
        if (t === 'script') {
          P('domconverter-unsafe-script-element-detected')
        }
        if (t === 'style') {
          P('domconverter-unsafe-style-element-detected')
        }
      }
      class Xm extends Qa() {
        constructor(t) {
          super()
          this.view = t
          this.document = t.document
          this.isEnabled = false
        }
        enable() {
          this.isEnabled = true
        }
        disable() {
          this.isEnabled = false
        }
        destroy() {
          this.disable()
          this.stopListening()
        }
        checkShouldIgnoreEventFromTarget(t) {
          if (t && t.nodeType === 3) {
            t = t.parentNode
          }
          if (!t || t.nodeType !== 1) {
            return false
          }
          return t.matches(
            '[data-cke-ignore-events], [data-cke-ignore-events] *'
          )
        }
      }
      var tg = df(function (t, e) {
        pi(e, tr(e), t)
      })
      const eg = tg
      class ng {
        constructor(t, e, n) {
          this.view = t
          this.document = t.document
          this.domEvent = e
          this.domTarget = e.target
          eg(this, n)
        }
        get target() {
          return this.view.domConverter.mapDomToView(this.domTarget)
        }
        preventDefault() {
          this.domEvent.preventDefault()
        }
        stopPropagation() {
          this.domEvent.stopPropagation()
        }
      }
      class ig extends Xm {
        constructor(t) {
          super(t)
          this.useCapture = false
        }
        observe(t) {
          const e =
            typeof this.domEventType == 'string'
              ? [this.domEventType]
              : this.domEventType
          e.forEach((e) => {
            this.listenTo(
              t,
              e,
              (t, e) => {
                if (
                  this.isEnabled &&
                  !this.checkShouldIgnoreEventFromTarget(e.target)
                ) {
                  this.onDomEvent(e)
                }
              },
              { useCapture: this.useCapture }
            )
          })
        }
        fire(t, e, n) {
          if (this.isEnabled) {
            this.document.fire(t, new ng(this.view, e, n))
          }
        }
      }
      class og extends ig {
        constructor(t) {
          super(t)
          this.domEventType = ['keydown', 'keyup']
        }
        onDomEvent(t) {
          const e = {
            keyCode: t.keyCode,
            altKey: t.altKey,
            ctrlKey: t.ctrlKey,
            shiftKey: t.shiftKey,
            metaKey: t.metaKey,
            get keystroke() {
              return Hc(this)
            }
          }
          this.fire(t.type, t, e)
        }
      }
      var rg = function () {
        return St.Date.now()
      }
      const sg = rg
      var ag = /\s/
      function cg(t) {
        var e = t.length
        while (e-- && ag.test(t.charAt(e))) {}
        return e
      }
      const lg = cg
      var dg = /^\s+/
      function ug(t) {
        return t ? t.slice(0, lg(t) + 1).replace(dg, '') : t
      }
      const hg = ug
      var fg = 0 / 0
      var mg = /^[-+]0x[0-9a-f]+$/i
      var gg = /^0b[01]+$/i
      var pg = /^0o[0-7]+$/i
      var bg = parseInt
      function kg(t) {
        if (typeof t == 'number') {
          return t
        }
        if (zu(t)) {
          return fg
        }
        if (rt(t)) {
          var e = typeof t.valueOf == 'function' ? t.valueOf() : t
          t = rt(e) ? e + '' : e
        }
        if (typeof t != 'string') {
          return t === 0 ? t : +t
        }
        t = hg(t)
        var n = gg.test(t)
        return n || pg.test(t)
          ? bg(t.slice(2), n ? 2 : 8)
          : mg.test(t)
          ? fg
          : +t
      }
      const wg = kg
      var _g = 'Expected a function'
      var Ag = Math.max,
        vg = Math.min
      function Cg(t, e, n) {
        var i,
          o,
          r,
          s,
          a,
          c,
          l = 0,
          d = false,
          u = false,
          h = true
        if (typeof t != 'function') {
          throw new TypeError(_g)
        }
        e = wg(e) || 0
        if (rt(n)) {
          d = !!n.leading
          u = 'maxWait' in n
          r = u ? Ag(wg(n.maxWait) || 0, e) : r
          h = 'trailing' in n ? !!n.trailing : h
        }
        function f(e) {
          var n = i,
            r = o
          i = o = undefined
          l = e
          s = t.apply(r, n)
          return s
        }
        function m(t) {
          l = t
          a = setTimeout(b, e)
          return d ? f(t) : s
        }
        function g(t) {
          var n = t - c,
            i = t - l,
            o = e - n
          return u ? vg(o, r - i) : o
        }
        function p(t) {
          var n = t - c,
            i = t - l
          return c === undefined || n >= e || n < 0 || (u && i >= r)
        }
        function b() {
          var t = sg()
          if (p(t)) {
            return k(t)
          }
          a = setTimeout(b, g(t))
        }
        function k(t) {
          a = undefined
          if (h && i) {
            return f(t)
          }
          i = o = undefined
          return s
        }
        function w() {
          if (a !== undefined) {
            clearTimeout(a)
          }
          l = 0
          i = c = o = a = undefined
        }
        function _() {
          return a === undefined ? s : k(sg())
        }
        function A() {
          var t = sg(),
            n = p(t)
          i = arguments
          o = this
          c = t
          if (n) {
            if (a === undefined) {
              return m(c)
            }
            if (u) {
              clearTimeout(a)
              a = setTimeout(b, e)
              return f(c)
            }
          }
          if (a === undefined) {
            a = setTimeout(b, e)
          }
          return s
        }
        A.cancel = w
        A.flush = _
        return A
      }
      const yg = Cg
      class xg extends Xm {
        constructor(t) {
          super(t)
          this._fireSelectionChangeDoneDebounced = yg((t) => {
            this.document.fire('selectionChangeDone', t)
          }, 200)
        }
        observe() {
          const t = this.document
          t.on(
            'arrowKey',
            (e, n) => {
              const i = t.selection
              if (i.isFake && this.isEnabled) {
                n.preventDefault()
              }
            },
            { context: '$capture' }
          )
          t.on(
            'arrowKey',
            (e, n) => {
              const i = t.selection
              if (i.isFake && this.isEnabled) {
                this._handleSelectionMove(n.keyCode)
              }
            },
            { priority: 'lowest' }
          )
        }
        destroy() {
          super.destroy()
          this._fireSelectionChangeDoneDebounced.cancel()
        }
        _handleSelectionMove(t) {
          const e = this.document.selection
          const n = new zf(e.getRanges(), {
            backward: e.isBackward,
            fake: false
          })
          if (t == Fc.arrowleft || t == Fc.arrowup) {
            n.setTo(n.getFirstPosition())
          }
          if (t == Fc.arrowright || t == Fc.arrowdown) {
            n.setTo(n.getLastPosition())
          }
          const i = { oldSelection: e, newSelection: n, domSelection: null }
          this.document.fire('selectionChange', i)
          this._fireSelectionChangeDoneDebounced(i)
        }
      }
      var Eg = '__lodash_hash_undefined__'
      function Dg(t) {
        this.__data__.set(t, Eg)
        return this
      }
      const Tg = Dg
      function Mg(t) {
        return this.__data__.has(t)
      }
      const Ig = Mg
      function Sg(t) {
        var e = -1,
          n = t == null ? 0 : t.length
        this.__data__ = new Xn()
        while (++e < n) {
          this.add(t[e])
        }
      }
      Sg.prototype.add = Sg.prototype.push = Tg
      Sg.prototype.has = Ig
      const Bg = Sg
      function Ng(t, e) {
        var n = -1,
          i = t == null ? 0 : t.length
        while (++n < i) {
          if (e(t[n], n, t)) {
            return true
          }
        }
        return false
      }
      const Pg = Ng
      function zg(t, e) {
        return t.has(e)
      }
      const Lg = zg
      var Og = 1,
        Rg = 2
      function jg(t, e, n, i, o, r) {
        var s = n & Og,
          a = t.length,
          c = e.length
        if (a != c && !(s && c > a)) {
          return false
        }
        var l = r.get(t)
        var d = r.get(e)
        if (l && d) {
          return l == e && d == t
        }
        var u = -1,
          h = true,
          f = n & Rg ? new Bg() : undefined
        r.set(t, e)
        r.set(e, t)
        while (++u < a) {
          var m = t[u],
            g = e[u]
          if (i) {
            var p = s ? i(g, m, u, e, t, r) : i(m, g, u, t, e, r)
          }
          if (p !== undefined) {
            if (p) {
              continue
            }
            h = false
            break
          }
          if (f) {
            if (
              !Pg(e, function (t, e) {
                if (!Lg(f, e) && (m === t || o(m, t, n, i, r))) {
                  return f.push(e)
                }
              })
            ) {
              h = false
              break
            }
          } else if (!(m === g || o(m, g, n, i, r))) {
            h = false
            break
          }
        }
        r['delete'](t)
        r['delete'](e)
        return h
      }
      const Fg = jg
      function Vg(t) {
        var e = -1,
          n = Array(t.size)
        t.forEach(function (t, i) {
          n[++e] = [i, t]
        })
        return n
      }
      const Hg = Vg
      function Ug(t) {
        var e = -1,
          n = Array(t.size)
        t.forEach(function (t) {
          n[++e] = t
        })
        return n
      }
      const Wg = Ug
      var qg = 1,
        $g = 2
      var Gg = '[object Boolean]',
        Yg = '[object Date]',
        Kg = '[object Error]',
        Qg = '[object Map]',
        Zg = '[object Number]',
        Jg = '[object RegExp]',
        Xg = '[object Set]',
        tp = '[object String]',
        ep = '[object Symbol]'
      var np = '[object ArrayBuffer]',
        ip = '[object DataView]'
      var op = Nt ? Nt.prototype : undefined,
        rp = op ? op.valueOf : undefined
      function sp(t, e, n, i, o, r, s) {
        switch (n) {
          case ip:
            if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset) {
              return false
            }
            t = t.buffer
            e = e.buffer
          case np:
            if (t.byteLength != e.byteLength || !r(new cs(t), new cs(e))) {
              return false
            }
            return true
          case Gg:
          case Yg:
          case Zg:
            return ke(+t, +e)
          case Kg:
            return t.name == e.name && t.message == e.message
          case Jg:
          case tp:
            return t == e + ''
          case Qg:
            var a = Hg
          case Xg:
            var c = i & qg
            a || (a = Wg)
            if (t.size != e.size && !c) {
              return false
            }
            var l = s.get(t)
            if (l) {
              return l == e
            }
            i |= $g
            s.set(t, e)
            var d = Fg(a(t), a(e), i, o, r, s)
            s['delete'](t)
            return d
          case ep:
            if (rp) {
              return rp.call(t) == rp.call(e)
            }
        }
        return false
      }
      const ap = sp
      var cp = 1
      var lp = Object.prototype
      var dp = lp.hasOwnProperty
      function up(t, e, n, i, o, r) {
        var s = n & cp,
          a = Nr(t),
          c = a.length,
          l = Nr(e),
          d = l.length
        if (c != d && !s) {
          return false
        }
        var u = c
        while (u--) {
          var h = a[u]
          if (!(s ? h in e : dp.call(e, h))) {
            return false
          }
        }
        var f = r.get(t)
        var m = r.get(e)
        if (f && m) {
          return f == e && m == t
        }
        var g = true
        r.set(t, e)
        r.set(e, t)
        var p = s
        while (++u < c) {
          h = a[u]
          var b = t[h],
            k = e[h]
          if (i) {
            var w = s ? i(k, b, h, e, t, r) : i(b, k, h, t, e, r)
          }
          if (!(w === undefined ? b === k || o(b, k, n, i, r) : w)) {
            g = false
            break
          }
          p || (p = h == 'constructor')
        }
        if (g && !p) {
          var _ = t.constructor,
            A = e.constructor
          if (
            _ != A &&
            'constructor' in t &&
            'constructor' in e &&
            !(
              typeof _ == 'function' &&
              _ instanceof _ &&
              typeof A == 'function' &&
              A instanceof A
            )
          ) {
            g = false
          }
        }
        r['delete'](t)
        r['delete'](e)
        return g
      }
      const hp = up
      var fp = 1
      var mp = '[object Arguments]',
        gp = '[object Array]',
        pp = '[object Object]'
      var bp = Object.prototype
      var kp = bp.hasOwnProperty
      function wp(t, e, n, i, o, r) {
        var s = Qt(t),
          a = Qt(e),
          c = s ? gp : ns(t),
          l = a ? gp : ns(e)
        c = c == mp ? pp : c
        l = l == mp ? pp : l
        var d = c == pp,
          u = l == pp,
          h = c == l
        if (h && zi(t)) {
          if (!zi(e)) {
            return false
          }
          s = true
          d = false
        }
        if (h && !d) {
          r || (r = new oi())
          return s || Do(t) ? Fg(t, e, n, i, o, r) : ap(t, e, c, n, i, o, r)
        }
        if (!(n & fp)) {
          var f = d && kp.call(t, '__wrapped__'),
            m = u && kp.call(e, '__wrapped__')
          if (f || m) {
            var g = f ? t.value() : t,
              p = m ? e.value() : e
            r || (r = new oi())
            return o(g, p, n, i, r)
          }
        }
        if (!h) {
          return false
        }
        r || (r = new oi())
        return hp(t, e, n, i, o, r)
      }
      const _p = wp
      function Ap(t, e, n, i, o) {
        if (t === e) {
          return true
        }
        if (t == null || e == null || (!Jt(t) && !Jt(e))) {
          return t !== t && e !== e
        }
        return _p(t, e, n, i, Ap, o)
      }
      const vp = Ap
      function Cp(t, e, n) {
        n = typeof n == 'function' ? n : undefined
        var i = n ? n(t, e) : undefined
        return i === undefined ? vp(t, e, undefined, n) : !!i
      }
      const yp = Cp
      class xp extends Xm {
        constructor(t) {
          super(t)
          this._config = { childList: true, characterData: true, subtree: true }
          this.domConverter = t.domConverter
          this.renderer = t._renderer
          this._domElements = []
          this._mutationObserver = new window.MutationObserver(
            this._onMutations.bind(this)
          )
        }
        flush() {
          this._onMutations(this._mutationObserver.takeRecords())
        }
        observe(t) {
          this._domElements.push(t)
          if (this.isEnabled) {
            this._mutationObserver.observe(t, this._config)
          }
        }
        enable() {
          super.enable()
          for (const t of this._domElements) {
            this._mutationObserver.observe(t, this._config)
          }
        }
        disable() {
          super.disable()
          this._mutationObserver.disconnect()
        }
        destroy() {
          super.destroy()
          this._mutationObserver.disconnect()
        }
        _onMutations(t) {
          if (t.length === 0) {
            return
          }
          const e = this.domConverter
          const n = new Set()
          const i = new Set()
          for (const n of t) {
            const t = e.mapDomToView(n.target)
            if (!t) {
              continue
            }
            if (t.is('uiElement') || t.is('rawElement')) {
              continue
            }
            if (n.type === 'childList' && !this._isBogusBrMutation(n)) {
              i.add(t)
            }
          }
          for (const o of t) {
            const t = e.mapDomToView(o.target)
            if (t && (t.is('uiElement') || t.is('rawElement'))) {
              continue
            }
            if (o.type === 'characterData') {
              const t = e.findCorrespondingViewText(o.target)
              if (t && !i.has(t.parent)) {
                n.add(t)
              } else if (!t && Cm(o.target)) {
                i.add(e.mapDomToView(o.target.parentNode))
              }
            }
          }
          let o = false
          for (const t of n) {
            o = true
            this.renderer.markToSync('text', t)
          }
          for (const t of i) {
            const n = e.mapViewToDom(t)
            const i = Array.from(t.getChildren())
            const r = Array.from(
              e.domChildrenToView(n, { withChildren: false })
            )
            if (!yp(i, r, Ep)) {
              o = true
              this.renderer.markToSync('children', t)
            }
          }
          if (o) {
            this.view.forceRender()
          }
        }
        _isBogusBrMutation(t) {
          let e = null
          if (
            t.nextSibling === null &&
            t.removedNodes.length === 0 &&
            t.addedNodes.length == 1
          ) {
            e = this.domConverter.domToView(t.addedNodes[0], {
              withChildren: false
            })
          }
          return e && e.is('element', 'br')
        }
      }
      function Ep(t, e) {
        if (Array.isArray(t)) {
          return
        }
        if (t === e) {
          return true
        } else if (t.is('$text') && e.is('$text')) {
          return t.data === e.data
        }
        return false
      }
      class Dp extends ig {
        constructor(t) {
          super(t)
          this._isFocusChanging = false
          this.domEventType = ['focus', 'blur']
          this.useCapture = true
          const e = this.document
          e.on('focus', () => {
            this._isFocusChanging = true
            this._renderTimeoutId = setTimeout(() => {
              this.flush()
              t.change(() => {})
            }, 50)
          })
          e.on('blur', (n, i) => {
            const o = e.selection.editableElement
            if (o === null || o === i.target) {
              e.isFocused = false
              this._isFocusChanging = false
              t.change(() => {})
            }
          })
        }
        flush() {
          if (this._isFocusChanging) {
            this._isFocusChanging = false
            this.document.isFocused = true
          }
        }
        onDomEvent(t) {
          this.fire(t.type, t)
        }
        destroy() {
          if (this._renderTimeoutId) {
            clearTimeout(this._renderTimeoutId)
          }
          super.destroy()
        }
      }
      class Tp extends Xm {
        constructor(t) {
          super(t)
          this.mutationObserver = t.getObserver(xp)
          this.focusObserver = t.getObserver(Dp)
          this.selection = this.document.selection
          this.domConverter = t.domConverter
          this._documents = new WeakSet()
          this._fireSelectionChangeDoneDebounced = yg((t) => {
            this.document.fire('selectionChangeDone', t)
          }, 200)
          this._clearInfiniteLoopInterval = setInterval(
            () => this._clearInfiniteLoop(),
            1e3
          )
          this._documentIsSelectingInactivityTimeoutDebounced = yg(
            () => (this.document.isSelecting = false),
            5e3
          )
          this._loopbackCounter = 0
        }
        observe(t) {
          const e = t.ownerDocument
          const n = () => {
            this.document.isSelecting = true
            this._documentIsSelectingInactivityTimeoutDebounced()
          }
          const i = () => {
            if (!this.document.isSelecting) {
              return
            }
            this._handleSelectionChange(null, e)
            this.document.isSelecting = false
            this._documentIsSelectingInactivityTimeoutDebounced.cancel()
          }
          this.listenTo(t, 'selectstart', n, { priority: 'highest' })
          this.listenTo(t, 'keydown', i, {
            priority: 'highest',
            useCapture: true
          })
          this.listenTo(t, 'keyup', i, {
            priority: 'highest',
            useCapture: true
          })
          if (this._documents.has(e)) {
            return
          }
          this.listenTo(e, 'mouseup', i, {
            priority: 'highest',
            useCapture: true
          })
          this.listenTo(e, 'selectionchange', (t, n) => {
            if (this.document.isComposing && !a.isAndroid) {
              return
            }
            this._handleSelectionChange(n, e)
            this._documentIsSelectingInactivityTimeoutDebounced()
          })
          this._documents.add(e)
        }
        destroy() {
          super.destroy()
          clearInterval(this._clearInfiniteLoopInterval)
          this._fireSelectionChangeDoneDebounced.cancel()
          this._documentIsSelectingInactivityTimeoutDebounced.cancel()
        }
        _handleSelectionChange(t, e) {
          if (!this.isEnabled) {
            return
          }
          const n = e.defaultView.getSelection()
          if (this.checkShouldIgnoreEventFromTarget(n.anchorNode)) {
            return
          }
          this.mutationObserver.flush()
          const i = this.domConverter.domSelectionToView(n)
          if (i.rangeCount == 0) {
            this.view.hasDomSelection = false
            return
          }
          this.view.hasDomSelection = true
          if (
            this.selection.isEqual(i) &&
            this.domConverter.isDomSelectionCorrect(n)
          ) {
            return
          }
          if (++this._loopbackCounter > 60) {
            return
          }
          this.focusObserver.flush()
          if (this.selection.isSimilar(i)) {
            this.view.forceRender()
          } else {
            const t = {
              oldSelection: this.selection,
              newSelection: i,
              domSelection: n
            }
            this.document.fire('selectionChange', t)
            this._fireSelectionChangeDoneDebounced(t)
          }
        }
        _clearInfiniteLoop() {
          this._loopbackCounter = 0
        }
      }
      class Mp extends ig {
        constructor(t) {
          super(t)
          this.domEventType = [
            'compositionstart',
            'compositionupdate',
            'compositionend'
          ]
          const e = this.document
          e.on(
            'compositionstart',
            () => {
              e.isComposing = true
            },
            { priority: 'low' }
          )
          e.on(
            'compositionend',
            () => {
              e.isComposing = false
            },
            { priority: 'low' }
          )
        }
        onDomEvent(t) {
          this.fire(t.type, t, { data: t.data })
        }
      }
      class Ip {
        constructor(t) {
          this.files = Sp(t)
          this._native = t
        }
        get types() {
          return this._native.types
        }
        getData(t) {
          return this._native.getData(t)
        }
        setData(t, e) {
          this._native.setData(t, e)
        }
        set effectAllowed(t) {
          this._native.effectAllowed = t
        }
        get effectAllowed() {
          return this._native.effectAllowed
        }
        set dropEffect(t) {
          this._native.dropEffect = t
        }
        get dropEffect() {
          return this._native.dropEffect
        }
        get isCanceled() {
          return (
            this._native.dropEffect == 'none' || !!this._native.mozUserCancelled
          )
        }
      }
      function Sp(t) {
        const e = Array.from(t.files || [])
        const n = Array.from(t.items || [])
        if (e.length) {
          return e
        }
        return n.filter((t) => t.kind === 'file').map((t) => t.getAsFile())
      }
      class Bp extends ig {
        constructor(t) {
          super(t)
          this.domEventType = ['beforeinput']
        }
        onDomEvent(t) {
          const e = t.getTargetRanges()
          const n = this.view
          const i = n.document
          let o = null
          let r = null
          let s = []
          if (t.dataTransfer) {
            o = new Ip(t.dataTransfer)
          }
          if (t.data !== null) {
            r = t.data
          } else if (o) {
            r = o.getData('text/plain')
          }
          if (i.selection.isFake) {
            s = Array.from(i.selection.getRanges())
          } else if (e.length) {
            s = e.map((t) => n.domConverter.domRangeToView(t))
          } else if (a.isAndroid) {
            const e = t.target.ownerDocument.defaultView.getSelection()
            s = Array.from(n.domConverter.domSelectionToView(e).getRanges())
          }
          if (
            a.isAndroid &&
            t.inputType == 'insertCompositionText' &&
            r &&
            r.endsWith('\n')
          ) {
            this.fire(t.type, t, {
              inputType: 'insertParagraph',
              targetRanges: [n.createRange(s[0].end)]
            })
            return
          }
          if (t.inputType == 'insertText' && r && r.includes('\n')) {
            const e = r.split(/\n{1,2}/g)
            let n = s
            for (let r = 0; r < e.length; r++) {
              const s = e[r]
              if (s != '') {
                this.fire(t.type, t, {
                  data: s,
                  dataTransfer: o,
                  targetRanges: n,
                  inputType: t.inputType,
                  isComposing: t.isComposing
                })
                n = [i.selection.getFirstRange()]
              }
              if (r + 1 < e.length) {
                this.fire(t.type, t, {
                  inputType: 'insertParagraph',
                  targetRanges: n
                })
                n = [i.selection.getFirstRange()]
              }
            }
            return
          }
          this.fire(t.type, t, {
            data: r,
            dataTransfer: o,
            targetRanges: s,
            inputType: t.inputType,
            isComposing: t.isComposing
          })
        }
      }
      class Np extends Xm {
        constructor(t) {
          super(t)
          this.document.on('keydown', (t, e) => {
            if (this.isEnabled && qc(e.keyCode)) {
              const n = new Of(
                this.document,
                'arrowKey',
                this.document.selection.getFirstRange()
              )
              this.document.fire(n, e)
              if (n.stop.called) {
                t.stop()
              }
            }
          })
        }
        observe() {}
      }
      class Pp extends Xm {
        constructor(t) {
          super(t)
          const e = this.document
          e.on('keydown', (t, n) => {
            if (!this.isEnabled || n.keyCode != Fc.tab || n.ctrlKey) {
              return
            }
            const i = new Of(e, 'tab', e.selection.getFirstRange())
            e.fire(i, n)
            if (i.stop.called) {
              t.stop()
            }
          })
        }
        observe() {}
      }
      class zp extends ht() {
        constructor(t) {
          super()
          this.document = new qf(t)
          this.domConverter = new Gm(this.document)
          this.domRoots = new Map()
          this.set('isRenderingInProgress', false)
          this.set('hasDomSelection', false)
          this._renderer = new Bm(this.domConverter, this.document.selection)
          this._renderer
            .bind('isFocused', 'isSelecting', 'isComposing')
            .to(this.document, 'isFocused', 'isSelecting', 'isComposing')
          this._initialDomRootAttributes = new WeakMap()
          this._observers = new Map()
          this._ongoingChange = false
          this._postFixersInProgress = false
          this._renderingDisabled = false
          this._hasChangedSinceTheLastRendering = false
          this._writer = new sm(this.document)
          this.addObserver(xp)
          this.addObserver(Dp)
          this.addObserver(Tp)
          this.addObserver(og)
          this.addObserver(xg)
          this.addObserver(Mp)
          this.addObserver(Np)
          this.addObserver(Bp)
          this.addObserver(Pp)
          Em(this)
          Xf(this)
          this.on('render', () => {
            this._render()
            this.document.fire('layoutChanged')
            this._hasChangedSinceTheLastRendering = false
          })
          this.listenTo(this.document.selection, 'change', () => {
            this._hasChangedSinceTheLastRendering = true
          })
          this.listenTo(this.document, 'change:isFocused', () => {
            this._hasChangedSinceTheLastRendering = true
          })
        }
        attachDomRoot(t, e = 'main') {
          const n = this.document.getRoot(e)
          n._name = t.tagName.toLowerCase()
          const i = {}
          for (const { name: e, value: o } of Array.from(t.attributes)) {
            i[e] = o
            if (e === 'class') {
              this._writer.addClass(o.split(' '), n)
            } else {
              this._writer.setAttribute(e, o, n)
            }
          }
          this._initialDomRootAttributes.set(t, i)
          const o = () => {
            this._writer.setAttribute(
              'contenteditable',
              (!n.isReadOnly).toString(),
              n
            )
            if (n.isReadOnly) {
              this._writer.addClass('ck-read-only', n)
            } else {
              this._writer.removeClass('ck-read-only', n)
            }
          }
          o()
          this.domRoots.set(e, t)
          this.domConverter.bindElements(t, n)
          this._renderer.markToSync('children', n)
          this._renderer.markToSync('attributes', n)
          this._renderer.domDocuments.add(t.ownerDocument)
          n.on('change:children', (t, e) =>
            this._renderer.markToSync('children', e)
          )
          n.on('change:attributes', (t, e) =>
            this._renderer.markToSync('attributes', e)
          )
          n.on('change:text', (t, e) => this._renderer.markToSync('text', e))
          n.on('change:isReadOnly', () => this.change(o))
          n.on('change', () => {
            this._hasChangedSinceTheLastRendering = true
          })
          for (const n of this._observers.values()) {
            n.observe(t, e)
          }
        }
        detachDomRoot(t) {
          const e = this.domRoots.get(t)
          Array.from(e.attributes).forEach(({ name: t }) =>
            e.removeAttribute(t)
          )
          const n = this._initialDomRootAttributes.get(e)
          for (const t in n) {
            e.setAttribute(t, n[t])
          }
          this.domRoots.delete(t)
          this.domConverter.unbindDomElement(e)
        }
        getDomRoot(t = 'main') {
          return this.domRoots.get(t)
        }
        addObserver(t) {
          let e = this._observers.get(t)
          if (e) {
            return e
          }
          e = new t(this)
          this._observers.set(t, e)
          for (const [t, n] of this.domRoots) {
            e.observe(n, t)
          }
          e.enable()
          return e
        }
        getObserver(t) {
          return this._observers.get(t)
        }
        disableObservers() {
          for (const t of this._observers.values()) {
            t.disable()
          }
        }
        enableObservers() {
          for (const t of this._observers.values()) {
            t.enable()
          }
        }
        scrollToTheSelection() {
          const t = this.document.selection.getFirstRange()
          if (t) {
            Dc({
              target: this.domConverter.viewRangeToDom(t),
              viewportOffset: 20
            })
          }
        }
        focus() {
          if (!this.document.isFocused) {
            const t = this.document.selection.editableElement
            if (t) {
              this.domConverter.focus(t)
              this.forceRender()
            } else {
            }
          }
        }
        change(t) {
          if (this.isRenderingInProgress || this._postFixersInProgress) {
            throw new N('cannot-change-view-tree', this)
          }
          try {
            if (this._ongoingChange) {
              return t(this._writer)
            }
            this._ongoingChange = true
            const e = t(this._writer)
            this._ongoingChange = false
            if (
              !this._renderingDisabled &&
              this._hasChangedSinceTheLastRendering
            ) {
              this._postFixersInProgress = true
              this.document._callPostFixers(this._writer)
              this._postFixersInProgress = false
              this.fire('render')
            }
            return e
          } catch (t) {
            N.rethrowUnexpectedError(t, this)
          }
        }
        forceRender() {
          this._hasChangedSinceTheLastRendering = true
          this.getObserver(Dp).flush()
          this.change(() => {})
        }
        destroy() {
          for (const t of this._observers.values()) {
            t.destroy()
          }
          this.document.destroy()
          this.stopListening()
        }
        createPositionAt(t, e) {
          return Bf._createAt(t, e)
        }
        createPositionAfter(t) {
          return Bf._createAfter(t)
        }
        createPositionBefore(t) {
          return Bf._createBefore(t)
        }
        createRange(...t) {
          return new Nf(...t)
        }
        createRangeOn(t) {
          return Nf._createOn(t)
        }
        createRangeIn(t) {
          return Nf._createIn(t)
        }
        createSelection(...t) {
          return new zf(...t)
        }
        _disableRendering(t) {
          this._renderingDisabled = t
          if (t == false) {
            this.change(() => {})
          }
        }
        _render() {
          this.isRenderingInProgress = true
          this.disableObservers()
          this._renderer.render()
          this.enableObservers()
          this.isRenderingInProgress = false
        }
      }
      class Lp {
        is() {
          throw new Error('is() method is abstract')
        }
      }
      class Op extends Lp {
        constructor(t) {
          super()
          this.parent = null
          this._attrs = hl(t)
        }
        get document() {
          return null
        }
        get index() {
          let t
          if (!this.parent) {
            return null
          }
          if ((t = this.parent.getChildIndex(this)) === null) {
            throw new N('model-node-not-found-in-parent', this)
          }
          return t
        }
        get startOffset() {
          let t
          if (!this.parent) {
            return null
          }
          if ((t = this.parent.getChildStartOffset(this)) === null) {
            throw new N('model-node-not-found-in-parent', this)
          }
          return t
        }
        get offsetSize() {
          return 1
        }
        get endOffset() {
          if (!this.parent) {
            return null
          }
          return this.startOffset + this.offsetSize
        }
        get nextSibling() {
          const t = this.index
          return (t !== null && this.parent.getChild(t + 1)) || null
        }
        get previousSibling() {
          const t = this.index
          return (t !== null && this.parent.getChild(t - 1)) || null
        }
        get root() {
          let t = this
          while (t.parent) {
            t = t.parent
          }
          return t
        }
        isAttached() {
          return this.root.is('rootElement')
        }
        getPath() {
          const t = []
          let e = this
          while (e.parent) {
            t.unshift(e.startOffset)
            e = e.parent
          }
          return t
        }
        getAncestors(t = {}) {
          const e = []
          let n = t.includeSelf ? this : this.parent
          while (n) {
            e[t.parentFirst ? 'push' : 'unshift'](n)
            n = n.parent
          }
          return e
        }
        getCommonAncestor(t, e = {}) {
          const n = this.getAncestors(e)
          const i = t.getAncestors(e)
          let o = 0
          while (n[o] == i[o] && n[o]) {
            o++
          }
          return o === 0 ? null : n[o - 1]
        }
        isBefore(t) {
          if (this == t) {
            return false
          }
          if (this.root !== t.root) {
            return false
          }
          const e = this.getPath()
          const n = t.getPath()
          const i = xt(e, n)
          switch (i) {
            case 'prefix':
              return true
            case 'extension':
              return false
            default:
              return e[i] < n[i]
          }
        }
        isAfter(t) {
          if (this == t) {
            return false
          }
          if (this.root !== t.root) {
            return false
          }
          return !this.isBefore(t)
        }
        hasAttribute(t) {
          return this._attrs.has(t)
        }
        getAttribute(t) {
          return this._attrs.get(t)
        }
        getAttributes() {
          return this._attrs.entries()
        }
        getAttributeKeys() {
          return this._attrs.keys()
        }
        toJSON() {
          const t = {}
          if (this._attrs.size) {
            t.attributes = Array.from(this._attrs).reduce((t, e) => {
              t[e[0]] = e[1]
              return t
            }, {})
          }
          return t
        }
        _clone(t) {
          return new this.constructor(this._attrs)
        }
        _remove() {
          this.parent._removeChildren(this.index)
        }
        _setAttribute(t, e) {
          this._attrs.set(t, e)
        }
        _setAttributesTo(t) {
          this._attrs = hl(t)
        }
        _removeAttribute(t) {
          return this._attrs.delete(t)
        }
        _clearAttributes() {
          this._attrs.clear()
        }
      }
      Op.prototype.is = function (t) {
        return t === 'node' || t === 'model:node'
      }
      class Rp {
        constructor(t) {
          this._nodes = []
          if (t) {
            this._insertNodes(0, t)
          }
        }
        [Symbol.iterator]() {
          return this._nodes[Symbol.iterator]()
        }
        get length() {
          return this._nodes.length
        }
        get maxOffset() {
          return this._nodes.reduce((t, e) => t + e.offsetSize, 0)
        }
        getNode(t) {
          return this._nodes[t] || null
        }
        getNodeIndex(t) {
          const e = this._nodes.indexOf(t)
          return e == -1 ? null : e
        }
        getNodeStartOffset(t) {
          const e = this.getNodeIndex(t)
          return e === null
            ? null
            : this._nodes.slice(0, e).reduce((t, e) => t + e.offsetSize, 0)
        }
        indexToOffset(t) {
          if (t == this._nodes.length) {
            return this.maxOffset
          }
          const e = this._nodes[t]
          if (!e) {
            throw new N('model-nodelist-index-out-of-bounds', this)
          }
          return this.getNodeStartOffset(e)
        }
        offsetToIndex(t) {
          let e = 0
          for (const n of this._nodes) {
            if (t >= e && t < e + n.offsetSize) {
              return this.getNodeIndex(n)
            }
            e += n.offsetSize
          }
          if (e != t) {
            throw new N('model-nodelist-offset-out-of-bounds', this, {
              offset: t,
              nodeList: this
            })
          }
          return this.length
        }
        _insertNodes(t, e) {
          for (const t of e) {
            if (!(t instanceof Op)) {
              throw new N('model-nodelist-insertnodes-not-node', this)
            }
          }
          this._nodes = ml(this._nodes, Array.from(e), t, 0)
        }
        _removeNodes(t, e = 1) {
          return this._nodes.splice(t, e)
        }
        toJSON() {
          return this._nodes.map((t) => t.toJSON())
        }
      }
      class jp extends Op {
        constructor(t, e) {
          super(e)
          this._data = t || ''
        }
        get offsetSize() {
          return this.data.length
        }
        get data() {
          return this._data
        }
        toJSON() {
          const t = super.toJSON()
          t.data = this.data
          return t
        }
        _clone() {
          return new jp(this.data, this.getAttributes())
        }
        static fromJSON(t) {
          return new jp(t.data, t.attributes)
        }
      }
      jp.prototype.is = function (t) {
        return (
          t === '$text' ||
          t === 'model:$text' ||
          t === 'text' ||
          t === 'model:text' ||
          t === 'node' ||
          t === 'model:node'
        )
      }
      class Fp extends Lp {
        constructor(t, e, n) {
          super()
          this.textNode = t
          if (e < 0 || e > t.offsetSize) {
            throw new N('model-textproxy-wrong-offsetintext', this)
          }
          if (n < 0 || e + n > t.offsetSize) {
            throw new N('model-textproxy-wrong-length', this)
          }
          this.data = t.data.substring(e, e + n)
          this.offsetInText = e
        }
        get startOffset() {
          return this.textNode.startOffset !== null
            ? this.textNode.startOffset + this.offsetInText
            : null
        }
        get offsetSize() {
          return this.data.length
        }
        get endOffset() {
          return this.startOffset !== null
            ? this.startOffset + this.offsetSize
            : null
        }
        get isPartial() {
          return this.offsetSize !== this.textNode.offsetSize
        }
        get parent() {
          return this.textNode.parent
        }
        get root() {
          return this.textNode.root
        }
        getPath() {
          const t = this.textNode.getPath()
          if (t.length > 0) {
            t[t.length - 1] += this.offsetInText
          }
          return t
        }
        getAncestors(t = {}) {
          const e = []
          let n = t.includeSelf ? this : this.parent
          while (n) {
            e[t.parentFirst ? 'push' : 'unshift'](n)
            n = n.parent
          }
          return e
        }
        hasAttribute(t) {
          return this.textNode.hasAttribute(t)
        }
        getAttribute(t) {
          return this.textNode.getAttribute(t)
        }
        getAttributes() {
          return this.textNode.getAttributes()
        }
        getAttributeKeys() {
          return this.textNode.getAttributeKeys()
        }
      }
      Fp.prototype.is = function (t) {
        return (
          t === '$textProxy' ||
          t === 'model:$textProxy' ||
          t === 'textProxy' ||
          t === 'model:textProxy'
        )
      }
      class Vp extends Op {
        constructor(t, e, n) {
          super(e)
          this._children = new Rp()
          this.name = t
          if (n) {
            this._insertChild(0, n)
          }
        }
        get childCount() {
          return this._children.length
        }
        get maxOffset() {
          return this._children.maxOffset
        }
        get isEmpty() {
          return this.childCount === 0
        }
        getChild(t) {
          return this._children.getNode(t)
        }
        getChildren() {
          return this._children[Symbol.iterator]()
        }
        getChildIndex(t) {
          return this._children.getNodeIndex(t)
        }
        getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t)
        }
        offsetToIndex(t) {
          return this._children.offsetToIndex(t)
        }
        getNodeByPath(t) {
          let e = this
          for (const n of t) {
            e = e.getChild(e.offsetToIndex(n))
          }
          return e
        }
        findAncestor(t, e = {}) {
          let n = e.includeSelf ? this : this.parent
          while (n) {
            if (n.name === t) {
              return n
            }
            n = n.parent
          }
          return null
        }
        toJSON() {
          const t = super.toJSON()
          t.name = this.name
          if (this._children.length > 0) {
            t.children = []
            for (const e of this._children) {
              t.children.push(e.toJSON())
            }
          }
          return t
        }
        _clone(t = false) {
          const e = t
            ? Array.from(this._children).map((t) => t._clone(true))
            : undefined
          return new Vp(this.name, this.getAttributes(), e)
        }
        _appendChild(t) {
          this._insertChild(this.childCount, t)
        }
        _insertChild(t, e) {
          const n = Hp(e)
          for (const t of n) {
            if (t.parent !== null) {
              t._remove()
            }
            t.parent = this
          }
          this._children._insertNodes(t, n)
        }
        _removeChildren(t, e = 1) {
          const n = this._children._removeNodes(t, e)
          for (const t of n) {
            t.parent = null
          }
          return n
        }
        static fromJSON(t) {
          let e
          if (t.children) {
            e = []
            for (const n of t.children) {
              if (n.name) {
                e.push(Vp.fromJSON(n))
              } else {
                e.push(jp.fromJSON(n))
              }
            }
          }
          return new Vp(t.name, t.attributes, e)
        }
      }
      Vp.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'element' ||
            t === 'model:element' ||
            t === 'node' ||
            t === 'model:node'
          )
        }
        return e === this.name && (t === 'element' || t === 'model:element')
      }
      function Hp(t) {
        if (typeof t == 'string') {
          return [new jp(t)]
        }
        if (!Et(t)) {
          t = [t]
        }
        return Array.from(t).map((t) => {
          if (typeof t == 'string') {
            return new jp(t)
          }
          if (t instanceof Fp) {
            return new jp(t.data, t.getAttributes())
          }
          return t
        })
      }
      class Up {
        constructor(t) {
          if (!t || (!t.boundaries && !t.startPosition)) {
            throw new N('model-tree-walker-no-start-position', null)
          }
          const e = t.direction || 'forward'
          if (e != 'forward' && e != 'backward') {
            throw new N('model-tree-walker-unknown-direction', t, {
              direction: e
            })
          }
          this.direction = e
          this.boundaries = t.boundaries || null
          if (t.startPosition) {
            this.position = t.startPosition.clone()
          } else {
            this.position = qp._createAt(
              this.boundaries[this.direction == 'backward' ? 'end' : 'start']
            )
          }
          this.position.stickiness = 'toNone'
          this.singleCharacters = !!t.singleCharacters
          this.shallow = !!t.shallow
          this.ignoreElementEnd = !!t.ignoreElementEnd
          this._boundaryStartParent = this.boundaries
            ? this.boundaries.start.parent
            : null
          this._boundaryEndParent = this.boundaries
            ? this.boundaries.end.parent
            : null
          this._visitedParent = this.position.parent
        }
        [Symbol.iterator]() {
          return this
        }
        skip(t) {
          let e, n, i, o
          do {
            i = this.position
            o = this._visitedParent
            ;({ done: e, value: n } = this.next())
          } while (!e && t(n))
          if (!e) {
            this.position = i
            this._visitedParent = o
          }
        }
        next() {
          if (this.direction == 'forward') {
            return this._next()
          } else {
            return this._previous()
          }
        }
        _next() {
          const t = this.position
          const e = this.position.clone()
          const n = this._visitedParent
          if (n.parent === null && e.offset === n.maxOffset) {
            return { done: true, value: undefined }
          }
          if (
            n === this._boundaryEndParent &&
            e.offset == this.boundaries.end.offset
          ) {
            return { done: true, value: undefined }
          }
          const i = $p(e, n)
          const o = i ? i : Gp(e, n, i)
          if (o instanceof Vp) {
            if (!this.shallow) {
              e.path.push(0)
              this._visitedParent = o
            } else {
              e.offset++
            }
            this.position = e
            return Wp('elementStart', o, t, e, 1)
          } else if (o instanceof jp) {
            let i
            if (this.singleCharacters) {
              i = 1
            } else {
              let t = o.endOffset
              if (
                this._boundaryEndParent == n &&
                this.boundaries.end.offset < t
              ) {
                t = this.boundaries.end.offset
              }
              i = t - e.offset
            }
            const r = e.offset - o.startOffset
            const s = new Fp(o, r, i)
            e.offset += i
            this.position = e
            return Wp('text', s, t, e, i)
          } else {
            e.path.pop()
            e.offset++
            this.position = e
            this._visitedParent = n.parent
            if (this.ignoreElementEnd) {
              return this._next()
            } else {
              return Wp('elementEnd', n, t, e)
            }
          }
        }
        _previous() {
          const t = this.position
          const e = this.position.clone()
          const n = this._visitedParent
          if (n.parent === null && e.offset === 0) {
            return { done: true, value: undefined }
          }
          if (
            n == this._boundaryStartParent &&
            e.offset == this.boundaries.start.offset
          ) {
            return { done: true, value: undefined }
          }
          const i = e.parent
          const o = $p(e, i)
          const r = o ? o : Yp(e, i, o)
          if (r instanceof Vp) {
            e.offset--
            if (!this.shallow) {
              e.path.push(r.maxOffset)
              this.position = e
              this._visitedParent = r
              if (this.ignoreElementEnd) {
                return this._previous()
              } else {
                return Wp('elementEnd', r, t, e)
              }
            } else {
              this.position = e
              return Wp('elementStart', r, t, e, 1)
            }
          } else if (r instanceof jp) {
            let i
            if (this.singleCharacters) {
              i = 1
            } else {
              let t = r.startOffset
              if (
                this._boundaryStartParent == n &&
                this.boundaries.start.offset > t
              ) {
                t = this.boundaries.start.offset
              }
              i = e.offset - t
            }
            const o = e.offset - r.startOffset
            const s = new Fp(r, o - i, i)
            e.offset -= i
            this.position = e
            return Wp('text', s, t, e, i)
          } else {
            e.path.pop()
            this.position = e
            this._visitedParent = n.parent
            return Wp('elementStart', n, t, e, 1)
          }
        }
      }
      function Wp(t, e, n, i, o) {
        return {
          done: false,
          value: {
            type: t,
            item: e,
            previousPosition: n,
            nextPosition: i,
            length: o
          }
        }
      }
      class qp extends Lp {
        constructor(t, e, n = 'toNone') {
          super()
          if (!t.is('element') && !t.is('documentFragment')) {
            throw new N('model-position-root-invalid', t)
          }
          if (!(e instanceof Array) || e.length === 0) {
            throw new N('model-position-path-incorrect-format', t, { path: e })
          }
          if (t.is('rootElement')) {
            e = e.slice()
          } else {
            e = [...t.getPath(), ...e]
            t = t.root
          }
          this.root = t
          this.path = e
          this.stickiness = n
        }
        get offset() {
          return this.path[this.path.length - 1]
        }
        set offset(t) {
          this.path[this.path.length - 1] = t
        }
        get parent() {
          let t = this.root
          for (let e = 0; e < this.path.length - 1; e++) {
            t = t.getChild(t.offsetToIndex(this.path[e]))
            if (!t) {
              throw new N('model-position-path-incorrect', this, {
                position: this
              })
            }
          }
          if (t.is('$text')) {
            throw new N('model-position-path-incorrect', this, {
              position: this
            })
          }
          return t
        }
        get index() {
          return this.parent.offsetToIndex(this.offset)
        }
        get textNode() {
          return $p(this, this.parent)
        }
        get nodeAfter() {
          const t = this.parent
          return Gp(this, t, $p(this, t))
        }
        get nodeBefore() {
          const t = this.parent
          return Yp(this, t, $p(this, t))
        }
        get isAtStart() {
          return this.offset === 0
        }
        get isAtEnd() {
          return this.offset == this.parent.maxOffset
        }
        compareWith(t) {
          if (this.root != t.root) {
            return 'different'
          }
          const e = xt(this.path, t.path)
          switch (e) {
            case 'same':
              return 'same'
            case 'prefix':
              return 'before'
            case 'extension':
              return 'after'
            default:
              return this.path[e] < t.path[e] ? 'before' : 'after'
          }
        }
        getLastMatchingPosition(t, e = {}) {
          e.startPosition = this
          const n = new Up(e)
          n.skip(t)
          return n.position
        }
        getParentPath() {
          return this.path.slice(0, -1)
        }
        getAncestors() {
          const t = this.parent
          if (t.is('documentFragment')) {
            return [t]
          } else {
            return t.getAncestors({ includeSelf: true })
          }
        }
        findAncestor(t) {
          const e = this.parent
          if (e.is('element')) {
            return e.findAncestor(t, { includeSelf: true })
          }
          return null
        }
        getCommonPath(t) {
          if (this.root != t.root) {
            return []
          }
          const e = xt(this.path, t.path)
          const n =
            typeof e == 'string' ? Math.min(this.path.length, t.path.length) : e
          return this.path.slice(0, n)
        }
        getCommonAncestor(t) {
          const e = this.getAncestors()
          const n = t.getAncestors()
          let i = 0
          while (e[i] == n[i] && e[i]) {
            i++
          }
          return i === 0 ? null : e[i - 1]
        }
        getShiftedBy(t) {
          const e = this.clone()
          const n = e.offset + t
          e.offset = n < 0 ? 0 : n
          return e
        }
        isAfter(t) {
          return this.compareWith(t) == 'after'
        }
        isBefore(t) {
          return this.compareWith(t) == 'before'
        }
        isEqual(t) {
          return this.compareWith(t) == 'same'
        }
        isTouching(t) {
          if (this.root !== t.root) {
            return false
          }
          const e = Math.min(this.path.length, t.path.length)
          for (let n = 0; n < e; n++) {
            const e = this.path[n] - t.path[n]
            if (e < -1 || e > 1) {
              return false
            } else if (e === 1) {
              return Kp(t, this, n)
            } else if (e === -1) {
              return Kp(this, t, n)
            }
          }
          if (this.path.length === t.path.length) {
            return true
          } else if (this.path.length > t.path.length) {
            return Qp(this.path, e)
          } else {
            return Qp(t.path, e)
          }
        }
        hasSameParentAs(t) {
          if (this.root !== t.root) {
            return false
          }
          const e = this.getParentPath()
          const n = t.getParentPath()
          return xt(e, n) == 'same'
        }
        getTransformedByOperation(t) {
          let e
          switch (t.type) {
            case 'insert':
              e = this._getTransformedByInsertOperation(t)
              break
            case 'move':
            case 'remove':
            case 'reinsert':
              e = this._getTransformedByMoveOperation(t)
              break
            case 'split':
              e = this._getTransformedBySplitOperation(t)
              break
            case 'merge':
              e = this._getTransformedByMergeOperation(t)
              break
            default:
              e = qp._createAt(this)
              break
          }
          return e
        }
        _getTransformedByInsertOperation(t) {
          return this._getTransformedByInsertion(t.position, t.howMany)
        }
        _getTransformedByMoveOperation(t) {
          return this._getTransformedByMove(
            t.sourcePosition,
            t.targetPosition,
            t.howMany
          )
        }
        _getTransformedBySplitOperation(t) {
          const e = t.movedRange
          const n =
            e.containsPosition(this) ||
            (e.start.isEqual(this) && this.stickiness == 'toNext')
          if (n) {
            return this._getCombined(t.splitPosition, t.moveTargetPosition)
          } else {
            if (t.graveyardPosition) {
              return this._getTransformedByMove(
                t.graveyardPosition,
                t.insertionPosition,
                1
              )
            } else {
              return this._getTransformedByInsertion(t.insertionPosition, 1)
            }
          }
        }
        _getTransformedByMergeOperation(t) {
          const e = t.movedRange
          const n = e.containsPosition(this) || e.start.isEqual(this)
          let i
          if (n) {
            i = this._getCombined(t.sourcePosition, t.targetPosition)
            if (t.sourcePosition.isBefore(t.targetPosition)) {
              i = i._getTransformedByDeletion(t.deletionPosition, 1)
            }
          } else if (this.isEqual(t.deletionPosition)) {
            i = qp._createAt(t.deletionPosition)
          } else {
            i = this._getTransformedByMove(
              t.deletionPosition,
              t.graveyardPosition,
              1
            )
          }
          return i
        }
        _getTransformedByDeletion(t, e) {
          const n = qp._createAt(this)
          if (this.root != t.root) {
            return n
          }
          if (xt(t.getParentPath(), this.getParentPath()) == 'same') {
            if (t.offset < this.offset) {
              if (t.offset + e > this.offset) {
                return null
              } else {
                n.offset -= e
              }
            }
          } else if (xt(t.getParentPath(), this.getParentPath()) == 'prefix') {
            const i = t.path.length - 1
            if (t.offset <= this.path[i]) {
              if (t.offset + e > this.path[i]) {
                return null
              } else {
                n.path[i] -= e
              }
            }
          }
          return n
        }
        _getTransformedByInsertion(t, e) {
          const n = qp._createAt(this)
          if (this.root != t.root) {
            return n
          }
          if (xt(t.getParentPath(), this.getParentPath()) == 'same') {
            if (
              t.offset < this.offset ||
              (t.offset == this.offset && this.stickiness != 'toPrevious')
            ) {
              n.offset += e
            }
          } else if (xt(t.getParentPath(), this.getParentPath()) == 'prefix') {
            const i = t.path.length - 1
            if (t.offset <= this.path[i]) {
              n.path[i] += e
            }
          }
          return n
        }
        _getTransformedByMove(t, e, n) {
          e = e._getTransformedByDeletion(t, n)
          if (t.isEqual(e)) {
            return qp._createAt(this)
          }
          const i = this._getTransformedByDeletion(t, n)
          const o =
            i === null ||
            (t.isEqual(this) && this.stickiness == 'toNext') ||
            (t.getShiftedBy(n).isEqual(this) && this.stickiness == 'toPrevious')
          if (o) {
            return this._getCombined(t, e)
          } else {
            return i._getTransformedByInsertion(e, n)
          }
        }
        _getCombined(t, e) {
          const n = t.path.length - 1
          const i = qp._createAt(e)
          i.stickiness = this.stickiness
          i.offset = i.offset + this.path[n] - t.offset
          i.path = [...i.path, ...this.path.slice(n + 1)]
          return i
        }
        toJSON() {
          return {
            root: this.root.toJSON(),
            path: Array.from(this.path),
            stickiness: this.stickiness
          }
        }
        clone() {
          return new this.constructor(this.root, this.path, this.stickiness)
        }
        static _createAt(t, e, n = 'toNone') {
          if (t instanceof qp) {
            return new qp(t.root, t.path, t.stickiness)
          } else {
            const i = t
            if (e == 'end') {
              e = i.maxOffset
            } else if (e == 'before') {
              return this._createBefore(i, n)
            } else if (e == 'after') {
              return this._createAfter(i, n)
            } else if (e !== 0 && !e) {
              throw new N('model-createpositionat-offset-required', [this, t])
            }
            if (!i.is('element') && !i.is('documentFragment')) {
              throw new N('model-position-parent-incorrect', [this, t])
            }
            const o = i.getPath()
            o.push(e)
            return new this(i.root, o, n)
          }
        }
        static _createAfter(t, e) {
          if (!t.parent) {
            throw new N('model-position-after-root', [this, t], { root: t })
          }
          return this._createAt(t.parent, t.endOffset, e)
        }
        static _createBefore(t, e) {
          if (!t.parent) {
            throw new N('model-position-before-root', t, { root: t })
          }
          return this._createAt(t.parent, t.startOffset, e)
        }
        static fromJSON(t, e) {
          if (t.root === '$graveyard') {
            const n = new qp(e.graveyard, t.path)
            n.stickiness = t.stickiness
            return n
          }
          if (!e.getRoot(t.root)) {
            throw new N('model-position-fromjson-no-root', e, {
              rootName: t.root
            })
          }
          return new qp(e.getRoot(t.root), t.path, t.stickiness)
        }
      }
      qp.prototype.is = function (t) {
        return t === 'position' || t === 'model:position'
      }
      function $p(t, e) {
        const n = e.getChild(e.offsetToIndex(t.offset))
        if (n && n.is('$text') && n.startOffset < t.offset) {
          return n
        }
        return null
      }
      function Gp(t, e, n) {
        if (n !== null) {
          return null
        }
        return e.getChild(e.offsetToIndex(t.offset))
      }
      function Yp(t, e, n) {
        if (n !== null) {
          return null
        }
        return e.getChild(e.offsetToIndex(t.offset) - 1)
      }
      function Kp(t, e, n) {
        if (n + 1 === t.path.length) {
          return false
        }
        if (!Qp(e.path, n + 1)) {
          return false
        }
        if (!Zp(t, n + 1)) {
          return false
        }
        return true
      }
      function Qp(t, e) {
        while (e < t.length) {
          if (t[e] !== 0) {
            return false
          }
          e++
        }
        return true
      }
      function Zp(t, e) {
        let n = t.parent
        let i = t.path.length - 1
        let o = 0
        while (i >= e) {
          if (t.path[i] + o !== n.maxOffset) {
            return false
          }
          o = 1
          i--
          n = n.parent
        }
        return true
      }
      class Jp extends Lp {
        constructor(t, e) {
          super()
          this.start = qp._createAt(t)
          this.end = e ? qp._createAt(e) : qp._createAt(t)
          this.start.stickiness = this.isCollapsed ? 'toNone' : 'toNext'
          this.end.stickiness = this.isCollapsed ? 'toNone' : 'toPrevious'
        }
        *[Symbol.iterator]() {
          yield* new Up({ boundaries: this, ignoreElementEnd: true })
        }
        get isCollapsed() {
          return this.start.isEqual(this.end)
        }
        get isFlat() {
          const t = this.start.getParentPath()
          const e = this.end.getParentPath()
          return xt(t, e) == 'same'
        }
        get root() {
          return this.start.root
        }
        containsPosition(t) {
          return t.isAfter(this.start) && t.isBefore(this.end)
        }
        containsRange(t, e = false) {
          if (t.isCollapsed) {
            e = false
          }
          const n =
            this.containsPosition(t.start) || (e && this.start.isEqual(t.start))
          const i =
            this.containsPosition(t.end) || (e && this.end.isEqual(t.end))
          return n && i
        }
        containsItem(t) {
          const e = qp._createBefore(t)
          return this.containsPosition(e) || this.start.isEqual(e)
        }
        isEqual(t) {
          return this.start.isEqual(t.start) && this.end.isEqual(t.end)
        }
        isIntersecting(t) {
          return this.start.isBefore(t.end) && this.end.isAfter(t.start)
        }
        getDifference(t) {
          const e = []
          if (this.isIntersecting(t)) {
            if (this.containsPosition(t.start)) {
              e.push(new Jp(this.start, t.start))
            }
            if (this.containsPosition(t.end)) {
              e.push(new Jp(t.end, this.end))
            }
          } else {
            e.push(new Jp(this.start, this.end))
          }
          return e
        }
        getIntersection(t) {
          if (this.isIntersecting(t)) {
            let e = this.start
            let n = this.end
            if (this.containsPosition(t.start)) {
              e = t.start
            }
            if (this.containsPosition(t.end)) {
              n = t.end
            }
            return new Jp(e, n)
          }
          return null
        }
        getJoined(t, e = false) {
          let n = this.isIntersecting(t)
          if (!n) {
            if (this.start.isBefore(t.start)) {
              n = e ? this.end.isTouching(t.start) : this.end.isEqual(t.start)
            } else {
              n = e ? t.end.isTouching(this.start) : t.end.isEqual(this.start)
            }
          }
          if (!n) {
            return null
          }
          let i = this.start
          let o = this.end
          if (t.start.isBefore(i)) {
            i = t.start
          }
          if (t.end.isAfter(o)) {
            o = t.end
          }
          return new Jp(i, o)
        }
        getMinimalFlatRanges() {
          const t = []
          const e = this.start.getCommonPath(this.end).length
          const n = qp._createAt(this.start)
          let i = n.parent
          while (n.path.length > e + 1) {
            const e = i.maxOffset - n.offset
            if (e !== 0) {
              t.push(new Jp(n, n.getShiftedBy(e)))
            }
            n.path = n.path.slice(0, -1)
            n.offset++
            i = i.parent
          }
          while (n.path.length <= this.end.path.length) {
            const e = this.end.path[n.path.length - 1]
            const i = e - n.offset
            if (i !== 0) {
              t.push(new Jp(n, n.getShiftedBy(i)))
            }
            n.offset = e
            n.path.push(0)
          }
          return t
        }
        getWalker(t = {}) {
          t.boundaries = this
          return new Up(t)
        }
        *getItems(t = {}) {
          t.boundaries = this
          t.ignoreElementEnd = true
          const e = new Up(t)
          for (const t of e) {
            yield t.item
          }
        }
        *getPositions(t = {}) {
          t.boundaries = this
          const e = new Up(t)
          yield e.position
          for (const t of e) {
            yield t.nextPosition
          }
        }
        getTransformedByOperation(t) {
          switch (t.type) {
            case 'insert':
              return this._getTransformedByInsertOperation(t)
            case 'move':
            case 'remove':
            case 'reinsert':
              return this._getTransformedByMoveOperation(t)
            case 'split':
              return [this._getTransformedBySplitOperation(t)]
            case 'merge':
              return [this._getTransformedByMergeOperation(t)]
          }
          return [new Jp(this.start, this.end)]
        }
        getTransformedByOperations(t) {
          const e = [new Jp(this.start, this.end)]
          for (const n of t) {
            for (let t = 0; t < e.length; t++) {
              const i = e[t].getTransformedByOperation(n)
              e.splice(t, 1, ...i)
              t += i.length - 1
            }
          }
          for (let t = 0; t < e.length; t++) {
            const n = e[t]
            for (let i = t + 1; i < e.length; i++) {
              const t = e[i]
              if (n.containsRange(t) || t.containsRange(n) || n.isEqual(t)) {
                e.splice(i, 1)
              }
            }
          }
          return e
        }
        getCommonAncestor() {
          return this.start.getCommonAncestor(this.end)
        }
        getContainedElement() {
          if (this.isCollapsed) {
            return null
          }
          const t = this.start.nodeAfter
          const e = this.end.nodeBefore
          if (t && t.is('element') && t === e) {
            return t
          }
          return null
        }
        toJSON() {
          return { start: this.start.toJSON(), end: this.end.toJSON() }
        }
        clone() {
          return new this.constructor(this.start, this.end)
        }
        _getTransformedByInsertOperation(t, e = false) {
          return this._getTransformedByInsertion(t.position, t.howMany, e)
        }
        _getTransformedByMoveOperation(t, e = false) {
          const n = t.sourcePosition
          const i = t.howMany
          const o = t.targetPosition
          return this._getTransformedByMove(n, o, i, e)
        }
        _getTransformedBySplitOperation(t) {
          const e = this.start._getTransformedBySplitOperation(t)
          let n = this.end._getTransformedBySplitOperation(t)
          if (this.end.isEqual(t.insertionPosition)) {
            n = this.end.getShiftedBy(1)
          }
          if (e.root != n.root) {
            n = this.end.getShiftedBy(-1)
          }
          return new Jp(e, n)
        }
        _getTransformedByMergeOperation(t) {
          if (
            this.start.isEqual(t.targetPosition) &&
            this.end.isEqual(t.deletionPosition)
          ) {
            return new Jp(this.start)
          }
          let e = this.start._getTransformedByMergeOperation(t)
          let n = this.end._getTransformedByMergeOperation(t)
          if (e.root != n.root) {
            n = this.end.getShiftedBy(-1)
          }
          if (e.isAfter(n)) {
            if (t.sourcePosition.isBefore(t.targetPosition)) {
              e = qp._createAt(n)
              e.offset = 0
            } else {
              if (!t.deletionPosition.isEqual(e)) {
                n = t.deletionPosition
              }
              e = t.targetPosition
            }
            return new Jp(e, n)
          }
          return new Jp(e, n)
        }
        _getTransformedByInsertion(t, e, n = false) {
          if (n && this.containsPosition(t)) {
            return [
              new Jp(this.start, t),
              new Jp(
                t.getShiftedBy(e),
                this.end._getTransformedByInsertion(t, e)
              )
            ]
          } else {
            const n = new Jp(this.start, this.end)
            n.start = n.start._getTransformedByInsertion(t, e)
            n.end = n.end._getTransformedByInsertion(t, e)
            return [n]
          }
        }
        _getTransformedByMove(t, e, n, i = false) {
          if (this.isCollapsed) {
            const i = this.start._getTransformedByMove(t, e, n)
            return [new Jp(i)]
          }
          const o = Jp._createFromPositionAndShift(t, n)
          const r = e._getTransformedByDeletion(t, n)
          if (this.containsPosition(e) && !i) {
            if (
              o.containsPosition(this.start) ||
              o.containsPosition(this.end)
            ) {
              const i = this.start._getTransformedByMove(t, e, n)
              const o = this.end._getTransformedByMove(t, e, n)
              return [new Jp(i, o)]
            }
          }
          let s
          const a = this.getDifference(o)
          let c = null
          const l = this.getIntersection(o)
          if (a.length == 1) {
            c = new Jp(
              a[0].start._getTransformedByDeletion(t, n),
              a[0].end._getTransformedByDeletion(t, n)
            )
          } else if (a.length == 2) {
            c = new Jp(this.start, this.end._getTransformedByDeletion(t, n))
          }
          if (c) {
            s = c._getTransformedByInsertion(r, n, l !== null || i)
          } else {
            s = []
          }
          if (l) {
            const t = new Jp(
              l.start._getCombined(o.start, r),
              l.end._getCombined(o.start, r)
            )
            if (s.length == 2) {
              s.splice(1, 0, t)
            } else {
              s.push(t)
            }
          }
          return s
        }
        _getTransformedByDeletion(t, e) {
          let n = this.start._getTransformedByDeletion(t, e)
          let i = this.end._getTransformedByDeletion(t, e)
          if (n == null && i == null) {
            return null
          }
          if (n == null) {
            n = t
          }
          if (i == null) {
            i = t
          }
          return new Jp(n, i)
        }
        static _createFromPositionAndShift(t, e) {
          const n = t
          const i = t.getShiftedBy(e)
          return e > 0 ? new this(n, i) : new this(i, n)
        }
        static _createIn(t) {
          return new this(qp._createAt(t, 0), qp._createAt(t, t.maxOffset))
        }
        static _createOn(t) {
          return this._createFromPositionAndShift(
            qp._createBefore(t),
            t.offsetSize
          )
        }
        static _createFromRanges(t) {
          if (t.length === 0) {
            throw new N('range-create-from-ranges-empty-array', null)
          } else if (t.length == 1) {
            return t[0].clone()
          }
          const e = t[0]
          t.sort((t, e) => (t.start.isAfter(e.start) ? 1 : -1))
          const n = t.indexOf(e)
          const i = new this(e.start, e.end)
          if (n > 0) {
            for (let e = n - 1; true; e++) {
              if (t[e].end.isEqual(i.start)) {
                i.start = qp._createAt(t[e].start)
              } else {
                break
              }
            }
          }
          for (let e = n + 1; e < t.length; e++) {
            if (t[e].start.isEqual(i.end)) {
              i.end = qp._createAt(t[e].end)
            } else {
              break
            }
          }
          return i
        }
        static fromJSON(t, e) {
          return new this(qp.fromJSON(t.start, e), qp.fromJSON(t.end, e))
        }
      }
      Jp.prototype.is = function (t) {
        return t === 'range' || t === 'model:range'
      }
      class Xp extends $() {
        constructor() {
          super()
          this._modelToViewMapping = new WeakMap()
          this._viewToModelMapping = new WeakMap()
          this._viewToModelLengthCallbacks = new Map()
          this._markerNameToElements = new Map()
          this._elementToMarkerNames = new Map()
          this._deferredBindingRemovals = new Map()
          this._unboundMarkerNames = new Set()
          this.on(
            'modelToViewPosition',
            (t, e) => {
              if (e.viewPosition) {
                return
              }
              const n = this._modelToViewMapping.get(e.modelPosition.parent)
              if (!n) {
                throw new N(
                  'mapping-model-position-view-parent-not-found',
                  this,
                  { modelPosition: e.modelPosition }
                )
              }
              e.viewPosition = this.findPositionIn(n, e.modelPosition.offset)
            },
            { priority: 'low' }
          )
          this.on(
            'viewToModelPosition',
            (t, e) => {
              if (e.modelPosition) {
                return
              }
              const n = this.findMappedViewAncestor(e.viewPosition)
              const i = this._viewToModelMapping.get(n)
              const o = this._toModelOffset(
                e.viewPosition.parent,
                e.viewPosition.offset,
                n
              )
              e.modelPosition = qp._createAt(i, o)
            },
            { priority: 'low' }
          )
        }
        bindElements(t, e) {
          this._modelToViewMapping.set(t, e)
          this._viewToModelMapping.set(e, t)
        }
        unbindViewElement(t, e = {}) {
          const n = this.toModelElement(t)
          if (this._elementToMarkerNames.has(t)) {
            for (const e of this._elementToMarkerNames.get(t)) {
              this._unboundMarkerNames.add(e)
            }
          }
          if (e.defer) {
            this._deferredBindingRemovals.set(t, t.root)
          } else {
            this._viewToModelMapping.delete(t)
            if (this._modelToViewMapping.get(n) == t) {
              this._modelToViewMapping.delete(n)
            }
          }
        }
        unbindModelElement(t) {
          const e = this.toViewElement(t)
          this._modelToViewMapping.delete(t)
          if (this._viewToModelMapping.get(e) == t) {
            this._viewToModelMapping.delete(e)
          }
        }
        bindElementToMarker(t, e) {
          const n = this._markerNameToElements.get(e) || new Set()
          n.add(t)
          const i = this._elementToMarkerNames.get(t) || new Set()
          i.add(e)
          this._markerNameToElements.set(e, n)
          this._elementToMarkerNames.set(t, i)
        }
        unbindElementFromMarkerName(t, e) {
          const n = this._markerNameToElements.get(e)
          if (n) {
            n.delete(t)
            if (n.size == 0) {
              this._markerNameToElements.delete(e)
            }
          }
          const i = this._elementToMarkerNames.get(t)
          if (i) {
            i.delete(e)
            if (i.size == 0) {
              this._elementToMarkerNames.delete(t)
            }
          }
        }
        flushUnboundMarkerNames() {
          const t = Array.from(this._unboundMarkerNames)
          this._unboundMarkerNames.clear()
          return t
        }
        flushDeferredBindings() {
          for (const [t, e] of this._deferredBindingRemovals) {
            if (t.root == e) {
              this.unbindViewElement(t)
            }
          }
          this._deferredBindingRemovals = new Map()
        }
        clearBindings() {
          this._modelToViewMapping = new WeakMap()
          this._viewToModelMapping = new WeakMap()
          this._markerNameToElements = new Map()
          this._elementToMarkerNames = new Map()
          this._unboundMarkerNames = new Set()
          this._deferredBindingRemovals = new Map()
        }
        toModelElement(t) {
          return this._viewToModelMapping.get(t)
        }
        toViewElement(t) {
          return this._modelToViewMapping.get(t)
        }
        toModelRange(t) {
          return new Jp(
            this.toModelPosition(t.start),
            this.toModelPosition(t.end)
          )
        }
        toViewRange(t) {
          return new Nf(
            this.toViewPosition(t.start),
            this.toViewPosition(t.end)
          )
        }
        toModelPosition(t) {
          const e = { viewPosition: t, mapper: this }
          this.fire('viewToModelPosition', e)
          return e.modelPosition
        }
        toViewPosition(t, e = {}) {
          const n = { modelPosition: t, mapper: this, isPhantom: e.isPhantom }
          this.fire('modelToViewPosition', n)
          return n.viewPosition
        }
        markerNameToElements(t) {
          const e = this._markerNameToElements.get(t)
          if (!e) {
            return null
          }
          const n = new Set()
          for (const t of e) {
            if (t.is('attributeElement')) {
              for (const e of t.getElementsWithSameId()) {
                n.add(e)
              }
            } else {
              n.add(t)
            }
          }
          return n
        }
        registerViewToModelLength(t, e) {
          this._viewToModelLengthCallbacks.set(t, e)
        }
        findMappedViewAncestor(t) {
          let e = t.parent
          while (!this._viewToModelMapping.has(e)) {
            e = e.parent
          }
          return e
        }
        _toModelOffset(t, e, n) {
          if (n != t) {
            const i = this._toModelOffset(t.parent, t.index, n)
            const o = this._toModelOffset(t, e, t)
            return i + o
          }
          if (t.is('$text')) {
            return e
          }
          let i = 0
          for (let n = 0; n < e; n++) {
            i += this.getModelLength(t.getChild(n))
          }
          return i
        }
        getModelLength(t) {
          if (this._viewToModelLengthCallbacks.get(t.name)) {
            const e = this._viewToModelLengthCallbacks.get(t.name)
            return e(t)
          } else if (this._viewToModelMapping.has(t)) {
            return 1
          } else if (t.is('$text')) {
            return t.data.length
          } else if (t.is('uiElement')) {
            return 0
          } else {
            let e = 0
            for (const n of t.getChildren()) {
              e += this.getModelLength(n)
            }
            return e
          }
        }
        findPositionIn(t, e) {
          let n
          let i = 0
          let o = 0
          let r = 0
          if (t.is('$text')) {
            return new Bf(t, e)
          }
          while (o < e) {
            n = t.getChild(r)
            i = this.getModelLength(n)
            o += i
            r++
          }
          if (o == e) {
            return this._moveViewPositionToTextNode(new Bf(t, r))
          } else {
            return this.findPositionIn(n, e - (o - i))
          }
        }
        _moveViewPositionToTextNode(t) {
          const e = t.nodeBefore
          const n = t.nodeAfter
          if (e instanceof Au) {
            return new Bf(e, e.data.length)
          } else if (n instanceof Au) {
            return new Bf(n, 0)
          }
          return t
        }
      }
      class tb {
        constructor() {
          this._consumable = new Map()
          this._textProxyRegistry = new Map()
        }
        add(t, e) {
          e = eb(e)
          if (t instanceof Fp) {
            t = this._getSymbolForTextProxy(t)
          }
          if (!this._consumable.has(t)) {
            this._consumable.set(t, new Map())
          }
          this._consumable.get(t).set(e, true)
        }
        consume(t, e) {
          e = eb(e)
          if (t instanceof Fp) {
            t = this._getSymbolForTextProxy(t)
          }
          if (this.test(t, e)) {
            this._consumable.get(t).set(e, false)
            return true
          } else {
            return false
          }
        }
        test(t, e) {
          e = eb(e)
          if (t instanceof Fp) {
            t = this._getSymbolForTextProxy(t)
          }
          const n = this._consumable.get(t)
          if (n === undefined) {
            return null
          }
          const i = n.get(e)
          if (i === undefined) {
            return null
          }
          return i
        }
        revert(t, e) {
          e = eb(e)
          if (t instanceof Fp) {
            t = this._getSymbolForTextProxy(t)
          }
          const n = this.test(t, e)
          if (n === false) {
            this._consumable.get(t).set(e, true)
            return true
          } else if (n === true) {
            return false
          }
          return null
        }
        verifyAllConsumed(t) {
          const e = []
          for (const [n, i] of this._consumable) {
            for (const [o, r] of i) {
              const i = o.split(':')[0]
              if (r && t == i) {
                e.push({ event: o, item: n.name || n.description })
              }
            }
          }
          if (e.length) {
            throw new N('conversion-model-consumable-not-consumed', null, {
              items: e
            })
          }
        }
        _getSymbolForTextProxy(t) {
          let e = null
          const n = this._textProxyRegistry.get(t.startOffset)
          if (n) {
            const i = n.get(t.endOffset)
            if (i) {
              e = i.get(t.parent)
            }
          }
          if (!e) {
            e = this._addSymbolForTextProxy(t)
          }
          return e
        }
        _addSymbolForTextProxy(t) {
          const e = t.startOffset
          const n = t.endOffset
          const i = t.parent
          const o = Symbol('$textProxy:' + t.data)
          let r
          let s
          r = this._textProxyRegistry.get(e)
          if (!r) {
            r = new Map()
            this._textProxyRegistry.set(e, r)
          }
          s = r.get(n)
          if (!s) {
            s = new Map()
            r.set(n, s)
          }
          s.set(i, o)
          return o
        }
      }
      function eb(t) {
        const e = t.split(':')
        if (e[0] == 'insert') {
          return e[0]
        }
        if (e[0] == 'addMarker' || e[0] == 'removeMarker') {
          return t
        }
        return e.length > 1 ? e[0] + ':' + e[1] : e[0]
      }
      class nb extends $() {
        constructor(t) {
          super()
          this._conversionApi = { dispatcher: this, ...t }
          this._firedEventsMap = new WeakMap()
        }
        convertChanges(t, e, n) {
          const i = this._createConversionApi(n, t.getRefreshedItems())
          for (const e of t.getMarkersToRemove()) {
            this._convertMarkerRemove(e.name, e.range, i)
          }
          const o = this._reduceChanges(t.getChanges())
          for (const t of o) {
            if (t.type === 'insert') {
              this._convertInsert(
                Jp._createFromPositionAndShift(t.position, t.length),
                i
              )
            } else if (t.type === 'reinsert') {
              this._convertReinsert(
                Jp._createFromPositionAndShift(t.position, t.length),
                i
              )
            } else if (t.type === 'remove') {
              this._convertRemove(t.position, t.length, t.name, i)
            } else {
              this._convertAttribute(
                t.range,
                t.attributeKey,
                t.attributeOldValue,
                t.attributeNewValue,
                i
              )
            }
          }
          for (const t of i.mapper.flushUnboundMarkerNames()) {
            const n = e.get(t).getRange()
            this._convertMarkerRemove(t, n, i)
            this._convertMarkerAdd(t, n, i)
          }
          for (const e of t.getMarkersToAdd()) {
            this._convertMarkerAdd(e.name, e.range, i)
          }
          i.mapper.flushDeferredBindings()
          i.consumable.verifyAllConsumed('insert')
        }
        convert(t, e, n, i = {}) {
          const o = this._createConversionApi(n, undefined, i)
          this._convertInsert(t, o)
          for (const [t, n] of e) {
            this._convertMarkerAdd(t, n, o)
          }
          o.consumable.verifyAllConsumed('insert')
        }
        convertSelection(t, e, n) {
          const i = Array.from(e.getMarkersAtPosition(t.getFirstPosition()))
          const o = this._createConversionApi(n)
          this._addConsumablesForSelection(o.consumable, t, i)
          this.fire('selection', { selection: t }, o)
          if (!t.isCollapsed) {
            return
          }
          for (const e of i) {
            const n = e.getRange()
            if (!ib(t.getFirstPosition(), e, o.mapper)) {
              continue
            }
            const i = { item: t, markerName: e.name, markerRange: n }
            if (o.consumable.test(t, 'addMarker:' + e.name)) {
              this.fire(`addMarker:${e.name}`, i, o)
            }
          }
          for (const e of t.getAttributeKeys()) {
            const n = {
              item: t,
              range: t.getFirstRange(),
              attributeKey: e,
              attributeOldValue: null,
              attributeNewValue: t.getAttribute(e)
            }
            if (o.consumable.test(t, 'attribute:' + n.attributeKey)) {
              this.fire(`attribute:${n.attributeKey}:$text`, n, o)
            }
          }
        }
        _convertInsert(t, e, n = {}) {
          if (!n.doNotAddConsumables) {
            this._addConsumablesForInsert(e.consumable, Array.from(t))
          }
          for (const n of Array.from(t.getWalker({ shallow: true })).map(rb)) {
            this._testAndFire('insert', n, e)
          }
        }
        _convertRemove(t, e, n, i) {
          this.fire(`remove:${n}`, { position: t, length: e }, i)
        }
        _convertAttribute(t, e, n, i, o) {
          this._addConsumablesForRange(o.consumable, t, `attribute:${e}`)
          for (const r of t) {
            const t = {
              item: r.item,
              range: Jp._createFromPositionAndShift(
                r.previousPosition,
                r.length
              ),
              attributeKey: e,
              attributeOldValue: n,
              attributeNewValue: i
            }
            this._testAndFire(`attribute:${e}`, t, o)
          }
        }
        _convertReinsert(t, e) {
          const n = Array.from(t.getWalker({ shallow: true }))
          this._addConsumablesForInsert(e.consumable, n)
          for (const t of n.map(rb)) {
            this._testAndFire('insert', { ...t, reconversion: true }, e)
          }
        }
        _convertMarkerAdd(t, e, n) {
          if (e.root.rootName == '$graveyard') {
            return
          }
          const i = `addMarker:${t}`
          n.consumable.add(e, i)
          this.fire(i, { markerName: t, markerRange: e }, n)
          if (!n.consumable.consume(e, i)) {
            return
          }
          this._addConsumablesForRange(n.consumable, e, i)
          for (const o of e.getItems()) {
            if (!n.consumable.test(o, i)) {
              continue
            }
            const r = {
              item: o,
              range: Jp._createOn(o),
              markerName: t,
              markerRange: e
            }
            this.fire(i, r, n)
          }
        }
        _convertMarkerRemove(t, e, n) {
          if (e.root.rootName == '$graveyard') {
            return
          }
          this.fire(`removeMarker:${t}`, { markerName: t, markerRange: e }, n)
        }
        _reduceChanges(t) {
          const e = { changes: t }
          this.fire('reduceChanges', e)
          return e.changes
        }
        _addConsumablesForInsert(t, e) {
          for (const n of e) {
            const e = n.item
            if (t.test(e, 'insert') === null) {
              t.add(e, 'insert')
              for (const n of e.getAttributeKeys()) {
                t.add(e, 'attribute:' + n)
              }
            }
          }
          return t
        }
        _addConsumablesForRange(t, e, n) {
          for (const i of e.getItems()) {
            t.add(i, n)
          }
          return t
        }
        _addConsumablesForSelection(t, e, n) {
          t.add(e, 'selection')
          for (const i of n) {
            t.add(e, 'addMarker:' + i.name)
          }
          for (const n of e.getAttributeKeys()) {
            t.add(e, 'attribute:' + n)
          }
          return t
        }
        _testAndFire(t, e, n) {
          const i = ob(t, e)
          const o = e.item.is('$textProxy')
            ? n.consumable._getSymbolForTextProxy(e.item)
            : e.item
          const r = this._firedEventsMap.get(n)
          const s = r.get(o)
          if (!s) {
            r.set(o, new Set([i]))
          } else if (!s.has(i)) {
            s.add(i)
          } else {
            return
          }
          this.fire(i, e, n)
        }
        _testAndFireAddAttributes(t, e) {
          const n = { item: t, range: Jp._createOn(t) }
          for (const t of n.item.getAttributeKeys()) {
            n.attributeKey = t
            n.attributeOldValue = null
            n.attributeNewValue = n.item.getAttribute(t)
            this._testAndFire(`attribute:${t}`, n, e)
          }
        }
        _createConversionApi(t, e = new Set(), n = {}) {
          const i = {
            ...this._conversionApi,
            consumable: new tb(),
            writer: t,
            options: n,
            convertItem: (t) => this._convertInsert(Jp._createOn(t), i),
            convertChildren: (t) =>
              this._convertInsert(Jp._createIn(t), i, {
                doNotAddConsumables: true
              }),
            convertAttributes: (t) => this._testAndFireAddAttributes(t, i),
            canReuseView: (t) => !e.has(i.mapper.toModelElement(t))
          }
          this._firedEventsMap.set(i, new Map())
          return i
        }
      }
      function ib(t, e, n) {
        const i = e.getRange()
        const o = Array.from(t.getAncestors())
        o.shift()
        o.reverse()
        const r = o.some((t) => {
          if (i.containsItem(t)) {
            const e = n.toViewElement(t)
            return !!e.getCustomProperty('addHighlight')
          }
        })
        return !r
      }
      function ob(t, e) {
        const n = e.item.is('element') ? e.item.name : '$text'
        return `${t}:${n}`
      }
      function rb(t) {
        const e = t.item
        const n = Jp._createFromPositionAndShift(t.previousPosition, t.length)
        return { item: e, range: n }
      }
      class sb extends $(Lp) {
        constructor(...t) {
          super()
          this._lastRangeBackward = false
          this._attrs = new Map()
          this._ranges = []
          if (t.length) {
            this.setTo(...t)
          }
        }
        get anchor() {
          if (this._ranges.length > 0) {
            const t = this._ranges[this._ranges.length - 1]
            return this._lastRangeBackward ? t.end : t.start
          }
          return null
        }
        get focus() {
          if (this._ranges.length > 0) {
            const t = this._ranges[this._ranges.length - 1]
            return this._lastRangeBackward ? t.start : t.end
          }
          return null
        }
        get isCollapsed() {
          const t = this._ranges.length
          if (t === 1) {
            return this._ranges[0].isCollapsed
          } else {
            return false
          }
        }
        get rangeCount() {
          return this._ranges.length
        }
        get isBackward() {
          return !this.isCollapsed && this._lastRangeBackward
        }
        isEqual(t) {
          if (this.rangeCount != t.rangeCount) {
            return false
          } else if (this.rangeCount === 0) {
            return true
          }
          if (!this.anchor.isEqual(t.anchor) || !this.focus.isEqual(t.focus)) {
            return false
          }
          for (const e of this._ranges) {
            let n = false
            for (const i of t._ranges) {
              if (e.isEqual(i)) {
                n = true
                break
              }
            }
            if (!n) {
              return false
            }
          }
          return true
        }
        *getRanges() {
          for (const t of this._ranges) {
            yield new Jp(t.start, t.end)
          }
        }
        getFirstRange() {
          let t = null
          for (const e of this._ranges) {
            if (!t || e.start.isBefore(t.start)) {
              t = e
            }
          }
          return t ? new Jp(t.start, t.end) : null
        }
        getLastRange() {
          let t = null
          for (const e of this._ranges) {
            if (!t || e.end.isAfter(t.end)) {
              t = e
            }
          }
          return t ? new Jp(t.start, t.end) : null
        }
        getFirstPosition() {
          const t = this.getFirstRange()
          return t ? t.start.clone() : null
        }
        getLastPosition() {
          const t = this.getLastRange()
          return t ? t.end.clone() : null
        }
        setTo(...t) {
          let [e, n, i] = t
          if (typeof n == 'object') {
            i = n
            n = undefined
          }
          if (e === null) {
            this._setRanges([])
          } else if (e instanceof sb) {
            this._setRanges(e.getRanges(), e.isBackward)
          } else if (e && typeof e.getRanges == 'function') {
            this._setRanges(e.getRanges(), e.isBackward)
          } else if (e instanceof Jp) {
            this._setRanges([e], !!i && !!i.backward)
          } else if (e instanceof qp) {
            this._setRanges([new Jp(e)])
          } else if (e instanceof Op) {
            const t = !!i && !!i.backward
            let o
            if (n == 'in') {
              o = Jp._createIn(e)
            } else if (n == 'on') {
              o = Jp._createOn(e)
            } else if (n !== undefined) {
              o = new Jp(qp._createAt(e, n))
            } else {
              throw new N('model-selection-setto-required-second-parameter', [
                this,
                e
              ])
            }
            this._setRanges([o], t)
          } else if (Et(e)) {
            this._setRanges(e, i && !!i.backward)
          } else {
            throw new N('model-selection-setto-not-selectable', [this, e])
          }
        }
        _setRanges(t, e = false) {
          const n = Array.from(t)
          const i = n.some((e) => {
            if (!(e instanceof Jp)) {
              throw new N('model-selection-set-ranges-not-range', [this, t])
            }
            return this._ranges.every((t) => !t.isEqual(e))
          })
          if (n.length === this._ranges.length && !i) {
            return
          }
          this._replaceAllRanges(n)
          this._lastRangeBackward = !!e
          this.fire('change:range', { directChange: true })
        }
        setFocus(t, e) {
          if (this.anchor === null) {
            throw new N('model-selection-setfocus-no-ranges', [this, t])
          }
          const n = qp._createAt(t, e)
          if (n.compareWith(this.focus) == 'same') {
            return
          }
          const i = this.anchor
          if (this._ranges.length) {
            this._popRange()
          }
          if (n.compareWith(i) == 'before') {
            this._pushRange(new Jp(n, i))
            this._lastRangeBackward = true
          } else {
            this._pushRange(new Jp(i, n))
            this._lastRangeBackward = false
          }
          this.fire('change:range', { directChange: true })
        }
        getAttribute(t) {
          return this._attrs.get(t)
        }
        getAttributes() {
          return this._attrs.entries()
        }
        getAttributeKeys() {
          return this._attrs.keys()
        }
        hasAttribute(t) {
          return this._attrs.has(t)
        }
        removeAttribute(t) {
          if (this.hasAttribute(t)) {
            this._attrs.delete(t)
            this.fire('change:attribute', {
              attributeKeys: [t],
              directChange: true
            })
          }
        }
        setAttribute(t, e) {
          if (this.getAttribute(t) !== e) {
            this._attrs.set(t, e)
            this.fire('change:attribute', {
              attributeKeys: [t],
              directChange: true
            })
          }
        }
        getSelectedElement() {
          if (this.rangeCount !== 1) {
            return null
          }
          return this.getFirstRange().getContainedElement()
        }
        *getSelectedBlocks() {
          const t = new WeakSet()
          for (const e of this.getRanges()) {
            const n = lb(e.start, t)
            if (n && db(n, e)) {
              yield n
            }
            for (const n of e.getWalker()) {
              const i = n.item
              if (n.type == 'elementEnd' && cb(i, t, e)) {
                yield i
              }
            }
            const i = lb(e.end, t)
            if (i && !e.end.isTouching(qp._createAt(i, 0)) && db(i, e)) {
              yield i
            }
          }
        }
        containsEntireContent(t = this.anchor.root) {
          const e = qp._createAt(t, 0)
          const n = qp._createAt(t, 'end')
          return (
            e.isTouching(this.getFirstPosition()) &&
            n.isTouching(this.getLastPosition())
          )
        }
        _pushRange(t) {
          this._checkRange(t)
          this._ranges.push(new Jp(t.start, t.end))
        }
        _checkRange(t) {
          for (let e = 0; e < this._ranges.length; e++) {
            if (t.isIntersecting(this._ranges[e])) {
              throw new N('model-selection-range-intersects', [this, t], {
                addedRange: t,
                intersectingRange: this._ranges[e]
              })
            }
          }
        }
        _replaceAllRanges(t) {
          this._removeAllRanges()
          for (const e of t) {
            this._pushRange(e)
          }
        }
        _removeAllRanges() {
          while (this._ranges.length > 0) {
            this._popRange()
          }
        }
        _popRange() {
          this._ranges.pop()
        }
      }
      sb.prototype.is = function (t) {
        return t === 'selection' || t === 'model:selection'
      }
      function ab(t, e) {
        if (e.has(t)) {
          return false
        }
        e.add(t)
        return t.root.document.model.schema.isBlock(t) && !!t.parent
      }
      function cb(t, e, n) {
        return ab(t, e) && db(t, n)
      }
      function lb(t, e) {
        const n = t.parent
        const i = n.root.document.model.schema
        const o = t.parent.getAncestors({
          parentFirst: true,
          includeSelf: true
        })
        let r = false
        const s = o.find((t) => {
          if (r) {
            return false
          }
          r = i.isLimit(t)
          return !r && ab(t, e)
        })
        o.forEach((t) => e.add(t))
        return s
      }
      function db(t, e) {
        const n = ub(t)
        if (!n) {
          return true
        }
        const i = e.containsRange(Jp._createOn(n), true)
        return !i
      }
      function ub(t) {
        const e = t.root.document.model.schema
        let n = t.parent
        while (n) {
          if (e.isBlock(n)) {
            return n
          }
          n = n.parent
        }
      }
      class hb extends $(Jp) {
        constructor(t, e) {
          super(t, e)
          fb.call(this)
        }
        detach() {
          this.stopListening()
        }
        toRange() {
          return new Jp(this.start, this.end)
        }
        static fromRange(t) {
          return new hb(t.start, t.end)
        }
      }
      hb.prototype.is = function (t) {
        return (
          t === 'liveRange' ||
          t === 'model:liveRange' ||
          t == 'range' ||
          t === 'model:range'
        )
      }
      function fb() {
        this.listenTo(
          this.root.document.model,
          'applyOperation',
          (t, e) => {
            const n = e[0]
            if (!n.isDocumentOperation) {
              return
            }
            mb.call(this, n)
          },
          { priority: 'low' }
        )
      }
      function mb(t) {
        const e = this.getTransformedByOperation(t)
        const n = Jp._createFromRanges(e)
        const i = !n.isEqual(this)
        const o = gb(this, t)
        let r = null
        if (i) {
          if (n.root.rootName == '$graveyard') {
            if (t.type == 'remove') {
              r = t.sourcePosition
            } else {
              r = t.deletionPosition
            }
          }
          const e = this.toRange()
          this.start = n.start
          this.end = n.end
          this.fire('change:range', e, { deletionPosition: r })
        } else if (o) {
          this.fire('change:content', this.toRange(), { deletionPosition: r })
        }
      }
      function gb(t, e) {
        switch (e.type) {
          case 'insert':
            return t.containsPosition(e.position)
          case 'move':
          case 'remove':
          case 'reinsert':
          case 'merge':
            return (
              t.containsPosition(e.sourcePosition) ||
              t.start.isEqual(e.sourcePosition) ||
              t.containsPosition(e.targetPosition)
            )
          case 'split':
            return (
              t.containsPosition(e.splitPosition) ||
              t.containsPosition(e.insertionPosition)
            )
        }
        return false
      }
      const pb = 'selection:'
      class bb extends $(Lp) {
        constructor(t) {
          super()
          this._selection = new kb(t)
          this._selection.delegate('change:range').to(this)
          this._selection.delegate('change:attribute').to(this)
          this._selection.delegate('change:marker').to(this)
        }
        get isCollapsed() {
          return this._selection.isCollapsed
        }
        get anchor() {
          return this._selection.anchor
        }
        get focus() {
          return this._selection.focus
        }
        get rangeCount() {
          return this._selection.rangeCount
        }
        get hasOwnRange() {
          return this._selection.hasOwnRange
        }
        get isBackward() {
          return this._selection.isBackward
        }
        get isGravityOverridden() {
          return this._selection.isGravityOverridden
        }
        get markers() {
          return this._selection.markers
        }
        get _ranges() {
          return this._selection._ranges
        }
        getRanges() {
          return this._selection.getRanges()
        }
        getFirstPosition() {
          return this._selection.getFirstPosition()
        }
        getLastPosition() {
          return this._selection.getLastPosition()
        }
        getFirstRange() {
          return this._selection.getFirstRange()
        }
        getLastRange() {
          return this._selection.getLastRange()
        }
        getSelectedBlocks() {
          return this._selection.getSelectedBlocks()
        }
        getSelectedElement() {
          return this._selection.getSelectedElement()
        }
        containsEntireContent(t) {
          return this._selection.containsEntireContent(t)
        }
        destroy() {
          this._selection.destroy()
        }
        getAttributeKeys() {
          return this._selection.getAttributeKeys()
        }
        getAttributes() {
          return this._selection.getAttributes()
        }
        getAttribute(t) {
          return this._selection.getAttribute(t)
        }
        hasAttribute(t) {
          return this._selection.hasAttribute(t)
        }
        refresh() {
          this._selection.updateMarkers()
          this._selection._updateAttributes(false)
        }
        observeMarkers(t) {
          this._selection.observeMarkers(t)
        }
        _setFocus(t, e) {
          this._selection.setFocus(t, e)
        }
        _setTo(...t) {
          this._selection.setTo(...t)
        }
        _setAttribute(t, e) {
          this._selection.setAttribute(t, e)
        }
        _removeAttribute(t) {
          this._selection.removeAttribute(t)
        }
        _getStoredAttributes() {
          return this._selection.getStoredAttributes()
        }
        _overrideGravity() {
          return this._selection.overrideGravity()
        }
        _restoreGravity(t) {
          this._selection.restoreGravity(t)
        }
        static _getStoreAttributeKey(t) {
          return pb + t
        }
        static _isStoreAttributeKey(t) {
          return t.startsWith(pb)
        }
      }
      bb.prototype.is = function (t) {
        return (
          t === 'selection' ||
          t == 'model:selection' ||
          t == 'documentSelection' ||
          t == 'model:documentSelection'
        )
      }
      class kb extends sb {
        constructor(t) {
          super()
          this.markers = new al({ idProperty: 'name' })
          this._attributePriority = new Map()
          this._selectionRestorePosition = null
          this._hasChangedRange = false
          this._overriddenGravityRegister = new Set()
          this._observedMarkers = new Set()
          this._model = t.model
          this._document = t
          this.listenTo(
            this._model,
            'applyOperation',
            (t, e) => {
              const n = e[0]
              if (
                !n.isDocumentOperation ||
                n.type == 'marker' ||
                n.type == 'rename' ||
                n.type == 'noop'
              ) {
                return
              }
              if (this._ranges.length == 0 && this._selectionRestorePosition) {
                this._fixGraveyardSelection(this._selectionRestorePosition)
              }
              this._selectionRestorePosition = null
              if (this._hasChangedRange) {
                this._hasChangedRange = false
                this.fire('change:range', { directChange: false })
              }
            },
            { priority: 'lowest' }
          )
          this.on('change:range', () => {
            this._validateSelectionRanges(this.getRanges())
          })
          this.listenTo(this._model.markers, 'update', (t, e, n, i) => {
            this._updateMarker(e, i)
          })
          this.listenTo(this._document, 'change', (t, e) => {
            _b(this._model, e)
          })
        }
        get isCollapsed() {
          const t = this._ranges.length
          return t === 0
            ? this._document._getDefaultRange().isCollapsed
            : super.isCollapsed
        }
        get anchor() {
          return super.anchor || this._document._getDefaultRange().start
        }
        get focus() {
          return super.focus || this._document._getDefaultRange().end
        }
        get rangeCount() {
          return this._ranges.length ? this._ranges.length : 1
        }
        get hasOwnRange() {
          return this._ranges.length > 0
        }
        get isGravityOverridden() {
          return !!this._overriddenGravityRegister.size
        }
        destroy() {
          for (let t = 0; t < this._ranges.length; t++) {
            this._ranges[t].detach()
          }
          this.stopListening()
        }
        *getRanges() {
          if (this._ranges.length) {
            yield* super.getRanges()
          } else {
            yield this._document._getDefaultRange()
          }
        }
        getFirstRange() {
          return super.getFirstRange() || this._document._getDefaultRange()
        }
        getLastRange() {
          return super.getLastRange() || this._document._getDefaultRange()
        }
        setTo(...t) {
          super.setTo(...t)
          this._updateAttributes(true)
          this.updateMarkers()
        }
        setFocus(t, e) {
          super.setFocus(t, e)
          this._updateAttributes(true)
          this.updateMarkers()
        }
        setAttribute(t, e) {
          if (this._setAttribute(t, e)) {
            const e = [t]
            this.fire('change:attribute', {
              attributeKeys: e,
              directChange: true
            })
          }
        }
        removeAttribute(t) {
          if (this._removeAttribute(t)) {
            const e = [t]
            this.fire('change:attribute', {
              attributeKeys: e,
              directChange: true
            })
          }
        }
        overrideGravity() {
          const t = T()
          this._overriddenGravityRegister.add(t)
          if (this._overriddenGravityRegister.size === 1) {
            this._updateAttributes(true)
          }
          return t
        }
        restoreGravity(t) {
          if (!this._overriddenGravityRegister.has(t)) {
            throw new N('document-selection-gravity-wrong-restore', this, {
              uid: t
            })
          }
          this._overriddenGravityRegister.delete(t)
          if (!this.isGravityOverridden) {
            this._updateAttributes(true)
          }
        }
        observeMarkers(t) {
          this._observedMarkers.add(t)
          this.updateMarkers()
        }
        _replaceAllRanges(t) {
          this._validateSelectionRanges(t)
          super._replaceAllRanges(t)
        }
        _popRange() {
          this._ranges.pop().detach()
        }
        _pushRange(t) {
          const e = this._prepareRange(t)
          if (e) {
            this._ranges.push(e)
          }
        }
        _validateSelectionRanges(t) {
          for (const e of t) {
            if (!this._document._validateSelectionRange(e)) {
              throw new N('document-selection-wrong-position', this, {
                range: e
              })
            }
          }
        }
        _prepareRange(t) {
          this._checkRange(t)
          if (t.root == this._document.graveyard) {
            return
          }
          const e = hb.fromRange(t)
          e.on('change:range', (t, n, i) => {
            this._hasChangedRange = true
            if (e.root == this._document.graveyard) {
              this._selectionRestorePosition = i.deletionPosition
              const t = this._ranges.indexOf(e)
              this._ranges.splice(t, 1)
              e.detach()
            }
          })
          return e
        }
        updateMarkers() {
          if (!this._observedMarkers.size) {
            return
          }
          const t = []
          let e = false
          for (const e of this._model.markers) {
            const n = e.name.split(':', 1)[0]
            if (!this._observedMarkers.has(n)) {
              continue
            }
            const i = e.getRange()
            for (const n of this.getRanges()) {
              if (i.containsRange(n, !n.isCollapsed)) {
                t.push(e)
              }
            }
          }
          const n = Array.from(this.markers)
          for (const n of t) {
            if (!this.markers.has(n)) {
              this.markers.add(n)
              e = true
            }
          }
          for (const n of Array.from(this.markers)) {
            if (!t.includes(n)) {
              this.markers.remove(n)
              e = true
            }
          }
          if (e) {
            this.fire('change:marker', { oldMarkers: n, directChange: false })
          }
        }
        _updateMarker(t, e) {
          const n = t.name.split(':', 1)[0]
          if (!this._observedMarkers.has(n)) {
            return
          }
          let i = false
          const o = Array.from(this.markers)
          const r = this.markers.has(t)
          if (!e) {
            if (r) {
              this.markers.remove(t)
              i = true
            }
          } else {
            let n = false
            for (const t of this.getRanges()) {
              if (e.containsRange(t, !t.isCollapsed)) {
                n = true
                break
              }
            }
            if (n && !r) {
              this.markers.add(t)
              i = true
            } else if (!n && r) {
              this.markers.remove(t)
              i = true
            }
          }
          if (i) {
            this.fire('change:marker', { oldMarkers: o, directChange: false })
          }
        }
        _updateAttributes(t) {
          const e = hl(this._getSurroundingAttributes())
          const n = hl(this.getAttributes())
          if (t) {
            this._attributePriority = new Map()
            this._attrs = new Map()
          } else {
            for (const [t, e] of this._attributePriority) {
              if (e == 'low') {
                this._attrs.delete(t)
                this._attributePriority.delete(t)
              }
            }
          }
          this._setAttributesTo(e)
          const i = []
          for (const [t, e] of this.getAttributes()) {
            if (!n.has(t) || n.get(t) !== e) {
              i.push(t)
            }
          }
          for (const [t] of n) {
            if (!this.hasAttribute(t)) {
              i.push(t)
            }
          }
          if (i.length > 0) {
            this.fire('change:attribute', {
              attributeKeys: i,
              directChange: false
            })
          }
        }
        _setAttribute(t, e, n = true) {
          const i = n ? 'normal' : 'low'
          if (i == 'low' && this._attributePriority.get(t) == 'normal') {
            return false
          }
          const o = super.getAttribute(t)
          if (o === e) {
            return false
          }
          this._attrs.set(t, e)
          this._attributePriority.set(t, i)
          return true
        }
        _removeAttribute(t, e = true) {
          const n = e ? 'normal' : 'low'
          if (n == 'low' && this._attributePriority.get(t) == 'normal') {
            return false
          }
          this._attributePriority.set(t, n)
          if (!super.hasAttribute(t)) {
            return false
          }
          this._attrs.delete(t)
          return true
        }
        _setAttributesTo(t) {
          const e = new Set()
          for (const [e, n] of this.getAttributes()) {
            if (t.get(e) === n) {
              continue
            }
            this._removeAttribute(e, false)
          }
          for (const [n, i] of t) {
            const t = this._setAttribute(n, i, false)
            if (t) {
              e.add(n)
            }
          }
          return e
        }
        *getStoredAttributes() {
          const t = this.getFirstPosition().parent
          if (this.isCollapsed && t.isEmpty) {
            for (const e of t.getAttributeKeys()) {
              if (e.startsWith(pb)) {
                const n = e.substr(pb.length)
                yield [n, t.getAttribute(e)]
              }
            }
          }
        }
        _getSurroundingAttributes() {
          const t = this.getFirstPosition()
          const e = this._model.schema
          let n = null
          if (!this.isCollapsed) {
            const t = this.getFirstRange()
            for (const i of t) {
              if (i.item.is('element') && e.isObject(i.item)) {
                break
              }
              if (i.type == 'text') {
                n = i.item.getAttributes()
                break
              }
            }
          } else {
            const i = t.textNode ? t.textNode : t.nodeBefore
            const o = t.textNode ? t.textNode : t.nodeAfter
            if (!this.isGravityOverridden) {
              n = wb(i)
            }
            if (!n) {
              n = wb(o)
            }
            if (!this.isGravityOverridden && !n) {
              let t = i
              while (t && !e.isInline(t) && !n) {
                t = t.previousSibling
                n = wb(t)
              }
            }
            if (!n) {
              let t = o
              while (t && !e.isInline(t) && !n) {
                t = t.nextSibling
                n = wb(t)
              }
            }
            if (!n) {
              n = this.getStoredAttributes()
            }
          }
          return n
        }
        _fixGraveyardSelection(t) {
          const e = this._model.schema.getNearestSelectionRange(t)
          if (e) {
            this._pushRange(e)
          }
        }
      }
      function wb(t) {
        if (t instanceof Fp || t instanceof jp) {
          return t.getAttributes()
        }
        return null
      }
      function _b(t, e) {
        const n = t.document.differ
        for (const i of n.getChanges()) {
          if (i.type != 'insert') {
            continue
          }
          const n = i.position.parent
          const o = i.length === n.maxOffset
          if (o) {
            t.enqueueChange(e, (t) => {
              const e = Array.from(n.getAttributeKeys()).filter((t) =>
                t.startsWith(pb)
              )
              for (const i of e) {
                t.removeAttribute(i, n)
              }
            })
          }
        }
      }
      class Ab {
        constructor(t) {
          this._dispatchers = t
        }
        add(t) {
          for (const e of this._dispatchers) {
            t(e)
          }
          return this
        }
      }
      var vb = 1,
        Cb = 4
      function yb(t) {
        return Oa(t, vb | Cb)
      }
      const xb = yb
      class Eb extends Ab {
        elementToElement(t) {
          return this.add(Yb(t))
        }
        elementToStructure(t) {
          return this.add(Kb(t))
        }
        attributeToElement(t) {
          return this.add(Qb(t))
        }
        attributeToAttribute(t) {
          return this.add(Zb(t))
        }
        markerToElement(t) {
          return this.add(Jb(t))
        }
        markerToHighlight(t) {
          return this.add(tk(t))
        }
        markerToData(t) {
          return this.add(Xb(t))
        }
      }
      function Db() {
        return (t, e, n) => {
          if (!n.consumable.consume(e.item, t.name)) {
            return
          }
          const i = n.writer
          const o = n.mapper.toViewPosition(e.range.start)
          const r = i.createText(e.item.data)
          i.insert(o, r)
        }
      }
      function Tb() {
        return (t, e, n) => {
          n.convertAttributes(e.item)
          if (!e.reconversion && e.item.is('element') && !e.item.isEmpty) {
            n.convertChildren(e.item)
          }
        }
      }
      function Mb() {
        return (t, e, n) => {
          const i = n.mapper.toViewPosition(e.position)
          const o = e.position.getShiftedBy(e.length)
          const r = n.mapper.toViewPosition(o, { isPhantom: true })
          const s = n.writer.createRange(i, r)
          const a = n.writer.remove(s.getTrimmed())
          for (const t of n.writer.createRangeIn(a).getItems()) {
            n.mapper.unbindViewElement(t, { defer: true })
          }
        }
      }
      function Ib(t, e) {
        const n = t.createAttributeElement('span', e.attributes)
        if (e.classes) {
          n._addClass(e.classes)
        }
        if (typeof e.priority === 'number') {
          n._priority = e.priority
        }
        n._id = e.id
        return n
      }
      function Sb() {
        return (t, e, n) => {
          const i = e.selection
          if (i.isCollapsed) {
            return
          }
          if (!n.consumable.consume(i, 'selection')) {
            return
          }
          const o = []
          for (const t of i.getRanges()) {
            o.push(n.mapper.toViewRange(t))
          }
          n.writer.setSelection(o, { backward: i.isBackward })
        }
      }
      function Bb() {
        return (t, e, n) => {
          const i = e.selection
          if (!i.isCollapsed) {
            return
          }
          if (!n.consumable.consume(i, 'selection')) {
            return
          }
          const o = n.writer
          const r = i.getFirstPosition()
          const s = n.mapper.toViewPosition(r)
          const a = o.breakAttributes(s)
          o.setSelection(a)
        }
      }
      function Nb() {
        return (t, e, n) => {
          const i = n.writer
          const o = i.document.selection
          for (const t of o.getRanges()) {
            if (t.isCollapsed) {
              if (t.end.parent.isAttached()) {
                n.writer.mergeAttributes(t.start)
              }
            }
          }
          i.setSelection(null)
        }
      }
      function Pb(t) {
        return (e, n, i) => {
          if (!i.consumable.test(n.item, e.name)) {
            return
          }
          const o = t(n.attributeOldValue, i, n)
          const r = t(n.attributeNewValue, i, n)
          if (!o && !r) {
            return
          }
          i.consumable.consume(n.item, e.name)
          const s = i.writer
          const a = s.document.selection
          if (n.item instanceof sb || n.item instanceof bb) {
            s.wrap(a.getFirstRange(), r)
          } else {
            let t = i.mapper.toViewRange(n.range)
            if (n.attributeOldValue !== null && o) {
              t = s.unwrap(t, o)
            }
            if (n.attributeNewValue !== null && r) {
              s.wrap(t, r)
            }
          }
        }
      }
      function zb(t, e = gk) {
        return (n, i, o) => {
          if (!e(i.item, o.consumable, { preflight: true })) {
            return
          }
          const r = t(i.item, o, i)
          if (!r) {
            return
          }
          e(i.item, o.consumable)
          const s = o.mapper.toViewPosition(i.range.start)
          o.mapper.bindElements(i.item, r)
          o.writer.insert(s, r)
          o.convertAttributes(i.item)
          fk(r, i.item.getChildren(), o, { reconversion: i.reconversion })
        }
      }
      function Lb(t, e) {
        return (n, i, o) => {
          if (!e(i.item, o.consumable, { preflight: true })) {
            return
          }
          const r = new Map()
          o.writer._registerSlotFactory(dk(i.item, r, o))
          const s = t(i.item, o, i)
          o.writer._clearSlotFactory()
          if (!s) {
            return
          }
          uk(i.item, r, o)
          e(i.item, o.consumable)
          const a = o.mapper.toViewPosition(i.range.start)
          o.mapper.bindElements(i.item, s)
          o.writer.insert(a, s)
          o.convertAttributes(i.item)
          hk(s, r, o, { reconversion: i.reconversion })
        }
      }
      function Ob(t) {
        return (e, n, i) => {
          n.isOpening = true
          const o = t(n, i)
          n.isOpening = false
          const r = t(n, i)
          if (!o || !r) {
            return
          }
          const s = n.markerRange
          if (s.isCollapsed && !i.consumable.consume(s, e.name)) {
            return
          }
          for (const t of s) {
            if (!i.consumable.consume(t.item, e.name)) {
              return
            }
          }
          const a = i.mapper
          const c = i.writer
          c.insert(a.toViewPosition(s.start), o)
          i.mapper.bindElementToMarker(o, n.markerName)
          if (!s.isCollapsed) {
            c.insert(a.toViewPosition(s.end), r)
            i.mapper.bindElementToMarker(r, n.markerName)
          }
          e.stop()
        }
      }
      function Rb() {
        return (t, e, n) => {
          const i = n.mapper.markerNameToElements(e.markerName)
          if (!i) {
            return
          }
          for (const t of i) {
            n.mapper.unbindElementFromMarkerName(t, e.markerName)
            n.writer.clear(n.writer.createRangeOn(t), t)
          }
          n.writer.clearClonedElementsGroup(e.markerName)
          t.stop()
        }
      }
      function jb(t) {
        return (e, n, i) => {
          const o = t(n.markerName, i)
          if (!o) {
            return
          }
          const r = n.markerRange
          if (!i.consumable.consume(r, e.name)) {
            return
          }
          Fb(r, false, i, n, o)
          Fb(r, true, i, n, o)
          e.stop()
        }
      }
      function Fb(t, e, n, i, o) {
        const r = e ? t.start : t.end
        const s = r.nodeAfter && r.nodeAfter.is('element') ? r.nodeAfter : null
        const a =
          r.nodeBefore && r.nodeBefore.is('element') ? r.nodeBefore : null
        if (s || a) {
          let t
          let r
          if ((e && s) || (!e && !a)) {
            t = s
            r = true
          } else {
            t = a
            r = false
          }
          const c = n.mapper.toViewElement(t)
          if (c) {
            Vb(c, e, r, n, i, o)
            return
          }
        }
        const c = n.mapper.toViewPosition(r)
        Hb(c, e, n, i, o)
      }
      function Vb(t, e, n, i, o, r) {
        const s = `data-${r.group}-${e ? 'start' : 'end'}-${
          n ? 'before' : 'after'
        }`
        const a = t.hasAttribute(s) ? t.getAttribute(s).split(',') : []
        a.unshift(r.name)
        i.writer.setAttribute(s, a.join(','), t)
        i.mapper.bindElementToMarker(t, o.markerName)
      }
      function Hb(t, e, n, i, o) {
        const r = `${o.group}-${e ? 'start' : 'end'}`
        const s = o.name ? { name: o.name } : null
        const a = n.writer.createUIElement(r, s)
        n.writer.insert(t, a)
        n.mapper.bindElementToMarker(a, i.markerName)
      }
      function Ub(t) {
        return (e, n, i) => {
          const o = t(n.markerName, i)
          if (!o) {
            return
          }
          const r = i.mapper.markerNameToElements(n.markerName)
          if (!r) {
            return
          }
          for (const t of r) {
            i.mapper.unbindElementFromMarkerName(t, n.markerName)
            if (t.is('containerElement')) {
              s(`data-${o.group}-start-before`, t)
              s(`data-${o.group}-start-after`, t)
              s(`data-${o.group}-end-before`, t)
              s(`data-${o.group}-end-after`, t)
            } else {
              i.writer.clear(i.writer.createRangeOn(t), t)
            }
          }
          i.writer.clearClonedElementsGroup(n.markerName)
          e.stop()
          function s(t, e) {
            if (e.hasAttribute(t)) {
              const n = new Set(e.getAttribute(t).split(','))
              n.delete(o.name)
              if (n.size == 0) {
                i.writer.removeAttribute(t, e)
              } else {
                i.writer.setAttribute(t, Array.from(n).join(','), e)
              }
            }
          }
        }
      }
      function Wb(t) {
        return (e, n, i) => {
          if (!i.consumable.test(n.item, e.name)) {
            return
          }
          const o = t(n.attributeOldValue, i, n)
          const r = t(n.attributeNewValue, i, n)
          if (!o && !r) {
            return
          }
          i.consumable.consume(n.item, e.name)
          const s = i.mapper.toViewElement(n.item)
          const a = i.writer
          if (!s) {
            throw new N(
              'conversion-attribute-to-attribute-on-text',
              i.dispatcher,
              n
            )
          }
          if (n.attributeOldValue !== null && o) {
            if (o.key == 'class') {
              const t = Zc(o.value)
              for (const e of t) {
                a.removeClass(e, s)
              }
            } else if (o.key == 'style') {
              const t = Object.keys(o.value)
              for (const e of t) {
                a.removeStyle(e, s)
              }
            } else {
              a.removeAttribute(o.key, s)
            }
          }
          if (n.attributeNewValue !== null && r) {
            if (r.key == 'class') {
              const t = Zc(r.value)
              for (const e of t) {
                a.addClass(e, s)
              }
            } else if (r.key == 'style') {
              const t = Object.keys(r.value)
              for (const e of t) {
                a.setStyle(e, r.value[e], s)
              }
            } else {
              a.setAttribute(r.key, r.value, s)
            }
          }
        }
      }
      function qb(t) {
        return (e, n, i) => {
          if (!n.item) {
            return
          }
          if (
            !(n.item instanceof sb || n.item instanceof bb) &&
            !n.item.is('$textProxy')
          ) {
            return
          }
          const o = sk(t, n, i)
          if (!o) {
            return
          }
          if (!i.consumable.consume(n.item, e.name)) {
            return
          }
          const r = i.writer
          const s = Ib(r, o)
          const a = r.document.selection
          if (n.item instanceof sb || n.item instanceof bb) {
            r.wrap(a.getFirstRange(), s)
          } else {
            const t = i.mapper.toViewRange(n.range)
            const e = r.wrap(t, s)
            for (const t of e.getItems()) {
              if (t.is('attributeElement') && t.isSimilar(s)) {
                i.mapper.bindElementToMarker(t, n.markerName)
                break
              }
            }
          }
        }
      }
      function $b(t) {
        return (e, n, i) => {
          if (!n.item) {
            return
          }
          if (!(n.item instanceof Vp)) {
            return
          }
          const o = sk(t, n, i)
          if (!o) {
            return
          }
          if (!i.consumable.test(n.item, e.name)) {
            return
          }
          const r = i.mapper.toViewElement(n.item)
          if (r && r.getCustomProperty('addHighlight')) {
            i.consumable.consume(n.item, e.name)
            for (const t of Jp._createIn(n.item)) {
              i.consumable.consume(t.item, e.name)
            }
            const t = r.getCustomProperty('addHighlight')
            t(r, o, i.writer)
            i.mapper.bindElementToMarker(r, n.markerName)
          }
        }
      }
      function Gb(t) {
        return (e, n, i) => {
          if (n.markerRange.isCollapsed) {
            return
          }
          const o = sk(t, n, i)
          if (!o) {
            return
          }
          const r = Ib(i.writer, o)
          const s = i.mapper.markerNameToElements(n.markerName)
          if (!s) {
            return
          }
          for (const t of s) {
            i.mapper.unbindElementFromMarkerName(t, n.markerName)
            if (t.is('attributeElement')) {
              i.writer.unwrap(i.writer.createRangeOn(t), r)
            } else {
              const e = t.getCustomProperty('removeHighlight')
              e(t, o.id, i.writer)
            }
          }
          i.writer.clearClonedElementsGroup(n.markerName)
          e.stop()
        }
      }
      function Yb(t) {
        const e = ek(t.model)
        const n = nk(t.view, 'container')
        if (e.attributes.length) {
          e.children = true
        }
        return (i) => {
          i.on(`insert:${e.name}`, zb(n, lk(e)), {
            priority: t.converterPriority || 'normal'
          })
          if (e.children || e.attributes.length) {
            i.on('reduceChanges', ck(e), { priority: 'low' })
          }
        }
      }
      function Kb(t) {
        const e = ek(t.model)
        const n = nk(t.view, 'container')
        e.children = true
        return (i) => {
          if (i._conversionApi.schema.checkChild(e.name, '$text')) {
            throw new N('conversion-element-to-structure-disallowed-text', i, {
              elementName: e.name
            })
          }
          i.on(`insert:${e.name}`, Lb(n, lk(e)), {
            priority: t.converterPriority || 'normal'
          })
          i.on('reduceChanges', ck(e), { priority: 'low' })
        }
      }
      function Qb(t) {
        t = xb(t)
        let e = t.model
        if (typeof e == 'string') {
          e = { key: e }
        }
        let n = `attribute:${e.key}`
        if (e.name) {
          n += ':' + e.name
        }
        if (e.values) {
          for (const n of e.values) {
            t.view[n] = nk(t.view[n], 'attribute')
          }
        } else {
          t.view = nk(t.view, 'attribute')
        }
        const i = ok(t)
        return (e) => {
          e.on(n, Pb(i), { priority: t.converterPriority || 'normal' })
        }
      }
      function Zb(t) {
        t = xb(t)
        let e = t.model
        if (typeof e == 'string') {
          e = { key: e }
        }
        let n = `attribute:${e.key}`
        if (e.name) {
          n += ':' + e.name
        }
        if (e.values) {
          for (const n of e.values) {
            t.view[n] = rk(t.view[n])
          }
        } else {
          t.view = rk(t.view)
        }
        const i = ok(t)
        return (e) => {
          e.on(n, Wb(i), { priority: t.converterPriority || 'normal' })
        }
      }
      function Jb(t) {
        const e = nk(t.view, 'ui')
        return (n) => {
          n.on(`addMarker:${t.model}`, Ob(e), {
            priority: t.converterPriority || 'normal'
          })
          n.on(`removeMarker:${t.model}`, Rb(), {
            priority: t.converterPriority || 'normal'
          })
        }
      }
      function Xb(t) {
        t = xb(t)
        const e = t.model
        let n = t.view
        if (!n) {
          n = (n) => ({ group: e, name: n.substr(t.model.length + 1) })
        }
        return (i) => {
          i.on(`addMarker:${e}`, jb(n), {
            priority: t.converterPriority || 'normal'
          })
          i.on(`removeMarker:${e}`, Ub(n), {
            priority: t.converterPriority || 'normal'
          })
        }
      }
      function tk(t) {
        return (e) => {
          e.on(`addMarker:${t.model}`, qb(t.view), {
            priority: t.converterPriority || 'normal'
          })
          e.on(`addMarker:${t.model}`, $b(t.view), {
            priority: t.converterPriority || 'normal'
          })
          e.on(`removeMarker:${t.model}`, Gb(t.view), {
            priority: t.converterPriority || 'normal'
          })
        }
      }
      function ek(t) {
        if (typeof t == 'string') {
          t = { name: t }
        }
        if (!t.attributes) {
          t.attributes = []
        } else if (!Array.isArray(t.attributes)) {
          t.attributes = [t.attributes]
        }
        t.children = !!t.children
        return t
      }
      function nk(t, e) {
        if (typeof t == 'function') {
          return t
        }
        return (n, i) => ik(t, i, e)
      }
      function ik(t, e, n) {
        if (typeof t == 'string') {
          t = { name: t }
        }
        let i
        const o = e.writer
        const r = Object.assign({}, t.attributes)
        if (n == 'container') {
          i = o.createContainerElement(t.name, r)
        } else if (n == 'attribute') {
          const e = { priority: t.priority || Gf.DEFAULT_PRIORITY }
          i = o.createAttributeElement(t.name, r, e)
        } else {
          i = o.createUIElement(t.name, r)
        }
        if (t.styles) {
          const e = Object.keys(t.styles)
          for (const n of e) {
            o.setStyle(n, t.styles[n], i)
          }
        }
        if (t.classes) {
          const e = t.classes
          if (typeof e == 'string') {
            o.addClass(e, i)
          } else {
            for (const t of e) {
              o.addClass(t, i)
            }
          }
        }
        return i
      }
      function ok(t) {
        if (t.model.values) {
          return (e, n, i) => {
            const o = t.view[e]
            if (o) {
              return o(e, n, i)
            }
            return null
          }
        } else {
          return t.view
        }
      }
      function rk(t) {
        if (typeof t == 'string') {
          return (e) => ({ key: t, value: e })
        } else if (typeof t == 'object') {
          if (t.value) {
            return () => t
          } else {
            return (e) => ({ key: t.key, value: e })
          }
        } else {
          return t
        }
      }
      function sk(t, e, n) {
        const i = typeof t == 'function' ? t(e, n) : t
        if (!i) {
          return null
        }
        if (!i.priority) {
          i.priority = 10
        }
        if (!i.id) {
          i.id = e.markerName
        }
        return i
      }
      function ak(t) {
        return (e, n) => {
          if (!e.is('element', t.name)) {
            return false
          }
          if (n.type == 'attribute') {
            if (t.attributes.includes(n.attributeKey)) {
              return true
            }
          } else {
            if (t.children) {
              return true
            }
          }
          return false
        }
      }
      function ck(t) {
        const e = ak(t)
        return (t, n) => {
          const i = []
          if (!n.reconvertedElements) {
            n.reconvertedElements = new Set()
          }
          for (const t of n.changes) {
            const o =
              t.type == 'attribute'
                ? t.range.start.nodeAfter
                : t.position.parent
            if (!o || !e(o, t)) {
              i.push(t)
              continue
            }
            if (!n.reconvertedElements.has(o)) {
              n.reconvertedElements.add(o)
              const t = qp._createBefore(o)
              i.push(
                { type: 'remove', name: o.name, position: t, length: 1 },
                { type: 'reinsert', name: o.name, position: t, length: 1 }
              )
            }
          }
          n.changes = i
        }
      }
      function lk(t) {
        return (e, n, i = {}) => {
          const o = ['insert']
          for (const n of t.attributes) {
            if (e.hasAttribute(n)) {
              o.push(`attribute:${n}`)
            }
          }
          if (!o.every((t) => n.test(e, t))) {
            return false
          }
          if (!i.preflight) {
            o.forEach((t) => n.consume(e, t))
          }
          return true
        }
      }
      function dk(t, e, n) {
        return (i, o = 'children') => {
          const r = i.createContainerElement('$slot')
          let s = null
          if (o === 'children') {
            s = Array.from(t.getChildren())
          } else if (typeof o == 'function') {
            s = Array.from(t.getChildren()).filter((t) => o(t))
          } else {
            throw new N('conversion-slot-mode-unknown', n.dispatcher, {
              modeOrFilter: o
            })
          }
          e.set(r, s)
          return r
        }
      }
      function uk(t, e, n) {
        const i = Array.from(e.values()).flat()
        const o = new Set(i)
        if (o.size != i.length) {
          throw new N('conversion-slot-filter-overlap', n.dispatcher, {
            element: t
          })
        }
        if (o.size != t.childCount) {
          throw new N('conversion-slot-filter-incomplete', n.dispatcher, {
            element: t
          })
        }
      }
      function hk(t, e, n, i) {
        n.mapper.on('modelToViewPosition', s, { priority: 'highest' })
        let o = null
        let r = null
        for ([o, r] of e) {
          fk(t, r, n, i)
          n.writer.move(
            n.writer.createRangeIn(o),
            n.writer.createPositionBefore(o)
          )
          n.writer.remove(o)
        }
        n.mapper.off('modelToViewPosition', s)
        function s(t, e) {
          const n = e.modelPosition.nodeAfter
          const i = r.indexOf(n)
          if (i < 0) {
            return
          }
          e.viewPosition = e.mapper.findPositionIn(o, i)
        }
      }
      function fk(t, e, n, i) {
        for (const o of e) {
          if (!mk(t.root, o, n, i)) {
            n.convertItem(o)
          }
        }
      }
      function mk(t, e, n, i) {
        const { writer: o, mapper: r } = n
        if (!i.reconversion) {
          return false
        }
        const s = r.toViewElement(e)
        if (!s || s.root == t) {
          return false
        }
        if (!n.canReuseView(s)) {
          return false
        }
        o.move(o.createRangeOn(s), r.toViewPosition(qp._createBefore(e)))
        return true
      }
      function gk(t, e, { preflight: n } = {}) {
        if (n) {
          return e.test(t, 'insert')
        } else {
          return e.consume(t, 'insert')
        }
      }
      function pk(t) {
        const { schema: e, document: n } = t.model
        for (const i of n.getRootNames()) {
          const o = n.getRoot(i)
          if (o.isEmpty && !e.checkChild(o, '$text')) {
            if (e.checkChild(o, 'paragraph')) {
              t.insertElement('paragraph', o)
              return true
            }
          }
        }
        return false
      }
      function bk(t, e, n) {
        const i = n.createContext(t)
        if (!n.checkChild(i, 'paragraph')) {
          return false
        }
        if (!n.checkChild(i.push('paragraph'), e)) {
          return false
        }
        return true
      }
      function kk(t, e) {
        const n = e.createElement('paragraph')
        e.insert(n, t)
        return e.createPositionAt(n, 0)
      }
      class wk extends Ab {
        elementToElement(t) {
          return this.add(Ck(t))
        }
        elementToAttribute(t) {
          return this.add(yk(t))
        }
        attributeToAttribute(t) {
          return this.add(xk(t))
        }
        elementToMarker(t) {
          return this.add(Ek(t))
        }
        dataToMarker(t) {
          return this.add(Dk(t))
        }
      }
      function _k() {
        return (t, e, n) => {
          if (
            !e.modelRange &&
            n.consumable.consume(e.viewItem, { name: true })
          ) {
            const { modelRange: t, modelCursor: i } = n.convertChildren(
              e.viewItem,
              e.modelCursor
            )
            e.modelRange = t
            e.modelCursor = i
          }
        }
      }
      function Ak() {
        return (t, e, { schema: n, consumable: i, writer: o }) => {
          let r = e.modelCursor
          if (!i.test(e.viewItem)) {
            return
          }
          if (!n.checkChild(r, '$text')) {
            if (!bk(r, '$text', n)) {
              return
            }
            if (e.viewItem.data.trim().length == 0) {
              return
            }
            const t = r.nodeBefore
            r = kk(r, o)
            if (t && t.is('element', '$marker')) {
              o.move(o.createRangeOn(t), r)
              r = o.createPositionAfter(t)
            }
          }
          i.consume(e.viewItem)
          const s = o.createText(e.viewItem.data)
          o.insert(s, r)
          e.modelRange = o.createRange(r, r.getShiftedBy(s.offsetSize))
          e.modelCursor = e.modelRange.end
        }
      }
      function vk(t, e) {
        return (n, i) => {
          const o = i.newSelection
          const r = []
          for (const t of o.getRanges()) {
            r.push(e.toModelRange(t))
          }
          const s = t.createSelection(r, { backward: o.isBackward })
          if (!s.isEqual(t.document.selection)) {
            t.change((t) => {
              t.setSelection(s)
            })
          }
        }
      }
      function Ck(t) {
        t = xb(t)
        const e = Ik(t)
        const n = Mk(t.view)
        const i = n ? `element:${n}` : 'element'
        return (n) => {
          n.on(i, e, { priority: t.converterPriority || 'normal' })
        }
      }
      function yk(t) {
        t = xb(t)
        Nk(t)
        const e = Pk(t, false)
        const n = Mk(t.view)
        const i = n ? `element:${n}` : 'element'
        return (n) => {
          n.on(i, e, { priority: t.converterPriority || 'low' })
        }
      }
      function xk(t) {
        t = xb(t)
        let e = null
        if (typeof t.view == 'string' || t.view.key) {
          e = Bk(t)
        }
        Nk(t, e)
        const n = Pk(t, true)
        return (e) => {
          e.on('element', n, { priority: t.converterPriority || 'low' })
        }
      }
      function Ek(t) {
        const e = Ok(t.model)
        return Ck({ ...t, model: e })
      }
      function Dk(t) {
        t = xb(t)
        if (!t.model) {
          t.model = (e) => (e ? t.view + ':' + e : t.view)
        }
        const e = { view: t.view, model: t.model }
        const n = Ik(Rk(e, 'start'))
        const i = Ik(Rk(e, 'end'))
        return (o) => {
          o.on(`element:${t.view}-start`, n, {
            priority: t.converterPriority || 'normal'
          })
          o.on(`element:${t.view}-end`, i, {
            priority: t.converterPriority || 'normal'
          })
          const r = I.get('low')
          const s = I.get('highest')
          const a = I.get(t.converterPriority) / s
          o.on('element', Tk(e), { priority: r + a })
        }
      }
      function Tk(t) {
        return (e, n, i) => {
          const o = `data-${t.view}`
          if (
            !i.consumable.test(n.viewItem, { attributes: o + '-end-after' }) &&
            !i.consumable.test(n.viewItem, {
              attributes: o + '-start-after'
            }) &&
            !i.consumable.test(n.viewItem, { attributes: o + '-end-before' }) &&
            !i.consumable.test(n.viewItem, { attributes: o + '-start-before' })
          ) {
            return
          }
          if (!n.modelRange) {
            Object.assign(n, i.convertChildren(n.viewItem, n.modelCursor))
          }
          if (
            i.consumable.consume(n.viewItem, { attributes: o + '-end-after' })
          ) {
            r(
              n.modelRange.end,
              n.viewItem.getAttribute(o + '-end-after').split(',')
            )
          }
          if (
            i.consumable.consume(n.viewItem, { attributes: o + '-start-after' })
          ) {
            r(
              n.modelRange.end,
              n.viewItem.getAttribute(o + '-start-after').split(',')
            )
          }
          if (
            i.consumable.consume(n.viewItem, { attributes: o + '-end-before' })
          ) {
            r(
              n.modelRange.start,
              n.viewItem.getAttribute(o + '-end-before').split(',')
            )
          }
          if (
            i.consumable.consume(n.viewItem, {
              attributes: o + '-start-before'
            })
          ) {
            r(
              n.modelRange.start,
              n.viewItem.getAttribute(o + '-start-before').split(',')
            )
          }
          function r(e, o) {
            for (const r of o) {
              const o = t.model(r, i)
              const s = i.writer.createElement('$marker', { 'data-name': o })
              i.writer.insert(s, e)
              if (n.modelCursor.isEqual(e)) {
                n.modelCursor = n.modelCursor.getShiftedBy(1)
              } else {
                n.modelCursor = n.modelCursor._getTransformedByInsertion(e, 1)
              }
              n.modelRange = n.modelRange._getTransformedByInsertion(e, 1)[0]
            }
          }
        }
      }
      function Mk(t) {
        if (typeof t == 'string') {
          return t
        }
        if (typeof t == 'object' && typeof t.name == 'string') {
          return t.name
        }
        return null
      }
      function Ik(t) {
        const e = new Cu(t.view)
        return (n, i, o) => {
          const r = e.match(i.viewItem)
          if (!r) {
            return
          }
          const s = r.match
          s.name = true
          if (!o.consumable.test(i.viewItem, s)) {
            return
          }
          const a = Sk(t.model, i.viewItem, o)
          if (!a) {
            return
          }
          if (!o.safeInsert(a, i.modelCursor)) {
            return
          }
          o.consumable.consume(i.viewItem, s)
          o.convertChildren(i.viewItem, a)
          o.updateConversionResult(a, i)
        }
      }
      function Sk(t, e, n) {
        if (t instanceof Function) {
          return t(e, n)
        } else {
          return n.writer.createElement(t)
        }
      }
      function Bk(t) {
        if (typeof t.view == 'string') {
          t.view = { key: t.view }
        }
        const e = t.view.key
        let n
        if (e == 'class' || e == 'style') {
          const i = e == 'class' ? 'classes' : 'styles'
          n = { [i]: t.view.value }
        } else {
          const i =
            typeof t.view.value == 'undefined' ? /[\s\S]*/ : t.view.value
          n = { attributes: { [e]: i } }
        }
        if (t.view.name) {
          n.name = t.view.name
        }
        t.view = n
        return e
      }
      function Nk(t, e = null) {
        const n = e === null ? true : (t) => t.getAttribute(e)
        const i = typeof t.model != 'object' ? t.model : t.model.key
        const o =
          typeof t.model != 'object' || typeof t.model.value == 'undefined'
            ? n
            : t.model.value
        t.model = { key: i, value: o }
      }
      function Pk(t, e) {
        const n = new Cu(t.view)
        return (i, o, r) => {
          if (!o.modelRange && e) {
            return
          }
          const s = n.match(o.viewItem)
          if (!s) {
            return
          }
          if (zk(t.view, o.viewItem)) {
            s.match.name = true
          } else {
            delete s.match.name
          }
          if (!r.consumable.test(o.viewItem, s.match)) {
            return
          }
          const a = t.model.key
          const c =
            typeof t.model.value == 'function'
              ? t.model.value(o.viewItem, r)
              : t.model.value
          if (c === null) {
            return
          }
          if (!o.modelRange) {
            Object.assign(o, r.convertChildren(o.viewItem, o.modelCursor))
          }
          const l = Lk(o.modelRange, { key: a, value: c }, e, r)
          if (l) {
            if (r.consumable.test(o.viewItem, { name: true })) {
              s.match.name = true
            }
            r.consumable.consume(o.viewItem, s.match)
          }
        }
      }
      function zk(t, e) {
        const n = typeof t == 'function' ? t(e) : t
        if (typeof n == 'object' && !Mk(n)) {
          return false
        }
        return !n.classes && !n.attributes && !n.styles
      }
      function Lk(t, e, n, i) {
        let o = false
        for (const r of Array.from(t.getItems({ shallow: n }))) {
          if (!i.schema.checkAttribute(r, e.key)) {
            continue
          }
          o = true
          if (r.hasAttribute(e.key)) {
            continue
          }
          i.writer.setAttribute(e.key, e.value, r)
        }
        return o
      }
      function Ok(t) {
        return (e, n) => {
          const i = typeof t == 'string' ? t : t(e, n)
          return n.writer.createElement('$marker', { 'data-name': i })
        }
      }
      function Rk(t, e) {
        const n = (e, n) => {
          const i = e.getAttribute('name')
          const o = t.model(i, n)
          return n.writer.createElement('$marker', { 'data-name': o })
        }
        return { view: `${t.view}-${e}`, model: n }
      }
      class jk extends ht() {
        constructor(t, e) {
          super()
          this.model = t
          this.view = new zp(e)
          this.mapper = new Xp()
          this.downcastDispatcher = new nb({
            mapper: this.mapper,
            schema: t.schema
          })
          const n = this.model.document
          const i = n.selection
          const o = this.model.markers
          this.listenTo(
            this.model,
            '_beforeChanges',
            () => {
              this.view._disableRendering(true)
            },
            { priority: 'highest' }
          )
          this.listenTo(
            this.model,
            '_afterChanges',
            () => {
              this.view._disableRendering(false)
            },
            { priority: 'lowest' }
          )
          this.listenTo(
            n,
            'change',
            () => {
              this.view.change((t) => {
                this.downcastDispatcher.convertChanges(n.differ, o, t)
                this.downcastDispatcher.convertSelection(i, o, t)
              })
            },
            { priority: 'low' }
          )
          this.listenTo(
            this.view.document,
            'selectionChange',
            vk(this.model, this.mapper)
          )
          this.downcastDispatcher.on('insert:$text', Db(), {
            priority: 'lowest'
          })
          this.downcastDispatcher.on('insert', Tb(), { priority: 'lowest' })
          this.downcastDispatcher.on('remove', Mb(), { priority: 'low' })
          this.downcastDispatcher.on('selection', Nb(), { priority: 'high' })
          this.downcastDispatcher.on('selection', Sb(), { priority: 'low' })
          this.downcastDispatcher.on('selection', Bb(), { priority: 'low' })
          this.view.document.roots
            .bindTo(this.model.document.roots)
            .using((t) => {
              if (t.rootName == '$graveyard') {
                return null
              }
              const e = new If(this.view.document, t.name)
              e.rootName = t.rootName
              this.mapper.bindElements(t, e)
              return e
            })
        }
        destroy() {
          this.view.destroy()
          this.stopListening()
        }
        reconvertMarker(t) {
          const e = typeof t == 'string' ? t : t.name
          const n = this.model.markers.get(e)
          if (!n) {
            throw new N(
              'editingcontroller-reconvertmarker-marker-not-exist',
              this,
              { markerName: e }
            )
          }
          this.model.change(() => {
            this.model.markers._refresh(n)
          })
        }
        reconvertItem(t) {
          this.model.change(() => {
            this.model.document.differ._refreshItem(t)
          })
        }
      }
      class Fk {
        constructor() {
          this._consumables = new Map()
        }
        add(t, e) {
          let n
          if (t.is('$text') || t.is('documentFragment')) {
            this._consumables.set(t, true)
            return
          }
          if (!this._consumables.has(t)) {
            n = new Hk(t)
            this._consumables.set(t, n)
          } else {
            n = this._consumables.get(t)
          }
          n.add(e)
        }
        test(t, e) {
          const n = this._consumables.get(t)
          if (n === undefined) {
            return null
          }
          if (t.is('$text') || t.is('documentFragment')) {
            return n
          }
          return n.test(e)
        }
        consume(t, e) {
          if (this.test(t, e)) {
            if (t.is('$text') || t.is('documentFragment')) {
              this._consumables.set(t, false)
            } else {
              this._consumables.get(t).consume(e)
            }
            return true
          }
          return false
        }
        revert(t, e) {
          const n = this._consumables.get(t)
          if (n !== undefined) {
            if (t.is('$text') || t.is('documentFragment')) {
              this._consumables.set(t, true)
            } else {
              n.revert(e)
            }
          }
        }
        static consumablesFromElement(t) {
          const e = {
            element: t,
            name: true,
            attributes: [],
            classes: [],
            styles: []
          }
          const n = t.getAttributeKeys()
          for (const t of n) {
            if (t == 'style' || t == 'class') {
              continue
            }
            e.attributes.push(t)
          }
          const i = t.getClassNames()
          for (const t of i) {
            e.classes.push(t)
          }
          const o = t.getStyleNames()
          for (const t of o) {
            e.styles.push(t)
          }
          return e
        }
        static createFrom(t, e) {
          if (!e) {
            e = new Fk()
          }
          if (t.is('$text')) {
            e.add(t)
            return e
          }
          if (t.is('element')) {
            e.add(t, Fk.consumablesFromElement(t))
          }
          if (t.is('documentFragment')) {
            e.add(t)
          }
          for (const n of t.getChildren()) {
            e = Fk.createFrom(n, e)
          }
          return e
        }
      }
      const Vk = ['attributes', 'classes', 'styles']
      class Hk {
        constructor(t) {
          this.element = t
          this._canConsumeName = null
          this._consumables = {
            attributes: new Map(),
            styles: new Map(),
            classes: new Map()
          }
        }
        add(t) {
          if (t.name) {
            this._canConsumeName = true
          }
          for (const e of Vk) {
            if (e in t) {
              this._add(e, t[e])
            }
          }
        }
        test(t) {
          if (t.name && !this._canConsumeName) {
            return this._canConsumeName
          }
          for (const e of Vk) {
            if (e in t) {
              const n = this._test(e, t[e])
              if (n !== true) {
                return n
              }
            }
          }
          return true
        }
        consume(t) {
          if (t.name) {
            this._canConsumeName = false
          }
          for (const e of Vk) {
            if (e in t) {
              this._consume(e, t[e])
            }
          }
        }
        revert(t) {
          if (t.name) {
            this._canConsumeName = true
          }
          for (const e of Vk) {
            if (e in t) {
              this._revert(e, t[e])
            }
          }
        }
        _add(t, e) {
          const n = Qt(e) ? e : [e]
          const i = this._consumables[t]
          for (const e of n) {
            if (t === 'attributes' && (e === 'class' || e === 'style')) {
              throw new N('viewconsumable-invalid-attribute', this)
            }
            i.set(e, true)
            if (t === 'styles') {
              for (const t of this.element.document.stylesProcessor.getRelatedStyles(
                e
              )) {
                i.set(t, true)
              }
            }
          }
        }
        _test(t, e) {
          const n = Qt(e) ? e : [e]
          const i = this._consumables[t]
          for (const e of n) {
            if (t === 'attributes' && (e === 'class' || e === 'style')) {
              const t = e == 'class' ? 'classes' : 'styles'
              const n = this._test(t, [...this._consumables[t].keys()])
              if (n !== true) {
                return n
              }
            } else {
              const t = i.get(e)
              if (t === undefined) {
                return null
              }
              if (!t) {
                return false
              }
            }
          }
          return true
        }
        _consume(t, e) {
          const n = Qt(e) ? e : [e]
          const i = this._consumables[t]
          for (const e of n) {
            if (t === 'attributes' && (e === 'class' || e === 'style')) {
              const t = e == 'class' ? 'classes' : 'styles'
              this._consume(t, [...this._consumables[t].keys()])
            } else {
              i.set(e, false)
              if (t == 'styles') {
                for (const t of this.element.document.stylesProcessor.getRelatedStyles(
                  e
                )) {
                  i.set(t, false)
                }
              }
            }
          }
        }
        _revert(t, e) {
          const n = Qt(e) ? e : [e]
          const i = this._consumables[t]
          for (const e of n) {
            if (t === 'attributes' && (e === 'class' || e === 'style')) {
              const t = e == 'class' ? 'classes' : 'styles'
              this._revert(t, [...this._consumables[t].keys()])
            } else {
              const t = i.get(e)
              if (t === false) {
                i.set(e, true)
              }
            }
          }
        }
      }
      class Uk extends ht() {
        constructor() {
          super()
          this._sourceDefinitions = {}
          this._attributeProperties = {}
          this.decorate('checkChild')
          this.decorate('checkAttribute')
          this.on(
            'checkAttribute',
            (t, e) => {
              e[0] = new Wk(e[0])
            },
            { priority: 'highest' }
          )
          this.on(
            'checkChild',
            (t, e) => {
              e[0] = new Wk(e[0])
              e[1] = this.getDefinition(e[1])
            },
            { priority: 'highest' }
          )
        }
        register(t, e) {
          if (this._sourceDefinitions[t]) {
            throw new N('schema-cannot-register-item-twice', this, {
              itemName: t
            })
          }
          this._sourceDefinitions[t] = [Object.assign({}, e)]
          this._clearCache()
        }
        extend(t, e) {
          if (!this._sourceDefinitions[t]) {
            throw new N('schema-cannot-extend-missing-item', this, {
              itemName: t
            })
          }
          this._sourceDefinitions[t].push(Object.assign({}, e))
          this._clearCache()
        }
        getDefinitions() {
          if (!this._compiledDefinitions) {
            this._compile()
          }
          return this._compiledDefinitions
        }
        getDefinition(t) {
          let e
          if (typeof t == 'string') {
            e = t
          } else if ('is' in t && (t.is('$text') || t.is('$textProxy'))) {
            e = '$text'
          } else {
            e = t.name
          }
          return this.getDefinitions()[e]
        }
        isRegistered(t) {
          return !!this.getDefinition(t)
        }
        isBlock(t) {
          const e = this.getDefinition(t)
          return !!(e && e.isBlock)
        }
        isLimit(t) {
          const e = this.getDefinition(t)
          if (!e) {
            return false
          }
          return !!(e.isLimit || e.isObject)
        }
        isObject(t) {
          const e = this.getDefinition(t)
          if (!e) {
            return false
          }
          return !!(e.isObject || (e.isLimit && e.isSelectable && e.isContent))
        }
        isInline(t) {
          const e = this.getDefinition(t)
          return !!(e && e.isInline)
        }
        isSelectable(t) {
          const e = this.getDefinition(t)
          if (!e) {
            return false
          }
          return !!(e.isSelectable || e.isObject)
        }
        isContent(t) {
          const e = this.getDefinition(t)
          if (!e) {
            return false
          }
          return !!(e.isContent || e.isObject)
        }
        checkChild(t, e) {
          if (!e) {
            return false
          }
          return this._checkContextMatch(e, t)
        }
        checkAttribute(t, e) {
          const n = this.getDefinition(t.last)
          if (!n) {
            return false
          }
          return n.allowAttributes.includes(e)
        }
        checkMerge(t, e) {
          if (t instanceof qp) {
            const e = t.nodeBefore
            const n = t.nodeAfter
            if (!(e instanceof Vp)) {
              throw new N('schema-check-merge-no-element-before', this)
            }
            if (!(n instanceof Vp)) {
              throw new N('schema-check-merge-no-element-after', this)
            }
            return this.checkMerge(e, n)
          }
          for (const n of e.getChildren()) {
            if (!this.checkChild(t, n)) {
              return false
            }
          }
          return true
        }
        addChildCheck(t) {
          this.on(
            'checkChild',
            (e, [n, i]) => {
              if (!i) {
                return
              }
              const o = t(n, i)
              if (typeof o == 'boolean') {
                e.stop()
                e.return = o
              }
            },
            { priority: 'high' }
          )
        }
        addAttributeCheck(t) {
          this.on(
            'checkAttribute',
            (e, [n, i]) => {
              const o = t(n, i)
              if (typeof o == 'boolean') {
                e.stop()
                e.return = o
              }
            },
            { priority: 'high' }
          )
        }
        setAttributeProperties(t, e) {
          this._attributeProperties[t] = Object.assign(
            this.getAttributeProperties(t),
            e
          )
        }
        getAttributeProperties(t) {
          return this._attributeProperties[t] || {}
        }
        getLimitElement(t) {
          let e
          if (t instanceof qp) {
            e = t.parent
          } else {
            const n = t instanceof Jp ? [t] : Array.from(t.getRanges())
            e = n.reduce((t, e) => {
              const n = e.getCommonAncestor()
              if (!t) {
                return n
              }
              return t.getCommonAncestor(n, { includeSelf: true })
            }, null)
          }
          while (!this.isLimit(e)) {
            if (e.parent) {
              e = e.parent
            } else {
              break
            }
          }
          return e
        }
        checkAttributeInSelection(t, e) {
          if (t.isCollapsed) {
            const n = t.getFirstPosition()
            const i = [...n.getAncestors(), new jp('', t.getAttributes())]
            return this.checkAttribute(i, e)
          } else {
            const n = t.getRanges()
            for (const t of n) {
              for (const n of t) {
                if (this.checkAttribute(n.item, e)) {
                  return true
                }
              }
            }
          }
          return false
        }
        *getValidRanges(t, e) {
          t = aw(t)
          for (const n of t) {
            yield* this._getValidRangesForRange(n, e)
          }
        }
        getNearestSelectionRange(t, e = 'both') {
          if (this.checkChild(t, '$text')) {
            return new Jp(t)
          }
          let n, i
          const o =
            t
              .getAncestors()
              .reverse()
              .find((t) => this.isLimit(t)) || t.root
          if (e == 'both' || e == 'backward') {
            n = new Up({
              boundaries: Jp._createIn(o),
              startPosition: t,
              direction: 'backward'
            })
          }
          if (e == 'both' || e == 'forward') {
            i = new Up({ boundaries: Jp._createIn(o), startPosition: t })
          }
          for (const t of sw(n, i)) {
            const e = t.walker == n ? 'elementEnd' : 'elementStart'
            const i = t.value
            if (i.type == e && this.isObject(i.item)) {
              return Jp._createOn(i.item)
            }
            if (this.checkChild(i.nextPosition, '$text')) {
              return new Jp(i.nextPosition)
            }
          }
          return null
        }
        findAllowedParent(t, e) {
          let n = t.parent
          while (n) {
            if (this.checkChild(n, e)) {
              return n
            }
            if (this.isLimit(n)) {
              return null
            }
            n = n.parent
          }
          return null
        }
        setAllowedAttributes(t, e, n) {
          const i = n.model
          for (const [o, r] of Object.entries(e)) {
            if (i.schema.checkAttribute(t, o)) {
              n.setAttribute(o, r, t)
            }
          }
        }
        removeDisallowedAttributes(t, e) {
          for (const n of t) {
            if (n.is('$text')) {
              cw(this, n, e)
            } else {
              const t = Jp._createIn(n)
              const i = t.getPositions()
              for (const t of i) {
                const n = t.nodeBefore || t.parent
                cw(this, n, e)
              }
            }
          }
        }
        getAttributesWithProperty(t, e, n) {
          const i = {}
          for (const [o, r] of t.getAttributes()) {
            const t = this.getAttributeProperties(o)
            if (t[e] === undefined) {
              continue
            }
            if (n === undefined || n === t[e]) {
              i[o] = r
            }
          }
          return i
        }
        createContext(t) {
          return new Wk(t)
        }
        _clearCache() {
          this._compiledDefinitions = null
        }
        _compile() {
          const t = {}
          const e = this._sourceDefinitions
          const n = Object.keys(e)
          for (const i of n) {
            t[i] = qk(e[i], i)
          }
          for (const e of n) {
            $k(t, e)
          }
          for (const e of n) {
            Gk(t, e)
          }
          for (const e of n) {
            Yk(t, e)
          }
          for (const e of n) {
            Kk(t, e)
            Qk(t, e)
          }
          for (const e of n) {
            Zk(t, e)
            Jk(t, e)
            Xk(t, e)
          }
          this._compiledDefinitions = t
        }
        _checkContextMatch(t, e, n = e.length - 1) {
          const i = e.getItem(n)
          if (t.allowIn.includes(i.name)) {
            if (n == 0) {
              return true
            } else {
              const t = this.getDefinition(i)
              return this._checkContextMatch(t, e, n - 1)
            }
          } else {
            return false
          }
        }
        *_getValidRangesForRange(t, e) {
          let n = t.start
          let i = t.start
          for (const o of t.getItems({ shallow: true })) {
            if (o.is('element')) {
              yield* this._getValidRangesForRange(Jp._createIn(o), e)
            }
            if (!this.checkAttribute(o, e)) {
              if (!n.isEqual(i)) {
                yield new Jp(n, i)
              }
              n = qp._createAfter(o)
            }
            i = qp._createAfter(o)
          }
          if (!n.isEqual(i)) {
            yield new Jp(n, i)
          }
        }
      }
      class Wk {
        constructor(t) {
          if (t instanceof Wk) {
            return t
          }
          let e
          if (typeof t == 'string') {
            e = [t]
          } else if (!Array.isArray(t)) {
            e = t.getAncestors({ includeSelf: true })
          } else {
            e = t
          }
          this._items = e.map(rw)
        }
        get length() {
          return this._items.length
        }
        get last() {
          return this._items[this._items.length - 1]
        }
        [Symbol.iterator]() {
          return this._items[Symbol.iterator]()
        }
        push(t) {
          const e = new Wk([t])
          e._items = [...this._items, ...e._items]
          return e
        }
        getItem(t) {
          return this._items[t]
        }
        *getNames() {
          yield* this._items.map((t) => t.name)
        }
        endsWith(t) {
          return Array.from(this.getNames()).join(' ').endsWith(t)
        }
        startsWith(t) {
          return Array.from(this.getNames()).join(' ').startsWith(t)
        }
      }
      function qk(t, e) {
        const n = {
          name: e,
          allowIn: [],
          allowContentOf: [],
          allowWhere: [],
          allowAttributes: [],
          allowAttributesOf: [],
          allowChildren: [],
          inheritTypesFrom: []
        }
        tw(t, n)
        ew(t, n, 'allowIn')
        ew(t, n, 'allowContentOf')
        ew(t, n, 'allowWhere')
        ew(t, n, 'allowAttributes')
        ew(t, n, 'allowAttributesOf')
        ew(t, n, 'allowChildren')
        ew(t, n, 'inheritTypesFrom')
        nw(t, n)
        return n
      }
      function $k(t, e) {
        const n = t[e]
        for (const i of n.allowChildren) {
          const n = t[i]
          if (!n) {
            continue
          }
          n.allowIn.push(e)
        }
        n.allowChildren.length = 0
      }
      function Gk(t, e) {
        for (const n of t[e].allowContentOf) {
          if (t[n]) {
            const i = iw(t, n)
            i.forEach((t) => {
              t.allowIn.push(e)
            })
          }
        }
        delete t[e].allowContentOf
      }
      function Yk(t, e) {
        for (const n of t[e].allowWhere) {
          const i = t[n]
          if (i) {
            const n = i.allowIn
            t[e].allowIn.push(...n)
          }
        }
        delete t[e].allowWhere
      }
      function Kk(t, e) {
        for (const n of t[e].allowAttributesOf) {
          const i = t[n]
          if (i) {
            const n = i.allowAttributes
            t[e].allowAttributes.push(...n)
          }
        }
        delete t[e].allowAttributesOf
      }
      function Qk(t, e) {
        const n = t[e]
        for (const e of n.inheritTypesFrom) {
          const i = t[e]
          if (i) {
            const t = Object.keys(i).filter((t) => t.startsWith('is'))
            for (const e of t) {
              if (!(e in n)) {
                n[e] = i[e]
              }
            }
          }
        }
        delete n.inheritTypesFrom
      }
      function Zk(t, e) {
        const n = t[e]
        const i = n.allowIn.filter((e) => t[e])
        n.allowIn = Array.from(new Set(i))
      }
      function Jk(t, e) {
        const n = t[e]
        for (const i of n.allowIn) {
          const n = t[i]
          n.allowChildren.push(e)
        }
      }
      function Xk(t, e) {
        const n = t[e]
        n.allowAttributes = Array.from(new Set(n.allowAttributes))
      }
      function tw(t, e) {
        for (const n of t) {
          const t = Object.keys(n).filter((t) => t.startsWith('is'))
          for (const i of t) {
            e[i] = !!n[i]
          }
        }
      }
      function ew(t, e, n) {
        for (const i of t) {
          const t = i[n]
          if (typeof t == 'string') {
            e[n].push(t)
          } else if (Array.isArray(t)) {
            e[n].push(...t)
          }
        }
      }
      function nw(t, e) {
        for (const n of t) {
          const t = n.inheritAllFrom
          if (t) {
            e.allowContentOf.push(t)
            e.allowWhere.push(t)
            e.allowAttributesOf.push(t)
            e.inheritTypesFrom.push(t)
          }
        }
      }
      function iw(t, e) {
        const n = t[e]
        return ow(t).filter((t) => t.allowIn.includes(n.name))
      }
      function ow(t) {
        return Object.keys(t).map((e) => t[e])
      }
      function rw(t) {
        if (typeof t == 'string' || t.is('documentFragment')) {
          return {
            name: typeof t == 'string' ? t : '$documentFragment',
            *getAttributeKeys() {},
            getAttribute() {}
          }
        } else {
          return {
            name: t.is('element') ? t.name : '$text',
            *getAttributeKeys() {
              yield* t.getAttributeKeys()
            },
            getAttribute(e) {
              return t.getAttribute(e)
            }
          }
        }
      }
      function* sw(t, e) {
        let n = false
        while (!n) {
          n = true
          if (t) {
            const e = t.next()
            if (!e.done) {
              n = false
              yield { walker: t, value: e.value }
            }
          }
          if (e) {
            const t = e.next()
            if (!t.done) {
              n = false
              yield { walker: e, value: t.value }
            }
          }
        }
      }
      function* aw(t) {
        for (const e of t) {
          yield* e.getMinimalFlatRanges()
        }
      }
      function cw(t, e, n) {
        for (const i of e.getAttributeKeys()) {
          if (!t.checkAttribute(e, i)) {
            n.removeAttribute(i, e)
          }
        }
      }
      class lw extends $() {
        constructor(t) {
          super()
          this._splitParts = new Map()
          this._cursorParents = new Map()
          this._modelCursor = null
          this._emptyElementsToKeep = new Set()
          this.conversionApi = {
            ...t,
            consumable: null,
            writer: null,
            store: null,
            convertItem: (t, e) => this._convertItem(t, e),
            convertChildren: (t, e) => this._convertChildren(t, e),
            safeInsert: (t, e) => this._safeInsert(t, e),
            updateConversionResult: (t, e) =>
              this._updateConversionResult(t, e),
            splitToAllowedParent: (t, e) => this._splitToAllowedParent(t, e),
            getSplitParts: (t) => this._getSplitParts(t),
            keepEmptyElement: (t) => this._keepEmptyElement(t)
          }
        }
        convert(t, e, n = ['$root']) {
          this.fire('viewCleanup', t)
          this._modelCursor = uw(n, e)
          this.conversionApi.writer = e
          this.conversionApi.consumable = Fk.createFrom(t)
          this.conversionApi.store = {}
          const { modelRange: i } = this._convertItem(t, this._modelCursor)
          const o = e.createDocumentFragment()
          if (i) {
            this._removeEmptyElements()
            for (const t of Array.from(
              this._modelCursor.parent.getChildren()
            )) {
              e.append(t, o)
            }
            o.markers = dw(o, e)
          }
          this._modelCursor = null
          this._splitParts.clear()
          this._cursorParents.clear()
          this._emptyElementsToKeep.clear()
          this.conversionApi.writer = null
          this.conversionApi.store = null
          return o
        }
        _convertItem(t, e) {
          const n = { viewItem: t, modelCursor: e, modelRange: null }
          if (t.is('element')) {
            this.fire(`element:${t.name}`, n, this.conversionApi)
          } else if (t.is('$text')) {
            this.fire('text', n, this.conversionApi)
          } else {
            this.fire('documentFragment', n, this.conversionApi)
          }
          if (n.modelRange && !(n.modelRange instanceof Jp)) {
            throw new N('view-conversion-dispatcher-incorrect-result', this)
          }
          return { modelRange: n.modelRange, modelCursor: n.modelCursor }
        }
        _convertChildren(t, e) {
          let n = e.is('position') ? e : qp._createAt(e, 0)
          const i = new Jp(n)
          for (const e of Array.from(t.getChildren())) {
            const t = this._convertItem(e, n)
            if (t.modelRange instanceof Jp) {
              i.end = t.modelRange.end
              n = t.modelCursor
            }
          }
          return { modelRange: i, modelCursor: n }
        }
        _safeInsert(t, e) {
          const n = this._splitToAllowedParent(t, e)
          if (!n) {
            return false
          }
          this.conversionApi.writer.insert(t, n.position)
          return true
        }
        _updateConversionResult(t, e) {
          const n = this._getSplitParts(t)
          const i = this.conversionApi.writer
          if (!e.modelRange) {
            e.modelRange = i.createRange(
              i.createPositionBefore(t),
              i.createPositionAfter(n[n.length - 1])
            )
          }
          const o = this._cursorParents.get(t)
          if (o) {
            e.modelCursor = i.createPositionAt(o, 0)
          } else {
            e.modelCursor = e.modelRange.end
          }
        }
        _splitToAllowedParent(t, e) {
          const { schema: n, writer: i } = this.conversionApi
          let o = n.findAllowedParent(e, t)
          if (o) {
            if (o === e.parent) {
              return { position: e }
            }
            if (this._modelCursor.parent.getAncestors().includes(o)) {
              o = null
            }
          }
          if (!o) {
            if (!bk(e, t, n)) {
              return null
            }
            return { position: kk(e, i) }
          }
          const r = this.conversionApi.writer.split(e, o)
          const s = []
          for (const t of r.range.getWalker()) {
            if (t.type == 'elementEnd') {
              s.push(t.item)
            } else {
              const e = s.pop()
              const n = t.item
              this._registerSplitPair(e, n)
            }
          }
          const a = r.range.end.parent
          this._cursorParents.set(t, a)
          return { position: r.position, cursorParent: a }
        }
        _registerSplitPair(t, e) {
          if (!this._splitParts.has(t)) {
            this._splitParts.set(t, [t])
          }
          const n = this._splitParts.get(t)
          this._splitParts.set(e, n)
          n.push(e)
        }
        _getSplitParts(t) {
          let e
          if (!this._splitParts.has(t)) {
            e = [t]
          } else {
            e = this._splitParts.get(t)
          }
          return e
        }
        _keepEmptyElement(t) {
          this._emptyElementsToKeep.add(t)
        }
        _removeEmptyElements() {
          let t = false
          for (const e of this._splitParts.keys()) {
            if (e.isEmpty && !this._emptyElementsToKeep.has(e)) {
              this.conversionApi.writer.remove(e)
              this._splitParts.delete(e)
              t = true
            }
          }
          if (t) {
            this._removeEmptyElements()
          }
        }
      }
      function dw(t, e) {
        const n = new Set()
        const i = new Map()
        const o = Jp._createIn(t).getItems()
        for (const t of o) {
          if (t.is('element', '$marker')) {
            n.add(t)
          }
        }
        for (const t of n) {
          const n = t.getAttribute('data-name')
          const o = e.createPositionBefore(t)
          if (!i.has(n)) {
            i.set(n, new Jp(o.clone()))
          } else {
            i.get(n).end = o.clone()
          }
          e.remove(t)
        }
        return i
      }
      function uw(t, e) {
        let n
        for (const i of new Wk(t)) {
          const t = {}
          for (const e of i.getAttributeKeys()) {
            t[e] = i.getAttribute(e)
          }
          const o = e.createElement(i.name, t)
          if (n) {
            e.insert(o, n)
          }
          n = qp._createAt(o, 0)
        }
        return n
      }
      class hw {
        getHtml(t) {
          const e = document.implementation.createHTMLDocument('')
          const n = e.createElement('div')
          n.appendChild(t)
          return n.innerHTML
        }
      }
      class fw {
        constructor(t) {
          this.skipComments = true
          this.domParser = new DOMParser()
          this.domConverter = new Gm(t, { renderingMode: 'data' })
          this.htmlWriter = new hw()
        }
        toData(t) {
          const e = this.domConverter.viewToDom(t)
          return this.htmlWriter.getHtml(e)
        }
        toView(t) {
          const e = this._toDom(t)
          return this.domConverter.domToView(e, {
            skipComments: this.skipComments
          })
        }
        registerRawContentMatcher(t) {
          this.domConverter.registerRawContentMatcher(t)
        }
        useFillerType(t) {
          this.domConverter.blockFillerMode =
            t == 'marked' ? 'markedNbsp' : 'nbsp'
        }
        _toDom(t) {
          if (!t.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i)) {
            t = `<body>${t}</body>`
          }
          const e = this.domParser.parseFromString(t, 'text/html')
          const n = e.createDocumentFragment()
          const i = e.body.childNodes
          while (i.length > 0) {
            n.appendChild(i[0])
          }
          return n
        }
      }
      class mw extends $() {
        constructor(t, e) {
          super()
          this.model = t
          this.mapper = new Xp()
          this.downcastDispatcher = new nb({
            mapper: this.mapper,
            schema: t.schema
          })
          this.downcastDispatcher.on('insert:$text', Db(), {
            priority: 'lowest'
          })
          this.downcastDispatcher.on('insert', Tb(), { priority: 'lowest' })
          this.upcastDispatcher = new lw({ schema: t.schema })
          this.viewDocument = new qf(e)
          this.stylesProcessor = e
          this.htmlProcessor = new fw(this.viewDocument)
          this.processor = this.htmlProcessor
          this._viewWriter = new sm(this.viewDocument)
          this.upcastDispatcher.on('text', Ak(), { priority: 'lowest' })
          this.upcastDispatcher.on('element', _k(), { priority: 'lowest' })
          this.upcastDispatcher.on('documentFragment', _k(), {
            priority: 'lowest'
          })
          ht().prototype.decorate.call(this, 'init')
          ht().prototype.decorate.call(this, 'set')
          ht().prototype.decorate.call(this, 'get')
          ht().prototype.decorate.call(this, 'toView')
          ht().prototype.decorate.call(this, 'toModel')
          this.on(
            'init',
            () => {
              this.fire('ready')
            },
            { priority: 'lowest' }
          )
          this.on(
            'ready',
            () => {
              this.model.enqueueChange({ isUndoable: false }, pk)
            },
            { priority: 'lowest' }
          )
        }
        get(t = {}) {
          const { rootName: e = 'main', trim: n = 'empty' } = t
          if (!this._checkIfRootsExists([e])) {
            throw new N('datacontroller-get-non-existent-root', this)
          }
          const i = this.model.document.getRoot(e)
          if (
            n === 'empty' &&
            !this.model.hasContent(i, { ignoreWhitespaces: true })
          ) {
            return ''
          }
          return this.stringify(i, t)
        }
        stringify(t, e = {}) {
          const n = this.toView(t, e)
          return this.processor.toData(n)
        }
        toView(t, e = {}) {
          const n = this.viewDocument
          const i = this._viewWriter
          this.mapper.clearBindings()
          const o = Jp._createIn(t)
          const r = new om(n)
          this.mapper.bindElements(t, r)
          const s = t.is('documentFragment') ? t.markers : gw(t)
          this.downcastDispatcher.convert(o, s, i, e)
          return r
        }
        init(t) {
          if (this.model.document.version) {
            throw new N('datacontroller-init-document-not-empty', this)
          }
          let e = {}
          if (typeof t === 'string') {
            e.main = t
          } else {
            e = t
          }
          if (!this._checkIfRootsExists(Object.keys(e))) {
            throw new N('datacontroller-init-non-existent-root', this)
          }
          this.model.enqueueChange({ isUndoable: false }, (t) => {
            for (const n of Object.keys(e)) {
              const i = this.model.document.getRoot(n)
              t.insert(this.parse(e[n], i), i, 0)
            }
          })
          return Promise.resolve()
        }
        set(t, e = {}) {
          let n = {}
          if (typeof t === 'string') {
            n.main = t
          } else {
            n = t
          }
          if (!this._checkIfRootsExists(Object.keys(n))) {
            throw new N('datacontroller-set-non-existent-root', this)
          }
          this.model.enqueueChange(e.batchType || {}, (t) => {
            t.setSelection(null)
            t.removeSelectionAttribute(
              this.model.document.selection.getAttributeKeys()
            )
            for (const e of Object.keys(n)) {
              const i = this.model.document.getRoot(e)
              t.remove(t.createRangeIn(i))
              t.insert(this.parse(n[e], i), i, 0)
            }
          })
        }
        parse(t, e = '$root') {
          const n = this.processor.toView(t)
          return this.toModel(n, e)
        }
        toModel(t, e = '$root') {
          return this.model.change((n) =>
            this.upcastDispatcher.convert(t, n, e)
          )
        }
        addStyleProcessorRules(t) {
          t(this.stylesProcessor)
        }
        registerRawContentMatcher(t) {
          if (this.processor && this.processor !== this.htmlProcessor) {
            this.processor.registerRawContentMatcher(t)
          }
          this.htmlProcessor.registerRawContentMatcher(t)
        }
        destroy() {
          this.stopListening()
        }
        _checkIfRootsExists(t) {
          for (const e of t) {
            if (!this.model.document.getRootNames().includes(e)) {
              return false
            }
          }
          return true
        }
      }
      function gw(t) {
        const e = []
        const n = t.root.document
        if (!n) {
          return new Map()
        }
        const i = Jp._createIn(t)
        for (const t of n.model.markers) {
          const n = t.getRange()
          const o = n.isCollapsed
          const r = n.start.isEqual(i.start) || n.end.isEqual(i.end)
          if (o && r) {
            e.push([t.name, n])
          } else {
            const o = i.getIntersection(n)
            if (o) {
              e.push([t.name, o])
            }
          }
        }
        e.sort(([t, e], [n, i]) => {
          if (e.end.compareWith(i.start) !== 'after') {
            return 1
          } else if (e.start.compareWith(i.end) !== 'before') {
            return -1
          } else {
            switch (e.start.compareWith(i.start)) {
              case 'before':
                return 1
              case 'after':
                return -1
              default:
                switch (e.end.compareWith(i.end)) {
                  case 'before':
                    return 1
                  case 'after':
                    return -1
                  default:
                    return n.localeCompare(t)
                }
            }
          }
        })
        return new Map(e)
      }
      class pw {
        constructor(t, e) {
          this._helpers = new Map()
          this._downcast = Zc(t)
          this._createConversionHelpers({
            name: 'downcast',
            dispatchers: this._downcast,
            isDowncast: true
          })
          this._upcast = Zc(e)
          this._createConversionHelpers({
            name: 'upcast',
            dispatchers: this._upcast,
            isDowncast: false
          })
        }
        addAlias(t, e) {
          const n = this._downcast.includes(e)
          const i = this._upcast.includes(e)
          if (!i && !n) {
            throw new N('conversion-add-alias-dispatcher-not-registered', this)
          }
          this._createConversionHelpers({
            name: t,
            dispatchers: [e],
            isDowncast: n
          })
        }
        for(t) {
          if (!this._helpers.has(t)) {
            throw new N('conversion-for-unknown-group', this)
          }
          return this._helpers.get(t)
        }
        elementToElement(t) {
          this.for('downcast').elementToElement(t)
          for (const { model: e, view: n } of bw(t)) {
            this.for('upcast').elementToElement({
              model: e,
              view: n,
              converterPriority: t.converterPriority
            })
          }
        }
        attributeToElement(t) {
          this.for('downcast').attributeToElement(t)
          for (const { model: e, view: n } of bw(t)) {
            this.for('upcast').elementToAttribute({
              view: n,
              model: e,
              converterPriority: t.converterPriority
            })
          }
        }
        attributeToAttribute(t) {
          this.for('downcast').attributeToAttribute(t)
          for (const { model: e, view: n } of bw(t)) {
            this.for('upcast').attributeToAttribute({ view: n, model: e })
          }
        }
        _createConversionHelpers({ name: t, dispatchers: e, isDowncast: n }) {
          if (this._helpers.has(t)) {
            throw new N('conversion-group-exists', this)
          }
          const i = n ? new Eb(e) : new wk(e)
          this._helpers.set(t, i)
        }
      }
      function* bw(t) {
        if (t.model.values) {
          for (const e of t.model.values) {
            const n = { key: t.model.key, value: e }
            const i = t.view[e]
            const o = t.upcastAlso ? t.upcastAlso[e] : undefined
            yield* kw(n, i, o)
          }
        } else {
          yield* kw(t.model, t.view, t.upcastAlso)
        }
      }
      function* kw(t, e, n) {
        yield { model: t, view: e }
        if (n) {
          for (const e of Zc(n)) {
            yield { model: t, view: e }
          }
        }
      }
      class ww {
        constructor(t) {
          this.baseVersion = t
          this.isDocumentOperation = this.baseVersion !== null
          this.batch = null
        }
        _validate() {}
        toJSON() {
          const t = Object.assign({}, this)
          t.__className = this.constructor.className
          delete t.batch
          delete t.isDocumentOperation
          return t
        }
        static get className() {
          return 'Operation'
        }
        static fromJSON(t, e) {
          return new this(t.baseVersion)
        }
      }
      function _w(t, e) {
        const n = yw(e)
        const i = n.reduce((t, e) => t + e.offsetSize, 0)
        const o = t.parent
        Ew(t)
        const r = t.index
        o._insertChild(r, n)
        xw(o, r + n.length)
        xw(o, r)
        return new Jp(t, t.getShiftedBy(i))
      }
      function Aw(t) {
        if (!t.isFlat) {
          throw new N('operation-utils-remove-range-not-flat', this)
        }
        const e = t.start.parent
        Ew(t.start)
        Ew(t.end)
        const n = e._removeChildren(t.start.index, t.end.index - t.start.index)
        xw(e, t.start.index)
        return n
      }
      function vw(t, e) {
        if (!t.isFlat) {
          throw new N('operation-utils-move-range-not-flat', this)
        }
        const n = Aw(t)
        e = e._getTransformedByDeletion(t.start, t.end.offset - t.start.offset)
        return _w(e, n)
      }
      function Cw(t, e, n) {
        Ew(t.start)
        Ew(t.end)
        for (const i of t.getItems({ shallow: true })) {
          const t = i.is('$textProxy') ? i.textNode : i
          if (n !== null) {
            t._setAttribute(e, n)
          } else {
            t._removeAttribute(e)
          }
          xw(t.parent, t.index)
        }
        xw(t.end.parent, t.end.index)
      }
      function yw(t) {
        const e = []
        function n(t) {
          if (typeof t == 'string') {
            e.push(new jp(t))
          } else if (t instanceof Fp) {
            e.push(new jp(t.data, t.getAttributes()))
          } else if (t instanceof Op) {
            e.push(t)
          } else if (Et(t)) {
            for (const e of t) {
              n(e)
            }
          }
        }
        n(t)
        for (let t = 1; t < e.length; t++) {
          const n = e[t]
          const i = e[t - 1]
          if (n instanceof jp && i instanceof jp && Dw(n, i)) {
            e.splice(t - 1, 2, new jp(i.data + n.data, i.getAttributes()))
            t--
          }
        }
        return e
      }
      function xw(t, e) {
        const n = t.getChild(e - 1)
        const i = t.getChild(e)
        if (n && i && n.is('$text') && i.is('$text') && Dw(n, i)) {
          const o = new jp(n.data + i.data, n.getAttributes())
          t._removeChildren(e - 1, 2)
          t._insertChild(e - 1, o)
        }
      }
      function Ew(t) {
        const e = t.textNode
        const n = t.parent
        if (e) {
          const i = t.offset - e.startOffset
          const o = e.index
          n._removeChildren(o, 1)
          const r = new jp(e.data.substr(0, i), e.getAttributes())
          const s = new jp(e.data.substr(i), e.getAttributes())
          n._insertChild(o, [r, s])
        }
      }
      function Dw(t, e) {
        const n = t.getAttributes()
        const i = e.getAttributes()
        for (const t of n) {
          if (t[1] !== e.getAttribute(t[0])) {
            return false
          }
          i.next()
        }
        return i.next().done
      }
      class Tw extends ww {
        constructor(t, e, n, i) {
          super(i)
          this.sourcePosition = t.clone()
          this.sourcePosition.stickiness = 'toNext'
          this.howMany = e
          this.targetPosition = n.clone()
          this.targetPosition.stickiness = 'toNone'
        }
        get type() {
          if (this.targetPosition.root.rootName == '$graveyard') {
            return 'remove'
          } else if (this.sourcePosition.root.rootName == '$graveyard') {
            return 'reinsert'
          }
          return 'move'
        }
        clone() {
          return new Tw(
            this.sourcePosition,
            this.howMany,
            this.targetPosition,
            this.baseVersion
          )
        }
        getMovedRangeStart() {
          return this.targetPosition._getTransformedByDeletion(
            this.sourcePosition,
            this.howMany
          )
        }
        getReversed() {
          const t = this.sourcePosition._getTransformedByInsertion(
            this.targetPosition,
            this.howMany
          )
          return new Tw(
            this.getMovedRangeStart(),
            this.howMany,
            t,
            this.baseVersion + 1
          )
        }
        _validate() {
          const t = this.sourcePosition.parent
          const e = this.targetPosition.parent
          const n = this.sourcePosition.offset
          const i = this.targetPosition.offset
          if (n + this.howMany > t.maxOffset) {
            throw new N('move-operation-nodes-do-not-exist', this)
          } else if (t === e && n < i && i < n + this.howMany) {
            throw new N('move-operation-range-into-itself', this)
          } else if (this.sourcePosition.root == this.targetPosition.root) {
            if (
              xt(
                this.sourcePosition.getParentPath(),
                this.targetPosition.getParentPath()
              ) == 'prefix'
            ) {
              const t = this.sourcePosition.path.length - 1
              if (
                this.targetPosition.path[t] >= n &&
                this.targetPosition.path[t] < n + this.howMany
              ) {
                throw new N('move-operation-node-into-itself', this)
              }
            }
          }
        }
        _execute() {
          vw(
            Jp._createFromPositionAndShift(this.sourcePosition, this.howMany),
            this.targetPosition
          )
        }
        toJSON() {
          const t = super.toJSON()
          t.sourcePosition = this.sourcePosition.toJSON()
          t.targetPosition = this.targetPosition.toJSON()
          return t
        }
        static get className() {
          return 'MoveOperation'
        }
        static fromJSON(t, e) {
          const n = qp.fromJSON(t.sourcePosition, e)
          const i = qp.fromJSON(t.targetPosition, e)
          return new this(n, t.howMany, i, t.baseVersion)
        }
      }
      class Mw extends ww {
        constructor(t, e, n) {
          super(n)
          this.position = t.clone()
          this.position.stickiness = 'toNone'
          this.nodes = new Rp(yw(e))
          this.shouldReceiveAttributes = false
        }
        get type() {
          return 'insert'
        }
        get howMany() {
          return this.nodes.maxOffset
        }
        clone() {
          const t = new Rp([...this.nodes].map((t) => t._clone(true)))
          const e = new Mw(this.position, t, this.baseVersion)
          e.shouldReceiveAttributes = this.shouldReceiveAttributes
          return e
        }
        getReversed() {
          const t = this.position.root.document.graveyard
          const e = new qp(t, [0])
          return new Tw(
            this.position,
            this.nodes.maxOffset,
            e,
            this.baseVersion + 1
          )
        }
        _validate() {
          const t = this.position.parent
          if (!t || t.maxOffset < this.position.offset) {
            throw new N('insert-operation-position-invalid', this)
          }
        }
        _execute() {
          const t = this.nodes
          this.nodes = new Rp([...t].map((t) => t._clone(true)))
          _w(this.position, t)
        }
        toJSON() {
          const t = super.toJSON()
          t.position = this.position.toJSON()
          t.nodes = this.nodes.toJSON()
          return t
        }
        static get className() {
          return 'InsertOperation'
        }
        static fromJSON(t, e) {
          const n = []
          for (const e of t.nodes) {
            if (e.name) {
              n.push(Vp.fromJSON(e))
            } else {
              n.push(jp.fromJSON(e))
            }
          }
          const i = new Mw(qp.fromJSON(t.position, e), n, t.baseVersion)
          i.shouldReceiveAttributes = t.shouldReceiveAttributes
          return i
        }
      }
      class Iw extends ww {
        constructor(t, e, n, i, o, r) {
          super(r)
          this.name = t
          this.oldRange = e ? e.clone() : null
          this.newRange = n ? n.clone() : null
          this.affectsData = o
          this._markers = i
        }
        get type() {
          return 'marker'
        }
        clone() {
          return new Iw(
            this.name,
            this.oldRange,
            this.newRange,
            this._markers,
            this.affectsData,
            this.baseVersion
          )
        }
        getReversed() {
          return new Iw(
            this.name,
            this.newRange,
            this.oldRange,
            this._markers,
            this.affectsData,
            this.baseVersion + 1
          )
        }
        _execute() {
          if (this.newRange) {
            this._markers._set(this.name, this.newRange, true, this.affectsData)
          } else {
            this._markers._remove(this.name)
          }
        }
        toJSON() {
          const t = super.toJSON()
          if (this.oldRange) {
            t.oldRange = this.oldRange.toJSON()
          }
          if (this.newRange) {
            t.newRange = this.newRange.toJSON()
          }
          delete t._markers
          return t
        }
        static get className() {
          return 'MarkerOperation'
        }
        static fromJSON(t, e) {
          return new Iw(
            t.name,
            t.oldRange ? Jp.fromJSON(t.oldRange, e) : null,
            t.newRange ? Jp.fromJSON(t.newRange, e) : null,
            e.model.markers,
            t.affectsData,
            t.baseVersion
          )
        }
      }
      function Sw(t, e) {
        return vp(t, e)
      }
      const Bw = Sw
      class Nw extends ww {
        constructor(t, e, n, i, o) {
          super(o)
          this.range = t.clone()
          this.key = e
          this.oldValue = n === undefined ? null : n
          this.newValue = i === undefined ? null : i
        }
        get type() {
          if (this.oldValue === null) {
            return 'addAttribute'
          } else if (this.newValue === null) {
            return 'removeAttribute'
          } else {
            return 'changeAttribute'
          }
        }
        clone() {
          return new Nw(
            this.range,
            this.key,
            this.oldValue,
            this.newValue,
            this.baseVersion
          )
        }
        getReversed() {
          return new Nw(
            this.range,
            this.key,
            this.newValue,
            this.oldValue,
            this.baseVersion + 1
          )
        }
        toJSON() {
          const t = super.toJSON()
          t.range = this.range.toJSON()
          return t
        }
        _validate() {
          if (!this.range.isFlat) {
            throw new N('attribute-operation-range-not-flat', this)
          }
          for (const t of this.range.getItems({ shallow: true })) {
            if (
              this.oldValue !== null &&
              !Bw(t.getAttribute(this.key), this.oldValue)
            ) {
              throw new N('attribute-operation-wrong-old-value', this, {
                item: t,
                key: this.key,
                value: this.oldValue
              })
            }
            if (
              this.oldValue === null &&
              this.newValue !== null &&
              t.hasAttribute(this.key)
            ) {
              throw new N('attribute-operation-attribute-exists', this, {
                node: t,
                key: this.key
              })
            }
          }
        }
        _execute() {
          if (!Bw(this.oldValue, this.newValue)) {
            Cw(this.range, this.key, this.newValue)
          }
        }
        static get className() {
          return 'AttributeOperation'
        }
        static fromJSON(t, e) {
          return new Nw(
            Jp.fromJSON(t.range, e),
            t.key,
            t.oldValue,
            t.newValue,
            t.baseVersion
          )
        }
      }
      class Pw extends ww {
        get type() {
          return 'noop'
        }
        clone() {
          return new Pw(this.baseVersion)
        }
        getReversed() {
          return new Pw(this.baseVersion + 1)
        }
        _execute() {}
        static get className() {
          return 'NoOperation'
        }
      }
      class zw extends ww {
        constructor(t, e, n, i) {
          super(i)
          this.position = t
          this.position.stickiness = 'toNext'
          this.oldName = e
          this.newName = n
        }
        get type() {
          return 'rename'
        }
        clone() {
          return new zw(
            this.position.clone(),
            this.oldName,
            this.newName,
            this.baseVersion
          )
        }
        getReversed() {
          return new zw(
            this.position.clone(),
            this.newName,
            this.oldName,
            this.baseVersion + 1
          )
        }
        _validate() {
          const t = this.position.nodeAfter
          if (!(t instanceof Vp)) {
            throw new N('rename-operation-wrong-position', this)
          } else if (t.name !== this.oldName) {
            throw new N('rename-operation-wrong-name', this)
          }
        }
        _execute() {
          const t = this.position.nodeAfter
          t.name = this.newName
        }
        toJSON() {
          const t = super.toJSON()
          t.position = this.position.toJSON()
          return t
        }
        static get className() {
          return 'RenameOperation'
        }
        static fromJSON(t, e) {
          return new zw(
            qp.fromJSON(t.position, e),
            t.oldName,
            t.newName,
            t.baseVersion
          )
        }
      }
      class Lw extends ww {
        constructor(t, e, n, i, o) {
          super(o)
          this.root = t
          this.key = e
          this.oldValue = n
          this.newValue = i
        }
        get type() {
          if (this.oldValue === null) {
            return 'addRootAttribute'
          } else if (this.newValue === null) {
            return 'removeRootAttribute'
          } else {
            return 'changeRootAttribute'
          }
        }
        clone() {
          return new Lw(
            this.root,
            this.key,
            this.oldValue,
            this.newValue,
            this.baseVersion
          )
        }
        getReversed() {
          return new Lw(
            this.root,
            this.key,
            this.newValue,
            this.oldValue,
            this.baseVersion + 1
          )
        }
        _validate() {
          if (this.root != this.root.root || this.root.is('documentFragment')) {
            throw new N('rootattribute-operation-not-a-root', this, {
              root: this.root,
              key: this.key
            })
          }
          if (
            this.oldValue !== null &&
            this.root.getAttribute(this.key) !== this.oldValue
          ) {
            throw new N('rootattribute-operation-wrong-old-value', this, {
              root: this.root,
              key: this.key
            })
          }
          if (
            this.oldValue === null &&
            this.newValue !== null &&
            this.root.hasAttribute(this.key)
          ) {
            throw new N('rootattribute-operation-attribute-exists', this, {
              root: this.root,
              key: this.key
            })
          }
        }
        _execute() {
          if (this.newValue !== null) {
            this.root._setAttribute(this.key, this.newValue)
          } else {
            this.root._removeAttribute(this.key)
          }
        }
        toJSON() {
          const t = super.toJSON()
          t.root = this.root.toJSON()
          return t
        }
        static get className() {
          return 'RootAttributeOperation'
        }
        static fromJSON(t, e) {
          if (!e.getRoot(t.root)) {
            throw new N('rootattribute-operation-fromjson-no-root', this, {
              rootName: t.root
            })
          }
          return new Lw(
            e.getRoot(t.root),
            t.key,
            t.oldValue,
            t.newValue,
            t.baseVersion
          )
        }
      }
      class Ow extends ww {
        constructor(t, e, n, i, o) {
          super(o)
          this.sourcePosition = t.clone()
          this.sourcePosition.stickiness = 'toPrevious'
          this.howMany = e
          this.targetPosition = n.clone()
          this.targetPosition.stickiness = 'toNext'
          this.graveyardPosition = i.clone()
        }
        get type() {
          return 'merge'
        }
        get deletionPosition() {
          return new qp(
            this.sourcePosition.root,
            this.sourcePosition.path.slice(0, -1)
          )
        }
        get movedRange() {
          const t = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY)
          return new Jp(this.sourcePosition, t)
        }
        clone() {
          return new Ow(
            this.sourcePosition,
            this.howMany,
            this.targetPosition,
            this.graveyardPosition,
            this.baseVersion
          )
        }
        getReversed() {
          const t = this.targetPosition._getTransformedByMergeOperation(this)
          const e = this.sourcePosition.path.slice(0, -1)
          const n = new qp(
            this.sourcePosition.root,
            e
          )._getTransformedByMergeOperation(this)
          return new Rw(
            t,
            this.howMany,
            n,
            this.graveyardPosition,
            this.baseVersion + 1
          )
        }
        _validate() {
          const t = this.sourcePosition.parent
          const e = this.targetPosition.parent
          if (!t.parent) {
            throw new N('merge-operation-source-position-invalid', this)
          } else if (!e.parent) {
            throw new N('merge-operation-target-position-invalid', this)
          } else if (this.howMany != t.maxOffset) {
            throw new N('merge-operation-how-many-invalid', this)
          }
        }
        _execute() {
          const t = this.sourcePosition.parent
          const e = Jp._createIn(t)
          vw(e, this.targetPosition)
          vw(Jp._createOn(t), this.graveyardPosition)
        }
        toJSON() {
          const t = super.toJSON()
          t.sourcePosition = t.sourcePosition.toJSON()
          t.targetPosition = t.targetPosition.toJSON()
          t.graveyardPosition = t.graveyardPosition.toJSON()
          return t
        }
        static get className() {
          return 'MergeOperation'
        }
        static fromJSON(t, e) {
          const n = qp.fromJSON(t.sourcePosition, e)
          const i = qp.fromJSON(t.targetPosition, e)
          const o = qp.fromJSON(t.graveyardPosition, e)
          return new this(n, t.howMany, i, o, t.baseVersion)
        }
      }
      class Rw extends ww {
        constructor(t, e, n, i, o) {
          super(o)
          this.splitPosition = t.clone()
          this.splitPosition.stickiness = 'toNext'
          this.howMany = e
          this.insertionPosition = n
          this.graveyardPosition = i ? i.clone() : null
          if (this.graveyardPosition) {
            this.graveyardPosition.stickiness = 'toNext'
          }
        }
        get type() {
          return 'split'
        }
        get moveTargetPosition() {
          const t = this.insertionPosition.path.slice()
          t.push(0)
          return new qp(this.insertionPosition.root, t)
        }
        get movedRange() {
          const t = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY)
          return new Jp(this.splitPosition, t)
        }
        clone() {
          return new Rw(
            this.splitPosition,
            this.howMany,
            this.insertionPosition,
            this.graveyardPosition,
            this.baseVersion
          )
        }
        getReversed() {
          const t = this.splitPosition.root.document.graveyard
          const e = new qp(t, [0])
          return new Ow(
            this.moveTargetPosition,
            this.howMany,
            this.splitPosition,
            e,
            this.baseVersion + 1
          )
        }
        _validate() {
          const t = this.splitPosition.parent
          const e = this.splitPosition.offset
          if (!t || t.maxOffset < e) {
            throw new N('split-operation-position-invalid', this)
          } else if (!t.parent) {
            throw new N('split-operation-split-in-root', this)
          } else if (this.howMany != t.maxOffset - this.splitPosition.offset) {
            throw new N('split-operation-how-many-invalid', this)
          } else if (
            this.graveyardPosition &&
            !this.graveyardPosition.nodeAfter
          ) {
            throw new N('split-operation-graveyard-position-invalid', this)
          }
        }
        _execute() {
          const t = this.splitPosition.parent
          if (this.graveyardPosition) {
            vw(
              Jp._createFromPositionAndShift(this.graveyardPosition, 1),
              this.insertionPosition
            )
          } else {
            const e = t._clone()
            _w(this.insertionPosition, e)
          }
          const e = new Jp(
            qp._createAt(t, this.splitPosition.offset),
            qp._createAt(t, t.maxOffset)
          )
          vw(e, this.moveTargetPosition)
        }
        toJSON() {
          const t = super.toJSON()
          t.splitPosition = this.splitPosition.toJSON()
          t.insertionPosition = this.insertionPosition.toJSON()
          if (this.graveyardPosition) {
            t.graveyardPosition = this.graveyardPosition.toJSON()
          }
          return t
        }
        static get className() {
          return 'SplitOperation'
        }
        static getInsertionPosition(t) {
          const e = t.path.slice(0, -1)
          e[e.length - 1]++
          return new qp(t.root, e, 'toPrevious')
        }
        static fromJSON(t, e) {
          const n = qp.fromJSON(t.splitPosition, e)
          const i = qp.fromJSON(t.insertionPosition, e)
          const o = t.graveyardPosition
            ? qp.fromJSON(t.graveyardPosition, e)
            : null
          return new this(n, t.howMany, i, o, t.baseVersion)
        }
      }
      const jw = {}
      jw[Nw.className] = Nw
      jw[Mw.className] = Mw
      jw[Iw.className] = Iw
      jw[Tw.className] = Tw
      jw[Pw.className] = Pw
      jw[ww.className] = ww
      jw[zw.className] = zw
      jw[Lw.className] = Lw
      jw[Rw.className] = Rw
      jw[Ow.className] = Ow
      class Fw {
        static fromJSON(t, e) {
          return jw[t.__className].fromJSON(t, e)
        }
      }
      const Vw = new Map()
      function Hw(t, e, n) {
        let i = Vw.get(t)
        if (!i) {
          i = new Map()
          Vw.set(t, i)
        }
        i.set(e, n)
      }
      function Uw(t, e) {
        const n = Vw.get(t)
        if (n && n.has(e)) {
          return n.get(e)
        }
        return Ww
      }
      function Ww(t) {
        return [t]
      }
      function qw(t, e, n = {}) {
        const i = Uw(t.constructor, e.constructor)
        try {
          t = t.clone()
          return i(t, e, n)
        } catch (t) {
          throw t
        }
      }
      function $w(t, e, n) {
        t = t.slice()
        e = e.slice()
        const i = new Gw(n.document, n.useRelations, n.forceWeakRemove)
        i.setOriginalOperations(t)
        i.setOriginalOperations(e)
        const o = i.originalOperations
        if (t.length == 0 || e.length == 0) {
          return { operationsA: t, operationsB: e, originalOperations: o }
        }
        const r = new WeakMap()
        for (const e of t) {
          r.set(e, 0)
        }
        const s = {
          nextBaseVersionA: t[t.length - 1].baseVersion + 1,
          nextBaseVersionB: e[e.length - 1].baseVersion + 1,
          originalOperationsACount: t.length,
          originalOperationsBCount: e.length
        }
        let a = 0
        while (a < t.length) {
          const n = t[a]
          const o = r.get(n)
          if (o == e.length) {
            a++
            continue
          }
          const s = e[o]
          const c = qw(n, s, i.getContext(n, s, true))
          const l = qw(s, n, i.getContext(s, n, false))
          i.updateRelation(n, s)
          i.setOriginalOperations(c, n)
          i.setOriginalOperations(l, s)
          for (const t of c) {
            r.set(t, o + l.length)
          }
          t.splice(a, 1, ...c)
          e.splice(o, 1, ...l)
        }
        if (n.padWithNoOps) {
          const n = t.length - s.originalOperationsACount
          const i = e.length - s.originalOperationsBCount
          Kw(t, i - n)
          Kw(e, n - i)
        }
        Yw(t, s.nextBaseVersionB)
        Yw(e, s.nextBaseVersionA)
        return { operationsA: t, operationsB: e, originalOperations: o }
      }
      class Gw {
        constructor(t, e, n = false) {
          this.originalOperations = new Map()
          this._history = t.history
          this._useRelations = e
          this._forceWeakRemove = !!n
          this._relations = new Map()
        }
        setOriginalOperations(t, e = null) {
          const n = e ? this.originalOperations.get(e) : null
          for (const e of t) {
            this.originalOperations.set(e, n || e)
          }
        }
        updateRelation(t, e) {
          if (t instanceof Tw) {
            if (e instanceof Ow) {
              if (
                t.targetPosition.isEqual(e.sourcePosition) ||
                e.movedRange.containsPosition(t.targetPosition)
              ) {
                this._setRelation(t, e, 'insertAtSource')
              } else if (t.targetPosition.isEqual(e.deletionPosition)) {
                this._setRelation(t, e, 'insertBetween')
              } else if (t.targetPosition.isAfter(e.sourcePosition)) {
                this._setRelation(t, e, 'moveTargetAfter')
              }
            } else if (e instanceof Tw) {
              if (
                t.targetPosition.isEqual(e.sourcePosition) ||
                t.targetPosition.isBefore(e.sourcePosition)
              ) {
                this._setRelation(t, e, 'insertBefore')
              } else {
                this._setRelation(t, e, 'insertAfter')
              }
            }
          } else if (t instanceof Rw) {
            if (e instanceof Ow) {
              if (t.splitPosition.isBefore(e.sourcePosition)) {
                this._setRelation(t, e, 'splitBefore')
              }
            } else if (e instanceof Tw) {
              if (
                t.splitPosition.isEqual(e.sourcePosition) ||
                t.splitPosition.isBefore(e.sourcePosition)
              ) {
                this._setRelation(t, e, 'splitBefore')
              } else {
                const n = Jp._createFromPositionAndShift(
                  e.sourcePosition,
                  e.howMany
                )
                if (
                  t.splitPosition.hasSameParentAs(e.sourcePosition) &&
                  n.containsPosition(t.splitPosition)
                ) {
                  const i = n.end.offset - t.splitPosition.offset
                  const o = t.splitPosition.offset - n.start.offset
                  this._setRelation(t, e, { howMany: i, offset: o })
                }
              }
            }
          } else if (t instanceof Ow) {
            if (e instanceof Ow) {
              if (!t.targetPosition.isEqual(e.sourcePosition)) {
                this._setRelation(t, e, 'mergeTargetNotMoved')
              }
              if (t.sourcePosition.isEqual(e.targetPosition)) {
                this._setRelation(t, e, 'mergeSourceNotMoved')
              }
              if (t.sourcePosition.isEqual(e.sourcePosition)) {
                this._setRelation(t, e, 'mergeSameElement')
              }
            } else if (e instanceof Rw) {
              if (t.sourcePosition.isEqual(e.splitPosition)) {
                this._setRelation(t, e, 'splitAtSource')
              }
            }
          } else if (t instanceof Iw) {
            const n = t.newRange
            if (!n) {
              return
            }
            if (e instanceof Tw) {
              const i = Jp._createFromPositionAndShift(
                e.sourcePosition,
                e.howMany
              )
              const o = i.containsPosition(n.start) || i.start.isEqual(n.start)
              const r = i.containsPosition(n.end) || i.end.isEqual(n.end)
              if ((o || r) && !i.containsRange(n)) {
                this._setRelation(t, e, {
                  side: o ? 'left' : 'right',
                  path: o ? n.start.path.slice() : n.end.path.slice()
                })
              }
            } else if (e instanceof Ow) {
              const i = n.start.isEqual(e.targetPosition)
              const o = n.start.isEqual(e.deletionPosition)
              const r = n.end.isEqual(e.deletionPosition)
              const s = n.end.isEqual(e.sourcePosition)
              if (i || o || r || s) {
                this._setRelation(t, e, {
                  wasInLeftElement: i,
                  wasStartBeforeMergedElement: o,
                  wasEndBeforeMergedElement: r,
                  wasInRightElement: s
                })
              }
            }
          }
        }
        getContext(t, e, n) {
          return {
            aIsStrong: n,
            aWasUndone: this._wasUndone(t),
            bWasUndone: this._wasUndone(e),
            abRelation: this._useRelations ? this._getRelation(t, e) : null,
            baRelation: this._useRelations ? this._getRelation(e, t) : null,
            forceWeakRemove: this._forceWeakRemove
          }
        }
        _wasUndone(t) {
          const e = this.originalOperations.get(t)
          return e.wasUndone || this._history.isUndoneOperation(e)
        }
        _getRelation(t, e) {
          const n = this.originalOperations.get(e)
          const i = this._history.getUndoneOperation(n)
          if (!i) {
            return null
          }
          const o = this.originalOperations.get(t)
          const r = this._relations.get(o)
          if (r) {
            return r.get(i) || null
          }
          return null
        }
        _setRelation(t, e, n) {
          const i = this.originalOperations.get(t)
          const o = this.originalOperations.get(e)
          let r = this._relations.get(i)
          if (!r) {
            r = new Map()
            this._relations.set(i, r)
          }
          r.set(o, n)
        }
      }
      function Yw(t, e) {
        for (const n of t) {
          n.baseVersion = e++
        }
      }
      function Kw(t, e) {
        for (let n = 0; n < e; n++) {
          t.push(new Pw(0))
        }
      }
      Hw(Nw, Nw, (t, e, n) => {
        if (t.key === e.key && t.range.start.hasSameParentAs(e.range.start)) {
          const i = t.range
            .getDifference(e.range)
            .map((e) => new Nw(e, t.key, t.oldValue, t.newValue, 0))
          const o = t.range.getIntersection(e.range)
          if (o) {
            if (n.aIsStrong) {
              i.push(new Nw(o, e.key, e.newValue, t.newValue, 0))
            }
          }
          if (i.length == 0) {
            return [new Pw(0)]
          }
          return i
        } else {
          return [t]
        }
      })
      Hw(Nw, Mw, (t, e) => {
        if (
          t.range.start.hasSameParentAs(e.position) &&
          t.range.containsPosition(e.position)
        ) {
          const n = t.range._getTransformedByInsertion(
            e.position,
            e.howMany,
            !e.shouldReceiveAttributes
          )
          const i = n.map(
            (e) => new Nw(e, t.key, t.oldValue, t.newValue, t.baseVersion)
          )
          if (e.shouldReceiveAttributes) {
            const n = Qw(e, t.key, t.oldValue)
            if (n) {
              i.unshift(n)
            }
          }
          return i
        }
        t.range = t.range._getTransformedByInsertion(
          e.position,
          e.howMany,
          false
        )[0]
        return [t]
      })
      function Qw(t, e, n) {
        const i = t.nodes
        const o = i.getNode(0).getAttribute(e)
        if (o == n) {
          return null
        }
        const r = new Jp(t.position, t.position.getShiftedBy(t.howMany))
        return new Nw(r, e, o, n, 0)
      }
      Hw(Nw, Ow, (t, e) => {
        const n = []
        if (t.range.start.hasSameParentAs(e.deletionPosition)) {
          if (
            t.range.containsPosition(e.deletionPosition) ||
            t.range.start.isEqual(e.deletionPosition)
          ) {
            n.push(Jp._createFromPositionAndShift(e.graveyardPosition, 1))
          }
        }
        const i = t.range._getTransformedByMergeOperation(e)
        if (!i.isCollapsed) {
          n.push(i)
        }
        return n.map(
          (e) => new Nw(e, t.key, t.oldValue, t.newValue, t.baseVersion)
        )
      })
      Hw(Nw, Tw, (t, e) => {
        const n = Zw(t.range, e)
        return n.map(
          (e) => new Nw(e, t.key, t.oldValue, t.newValue, t.baseVersion)
        )
      })
      function Zw(t, e) {
        const n = Jp._createFromPositionAndShift(e.sourcePosition, e.howMany)
        let i = null
        let o = []
        if (n.containsRange(t, true)) {
          i = t
        } else if (t.start.hasSameParentAs(n.start)) {
          o = t.getDifference(n)
          i = t.getIntersection(n)
        } else {
          o = [t]
        }
        const r = []
        for (let t of o) {
          t = t._getTransformedByDeletion(e.sourcePosition, e.howMany)
          const n = e.getMovedRangeStart()
          const i = t.start.hasSameParentAs(n)
          const o = t._getTransformedByInsertion(n, e.howMany, i)
          r.push(...o)
        }
        if (i) {
          r.push(
            i._getTransformedByMove(
              e.sourcePosition,
              e.targetPosition,
              e.howMany,
              false
            )[0]
          )
        }
        return r
      }
      Hw(Nw, Rw, (t, e) => {
        if (t.range.end.isEqual(e.insertionPosition)) {
          if (!e.graveyardPosition) {
            t.range.end.offset++
          }
          return [t]
        }
        if (
          t.range.start.hasSameParentAs(e.splitPosition) &&
          t.range.containsPosition(e.splitPosition)
        ) {
          const n = t.clone()
          n.range = new Jp(
            e.moveTargetPosition.clone(),
            t.range.end._getCombined(e.splitPosition, e.moveTargetPosition)
          )
          t.range.end = e.splitPosition.clone()
          t.range.end.stickiness = 'toPrevious'
          return [t, n]
        }
        t.range = t.range._getTransformedBySplitOperation(e)
        return [t]
      })
      Hw(Mw, Nw, (t, e) => {
        const n = [t]
        if (
          t.shouldReceiveAttributes &&
          t.position.hasSameParentAs(e.range.start) &&
          e.range.containsPosition(t.position)
        ) {
          const i = Qw(t, e.key, e.newValue)
          if (i) {
            n.push(i)
          }
        }
        return n
      })
      Hw(Mw, Mw, (t, e, n) => {
        if (t.position.isEqual(e.position) && n.aIsStrong) {
          return [t]
        }
        t.position = t.position._getTransformedByInsertOperation(e)
        return [t]
      })
      Hw(Mw, Tw, (t, e) => {
        t.position = t.position._getTransformedByMoveOperation(e)
        return [t]
      })
      Hw(Mw, Rw, (t, e) => {
        t.position = t.position._getTransformedBySplitOperation(e)
        return [t]
      })
      Hw(Mw, Ow, (t, e) => {
        t.position = t.position._getTransformedByMergeOperation(e)
        return [t]
      })
      Hw(Iw, Mw, (t, e) => {
        if (t.oldRange) {
          t.oldRange = t.oldRange._getTransformedByInsertOperation(e)[0]
        }
        if (t.newRange) {
          t.newRange = t.newRange._getTransformedByInsertOperation(e)[0]
        }
        return [t]
      })
      Hw(Iw, Iw, (t, e, n) => {
        if (t.name == e.name) {
          if (n.aIsStrong) {
            t.oldRange = e.newRange ? e.newRange.clone() : null
          } else {
            return [new Pw(0)]
          }
        }
        return [t]
      })
      Hw(Iw, Ow, (t, e) => {
        if (t.oldRange) {
          t.oldRange = t.oldRange._getTransformedByMergeOperation(e)
        }
        if (t.newRange) {
          t.newRange = t.newRange._getTransformedByMergeOperation(e)
        }
        return [t]
      })
      Hw(Iw, Tw, (t, e, n) => {
        if (t.oldRange) {
          t.oldRange = Jp._createFromRanges(
            t.oldRange._getTransformedByMoveOperation(e)
          )
        }
        if (t.newRange) {
          if (n.abRelation) {
            const i = Jp._createFromRanges(
              t.newRange._getTransformedByMoveOperation(e)
            )
            if (
              n.abRelation.side == 'left' &&
              e.targetPosition.isEqual(t.newRange.start)
            ) {
              t.newRange.end = i.end
              t.newRange.start.path = n.abRelation.path
              return [t]
            } else if (
              n.abRelation.side == 'right' &&
              e.targetPosition.isEqual(t.newRange.end)
            ) {
              t.newRange.start = i.start
              t.newRange.end.path = n.abRelation.path
              return [t]
            }
          }
          t.newRange = Jp._createFromRanges(
            t.newRange._getTransformedByMoveOperation(e)
          )
        }
        return [t]
      })
      Hw(Iw, Rw, (t, e, n) => {
        if (t.oldRange) {
          t.oldRange = t.oldRange._getTransformedBySplitOperation(e)
        }
        if (t.newRange) {
          if (n.abRelation) {
            const i = t.newRange._getTransformedBySplitOperation(e)
            if (
              t.newRange.start.isEqual(e.splitPosition) &&
              n.abRelation.wasStartBeforeMergedElement
            ) {
              t.newRange.start = qp._createAt(e.insertionPosition)
            } else if (
              t.newRange.start.isEqual(e.splitPosition) &&
              !n.abRelation.wasInLeftElement
            ) {
              t.newRange.start = qp._createAt(e.moveTargetPosition)
            }
            if (
              t.newRange.end.isEqual(e.splitPosition) &&
              n.abRelation.wasInRightElement
            ) {
              t.newRange.end = qp._createAt(e.moveTargetPosition)
            } else if (
              t.newRange.end.isEqual(e.splitPosition) &&
              n.abRelation.wasEndBeforeMergedElement
            ) {
              t.newRange.end = qp._createAt(e.insertionPosition)
            } else {
              t.newRange.end = i.end
            }
            return [t]
          }
          t.newRange = t.newRange._getTransformedBySplitOperation(e)
        }
        return [t]
      })
      Hw(Ow, Mw, (t, e) => {
        if (t.sourcePosition.hasSameParentAs(e.position)) {
          t.howMany += e.howMany
        }
        t.sourcePosition = t.sourcePosition._getTransformedByInsertOperation(e)
        t.targetPosition = t.targetPosition._getTransformedByInsertOperation(e)
        return [t]
      })
      Hw(Ow, Ow, (t, e, n) => {
        if (
          t.sourcePosition.isEqual(e.sourcePosition) &&
          t.targetPosition.isEqual(e.targetPosition)
        ) {
          if (!n.bWasUndone) {
            return [new Pw(0)]
          } else {
            const n = e.graveyardPosition.path.slice()
            n.push(0)
            t.sourcePosition = new qp(e.graveyardPosition.root, n)
            t.howMany = 0
            return [t]
          }
        }
        if (
          t.sourcePosition.isEqual(e.sourcePosition) &&
          !t.targetPosition.isEqual(e.targetPosition) &&
          !n.bWasUndone &&
          n.abRelation != 'splitAtSource'
        ) {
          const i = t.targetPosition.root.rootName == '$graveyard'
          const o = e.targetPosition.root.rootName == '$graveyard'
          const r = i && !o
          const s = o && !i
          const a = s || (!r && n.aIsStrong)
          if (a) {
            const n = e.targetPosition._getTransformedByMergeOperation(e)
            const i = t.targetPosition._getTransformedByMergeOperation(e)
            return [new Tw(n, t.howMany, i, 0)]
          } else {
            return [new Pw(0)]
          }
        }
        if (t.sourcePosition.hasSameParentAs(e.targetPosition)) {
          t.howMany += e.howMany
        }
        t.sourcePosition = t.sourcePosition._getTransformedByMergeOperation(e)
        t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e)
        if (!t.graveyardPosition.isEqual(e.graveyardPosition) || !n.aIsStrong) {
          t.graveyardPosition =
            t.graveyardPosition._getTransformedByMergeOperation(e)
        }
        return [t]
      })
      Hw(Ow, Tw, (t, e, n) => {
        const i = Jp._createFromPositionAndShift(e.sourcePosition, e.howMany)
        if (e.type == 'remove' && !n.bWasUndone && !n.forceWeakRemove) {
          if (
            t.deletionPosition.hasSameParentAs(e.sourcePosition) &&
            i.containsPosition(t.sourcePosition)
          ) {
            return [new Pw(0)]
          }
        }
        if (t.sourcePosition.hasSameParentAs(e.targetPosition)) {
          t.howMany += e.howMany
        }
        if (t.sourcePosition.hasSameParentAs(e.sourcePosition)) {
          t.howMany -= e.howMany
        }
        t.sourcePosition = t.sourcePosition._getTransformedByMoveOperation(e)
        t.targetPosition = t.targetPosition._getTransformedByMoveOperation(e)
        if (!t.graveyardPosition.isEqual(e.targetPosition)) {
          t.graveyardPosition =
            t.graveyardPosition._getTransformedByMoveOperation(e)
        }
        return [t]
      })
      Hw(Ow, Rw, (t, e, n) => {
        if (e.graveyardPosition) {
          t.graveyardPosition = t.graveyardPosition._getTransformedByDeletion(
            e.graveyardPosition,
            1
          )
          if (t.deletionPosition.isEqual(e.graveyardPosition)) {
            t.howMany = e.howMany
          }
        }
        if (t.targetPosition.isEqual(e.splitPosition)) {
          const i = e.howMany != 0
          const o =
            e.graveyardPosition &&
            t.deletionPosition.isEqual(e.graveyardPosition)
          if (i || o || n.abRelation == 'mergeTargetNotMoved') {
            t.sourcePosition =
              t.sourcePosition._getTransformedBySplitOperation(e)
            return [t]
          }
        }
        if (t.sourcePosition.isEqual(e.splitPosition)) {
          if (n.abRelation == 'mergeSourceNotMoved') {
            t.howMany = 0
            t.targetPosition =
              t.targetPosition._getTransformedBySplitOperation(e)
            return [t]
          }
          if (
            n.abRelation == 'mergeSameElement' ||
            t.sourcePosition.offset > 0
          ) {
            t.sourcePosition = e.moveTargetPosition.clone()
            t.targetPosition =
              t.targetPosition._getTransformedBySplitOperation(e)
            return [t]
          }
        }
        if (t.sourcePosition.hasSameParentAs(e.splitPosition)) {
          t.howMany = e.splitPosition.offset
        }
        t.sourcePosition = t.sourcePosition._getTransformedBySplitOperation(e)
        t.targetPosition = t.targetPosition._getTransformedBySplitOperation(e)
        return [t]
      })
      Hw(Tw, Mw, (t, e) => {
        const n = Jp._createFromPositionAndShift(t.sourcePosition, t.howMany)
        const i = n._getTransformedByInsertOperation(e, false)[0]
        t.sourcePosition = i.start
        t.howMany = i.end.offset - i.start.offset
        if (!t.targetPosition.isEqual(e.position)) {
          t.targetPosition =
            t.targetPosition._getTransformedByInsertOperation(e)
        }
        return [t]
      })
      Hw(Tw, Tw, (t, e, n) => {
        const i = Jp._createFromPositionAndShift(t.sourcePosition, t.howMany)
        const o = Jp._createFromPositionAndShift(e.sourcePosition, e.howMany)
        let r = n.aIsStrong
        let s = !n.aIsStrong
        if (n.abRelation == 'insertBefore' || n.baRelation == 'insertAfter') {
          s = true
        } else if (
          n.abRelation == 'insertAfter' ||
          n.baRelation == 'insertBefore'
        ) {
          s = false
        }
        let a
        if (t.targetPosition.isEqual(e.targetPosition) && s) {
          a = t.targetPosition._getTransformedByDeletion(
            e.sourcePosition,
            e.howMany
          )
        } else {
          a = t.targetPosition._getTransformedByMove(
            e.sourcePosition,
            e.targetPosition,
            e.howMany
          )
        }
        if (Jw(t, e) && Jw(e, t)) {
          return [e.getReversed()]
        }
        const c = i.containsPosition(e.targetPosition)
        if (c && i.containsRange(o, true)) {
          i.start = i.start._getTransformedByMove(
            e.sourcePosition,
            e.targetPosition,
            e.howMany
          )
          i.end = i.end._getTransformedByMove(
            e.sourcePosition,
            e.targetPosition,
            e.howMany
          )
          return Xw([i], a)
        }
        const l = o.containsPosition(t.targetPosition)
        if (l && o.containsRange(i, true)) {
          i.start = i.start._getCombined(
            e.sourcePosition,
            e.getMovedRangeStart()
          )
          i.end = i.end._getCombined(e.sourcePosition, e.getMovedRangeStart())
          return Xw([i], a)
        }
        const d = xt(
          t.sourcePosition.getParentPath(),
          e.sourcePosition.getParentPath()
        )
        if (d == 'prefix' || d == 'extension') {
          i.start = i.start._getTransformedByMove(
            e.sourcePosition,
            e.targetPosition,
            e.howMany
          )
          i.end = i.end._getTransformedByMove(
            e.sourcePosition,
            e.targetPosition,
            e.howMany
          )
          return Xw([i], a)
        }
        if (
          t.type == 'remove' &&
          e.type != 'remove' &&
          !n.aWasUndone &&
          !n.forceWeakRemove
        ) {
          r = true
        } else if (
          t.type != 'remove' &&
          e.type == 'remove' &&
          !n.bWasUndone &&
          !n.forceWeakRemove
        ) {
          r = false
        }
        const u = []
        const h = i.getDifference(o)
        for (const t of h) {
          t.start = t.start._getTransformedByDeletion(
            e.sourcePosition,
            e.howMany
          )
          t.end = t.end._getTransformedByDeletion(e.sourcePosition, e.howMany)
          const n =
            xt(
              t.start.getParentPath(),
              e.getMovedRangeStart().getParentPath()
            ) == 'same'
          const i = t._getTransformedByInsertion(
            e.getMovedRangeStart(),
            e.howMany,
            n
          )
          u.push(...i)
        }
        const f = i.getIntersection(o)
        if (f !== null && r) {
          f.start = f.start._getCombined(
            e.sourcePosition,
            e.getMovedRangeStart()
          )
          f.end = f.end._getCombined(e.sourcePosition, e.getMovedRangeStart())
          if (u.length === 0) {
            u.push(f)
          } else if (u.length == 1) {
            if (o.start.isBefore(i.start) || o.start.isEqual(i.start)) {
              u.unshift(f)
            } else {
              u.push(f)
            }
          } else {
            u.splice(1, 0, f)
          }
        }
        if (u.length === 0) {
          return [new Pw(t.baseVersion)]
        }
        return Xw(u, a)
      })
      Hw(Tw, Rw, (t, e, n) => {
        let i = t.targetPosition.clone()
        if (
          !t.targetPosition.isEqual(e.insertionPosition) ||
          !e.graveyardPosition ||
          n.abRelation == 'moveTargetAfter'
        ) {
          i = t.targetPosition._getTransformedBySplitOperation(e)
        }
        const o = Jp._createFromPositionAndShift(t.sourcePosition, t.howMany)
        if (o.end.isEqual(e.insertionPosition)) {
          if (!e.graveyardPosition) {
            t.howMany++
          }
          t.targetPosition = i
          return [t]
        }
        if (
          o.start.hasSameParentAs(e.splitPosition) &&
          o.containsPosition(e.splitPosition)
        ) {
          let t = new Jp(e.splitPosition, o.end)
          t = t._getTransformedBySplitOperation(e)
          const n = [new Jp(o.start, e.splitPosition), t]
          return Xw(n, i)
        }
        if (
          t.targetPosition.isEqual(e.splitPosition) &&
          n.abRelation == 'insertAtSource'
        ) {
          i = e.moveTargetPosition
        }
        if (
          t.targetPosition.isEqual(e.insertionPosition) &&
          n.abRelation == 'insertBetween'
        ) {
          i = t.targetPosition
        }
        const r = o._getTransformedBySplitOperation(e)
        const s = [r]
        if (e.graveyardPosition) {
          const i =
            o.start.isEqual(e.graveyardPosition) ||
            o.containsPosition(e.graveyardPosition)
          if (t.howMany > 1 && i && !n.aWasUndone) {
            s.push(Jp._createFromPositionAndShift(e.insertionPosition, 1))
          }
        }
        return Xw(s, i)
      })
      Hw(Tw, Ow, (t, e, n) => {
        const i = Jp._createFromPositionAndShift(t.sourcePosition, t.howMany)
        if (
          e.deletionPosition.hasSameParentAs(t.sourcePosition) &&
          i.containsPosition(e.sourcePosition)
        ) {
          if (t.type == 'remove' && !n.forceWeakRemove) {
            if (!n.aWasUndone) {
              const n = []
              let i = e.graveyardPosition.clone()
              let o = e.targetPosition._getTransformedByMergeOperation(e)
              if (t.howMany > 1) {
                n.push(
                  new Tw(t.sourcePosition, t.howMany - 1, t.targetPosition, 0)
                )
                i = i._getTransformedByMove(
                  t.sourcePosition,
                  t.targetPosition,
                  t.howMany - 1
                )
                o = o._getTransformedByMove(
                  t.sourcePosition,
                  t.targetPosition,
                  t.howMany - 1
                )
              }
              const r = e.deletionPosition._getCombined(
                t.sourcePosition,
                t.targetPosition
              )
              const s = new Tw(i, 1, r, 0)
              const a = s.getMovedRangeStart().path.slice()
              a.push(0)
              const c = new qp(s.targetPosition.root, a)
              o = o._getTransformedByMove(i, r, 1)
              const l = new Tw(o, e.howMany, c, 0)
              n.push(s)
              n.push(l)
              return n
            }
          } else {
            if (t.howMany == 1) {
              if (!n.bWasUndone) {
                return [new Pw(0)]
              } else {
                t.sourcePosition = e.graveyardPosition.clone()
                t.targetPosition =
                  t.targetPosition._getTransformedByMergeOperation(e)
                return [t]
              }
            }
          }
        }
        const o = Jp._createFromPositionAndShift(t.sourcePosition, t.howMany)
        const r = o._getTransformedByMergeOperation(e)
        t.sourcePosition = r.start
        t.howMany = r.end.offset - r.start.offset
        t.targetPosition = t.targetPosition._getTransformedByMergeOperation(e)
        return [t]
      })
      Hw(zw, Mw, (t, e) => {
        t.position = t.position._getTransformedByInsertOperation(e)
        return [t]
      })
      Hw(zw, Ow, (t, e) => {
        if (t.position.isEqual(e.deletionPosition)) {
          t.position = e.graveyardPosition.clone()
          t.position.stickiness = 'toNext'
          return [t]
        }
        t.position = t.position._getTransformedByMergeOperation(e)
        return [t]
      })
      Hw(zw, Tw, (t, e) => {
        t.position = t.position._getTransformedByMoveOperation(e)
        return [t]
      })
      Hw(zw, zw, (t, e, n) => {
        if (t.position.isEqual(e.position)) {
          if (n.aIsStrong) {
            t.oldName = e.newName
          } else {
            return [new Pw(0)]
          }
        }
        return [t]
      })
      Hw(zw, Rw, (t, e) => {
        const n = t.position.path
        const i = e.splitPosition.getParentPath()
        if (xt(n, i) == 'same' && !e.graveyardPosition) {
          const e = new zw(t.position.getShiftedBy(1), t.oldName, t.newName, 0)
          return [t, e]
        }
        t.position = t.position._getTransformedBySplitOperation(e)
        return [t]
      })
      Hw(Lw, Lw, (t, e, n) => {
        if (t.root === e.root && t.key === e.key) {
          if (!n.aIsStrong || t.newValue === e.newValue) {
            return [new Pw(0)]
          } else {
            t.oldValue = e.newValue
          }
        }
        return [t]
      })
      Hw(Rw, Mw, (t, e) => {
        if (
          t.splitPosition.hasSameParentAs(e.position) &&
          t.splitPosition.offset < e.position.offset
        ) {
          t.howMany += e.howMany
        }
        t.splitPosition = t.splitPosition._getTransformedByInsertOperation(e)
        t.insertionPosition =
          t.insertionPosition._getTransformedByInsertOperation(e)
        return [t]
      })
      Hw(Rw, Ow, (t, e, n) => {
        if (
          !t.graveyardPosition &&
          !n.bWasUndone &&
          t.splitPosition.hasSameParentAs(e.sourcePosition)
        ) {
          const n = e.graveyardPosition.path.slice()
          n.push(0)
          const i = new qp(e.graveyardPosition.root, n)
          const o = Rw.getInsertionPosition(new qp(e.graveyardPosition.root, n))
          const r = new Rw(i, 0, o, null, 0)
          t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e)
          t.insertionPosition = Rw.getInsertionPosition(t.splitPosition)
          t.graveyardPosition = r.insertionPosition.clone()
          t.graveyardPosition.stickiness = 'toNext'
          return [r, t]
        }
        if (
          t.splitPosition.hasSameParentAs(e.deletionPosition) &&
          !t.splitPosition.isAfter(e.deletionPosition)
        ) {
          t.howMany--
        }
        if (t.splitPosition.hasSameParentAs(e.targetPosition)) {
          t.howMany += e.howMany
        }
        t.splitPosition = t.splitPosition._getTransformedByMergeOperation(e)
        t.insertionPosition = Rw.getInsertionPosition(t.splitPosition)
        if (t.graveyardPosition) {
          t.graveyardPosition =
            t.graveyardPosition._getTransformedByMergeOperation(e)
        }
        return [t]
      })
      Hw(Rw, Tw, (t, e, n) => {
        const i = Jp._createFromPositionAndShift(e.sourcePosition, e.howMany)
        if (t.graveyardPosition) {
          const o =
            i.start.isEqual(t.graveyardPosition) ||
            i.containsPosition(t.graveyardPosition)
          if (!n.bWasUndone && o) {
            const n = t.splitPosition._getTransformedByMoveOperation(e)
            const i = t.graveyardPosition._getTransformedByMoveOperation(e)
            const o = i.path.slice()
            o.push(0)
            const r = new qp(i.root, o)
            const s = new Tw(n, t.howMany, r, 0)
            return [s]
          }
          t.graveyardPosition =
            t.graveyardPosition._getTransformedByMoveOperation(e)
        }
        const o = t.splitPosition.isEqual(e.targetPosition)
        if (
          o &&
          (n.baRelation == 'insertAtSource' || n.abRelation == 'splitBefore')
        ) {
          t.howMany += e.howMany
          t.splitPosition = t.splitPosition._getTransformedByDeletion(
            e.sourcePosition,
            e.howMany
          )
          t.insertionPosition = Rw.getInsertionPosition(t.splitPosition)
          return [t]
        }
        if (o && n.abRelation && n.abRelation.howMany) {
          const { howMany: e, offset: i } = n.abRelation
          t.howMany += e
          t.splitPosition = t.splitPosition.getShiftedBy(i)
          return [t]
        }
        if (
          t.splitPosition.hasSameParentAs(e.sourcePosition) &&
          i.containsPosition(t.splitPosition)
        ) {
          const n =
            e.howMany - (t.splitPosition.offset - e.sourcePosition.offset)
          t.howMany -= n
          if (
            t.splitPosition.hasSameParentAs(e.targetPosition) &&
            t.splitPosition.offset < e.targetPosition.offset
          ) {
            t.howMany += e.howMany
          }
          t.splitPosition = e.sourcePosition.clone()
          t.insertionPosition = Rw.getInsertionPosition(t.splitPosition)
          return [t]
        }
        if (!e.sourcePosition.isEqual(e.targetPosition)) {
          if (
            t.splitPosition.hasSameParentAs(e.sourcePosition) &&
            t.splitPosition.offset <= e.sourcePosition.offset
          ) {
            t.howMany -= e.howMany
          }
          if (
            t.splitPosition.hasSameParentAs(e.targetPosition) &&
            t.splitPosition.offset < e.targetPosition.offset
          ) {
            t.howMany += e.howMany
          }
        }
        t.splitPosition.stickiness = 'toNone'
        t.splitPosition = t.splitPosition._getTransformedByMoveOperation(e)
        t.splitPosition.stickiness = 'toNext'
        if (t.graveyardPosition) {
          t.insertionPosition =
            t.insertionPosition._getTransformedByMoveOperation(e)
        } else {
          t.insertionPosition = Rw.getInsertionPosition(t.splitPosition)
        }
        return [t]
      })
      Hw(Rw, Rw, (t, e, n) => {
        if (t.splitPosition.isEqual(e.splitPosition)) {
          if (!t.graveyardPosition && !e.graveyardPosition) {
            return [new Pw(0)]
          }
          if (
            t.graveyardPosition &&
            e.graveyardPosition &&
            t.graveyardPosition.isEqual(e.graveyardPosition)
          ) {
            return [new Pw(0)]
          }
          if (n.abRelation == 'splitBefore') {
            t.howMany = 0
            t.graveyardPosition =
              t.graveyardPosition._getTransformedBySplitOperation(e)
            return [t]
          }
        }
        if (
          t.graveyardPosition &&
          e.graveyardPosition &&
          t.graveyardPosition.isEqual(e.graveyardPosition)
        ) {
          const i = t.splitPosition.root.rootName == '$graveyard'
          const o = e.splitPosition.root.rootName == '$graveyard'
          const r = i && !o
          const s = o && !i
          const a = s || (!r && n.aIsStrong)
          if (a) {
            const n = []
            if (e.howMany) {
              n.push(
                new Tw(e.moveTargetPosition, e.howMany, e.splitPosition, 0)
              )
            }
            if (t.howMany) {
              n.push(
                new Tw(t.splitPosition, t.howMany, t.moveTargetPosition, 0)
              )
            }
            return n
          } else {
            return [new Pw(0)]
          }
        }
        if (t.graveyardPosition) {
          t.graveyardPosition =
            t.graveyardPosition._getTransformedBySplitOperation(e)
        }
        if (
          t.splitPosition.isEqual(e.insertionPosition) &&
          n.abRelation == 'splitBefore'
        ) {
          t.howMany++
          return [t]
        }
        if (
          e.splitPosition.isEqual(t.insertionPosition) &&
          n.baRelation == 'splitBefore'
        ) {
          const n = e.insertionPosition.path.slice()
          n.push(0)
          const i = new qp(e.insertionPosition.root, n)
          const o = new Tw(t.insertionPosition, 1, i, 0)
          return [t, o]
        }
        if (
          t.splitPosition.hasSameParentAs(e.splitPosition) &&
          t.splitPosition.offset < e.splitPosition.offset
        ) {
          t.howMany -= e.howMany
        }
        t.splitPosition = t.splitPosition._getTransformedBySplitOperation(e)
        t.insertionPosition = Rw.getInsertionPosition(t.splitPosition)
        return [t]
      })
      function Jw(t, e) {
        return (
          t.targetPosition._getTransformedByDeletion(
            e.sourcePosition,
            e.howMany
          ) === null
        )
      }
      function Xw(t, e) {
        const n = []
        for (let i = 0; i < t.length; i++) {
          const o = t[i]
          const r = new Tw(o.start, o.end.offset - o.start.offset, e, 0)
          n.push(r)
          for (let e = i + 1; e < t.length; e++) {
            t[e] = t[e]._getTransformedByMove(
              r.sourcePosition,
              r.targetPosition,
              r.howMany
            )[0]
          }
          e = e._getTransformedByMove(
            r.sourcePosition,
            r.targetPosition,
            r.howMany
          )
        }
        return n
      }
      class t_ extends $(qp) {
        constructor(t, e, n = 'toNone') {
          super(t, e, n)
          if (!this.root.is('rootElement')) {
            throw new N('model-liveposition-root-not-rootelement', t)
          }
          e_.call(this)
        }
        detach() {
          this.stopListening()
        }
        toPosition() {
          return new qp(this.root, this.path.slice(), this.stickiness)
        }
        static fromPosition(t, e) {
          return new this(t.root, t.path.slice(), e ? e : t.stickiness)
        }
      }
      t_.prototype.is = function (t) {
        return (
          t === 'livePosition' ||
          t === 'model:livePosition' ||
          t == 'position' ||
          t === 'model:position'
        )
      }
      function e_() {
        this.listenTo(
          this.root.document.model,
          'applyOperation',
          (t, e) => {
            const n = e[0]
            if (!n.isDocumentOperation) {
              return
            }
            n_.call(this, n)
          },
          { priority: 'low' }
        )
      }
      function n_(t) {
        const e = this.getTransformedByOperation(t)
        if (!this.isEqual(e)) {
          const t = this.toPosition()
          this.path = e.path
          this.root = e.root
          this.fire('change', t)
        }
      }
      class i_ {
        constructor(t = {}) {
          if (typeof t === 'string') {
            t = t === 'transparent' ? { isUndoable: false } : {}
            P('batch-constructor-deprecated-string-type')
          }
          const {
            isUndoable: e = true,
            isLocal: n = true,
            isUndo: i = false,
            isTyping: o = false
          } = t
          this.operations = []
          this.isUndoable = e
          this.isLocal = n
          this.isUndo = i
          this.isTyping = o
        }
        get type() {
          P('batch-type-deprecated')
          return 'default'
        }
        get baseVersion() {
          for (const t of this.operations) {
            if (t.baseVersion !== null) {
              return t.baseVersion
            }
          }
          return null
        }
        addOperation(t) {
          t.batch = this
          this.operations.push(t)
          return t
        }
      }
      class o_ {
        constructor(t) {
          this._changesInElement = new Map()
          this._elementSnapshots = new Map()
          this._changedMarkers = new Map()
          this._changeCount = 0
          this._cachedChanges = null
          this._cachedChangesWithGraveyard = null
          this._refreshedItems = new Set()
          this._markerCollection = t
        }
        get isEmpty() {
          return (
            this._changesInElement.size == 0 && this._changedMarkers.size == 0
          )
        }
        bufferOperation(t) {
          const e = t
          switch (e.type) {
            case 'insert': {
              if (this._isInInsertedElement(e.position.parent)) {
                return
              }
              this._markInsert(
                e.position.parent,
                e.position.offset,
                e.nodes.maxOffset
              )
              break
            }
            case 'addAttribute':
            case 'removeAttribute':
            case 'changeAttribute': {
              for (const t of e.range.getItems({ shallow: true })) {
                if (this._isInInsertedElement(t.parent)) {
                  continue
                }
                this._markAttribute(t)
              }
              break
            }
            case 'remove':
            case 'move':
            case 'reinsert': {
              if (
                e.sourcePosition.isEqual(e.targetPosition) ||
                e.sourcePosition
                  .getShiftedBy(e.howMany)
                  .isEqual(e.targetPosition)
              ) {
                return
              }
              const t = this._isInInsertedElement(e.sourcePosition.parent)
              const n = this._isInInsertedElement(e.targetPosition.parent)
              if (!t) {
                this._markRemove(
                  e.sourcePosition.parent,
                  e.sourcePosition.offset,
                  e.howMany
                )
              }
              if (!n) {
                this._markInsert(
                  e.targetPosition.parent,
                  e.getMovedRangeStart().offset,
                  e.howMany
                )
              }
              break
            }
            case 'rename': {
              if (this._isInInsertedElement(e.position.parent)) {
                return
              }
              this._markRemove(e.position.parent, e.position.offset, 1)
              this._markInsert(e.position.parent, e.position.offset, 1)
              const t = Jp._createFromPositionAndShift(e.position, 1)
              for (const e of this._markerCollection.getMarkersIntersectingRange(
                t
              )) {
                const t = e.getData()
                this.bufferMarkerChange(e.name, t, t)
              }
              break
            }
            case 'split': {
              const t = e.splitPosition.parent
              if (!this._isInInsertedElement(t)) {
                this._markRemove(t, e.splitPosition.offset, e.howMany)
              }
              if (!this._isInInsertedElement(e.insertionPosition.parent)) {
                this._markInsert(
                  e.insertionPosition.parent,
                  e.insertionPosition.offset,
                  1
                )
              }
              if (e.graveyardPosition) {
                this._markRemove(
                  e.graveyardPosition.parent,
                  e.graveyardPosition.offset,
                  1
                )
              }
              break
            }
            case 'merge': {
              const t = e.sourcePosition.parent
              if (!this._isInInsertedElement(t.parent)) {
                this._markRemove(t.parent, t.startOffset, 1)
              }
              const n = e.graveyardPosition.parent
              this._markInsert(n, e.graveyardPosition.offset, 1)
              const i = e.targetPosition.parent
              if (!this._isInInsertedElement(i)) {
                this._markInsert(i, e.targetPosition.offset, t.maxOffset)
              }
              break
            }
          }
          this._cachedChanges = null
        }
        bufferMarkerChange(t, e, n) {
          const i = this._changedMarkers.get(t)
          if (!i) {
            this._changedMarkers.set(t, { newMarkerData: n, oldMarkerData: e })
          } else {
            i.newMarkerData = n
            if (i.oldMarkerData.range == null && n.range == null) {
              this._changedMarkers.delete(t)
            }
          }
        }
        getMarkersToRemove() {
          const t = []
          for (const [e, n] of this._changedMarkers) {
            if (n.oldMarkerData.range != null) {
              t.push({ name: e, range: n.oldMarkerData.range })
            }
          }
          return t
        }
        getMarkersToAdd() {
          const t = []
          for (const [e, n] of this._changedMarkers) {
            if (n.newMarkerData.range != null) {
              t.push({ name: e, range: n.newMarkerData.range })
            }
          }
          return t
        }
        getChangedMarkers() {
          return Array.from(this._changedMarkers).map(([t, e]) => ({
            name: t,
            data: {
              oldRange: e.oldMarkerData.range,
              newRange: e.newMarkerData.range
            }
          }))
        }
        hasDataChanges() {
          if (this._changesInElement.size > 0) {
            return true
          }
          for (const {
            newMarkerData: t,
            oldMarkerData: e
          } of this._changedMarkers.values()) {
            if (t.affectsData !== e.affectsData) {
              return true
            }
            if (t.affectsData) {
              const n = t.range && !e.range
              const i = !t.range && e.range
              const o = t.range && e.range && !t.range.isEqual(e.range)
              if (n || i || o) {
                return true
              }
            }
          }
          return false
        }
        getChanges(t = {}) {
          if (this._cachedChanges) {
            if (t.includeChangesInGraveyard) {
              return this._cachedChangesWithGraveyard.slice()
            } else {
              return this._cachedChanges.slice()
            }
          }
          let e = []
          for (const t of this._changesInElement.keys()) {
            const n = this._changesInElement.get(t).sort((t, e) => {
              if (t.offset === e.offset) {
                if (t.type != e.type) {
                  return t.type == 'remove' ? -1 : 1
                }
                return 0
              }
              return t.offset < e.offset ? -1 : 1
            })
            const i = this._elementSnapshots.get(t)
            const o = r_(t.getChildren())
            const r = s_(i.length, n)
            let s = 0
            let a = 0
            for (const n of r) {
              if (n === 'i') {
                e.push(this._getInsertDiff(t, s, o[s]))
                s++
              } else if (n === 'r') {
                e.push(this._getRemoveDiff(t, s, i[a]))
                a++
              } else if (n === 'a') {
                const n = o[s].attributes
                const r = i[a].attributes
                let c
                if (o[s].name == '$text') {
                  c = new Jp(qp._createAt(t, s), qp._createAt(t, s + 1))
                } else {
                  const e = t.offsetToIndex(s)
                  c = new Jp(qp._createAt(t, s), qp._createAt(t.getChild(e), 0))
                }
                e.push(...this._getAttributesDiff(c, r, n))
                s++
                a++
              } else {
                s++
                a++
              }
            }
          }
          e.sort((t, e) => {
            if (t.position.root != e.position.root) {
              return t.position.root.rootName < e.position.root.rootName
                ? -1
                : 1
            }
            if (t.position.isEqual(e.position)) {
              return t.changeCount - e.changeCount
            }
            return t.position.isBefore(e.position) ? -1 : 1
          })
          for (let t = 1, n = 0; t < e.length; t++) {
            const i = e[n]
            const o = e[t]
            const r =
              i.type == 'remove' &&
              o.type == 'remove' &&
              i.name == '$text' &&
              o.name == '$text' &&
              i.position.isEqual(o.position)
            const s =
              i.type == 'insert' &&
              o.type == 'insert' &&
              i.name == '$text' &&
              o.name == '$text' &&
              i.position.parent == o.position.parent &&
              i.position.offset + i.length == o.position.offset
            const a =
              i.type == 'attribute' &&
              o.type == 'attribute' &&
              i.position.parent == o.position.parent &&
              i.range.isFlat &&
              o.range.isFlat &&
              i.position.offset + i.length == o.position.offset &&
              i.attributeKey == o.attributeKey &&
              i.attributeOldValue == o.attributeOldValue &&
              i.attributeNewValue == o.attributeNewValue
            if (r || s || a) {
              i.length++
              if (a) {
                i.range.end = i.range.end.getShiftedBy(1)
              }
              e[t] = null
            } else {
              n = t
            }
          }
          e = e.filter((t) => t)
          for (const t of e) {
            delete t.changeCount
            if (t.type == 'attribute') {
              delete t.position
              delete t.length
            }
          }
          this._changeCount = 0
          this._cachedChangesWithGraveyard = e
          this._cachedChanges = e.filter(a_)
          if (t.includeChangesInGraveyard) {
            return this._cachedChangesWithGraveyard.slice()
          } else {
            return this._cachedChanges.slice()
          }
        }
        getRefreshedItems() {
          return new Set(this._refreshedItems)
        }
        reset() {
          this._changesInElement.clear()
          this._elementSnapshots.clear()
          this._changedMarkers.clear()
          this._refreshedItems = new Set()
          this._cachedChanges = null
        }
        _refreshItem(t) {
          if (this._isInInsertedElement(t.parent)) {
            return
          }
          this._markRemove(t.parent, t.startOffset, t.offsetSize)
          this._markInsert(t.parent, t.startOffset, t.offsetSize)
          this._refreshedItems.add(t)
          const e = Jp._createOn(t)
          for (const t of this._markerCollection.getMarkersIntersectingRange(
            e
          )) {
            const e = t.getData()
            this.bufferMarkerChange(t.name, e, e)
          }
          this._cachedChanges = null
        }
        _markInsert(t, e, n) {
          const i = {
            type: 'insert',
            offset: e,
            howMany: n,
            count: this._changeCount++
          }
          this._markChange(t, i)
        }
        _markRemove(t, e, n) {
          const i = {
            type: 'remove',
            offset: e,
            howMany: n,
            count: this._changeCount++
          }
          this._markChange(t, i)
          this._removeAllNestedChanges(t, e, n)
        }
        _markAttribute(t) {
          const e = {
            type: 'attribute',
            offset: t.startOffset,
            howMany: t.offsetSize,
            count: this._changeCount++
          }
          this._markChange(t.parent, e)
        }
        _markChange(t, e) {
          this._makeSnapshot(t)
          const n = this._getChangesForElement(t)
          this._handleChange(e, n)
          n.push(e)
          for (let t = 0; t < n.length; t++) {
            if (n[t].howMany < 1) {
              n.splice(t, 1)
              t--
            }
          }
        }
        _getChangesForElement(t) {
          let e
          if (this._changesInElement.has(t)) {
            e = this._changesInElement.get(t)
          } else {
            e = []
            this._changesInElement.set(t, e)
          }
          return e
        }
        _makeSnapshot(t) {
          if (!this._elementSnapshots.has(t)) {
            this._elementSnapshots.set(t, r_(t.getChildren()))
          }
        }
        _handleChange(t, e) {
          t.nodesToHandle = t.howMany
          for (const n of e) {
            const i = t.offset + t.howMany
            const o = n.offset + n.howMany
            if (t.type == 'insert') {
              if (n.type == 'insert') {
                if (t.offset <= n.offset) {
                  n.offset += t.howMany
                } else if (t.offset < o) {
                  n.howMany += t.nodesToHandle
                  t.nodesToHandle = 0
                }
              }
              if (n.type == 'remove') {
                if (t.offset < n.offset) {
                  n.offset += t.howMany
                }
              }
              if (n.type == 'attribute') {
                if (t.offset <= n.offset) {
                  n.offset += t.howMany
                } else if (t.offset < o) {
                  const o = n.howMany
                  n.howMany = t.offset - n.offset
                  e.unshift({
                    type: 'attribute',
                    offset: i,
                    howMany: o - n.howMany,
                    count: this._changeCount++
                  })
                }
              }
            }
            if (t.type == 'remove') {
              if (n.type == 'insert') {
                if (i <= n.offset) {
                  n.offset -= t.howMany
                } else if (i <= o) {
                  if (t.offset < n.offset) {
                    const e = i - n.offset
                    n.offset = t.offset
                    n.howMany -= e
                    t.nodesToHandle -= e
                  } else {
                    n.howMany -= t.nodesToHandle
                    t.nodesToHandle = 0
                  }
                } else {
                  if (t.offset <= n.offset) {
                    t.nodesToHandle -= n.howMany
                    n.howMany = 0
                  } else if (t.offset < o) {
                    const e = o - t.offset
                    n.howMany -= e
                    t.nodesToHandle -= e
                  }
                }
              }
              if (n.type == 'remove') {
                if (i <= n.offset) {
                  n.offset -= t.howMany
                } else if (t.offset < n.offset) {
                  t.nodesToHandle += n.howMany
                  n.howMany = 0
                }
              }
              if (n.type == 'attribute') {
                if (i <= n.offset) {
                  n.offset -= t.howMany
                } else if (t.offset < n.offset) {
                  const e = i - n.offset
                  n.offset = t.offset
                  n.howMany -= e
                } else if (t.offset < o) {
                  if (i <= o) {
                    const i = n.howMany
                    n.howMany = t.offset - n.offset
                    const o = i - n.howMany - t.nodesToHandle
                    e.unshift({
                      type: 'attribute',
                      offset: t.offset,
                      howMany: o,
                      count: this._changeCount++
                    })
                  } else {
                    n.howMany -= o - t.offset
                  }
                }
              }
            }
            if (t.type == 'attribute') {
              if (n.type == 'insert') {
                if (t.offset < n.offset && i > n.offset) {
                  if (i > o) {
                    const t = {
                      type: 'attribute',
                      offset: o,
                      howMany: i - o,
                      count: this._changeCount++
                    }
                    this._handleChange(t, e)
                    e.push(t)
                  }
                  t.nodesToHandle = n.offset - t.offset
                  t.howMany = t.nodesToHandle
                } else if (t.offset >= n.offset && t.offset < o) {
                  if (i > o) {
                    t.nodesToHandle = i - o
                    t.offset = o
                  } else {
                    t.nodesToHandle = 0
                  }
                }
              }
              if (n.type == 'remove') {
                if (t.offset < n.offset && i > n.offset) {
                  const o = {
                    type: 'attribute',
                    offset: n.offset,
                    howMany: i - n.offset,
                    count: this._changeCount++
                  }
                  this._handleChange(o, e)
                  e.push(o)
                  t.nodesToHandle = n.offset - t.offset
                  t.howMany = t.nodesToHandle
                }
              }
              if (n.type == 'attribute') {
                if (t.offset >= n.offset && i <= o) {
                  t.nodesToHandle = 0
                  t.howMany = 0
                  t.offset = 0
                } else if (t.offset <= n.offset && i >= o) {
                  n.howMany = 0
                }
              }
            }
          }
          t.howMany = t.nodesToHandle
          delete t.nodesToHandle
        }
        _getInsertDiff(t, e, n) {
          return {
            type: 'insert',
            position: qp._createAt(t, e),
            name: n.name,
            attributes: new Map(n.attributes),
            length: 1,
            changeCount: this._changeCount++
          }
        }
        _getRemoveDiff(t, e, n) {
          return {
            type: 'remove',
            position: qp._createAt(t, e),
            name: n.name,
            attributes: new Map(n.attributes),
            length: 1,
            changeCount: this._changeCount++
          }
        }
        _getAttributesDiff(t, e, n) {
          const i = []
          n = new Map(n)
          for (const [o, r] of e) {
            const e = n.has(o) ? n.get(o) : null
            if (e !== r) {
              i.push({
                type: 'attribute',
                position: t.start,
                range: t.clone(),
                length: 1,
                attributeKey: o,
                attributeOldValue: r,
                attributeNewValue: e,
                changeCount: this._changeCount++
              })
            }
            n.delete(o)
          }
          for (const [e, o] of n) {
            i.push({
              type: 'attribute',
              position: t.start,
              range: t.clone(),
              length: 1,
              attributeKey: e,
              attributeOldValue: null,
              attributeNewValue: o,
              changeCount: this._changeCount++
            })
          }
          return i
        }
        _isInInsertedElement(t) {
          const e = t.parent
          if (!e) {
            return false
          }
          const n = this._changesInElement.get(e)
          const i = t.startOffset
          if (n) {
            for (const t of n) {
              if (
                t.type == 'insert' &&
                i >= t.offset &&
                i < t.offset + t.howMany
              ) {
                return true
              }
            }
          }
          return this._isInInsertedElement(e)
        }
        _removeAllNestedChanges(t, e, n) {
          const i = new Jp(qp._createAt(t, e), qp._createAt(t, e + n))
          for (const t of i.getItems({ shallow: true })) {
            if (t.is('element')) {
              this._elementSnapshots.delete(t)
              this._changesInElement.delete(t)
              this._removeAllNestedChanges(t, 0, t.maxOffset)
            }
          }
        }
      }
      function r_(t) {
        const e = []
        for (const n of t) {
          if (n.is('$text')) {
            for (let t = 0; t < n.data.length; t++) {
              e.push({ name: '$text', attributes: new Map(n.getAttributes()) })
            }
          } else {
            e.push({ name: n.name, attributes: new Map(n.getAttributes()) })
          }
        }
        return e
      }
      function s_(t, e) {
        const n = []
        let i = 0
        let o = 0
        for (const t of e) {
          if (t.offset > i) {
            for (let e = 0; e < t.offset - i; e++) {
              n.push('e')
            }
            o += t.offset - i
          }
          if (t.type == 'insert') {
            for (let e = 0; e < t.howMany; e++) {
              n.push('i')
            }
            i = t.offset + t.howMany
          } else if (t.type == 'remove') {
            for (let e = 0; e < t.howMany; e++) {
              n.push('r')
            }
            i = t.offset
            o += t.howMany
          } else {
            n.push(...'a'.repeat(t.howMany).split(''))
            i = t.offset + t.howMany
            o += t.howMany
          }
        }
        if (o < t) {
          for (let e = 0; e < t - o - i; e++) {
            n.push('e')
          }
        }
        return n
      }
      function a_(t) {
        const e = 'position' in t && t.position.root.rootName == '$graveyard'
        const n = 'range' in t && t.range.root.rootName == '$graveyard'
        return !e && !n
      }
      class c_ {
        constructor() {
          this._operations = []
          this._undoPairs = new Map()
          this._undoneOperations = new Set()
          this._baseVersionToOperationIndex = new Map()
          this._version = 0
          this._gaps = new Map()
        }
        get version() {
          return this._version
        }
        set version(t) {
          if (this._operations.length && t > this._version + 1) {
            this._gaps.set(this._version, t)
          }
          this._version = t
        }
        get lastOperation() {
          return this._operations[this._operations.length - 1]
        }
        addOperation(t) {
          if (t.baseVersion !== this.version) {
            throw new N(
              'model-document-history-addoperation-incorrect-version',
              this,
              { operation: t, historyVersion: this.version }
            )
          }
          this._operations.push(t)
          this._version++
          this._baseVersionToOperationIndex.set(
            t.baseVersion,
            this._operations.length - 1
          )
        }
        getOperations(t, e = this.version) {
          if (!this._operations.length) {
            return []
          }
          const n = this._operations[0]
          if (t === undefined) {
            t = n.baseVersion
          }
          let i = e - 1
          for (const [e, n] of this._gaps) {
            if (t > e && t < n) {
              t = n
            }
            if (i > e && i < n) {
              i = e - 1
            }
          }
          if (i < n.baseVersion || t > this.lastOperation.baseVersion) {
            return []
          }
          let o = this._baseVersionToOperationIndex.get(t)
          if (o === undefined) {
            o = 0
          }
          let r = this._baseVersionToOperationIndex.get(i)
          if (r === undefined) {
            r = this._operations.length - 1
          }
          return this._operations.slice(o, r + 1)
        }
        getOperation(t) {
          const e = this._baseVersionToOperationIndex.get(t)
          if (e === undefined) {
            return
          }
          return this._operations[e]
        }
        setOperationAsUndone(t, e) {
          this._undoPairs.set(e, t)
          this._undoneOperations.add(t)
        }
        isUndoingOperation(t) {
          return this._undoPairs.has(t)
        }
        isUndoneOperation(t) {
          return this._undoneOperations.has(t)
        }
        getUndoneOperation(t) {
          return this._undoPairs.get(t)
        }
        reset() {
          this._version = 0
          this._undoPairs = new Map()
          this._operations = []
          this._undoneOperations = new Set()
          this._gaps = new Map()
          this._baseVersionToOperationIndex = new Map()
        }
      }
      class l_ extends Vp {
        constructor(t, e, n = 'main') {
          super(e)
          this._document = t
          this.rootName = n
        }
        get document() {
          return this._document
        }
        toJSON() {
          return this.rootName
        }
      }
      l_.prototype.is = function (t, e) {
        if (!e) {
          return (
            t === 'rootElement' ||
            t === 'model:rootElement' ||
            t === 'element' ||
            t === 'model:element' ||
            t === 'node' ||
            t === 'model:node'
          )
        }
        return (
          e === this.name &&
          (t === 'rootElement' ||
            t === 'model:rootElement' ||
            t === 'element' ||
            t === 'model:element')
        )
      }
      const d_ = '$graveyard'
      class u_ extends $() {
        constructor(t) {
          super()
          this.model = t
          this.history = new c_()
          this.selection = new bb(this)
          this.roots = new al({ idProperty: 'rootName' })
          this.differ = new o_(t.markers)
          this._postFixers = new Set()
          this._hasSelectionChangedFromTheLastChangeBlock = false
          this.createRoot('$root', d_)
          this.listenTo(
            t,
            'applyOperation',
            (t, e) => {
              const n = e[0]
              if (n.isDocumentOperation) {
                this.differ.bufferOperation(n)
              }
            },
            { priority: 'high' }
          )
          this.listenTo(
            t,
            'applyOperation',
            (t, e) => {
              const n = e[0]
              if (n.isDocumentOperation) {
                this.history.addOperation(n)
              }
            },
            { priority: 'low' }
          )
          this.listenTo(this.selection, 'change', () => {
            this._hasSelectionChangedFromTheLastChangeBlock = true
          })
          this.listenTo(t.markers, 'update', (t, e, n, i, o) => {
            const r = { ...e.getData(), range: i }
            this.differ.bufferMarkerChange(e.name, o, r)
            if (n === null) {
              e.on('change', (t, n) => {
                const i = e.getData()
                this.differ.bufferMarkerChange(e.name, { ...i, range: n }, i)
              })
            }
          })
        }
        get version() {
          return this.history.version
        }
        set version(t) {
          this.history.version = t
        }
        get graveyard() {
          return this.getRoot(d_)
        }
        createRoot(t = '$root', e = 'main') {
          if (this.roots.get(e)) {
            throw new N('model-document-createroot-name-exists', this, {
              name: e
            })
          }
          const n = new l_(this, t, e)
          this.roots.add(n)
          return n
        }
        destroy() {
          this.selection.destroy()
          this.stopListening()
        }
        getRoot(t = 'main') {
          return this.roots.get(t)
        }
        getRootNames() {
          return Array.from(this.roots, (t) => t.rootName).filter(
            (t) => t != d_
          )
        }
        registerPostFixer(t) {
          this._postFixers.add(t)
        }
        toJSON() {
          const t = wu(this)
          t.selection = '[engine.model.DocumentSelection]'
          t.model = '[engine.model.Model]'
          return t
        }
        _handleChangeBlock(t) {
          if (this._hasDocumentChangedFromTheLastChangeBlock()) {
            this._callPostFixers(t)
            this.selection.refresh()
            if (this.differ.hasDataChanges()) {
              this.fire('change:data', t.batch)
            } else {
              this.fire('change', t.batch)
            }
            this.selection.refresh()
            this.differ.reset()
          }
          this._hasSelectionChangedFromTheLastChangeBlock = false
        }
        _hasDocumentChangedFromTheLastChangeBlock() {
          return (
            !this.differ.isEmpty ||
            this._hasSelectionChangedFromTheLastChangeBlock
          )
        }
        _getDefaultRoot() {
          for (const t of this.roots) {
            if (t !== this.graveyard) {
              return t
            }
          }
          return this.graveyard
        }
        _getDefaultRange() {
          const t = this._getDefaultRoot()
          const e = this.model
          const n = e.schema
          const i = e.createPositionFromPath(t, [0])
          const o = n.getNearestSelectionRange(i)
          return o || e.createRange(i)
        }
        _validateSelectionRange(t) {
          return h_(t.start) && h_(t.end)
        }
        _callPostFixers(t) {
          let e = false
          do {
            for (const n of this._postFixers) {
              this.selection.refresh()
              e = n(t)
              if (e) {
                break
              }
            }
          } while (e)
        }
      }
      function h_(t) {
        const e = t.textNode
        if (e) {
          const n = e.data
          const i = t.offset - e.startOffset
          return !kl(n, i) && !wl(n, i)
        }
        return true
      }
      class f_ extends $() {
        constructor() {
          super(...arguments)
          this._markers = new Map()
        }
        [Symbol.iterator]() {
          return this._markers.values()
        }
        has(t) {
          const e = t instanceof m_ ? t.name : t
          return this._markers.has(e)
        }
        get(t) {
          return this._markers.get(t) || null
        }
        _set(t, e, n = false, i = false) {
          const o = t instanceof m_ ? t.name : t
          if (o.includes(',')) {
            throw new N('markercollection-incorrect-marker-name', this)
          }
          const r = this._markers.get(o)
          if (r) {
            const t = r.getData()
            const s = r.getRange()
            let a = false
            if (!s.isEqual(e)) {
              r._attachLiveRange(hb.fromRange(e))
              a = true
            }
            if (n != r.managedUsingOperations) {
              r._managedUsingOperations = n
              a = true
            }
            if (typeof i === 'boolean' && i != r.affectsData) {
              r._affectsData = i
              a = true
            }
            if (a) {
              this.fire(`update:${o}`, r, s, e, t)
            }
            return r
          }
          const s = hb.fromRange(e)
          const a = new m_(o, s, n, i)
          this._markers.set(o, a)
          this.fire(`update:${o}`, a, null, e, { ...a.getData(), range: null })
          return a
        }
        _remove(t) {
          const e = t instanceof m_ ? t.name : t
          const n = this._markers.get(e)
          if (n) {
            this._markers.delete(e)
            this.fire(`update:${e}`, n, n.getRange(), null, n.getData())
            this._destroyMarker(n)
            return true
          }
          return false
        }
        _refresh(t) {
          const e = t instanceof m_ ? t.name : t
          const n = this._markers.get(e)
          if (!n) {
            throw new N('markercollection-refresh-marker-not-exists', this)
          }
          const i = n.getRange()
          this.fire(`update:${e}`, n, i, i, n.getData())
        }
        *getMarkersAtPosition(t) {
          for (const e of this) {
            if (e.getRange().containsPosition(t)) {
              yield e
            }
          }
        }
        *getMarkersIntersectingRange(t) {
          for (const e of this) {
            if (e.getRange().getIntersection(t) !== null) {
              yield e
            }
          }
        }
        destroy() {
          for (const t of this._markers.values()) {
            this._destroyMarker(t)
          }
          this._markers = null
          this.stopListening()
        }
        *getMarkersGroup(t) {
          for (const e of this._markers.values()) {
            if (e.name.startsWith(t + ':')) {
              yield e
            }
          }
        }
        _destroyMarker(t) {
          t.stopListening()
          t._detachLiveRange()
        }
      }
      class m_ extends $(Lp) {
        constructor(t, e, n, i) {
          super()
          this.name = t
          this._liveRange = this._attachLiveRange(e)
          this._managedUsingOperations = n
          this._affectsData = i
        }
        get managedUsingOperations() {
          if (!this._liveRange) {
            throw new N('marker-destroyed', this)
          }
          return this._managedUsingOperations
        }
        get affectsData() {
          if (!this._liveRange) {
            throw new N('marker-destroyed', this)
          }
          return this._affectsData
        }
        getData() {
          return {
            range: this.getRange(),
            affectsData: this.affectsData,
            managedUsingOperations: this.managedUsingOperations
          }
        }
        getStart() {
          if (!this._liveRange) {
            throw new N('marker-destroyed', this)
          }
          return this._liveRange.start.clone()
        }
        getEnd() {
          if (!this._liveRange) {
            throw new N('marker-destroyed', this)
          }
          return this._liveRange.end.clone()
        }
        getRange() {
          if (!this._liveRange) {
            throw new N('marker-destroyed', this)
          }
          return this._liveRange.toRange()
        }
        _attachLiveRange(t) {
          if (this._liveRange) {
            this._detachLiveRange()
          }
          t.delegate('change:range').to(this)
          t.delegate('change:content').to(this)
          this._liveRange = t
          return t
        }
        _detachLiveRange() {
          this._liveRange.stopDelegating('change:range', this)
          this._liveRange.stopDelegating('change:content', this)
          this._liveRange.detach()
          this._liveRange = null
        }
      }
      m_.prototype.is = function (t) {
        return t === 'marker' || t === 'model:marker'
      }
      class g_ extends ww {
        constructor(t, e) {
          super(null)
          this.sourcePosition = t.clone()
          this.howMany = e
        }
        get type() {
          return 'detach'
        }
        toJSON() {
          const t = super.toJSON()
          t.sourcePosition = this.sourcePosition.toJSON()
          return t
        }
        _validate() {
          if (this.sourcePosition.root.document) {
            throw new N('detach-operation-on-document-node', this)
          }
        }
        _execute() {
          Aw(Jp._createFromPositionAndShift(this.sourcePosition, this.howMany))
        }
        static get className() {
          return 'DetachOperation'
        }
      }
      class p_ extends Lp {
        constructor(t) {
          super()
          this.markers = new Map()
          this._children = new Rp()
          if (t) {
            this._insertChild(0, t)
          }
        }
        [Symbol.iterator]() {
          return this.getChildren()
        }
        get childCount() {
          return this._children.length
        }
        get maxOffset() {
          return this._children.maxOffset
        }
        get isEmpty() {
          return this.childCount === 0
        }
        get nextSibling() {
          return null
        }
        get previousSibling() {
          return null
        }
        get root() {
          return this
        }
        get parent() {
          return null
        }
        get document() {
          return null
        }
        getAncestors() {
          return []
        }
        getChild(t) {
          return this._children.getNode(t)
        }
        getChildren() {
          return this._children[Symbol.iterator]()
        }
        getChildIndex(t) {
          return this._children.getNodeIndex(t)
        }
        getChildStartOffset(t) {
          return this._children.getNodeStartOffset(t)
        }
        getPath() {
          return []
        }
        getNodeByPath(t) {
          let e = this
          for (const n of t) {
            e = e.getChild(e.offsetToIndex(n))
          }
          return e
        }
        offsetToIndex(t) {
          return this._children.offsetToIndex(t)
        }
        toJSON() {
          const t = []
          for (const e of this._children) {
            t.push(e.toJSON())
          }
          return t
        }
        static fromJSON(t) {
          const e = []
          for (const n of t) {
            if (n.name) {
              e.push(Vp.fromJSON(n))
            } else {
              e.push(jp.fromJSON(n))
            }
          }
          return new p_(e)
        }
        _appendChild(t) {
          this._insertChild(this.childCount, t)
        }
        _insertChild(t, e) {
          const n = b_(e)
          for (const t of n) {
            if (t.parent !== null) {
              t._remove()
            }
            t.parent = this
          }
          this._children._insertNodes(t, n)
        }
        _removeChildren(t, e = 1) {
          const n = this._children._removeNodes(t, e)
          for (const t of n) {
            t.parent = null
          }
          return n
        }
      }
      p_.prototype.is = function (t) {
        return t === 'documentFragment' || t === 'model:documentFragment'
      }
      function b_(t) {
        if (typeof t == 'string') {
          return [new jp(t)]
        }
        if (!Et(t)) {
          t = [t]
        }
        return Array.from(t).map((t) => {
          if (typeof t == 'string') {
            return new jp(t)
          }
          if (t instanceof Fp) {
            return new jp(t.data, t.getAttributes())
          }
          return t
        })
      }
      class k_ {
        constructor(t, e) {
          this.model = t
          this.batch = e
        }
        createText(t, e) {
          return new jp(t, e)
        }
        createElement(t, e) {
          return new Vp(t, e)
        }
        createDocumentFragment() {
          return new p_()
        }
        cloneElement(t, e = true) {
          return t._clone(e)
        }
        insert(t, e, n = 0) {
          this._assertWriterUsedCorrectly()
          if (t instanceof jp && t.data == '') {
            return
          }
          const i = qp._createAt(e, n)
          if (t.parent) {
            if (C_(t.root, i.root)) {
              this.move(Jp._createOn(t), i)
              return
            } else {
              if (t.root.document) {
                throw new N('model-writer-insert-forbidden-move', this)
              } else {
                this.remove(t)
              }
            }
          }
          const o = i.root.document ? i.root.document.version : null
          const r = new Mw(i, t, o)
          if (t instanceof jp) {
            r.shouldReceiveAttributes = true
          }
          this.batch.addOperation(r)
          this.model.applyOperation(r)
          if (t instanceof p_) {
            for (const [e, n] of t.markers) {
              const t = qp._createAt(n.root, 0)
              const o = new Jp(
                n.start._getCombined(t, i),
                n.end._getCombined(t, i)
              )
              const r = { range: o, usingOperation: true, affectsData: true }
              if (this.model.markers.has(e)) {
                this.updateMarker(e, r)
              } else {
                this.addMarker(e, r)
              }
            }
          }
        }
        insertText(t, e, n, i) {
          if (e instanceof p_ || e instanceof Vp || e instanceof qp) {
            this.insert(this.createText(t), e, n)
          } else {
            this.insert(this.createText(t, e), n, i)
          }
        }
        insertElement(t, e, n, i) {
          if (e instanceof p_ || e instanceof Vp || e instanceof qp) {
            this.insert(this.createElement(t), e, n)
          } else {
            this.insert(this.createElement(t, e), n, i)
          }
        }
        append(t, e) {
          this.insert(t, e, 'end')
        }
        appendText(t, e, n) {
          if (e instanceof p_ || e instanceof Vp) {
            this.insert(this.createText(t), e, 'end')
          } else {
            this.insert(this.createText(t, e), n, 'end')
          }
        }
        appendElement(t, e, n) {
          if (e instanceof p_ || e instanceof Vp) {
            this.insert(this.createElement(t), e, 'end')
          } else {
            this.insert(this.createElement(t, e), n, 'end')
          }
        }
        setAttribute(t, e, n) {
          this._assertWriterUsedCorrectly()
          if (n instanceof Jp) {
            const i = n.getMinimalFlatRanges()
            for (const n of i) {
              w_(this, t, e, n)
            }
          } else {
            __(this, t, e, n)
          }
        }
        setAttributes(t, e) {
          for (const [n, i] of hl(t)) {
            this.setAttribute(n, i, e)
          }
        }
        removeAttribute(t, e) {
          this._assertWriterUsedCorrectly()
          if (e instanceof Jp) {
            const n = e.getMinimalFlatRanges()
            for (const e of n) {
              w_(this, t, null, e)
            }
          } else {
            __(this, t, null, e)
          }
        }
        clearAttributes(t) {
          this._assertWriterUsedCorrectly()
          const e = (t) => {
            for (const e of t.getAttributeKeys()) {
              this.removeAttribute(e, t)
            }
          }
          if (!(t instanceof Jp)) {
            e(t)
          } else {
            for (const n of t.getItems()) {
              e(n)
            }
          }
        }
        move(t, e, n) {
          this._assertWriterUsedCorrectly()
          if (!(t instanceof Jp)) {
            throw new N('writer-move-invalid-range', this)
          }
          if (!t.isFlat) {
            throw new N('writer-move-range-not-flat', this)
          }
          const i = qp._createAt(e, n)
          if (i.isEqual(t.start)) {
            return
          }
          this._addOperationForAffectedMarkers('move', t)
          if (!C_(t.root, i.root)) {
            throw new N('writer-move-different-document', this)
          }
          const o = t.root.document ? t.root.document.version : null
          const r = new Tw(t.start, t.end.offset - t.start.offset, i, o)
          this.batch.addOperation(r)
          this.model.applyOperation(r)
        }
        remove(t) {
          this._assertWriterUsedCorrectly()
          const e = t instanceof Jp ? t : Jp._createOn(t)
          const n = e.getMinimalFlatRanges().reverse()
          for (const t of n) {
            this._addOperationForAffectedMarkers('move', t)
            v_(t.start, t.end.offset - t.start.offset, this.batch, this.model)
          }
        }
        merge(t) {
          this._assertWriterUsedCorrectly()
          const e = t.nodeBefore
          const n = t.nodeAfter
          this._addOperationForAffectedMarkers('merge', t)
          if (!(e instanceof Vp)) {
            throw new N('writer-merge-no-element-before', this)
          }
          if (!(n instanceof Vp)) {
            throw new N('writer-merge-no-element-after', this)
          }
          if (!t.root.document) {
            this._mergeDetached(t)
          } else {
            this._merge(t)
          }
        }
        createPositionFromPath(t, e, n) {
          return this.model.createPositionFromPath(t, e, n)
        }
        createPositionAt(t, e) {
          return this.model.createPositionAt(t, e)
        }
        createPositionAfter(t) {
          return this.model.createPositionAfter(t)
        }
        createPositionBefore(t) {
          return this.model.createPositionBefore(t)
        }
        createRange(t, e) {
          return this.model.createRange(t, e)
        }
        createRangeIn(t) {
          return this.model.createRangeIn(t)
        }
        createRangeOn(t) {
          return this.model.createRangeOn(t)
        }
        createSelection(...t) {
          return this.model.createSelection(...t)
        }
        _mergeDetached(t) {
          const e = t.nodeBefore
          const n = t.nodeAfter
          this.move(Jp._createIn(n), qp._createAt(e, 'end'))
          this.remove(n)
        }
        _merge(t) {
          const e = qp._createAt(t.nodeBefore, 'end')
          const n = qp._createAt(t.nodeAfter, 0)
          const i = t.root.document.graveyard
          const o = new qp(i, [0])
          const r = t.root.document.version
          const s = new Ow(n, t.nodeAfter.maxOffset, e, o, r)
          this.batch.addOperation(s)
          this.model.applyOperation(s)
        }
        rename(t, e) {
          this._assertWriterUsedCorrectly()
          if (!(t instanceof Vp)) {
            throw new N('writer-rename-not-element-instance', this)
          }
          const n = t.root.document ? t.root.document.version : null
          const i = new zw(qp._createBefore(t), t.name, e, n)
          this.batch.addOperation(i)
          this.model.applyOperation(i)
        }
        split(t, e) {
          this._assertWriterUsedCorrectly()
          let n = t.parent
          if (!n.parent) {
            throw new N('writer-split-element-no-parent', this)
          }
          if (!e) {
            e = n.parent
          }
          if (!t.parent.getAncestors({ includeSelf: true }).includes(e)) {
            throw new N('writer-split-invalid-limit-element', this)
          }
          let i
          let o
          do {
            const e = n.root.document ? n.root.document.version : null
            const r = n.maxOffset - t.offset
            const s = Rw.getInsertionPosition(t)
            const a = new Rw(t, r, s, null, e)
            this.batch.addOperation(a)
            this.model.applyOperation(a)
            if (!i && !o) {
              i = n
              o = t.parent.nextSibling
            }
            t = this.createPositionAfter(t.parent)
            n = t.parent
          } while (n !== e)
          return {
            position: t,
            range: new Jp(qp._createAt(i, 'end'), qp._createAt(o, 0))
          }
        }
        wrap(t, e) {
          this._assertWriterUsedCorrectly()
          if (!t.isFlat) {
            throw new N('writer-wrap-range-not-flat', this)
          }
          const n = e instanceof Vp ? e : new Vp(e)
          if (n.childCount > 0) {
            throw new N('writer-wrap-element-not-empty', this)
          }
          if (n.parent !== null) {
            throw new N('writer-wrap-element-attached', this)
          }
          this.insert(n, t.start)
          const i = new Jp(t.start.getShiftedBy(1), t.end.getShiftedBy(1))
          this.move(i, qp._createAt(n, 0))
        }
        unwrap(t) {
          this._assertWriterUsedCorrectly()
          if (t.parent === null) {
            throw new N('writer-unwrap-element-no-parent', this)
          }
          this.move(Jp._createIn(t), this.createPositionAfter(t))
          this.remove(t)
        }
        addMarker(t, e) {
          this._assertWriterUsedCorrectly()
          if (!e || typeof e.usingOperation != 'boolean') {
            throw new N('writer-addmarker-no-usingoperation', this)
          }
          const n = e.usingOperation
          const i = e.range
          const o = e.affectsData === undefined ? false : e.affectsData
          if (this.model.markers.has(t)) {
            throw new N('writer-addmarker-marker-exists', this)
          }
          if (!i) {
            throw new N('writer-addmarker-no-range', this)
          }
          if (!n) {
            return this.model.markers._set(t, i, n, o)
          }
          A_(this, t, null, i, o)
          return this.model.markers.get(t)
        }
        updateMarker(t, e) {
          this._assertWriterUsedCorrectly()
          const n = typeof t == 'string' ? t : t.name
          const i = this.model.markers.get(n)
          if (!i) {
            throw new N('writer-updatemarker-marker-not-exists', this)
          }
          if (!e) {
            P('writer-updatemarker-reconvert-using-editingcontroller', {
              markerName: n
            })
            this.model.markers._refresh(i)
            return
          }
          const o = typeof e.usingOperation == 'boolean'
          const r = typeof e.affectsData == 'boolean'
          const s = r ? e.affectsData : i.affectsData
          if (!o && !e.range && !r) {
            throw new N('writer-updatemarker-wrong-options', this)
          }
          const a = i.getRange()
          const c = e.range ? e.range : a
          if (o && e.usingOperation !== i.managedUsingOperations) {
            if (e.usingOperation) {
              A_(this, n, null, c, s)
            } else {
              A_(this, n, a, null, s)
              this.model.markers._set(n, c, undefined, s)
            }
            return
          }
          if (i.managedUsingOperations) {
            A_(this, n, a, c, s)
          } else {
            this.model.markers._set(n, c, undefined, s)
          }
        }
        removeMarker(t) {
          this._assertWriterUsedCorrectly()
          const e = typeof t == 'string' ? t : t.name
          if (!this.model.markers.has(e)) {
            throw new N('writer-removemarker-no-marker', this)
          }
          const n = this.model.markers.get(e)
          if (!n.managedUsingOperations) {
            this.model.markers._remove(e)
            return
          }
          const i = n.getRange()
          A_(this, e, i, null, n.affectsData)
        }
        setSelection(...t) {
          this._assertWriterUsedCorrectly()
          this.model.document.selection._setTo(...t)
        }
        setSelectionFocus(t, e) {
          this._assertWriterUsedCorrectly()
          this.model.document.selection._setFocus(t, e)
        }
        setSelectionAttribute(t, e) {
          this._assertWriterUsedCorrectly()
          if (typeof t === 'string') {
            this._setSelectionAttribute(t, e)
          } else {
            for (const [e, n] of hl(t)) {
              this._setSelectionAttribute(e, n)
            }
          }
        }
        removeSelectionAttribute(t) {
          this._assertWriterUsedCorrectly()
          if (typeof t === 'string') {
            this._removeSelectionAttribute(t)
          } else {
            for (const e of t) {
              this._removeSelectionAttribute(e)
            }
          }
        }
        overrideSelectionGravity() {
          return this.model.document.selection._overrideGravity()
        }
        restoreSelectionGravity(t) {
          this.model.document.selection._restoreGravity(t)
        }
        _setSelectionAttribute(t, e) {
          const n = this.model.document.selection
          if (n.isCollapsed && n.anchor.parent.isEmpty) {
            const i = bb._getStoreAttributeKey(t)
            this.setAttribute(i, e, n.anchor.parent)
          }
          n._setAttribute(t, e)
        }
        _removeSelectionAttribute(t) {
          const e = this.model.document.selection
          if (e.isCollapsed && e.anchor.parent.isEmpty) {
            const n = bb._getStoreAttributeKey(t)
            this.removeAttribute(n, e.anchor.parent)
          }
          e._removeAttribute(t)
        }
        _assertWriterUsedCorrectly() {
          if (this.model._currentWriter !== this) {
            throw new N('writer-incorrect-use', this)
          }
        }
        _addOperationForAffectedMarkers(t, e) {
          for (const n of this.model.markers) {
            if (!n.managedUsingOperations) {
              continue
            }
            const i = n.getRange()
            let o = false
            if (t === 'move') {
              const t = e
              o =
                t.containsPosition(i.start) ||
                t.start.isEqual(i.start) ||
                t.containsPosition(i.end) ||
                t.end.isEqual(i.end)
            } else {
              const t = e
              const n = t.nodeBefore
              const r = t.nodeAfter
              const s = i.start.parent == n && i.start.isAtEnd
              const a = i.end.parent == r && i.end.offset == 0
              const c = i.end.nodeAfter == r
              const l = i.start.nodeAfter == r
              o = s || a || c || l
            }
            if (o) {
              this.updateMarker(n.name, { range: i })
            }
          }
        }
      }
      function w_(t, e, n, i) {
        const o = t.model
        const r = o.document
        let s = i.start
        let a
        let c
        let l
        for (const t of i.getWalker({ shallow: true })) {
          l = t.item.getAttribute(e)
          if (a && c != l) {
            if (c != n) {
              d()
            }
            s = a
          }
          a = t.nextPosition
          c = l
        }
        if (a instanceof qp && a != s && c != n) {
          d()
        }
        function d() {
          const i = new Jp(s, a)
          const l = i.root.document ? r.version : null
          const d = new Nw(i, e, c, n, l)
          t.batch.addOperation(d)
          o.applyOperation(d)
        }
      }
      function __(t, e, n, i) {
        const o = t.model
        const r = o.document
        const s = i.getAttribute(e)
        let a, c
        if (s != n) {
          const l = i.root === i
          if (l) {
            const t = i.document ? r.version : null
            c = new Lw(i, e, s, n, t)
          } else {
            a = new Jp(qp._createBefore(i), t.createPositionAfter(i))
            const o = a.root.document ? r.version : null
            c = new Nw(a, e, s, n, o)
          }
          t.batch.addOperation(c)
          o.applyOperation(c)
        }
      }
      function A_(t, e, n, i, o) {
        const r = t.model
        const s = r.document
        const a = new Iw(e, n, i, r.markers, !!o, s.version)
        t.batch.addOperation(a)
        r.applyOperation(a)
      }
      function v_(t, e, n, i) {
        let o
        if (t.root.document) {
          const n = i.document
          const r = new qp(n.graveyard, [0])
          o = new Tw(t, e, r, n.version)
        } else {
          o = new g_(t, e)
        }
        n.addOperation(o)
        i.applyOperation(o)
      }
      function C_(t, e) {
        if (t === e) {
          return true
        }
        if (t instanceof l_ && e instanceof l_) {
          return true
        }
        return false
      }
      function y_(t) {
        t.document.registerPostFixer((e) => x_(e, t))
      }
      function x_(t, e) {
        const n = e.document.selection
        const i = e.schema
        const o = []
        let r = false
        for (const t of n.getRanges()) {
          const e = E_(t, i)
          if (e && !e.isEqual(t)) {
            o.push(e)
            r = true
          } else {
            o.push(t)
          }
        }
        if (r) {
          t.setSelection(S_(o), { backward: n.isBackward })
        }
        return false
      }
      function E_(t, e) {
        if (t.isCollapsed) {
          return D_(t, e)
        }
        return T_(t, e)
      }
      function D_(t, e) {
        const n = t.start
        const i = e.getNearestSelectionRange(n)
        if (!i) {
          const t = n
            .getAncestors()
            .reverse()
            .find((t) => e.isObject(t))
          if (t) {
            return Jp._createOn(t)
          }
          return null
        }
        if (!i.isCollapsed) {
          return i
        }
        const o = i.start
        if (n.isEqual(o)) {
          return null
        }
        return new Jp(o)
      }
      function T_(t, e) {
        const { start: n, end: i } = t
        const o = e.checkChild(n, '$text')
        const r = e.checkChild(i, '$text')
        const s = e.getLimitElement(n)
        const a = e.getLimitElement(i)
        if (s === a) {
          if (o && r) {
            return null
          }
          if (I_(n, i, e)) {
            const t = n.nodeAfter && e.isSelectable(n.nodeAfter)
            const o = t ? null : e.getNearestSelectionRange(n, 'forward')
            const r = i.nodeBefore && e.isSelectable(i.nodeBefore)
            const s = r ? null : e.getNearestSelectionRange(i, 'backward')
            const a = o ? o.start : n
            const c = s ? s.end : i
            return new Jp(a, c)
          }
        }
        const c = s && !s.is('rootElement')
        const l = a && !a.is('rootElement')
        if (c || l) {
          const t =
            n.nodeAfter &&
            i.nodeBefore &&
            n.nodeAfter.parent === i.nodeBefore.parent
          const o = c && (!t || !B_(n.nodeAfter, e))
          const r = l && (!t || !B_(i.nodeBefore, e))
          let d = n
          let u = i
          if (o) {
            d = qp._createBefore(M_(s, e))
          }
          if (r) {
            u = qp._createAfter(M_(a, e))
          }
          return new Jp(d, u)
        }
        return null
      }
      function M_(t, e) {
        let n = t
        let i = n
        while (e.isLimit(i) && i.parent) {
          n = i
          i = i.parent
        }
        return n
      }
      function I_(t, e, n) {
        const i =
          (t.nodeAfter && !n.isLimit(t.nodeAfter)) || n.checkChild(t, '$text')
        const o =
          (e.nodeBefore && !n.isLimit(e.nodeBefore)) || n.checkChild(e, '$text')
        return i || o
      }
      function S_(t) {
        const e = [...t]
        const n = new Set()
        let i = 1
        while (i < e.length) {
          const t = e[i]
          const o = e.slice(0, i)
          for (const [r, s] of o.entries()) {
            if (n.has(r)) {
              continue
            }
            if (t.isEqual(s)) {
              n.add(r)
            } else if (t.isIntersecting(s)) {
              n.add(r)
              n.add(i)
              const o = t.getJoined(s)
              e.push(o)
            }
          }
          i++
        }
        const o = e.filter((t, e) => !n.has(e))
        return o
      }
      function B_(t, e) {
        return t && e.isSelectable(t)
      }
      function N_(t, e, n = {}) {
        if (e.isCollapsed) {
          return
        }
        const i = e.getFirstRange()
        if (i.root.rootName == '$graveyard') {
          return
        }
        const o = t.schema
        t.change((t) => {
          if (!n.doNotResetEntireContent && $_(o, e)) {
            q_(t, e)
            return
          }
          const r = {}
          if (!n.doNotAutoparagraph) {
            const t = e.getSelectedElement()
            if (t) {
              Object.assign(
                r,
                o.getAttributesWithProperty(t, 'copyOnReplace', true)
              )
            }
          }
          const [s, a] = P_(i)
          if (!s.isTouching(a)) {
            t.remove(t.createRange(s, a))
          }
          if (!n.leaveUnmerged) {
            L_(t, s, a)
            o.removeDisallowedAttributes(s.parent.getChildren(), t)
          }
          G_(t, e, s)
          if (!n.doNotAutoparagraph && H_(o, s)) {
            W_(t, s, e, r)
          }
          s.detach()
          a.detach()
        })
      }
      function P_(t) {
        const e = t.root.document.model
        const n = t.start
        let i = t.end
        if (e.hasContent(t, { ignoreMarkers: true })) {
          const n = z_(i)
          if (n && i.isTouching(e.createPositionAt(n, 0))) {
            const n = e.createSelection(t)
            e.modifySelection(n, { direction: 'backward' })
            const o = n.getLastPosition()
            const r = e.createRange(o, i)
            if (!e.hasContent(r, { ignoreMarkers: true })) {
              i = o
            }
          }
        }
        return [t_.fromPosition(n, 'toPrevious'), t_.fromPosition(i, 'toNext')]
      }
      function z_(t) {
        const e = t.parent
        const n = e.root.document.model.schema
        const i = e.getAncestors({ parentFirst: true, includeSelf: true })
        for (const t of i) {
          if (n.isLimit(t)) {
            return null
          }
          if (n.isBlock(t)) {
            return t
          }
        }
      }
      function L_(t, e, n) {
        const i = t.model
        if (!F_(t.model.schema, e, n)) {
          return
        }
        const [o, r] = V_(e, n)
        if (!o || !r) {
          return
        }
        if (
          !i.hasContent(o, { ignoreMarkers: true }) &&
          i.hasContent(r, { ignoreMarkers: true })
        ) {
          R_(t, e, n, o.parent)
        } else {
          O_(t, e, n, o.parent)
        }
      }
      function O_(t, e, n, i) {
        const o = e.parent
        const r = n.parent
        if (o == i || r == i) {
          return
        }
        e = t.createPositionAfter(o)
        n = t.createPositionBefore(r)
        if (!n.isEqual(e)) {
          t.insert(r, e)
        }
        t.merge(e)
        while (n.parent.isEmpty) {
          const e = n.parent
          n = t.createPositionBefore(e)
          t.remove(e)
        }
        if (!F_(t.model.schema, e, n)) {
          return
        }
        O_(t, e, n, i)
      }
      function R_(t, e, n, i) {
        const o = e.parent
        const r = n.parent
        if (o == i || r == i) {
          return
        }
        e = t.createPositionAfter(o)
        n = t.createPositionBefore(r)
        if (!n.isEqual(e)) {
          t.insert(o, n)
        }
        while (e.parent.isEmpty) {
          const n = e.parent
          e = t.createPositionBefore(n)
          t.remove(n)
        }
        n = t.createPositionBefore(r)
        j_(t, n)
        if (!F_(t.model.schema, e, n)) {
          return
        }
        R_(t, e, n, i)
      }
      function j_(t, e) {
        const n = e.nodeBefore
        const i = e.nodeAfter
        if (n.name != i.name) {
          t.rename(n, i.name)
        }
        t.clearAttributes(n)
        t.setAttributes(Object.fromEntries(i.getAttributes()), n)
        t.merge(e)
      }
      function F_(t, e, n) {
        const i = e.parent
        const o = n.parent
        if (i == o) {
          return false
        }
        if (t.isLimit(i) || t.isLimit(o)) {
          return false
        }
        return U_(e, n, t)
      }
      function V_(t, e) {
        const n = t.getAncestors()
        const i = e.getAncestors()
        let o = 0
        while (n[o] && n[o] == i[o]) {
          o++
        }
        return [n[o], i[o]]
      }
      function H_(t, e) {
        const n = t.checkChild(e, '$text')
        const i = t.checkChild(e, 'paragraph')
        return !n && i
      }
      function U_(t, e, n) {
        const i = new Jp(t, e)
        for (const t of i.getWalker()) {
          if (n.isLimit(t.item)) {
            return false
          }
        }
        return true
      }
      function W_(t, e, n, i = {}) {
        const o = t.createElement('paragraph')
        t.model.schema.setAllowedAttributes(o, i, t)
        t.insert(o, e)
        G_(t, n, t.createPositionAt(o, 0))
      }
      function q_(t, e) {
        const n = t.model.schema.getLimitElement(e)
        t.remove(t.createRangeIn(n))
        W_(t, t.createPositionAt(n, 0), e)
      }
      function $_(t, e) {
        const n = t.getLimitElement(e)
        if (!e.containsEntireContent(n)) {
          return false
        }
        const i = e.getFirstRange()
        if (i.start.parent == i.end.parent) {
          return false
        }
        return t.checkChild(n, 'paragraph')
      }
      function G_(t, e, n) {
        if (e instanceof bb) {
          t.setSelection(n)
        } else {
          e.setTo(n)
        }
      }
      function Y_(t, e) {
        return t.change((t) => {
          const n = t.createDocumentFragment()
          const i = e.getFirstRange()
          if (!i || i.isCollapsed) {
            return n
          }
          const o = i.start.root
          const r = i.start.getCommonPath(i.end)
          const s = o.getNodeByPath(r)
          let a
          if (i.start.parent == i.end.parent) {
            a = i
          } else {
            a = t.createRange(
              t.createPositionAt(s, i.start.path[r.length]),
              t.createPositionAt(s, i.end.path[r.length] + 1)
            )
          }
          const c = a.end.offset - a.start.offset
          for (const e of a.getItems({ shallow: true })) {
            if (e.is('$textProxy')) {
              t.appendText(e.data, e.getAttributes(), n)
            } else {
              t.append(t.cloneElement(e, true), n)
            }
          }
          if (a != i) {
            const e = i._getTransformedByMove(
              a.start,
              t.createPositionAt(n, 0),
              c
            )[0]
            const o = t.createRange(t.createPositionAt(n, 0), e.start)
            const r = t.createRange(e.end, t.createPositionAt(n, 'end'))
            K_(r, t)
            K_(o, t)
          }
          return n
        })
      }
      function K_(t, e) {
        const n = []
        Array.from(t.getItems({ direction: 'backward' }))
          .map((t) => e.createRangeOn(t))
          .filter((e) => {
            const n =
              (e.start.isAfter(t.start) || e.start.isEqual(t.start)) &&
              (e.end.isBefore(t.end) || e.end.isEqual(t.end))
            return n
          })
          .forEach((t) => {
            n.push(t.start.parent)
            e.remove(t)
          })
        n.forEach((t) => {
          let n = t
          while (n.parent && n.isEmpty) {
            const t = e.createRangeOn(n)
            n = n.parent
            e.remove(t)
          }
        })
      }
      function Q_(t, e, n, i) {
        return t.change((o) => {
          let r
          if (!n) {
            r = t.document.selection
          } else if (n instanceof sb || n instanceof bb) {
            r = n
          } else {
            r = o.createSelection(n, i)
          }
          if (!r.isCollapsed) {
            t.deleteContent(r, { doNotAutoparagraph: true })
          }
          const s = new Z_(t, o, r.anchor)
          const a = []
          let c
          if (e.is('documentFragment')) {
            if (e.markers.size) {
              const t = []
              for (const [n, i] of e.markers) {
                const { start: e, end: o } = i
                const r = e.isEqual(o)
                t.push(
                  { position: e, name: n, isCollapsed: r },
                  { position: o, name: n, isCollapsed: r }
                )
              }
              t.sort(({ position: t }, { position: e }) =>
                t.isBefore(e) ? 1 : -1
              )
              for (const { position: n, name: i, isCollapsed: r } of t) {
                let t = null
                let s = null
                const c = n.parent === e && n.isAtStart
                const l = n.parent === e && n.isAtEnd
                if (!c && !l) {
                  t = o.createElement('$marker')
                  o.insert(t, n)
                } else if (r) {
                  s = c ? 'start' : 'end'
                }
                a.push({ name: i, element: t, collapsed: s })
              }
            }
            c = e.getChildren()
          } else {
            c = [e]
          }
          s.handleNodes(c)
          let l = s.getSelectionRange()
          if (e.is('documentFragment') && a.length) {
            const t = l ? hb.fromRange(l) : null
            const e = {}
            for (let t = a.length - 1; t >= 0; t--) {
              const { name: n, element: i, collapsed: r } = a[t]
              const c = !e[n]
              if (c) {
                e[n] = []
              }
              if (i) {
                const t = o.createPositionAt(i, 'before')
                e[n].push(t)
                o.remove(i)
              } else {
                const t = s.getAffectedRange()
                if (!t) {
                  if (r) {
                    e[n].push(s.position)
                  }
                  continue
                }
                if (r) {
                  e[n].push(t[r])
                } else {
                  e[n].push(c ? t.start : t.end)
                }
              }
            }
            for (const [t, [n, i]] of Object.entries(e)) {
              if (n && i && n.root === i.root) {
                o.addMarker(t, {
                  usingOperation: true,
                  affectsData: true,
                  range: new Jp(n, i)
                })
              }
            }
            if (t) {
              l = t.toRange()
              t.detach()
            }
          }
          if (l) {
            if (r instanceof bb) {
              o.setSelection(l)
            } else {
              r.setTo(l)
            }
          } else {
          }
          const d = s.getAffectedRange() || t.createRange(r.anchor)
          s.destroy()
          return d
        })
      }
      class Z_ {
        constructor(t, e, n) {
          this._firstNode = null
          this._lastNode = null
          this._lastAutoParagraph = null
          this._filterAttributesOf = []
          this._affectedStart = null
          this._affectedEnd = null
          this._nodeToSelect = null
          this.model = t
          this.writer = e
          this.position = n
          this.canMergeWith = new Set([this.position.parent])
          this.schema = t.schema
          this._documentFragment = e.createDocumentFragment()
          this._documentFragmentPosition = e.createPositionAt(
            this._documentFragment,
            0
          )
        }
        handleNodes(t) {
          for (const e of Array.from(t)) {
            this._handleNode(e)
          }
          this._insertPartialFragment()
          if (this._lastAutoParagraph) {
            this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph)
          }
          this._mergeOnRight()
          this.schema.removeDisallowedAttributes(
            this._filterAttributesOf,
            this.writer
          )
          this._filterAttributesOf = []
        }
        _updateLastNodeFromAutoParagraph(t) {
          const e = this.writer.createPositionAfter(this._lastNode)
          const n = this.writer.createPositionAfter(t)
          if (n.isAfter(e)) {
            this._lastNode = t
            if (this.position.parent != t || !this.position.isAtEnd) {
              throw new N('insertcontent-invalid-insertion-position', this)
            }
            this.position = n
            this._setAffectedBoundaries(this.position)
          }
        }
        getSelectionRange() {
          if (this._nodeToSelect) {
            return Jp._createOn(this._nodeToSelect)
          }
          return this.model.schema.getNearestSelectionRange(this.position)
        }
        getAffectedRange() {
          if (!this._affectedStart) {
            return null
          }
          return new Jp(this._affectedStart, this._affectedEnd)
        }
        destroy() {
          if (this._affectedStart) {
            this._affectedStart.detach()
          }
          if (this._affectedEnd) {
            this._affectedEnd.detach()
          }
        }
        _handleNode(t) {
          if (this.schema.isObject(t)) {
            this._handleObject(t)
            return
          }
          let e = this._checkAndAutoParagraphToAllowedPosition(t)
          if (!e) {
            e = this._checkAndSplitToAllowedPosition(t)
            if (!e) {
              this._handleDisallowedNode(t)
              return
            }
          }
          this._appendToFragment(t)
          if (!this._firstNode) {
            this._firstNode = t
          }
          this._lastNode = t
        }
        _insertPartialFragment() {
          if (this._documentFragment.isEmpty) {
            return
          }
          const t = t_.fromPosition(this.position, 'toNext')
          this._setAffectedBoundaries(this.position)
          if (this._documentFragment.getChild(0) == this._firstNode) {
            this.writer.insert(this._firstNode, this.position)
            this._mergeOnLeft()
            this.position = t.toPosition()
          }
          if (!this._documentFragment.isEmpty) {
            this.writer.insert(this._documentFragment, this.position)
          }
          this._documentFragmentPosition = this.writer.createPositionAt(
            this._documentFragment,
            0
          )
          this.position = t.toPosition()
          t.detach()
        }
        _handleObject(t) {
          if (this._checkAndSplitToAllowedPosition(t)) {
            this._appendToFragment(t)
          } else {
            this._tryAutoparagraphing(t)
          }
        }
        _handleDisallowedNode(t) {
          if (t.is('element')) {
            this.handleNodes(t.getChildren())
          } else {
            this._tryAutoparagraphing(t)
          }
        }
        _appendToFragment(t) {
          if (!this.schema.checkChild(this.position, t)) {
            throw new N('insertcontent-wrong-position', this, {
              node: t,
              position: this.position
            })
          }
          this.writer.insert(t, this._documentFragmentPosition)
          this._documentFragmentPosition =
            this._documentFragmentPosition.getShiftedBy(t.offsetSize)
          if (
            this.schema.isObject(t) &&
            !this.schema.checkChild(this.position, '$text')
          ) {
            this._nodeToSelect = t
          } else {
            this._nodeToSelect = null
          }
          this._filterAttributesOf.push(t)
        }
        _setAffectedBoundaries(t) {
          if (!this._affectedStart) {
            this._affectedStart = t_.fromPosition(t, 'toPrevious')
          }
          if (!this._affectedEnd || this._affectedEnd.isBefore(t)) {
            if (this._affectedEnd) {
              this._affectedEnd.detach()
            }
            this._affectedEnd = t_.fromPosition(t, 'toNext')
          }
        }
        _mergeOnLeft() {
          const t = this._firstNode
          if (!(t instanceof Vp)) {
            return
          }
          if (!this._canMergeLeft(t)) {
            return
          }
          const e = t_._createBefore(t)
          e.stickiness = 'toNext'
          const n = t_.fromPosition(this.position, 'toNext')
          if (this._affectedStart.isEqual(e)) {
            this._affectedStart.detach()
            this._affectedStart = t_._createAt(
              e.nodeBefore,
              'end',
              'toPrevious'
            )
          }
          if (this._firstNode === this._lastNode) {
            this._firstNode = e.nodeBefore
            this._lastNode = e.nodeBefore
          }
          this.writer.merge(e)
          if (
            e.isEqual(this._affectedEnd) &&
            this._firstNode === this._lastNode
          ) {
            this._affectedEnd.detach()
            this._affectedEnd = t_._createAt(e.nodeBefore, 'end', 'toNext')
          }
          this.position = n.toPosition()
          n.detach()
          this._filterAttributesOf.push(this.position.parent)
          e.detach()
        }
        _mergeOnRight() {
          const t = this._lastNode
          if (!(t instanceof Vp)) {
            return
          }
          if (!this._canMergeRight(t)) {
            return
          }
          const e = t_._createAfter(t)
          e.stickiness = 'toNext'
          if (!this.position.isEqual(e)) {
            throw new N('insertcontent-invalid-insertion-position', this)
          }
          this.position = qp._createAt(e.nodeBefore, 'end')
          const n = t_.fromPosition(this.position, 'toPrevious')
          if (this._affectedEnd.isEqual(e)) {
            this._affectedEnd.detach()
            this._affectedEnd = t_._createAt(e.nodeBefore, 'end', 'toNext')
          }
          if (this._firstNode === this._lastNode) {
            this._firstNode = e.nodeBefore
            this._lastNode = e.nodeBefore
          }
          this.writer.merge(e)
          if (
            e.getShiftedBy(-1).isEqual(this._affectedStart) &&
            this._firstNode === this._lastNode
          ) {
            this._affectedStart.detach()
            this._affectedStart = t_._createAt(e.nodeBefore, 0, 'toPrevious')
          }
          this.position = n.toPosition()
          n.detach()
          this._filterAttributesOf.push(this.position.parent)
          e.detach()
        }
        _canMergeLeft(t) {
          const e = t.previousSibling
          return (
            e instanceof Vp &&
            this.canMergeWith.has(e) &&
            this.model.schema.checkMerge(e, t)
          )
        }
        _canMergeRight(t) {
          const e = t.nextSibling
          return (
            e instanceof Vp &&
            this.canMergeWith.has(e) &&
            this.model.schema.checkMerge(t, e)
          )
        }
        _tryAutoparagraphing(t) {
          const e = this.writer.createElement('paragraph')
          if (
            this._getAllowedIn(this.position.parent, e) &&
            this.schema.checkChild(e, t)
          ) {
            e._appendChild(t)
            this._handleNode(e)
          }
        }
        _checkAndAutoParagraphToAllowedPosition(t) {
          if (this.schema.checkChild(this.position.parent, t)) {
            return true
          }
          if (
            !this.schema.checkChild(this.position.parent, 'paragraph') ||
            !this.schema.checkChild('paragraph', t)
          ) {
            return false
          }
          this._insertPartialFragment()
          const e = this.writer.createElement('paragraph')
          this.writer.insert(e, this.position)
          this._setAffectedBoundaries(this.position)
          this._lastAutoParagraph = e
          this.position = this.writer.createPositionAt(e, 0)
          return true
        }
        _checkAndSplitToAllowedPosition(t) {
          const e = this._getAllowedIn(this.position.parent, t)
          if (!e) {
            return false
          }
          if (e != this.position.parent) {
            this._insertPartialFragment()
          }
          while (e != this.position.parent) {
            if (this.position.isAtStart) {
              const t = this.position.parent
              this.position = this.writer.createPositionBefore(t)
              if (t.isEmpty && t.parent === e) {
                this.writer.remove(t)
              }
            } else if (this.position.isAtEnd) {
              this.position = this.writer.createPositionAfter(
                this.position.parent
              )
            } else {
              const t = this.writer.createPositionAfter(this.position.parent)
              this._setAffectedBoundaries(this.position)
              this.writer.split(this.position)
              this.position = t
              this.canMergeWith.add(this.position.nodeAfter)
            }
          }
          return true
        }
        _getAllowedIn(t, e) {
          if (this.schema.checkChild(t, e)) {
            return t
          }
          if (this.schema.isLimit(t)) {
            return null
          }
          return this._getAllowedIn(t.parent, e)
        }
      }
      function J_(t, e, n = 'auto') {
        const i = t.getSelectedElement()
        if (i && e.schema.isObject(i) && !e.schema.isInline(i)) {
          if (n == 'before' || n == 'after') {
            return e.createRange(e.createPositionAt(i, n))
          }
          return e.createRangeOn(i)
        }
        const o = cl(t.getSelectedBlocks())
        if (!o) {
          return e.createRange(t.focus)
        }
        if (o.isEmpty) {
          return e.createRange(e.createPositionAt(o, 0))
        }
        const r = e.createPositionAfter(o)
        if (t.focus.isTouching(r)) {
          return e.createRange(r)
        }
        return e.createRange(e.createPositionBefore(o))
      }
      function X_(t, e, n, i, o = {}) {
        if (!t.schema.isObject(e)) {
          throw new N('insertobject-element-not-an-object', t, { object: e })
        }
        let r
        if (!n) {
          r = t.document.selection
        } else if (n instanceof sb || n instanceof bb) {
          r = n
        } else {
          r = t.createSelection(n, i)
        }
        let s = r
        if (o.findOptimalPosition && t.schema.isBlock(e)) {
          s = t.createSelection(J_(r, t, o.findOptimalPosition))
        }
        const a = cl(r.getSelectedBlocks())
        const c = {}
        if (a) {
          Object.assign(
            c,
            t.schema.getAttributesWithProperty(a, 'copyOnReplace', true)
          )
        }
        return t.change((n) => {
          if (!s.isCollapsed) {
            t.deleteContent(s, { doNotAutoparagraph: true })
          }
          let i = e
          const r = s.anchor.parent
          if (
            !t.schema.checkChild(r, e) &&
            t.schema.checkChild(r, 'paragraph') &&
            t.schema.checkChild('paragraph', e)
          ) {
            i = n.createElement('paragraph')
            n.insert(e, i)
          }
          t.schema.setAllowedAttributes(i, c, n)
          const a = t.insertContent(i, s)
          if (a.isCollapsed) {
            return a
          }
          if (o.setSelection) {
            tA(n, e, o.setSelection, c)
          }
          return a
        })
      }
      function tA(t, e, n, i) {
        const o = t.model
        if (n == 'on') {
          t.setSelection(e, 'on')
          return
        }
        if (n != 'after') {
          throw new N('insertobject-invalid-place-parameter-value', o)
        }
        let r = e.nextSibling
        if (o.schema.isInline(e)) {
          t.setSelection(e, 'after')
          return
        }
        const s = r && o.schema.checkChild(r, '$text')
        if (!s && o.schema.checkChild(e.parent, 'paragraph')) {
          r = t.createElement('paragraph')
          o.schema.setAllowedAttributes(r, i, t)
          o.insertContent(r, t.createPositionAfter(e))
        }
        if (r) {
          t.setSelection(r, 0)
        }
      }
      const eA = ' ,.?!:;"-()'
      function nA(t, e, n = {}) {
        const i = t.schema
        const o = n.direction != 'backward'
        const r = n.unit ? n.unit : 'character'
        const s = !!n.treatEmojiAsSingleUnit
        const a = e.focus
        const c = new Up({
          boundaries: sA(a, o),
          singleCharacters: true,
          direction: o ? 'forward' : 'backward'
        })
        const l = {
          walker: c,
          schema: i,
          isForward: o,
          unit: r,
          treatEmojiAsSingleUnit: s
        }
        let d
        while ((d = c.next())) {
          if (d.done) {
            return
          }
          const n = iA(l, d.value)
          if (n) {
            if (e instanceof bb) {
              t.change((t) => {
                t.setSelectionFocus(n)
              })
            } else {
              e.setFocus(n)
            }
            return
          }
        }
      }
      function iA(t, e) {
        const {
          isForward: n,
          walker: i,
          unit: o,
          schema: r,
          treatEmojiAsSingleUnit: s
        } = t
        const { type: a, item: c, nextPosition: l } = e
        if (a == 'text') {
          if (t.unit === 'word') {
            return rA(i, n)
          }
          return oA(i, o, s)
        }
        if (a == (n ? 'elementStart' : 'elementEnd')) {
          if (r.isSelectable(c)) {
            return qp._createAt(c, n ? 'after' : 'before')
          }
          if (r.checkChild(l, '$text')) {
            return l
          }
        } else {
          if (r.isLimit(c)) {
            i.skip(() => true)
            return
          }
          if (r.checkChild(l, '$text')) {
            return l
          }
        }
      }
      function oA(t, e, n) {
        const i = t.position.textNode
        if (i) {
          const o = i.data
          let r = t.position.offset - i.startOffset
          while (
            kl(o, r) ||
            (e == 'character' && wl(o, r)) ||
            (n && Al(o, r))
          ) {
            t.next()
            r = t.position.offset - i.startOffset
          }
        }
        return t.position
      }
      function rA(t, e) {
        let n = t.position.textNode
        if (!n) {
          n = e ? t.position.nodeAfter : t.position.nodeBefore
        }
        while (n && n.is('$text')) {
          const i = t.position.offset - n.startOffset
          if (cA(n, i, e)) {
            n = e ? t.position.nodeAfter : t.position.nodeBefore
          } else if (aA(n.data, i, e)) {
            break
          } else {
            t.next()
          }
        }
        return t.position
      }
      function sA(t, e) {
        const n = t.root
        const i = qp._createAt(n, e ? 'end' : 0)
        if (e) {
          return new Jp(t, i)
        } else {
          return new Jp(i, t)
        }
      }
      function aA(t, e, n) {
        const i = e + (n ? 0 : -1)
        return eA.includes(t.charAt(i))
      }
      function cA(t, e, n) {
        return e === (n ? t.offsetSize : 0)
      }
      class lA extends ht() {
        constructor() {
          super()
          this.markers = new f_()
          this.document = new u_(this)
          this.schema = new Uk()
          this._pendingChanges = []
          this._currentWriter = null
          ;[
            'insertContent',
            'insertObject',
            'deleteContent',
            'modifySelection',
            'getSelectedContent',
            'applyOperation'
          ].forEach((t) => this.decorate(t))
          this.on(
            'applyOperation',
            (t, e) => {
              const n = e[0]
              n._validate()
            },
            { priority: 'highest' }
          )
          this.schema.register('$root', { isLimit: true })
          this.schema.register('$container', {
            allowIn: ['$root', '$container']
          })
          this.schema.register('$block', {
            allowIn: ['$root', '$container'],
            isBlock: true
          })
          this.schema.register('$blockObject', {
            allowWhere: '$block',
            isBlock: true,
            isObject: true
          })
          this.schema.register('$inlineObject', {
            allowWhere: '$text',
            allowAttributesOf: '$text',
            isInline: true,
            isObject: true
          })
          this.schema.register('$text', {
            allowIn: '$block',
            isInline: true,
            isContent: true
          })
          this.schema.register('$clipboardHolder', {
            allowContentOf: '$root',
            allowChildren: '$text',
            isLimit: true
          })
          this.schema.register('$documentFragment', {
            allowContentOf: '$root',
            allowChildren: '$text',
            isLimit: true
          })
          this.schema.register('$marker')
          this.schema.addChildCheck((t, e) => {
            if (e.name === '$marker') {
              return true
            }
          })
          y_(this)
          this.document.registerPostFixer(pk)
        }
        change(t) {
          try {
            if (this._pendingChanges.length === 0) {
              this._pendingChanges.push({ batch: new i_(), callback: t })
              return this._runPendingChanges()[0]
            } else {
              return t(this._currentWriter)
            }
          } catch (t) {
            N.rethrowUnexpectedError(t, this)
          }
        }
        enqueueChange(t, e) {
          try {
            if (!t) {
              t = new i_()
            } else if (typeof t === 'function') {
              e = t
              t = new i_()
            } else if (!(t instanceof i_)) {
              t = new i_(t)
            }
            this._pendingChanges.push({ batch: t, callback: e })
            if (this._pendingChanges.length == 1) {
              this._runPendingChanges()
            }
          } catch (t) {
            N.rethrowUnexpectedError(t, this)
          }
        }
        applyOperation(t) {
          t._execute()
        }
        insertContent(t, e, n) {
          return Q_(this, t, e, n)
        }
        insertObject(t, e, n, i) {
          return X_(this, t, e, n, i)
        }
        deleteContent(t, e) {
          N_(this, t, e)
        }
        modifySelection(t, e) {
          nA(this, t, e)
        }
        getSelectedContent(t) {
          return Y_(this, t)
        }
        hasContent(t, e = {}) {
          const n = t instanceof Jp ? t : Jp._createIn(t)
          if (n.isCollapsed) {
            return false
          }
          const { ignoreWhitespaces: i = false, ignoreMarkers: o = false } = e
          if (!o) {
            for (const t of this.markers.getMarkersIntersectingRange(n)) {
              if (t.affectsData) {
                return true
              }
            }
          }
          for (const t of n.getItems()) {
            if (this.schema.isContent(t)) {
              if (t.is('$textProxy')) {
                if (!i) {
                  return true
                } else if (t.data.search(/\S/) !== -1) {
                  return true
                }
              } else {
                return true
              }
            }
          }
          return false
        }
        createPositionFromPath(t, e, n) {
          return new qp(t, e, n)
        }
        createPositionAt(t, e) {
          return qp._createAt(t, e)
        }
        createPositionAfter(t) {
          return qp._createAfter(t)
        }
        createPositionBefore(t) {
          return qp._createBefore(t)
        }
        createRange(t, e) {
          return new Jp(t, e)
        }
        createRangeIn(t) {
          return Jp._createIn(t)
        }
        createRangeOn(t) {
          return Jp._createOn(t)
        }
        createSelection(...t) {
          return new sb(...t)
        }
        createBatch(t) {
          return new i_(t)
        }
        createOperationFromJSON(t) {
          return Fw.fromJSON(t, this.document)
        }
        destroy() {
          this.document.destroy()
          this.stopListening()
        }
        _runPendingChanges() {
          const t = []
          this.fire('_beforeChanges')
          try {
            while (this._pendingChanges.length) {
              const e = this._pendingChanges[0].batch
              this._currentWriter = new k_(this, e)
              const n = this._pendingChanges[0].callback(this._currentWriter)
              t.push(n)
              this.document._handleChangeBlock(this._currentWriter)
              this._pendingChanges.shift()
              this._currentWriter = null
            }
          } finally {
            this._pendingChanges.length = 0
            this._currentWriter = null
            this.fire('_afterChanges')
          }
          return t
        }
      }
      class dA extends ig {
        constructor(t) {
          super(t)
          this.domEventType = 'click'
        }
        onDomEvent(t) {
          this.fire(t.type, t)
        }
      }
      class uA extends ig {
        constructor(t) {
          super(t)
          this.domEventType = ['mousedown', 'mouseup', 'mouseover', 'mouseout']
        }
        onDomEvent(t) {
          this.fire(t.type, t)
        }
      }
      class hA {
        constructor(t) {
          this.document = t
        }
        createDocumentFragment(t) {
          return new om(this.document, t)
        }
        createElement(t, e, n) {
          return new vf(this.document, t, e, n)
        }
        createText(t) {
          return new Au(this.document, t)
        }
        clone(t, e = false) {
          return t._clone(e)
        }
        appendChild(t, e) {
          return e._appendChild(t)
        }
        insertChild(t, e, n) {
          return n._insertChild(t, e)
        }
        removeChildren(t, e, n) {
          return n._removeChildren(t, e)
        }
        remove(t) {
          const e = t.parent
          if (e) {
            return this.removeChildren(e.getChildIndex(t), 1, e)
          }
          return []
        }
        replace(t, e) {
          const n = t.parent
          if (n) {
            const i = n.getChildIndex(t)
            this.removeChildren(i, 1, n)
            this.insertChild(i, e, n)
            return true
          }
          return false
        }
        unwrapElement(t) {
          const e = t.parent
          if (e) {
            const n = e.getChildIndex(t)
            this.remove(t)
            this.insertChild(n, t.getChildren(), e)
          }
        }
        rename(t, e) {
          const n = new vf(this.document, t, e.getAttributes(), e.getChildren())
          return this.replace(e, n) ? n : null
        }
        setAttribute(t, e, n) {
          n._setAttribute(t, e)
        }
        removeAttribute(t, e) {
          e._removeAttribute(t)
        }
        addClass(t, e) {
          e._addClass(t)
        }
        removeClass(t, e) {
          e._removeClass(t)
        }
        setStyle(t, e, n) {
          if (me(t) && n === undefined) {
            e._setStyle(t)
          } else {
            n._setStyle(t, e)
          }
        }
        removeStyle(t, e) {
          e._removeStyle(t)
        }
        setCustomProperty(t, e, n) {
          n._setCustomProperty(t, e)
        }
        removeCustomProperty(t, e) {
          return e._removeCustomProperty(t)
        }
        createPositionAt(t, e) {
          return Bf._createAt(t, e)
        }
        createPositionAfter(t) {
          return Bf._createAfter(t)
        }
        createPositionBefore(t) {
          return Bf._createBefore(t)
        }
        createRange(t, e) {
          return new Nf(t, e)
        }
        createRangeOn(t) {
          return Nf._createOn(t)
        }
        createRangeIn(t) {
          return Nf._createIn(t)
        }
        createSelection(...t) {
          return new zf(...t)
        }
      }
      const fA = /^#([0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/i
      const mA = /^rgb\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}[0-9]{1,3}[ %]?\)$/i
      const gA =
        /^rgba\([ ]?([0-9]{1,3}[ %]?,[ ]?){3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i
      const pA =
        /^hsl\([ ]?([0-9]{1,3}[ %]?[,]?[ ]*){3}(1|[0-9]+%|[0]?\.?[0-9]+)?\)$/i
      const bA =
        /^hsla\([ ]?([0-9]{1,3}[ %]?,[ ]?){2,3}(1|[0-9]+%|[0]?\.?[0-9]+)\)$/i
      const kA = new Set([
        'black',
        'silver',
        'gray',
        'white',
        'maroon',
        'red',
        'purple',
        'fuchsia',
        'green',
        'lime',
        'olive',
        'yellow',
        'navy',
        'blue',
        'teal',
        'aqua',
        'orange',
        'aliceblue',
        'antiquewhite',
        'aquamarine',
        'azure',
        'beige',
        'bisque',
        'blanchedalmond',
        'blueviolet',
        'brown',
        'burlywood',
        'cadetblue',
        'chartreuse',
        'chocolate',
        'coral',
        'cornflowerblue',
        'cornsilk',
        'crimson',
        'cyan',
        'darkblue',
        'darkcyan',
        'darkgoldenrod',
        'darkgray',
        'darkgreen',
        'darkgrey',
        'darkkhaki',
        'darkmagenta',
        'darkolivegreen',
        'darkorange',
        'darkorchid',
        'darkred',
        'darksalmon',
        'darkseagreen',
        'darkslateblue',
        'darkslategray',
        'darkslategrey',
        'darkturquoise',
        'darkviolet',
        'deeppink',
        'deepskyblue',
        'dimgray',
        'dimgrey',
        'dodgerblue',
        'firebrick',
        'floralwhite',
        'forestgreen',
        'gainsboro',
        'ghostwhite',
        'gold',
        'goldenrod',
        'greenyellow',
        'grey',
        'honeydew',
        'hotpink',
        'indianred',
        'indigo',
        'ivory',
        'khaki',
        'lavender',
        'lavenderblush',
        'lawngreen',
        'lemonchiffon',
        'lightblue',
        'lightcoral',
        'lightcyan',
        'lightgoldenrodyellow',
        'lightgray',
        'lightgreen',
        'lightgrey',
        'lightpink',
        'lightsalmon',
        'lightseagreen',
        'lightskyblue',
        'lightslategray',
        'lightslategrey',
        'lightsteelblue',
        'lightyellow',
        'limegreen',
        'linen',
        'magenta',
        'mediumaquamarine',
        'mediumblue',
        'mediumorchid',
        'mediumpurple',
        'mediumseagreen',
        'mediumslateblue',
        'mediumspringgreen',
        'mediumturquoise',
        'mediumvioletred',
        'midnightblue',
        'mintcream',
        'mistyrose',
        'moccasin',
        'navajowhite',
        'oldlace',
        'olivedrab',
        'orangered',
        'orchid',
        'palegoldenrod',
        'palegreen',
        'paleturquoise',
        'palevioletred',
        'papayawhip',
        'peachpuff',
        'peru',
        'pink',
        'plum',
        'powderblue',
        'rosybrown',
        'royalblue',
        'saddlebrown',
        'salmon',
        'sandybrown',
        'seagreen',
        'seashell',
        'sienna',
        'skyblue',
        'slateblue',
        'slategray',
        'slategrey',
        'snow',
        'springgreen',
        'steelblue',
        'tan',
        'thistle',
        'tomato',
        'turquoise',
        'violet',
        'wheat',
        'whitesmoke',
        'yellowgreen',
        'activeborder',
        'activecaption',
        'appworkspace',
        'background',
        'buttonface',
        'buttonhighlight',
        'buttonshadow',
        'buttontext',
        'captiontext',
        'graytext',
        'highlight',
        'highlighttext',
        'inactiveborder',
        'inactivecaption',
        'inactivecaptiontext',
        'infobackground',
        'infotext',
        'menu',
        'menutext',
        'scrollbar',
        'threeddarkshadow',
        'threedface',
        'threedhighlight',
        'threedlightshadow',
        'threedshadow',
        'window',
        'windowframe',
        'windowtext',
        'rebeccapurple',
        'currentcolor',
        'transparent'
      ])
      function wA(t) {
        if (t.startsWith('#')) {
          return fA.test(t)
        }
        if (t.startsWith('rgb')) {
          return mA.test(t) || gA.test(t)
        }
        if (t.startsWith('hsl')) {
          return pA.test(t) || bA.test(t)
        }
        return kA.has(t.toLowerCase())
      }
      const _A = null && [
        'none',
        'hidden',
        'dotted',
        'dashed',
        'solid',
        'double',
        'groove',
        'ridge',
        'inset',
        'outset'
      ]
      function AA(t) {
        return _A.includes(t)
      }
      const vA =
        /^([+-]?[0-9]*([.][0-9]+)?(px|cm|mm|in|pc|pt|ch|em|ex|rem|vh|vw|vmin|vmax)|0)$/
      function CA(t) {
        return vA.test(t)
      }
      const yA = /^[+-]?[0-9]*([.][0-9]+)?%$/
      function xA(t) {
        return yA.test(t)
      }
      const EA = null && [
        'repeat-x',
        'repeat-y',
        'repeat',
        'space',
        'round',
        'no-repeat'
      ]
      function DA(t) {
        return EA.includes(t)
      }
      const TA = null && ['center', 'top', 'bottom', 'left', 'right']
      function MA(t) {
        return TA.includes(t)
      }
      const IA = null && ['fixed', 'scroll', 'local']
      function SA(t) {
        return IA.includes(t)
      }
      const BA = /^url\(/
      function NA(t) {
        return BA.test(t)
      }
      function PA(t = '') {
        if (t === '') {
          return {
            top: undefined,
            right: undefined,
            bottom: undefined,
            left: undefined
          }
        }
        const e = RA(t)
        const n = e[0]
        const i = e[2] || n
        const o = e[1] || n
        const r = e[3] || o
        return { top: n, bottom: i, right: o, left: r }
      }
      function zA(t) {
        return (e) => {
          const { top: n, right: i, bottom: o, left: r } = e
          const s = []
          if (![n, i, r, o].every((t) => !!t)) {
            if (n) {
              s.push([t + '-top', n])
            }
            if (i) {
              s.push([t + '-right', i])
            }
            if (o) {
              s.push([t + '-bottom', o])
            }
            if (r) {
              s.push([t + '-left', r])
            }
          } else {
            s.push([t, LA(e)])
          }
          return s
        }
      }
      function LA({ top: t, right: e, bottom: n, left: i }) {
        const o = []
        if (i !== e) {
          o.push(t, e, n, i)
        } else if (n !== t) {
          o.push(t, e, n)
        } else if (e !== t) {
          o.push(t, e)
        } else {
          o.push(t)
        }
        return o.join(' ')
      }
      function OA(t) {
        return (e) => ({ path: t, value: PA(e) })
      }
      function RA(t) {
        return t
          .replace(/, /g, ',')
          .split(' ')
          .map((t) => t.replace(/,/g, ', '))
      }
      function jA(t) {
        t.setNormalizer('background', FA())
        t.setNormalizer('background-color', VA())
        t.setReducer('background', HA())
        t.setStyleRelation('background', ['background-color'])
      }
      function FA() {
        return (t) => {
          const e = {}
          const n = getShorthandValues(t)
          for (const t of n) {
            if (isRepeat(t)) {
              e.repeat = e.repeat || []
              e.repeat.push(t)
            } else if (isPosition(t)) {
              e.position = e.position || []
              e.position.push(t)
            } else if (isAttachment(t)) {
              e.attachment = t
            } else if (isColor(t)) {
              e.color = t
            } else if (isURL(t)) {
              e.image = t
            }
          }
          return { path: 'background', value: e }
        }
      }
      function VA() {
        return (t) => ({ path: 'background.color', value: t })
      }
      function HA() {
        return (t) => {
          const e = []
          e.push(['background-color', t.color])
          return e
        }
      }
      function UA(t) {
        t.setNormalizer('border', WA())
        t.setNormalizer('border-top', qA('top'))
        t.setNormalizer('border-right', qA('right'))
        t.setNormalizer('border-bottom', qA('bottom'))
        t.setNormalizer('border-left', qA('left'))
        t.setNormalizer('border-color', $A('color'))
        t.setNormalizer('border-width', $A('width'))
        t.setNormalizer('border-style', $A('style'))
        t.setNormalizer('border-top-color', YA('color', 'top'))
        t.setNormalizer('border-top-style', YA('style', 'top'))
        t.setNormalizer('border-top-width', YA('width', 'top'))
        t.setNormalizer('border-right-color', YA('color', 'right'))
        t.setNormalizer('border-right-style', YA('style', 'right'))
        t.setNormalizer('border-right-width', YA('width', 'right'))
        t.setNormalizer('border-bottom-color', YA('color', 'bottom'))
        t.setNormalizer('border-bottom-style', YA('style', 'bottom'))
        t.setNormalizer('border-bottom-width', YA('width', 'bottom'))
        t.setNormalizer('border-left-color', YA('color', 'left'))
        t.setNormalizer('border-left-style', YA('style', 'left'))
        t.setNormalizer('border-left-width', YA('width', 'left'))
        t.setExtractor('border-top', KA('top'))
        t.setExtractor('border-right', KA('right'))
        t.setExtractor('border-bottom', KA('bottom'))
        t.setExtractor('border-left', KA('left'))
        t.setExtractor('border-top-color', 'border.color.top')
        t.setExtractor('border-right-color', 'border.color.right')
        t.setExtractor('border-bottom-color', 'border.color.bottom')
        t.setExtractor('border-left-color', 'border.color.left')
        t.setExtractor('border-top-width', 'border.width.top')
        t.setExtractor('border-right-width', 'border.width.right')
        t.setExtractor('border-bottom-width', 'border.width.bottom')
        t.setExtractor('border-left-width', 'border.width.left')
        t.setExtractor('border-top-style', 'border.style.top')
        t.setExtractor('border-right-style', 'border.style.right')
        t.setExtractor('border-bottom-style', 'border.style.bottom')
        t.setExtractor('border-left-style', 'border.style.left')
        t.setReducer('border-color', getBoxSidesValueReducer('border-color'))
        t.setReducer('border-style', getBoxSidesValueReducer('border-style'))
        t.setReducer('border-width', getBoxSidesValueReducer('border-width'))
        t.setReducer('border-top', XA('top'))
        t.setReducer('border-right', XA('right'))
        t.setReducer('border-bottom', XA('bottom'))
        t.setReducer('border-left', XA('left'))
        t.setReducer('border', JA())
        t.setStyleRelation('border', [
          'border-color',
          'border-style',
          'border-width',
          'border-top',
          'border-right',
          'border-bottom',
          'border-left',
          'border-top-color',
          'border-right-color',
          'border-bottom-color',
          'border-left-color',
          'border-top-style',
          'border-right-style',
          'border-bottom-style',
          'border-left-style',
          'border-top-width',
          'border-right-width',
          'border-bottom-width',
          'border-left-width'
        ])
        t.setStyleRelation('border-color', [
          'border-top-color',
          'border-right-color',
          'border-bottom-color',
          'border-left-color'
        ])
        t.setStyleRelation('border-style', [
          'border-top-style',
          'border-right-style',
          'border-bottom-style',
          'border-left-style'
        ])
        t.setStyleRelation('border-width', [
          'border-top-width',
          'border-right-width',
          'border-bottom-width',
          'border-left-width'
        ])
        t.setStyleRelation('border-top', [
          'border-top-color',
          'border-top-style',
          'border-top-width'
        ])
        t.setStyleRelation('border-right', [
          'border-right-color',
          'border-right-style',
          'border-right-width'
        ])
        t.setStyleRelation('border-bottom', [
          'border-bottom-color',
          'border-bottom-style',
          'border-bottom-width'
        ])
        t.setStyleRelation('border-left', [
          'border-left-color',
          'border-left-style',
          'border-left-width'
        ])
      }
      function WA() {
        return (t) => {
          const { color: e, style: n, width: i } = ZA(t)
          return {
            path: 'border',
            value: {
              color: getBoxSidesValues(e),
              style: getBoxSidesValues(n),
              width: getBoxSidesValues(i)
            }
          }
        }
      }
      function qA(t) {
        return (e) => {
          const { color: n, style: i, width: o } = ZA(e)
          const r = {}
          if (n !== undefined) {
            r.color = { [t]: n }
          }
          if (i !== undefined) {
            r.style = { [t]: i }
          }
          if (o !== undefined) {
            r.width = { [t]: o }
          }
          return { path: 'border', value: r }
        }
      }
      function $A(t) {
        return (e) => ({ path: 'border', value: GA(e, t) })
      }
      function GA(t, e) {
        return { [e]: getBoxSidesValues(t) }
      }
      function YA(t, e) {
        return (n) => ({ path: 'border', value: { [t]: { [e]: n } } })
      }
      function KA(t) {
        return (e, n) => {
          if (n.border) {
            return QA(n.border, t)
          }
        }
      }
      function QA(t, e) {
        const n = {}
        if (t.width && t.width[e]) {
          n.width = t.width[e]
        }
        if (t.style && t.style[e]) {
          n.style = t.style[e]
        }
        if (t.color && t.color[e]) {
          n.color = t.color[e]
        }
        return n
      }
      function ZA(t) {
        const e = {}
        const n = getShorthandValues(t)
        for (const t of n) {
          if (isLength(t) || /thin|medium|thick/.test(t)) {
            e.width = t
          } else if (isLineStyle(t)) {
            e.style = t
          } else {
            e.color = t
          }
        }
        return e
      }
      function JA() {
        return (e) => {
          const n = QA(e, 'top')
          const i = QA(e, 'right')
          const o = QA(e, 'bottom')
          const r = QA(e, 'left')
          const s = [n, i, o, r]
          const a = {
            width: t(s, 'width'),
            style: t(s, 'style'),
            color: t(s, 'color')
          }
          const c = tv(a, 'all')
          if (c.length) {
            return c
          }
          const l = Object.entries(a).reduce((t, [e, n]) => {
            if (n) {
              t.push([`border-${e}`, n])
              s.forEach((t) => delete t[e])
            }
            return t
          }, [])
          return [
            ...l,
            ...tv(n, 'top'),
            ...tv(i, 'right'),
            ...tv(o, 'bottom'),
            ...tv(r, 'left')
          ]
        }
        function t(t, e) {
          return t.map((t) => t[e]).reduce((t, e) => (t == e ? t : null))
        }
      }
      function XA(t) {
        return (e) => tv(e, t)
      }
      function tv(t, e) {
        const n = []
        if (t && t.width) {
          n.push('width')
        }
        if (t && t.style) {
          n.push('style')
        }
        if (t && t.color) {
          n.push('color')
        }
        if (n.length == 3) {
          const i = n.map((e) => t[e]).join(' ')
          return [e == 'all' ? ['border', i] : [`border-${e}`, i]]
        }
        if (e == 'all') {
          return []
        }
        return n.map((n) => [`border-${e}-${n}`, t[n]])
      }
      function ev(t) {
        t.setNormalizer('margin', getPositionShorthandNormalizer('margin'))
        t.setNormalizer('margin-top', (t) => ({ path: 'margin.top', value: t }))
        t.setNormalizer('margin-right', (t) => ({
          path: 'margin.right',
          value: t
        }))
        t.setNormalizer('margin-bottom', (t) => ({
          path: 'margin.bottom',
          value: t
        }))
        t.setNormalizer('margin-left', (t) => ({
          path: 'margin.left',
          value: t
        }))
        t.setReducer('margin', getBoxSidesValueReducer('margin'))
        t.setStyleRelation('margin', [
          'margin-top',
          'margin-right',
          'margin-bottom',
          'margin-left'
        ])
      }
      function nv(t) {
        t.setNormalizer('padding', getPositionShorthandNormalizer('padding'))
        t.setNormalizer('padding-top', (t) => ({
          path: 'padding.top',
          value: t
        }))
        t.setNormalizer('padding-right', (t) => ({
          path: 'padding.right',
          value: t
        }))
        t.setNormalizer('padding-bottom', (t) => ({
          path: 'padding.bottom',
          value: t
        }))
        t.setNormalizer('padding-left', (t) => ({
          path: 'padding.left',
          value: t
        }))
        t.setReducer('padding', getBoxSidesValueReducer('padding'))
        t.setStyleRelation('padding', [
          'padding-top',
          'padding-right',
          'padding-bottom',
          'padding-left'
        ])
      }
      class iv {
        constructor() {
          this._commands = new Map()
        }
        add(t, e) {
          this._commands.set(t, e)
        }
        get(t) {
          return this._commands.get(t)
        }
        execute(t, ...e) {
          const n = this.get(t)
          if (!n) {
            throw new N('commandcollection-command-not-found', this, {
              commandName: t
            })
          }
          return n.execute(...e)
        }
        *names() {
          yield* this._commands.keys()
        }
        *commands() {
          yield* this._commands.values()
        }
        [Symbol.iterator]() {
          return this._commands[Symbol.iterator]()
        }
        destroy() {
          for (const t of this.commands()) {
            t.destroy()
          }
        }
      }
      class ov extends dl {
        constructor(t) {
          super()
          this.editor = t
        }
        set(t, e, n = {}) {
          if (typeof e == 'string') {
            const t = e
            e = (e, n) => {
              this.editor.execute(t)
              n()
            }
          }
          super.set(t, e, n)
        }
      }
      class rv extends ht() {
        constructor(t = {}) {
          super()
          const e = this.constructor
          const n = t.language || (e.defaultConfig && e.defaultConfig.language)
          this._context = t.context || new eu({ language: n })
          this._context._addEditor(this, !t.context)
          const i = Array.from(e.builtinPlugins || [])
          this.config = new Wa(t, e.defaultConfig)
          this.config.define('plugins', i)
          this.config.define(this._context._getEditorConfig())
          this.plugins = new tu(this, i, this._context.plugins)
          this.locale = this._context.locale
          this.t = this.locale.t
          this._readOnlyLocks = new Set()
          this.commands = new iv()
          this.set('state', 'initializing')
          this.once('ready', () => (this.state = 'ready'), { priority: 'high' })
          this.once('destroy', () => (this.state = 'destroyed'), {
            priority: 'high'
          })
          this.model = new lA()
          const o = new kf()
          this.data = new mw(this.model, o)
          this.editing = new jk(this.model, o)
          this.editing.view.document.bind('isReadOnly').to(this)
          this.conversion = new pw(
            [this.editing.downcastDispatcher, this.data.downcastDispatcher],
            this.data.upcastDispatcher
          )
          this.conversion.addAlias('dataDowncast', this.data.downcastDispatcher)
          this.conversion.addAlias(
            'editingDowncast',
            this.editing.downcastDispatcher
          )
          this.keystrokes = new ov(this)
          this.keystrokes.listenTo(this.editing.view.document)
        }
        get isReadOnly() {
          return this._readOnlyLocks.size > 0
        }
        set isReadOnly(t) {
          throw new N('editor-isreadonly-has-no-setter')
        }
        enableReadOnlyMode(t) {
          if (typeof t !== 'string' && typeof t !== 'symbol') {
            throw new N('editor-read-only-lock-id-invalid', null, { lockId: t })
          }
          if (this._readOnlyLocks.has(t)) {
            return
          }
          this._readOnlyLocks.add(t)
          if (this._readOnlyLocks.size === 1) {
            this.fire('change:isReadOnly', 'isReadOnly', true, false)
          }
        }
        disableReadOnlyMode(t) {
          if (typeof t !== 'string' && typeof t !== 'symbol') {
            throw new N('editor-read-only-lock-id-invalid', null, { lockId: t })
          }
          if (!this._readOnlyLocks.has(t)) {
            return
          }
          this._readOnlyLocks.delete(t)
          if (this._readOnlyLocks.size === 0) {
            this.fire('change:isReadOnly', 'isReadOnly', false, true)
          }
        }
        initPlugins() {
          const t = this.config
          const e = t.get('plugins')
          const n = t.get('removePlugins') || []
          const i = t.get('extraPlugins') || []
          const o = t.get('substitutePlugins') || []
          return this.plugins.init(e.concat(i), n, o)
        }
        destroy() {
          let t = Promise.resolve()
          if (this.state == 'initializing') {
            t = new Promise((t) => this.once('ready', t))
          }
          return t
            .then(() => {
              this.fire('destroy')
              this.stopListening()
              this.commands.destroy()
            })
            .then(() => this.plugins.destroy())
            .then(() => {
              this.model.destroy()
              this.data.destroy()
              this.editing.destroy()
              this.keystrokes.destroy()
            })
            .then(() => this._context._removeEditor(this))
        }
        execute(t, ...e) {
          try {
            return this.commands.execute(t, ...e)
          } catch (t) {
            N.rethrowUnexpectedError(t, this)
          }
        }
        focus() {
          this.editing.view.focus()
        }
      }
      function sv(t) {
        if (!$e(t.updateSourceElement)) {
          throw new N('attachtoform-missing-elementapi-interface', t)
        }
        const e = t.sourceElement
        if (av(e) && e.form) {
          let n
          const i = e.form
          const o = () => t.updateSourceElement()
          if ($e(i.submit)) {
            n = i.submit
            i.submit = () => {
              o()
              n.apply(i)
            }
          }
          i.addEventListener('submit', o)
          t.on('destroy', () => {
            i.removeEventListener('submit', o)
            if (n) {
              i.submit = n
            }
          })
        }
      }
      function av(t) {
        return !!t && t.tagName.toLowerCase() === 'textarea'
      }
      function cv(t) {
        class e extends t {
          setData(t) {
            this.data.set(t)
          }
          getData(t) {
            return this.data.get(t)
          }
        }
        return e
      }
      {
        const t = cv(Object)
        cv.setData = t.prototype.setData
        cv.getData = t.prototype.getData
      }
      function lv(t) {
        class e extends t {
          updateSourceElement(t = this.data.get()) {
            if (!this.sourceElement) {
              throw new N('editor-missing-sourceelement', this)
            }
            const e = this.config.get('updateSourceElementOnDestroy')
            const n = this.sourceElement instanceof HTMLTextAreaElement
            if (!e && !n) {
              fc(this.sourceElement, '')
              return
            }
            fc(this.sourceElement, t)
          }
        }
        return e
      }
      lv.updateSourceElement = lv(Object).prototype.updateSourceElement
      function dv(t) {
        const e = t.sourceElement
        if (!e) {
          return
        }
        if (e.ckeditorInstance) {
          throw new CKEditorError('editor-source-element-already-used', t)
        }
        e.ckeditorInstance = t
        t.once('destroy', () => {
          delete e.ckeditorInstance
        })
      }
      class uv extends nu {
        static get pluginName() {
          return 'PendingActions'
        }
        init() {
          this.set('hasAny', false)
          this._actions = new al({ idProperty: '_id' })
          this._actions.delegate('add', 'remove').to(this)
        }
        add(t) {
          if (typeof t !== 'string') {
            throw new N('pendingactions-add-invalid-message', this)
          }
          const e = new (ht())()
          e.set('message', t)
          this._actions.add(e)
          this.hasAny = true
          return e
        }
        remove(t) {
          this._actions.remove(t)
          this.hasAny = !!this._actions.length
        }
        get first() {
          return this._actions.get(0)
        }
        [Symbol.iterator]() {
          return this._actions[Symbol.iterator]()
        }
      }
      const hv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>'
      const fv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>'
      const mv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>'
      const gv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>'
      const pv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>'
      const bv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>'
      const kv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.91 10.54c.26-.23.64-.21.88.03l3.36 3.14 2.23-2.06a.64.64 0 0 1 .87 0l2.52 2.97V4.5H3.2v10.12l3.71-4.08zm10.27-7.51c.6 0 1.09.47 1.09 1.05v11.84c0 .59-.49 1.06-1.09 1.06H2.79c-.6 0-1.09-.47-1.09-1.06V4.08c0-.58.49-1.05 1.1-1.05h14.38zm-5.22 5.56a1.96 1.96 0 1 1 3.4-1.96 1.96 1.96 0 0 1-3.4 1.96z"/></svg>'
      const wv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>'
      const _v =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>'
      const Av =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>'
      const vv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>'
      const Cv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>'
      const yv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>'
      const xv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>'
      const Ev =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>'
      const Dv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>'
      const Tv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>'
      const Mv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>'
      const Iv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>'
      const Sv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>'
      const Bv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>'
      const Nv =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>'
      const Pv =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>'
      const zv =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>'
      const Lv =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>'
      const Ov =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>'
      const Rv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>'
      const jv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>'
      const Fv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>'
      const Vv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>'
      const Hv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>'
      const Uv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>'
      const Wv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path clip-rule="evenodd" d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></svg>'
      const qv =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path clip-rule="evenodd" d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></g><defs><clipPath id="a"><path d="M0 0h20v20H0z"/></clipPath></defs></svg>'
      const $v = {
        bold: Vv,
        cancel: hv,
        caption: fv,
        check: mv,
        cog: gv,
        eraser: pv,
        image: kv,
        lowVision: bv,
        importExport: qv,
        paragraph: Hv,
        plus: Uv,
        text: Wv,
        alignBottom: wv,
        alignMiddle: _v,
        alignTop: Av,
        alignLeft: vv,
        alignCenter: Cv,
        alignRight: yv,
        alignJustify: xv,
        objectLeft: Sv,
        objectCenter: Dv,
        objectRight: Bv,
        objectFullWidth: Mv,
        objectInline: Iv,
        objectBlockLeft: Ev,
        objectBlockRight: Tv,
        objectSizeFull: Nv,
        objectSizeLarge: Pv,
        objectSizeSmall: zv,
        objectSizeMedium: Lv,
        pencil: Ov,
        pilcrow: Rv,
        quote: jv,
        threeVerticalDots: Fv
      }
      var Gv = __webpack_require__(5571)
      var Yv = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Yv.insert = 'head'
      Yv.singleton = true
      var Kv = El()(Gv.Z, Yv)
      const Qv = Gv.Z.locals || {}
      const { threeVerticalDots: Zv } = $v
      const Jv = {
        alignLeft: $v.alignLeft,
        bold: $v.bold,
        importExport: $v.importExport,
        paragraph: $v.paragraph,
        plus: $v.plus,
        text: $v.text,
        threeVerticalDots: $v.threeVerticalDots
      }
      class Xv extends Sl {
        constructor(t, e) {
          super(t)
          const n = this.bindTemplate
          const i = this.t
          this.options = e || {}
          this.set('ariaLabel', i('Editor toolbar'))
          this.set('maxWidth', 'auto')
          this.items = this.createCollection()
          this.focusTracker = new ll()
          this.keystrokes = new dl()
          this.set('class', undefined)
          this.set('isCompact', false)
          this.itemsView = new tC(t)
          this.children = this.createCollection()
          this.children.add(this.itemsView)
          this.focusables = this.createCollection()
          const o = t.uiLanguageDirection === 'rtl'
          this._focusCycler = new Ud({
            focusables: this.focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: {
              focusPrevious: [o ? 'arrowright' : 'arrowleft', 'arrowup'],
              focusNext: [o ? 'arrowleft' : 'arrowright', 'arrowdown']
            }
          })
          const r = [
            'ck',
            'ck-toolbar',
            n.to('class'),
            n.if('isCompact', 'ck-toolbar_compact')
          ]
          if (this.options.shouldGroupWhenFull && this.options.isFloating) {
            r.push('ck-toolbar_floating')
          }
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: r,
              role: 'toolbar',
              'aria-label': n.to('ariaLabel'),
              style: { maxWidth: n.to('maxWidth') }
            },
            children: this.children,
            on: { mousedown: Gd(this) }
          })
          this._behavior = this.options.shouldGroupWhenFull
            ? new nC(this)
            : new eC(this)
        }
        render() {
          super.render()
          for (const t of this.items) {
            this.focusTracker.add(t.element)
          }
          this.items.on('add', (t, e) => {
            this.focusTracker.add(e.element)
          })
          this.items.on('remove', (t, e) => {
            this.focusTracker.remove(e.element)
          })
          this.keystrokes.listenTo(this.element)
          this._behavior.render(this)
        }
        destroy() {
          this._behavior.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
          return super.destroy()
        }
        focus() {
          this._focusCycler.focusFirst()
        }
        focusLast() {
          this._focusCycler.focusLast()
        }
        fillFromConfig(t, e, n) {
          this.items.addMany(this._buildItemsFromConfig(t, e, n))
        }
        _buildItemsFromConfig(t, e, n) {
          const i = Yd(t)
          const o = n || i.removeItems
          const r = this._cleanItemsConfiguration(i.items, e, o)
            .map((t) => {
              if (rt(t)) {
                return this._createNestedToolbarDropdown(t, e, o)
              } else if (t === '|') {
                return new qd()
              } else if (t === '-') {
                return new $d()
              }
              return e.create(t)
            })
            .filter((t) => !!t)
          return r
        }
        _cleanItemsConfiguration(t, e, n) {
          const i = t.filter((t, i, o) => {
            if (t === '|') {
              return true
            }
            if (n.indexOf(t) !== -1) {
              return false
            }
            if (t === '-') {
              if (this.options.shouldGroupWhenFull) {
                P('toolbarview-line-break-ignored-when-grouping-items', o)
                return false
              }
              return true
            }
            if (!rt(t) && !e.has(t)) {
              P('toolbarview-item-unavailable', { item: t })
              return false
            }
            return true
          })
          return this._cleanSeparatorsAndLineBreaks(i)
        }
        _cleanSeparatorsAndLineBreaks(t) {
          const e = (t) => t !== '-' && t !== '|'
          const n = t.length
          const i = t.findIndex(e)
          if (i === -1) {
            return []
          }
          const o = n - t.slice().reverse().findIndex(e)
          return t.slice(i, o).filter((t, n, i) => {
            if (e(t)) {
              return true
            }
            const o = n > 0 && i[n - 1] === t
            return !o
          })
        }
        _createNestedToolbarDropdown(t, e, n) {
          let {
            label: i,
            icon: o,
            items: r,
            tooltip: s = true,
            withText: a = false
          } = t
          r = this._cleanItemsConfiguration(r, e, n)
          if (!r.length) {
            return null
          }
          const c = this.locale
          const l = kC(c)
          if (!i) {
            P('toolbarview-nested-toolbar-dropdown-missing-label', t)
          }
          l.class = 'ck-toolbar__nested-toolbar-dropdown'
          l.buttonView.set({ label: i, tooltip: s, withText: !!a })
          if (o !== false) {
            l.buttonView.icon = Jv[o] || o || Zv
          } else {
            l.buttonView.withText = true
          }
          wC(l, () => l.toolbarView._buildItemsFromConfig(r, e, n))
          return l
        }
      }
      class tC extends Sl {
        constructor(t) {
          super(t)
          this.children = this.createCollection()
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-toolbar__items'] },
            children: this.children
          })
        }
      }
      class eC {
        constructor(t) {
          const e = t.bindTemplate
          t.set('isVertical', false)
          t.itemsView.children.bindTo(t.items).using((t) => t)
          t.focusables.bindTo(t.items).using((t) => t)
          t.extendTemplate({
            attributes: { class: [e.if('isVertical', 'ck-toolbar_vertical')] }
          })
        }
        render() {}
        destroy() {}
      }
      class nC {
        constructor(t) {
          this.view = t
          this.viewChildren = t.children
          this.viewFocusables = t.focusables
          this.viewItemsView = t.itemsView
          this.viewFocusTracker = t.focusTracker
          this.viewLocale = t.locale
          this.ungroupedItems = t.createCollection()
          this.groupedItems = t.createCollection()
          this.groupedItemsDropdown = this._createGroupedItemsDropdown()
          this.resizeObserver = null
          this.cachedPadding = null
          this.shouldUpdateGroupingOnNextResize = false
          t.itemsView.children.bindTo(this.ungroupedItems).using((t) => t)
          this.ungroupedItems.on(
            'change',
            this._updateFocusCycleableItems.bind(this)
          )
          t.children.on('change', this._updateFocusCycleableItems.bind(this))
          t.items.on('change', (t, e) => {
            const n = e.index
            const i = Array.from(e.added)
            for (const t of e.removed) {
              if (n >= this.ungroupedItems.length) {
                this.groupedItems.remove(t)
              } else {
                this.ungroupedItems.remove(t)
              }
            }
            for (let t = n; t < n + i.length; t++) {
              const e = i[t - n]
              if (t > this.ungroupedItems.length) {
                this.groupedItems.add(e, t - this.ungroupedItems.length)
              } else {
                this.ungroupedItems.add(e, t)
              }
            }
            this._updateGrouping()
          })
          t.extendTemplate({ attributes: { class: ['ck-toolbar_grouping'] } })
        }
        render(t) {
          this.viewElement = t.element
          this._enableGroupingOnResize()
          this._enableGroupingOnMaxWidthChange(t)
        }
        destroy() {
          this.groupedItemsDropdown.destroy()
          this.resizeObserver.destroy()
        }
        _updateGrouping() {
          if (!this.viewElement.ownerDocument.body.contains(this.viewElement)) {
            return
          }
          if (!kc(this.viewElement)) {
            this.shouldUpdateGroupingOnNextResize = true
            return
          }
          const t = this.groupedItems.length
          let e
          while (this._areItemsOverflowing) {
            this._groupLastItem()
            e = true
          }
          if (!e && this.groupedItems.length) {
            while (this.groupedItems.length && !this._areItemsOverflowing) {
              this._ungroupFirstItem()
            }
            if (this._areItemsOverflowing) {
              this._groupLastItem()
            }
          }
          if (this.groupedItems.length !== t) {
            this.view.fire('groupedItemsUpdate')
          }
        }
        get _areItemsOverflowing() {
          if (!this.ungroupedItems.length) {
            return false
          }
          const t = this.viewElement
          const e = this.viewLocale.uiLanguageDirection
          const n = new cc(t.lastChild)
          const i = new cc(t)
          if (!this.cachedPadding) {
            const n = ec.window.getComputedStyle(t)
            const i = e === 'ltr' ? 'paddingRight' : 'paddingLeft'
            this.cachedPadding = Number.parseInt(n[i])
          }
          if (e === 'ltr') {
            return n.right > i.right - this.cachedPadding
          } else {
            return n.left < i.left + this.cachedPadding
          }
        }
        _enableGroupingOnResize() {
          let t
          this.resizeObserver = new hc(this.viewElement, (e) => {
            if (
              !t ||
              t !== e.contentRect.width ||
              this.shouldUpdateGroupingOnNextResize
            ) {
              this.shouldUpdateGroupingOnNextResize = false
              this._updateGrouping()
              t = e.contentRect.width
            }
          })
          this._updateGrouping()
        }
        _enableGroupingOnMaxWidthChange(t) {
          t.on('change:maxWidth', () => {
            this._updateGrouping()
          })
        }
        _groupLastItem() {
          if (!this.groupedItems.length) {
            this.viewChildren.add(new qd())
            this.viewChildren.add(this.groupedItemsDropdown)
            this.viewFocusTracker.add(this.groupedItemsDropdown.element)
          }
          this.groupedItems.add(
            this.ungroupedItems.remove(this.ungroupedItems.last),
            0
          )
        }
        _ungroupFirstItem() {
          this.ungroupedItems.add(
            this.groupedItems.remove(this.groupedItems.first)
          )
          if (!this.groupedItems.length) {
            this.viewChildren.remove(this.groupedItemsDropdown)
            this.viewChildren.remove(this.viewChildren.last)
            this.viewFocusTracker.remove(this.groupedItemsDropdown.element)
          }
        }
        _createGroupedItemsDropdown() {
          const t = this.viewLocale
          const e = t.t
          const n = kC(t)
          n.class = 'ck-toolbar__grouped-dropdown'
          n.panelPosition = t.uiLanguageDirection === 'ltr' ? 'sw' : 'se'
          wC(n, this.groupedItems)
          n.buttonView.set({
            label: e('Show more items'),
            tooltip: true,
            tooltipPosition: t.uiLanguageDirection === 'rtl' ? 'se' : 'sw',
            icon: Zv
          })
          return n
        }
        _updateFocusCycleableItems() {
          this.viewFocusables.clear()
          this.ungroupedItems.map((t) => {
            this.viewFocusables.add(t)
          })
          if (this.groupedItems.length) {
            this.viewFocusables.add(this.groupedItemsDropdown)
          }
        }
      }
      var iC = __webpack_require__(1162)
      var oC = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      oC.insert = 'head'
      oC.singleton = true
      var rC = El()(iC.Z, oC)
      const sC = iC.Z.locals || {}
      class aC extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.items = this.createCollection()
          this.focusTracker = new ll()
          this.keystrokes = new dl()
          this._focusCycler = new Ud({
            focusables: this.items,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'arrowup', focusNext: 'arrowdown' }
          })
          this.set('ariaLabel', undefined)
          this.setTemplate({
            tag: 'ul',
            attributes: {
              class: ['ck', 'ck-reset', 'ck-list'],
              'aria-label': e.to('ariaLabel')
            },
            children: this.items
          })
        }
        render() {
          super.render()
          for (const t of this.items) {
            this.focusTracker.add(t.element)
          }
          this.items.on('add', (t, e) => {
            this.focusTracker.add(e.element)
          })
          this.items.on('remove', (t, e) => {
            this.focusTracker.remove(e.element)
          })
          this.keystrokes.listenTo(this.element)
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
        }
        focus() {
          this._focusCycler.focusFirst()
        }
        focusLast() {
          this._focusCycler.focusLast()
        }
      }
      class cC extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.set('isVisible', true)
          this.children = this.createCollection()
          this.setTemplate({
            tag: 'li',
            attributes: {
              class: [
                'ck',
                'ck-list__item',
                e.if('isVisible', 'ck-hidden', (t) => !t)
              ]
            },
            children: this.children
          })
        }
        focus() {
          this.children.first.focus()
        }
      }
      class lC extends Sl {
        constructor(t) {
          super(t)
          this.setTemplate({
            tag: 'li',
            attributes: { class: ['ck', 'ck-list__separator'] }
          })
        }
      }
      var dC = __webpack_require__(5075)
      var uC = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      uC.insert = 'head'
      uC.singleton = true
      var hC = El()(dC.Z, uC)
      const fC = dC.Z.locals || {}
      var mC = __webpack_require__(6875)
      var gC = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      gC.insert = 'head'
      gC.singleton = true
      var pC = El()(mC.Z, gC)
      const bC = mC.Z.locals || {}
      function kC(t, e = Ld) {
        const n = new e(t)
        const i = new Hd(t)
        const o = new Pd(t, n, i)
        n.bind('isEnabled').to(o)
        if (n instanceof Vd) {
          n.arrowView.bind('isOn').to(o, 'isOpen')
        } else {
          n.bind('isOn').to(o, 'isOpen')
        }
        yC(o)
        return o
      }
      function wC(t, e, n = {}) {
        t.extendTemplate({ attributes: { class: ['ck-toolbar-dropdown'] } })
        if (t.isOpen) {
          _C(t, e, n)
        } else {
          t.once('change:isOpen', () => _C(t, e, n), { priority: 'highest' })
        }
        if (n.enableActiveItemFocusOnDropdownOpen) {
          CC(t, () => t.toolbarView.items.find((t) => t.isOn))
        }
      }
      function _C(t, e, n) {
        const i = t.locale
        const o = i.t
        const r = (t.toolbarView = new Xv(i))
        const s = typeof e == 'function' ? e() : e
        r.ariaLabel = n.ariaLabel || o('Dropdown toolbar')
        if (n.maxWidth) {
          r.maxWidth = n.maxWidth
        }
        if (n.class) {
          r.class = n.class
        }
        if (n.isCompact) {
          r.isCompact = n.isCompact
        }
        if (n.isVertical) {
          r.isVertical = true
        }
        if (s instanceof Cl) {
          r.items.bindTo(s).using((t) => t)
        } else {
          r.items.addMany(s)
        }
        t.panelView.children.add(r)
        r.items.delegate('execute').to(t)
      }
      function AC(t, e, n = {}) {
        if (t.isOpen) {
          vC(t, e, n)
        } else {
          t.once('change:isOpen', () => vC(t, e, n), { priority: 'highest' })
        }
        CC(t, () =>
          t.listView.items.find((t) => {
            if (t instanceof cC) {
              return t.children.first.isOn
            }
            return false
          })
        )
      }
      function vC(t, e, n) {
        const i = t.locale
        const o = (t.listView = new aC(i))
        const r = typeof e == 'function' ? e() : e
        o.ariaLabel = n.ariaLabel
        o.items.bindTo(r).using((t) => {
          if (t.type === 'separator') {
            return new lC(i)
          } else if (t.type === 'button' || t.type === 'switchbutton') {
            const e = new cC(i)
            let n
            if (t.type === 'button') {
              n = new pd(i)
            } else {
              n = new Ad(i)
            }
            n.bind(...Object.keys(t.model)).to(t.model)
            n.delegate('execute').to(e)
            e.children.add(n)
            return e
          }
          return null
        })
        t.panelView.children.add(o)
        o.items.delegate('execute').to(t)
      }
      function CC(t, e) {
        t.on(
          'change:isOpen',
          () => {
            if (!t.isOpen) {
              return
            }
            const n = e()
            if (!n) {
              return
            }
            if (typeof n.focus === 'function') {
              n.focus()
            } else {
              P('ui-dropdown-focus-child-on-open-child-missing-focus', {
                view: n
              })
            }
          },
          { priority: I.low - 10 }
        )
      }
      function yC(t) {
        xC(t)
        EC(t)
        DC(t)
        TC(t)
        MC(t)
        IC(t)
      }
      function xC(e) {
        e.on('render', () => {
          t({
            emitter: e,
            activator: () => e.isOpen,
            callback: () => {
              e.isOpen = false
            },
            contextElements: [e.element]
          })
        })
      }
      function EC(t) {
        t.on('execute', (e) => {
          if (e.source instanceof Ad) {
            return
          }
          t.isOpen = false
        })
      }
      function DC(t) {
        t.focusTracker.on('change:isFocused', (e, n, i) => {
          if (t.isOpen && !i) {
            t.isOpen = false
          }
        })
      }
      function TC(t) {
        t.keystrokes.set('arrowdown', (e, n) => {
          if (t.isOpen) {
            t.panelView.focus()
            n()
          }
        })
        t.keystrokes.set('arrowup', (e, n) => {
          if (t.isOpen) {
            t.panelView.focusLast()
            n()
          }
        })
      }
      function MC(t) {
        t.on('change:isOpen', (e, n, i) => {
          if (i) {
            return
          }
          const o = t.panelView.element
          if (o && o.contains(ec.document.activeElement)) {
            t.buttonView.focus()
          }
        })
      }
      function IC(t) {
        t.on(
          'change:isOpen',
          (e, n, i) => {
            if (!i) {
              return
            }
            t.panelView.focus()
          },
          { priority: 'low' }
        )
      }
      var SC = __webpack_require__(8245)
      var BC = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      BC.insert = 'head'
      BC.singleton = true
      var NC = El()(SC.Z, BC)
      const PC = SC.Z.locals || {}
      const zC = mc('px')
      const LC = ec.document.body
      class OC extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.set('top', 0)
          this.set('left', 0)
          this.set('position', 'arrow_nw')
          this.set('isVisible', false)
          this.set('withArrow', true)
          this.set('class', undefined)
          this._pinWhenIsVisibleCallback = null
          this.content = this.createCollection()
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-balloon-panel',
                e.to('position', (t) => `ck-balloon-panel_${t}`),
                e.if('isVisible', 'ck-balloon-panel_visible'),
                e.if('withArrow', 'ck-balloon-panel_with-arrow'),
                e.to('class')
              ],
              style: { top: e.to('top', zC), left: e.to('left', zC) }
            },
            children: this.content
          })
        }
        show() {
          this.isVisible = true
        }
        hide() {
          this.isVisible = false
        }
        attachTo(t) {
          this.show()
          const e = OC.defaultPositions
          const n = Object.assign(
            {},
            {
              element: this.element,
              positions: [
                e.southArrowNorth,
                e.southArrowNorthMiddleWest,
                e.southArrowNorthMiddleEast,
                e.southArrowNorthWest,
                e.southArrowNorthEast,
                e.northArrowSouth,
                e.northArrowSouthMiddleWest,
                e.northArrowSouthMiddleEast,
                e.northArrowSouthWest,
                e.northArrowSouthEast,
                e.viewportStickyNorth
              ],
              limiter: LC,
              fitInViewport: true
            },
            t
          )
          const i = OC._getOptimalPosition(n)
          const o = parseInt(i.left)
          const r = parseInt(i.top)
          const s = i.name
          const a = i.config || {}
          const { withArrow: c = true } = a
          this.top = r
          this.left = o
          this.position = s
          this.withArrow = c
        }
        pin(t) {
          this.unpin()
          this._pinWhenIsVisibleCallback = () => {
            if (this.isVisible) {
              this._startPinning(t)
            } else {
              this._stopPinning()
            }
          }
          this._startPinning(t)
          this.listenTo(
            this,
            'change:isVisible',
            this._pinWhenIsVisibleCallback
          )
        }
        unpin() {
          if (this._pinWhenIsVisibleCallback) {
            this._stopPinning()
            this.stopListening(
              this,
              'change:isVisible',
              this._pinWhenIsVisibleCallback
            )
            this._pinWhenIsVisibleCallback = null
            this.hide()
          }
        }
        _startPinning(t) {
          this.attachTo(t)
          const e = RC(t.target)
          const n = t.limiter ? RC(t.limiter) : LC
          this.listenTo(
            ec.document,
            'scroll',
            (i, o) => {
              const r = o.target
              const s = e && r.contains(e)
              const a = n && r.contains(n)
              if (s || a || !e || !n) {
                this.attachTo(t)
              }
            },
            { useCapture: true }
          )
          this.listenTo(ec.window, 'resize', () => {
            this.attachTo(t)
          })
        }
        _stopPinning() {
          this.stopListening(ec.document, 'scroll')
          this.stopListening(ec.window, 'resize')
        }
      }
      OC.arrowSideOffset = 25
      OC.arrowHeightOffset = 10
      OC.stickyVerticalOffset = 20
      OC._getOptimalPosition = _c
      OC.defaultPositions = jC()
      function RC(t) {
        if (Ua(t)) {
          return t
        }
        if (rc(t)) {
          return t.commonAncestorContainer
        }
        if (typeof t == 'function') {
          return RC(t())
        }
        return null
      }
      function jC(t = {}) {
        const {
          sideOffset: e = OC.arrowSideOffset,
          heightOffset: n = OC.arrowHeightOffset,
          stickyVerticalOffset: i = OC.stickyVerticalOffset,
          config: o
        } = t
        return {
          northWestArrowSouthWest: (t, n) => ({
            top: r(t, n),
            left: t.left - e,
            name: 'arrow_sw',
            ...(o && { config: o })
          }),
          northWestArrowSouthMiddleWest: (t, n) => ({
            top: r(t, n),
            left: t.left - n.width * 0.25 - e,
            name: 'arrow_smw',
            ...(o && { config: o })
          }),
          northWestArrowSouth: (t, e) => ({
            top: r(t, e),
            left: t.left - e.width / 2,
            name: 'arrow_s',
            ...(o && { config: o })
          }),
          northWestArrowSouthMiddleEast: (t, n) => ({
            top: r(t, n),
            left: t.left - n.width * 0.75 + e,
            name: 'arrow_sme',
            ...(o && { config: o })
          }),
          northWestArrowSouthEast: (t, n) => ({
            top: r(t, n),
            left: t.left - n.width + e,
            name: 'arrow_se',
            ...(o && { config: o })
          }),
          northArrowSouthWest: (t, n) => ({
            top: r(t, n),
            left: t.left + t.width / 2 - e,
            name: 'arrow_sw',
            ...(o && { config: o })
          }),
          northArrowSouthMiddleWest: (t, n) => ({
            top: r(t, n),
            left: t.left + t.width / 2 - n.width * 0.25 - e,
            name: 'arrow_smw',
            ...(o && { config: o })
          }),
          northArrowSouth: (t, e) => ({
            top: r(t, e),
            left: t.left + t.width / 2 - e.width / 2,
            name: 'arrow_s',
            ...(o && { config: o })
          }),
          northArrowSouthMiddleEast: (t, n) => ({
            top: r(t, n),
            left: t.left + t.width / 2 - n.width * 0.75 + e,
            name: 'arrow_sme',
            ...(o && { config: o })
          }),
          northArrowSouthEast: (t, n) => ({
            top: r(t, n),
            left: t.left + t.width / 2 - n.width + e,
            name: 'arrow_se',
            ...(o && { config: o })
          }),
          northEastArrowSouthWest: (t, n) => ({
            top: r(t, n),
            left: t.right - e,
            name: 'arrow_sw',
            ...(o && { config: o })
          }),
          northEastArrowSouthMiddleWest: (t, n) => ({
            top: r(t, n),
            left: t.right - n.width * 0.25 - e,
            name: 'arrow_smw',
            ...(o && { config: o })
          }),
          northEastArrowSouth: (t, e) => ({
            top: r(t, e),
            left: t.right - e.width / 2,
            name: 'arrow_s',
            ...(o && { config: o })
          }),
          northEastArrowSouthMiddleEast: (t, n) => ({
            top: r(t, n),
            left: t.right - n.width * 0.75 + e,
            name: 'arrow_sme',
            ...(o && { config: o })
          }),
          northEastArrowSouthEast: (t, n) => ({
            top: r(t, n),
            left: t.right - n.width + e,
            name: 'arrow_se',
            ...(o && { config: o })
          }),
          southWestArrowNorthWest: (t) => ({
            top: s(t),
            left: t.left - e,
            name: 'arrow_nw',
            ...(o && { config: o })
          }),
          southWestArrowNorthMiddleWest: (t, n) => ({
            top: s(t),
            left: t.left - n.width * 0.25 - e,
            name: 'arrow_nmw',
            ...(o && { config: o })
          }),
          southWestArrowNorth: (t, e) => ({
            top: s(t),
            left: t.left - e.width / 2,
            name: 'arrow_n',
            ...(o && { config: o })
          }),
          southWestArrowNorthMiddleEast: (t, n) => ({
            top: s(t),
            left: t.left - n.width * 0.75 + e,
            name: 'arrow_nme',
            ...(o && { config: o })
          }),
          southWestArrowNorthEast: (t, n) => ({
            top: s(t),
            left: t.left - n.width + e,
            name: 'arrow_ne',
            ...(o && { config: o })
          }),
          southArrowNorthWest: (t) => ({
            top: s(t),
            left: t.left + t.width / 2 - e,
            name: 'arrow_nw',
            ...(o && { config: o })
          }),
          southArrowNorthMiddleWest: (t, n) => ({
            top: s(t),
            left: t.left + t.width / 2 - n.width * 0.25 - e,
            name: 'arrow_nmw',
            ...(o && { config: o })
          }),
          southArrowNorth: (t, e) => ({
            top: s(t),
            left: t.left + t.width / 2 - e.width / 2,
            name: 'arrow_n',
            ...(o && { config: o })
          }),
          southArrowNorthMiddleEast: (t, n) => ({
            top: s(t),
            left: t.left + t.width / 2 - n.width * 0.75 + e,
            name: 'arrow_nme',
            ...(o && { config: o })
          }),
          southArrowNorthEast: (t, n) => ({
            top: s(t),
            left: t.left + t.width / 2 - n.width + e,
            name: 'arrow_ne',
            ...(o && { config: o })
          }),
          southEastArrowNorthWest: (t) => ({
            top: s(t),
            left: t.right - e,
            name: 'arrow_nw',
            ...(o && { config: o })
          }),
          southEastArrowNorthMiddleWest: (t, n) => ({
            top: s(t),
            left: t.right - n.width * 0.25 - e,
            name: 'arrow_nmw',
            ...(o && { config: o })
          }),
          southEastArrowNorth: (t, e) => ({
            top: s(t),
            left: t.right - e.width / 2,
            name: 'arrow_n',
            ...(o && { config: o })
          }),
          southEastArrowNorthMiddleEast: (t, n) => ({
            top: s(t),
            left: t.right - n.width * 0.75 + e,
            name: 'arrow_nme',
            ...(o && { config: o })
          }),
          southEastArrowNorthEast: (t, n) => ({
            top: s(t),
            left: t.right - n.width + e,
            name: 'arrow_ne',
            ...(o && { config: o })
          }),
          westArrowEast: (t, e) => ({
            top: t.top + t.height / 2 - e.height / 2,
            left: t.left - e.width - n,
            name: 'arrow_e',
            ...(o && { config: o })
          }),
          eastArrowWest: (t, e) => ({
            top: t.top + t.height / 2 - e.height / 2,
            left: t.right + n,
            name: 'arrow_w',
            ...(o && { config: o })
          }),
          viewportStickyNorth: (t, e, n) => {
            if (!t.getIntersection(n)) {
              return null
            }
            return {
              top: n.top + i,
              left: t.left + t.width / 2 - e.width / 2,
              name: 'arrowless',
              config: { withArrow: false, ...o }
            }
          }
        }
        function r(t, e) {
          return t.top - e.height - n
        }
        function s(t) {
          return t.bottom + n
        }
      }
      var FC = __webpack_require__(9948)
      var VC = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      VC.insert = 'head'
      VC.singleton = true
      var HC = El()(FC.Z, VC)
      const UC = FC.Z.locals || {}
      const WC = 'ck-tooltip'
      class qC extends Qa() {
        constructor(t) {
          super()
          qC._editors.add(t)
          if (qC._instance) {
            return qC._instance
          }
          qC._instance = this
          this.tooltipTextView = new Sl(t.locale)
          this.tooltipTextView.set('text', '')
          this.tooltipTextView.setTemplate({
            tag: 'span',
            attributes: { class: ['ck', 'ck-tooltip__text'] },
            children: [{ text: this.tooltipTextView.bindTemplate.to('text') }]
          })
          this.balloonPanelView = new OC(t.locale)
          this.balloonPanelView.class = WC
          this.balloonPanelView.content.add(this.tooltipTextView)
          this._resizeObserver = null
          this._currentElementWithTooltip = null
          this._currentTooltipPosition = null
          this._pinTooltipDebounced = yg(this._pinTooltip, 600)
          this.listenTo(
            ec.document,
            'mouseenter',
            this._onEnterOrFocus.bind(this),
            { useCapture: true }
          )
          this.listenTo(
            ec.document,
            'mouseleave',
            this._onLeaveOrBlur.bind(this),
            { useCapture: true }
          )
          this.listenTo(ec.document, 'focus', this._onEnterOrFocus.bind(this), {
            useCapture: true
          })
          this.listenTo(ec.document, 'blur', this._onLeaveOrBlur.bind(this), {
            useCapture: true
          })
          this.listenTo(ec.document, 'scroll', this._onScroll.bind(this), {
            useCapture: true
          })
          this._watchdogExcluded = true
        }
        destroy(t) {
          const e = t.ui.view && t.ui.view.body
          qC._editors.delete(t)
          this.stopListening(t.ui)
          if (e && e.has(this.balloonPanelView)) {
            e.remove(this.balloonPanelView)
          }
          if (!qC._editors.size) {
            this._unpinTooltip()
            this.balloonPanelView.destroy()
            this.stopListening()
            qC._instance = null
          }
        }
        static getPositioningFunctions(t) {
          const e = qC.defaultBalloonPositions
          return {
            s: [
              e.southArrowNorth,
              e.southArrowNorthEast,
              e.southArrowNorthWest
            ],
            n: [e.northArrowSouth],
            e: [e.eastArrowWest],
            w: [e.westArrowEast],
            sw: [e.southArrowNorthEast],
            se: [e.southArrowNorthWest]
          }[t]
        }
        _onEnterOrFocus(t, { target: e }) {
          const n = $C(e)
          if (!n) {
            return
          }
          if (n === this._currentElementWithTooltip) {
            return
          }
          this._unpinTooltip()
          this._pinTooltipDebounced(n, GC(n))
        }
        _onLeaveOrBlur(t, { target: e, relatedTarget: n }) {
          if (t.name === 'mouseleave') {
            if (!Ua(e)) {
              return
            }
            if (
              this._currentElementWithTooltip &&
              e !== this._currentElementWithTooltip
            ) {
              return
            }
            const t = $C(e)
            const i = $C(n)
            if (t && t !== i) {
              this._unpinTooltip()
            }
          } else {
            if (
              this._currentElementWithTooltip &&
              e !== this._currentElementWithTooltip
            ) {
              return
            }
            this._unpinTooltip()
          }
        }
        _onScroll(t, { target: e }) {
          if (!this._currentElementWithTooltip) {
            return
          }
          if (
            e.contains(this.balloonPanelView.element) &&
            e.contains(this._currentElementWithTooltip)
          ) {
            return
          }
          this._unpinTooltip()
        }
        _pinTooltip(t, { text: e, position: n, cssClass: i }) {
          const o = cl(qC._editors.values()).ui.view.body
          if (!o.has(this.balloonPanelView)) {
            o.add(this.balloonPanelView)
          }
          this.tooltipTextView.text = e
          this.balloonPanelView.pin({
            target: t,
            positions: qC.getPositioningFunctions(n)
          })
          this._resizeObserver = new hc(t, () => {
            if (!kc(t)) {
              this._unpinTooltip()
            }
          })
          this.balloonPanelView.class = [WC, i].filter((t) => t).join(' ')
          for (const t of qC._editors) {
            this.listenTo(
              t.ui,
              'update',
              this._updateTooltipPosition.bind(this),
              { priority: 'low' }
            )
          }
          this._currentElementWithTooltip = t
          this._currentTooltipPosition = n
        }
        _unpinTooltip() {
          this._pinTooltipDebounced.cancel()
          this.balloonPanelView.unpin()
          for (const t of qC._editors) {
            this.stopListening(t.ui, 'update')
          }
          this._currentElementWithTooltip = null
          this._currentTooltipPosition = null
          if (this._resizeObserver) {
            this._resizeObserver.destroy()
          }
        }
        _updateTooltipPosition() {
          if (!kc(this._currentElementWithTooltip)) {
            this._unpinTooltip()
            return
          }
          this.balloonPanelView.pin({
            target: this._currentElementWithTooltip,
            positions: qC.getPositioningFunctions(this._currentTooltipPosition)
          })
        }
      }
      qC.defaultBalloonPositions = jC({ heightOffset: 5, sideOffset: 13 })
      qC._editors = new Set()
      qC._instance = null
      function $C(t) {
        if (!Ua(t)) {
          return null
        }
        return t.closest(
          '[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])'
        )
      }
      function GC(t) {
        return {
          text: t.dataset.ckeTooltipText,
          position: t.dataset.ckeTooltipPosition || 's',
          cssClass: t.dataset.ckeTooltipClass || ''
        }
      }
      class YC extends ht() {
        constructor(t) {
          super()
          this.editor = t
          this.componentFactory = new Td(t)
          this.focusTracker = new ll()
          this.tooltipManager = new qC(t)
          this.set('viewportOffset', this._readViewportOffsetFromConfig())
          this.isReady = false
          this.once('ready', () => {
            this.isReady = true
          })
          this._editableElementsMap = new Map()
          this._focusableToolbarDefinitions = []
          this.listenTo(t.editing.view.document, 'layoutChanged', () =>
            this.update()
          )
          this._initFocusTracking()
        }
        get element() {
          return null
        }
        update() {
          this.fire('update')
        }
        destroy() {
          this.stopListening()
          this.focusTracker.destroy()
          this.tooltipManager.destroy(this.editor)
          for (const t of this._editableElementsMap.values()) {
            t.ckeditorInstance = null
          }
          this._editableElementsMap = new Map()
          this._focusableToolbarDefinitions = []
        }
        setEditableElement(t, e) {
          this._editableElementsMap.set(t, e)
          if (!e.ckeditorInstance) {
            e.ckeditorInstance = this.editor
          }
          this.focusTracker.add(e)
          const n = () => {
            if (this.editor.editing.view.getDomRoot(t)) {
              return
            }
            this.editor.keystrokes.listenTo(e)
          }
          if (this.isReady) {
            n()
          } else {
            this.once('ready', n)
          }
        }
        getEditableElement(t = 'main') {
          return this._editableElementsMap.get(t)
        }
        getEditableElementsNames() {
          return this._editableElementsMap.keys()
        }
        addToolbar(t, e = {}) {
          if (t.isRendered) {
            this.focusTracker.add(t.element)
            this.editor.keystrokes.listenTo(t.element)
          } else {
            t.once('render', () => {
              this.focusTracker.add(t.element)
              this.editor.keystrokes.listenTo(t.element)
            })
          }
          this._focusableToolbarDefinitions.push({ toolbarView: t, options: e })
        }
        get _editableElements() {
          console.warn(
            'editor-ui-deprecated-editable-elements: ' +
              'The EditorUI#_editableElements property has been deprecated and will be removed in the near future.',
            { editorUI: this }
          )
          return this._editableElementsMap
        }
        _readViewportOffsetFromConfig() {
          const t = this.editor
          const e = t.config.get('ui.viewportOffset')
          if (e) {
            return e
          }
          const n = t.config.get('toolbar.viewportTopOffset')
          if (n) {
            console.warn(
              'editor-ui-deprecated-viewport-offset-config: ' +
                'The `toolbar.vieportTopOffset` configuration option is deprecated. ' +
                'It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead.'
            )
            return { top: n }
          }
          return { top: 0 }
        }
        _initFocusTracking() {
          const t = this.editor
          const e = t.editing.view
          let n
          let i
          t.keystrokes.set('Alt+F10', (t, o) => {
            const r = this.focusTracker.focusedElement
            if (
              Array.from(this._editableElementsMap.values()).includes(r) &&
              !Array.from(e.domRoots.values()).includes(r)
            ) {
              n = r
            }
            const s = this._getCurrentFocusedToolbarDefinition()
            if (!s || !i) {
              i = this._getFocusableCandidateToolbarDefinitions()
            }
            for (let t = 0; t < i.length; t++) {
              const t = i.shift()
              i.push(t)
              if (t !== s && this._focusFocusableCandidateToolbar(t)) {
                if (s && s.options.afterBlur) {
                  s.options.afterBlur()
                }
                break
              }
            }
            o()
          })
          t.keystrokes.set('Esc', (e, i) => {
            const o = this._getCurrentFocusedToolbarDefinition()
            if (!o) {
              return
            }
            if (n) {
              n.focus()
              n = null
            } else {
              t.editing.view.focus()
            }
            if (o.options.afterBlur) {
              o.options.afterBlur()
            }
            i()
          })
        }
        _getFocusableCandidateToolbarDefinitions() {
          const t = []
          for (const e of this._focusableToolbarDefinitions) {
            const { toolbarView: n, options: i } = e
            if (kc(n.element) || i.beforeFocus) {
              t.push(e)
            }
          }
          t.sort((t, e) => KC(t) - KC(e))
          return t
        }
        _getCurrentFocusedToolbarDefinition() {
          for (const t of this._focusableToolbarDefinitions) {
            if (
              t.toolbarView.element &&
              t.toolbarView.element.contains(this.focusTracker.focusedElement)
            ) {
              return t
            }
          }
          return null
        }
        _focusFocusableCandidateToolbar(t) {
          const {
            toolbarView: e,
            options: { beforeFocus: n }
          } = t
          if (n) {
            n()
          }
          if (!kc(e.element)) {
            return false
          }
          e.focus()
          return true
        }
      }
      function KC(t) {
        const { toolbarView: e, options: n } = t
        let i = 10
        if (kc(e.element)) {
          i--
        }
        if (n.isContextual) {
          i--
        }
        return i
      }
      var QC = __webpack_require__(4547)
      var ZC = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      ZC.insert = 'head'
      ZC.singleton = true
      var JC = El()(QC.Z, ZC)
      const XC = QC.Z.locals || {}
      class ty extends Sl {
        constructor(t) {
          super(t)
          this.body = new sd(t)
        }
        render() {
          super.render()
          this.body.attachToDom()
        }
        destroy() {
          this.body.detachFromDom()
          return super.destroy()
        }
      }
      var ey = __webpack_require__(2751)
      var ny = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      ny.insert = 'head'
      ny.singleton = true
      var iy = El()(ey.Z, ny)
      const oy = ey.Z.locals || {}
      class ry extends Sl {
        constructor(t) {
          super(t)
          this.set('text', undefined)
          this.set('for', undefined)
          this.id = `ck-editor__label_${T()}`
          const e = this.bindTemplate
          this.setTemplate({
            tag: 'label',
            attributes: {
              class: ['ck', 'ck-label'],
              id: this.id,
              for: e.to('for')
            },
            children: [{ text: e.to('text') }]
          })
        }
      }
      class sy extends ty {
        constructor(t) {
          super(t)
          this.top = this.createCollection()
          this.main = this.createCollection()
          this._voiceLabelView = this._createVoiceLabel()
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-reset', 'ck-editor', 'ck-rounded-corners'],
              role: 'application',
              dir: t.uiLanguageDirection,
              lang: t.uiLanguage,
              'aria-labelledby': this._voiceLabelView.id
            },
            children: [
              this._voiceLabelView,
              {
                tag: 'div',
                attributes: {
                  class: ['ck', 'ck-editor__top', 'ck-reset_all'],
                  role: 'presentation'
                },
                children: this.top
              },
              {
                tag: 'div',
                attributes: {
                  class: ['ck', 'ck-editor__main'],
                  role: 'presentation'
                },
                children: this.main
              }
            ]
          })
        }
        _createVoiceLabel() {
          const t = this.t
          const e = new ry()
          e.text = t('Rich Text Editor')
          e.extendTemplate({ attributes: { class: 'ck-voice-label' } })
          return e
        }
      }
      class ay extends Sl {
        constructor(t, e, n) {
          super(t)
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-content',
                'ck-editor__editable',
                'ck-rounded-corners'
              ],
              lang: t.contentLanguage,
              dir: t.contentLanguageDirection
            }
          })
          this.name = null
          this.set('isFocused', false)
          this._editableElement = n
          this._hasExternalElement = !!this._editableElement
          this._editingView = e
        }
        render() {
          super.render()
          if (this._hasExternalElement) {
            this.template.apply((this.element = this._editableElement))
          } else {
            this._editableElement = this.element
          }
          this.on('change:isFocused', () => this._updateIsFocusedClasses())
          this._updateIsFocusedClasses()
        }
        destroy() {
          if (this._hasExternalElement) {
            this.template.revert(this._editableElement)
          }
          super.destroy()
        }
        _updateIsFocusedClasses() {
          const t = this._editingView
          if (t.isRenderingInProgress) {
            n(this)
          } else {
            e(this)
          }
          function e(e) {
            t.change((n) => {
              const i = t.document.getRoot(e.name)
              n.addClass(e.isFocused ? 'ck-focused' : 'ck-blurred', i)
              n.removeClass(e.isFocused ? 'ck-blurred' : 'ck-focused', i)
            })
          }
          function n(i) {
            t.once('change:isRenderingInProgress', (t, o, r) => {
              if (!r) {
                e(i)
              } else {
                n(i)
              }
            })
          }
        }
      }
      class cy extends ay {
        constructor(t, e, n, i = {}) {
          super(t, e, n)
          const o = t.t
          this.extendTemplate({
            attributes: { role: 'textbox', class: 'ck-editor__editable_inline' }
          })
          this._generateLabel =
            i.label || (() => o('Editor editing area: %0', this.name))
        }
        render() {
          super.render()
          const t = this._editingView
          t.change((e) => {
            const n = t.document.getRoot(this.name)
            e.setAttribute('aria-label', this._generateLabel(this), n)
          })
        }
      }
      var ly = __webpack_require__(5523)
      var dy = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      dy.insert = 'head'
      dy.singleton = true
      var uy = El()(ly.Z, dy)
      const hy = ly.Z.locals || {}
      class fy extends (null && View) {
        constructor(t, e = {}) {
          super(t)
          const n = this.bindTemplate
          this.set('label', e.label || '')
          this.set('class', e.class || null)
          this.children = this.createCollection()
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-form__header', n.to('class')] },
            children: this.children
          })
          const i = new View(t)
          i.setTemplate({
            tag: 'h2',
            attributes: { class: ['ck', 'ck-form__header__label'] },
            children: [{ text: n.to('label') }]
          })
          this.children.add(i)
        }
      }
      var my = __webpack_require__(6985)
      var gy = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      gy.insert = 'head'
      gy.singleton = true
      var py = El()(my.Z, gy)
      const by = my.Z.locals || {}
      class ky extends Sl {
        constructor(t) {
          super(t)
          this.set('value', undefined)
          this.set('id', undefined)
          this.set('placeholder', undefined)
          this.set('isReadOnly', false)
          this.set('hasError', false)
          this.set('ariaDescribedById', undefined)
          this.focusTracker = new ll()
          this.bind('isFocused').to(this.focusTracker)
          this.set('isEmpty', true)
          this.set('inputMode', 'text')
          const e = this.bindTemplate
          this.setTemplate({
            tag: 'input',
            attributes: {
              class: [
                'ck',
                'ck-input',
                e.if('isFocused', 'ck-input_focused'),
                e.if('isEmpty', 'ck-input-text_empty'),
                e.if('hasError', 'ck-error')
              ],
              id: e.to('id'),
              placeholder: e.to('placeholder'),
              readonly: e.to('isReadOnly'),
              inputmode: e.to('inputMode'),
              'aria-invalid': e.if('hasError', true),
              'aria-describedby': e.to('ariaDescribedById')
            },
            on: {
              input: e.to((...t) => {
                this.fire('input', ...t)
                this._updateIsEmpty()
              }),
              change: e.to(this._updateIsEmpty.bind(this))
            }
          })
        }
        render() {
          super.render()
          this.focusTracker.add(this.element)
          this._setDomElementValue(this.value)
          this._updateIsEmpty()
          this.on('change:value', (t, e, n) => {
            this._setDomElementValue(n)
            this._updateIsEmpty()
          })
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
        }
        select() {
          this.element.select()
        }
        focus() {
          this.element.focus()
        }
        _updateIsEmpty() {
          this.isEmpty = wy(this.element)
        }
        _setDomElementValue(t) {
          this.element.value = !t && t !== 0 ? '' : t
        }
      }
      function wy(t) {
        return !t.value
      }
      class _y extends ky {
        constructor(t) {
          super(t)
          this.extendTemplate({
            attributes: { type: 'text', class: ['ck-input-text'] }
          })
        }
      }
      class Ay extends (null && InputView) {
        constructor(t, { min: e, max: n, step: i } = {}) {
          super(t)
          const o = this.bindTemplate
          this.set('min', e)
          this.set('max', n)
          this.set('step', i)
          this.extendTemplate({
            attributes: {
              type: 'number',
              class: ['ck-input-number'],
              min: o.to('min'),
              max: o.to('max'),
              step: o.to('step')
            }
          })
        }
      }
      class vy extends (null && View) {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.setTemplate({
            tag: 'iframe',
            attributes: {
              class: ['ck', 'ck-reset_all'],
              sandbox: 'allow-same-origin allow-scripts'
            },
            on: { load: e.to('loaded') }
          })
        }
        render() {
          return new Promise((t) => {
            this.on('loaded', t)
            return super.render()
          })
        }
      }
      var Cy = __webpack_require__(8111)
      var yy = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      yy.insert = 'head'
      yy.singleton = true
      var xy = El()(Cy.Z, yy)
      const Ey = Cy.Z.locals || {}
      class Dy extends Sl {
        constructor(t, e) {
          super(t)
          const n = `ck-labeled-field-view-${T()}`
          const i = `ck-labeled-field-view-status-${T()}`
          this.fieldView = e(this, n, i)
          this.set('label', undefined)
          this.set('isEnabled', true)
          this.set('isEmpty', true)
          this.set('isFocused', false)
          this.set('errorText', null)
          this.set('infoText', null)
          this.set('class', undefined)
          this.set('placeholder', undefined)
          this.labelView = this._createLabelView(n)
          this.statusView = this._createStatusView(i)
          this.fieldWrapperChildren = this.createCollection([
            this.fieldView,
            this.labelView
          ])
          this.bind('_statusText').to(
            this,
            'errorText',
            this,
            'infoText',
            (t, e) => t || e
          )
          const o = this.bindTemplate
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-labeled-field-view',
                o.to('class'),
                o.if('isEnabled', 'ck-disabled', (t) => !t),
                o.if('isEmpty', 'ck-labeled-field-view_empty'),
                o.if('isFocused', 'ck-labeled-field-view_focused'),
                o.if('placeholder', 'ck-labeled-field-view_placeholder'),
                o.if('errorText', 'ck-error')
              ]
            },
            children: [
              {
                tag: 'div',
                attributes: {
                  class: ['ck', 'ck-labeled-field-view__input-wrapper']
                },
                children: this.fieldWrapperChildren
              },
              this.statusView
            ]
          })
        }
        _createLabelView(t) {
          const e = new ry(this.locale)
          e.for = t
          e.bind('text').to(this, 'label')
          return e
        }
        _createStatusView(t) {
          const e = new Sl(this.locale)
          const n = this.bindTemplate
          e.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-labeled-field-view__status',
                n.if('errorText', 'ck-labeled-field-view__status_error'),
                n.if('_statusText', 'ck-hidden', (t) => !t)
              ],
              id: t,
              role: n.if('errorText', 'alert')
            },
            children: [{ text: n.to('_statusText') }]
          })
          return e
        }
        focus() {
          this.fieldView.focus()
        }
      }
      function Ty(t, e, n) {
        const i = new _y(t.locale)
        i.set({ id: e, ariaDescribedById: n })
        i.bind('isReadOnly').to(t, 'isEnabled', (t) => !t)
        i.bind('hasError').to(t, 'errorText', (t) => !!t)
        i.on('input', () => {
          t.errorText = null
        })
        t.bind('isEmpty', 'isFocused', 'placeholder').to(i)
        return i
      }
      function My(t, e, n) {
        const i = new InputNumberView(t.locale)
        i.set({ id: e, ariaDescribedById: n, inputMode: 'numeric' })
        i.bind('isReadOnly').to(t, 'isEnabled', (t) => !t)
        i.bind('hasError').to(t, 'errorText', (t) => !!t)
        i.on('input', () => {
          t.errorText = null
        })
        t.bind('isEmpty', 'isFocused', 'placeholder').to(i)
        return i
      }
      function Iy(t, e, n) {
        const i = createDropdown(t.locale)
        i.set({ id: e, ariaDescribedById: n })
        i.bind('isEnabled').to(t)
        return i
      }
      class Sy extends nu {
        static get pluginName() {
          return 'Notification'
        }
        init() {
          this.on(
            'show:warning',
            (t, e) => {
              window.alert(e.message)
            },
            { priority: 'lowest' }
          )
        }
        showSuccess(t, e = {}) {
          this._showNotification({
            message: t,
            type: 'success',
            namespace: e.namespace,
            title: e.title
          })
        }
        showInfo(t, e = {}) {
          this._showNotification({
            message: t,
            type: 'info',
            namespace: e.namespace,
            title: e.title
          })
        }
        showWarning(t, e = {}) {
          this._showNotification({
            message: t,
            type: 'warning',
            namespace: e.namespace,
            title: e.title
          })
        }
        _showNotification(t) {
          const e = t.namespace
            ? `show:${t.type}:${t.namespace}`
            : `show:${t.type}`
          this.fire(e, {
            message: t.message,
            type: t.type,
            title: t.title || ''
          })
        }
      }
      class By extends ht() {
        constructor(t, e) {
          super()
          if (e) {
            eg(this, e)
          }
          if (t) {
            this.set(t)
          }
        }
      }
      const Ny =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'
      const Py =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'
      var zy = __webpack_require__(1757)
      var Ly = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Ly.insert = 'head'
      Ly.singleton = true
      var Oy = El()(zy.Z, Ly)
      const Ry = zy.Z.locals || {}
      var jy = __webpack_require__(3553)
      var Fy = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Fy.insert = 'head'
      Fy.singleton = true
      var Vy = El()(jy.Z, Fy)
      const Hy = jy.Z.locals || {}
      const Uy = mc('px')
      class Wy extends Kd {
        static get pluginName() {
          return 'ContextualBalloon'
        }
        constructor(t) {
          super(t)
          this._view = null
          this._rotatorView = null
          this._fakePanelsView = null
          this.positionLimiter = () => {
            const t = this.editor.editing.view
            const e = t.document
            const n = e.selection.editableElement
            if (n) {
              return t.domConverter.mapViewToDom(n.root)
            }
            return null
          }
          this.set('visibleView', null)
          this._viewToStack = new Map()
          this._idToStack = new Map()
          this.set('_numberOfStacks', 0)
          this.set('_singleViewMode', false)
          this._rotatorView = null
          this._fakePanelsView = null
        }
        destroy() {
          super.destroy()
          if (this._view) {
            this._view.destroy()
          }
          if (this._rotatorView) {
            this._rotatorView.destroy()
          }
          if (this._fakePanelsView) {
            this._fakePanelsView.destroy()
          }
        }
        get view() {
          if (!this._view) {
            this._createPanelView()
          }
          return this._view
        }
        hasView(t) {
          return Array.from(this._viewToStack.keys()).includes(t)
        }
        add(t) {
          if (!this._view) {
            this._createPanelView()
          }
          if (this.hasView(t.view)) {
            throw new N('contextualballoon-add-view-exist', [this, t])
          }
          const e = t.stackId || 'main'
          if (!this._idToStack.has(e)) {
            this._idToStack.set(e, new Map([[t.view, t]]))
            this._viewToStack.set(t.view, this._idToStack.get(e))
            this._numberOfStacks = this._idToStack.size
            if (!this._visibleStack || t.singleViewMode) {
              this.showStack(e)
            }
            return
          }
          const n = this._idToStack.get(e)
          if (t.singleViewMode) {
            this.showStack(e)
          }
          n.set(t.view, t)
          this._viewToStack.set(t.view, n)
          if (n === this._visibleStack) {
            this._showView(t)
          }
        }
        remove(t) {
          if (!this.hasView(t)) {
            throw new N('contextualballoon-remove-view-not-exist', [this, t])
          }
          const e = this._viewToStack.get(t)
          if (this._singleViewMode && this.visibleView === t) {
            this._singleViewMode = false
          }
          if (this.visibleView === t) {
            if (e.size === 1) {
              if (this._idToStack.size > 1) {
                this._showNextStack()
              } else {
                this.view.hide()
                this.visibleView = null
                this._rotatorView.hideView()
              }
            } else {
              this._showView(Array.from(e.values())[e.size - 2])
            }
          }
          if (e.size === 1) {
            this._idToStack.delete(this._getStackId(e))
            this._numberOfStacks = this._idToStack.size
          } else {
            e.delete(t)
          }
          this._viewToStack.delete(t)
        }
        updatePosition(t) {
          if (t) {
            this._visibleStack.get(this.visibleView).position = t
          }
          this.view.pin(this._getBalloonPosition())
          this._fakePanelsView.updatePosition()
        }
        showStack(t) {
          this.visibleStack = t
          const e = this._idToStack.get(t)
          if (!e) {
            throw new N('contextualballoon-showstack-stack-not-exist', this)
          }
          if (this._visibleStack === e) {
            return
          }
          this._showView(Array.from(e.values()).pop())
        }
        _createPanelView() {
          this._view = new OC(this.editor.locale)
          this.editor.ui.view.body.add(this._view)
          this.editor.ui.focusTracker.add(this._view.element)
          this._rotatorView = this._createRotatorView()
          this._fakePanelsView = this._createFakePanelsView()
        }
        get _visibleStack() {
          return this._viewToStack.get(this.visibleView)
        }
        _getStackId(t) {
          const e = Array.from(this._idToStack.entries()).find(
            (e) => e[1] === t
          )
          return e[0]
        }
        _showNextStack() {
          const t = Array.from(this._idToStack.values())
          let e = t.indexOf(this._visibleStack) + 1
          if (!t[e]) {
            e = 0
          }
          this.showStack(this._getStackId(t[e]))
        }
        _showPrevStack() {
          const t = Array.from(this._idToStack.values())
          let e = t.indexOf(this._visibleStack) - 1
          if (!t[e]) {
            e = t.length - 1
          }
          this.showStack(this._getStackId(t[e]))
        }
        _createRotatorView() {
          const t = new qy(this.editor.locale)
          const e = this.editor.locale.t
          this.view.content.add(t)
          t.bind('isNavigationVisible').to(
            this,
            '_numberOfStacks',
            this,
            '_singleViewMode',
            (t, e) => !e && t > 1
          )
          t.on('change:isNavigationVisible', () => this.updatePosition(), {
            priority: 'low'
          })
          t.bind('counter').to(
            this,
            'visibleView',
            this,
            '_numberOfStacks',
            (t, n) => {
              if (n < 2) {
                return ''
              }
              const i =
                Array.from(this._idToStack.values()).indexOf(
                  this._visibleStack
                ) + 1
              return e('%0 of %1', [i, n])
            }
          )
          t.buttonNextView.on('execute', () => {
            if (t.focusTracker.isFocused) {
              this.editor.editing.view.focus()
            }
            this._showNextStack()
          })
          t.buttonPrevView.on('execute', () => {
            if (t.focusTracker.isFocused) {
              this.editor.editing.view.focus()
            }
            this._showPrevStack()
          })
          return t
        }
        _createFakePanelsView() {
          const t = new $y(this.editor.locale, this.view)
          t.bind('numberOfPanels').to(
            this,
            '_numberOfStacks',
            this,
            '_singleViewMode',
            (t, e) => {
              const n = !e && t >= 2
              return n ? Math.min(t - 1, 2) : 0
            }
          )
          t.listenTo(this.view, 'change:top', () => t.updatePosition())
          t.listenTo(this.view, 'change:left', () => t.updatePosition())
          this.editor.ui.view.body.add(t)
          return t
        }
        _showView({
          view: t,
          balloonClassName: e = '',
          withArrow: n = true,
          singleViewMode: i = false
        }) {
          this.view.class = e
          this.view.withArrow = n
          this._rotatorView.showView(t)
          this.visibleView = t
          this.view.pin(this._getBalloonPosition())
          this._fakePanelsView.updatePosition()
          if (i) {
            this._singleViewMode = true
          }
        }
        _getBalloonPosition() {
          let t = Array.from(this._visibleStack.values()).pop().position
          if (t) {
            if (!t.limiter) {
              t = Object.assign({}, t, { limiter: this.positionLimiter })
            }
            t = Object.assign({}, t, {
              viewportOffsetConfig: this.editor.ui.viewportOffset
            })
          }
          return t
        }
      }
      class qy extends Sl {
        constructor(t) {
          super(t)
          const e = t.t
          const n = this.bindTemplate
          this.set('isNavigationVisible', true)
          this.focusTracker = new ll()
          this.buttonPrevView = this._createButtonView(e('Previous'), Ny)
          this.buttonNextView = this._createButtonView(e('Next'), Py)
          this.content = this.createCollection()
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-balloon-rotator'],
              'z-index': '-1'
            },
            children: [
              {
                tag: 'div',
                attributes: {
                  class: [
                    'ck-balloon-rotator__navigation',
                    n.to('isNavigationVisible', (t) => (t ? '' : 'ck-hidden'))
                  ]
                },
                children: [
                  this.buttonPrevView,
                  {
                    tag: 'span',
                    attributes: { class: ['ck-balloon-rotator__counter'] },
                    children: [{ text: n.to('counter') }]
                  },
                  this.buttonNextView
                ]
              },
              {
                tag: 'div',
                attributes: { class: 'ck-balloon-rotator__content' },
                children: this.content
              }
            ]
          })
        }
        render() {
          super.render()
          this.focusTracker.add(this.element)
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
        }
        showView(t) {
          this.hideView()
          this.content.add(t)
        }
        hideView() {
          this.content.clear()
        }
        _createButtonView(t, e) {
          const n = new pd(this.locale)
          n.set({ label: t, icon: e, tooltip: true })
          return n
        }
      }
      class $y extends Sl {
        constructor(t, e) {
          super(t)
          const n = this.bindTemplate
          this.set('top', 0)
          this.set('left', 0)
          this.set('height', 0)
          this.set('width', 0)
          this.set('numberOfPanels', 0)
          this.content = this.createCollection()
          this._balloonPanelView = e
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck-fake-panel',
                n.to('numberOfPanels', (t) => (t ? '' : 'ck-hidden'))
              ],
              style: {
                top: n.to('top', Uy),
                left: n.to('left', Uy),
                width: n.to('width', Uy),
                height: n.to('height', Uy)
              }
            },
            children: this.content
          })
          this.on('change:numberOfPanels', (t, e, n, i) => {
            if (n > i) {
              this._addPanels(n - i)
            } else {
              this._removePanels(i - n)
            }
            this.updatePosition()
          })
        }
        _addPanels(t) {
          while (t--) {
            const t = new Sl()
            t.setTemplate({ tag: 'div' })
            this.content.add(t)
            this.registerChild(t)
          }
        }
        _removePanels(t) {
          while (t--) {
            const t = this.content.last
            this.content.remove(t)
            this.deregisterChild(t)
            t.destroy()
          }
        }
        updatePosition() {
          if (this.numberOfPanels) {
            const { top: t, left: e } = this._balloonPanelView
            const { width: n, height: i } = new cc(
              this._balloonPanelView.element
            )
            Object.assign(this, { top: t, left: e, width: n, height: i })
          }
        }
      }
      var Gy = __webpack_require__(3609)
      var Yy = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Yy.insert = 'head'
      Yy.singleton = true
      var Ky = El()(Gy.Z, Yy)
      const Qy = Gy.Z.locals || {}
      const Zy = mc('px')
      class Jy extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.set('isActive', false)
          this.set('isSticky', false)
          this.set('limiterElement', null)
          this.set('limiterBottomOffset', 50)
          this.set('viewportTopOffset', 0)
          this.set('_marginLeft', null)
          this.set('_isStickyToTheLimiter', false)
          this.set('_hasViewportTopOffset', false)
          this.content = this.createCollection()
          this._contentPanelPlaceholder = new Nl({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-sticky-panel__placeholder'],
              style: {
                display: e.to('isSticky', (t) => (t ? 'block' : 'none')),
                height: e.to('isSticky', (t) =>
                  t ? Zy(this._panelRect.height) : null
                )
              }
            }
          }).render()
          this._contentPanel = new Nl({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-sticky-panel__content',
                e.if('isSticky', 'ck-sticky-panel__content_sticky'),
                e.if(
                  '_isStickyToTheLimiter',
                  'ck-sticky-panel__content_sticky_bottom-limit'
                )
              ],
              style: {
                width: e.to('isSticky', (t) =>
                  t
                    ? Zy(
                        this._contentPanelPlaceholder.getBoundingClientRect()
                          .width
                      )
                    : null
                ),
                top: e.to('_hasViewportTopOffset', (t) =>
                  t ? Zy(this.viewportTopOffset) : null
                ),
                bottom: e.to('_isStickyToTheLimiter', (t) =>
                  t ? Zy(this.limiterBottomOffset) : null
                ),
                marginLeft: e.to('_marginLeft')
              }
            },
            children: this.content
          }).render()
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck', 'ck-sticky-panel'] },
            children: [this._contentPanelPlaceholder, this._contentPanel]
          })
        }
        render() {
          super.render()
          this._checkIfShouldBeSticky()
          this.listenTo(ec.window, 'scroll', () => {
            this._checkIfShouldBeSticky()
          })
          this.listenTo(this, 'change:isActive', () => {
            this._checkIfShouldBeSticky()
          })
        }
        _checkIfShouldBeSticky() {
          const t = (this._panelRect =
            this._contentPanel.getBoundingClientRect())
          let e
          if (!this.limiterElement) {
            this.isSticky = false
          } else {
            e = this._limiterRect = this.limiterElement.getBoundingClientRect()
            this.isSticky =
              this.isActive &&
              e.top < this.viewportTopOffset &&
              this._panelRect.height + this.limiterBottomOffset < e.height
          }
          if (this.isSticky) {
            this._isStickyToTheLimiter =
              e.bottom <
              t.height + this.limiterBottomOffset + this.viewportTopOffset
            this._hasViewportTopOffset =
              !this._isStickyToTheLimiter && !!this.viewportTopOffset
            this._marginLeft = this._isStickyToTheLimiter
              ? null
              : Zy(-ec.window.scrollX)
          } else {
            this._isStickyToTheLimiter = false
            this._hasViewportTopOffset = false
            this._marginLeft = null
          }
        }
      }
      const Xy = mc('px')
      class tx extends (null && Plugin) {
        static get pluginName() {
          return 'BalloonToolbar'
        }
        static get requires() {
          return [ContextualBalloon]
        }
        constructor(t) {
          super(t)
          this._balloonConfig = normalizeToolbarConfig(
            t.config.get('balloonToolbar')
          )
          this.toolbarView = this._createToolbarView()
          this.focusTracker = new FocusTracker()
          t.ui.once('ready', () => {
            this.focusTracker.add(t.ui.getEditableElement())
            this.focusTracker.add(this.toolbarView.element)
          })
          t.ui.addToolbar(this.toolbarView, {
            beforeFocus: () => this.show(true),
            afterBlur: () => this.hide(),
            isContextual: true
          })
          this._resizeObserver = null
          this._balloon = t.plugins.get(ContextualBalloon)
          this._fireSelectionChangeDebounced = debounce(
            () => this.fire('_selectionChangeDebounced'),
            200
          )
          this.decorate('show')
        }
        init() {
          const t = this.editor
          const e = t.model.document.selection
          this.listenTo(this.focusTracker, 'change:isFocused', (t, e, n) => {
            const i = this._balloon.visibleView === this.toolbarView
            if (!n && i) {
              this.hide()
            } else if (n) {
              this.show()
            }
          })
          this.listenTo(e, 'change:range', (t, n) => {
            if (n.directChange || e.isCollapsed) {
              this.hide()
            }
            this._fireSelectionChangeDebounced()
          })
          this.listenTo(this, '_selectionChangeDebounced', () => {
            if (this.editor.editing.view.document.isFocused) {
              this.show()
            }
          })
          if (!this._balloonConfig.shouldNotGroupWhenFull) {
            this.listenTo(t, 'ready', () => {
              const e = t.ui.view.editable.element
              this._resizeObserver = new ResizeObserver(e, (t) => {
                this.toolbarView.maxWidth = Xy(t.contentRect.width * 0.9)
              })
            })
          }
          this.listenTo(this.toolbarView, 'groupedItemsUpdate', () => {
            this._updatePosition()
          })
        }
        afterInit() {
          const t = this.editor.ui.componentFactory
          this.toolbarView.fillFromConfig(this._balloonConfig, t)
        }
        _createToolbarView() {
          const t = this.editor.locale.t
          const e = !this._balloonConfig.shouldNotGroupWhenFull
          const n = new ToolbarView(this.editor.locale, {
            shouldGroupWhenFull: e,
            isFloating: true
          })
          n.ariaLabel = t('Editor contextual toolbar')
          n.render()
          return n
        }
        show(t = false) {
          const e = this.editor
          const n = e.model.document.selection
          const i = e.model.schema
          if (this._balloon.hasView(this.toolbarView)) {
            return
          }
          if (n.isCollapsed && !t) {
            return
          }
          if (ex(n, i)) {
            return
          }
          if (
            Array.from(this.toolbarView.items).every(
              (t) => t.isEnabled !== undefined && !t.isEnabled
            )
          ) {
            return
          }
          this.listenTo(this.editor.ui, 'update', () => {
            this._updatePosition()
          })
          this._balloon.add({
            view: this.toolbarView,
            position: this._getBalloonPositionData(),
            balloonClassName: 'ck-toolbar-container'
          })
        }
        hide() {
          if (this._balloon.hasView(this.toolbarView)) {
            this.stopListening(this.editor.ui, 'update')
            this._balloon.remove(this.toolbarView)
          }
        }
        _getBalloonPositionData() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          const i = n.selection
          const o = n.selection.isBackward
          return {
            target: () => {
              const t = o ? i.getFirstRange() : i.getLastRange()
              const n = Rect.getDomRangeRects(e.domConverter.viewRangeToDom(t))
              if (o) {
                return n[0]
              } else {
                if (n.length > 1 && n[n.length - 1].width === 0) {
                  n.pop()
                }
                return n[n.length - 1]
              }
            },
            positions: this._getBalloonPositions(o)
          }
        }
        _updatePosition() {
          this._balloon.updatePosition(this._getBalloonPositionData())
        }
        destroy() {
          super.destroy()
          this.stopListening()
          this._fireSelectionChangeDebounced.cancel()
          this.toolbarView.destroy()
          this.focusTracker.destroy()
          if (this._resizeObserver) {
            this._resizeObserver.destroy()
          }
        }
        _getBalloonPositions(t) {
          const e = env.isSafari && env.isiOS
          const n = e
            ? generatePositions({
                heightOffset: Math.max(
                  BalloonPanelView.arrowHeightOffset,
                  Math.round(20 / global.window.visualViewport.scale)
                )
              })
            : BalloonPanelView.defaultPositions
          return t
            ? [
                n.northWestArrowSouth,
                n.northWestArrowSouthWest,
                n.northWestArrowSouthEast,
                n.northWestArrowSouthMiddleEast,
                n.northWestArrowSouthMiddleWest,
                n.southWestArrowNorth,
                n.southWestArrowNorthWest,
                n.southWestArrowNorthEast,
                n.southWestArrowNorthMiddleWest,
                n.southWestArrowNorthMiddleEast
              ]
            : [
                n.southEastArrowNorth,
                n.southEastArrowNorthEast,
                n.southEastArrowNorthWest,
                n.southEastArrowNorthMiddleEast,
                n.southEastArrowNorthMiddleWest,
                n.northEastArrowSouth,
                n.northEastArrowSouthEast,
                n.northEastArrowSouthWest,
                n.northEastArrowSouthMiddleEast,
                n.northEastArrowSouthMiddleWest
              ]
        }
      }
      function ex(t, e) {
        if (t.rangeCount === 1) {
          return false
        }
        return [...t.getRanges()].every((t) => {
          const n = t.getContainedElement()
          return n && e.isSelectable(n)
        })
      }
      var nx = __webpack_require__(6706)
      var ix = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      ix.insert = 'head'
      ix.singleton = true
      var ox = El()(nx.Z, ix)
      const rx = nx.Z.locals || {}
      const sx = mc('px')
      class ax extends (null && ButtonView) {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.isVisible = false
          this.isToggleable = true
          this.set('top', 0)
          this.set('left', 0)
          this.extendTemplate({
            attributes: {
              class: 'ck-block-toolbar-button',
              style: {
                top: e.to('top', (t) => sx(t)),
                left: e.to('left', (t) => sx(t))
              }
            }
          })
        }
      }
      const cx = mc('px')
      const { pilcrow: lx } = $v
      class dx extends (null && Plugin) {
        static get pluginName() {
          return 'BlockToolbar'
        }
        constructor(t) {
          super(t)
          this._blockToolbarConfig = normalizeToolbarConfig(
            this.editor.config.get('blockToolbar')
          )
          this.toolbarView = this._createToolbarView()
          this.panelView = this._createPanelView()
          this.buttonView = this._createButtonView()
          this._resizeObserver = null
          clickOutsideHandler({
            emitter: this.panelView,
            contextElements: [this.panelView.element, this.buttonView.element],
            activator: () => this.panelView.isVisible,
            callback: () => this._hidePanel()
          })
        }
        init() {
          const t = this.editor
          this.listenTo(t.model.document.selection, 'change:range', (t, e) => {
            if (e.directChange) {
              this._hidePanel()
            }
          })
          this.listenTo(t.ui, 'update', () => this._updateButton())
          this.listenTo(t, 'change:isReadOnly', () => this._updateButton(), {
            priority: 'low'
          })
          this.listenTo(t.ui.focusTracker, 'change:isFocused', () =>
            this._updateButton()
          )
          this.listenTo(this.buttonView, 'change:isVisible', (t, e, n) => {
            if (n) {
              this.buttonView.listenTo(window, 'resize', () =>
                this._updateButton()
              )
            } else {
              this.buttonView.stopListening(window, 'resize')
              this._hidePanel()
            }
          })
          t.ui.addToolbar(this.toolbarView, {
            beforeFocus: () => this._showPanel(),
            afterBlur: () => this._hidePanel()
          })
        }
        afterInit() {
          const t = this.editor.ui.componentFactory
          const e = this._blockToolbarConfig
          this.toolbarView.fillFromConfig(e, t)
          for (const t of this.toolbarView.items) {
            t.on('execute', () => this._hidePanel(true), { priority: 'high' })
          }
          if (!e.shouldNotGroupWhenFull) {
            this.listenTo(this.editor, 'ready', () => {
              const t = this.editor.ui.view.editable.element
              this._resizeObserver = new ResizeObserver(t, () => {
                this.toolbarView.maxWidth = this._getToolbarMaxWidth()
              })
            })
          }
        }
        destroy() {
          super.destroy()
          this.panelView.destroy()
          this.buttonView.destroy()
          this.toolbarView.destroy()
          if (this._resizeObserver) {
            this._resizeObserver.destroy()
          }
        }
        _createToolbarView() {
          const t = this.editor.locale.t
          const e = !this._blockToolbarConfig.shouldNotGroupWhenFull
          const n = new ToolbarView(this.editor.locale, {
            shouldGroupWhenFull: e,
            isFloating: true
          })
          n.ariaLabel = t('Editor block content toolbar')
          n.focusTracker.on('change:isFocused', (t, e, n) => {
            if (!n) {
              this._hidePanel()
            }
          })
          return n
        }
        _createPanelView() {
          const t = this.editor
          const e = new BalloonPanelView(t.locale)
          e.content.add(this.toolbarView)
          e.class = 'ck-toolbar-container'
          t.ui.view.body.add(e)
          t.ui.focusTracker.add(e.element)
          this.toolbarView.keystrokes.set('Esc', (t, e) => {
            this._hidePanel(true)
            e()
          })
          return e
        }
        _createButtonView() {
          const t = this.editor
          const e = t.t
          const n = new BlockButtonView(t.locale)
          const i = n.bindTemplate
          n.set({ label: e('Edit block'), icon: lx, withText: false })
          n.extendTemplate({
            on: {
              mousedown: i.to((t) => {
                if (env.isSafari && this.panelView.isVisible) {
                  this.toolbarView.focus()
                }
                t.preventDefault()
              })
            }
          })
          n.bind('isOn').to(this.panelView, 'isVisible')
          n.bind('tooltip').to(this.panelView, 'isVisible', (t) => !t)
          this.listenTo(n, 'execute', () => {
            if (!this.panelView.isVisible) {
              this._showPanel()
            } else {
              this._hidePanel(true)
            }
          })
          t.ui.view.body.add(n)
          t.ui.focusTracker.add(n.element)
          return n
        }
        _updateButton() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          if (!t.ui.focusTracker.isFocused) {
            this._hideButton()
            return
          }
          if (t.isReadOnly) {
            this._hideButton()
            return
          }
          const i = Array.from(e.document.selection.getSelectedBlocks())[0]
          if (
            !i ||
            Array.from(this.toolbarView.items).every((t) => !t.isEnabled)
          ) {
            this._hideButton()
            return
          }
          const o = n.domConverter.mapViewToDom(
            t.editing.mapper.toViewElement(i)
          )
          this.buttonView.isVisible = true
          this._attachButtonToElement(o)
          if (this.panelView.isVisible) {
            this._showPanel()
          }
        }
        _hideButton() {
          this.buttonView.isVisible = false
        }
        _showPanel() {
          if (!this.buttonView.isVisible) {
            return
          }
          const t = this.panelView.isVisible
          this.panelView.show()
          this.toolbarView.maxWidth = this._getToolbarMaxWidth()
          this.panelView.pin({
            target: this.buttonView.element,
            limiter: this.editor.ui.getEditableElement()
          })
          if (!t) {
            this.toolbarView.items.get(0).focus()
          }
        }
        _hidePanel(t) {
          this.panelView.isVisible = false
          if (t) {
            this.editor.editing.view.focus()
          }
        }
        _attachButtonToElement(t) {
          const e = window.getComputedStyle(t)
          const n = new Rect(this.editor.ui.getEditableElement())
          const i = parseInt(e.paddingTop, 10)
          const o = parseInt(e.lineHeight, 10) || parseInt(e.fontSize, 10) * 1.2
          const r = getOptimalPosition({
            element: this.buttonView.element,
            target: t,
            positions: [
              (t, e) => {
                let r
                if (this.editor.locale.uiLanguageDirection === 'ltr') {
                  r = n.left - e.width
                } else {
                  r = n.right
                }
                return { top: t.top + i + (o - e.height) / 2, left: r }
              }
            ]
          })
          this.buttonView.top = r.top
          this.buttonView.left = r.left
        }
        _getToolbarMaxWidth() {
          const t = this.editor.ui.view.editable.element
          const e = new Rect(t)
          const n = new Rect(this.buttonView.element)
          const i = this.editor.locale.uiLanguageDirection === 'rtl'
          const o = i ? n.left - e.right + n.width : e.left - n.left
          return cx(e.width + o)
        }
      }
      class ux extends YC {
        constructor(t, e) {
          super(t)
          this.view = e
          this._toolbarConfig = Yd(t.config.get('toolbar'))
          this._elementReplacer = new Ct()
        }
        get element() {
          return this.view.element
        }
        init(t) {
          const e = this.editor
          const n = this.view
          const i = e.editing.view
          const o = n.editable
          const r = i.document.getRoot()
          o.name = r.rootName
          n.render()
          const s = o.element
          this.setEditableElement(o.name, s)
          n.editable.bind('isFocused').to(this.focusTracker)
          i.attachDomRoot(s)
          if (t) {
            this._elementReplacer.replace(t, this.element)
          }
          this._initPlaceholder()
          this._initToolbar()
          this.fire('ready')
        }
        destroy() {
          super.destroy()
          const t = this.view
          const e = this.editor.editing.view
          this._elementReplacer.restore()
          e.detachDomRoot(t.editable.name)
          t.destroy()
        }
        _initToolbar() {
          const t = this.view
          t.stickyPanel.bind('isActive').to(this.focusTracker, 'isFocused')
          t.stickyPanel.limiterElement = t.element
          t.stickyPanel
            .bind('viewportTopOffset')
            .to(this, 'viewportOffset', ({ top: t }) => t || 0)
          t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory)
          this.addToolbar(t.toolbar)
        }
        _initPlaceholder() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document.getRoot()
          const i = t.sourceElement
          const o =
            t.config.get('placeholder') ||
            (i &&
              i.tagName.toLowerCase() === 'textarea' &&
              i.getAttribute('placeholder'))
          if (o) {
            cu({
              view: e,
              element: n,
              text: o,
              isDirectHost: false,
              keepOnFocus: true
            })
          }
        }
      }
      var hx = __webpack_require__(3638)
      var fx = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      fx.insert = 'head'
      fx.singleton = true
      var mx = El()(hx.Z, fx)
      const gx = hx.Z.locals || {}
      class px extends sy {
        constructor(t, e, n = {}) {
          super(t)
          this.stickyPanel = new Jy(t)
          this.toolbar = new Xv(t, {
            shouldGroupWhenFull: n.shouldToolbarGroupWhenFull
          })
          this.editable = new cy(t, e)
        }
        render() {
          super.render()
          this.stickyPanel.content.add(this.toolbar)
          this.top.add(this.stickyPanel)
          this.main.add(this.editable)
        }
      }
      class bx extends cv(lv(rv)) {
        constructor(t, e = {}) {
          if (!wx(t) && e.initialData !== undefined) {
            throw new N('editor-create-initial-data', null)
          }
          super(e)
          if (this.config.get('initialData') === undefined) {
            this.config.set('initialData', kx(t))
          }
          if (wx(t)) {
            this.sourceElement = t
          }
          this.model.document.createRoot()
          const n = !this.config.get('toolbar.shouldNotGroupWhenFull')
          const i = new px(this.locale, this.editing.view, {
            shouldToolbarGroupWhenFull: n
          })
          this.ui = new ux(this, i)
          sv(this)
        }
        destroy() {
          if (this.sourceElement) {
            this.updateSourceElement()
          }
          this.ui.destroy()
          return super.destroy()
        }
        static create(t, e = {}) {
          return new Promise((n) => {
            const i = new this(t, e)
            n(
              i
                .initPlugins()
                .then(() => i.ui.init(wx(t) ? t : null))
                .then(() => i.data.init(i.config.get('initialData')))
                .then(() => i.fire('ready'))
                .then(() => i)
            )
          })
        }
      }
      function kx(t) {
        return wx(t) ? ic(t) : t
      }
      function wx(t) {
        return Ua(t)
      }
      class _x {
        constructor(t, e = 20) {
          this._batch = null
          this.model = t
          this._size = 0
          this.limit = e
          this._isLocked = false
          this._changeCallback = (t, e) => {
            if (e.isLocal && e.isUndoable && e !== this._batch) {
              this._reset(true)
            }
          }
          this._selectionChangeCallback = () => {
            this._reset()
          }
          this.model.document.on('change', this._changeCallback)
          this.model.document.selection.on(
            'change:range',
            this._selectionChangeCallback
          )
          this.model.document.selection.on(
            'change:attribute',
            this._selectionChangeCallback
          )
        }
        get batch() {
          if (!this._batch) {
            this._batch = this.model.createBatch({ isTyping: true })
          }
          return this._batch
        }
        get size() {
          return this._size
        }
        input(t) {
          this._size += t
          if (this._size >= this.limit) {
            this._reset(true)
          }
        }
        get isLocked() {
          return this._isLocked
        }
        lock() {
          this._isLocked = true
        }
        unlock() {
          this._isLocked = false
        }
        destroy() {
          this.model.document.off('change', this._changeCallback)
          this.model.document.selection.off(
            'change:range',
            this._selectionChangeCallback
          )
          this.model.document.selection.off(
            'change:attribute',
            this._selectionChangeCallback
          )
        }
        _reset(t = false) {
          if (!this.isLocked || t) {
            this._batch = null
            this._size = 0
          }
        }
      }
      class Ax extends Zd {
        constructor(t, e) {
          super(t)
          this._buffer = new _x(t.model, e)
        }
        get buffer() {
          return this._buffer
        }
        destroy() {
          super.destroy()
          this._buffer.destroy()
        }
        execute(t = {}) {
          const e = this.editor.model
          const n = e.document
          const i = t.text || ''
          const o = i.length
          let r = n.selection
          if (t.selection) {
            r = t.selection
          } else if (t.range) {
            r = e.createSelection(t.range)
          }
          const s = t.resultRange
          e.enqueueChange(this._buffer.batch, (t) => {
            this._buffer.lock()
            e.deleteContent(r)
            if (i) {
              e.insertContent(t.createText(i, n.selection.getAttributes()), r)
            }
            if (s) {
              t.setSelection(s)
            } else if (!r.is('documentSelection')) {
              t.setSelection(r)
            }
            this._buffer.unlock()
            this._buffer.input(o)
          })
        }
      }
      const vx = ['insertText', 'insertReplacementText']
      class Cx extends Xm {
        constructor(t) {
          super(t)
          if (a.isAndroid) {
            vx.push('insertCompositionText')
          }
          const e = t.document
          e.on('beforeinput', (n, i) => {
            if (!this.isEnabled) {
              return
            }
            const { data: o, targetRanges: r, inputType: s, domEvent: a } = i
            if (!vx.includes(s)) {
              return
            }
            const c = new E(e, 'insertText')
            e.fire(
              c,
              new ng(t, a, { text: o, selection: t.createSelection(r) })
            )
            if (c.stop.called) {
              n.stop()
            }
          })
          e.on(
            'compositionend',
            (n, { data: i, domEvent: o }) => {
              if (!this.isEnabled || a.isAndroid) {
                return
              }
              if (!i) {
                return
              }
              e.fire(
                'insertText',
                new ng(t, o, { text: i, selection: e.selection })
              )
            },
            { priority: 'lowest' }
          )
        }
        observe() {}
      }
      class yx extends Kd {
        static get pluginName() {
          return 'Input'
        }
        init() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          const i = e.document.selection
          n.addObserver(Cx)
          const o = new Ax(t, t.config.get('typing.undoStep') || 20)
          t.commands.add('insertText', o)
          t.commands.add('input', o)
          this.listenTo(n.document, 'insertText', (i, o) => {
            if (!n.document.isComposing) {
              o.preventDefault()
            }
            const { text: r, selection: s, resultRange: c } = o
            const l = Array.from(s.getRanges()).map((e) =>
              t.editing.mapper.toModelRange(e)
            )
            let d = r
            if (a.isAndroid) {
              const t = Array.from(l[0].getItems()).reduce(
                (t, e) => t + (e.is('$textProxy') ? e.data : ''),
                ''
              )
              if (t) {
                if (t.length <= d.length) {
                  if (d.startsWith(t)) {
                    d = d.substring(t.length)
                    l[0].start = l[0].start.getShiftedBy(t.length)
                  }
                } else {
                  if (t.startsWith(d)) {
                    l[0].start = l[0].start.getShiftedBy(d.length)
                    d = ''
                  }
                }
              }
            }
            const u = { text: d, selection: e.createSelection(l) }
            if (c) {
              u.resultRange = t.editing.mapper.toModelRange(c)
            }
            t.execute('insertText', u)
          })
          if (a.isAndroid) {
            this.listenTo(n.document, 'keydown', (t, r) => {
              if (
                i.isCollapsed ||
                r.keyCode != 229 ||
                !n.document.isComposing
              ) {
                return
              }
              xx(e, o)
            })
          } else {
            this.listenTo(n.document, 'compositionstart', () => {
              if (i.isCollapsed) {
                return
              }
              xx(e, o)
            })
          }
        }
      }
      function xx(t, e) {
        if (!e.isEnabled) {
          return
        }
        const n = e.buffer
        n.lock()
        t.enqueueChange(n.batch, () => {
          t.deleteContent(t.document.selection)
        })
        n.unlock()
      }
      class Ex extends Zd {
        constructor(t, e) {
          super(t)
          this.direction = e
          this._buffer = new _x(t.model, t.config.get('typing.undoStep'))
        }
        get buffer() {
          return this._buffer
        }
        execute(t = {}) {
          const e = this.editor.model
          const n = e.document
          e.enqueueChange(this._buffer.batch, (i) => {
            this._buffer.lock()
            const o = i.createSelection(t.selection || n.selection)
            const r = t.sequence || 1
            const s = o.isCollapsed
            if (o.isCollapsed) {
              e.modifySelection(o, {
                direction: this.direction,
                unit: t.unit,
                treatEmojiAsSingleUnit: true
              })
            }
            if (this._shouldEntireContentBeReplacedWithParagraph(r)) {
              this._replaceEntireContentWithParagraph(i)
              return
            }
            if (this._shouldReplaceFirstBlockWithParagraph(o, r)) {
              this.editor.execute('paragraph', { selection: o })
              return
            }
            if (o.isCollapsed) {
              return
            }
            let a = 0
            o.getFirstRange()
              .getMinimalFlatRanges()
              .forEach((t) => {
                a += yt(
                  t.getWalker({
                    singleCharacters: true,
                    ignoreElementEnd: true,
                    shallow: true
                  })
                )
              })
            e.deleteContent(o, {
              doNotResetEntireContent: s,
              direction: this.direction
            })
            this._buffer.input(a)
            i.setSelection(o)
            this._buffer.unlock()
          })
        }
        _shouldEntireContentBeReplacedWithParagraph(t) {
          if (t > 1) {
            return false
          }
          const e = this.editor.model
          const n = e.document
          const i = n.selection
          const o = e.schema.getLimitElement(i)
          const r = i.isCollapsed && i.containsEntireContent(o)
          if (!r) {
            return false
          }
          if (!e.schema.checkChild(o, 'paragraph')) {
            return false
          }
          const s = o.getChild(0)
          if (s && s.is('element', 'paragraph')) {
            return false
          }
          return true
        }
        _replaceEntireContentWithParagraph(t) {
          const e = this.editor.model
          const n = e.document
          const i = n.selection
          const o = e.schema.getLimitElement(i)
          const r = t.createElement('paragraph')
          t.remove(t.createRangeIn(o))
          t.insert(r, o)
          t.setSelection(r, 0)
        }
        _shouldReplaceFirstBlockWithParagraph(t, e) {
          const n = this.editor.model
          if (e > 1 || this.direction != 'backward') {
            return false
          }
          if (!t.isCollapsed) {
            return false
          }
          const i = t.getFirstPosition()
          const o = n.schema.getLimitElement(i)
          const r = o.getChild(0)
          if (i.parent != r) {
            return false
          }
          if (!t.containsEntireContent(r)) {
            return false
          }
          if (!n.schema.checkChild(o, 'paragraph')) {
            return false
          }
          if (r.name == 'paragraph') {
            return false
          }
          return true
        }
      }
      const Dx = 'character'
      const Tx = 'word'
      const Mx = 'codePoint'
      const Ix = 'selection'
      const Sx = 'backward'
      const Bx = 'forward'
      const Nx = {
        deleteContent: { unit: Ix, direction: Sx },
        deleteContentBackward: { unit: Mx, direction: Sx },
        deleteWordBackward: { unit: Tx, direction: Sx },
        deleteHardLineBackward: { unit: Ix, direction: Sx },
        deleteSoftLineBackward: { unit: Ix, direction: Sx },
        deleteContentForward: { unit: Dx, direction: Bx },
        deleteWordForward: { unit: Tx, direction: Bx },
        deleteHardLineForward: { unit: Ix, direction: Bx },
        deleteSoftLineForward: { unit: Ix, direction: Bx }
      }
      class Px extends Xm {
        constructor(t) {
          super(t)
          const e = t.document
          let n = 0
          e.on('keydown', () => {
            n++
          })
          e.on('keyup', () => {
            n = 0
          })
          e.on('beforeinput', (i, o) => {
            if (!this.isEnabled) {
              return
            }
            const { targetRanges: r, domEvent: s, inputType: c } = o
            const l = Nx[c]
            if (!l) {
              return
            }
            const d = { direction: l.direction, unit: l.unit, sequence: n }
            if (d.unit == Ix) {
              d.selectionToRemove = t.createSelection(r[0])
            }
            if (a.isAndroid && c === 'deleteContentBackward') {
              d.sequence = 1
              if (
                r.length == 1 &&
                (r[0].start.parent != r[0].end.parent ||
                  r[0].start.offset + 1 != r[0].end.offset)
              ) {
                d.unit = Ix
                d.selectionToRemove = t.createSelection(r)
              }
            }
            const u = new Of(e, 'delete', r[0])
            e.fire(u, new ng(t, s, d))
            if (u.stop.called) {
              i.stop()
            }
          })
          if (a.isBlink) {
            zx(this)
          }
        }
        observe() {}
      }
      function zx(t) {
        const e = t.view
        const n = e.document
        let i = null
        let o = false
        n.on('keydown', (t, { keyCode: e }) => {
          i = e
          o = false
        })
        n.on('keyup', (a, { keyCode: c, domEvent: l }) => {
          const d = n.selection
          const u = t.isEnabled && c == i && r(c) && !d.isCollapsed && !o
          i = null
          if (u) {
            const t = d.getFirstRange()
            const i = new Of(n, 'delete', t)
            const o = { unit: Ix, direction: s(c), selectionToRemove: d }
            n.fire(i, new ng(e, l, o))
          }
        })
        n.on(
          'beforeinput',
          (t, { inputType: e }) => {
            const n = Nx[e]
            const a = r(i) && n && n.direction == s(i)
            if (a) {
              o = true
            }
          },
          { priority: 'high' }
        )
        n.on(
          'beforeinput',
          (t, { inputType: e, data: n }) => {
            const o = i == Fc['delete'] && e == 'insertText' && n == ''
            if (o) {
              t.stop()
            }
          },
          { priority: 'high' }
        )
        function r(t) {
          return t == Fc.backspace || t == Fc['delete']
        }
        function s(t) {
          return t == Fc.backspace ? Sx : Bx
        }
      }
      class Lx extends Kd {
        static get pluginName() {
          return 'Delete'
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          const i = t.model.document
          e.addObserver(Px)
          this._undoOnBackspace = false
          const o = new Ex(t, 'forward')
          t.commands.add('deleteForward', o)
          t.commands.add('forwardDelete', o)
          t.commands.add('delete', new Ex(t, 'backward'))
          this.listenTo(
            n,
            'delete',
            (i, o) => {
              if (!n.isComposing) {
                o.preventDefault()
              }
              const {
                direction: r,
                sequence: s,
                selectionToRemove: a,
                unit: c
              } = o
              const l = r === 'forward' ? 'deleteForward' : 'delete'
              const d = { sequence: s }
              if (c == 'selection') {
                const e = Array.from(a.getRanges()).map((e) =>
                  t.editing.mapper.toModelRange(e)
                )
                d.selection = t.model.createSelection(e)
              } else {
                d.unit = c
              }
              t.execute(l, d)
              e.scrollToTheSelection()
            },
            { priority: 'low' }
          )
          if (this.editor.plugins.has('UndoEditing')) {
            this.listenTo(
              n,
              'delete',
              (e, n) => {
                if (
                  this._undoOnBackspace &&
                  n.direction == 'backward' &&
                  n.sequence == 1 &&
                  n.unit == 'codePoint'
                ) {
                  this._undoOnBackspace = false
                  t.execute('undo')
                  n.preventDefault()
                  e.stop()
                }
              },
              { context: '$capture' }
            )
            this.listenTo(i, 'change', () => {
              this._undoOnBackspace = false
            })
          }
        }
        requestUndoOnBackspace() {
          if (this.editor.plugins.has('UndoEditing')) {
            this._undoOnBackspace = true
          }
        }
      }
      class Ox extends Kd {
        static get requires() {
          return [yx, Lx]
        }
        static get pluginName() {
          return 'Typing'
        }
      }
      function Rx(t, e) {
        let n = t.start
        const i = Array.from(t.getItems()).reduce((t, i) => {
          if (!(i.is('$text') || i.is('$textProxy'))) {
            n = e.createPositionAfter(i)
            return ''
          }
          return t + i.data
        }, '')
        return { text: i, range: e.createRange(n, t.end) }
      }
      class jx extends ht() {
        constructor(t, e) {
          super()
          this.model = t
          this.testCallback = e
          this._hasMatch = false
          this.set('isEnabled', true)
          this.on('change:isEnabled', () => {
            if (this.isEnabled) {
              this._startListening()
            } else {
              this.stopListening(t.document.selection)
              this.stopListening(t.document)
            }
          })
          this._startListening()
        }
        get hasMatch() {
          return this._hasMatch
        }
        _startListening() {
          const t = this.model
          const e = t.document
          this.listenTo(
            e.selection,
            'change:range',
            (t, { directChange: n }) => {
              if (!n) {
                return
              }
              if (!e.selection.isCollapsed) {
                if (this.hasMatch) {
                  this.fire('unmatched')
                  this._hasMatch = false
                }
                return
              }
              this._evaluateTextBeforeSelection('selection')
            }
          )
          this.listenTo(e, 'change:data', (t, e) => {
            if (e.isUndo || !e.isLocal) {
              return
            }
            this._evaluateTextBeforeSelection('data', { batch: e })
          })
        }
        _evaluateTextBeforeSelection(t, e = {}) {
          const n = this.model
          const i = n.document
          const o = i.selection
          const r = n.createRange(
            n.createPositionAt(o.focus.parent, 0),
            o.focus
          )
          const { text: s, range: a } = Rx(r, n)
          const c = this.testCallback(s)
          if (!c && this.hasMatch) {
            this.fire('unmatched')
          }
          this._hasMatch = !!c
          if (c) {
            const n = Object.assign(e, { text: s, range: a })
            if (typeof c == 'object') {
              Object.assign(n, c)
            }
            this.fire(`matched:${t}`, n)
          }
        }
      }
      class Fx extends Kd {
        static get pluginName() {
          return 'TwoStepCaretMovement'
        }
        constructor(t) {
          super(t)
          this.attributes = new Set()
          this._overrideUid = null
        }
        init() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          const i = t.locale
          const o = e.document.selection
          this.listenTo(
            n.document,
            'arrowKey',
            (t, e) => {
              if (!o.isCollapsed) {
                return
              }
              if (e.shiftKey || e.altKey || e.ctrlKey) {
                return
              }
              const n = e.keyCode == Fc.arrowright
              const r = e.keyCode == Fc.arrowleft
              if (!n && !r) {
                return
              }
              const s = i.contentLanguageDirection
              let a = false
              if ((s === 'ltr' && n) || (s === 'rtl' && r)) {
                a = this._handleForwardMovement(e)
              } else {
                a = this._handleBackwardMovement(e)
              }
              if (a === true) {
                t.stop()
              }
            },
            { context: '$text', priority: 'highest' }
          )
          this._isNextGravityRestorationSkipped = false
          this.listenTo(o, 'change:range', (t, e) => {
            if (this._isNextGravityRestorationSkipped) {
              this._isNextGravityRestorationSkipped = false
              return
            }
            if (!this._isGravityOverridden) {
              return
            }
            if (!e.directChange && qx(o.getFirstPosition(), this.attributes)) {
              return
            }
            this._restoreGravity()
          })
        }
        registerAttribute(t) {
          this.attributes.add(t)
        }
        _handleForwardMovement(t) {
          const e = this.attributes
          const n = this.editor.model
          const i = n.document.selection
          const o = i.getFirstPosition()
          if (this._isGravityOverridden) {
            return false
          }
          if (o.isAtStart && Vx(i, e)) {
            return false
          }
          if (qx(o, e)) {
            Ux(t)
            this._overrideGravity()
            return true
          }
          return false
        }
        _handleBackwardMovement(t) {
          const e = this.attributes
          const n = this.editor.model
          const i = n.document.selection
          const o = i.getFirstPosition()
          if (this._isGravityOverridden) {
            Ux(t)
            this._restoreGravity()
            Hx(n, e, o)
            return true
          } else {
            if (o.isAtStart) {
              if (Vx(i, e)) {
                Ux(t)
                Hx(n, e, o)
                return true
              }
              return false
            }
            if (Wx(o, e)) {
              if (o.isAtEnd && !Vx(i, e) && qx(o, e)) {
                Ux(t)
                Hx(n, e, o)
                return true
              }
              this._isNextGravityRestorationSkipped = true
              this._overrideGravity()
              return false
            }
          }
          return false
        }
        get _isGravityOverridden() {
          return !!this._overrideUid
        }
        _overrideGravity() {
          this._overrideUid = this.editor.model.change((t) =>
            t.overrideSelectionGravity()
          )
        }
        _restoreGravity() {
          this.editor.model.change((t) => {
            t.restoreSelectionGravity(this._overrideUid)
            this._overrideUid = null
          })
        }
      }
      function Vx(t, e) {
        for (const n of e) {
          if (t.hasAttribute(n)) {
            return true
          }
        }
        return false
      }
      function Hx(t, e, n) {
        const i = n.nodeBefore
        t.change((t) => {
          if (i) {
            t.setSelectionAttribute(i.getAttributes())
          } else {
            t.removeSelectionAttribute(e)
          }
        })
      }
      function Ux(t) {
        t.preventDefault()
      }
      function Wx(t, e) {
        const n = t.getShiftedBy(-1)
        return qx(n, e)
      }
      function qx(t, e) {
        const { nodeBefore: n, nodeAfter: i } = t
        for (const t of e) {
          const e = n ? n.getAttribute(t) : undefined
          const o = i ? i.getAttribute(t) : undefined
          if (o !== e) {
            return true
          }
        }
        return false
      }
      var $x = /[\\^$.*+?()[\]{}|]/g,
        Gx = RegExp($x.source)
      function Yx(t) {
        t = oh(t)
        return t && Gx.test(t) ? t.replace($x, '\\$&') : t
      }
      const Kx = Yx
      const Qx = {
        copyright: { from: '(c)', to: '©' },
        registeredTrademark: { from: '(r)', to: '®' },
        trademark: { from: '(tm)', to: '™' },
        oneHalf: {
          from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i,
          to: [null, '½', null]
        },
        oneThird: {
          from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i,
          to: [null, '⅓', null]
        },
        twoThirds: {
          from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i,
          to: [null, '⅔', null]
        },
        oneForth: {
          from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i,
          to: [null, '¼', null]
        },
        threeQuarters: {
          from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i,
          to: [null, '¾', null]
        },
        lessThanOrEqual: { from: '<=', to: '≤' },
        greaterThanOrEqual: { from: '>=', to: '≥' },
        notEqual: { from: '!=', to: '≠' },
        arrowLeft: { from: '<-', to: '←' },
        arrowRight: { from: '->', to: '→' },
        horizontalEllipsis: { from: '...', to: '…' },
        enDash: { from: /(^| )(--)( )$/, to: [null, '–', null] },
        emDash: { from: /(^| )(---)( )$/, to: [null, '—', null] },
        quotesPrimary: { from: iE('"'), to: [null, '“', null, '”'] },
        quotesSecondary: { from: iE("'"), to: [null, '‘', null, '’'] },
        quotesPrimaryEnGb: { from: iE("'"), to: [null, '‘', null, '’'] },
        quotesSecondaryEnGb: { from: iE('"'), to: [null, '“', null, '”'] },
        quotesPrimaryPl: { from: iE('"'), to: [null, '„', null, '”'] },
        quotesSecondaryPl: { from: iE("'"), to: [null, '‚', null, '’'] }
      }
      const Zx = {
        symbols: ['copyright', 'registeredTrademark', 'trademark'],
        mathematical: [
          'oneHalf',
          'oneThird',
          'twoThirds',
          'oneForth',
          'threeQuarters',
          'lessThanOrEqual',
          'greaterThanOrEqual',
          'notEqual',
          'arrowLeft',
          'arrowRight'
        ],
        typography: ['horizontalEllipsis', 'enDash', 'emDash'],
        quotes: ['quotesPrimary', 'quotesSecondary']
      }
      const Jx = ['symbols', 'mathematical', 'typography', 'quotes']
      class Xx extends Kd {
        static get requires() {
          return ['Delete', 'Input']
        }
        static get pluginName() {
          return 'TextTransformation'
        }
        constructor(t) {
          super(t)
          t.config.define('typing', { transformations: { include: Jx } })
        }
        init() {
          const t = this.editor.model
          const e = t.document.selection
          e.on('change:range', () => {
            this.isEnabled = !e.anchor.parent.is('element', 'codeBlock')
          })
          this._enableTransformationWatchers()
        }
        _enableTransformationWatchers() {
          const t = this.editor
          const e = t.model
          const n = t.plugins.get('Delete')
          const i = oE(t.config.get('typing.transformations'))
          const o = (t) => {
            for (const e of i) {
              const n = e.from
              const i = n.test(t)
              if (i) {
                return { normalizedTransformation: e }
              }
            }
          }
          const r = new jx(t.model, o)
          r.on('matched:data', (t, i) => {
            if (!i.batch.isTyping) {
              return
            }
            const { from: o, to: r } = i.normalizedTransformation
            const s = o.exec(i.text)
            const a = r(s.slice(1))
            const c = i.range
            let l = s.index
            e.enqueueChange((t) => {
              for (let n = 1; n < s.length; n++) {
                const i = s[n]
                const o = a[n - 1]
                if (o == null) {
                  l += i.length
                  continue
                }
                const r = c.start.getShiftedBy(l)
                const d = e.createRange(r, r.getShiftedBy(i.length))
                const u = nE(r)
                e.insertContent(t.createText(o, u), d)
                l += o.length
              }
              e.enqueueChange(() => {
                n.requestUndoOnBackspace()
              })
            })
          })
          r.bind('isEnabled').to(this)
        }
      }
      function tE(t) {
        if (typeof t == 'string') {
          return new RegExp(`(${Kx(t)})$`)
        }
        return t
      }
      function eE(t) {
        if (typeof t == 'string') {
          return () => [t]
        } else if (t instanceof Array) {
          return () => t
        }
        return t
      }
      function nE(t) {
        const e = t.textNode ? t.textNode : t.nodeAfter
        return e.getAttributes()
      }
      function iE(t) {
        return new RegExp(`(^|\\s)(${t})([^${t}]*)(${t})$`)
      }
      function oE(t) {
        const e = t.extra || []
        const n = t.remove || []
        const i = (t) => !n.includes(t)
        const o = t.include.concat(e).filter(i)
        return rE(o)
          .filter(i)
          .map((t) => (typeof t == 'string' && Qx[t] ? Qx[t] : t))
          .filter((t) => typeof t === 'object')
          .map((t) => ({ from: tE(t.from), to: eE(t.to) }))
      }
      function rE(t) {
        const e = new Set()
        for (const n of t) {
          if (typeof n == 'string' && Zx[n]) {
            for (const t of Zx[n]) {
              e.add(t)
            }
          } else {
            e.add(n)
          }
        }
        return Array.from(e)
      }
      function sE(t, e, n, i) {
        return i.createRange(aE(t, e, n, true, i), aE(t, e, n, false, i))
      }
      function aE(t, e, n, i, o) {
        let r = t.textNode || (i ? t.nodeBefore : t.nodeAfter)
        let s = null
        while (r && r.getAttribute(e) == n) {
          s = r
          r = i ? r.previousSibling : r.nextSibling
        }
        return s ? o.createPositionAt(s, i ? 'before' : 'after') : t
      }
      function cE(t, e, n, i) {
        const o = t.editing.view
        const r = new Set()
        o.document.registerPostFixer((o) => {
          const s = t.model.document.selection
          let a = false
          if (s.hasAttribute(e)) {
            const c = sE(s.getFirstPosition(), e, s.getAttribute(e), t.model)
            const l = t.editing.mapper.toViewRange(c)
            for (const t of l.getItems()) {
              if (t.is('element', n) && !t.hasClass(i)) {
                o.addClass(i, t)
                r.add(t)
                a = true
              }
            }
          }
          return a
        })
        t.conversion.for('editingDowncast').add((t) => {
          t.on('insert', e, { priority: 'highest' })
          t.on('remove', e, { priority: 'highest' })
          t.on('attribute', e, { priority: 'highest' })
          t.on('selection', e, { priority: 'highest' })
          function e() {
            o.change((t) => {
              for (const e of r.values()) {
                t.removeClass(i, e)
                r.delete(e)
              }
            })
          }
        })
      }
      function lE(t, e, n, i) {
        let o
        let r = null
        if (typeof i == 'function') {
          o = i
        } else {
          r = t.commands.get(i)
          o = () => {
            t.execute(i)
          }
        }
        t.model.document.on('change:data', (s, a) => {
          if ((r && !r.isEnabled) || !e.isEnabled) {
            return
          }
          const c = cl(t.model.document.selection.getRanges())
          if (!c.isCollapsed) {
            return
          }
          if (a.isUndo || !a.isLocal) {
            return
          }
          const l = Array.from(t.model.document.differ.getChanges())
          const d = l[0]
          if (
            l.length != 1 ||
            d.type !== 'insert' ||
            d.name != '$text' ||
            d.length != 1
          ) {
            return
          }
          const u = d.position.parent
          if (u.is('element', 'codeBlock')) {
            return
          }
          if (
            u.is('element', 'listItem') &&
            typeof i !== 'function' &&
            !['numberedList', 'bulletedList', 'todoList'].includes(i)
          ) {
            return
          }
          if (r && r.value === true) {
            return
          }
          const h = u.getChild(0)
          const f = t.model.createRangeOn(h)
          if (!f.containsRange(c) && !c.end.isEqual(f.end)) {
            return
          }
          const m = n.exec(h.data.substr(0, c.end.offset))
          if (!m) {
            return
          }
          t.model.enqueueChange((e) => {
            const n = e.createPositionAt(u, 0)
            const i = e.createPositionAt(u, m[0].length)
            const r = new hb(n, i)
            const s = o({ match: m })
            if (s !== false) {
              e.remove(r)
              const n = t.model.document.selection.getFirstRange()
              const i = e.createRangeIn(u)
              if (u.isEmpty && !i.isEqual(n) && !i.containsRange(n, true)) {
                e.remove(u)
              }
            }
            r.detach()
            t.model.enqueueChange(() => {
              t.plugins.get('Delete').requestUndoOnBackspace()
            })
          })
        })
      }
      function dE(t, e, n, i) {
        let o
        let r
        if (n instanceof RegExp) {
          o = n
        } else {
          r = n
        }
        r =
          r ||
          ((t) => {
            let e
            const n = []
            const i = []
            while ((e = o.exec(t)) !== null) {
              if (e && e.length < 4) {
                break
              }
              let { index: t, 1: o, 2: r, 3: s } = e
              const a = o + r + s
              t += e[0].length - a.length
              const c = [t, t + o.length]
              const l = [
                t + o.length + r.length,
                t + o.length + r.length + s.length
              ]
              n.push(c)
              n.push(l)
              i.push([t + o.length, t + o.length + r.length])
            }
            return { remove: n, format: i }
          })
        t.model.document.on('change:data', (n, o) => {
          if (o.isUndo || !o.isLocal || !e.isEnabled) {
            return
          }
          const s = t.model
          const a = s.document.selection
          if (!a.isCollapsed) {
            return
          }
          const c = Array.from(s.document.differ.getChanges())
          const l = c[0]
          if (
            c.length != 1 ||
            l.type !== 'insert' ||
            l.name != '$text' ||
            l.length != 1
          ) {
            return
          }
          const d = a.focus
          const u = d.parent
          const { text: h, range: f } = hE(
            s.createRange(s.createPositionAt(u, 0), d),
            s
          )
          const m = r(h)
          const g = uE(f.start, m.format, s)
          const p = uE(f.start, m.remove, s)
          if (!(g.length && p.length)) {
            return
          }
          s.enqueueChange((e) => {
            const n = i(e, g)
            if (n === false) {
              return
            }
            for (const t of p.reverse()) {
              e.remove(t)
            }
            s.enqueueChange(() => {
              t.plugins.get('Delete').requestUndoOnBackspace()
            })
          })
        })
      }
      function uE(t, e, n) {
        return e
          .filter((t) => t[0] !== undefined && t[1] !== undefined)
          .map((e) => n.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1])))
      }
      function hE(t, e) {
        let n = t.start
        const i = Array.from(t.getItems()).reduce((t, i) => {
          if (
            !(i.is('$text') || i.is('$textProxy')) ||
            i.getAttribute('code')
          ) {
            n = e.createPositionAfter(i)
            return ''
          }
          return t + i.data
        }, '')
        return { text: i, range: e.createRange(n, t.end) }
      }
      class fE extends Kd {
        static get requires() {
          return [Lx]
        }
        static get pluginName() {
          return 'Autoformat'
        }
        afterInit() {
          this._addListAutoformats()
          this._addBasicStylesAutoformats()
          this._addHeadingAutoformats()
          this._addBlockQuoteAutoformats()
          this._addCodeBlockAutoformats()
          this._addHorizontalLineAutoformats()
        }
        _addListAutoformats() {
          const t = this.editor.commands
          if (t.get('bulletedList')) {
            lE(this.editor, this, /^[*-]\s$/, 'bulletedList')
          }
          if (t.get('numberedList')) {
            lE(this.editor, this, /^1[.|)]\s$/, 'numberedList')
          }
          if (t.get('todoList')) {
            lE(this.editor, this, /^\[\s?\]\s$/, 'todoList')
          }
          if (t.get('checkTodoList')) {
            lE(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
              this.editor.execute('todoList')
              this.editor.execute('checkTodoList')
            })
          }
        }
        _addBasicStylesAutoformats() {
          const t = this.editor.commands
          if (t.get('bold')) {
            const t = mE(this.editor, 'bold')
            dE(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t)
            dE(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t)
          }
          if (t.get('italic')) {
            const t = mE(this.editor, 'italic')
            dE(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t)
            dE(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t)
          }
          if (t.get('code')) {
            const t = mE(this.editor, 'code')
            dE(this.editor, this, /(`)([^`]+)(`)$/g, t)
          }
          if (t.get('strikethrough')) {
            const t = mE(this.editor, 'strikethrough')
            dE(this.editor, this, /(~~)([^~]+)(~~)$/g, t)
          }
        }
        _addHeadingAutoformats() {
          const t = this.editor.commands.get('heading')
          if (t) {
            t.modelElements
              .filter((t) => t.match(/^heading[1-6]$/))
              .forEach((e) => {
                const n = e[7]
                const i = new RegExp(`^(#{${n}})\\s$`)
                lE(this.editor, this, i, () => {
                  if (!t.isEnabled || t.value === e) {
                    return false
                  }
                  this.editor.execute('heading', { value: e })
                })
              })
          }
        }
        _addBlockQuoteAutoformats() {
          if (this.editor.commands.get('blockQuote')) {
            lE(this.editor, this, /^>\s$/, 'blockQuote')
          }
        }
        _addCodeBlockAutoformats() {
          const t = this.editor
          const e = t.model.document.selection
          if (t.commands.get('codeBlock')) {
            lE(t, this, /^```$/, () => {
              if (e.getFirstPosition().parent.is('element', 'listItem')) {
                return false
              }
              this.editor.execute('codeBlock', {
                usePreviousLanguageChoice: true
              })
            })
          }
        }
        _addHorizontalLineAutoformats() {
          if (this.editor.commands.get('horizontalLine')) {
            lE(this.editor, this, /^---$/, 'horizontalLine')
          }
        }
      }
      function mE(t, e) {
        return (n, i) => {
          const o = t.commands.get(e)
          if (!o.isEnabled) {
            return false
          }
          const r = t.model.schema.getValidRanges(i, e)
          for (const t of r) {
            n.setAttribute(e, true, t)
          }
          n.removeSelectionAttribute(e)
        }
      }
      function* gE(t, e) {
        for (const n of e) {
          if (n && t.getAttributeProperties(n[0]).copyOnEnter) {
            yield n
          }
        }
      }
      class pE extends Zd {
        execute() {
          this.editor.model.change((t) => {
            this.enterBlock(t)
            this.fire('afterExecute', { writer: t })
          })
        }
        enterBlock(t) {
          const e = this.editor.model
          const n = e.document.selection
          const i = e.schema
          const o = n.isCollapsed
          const r = n.getFirstRange()
          const s = r.start.parent
          const a = r.end.parent
          if (i.isLimit(s) || i.isLimit(a)) {
            if (!o && s == a) {
              e.deleteContent(n)
            }
            return false
          }
          if (o) {
            const e = gE(t.model.schema, n.getAttributes())
            bE(t, r.start)
            t.setSelectionAttribute(e)
            return true
          } else {
            const i = !(r.start.isAtStart && r.end.isAtEnd)
            const o = s == a
            e.deleteContent(n, { leaveUnmerged: i })
            if (i) {
              if (o) {
                bE(t, n.focus)
                return true
              } else {
                t.setSelection(a, 0)
              }
            }
          }
          return false
        }
      }
      function bE(t, e) {
        t.split(e)
        t.setSelection(e.parent.nextSibling, 0)
      }
      const kE = {
        insertParagraph: { isSoft: false },
        insertLineBreak: { isSoft: true }
      }
      class wE extends Xm {
        constructor(t) {
          super(t)
          const e = this.document
          e.on('beforeinput', (n, i) => {
            if (!this.isEnabled) {
              return
            }
            const o = i.domEvent
            const r = kE[i.inputType]
            if (!r) {
              return
            }
            const s = new Of(e, 'enter', i.targetRanges[0])
            e.fire(s, new ng(t, o, { isSoft: r.isSoft }))
            if (s.stop.called) {
              n.stop()
            }
          })
        }
        observe() {}
      }
      class _E extends Kd {
        static get pluginName() {
          return 'Enter'
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          e.addObserver(wE)
          t.commands.add('enter', new pE(t))
          this.listenTo(
            n,
            'enter',
            (i, o) => {
              if (!n.isComposing) {
                o.preventDefault()
              }
              if (o.isSoft) {
                return
              }
              t.execute('enter')
              e.scrollToTheSelection()
            },
            { priority: 'low' }
          )
        }
      }
      class AE extends Zd {
        execute() {
          const t = this.editor.model
          const e = t.document
          t.change((n) => {
            CE(t, n, e.selection)
            this.fire('afterExecute', { writer: n })
          })
        }
        refresh() {
          const t = this.editor.model
          const e = t.document
          this.isEnabled = vE(t.schema, e.selection)
        }
      }
      function vE(t, e) {
        if (e.rangeCount > 1) {
          return false
        }
        const n = e.anchor
        if (!n || !t.checkChild(n, 'softBreak')) {
          return false
        }
        const i = e.getFirstRange()
        const o = i.start.parent
        const r = i.end.parent
        if ((xE(o, t) || xE(r, t)) && o !== r) {
          return false
        }
        return true
      }
      function CE(t, e, n) {
        const i = n.isCollapsed
        const o = n.getFirstRange()
        const r = o.start.parent
        const s = o.end.parent
        const a = r == s
        if (i) {
          const i = gE(t.schema, n.getAttributes())
          yE(t, e, o.end)
          e.removeSelectionAttribute(n.getAttributeKeys())
          e.setSelectionAttribute(i)
        } else {
          const i = !(o.start.isAtStart && o.end.isAtEnd)
          t.deleteContent(n, { leaveUnmerged: i })
          if (a) {
            yE(t, e, n.focus)
          } else {
            if (i) {
              e.setSelection(s, 0)
            }
          }
        }
      }
      function yE(t, e, n) {
        const i = e.createElement('softBreak')
        t.insertContent(i, n)
        e.setSelection(i, 'after')
      }
      function xE(t, e) {
        if (t.is('rootElement')) {
          return false
        }
        return e.isLimit(t) || xE(t.parent, e)
      }
      class EE extends Kd {
        static get pluginName() {
          return 'ShiftEnter'
        }
        init() {
          const t = this.editor
          const e = t.model.schema
          const n = t.conversion
          const i = t.editing.view
          const o = i.document
          e.register('softBreak', { allowWhere: '$text', isInline: true })
          n.for('upcast').elementToElement({ model: 'softBreak', view: 'br' })
          n.for('downcast').elementToElement({
            model: 'softBreak',
            view: (t, { writer: e }) => e.createEmptyElement('br')
          })
          i.addObserver(wE)
          t.commands.add('shiftEnter', new AE(t))
          this.listenTo(
            o,
            'enter',
            (e, n) => {
              if (!o.isComposing) {
                n.preventDefault()
              }
              if (!n.isSoft) {
                return
              }
              t.execute('shiftEnter')
              i.scrollToTheSelection()
            },
            { priority: 'low' }
          )
        }
      }
      class DE extends Zd {
        refresh() {
          this.value = this._getValue()
          this.isEnabled = this._checkEnabled()
        }
        execute(t = {}) {
          const e = this.editor.model
          const n = e.schema
          const i = e.document.selection
          const o = Array.from(i.getSelectedBlocks())
          const r = t.forceValue === undefined ? !this.value : t.forceValue
          e.change((t) => {
            if (!r) {
              this._removeQuote(t, o.filter(TE))
            } else {
              const e = o.filter((t) => TE(t) || IE(n, t))
              this._applyQuote(t, e)
            }
          })
        }
        _getValue() {
          const t = this.editor.model.document.selection
          const e = cl(t.getSelectedBlocks())
          return !!(e && TE(e))
        }
        _checkEnabled() {
          if (this.value) {
            return true
          }
          const t = this.editor.model.document.selection
          const e = this.editor.model.schema
          const n = cl(t.getSelectedBlocks())
          if (!n) {
            return false
          }
          return IE(e, n)
        }
        _removeQuote(t, e) {
          ME(t, e)
            .reverse()
            .forEach((e) => {
              if (e.start.isAtStart && e.end.isAtEnd) {
                t.unwrap(e.start.parent)
                return
              }
              if (e.start.isAtStart) {
                const n = t.createPositionBefore(e.start.parent)
                t.move(e, n)
                return
              }
              if (!e.end.isAtEnd) {
                t.split(e.end)
              }
              const n = t.createPositionAfter(e.end.parent)
              t.move(e, n)
            })
        }
        _applyQuote(t, e) {
          const n = []
          ME(t, e)
            .reverse()
            .forEach((e) => {
              let i = TE(e.start)
              if (!i) {
                i = t.createElement('blockQuote')
                t.wrap(e, i)
              }
              n.push(i)
            })
          n.reverse().reduce((e, n) => {
            if (e.nextSibling == n) {
              t.merge(t.createPositionAfter(e))
              return e
            }
            return n
          })
        }
      }
      function TE(t) {
        return t.parent.name == 'blockQuote' ? t.parent : null
      }
      function ME(t, e) {
        let n
        let i = 0
        const o = []
        while (i < e.length) {
          const r = e[i]
          const s = e[i + 1]
          if (!n) {
            n = t.createPositionBefore(r)
          }
          if (!s || r.nextSibling != s) {
            o.push(t.createRange(n, t.createPositionAfter(r)))
            n = null
          }
          i++
        }
        return o
      }
      function IE(t, e) {
        const n = t.checkChild(e.parent, 'blockQuote')
        const i = t.checkChild(['$root', 'blockQuote'], e)
        return n && i
      }
      class SE extends Kd {
        static get pluginName() {
          return 'BlockQuoteEditing'
        }
        static get requires() {
          return [_E, Lx]
        }
        init() {
          const t = this.editor
          const e = t.model.schema
          t.commands.add('blockQuote', new DE(t))
          e.register('blockQuote', { inheritAllFrom: '$container' })
          t.conversion.elementToElement({
            model: 'blockQuote',
            view: 'blockquote'
          })
          t.model.document.registerPostFixer((n) => {
            const i = t.model.document.differ.getChanges()
            for (const t of i) {
              if (t.type == 'insert') {
                const i = t.position.nodeAfter
                if (!i) {
                  continue
                }
                if (i.is('element', 'blockQuote') && i.isEmpty) {
                  n.remove(i)
                  return true
                } else if (
                  i.is('element', 'blockQuote') &&
                  !e.checkChild(t.position, i)
                ) {
                  n.unwrap(i)
                  return true
                } else if (i.is('element')) {
                  const t = n.createRangeIn(i)
                  for (const i of t.getItems()) {
                    if (
                      i.is('element', 'blockQuote') &&
                      !e.checkChild(n.createPositionBefore(i), i)
                    ) {
                      n.unwrap(i)
                      return true
                    }
                  }
                }
              } else if (t.type == 'remove') {
                const e = t.position.parent
                if (e.is('element', 'blockQuote') && e.isEmpty) {
                  n.remove(e)
                  return true
                }
              }
            }
            return false
          })
          const n = this.editor.editing.view.document
          const i = t.model.document.selection
          const o = t.commands.get('blockQuote')
          this.listenTo(
            n,
            'enter',
            (e, n) => {
              if (!i.isCollapsed || !o.value) {
                return
              }
              const r = i.getLastPosition().parent
              if (r.isEmpty) {
                t.execute('blockQuote')
                t.editing.view.scrollToTheSelection()
                n.preventDefault()
                e.stop()
              }
            },
            { context: 'blockquote' }
          )
          this.listenTo(
            n,
            'delete',
            (e, n) => {
              if (n.direction != 'backward' || !i.isCollapsed || !o.value) {
                return
              }
              const r = i.getLastPosition().parent
              if (r.isEmpty && !r.previousSibling) {
                t.execute('blockQuote')
                t.editing.view.scrollToTheSelection()
                n.preventDefault()
                e.stop()
              }
            },
            { context: 'blockquote' }
          )
        }
      }
      var BE = __webpack_require__(636)
      var NE = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      NE.insert = 'head'
      NE.singleton = true
      var PE = El()(BE.Z, NE)
      const zE = BE.Z.locals || {}
      class LE extends Kd {
        static get pluginName() {
          return 'BlockQuoteUI'
        }
        init() {
          const t = this.editor
          const e = t.t
          t.ui.componentFactory.add('blockQuote', (n) => {
            const i = t.commands.get('blockQuote')
            const o = new pd(n)
            o.set({
              label: e('Block quote'),
              icon: $v.quote,
              tooltip: true,
              isToggleable: true
            })
            o.bind('isOn', 'isEnabled').to(i, 'value', 'isEnabled')
            this.listenTo(o, 'execute', () => {
              t.execute('blockQuote')
              t.editing.view.focus()
            })
            return o
          })
        }
      }
      class OE extends Kd {
        static get requires() {
          return [SE, LE]
        }
        static get pluginName() {
          return 'BlockQuote'
        }
      }
      class RE extends Zd {
        constructor(t, e) {
          super(t)
          this.attributeKey = e
        }
        refresh() {
          const t = this.editor.model
          const e = t.document
          this.value = this._getValueFromFirstAllowedNode()
          this.isEnabled = t.schema.checkAttributeInSelection(
            e.selection,
            this.attributeKey
          )
        }
        execute(t = {}) {
          const e = this.editor.model
          const n = e.document
          const i = n.selection
          const o = t.forceValue === undefined ? !this.value : t.forceValue
          e.change((t) => {
            if (i.isCollapsed) {
              if (o) {
                t.setSelectionAttribute(this.attributeKey, true)
              } else {
                t.removeSelectionAttribute(this.attributeKey)
              }
            } else {
              const n = e.schema.getValidRanges(
                i.getRanges(),
                this.attributeKey
              )
              for (const e of n) {
                if (o) {
                  t.setAttribute(this.attributeKey, o, e)
                } else {
                  t.removeAttribute(this.attributeKey, e)
                }
              }
            }
          })
        }
        _getValueFromFirstAllowedNode() {
          const t = this.editor.model
          const e = t.schema
          const n = t.document.selection
          if (n.isCollapsed) {
            return n.hasAttribute(this.attributeKey)
          }
          for (const t of n.getRanges()) {
            for (const n of t.getItems()) {
              if (e.checkAttribute(n, this.attributeKey)) {
                return n.hasAttribute(this.attributeKey)
              }
            }
          }
          return false
        }
      }
      const jE = 'bold'
      class FE extends Kd {
        static get pluginName() {
          return 'BoldEditing'
        }
        init() {
          const t = this.editor
          t.model.schema.extend('$text', { allowAttributes: jE })
          t.model.schema.setAttributeProperties(jE, {
            isFormatting: true,
            copyOnEnter: true
          })
          t.conversion.attributeToElement({
            model: jE,
            view: 'strong',
            upcastAlso: [
              'b',
              (t) => {
                const e = t.getStyle('font-weight')
                if (!e) {
                  return null
                }
                if (e == 'bold' || Number(e) >= 600) {
                  return { name: true, styles: ['font-weight'] }
                }
                return null
              }
            ]
          })
          t.commands.add(jE, new RE(t, jE))
          t.keystrokes.set('CTRL+B', jE)
        }
      }
      const VE = 'bold'
      class HE extends Kd {
        static get pluginName() {
          return 'BoldUI'
        }
        init() {
          const t = this.editor
          const e = t.t
          t.ui.componentFactory.add(VE, (n) => {
            const i = t.commands.get(VE)
            const o = new pd(n)
            o.set({
              label: e('Bold'),
              icon: $v.bold,
              keystroke: 'CTRL+B',
              tooltip: true,
              isToggleable: true
            })
            o.bind('isOn', 'isEnabled').to(i, 'value', 'isEnabled')
            this.listenTo(o, 'execute', () => {
              t.execute(VE)
              t.editing.view.focus()
            })
            return o
          })
        }
      }
      class UE extends Kd {
        static get requires() {
          return [FE, HE]
        }
        static get pluginName() {
          return 'Bold'
        }
      }
      const WE =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>'
      class qE extends Kd {
        static get pluginName() {
          return 'CKBoxUI'
        }
        afterInit() {
          const t = this.editor
          if (!t.commands.get('ckbox')) {
            return
          }
          const e = t.t
          const n = t.ui.componentFactory
          n.add('ckbox', (n) => {
            const i = t.commands.get('ckbox')
            const o = new pd(n)
            o.set({ label: e('Open file manager'), icon: WE, tooltip: true })
            o.bind('isOn', 'isEnabled').to(i, 'value', 'isEnabled')
            o.on('execute', () => {
              t.execute('ckbox')
            })
            return o
          })
        }
      }
      const $E = 4e3
      const GE = 80
      const YE = 10
      function KE({ token: t, id: e, origin: n, width: i, extension: o }) {
        const r = QE(t)
        const s = ZE(i)
        const a = JE(o)
        const c = XE({
          environmentId: r,
          id: e,
          origin: n,
          width: i,
          extension: a
        })
        const l = s.map((t) => {
          const i = XE({
            environmentId: r,
            id: e,
            origin: n,
            width: t,
            extension: 'webp'
          })
          return `${i} ${t}w`
        })
        const d = [
          {
            srcset: l.join(','),
            sizes: `(max-width: ${i}px) 100vw, ${i}px`,
            type: 'image/webp'
          }
        ]
        return { imageFallbackUrl: c, imageSources: d }
      }
      function QE(t) {
        const [, e] = t.value.split('.')
        const n = JSON.parse(atob(e))
        return n.aud
      }
      function ZE(t) {
        const e = [(t * YE) / 100, GE]
        const n = Math.floor(Math.max(...e))
        const i = [Math.min(t, $E)]
        let o = i[0]
        while (o - n >= n) {
          o -= n
          i.unshift(o)
        }
        return i
      }
      function JE(t) {
        if (t === 'bmp' || t === 'tiff' || t === 'jpg') {
          return 'jpeg'
        }
        return t
      }
      function XE({
        environmentId: t,
        id: e,
        origin: n,
        width: i,
        extension: o
      }) {
        const r = `${t}/assets/${e}/images/${i}.${o}`
        return new URL(r, n).toString()
      }
      const tD = 1e3
      class eD extends Zd {
        constructor(t) {
          super(t)
          this._chosenAssets = new Set()
          this._wrapper = null
          this._initListeners()
        }
        refresh() {
          this.value = this._getValue()
          this.isEnabled = this._checkEnabled()
        }
        execute() {
          this.fire('ckbox:open')
        }
        _getValue() {
          return this._wrapper !== null
        }
        _checkEnabled() {
          const t = this.editor.commands.get('insertImage')
          const e = this.editor.commands.get('link')
          if (!t.isEnabled && !e.isEnabled) {
            return false
          }
          return true
        }
        _prepareOptions() {
          const t = this.editor
          const e = t.config.get('ckbox')
          return {
            theme: e.theme,
            language: e.language,
            tokenUrl: e.tokenUrl,
            serviceOrigin: e.serviceOrigin,
            assetsOrigin: e.assetsOrigin,
            dialog: { onClose: () => this.fire('ckbox:close') },
            assets: { onChoose: (t) => this.fire('ckbox:choose', t) }
          }
        }
        _initListeners() {
          const t = this.editor
          const e = t.model
          const n = !t.config.get('ckbox.ignoreDataId')
          this.on(
            'ckbox',
            () => {
              this.refresh()
            },
            { priority: 'low' }
          )
          this.on('ckbox:open', () => {
            if (!this.isEnabled || this.value) {
              return
            }
            this._wrapper = ne(document, 'div', { class: 'ck ckbox-wrapper' })
            document.body.appendChild(this._wrapper)
            window.CKBox.mount(this._wrapper, this._prepareOptions())
          })
          this.on('ckbox:close', () => {
            if (!this.value) {
              return
            }
            this._wrapper.remove()
            this._wrapper = null
          })
          this.on('ckbox:choose', (i, o) => {
            if (!this.isEnabled) {
              return
            }
            const r = t.commands.get('insertImage')
            const s = t.commands.get('link')
            const a = t.plugins.get('CKBoxEditing')
            const c = t.config.get('ckbox.assetsOrigin')
            const l = nD({
              assets: o,
              origin: c,
              token: a.getToken(),
              isImageAllowed: r.isEnabled,
              isLinkAllowed: s.isEnabled
            })
            if (l.length === 0) {
              return
            }
            e.change((t) => {
              for (const e of l) {
                const i = e === l[l.length - 1]
                this._insertAsset(e, i, t)
                if (n) {
                  setTimeout(() => this._chosenAssets.delete(e), tD)
                  this._chosenAssets.add(e)
                }
              }
            })
          })
          this.listenTo(t, 'destroy', () => {
            this.fire('ckbox:close')
            this._chosenAssets.clear()
          })
        }
        _insertAsset(t, e, n) {
          const i = this.editor
          const o = i.model
          const r = o.document.selection
          n.removeSelectionAttribute('linkHref')
          if (t.type === 'image') {
            this._insertImage(t)
          } else {
            this._insertLink(t, n)
          }
          if (!e) {
            n.setSelection(r.getLastPosition())
          }
        }
        _insertImage(t) {
          const e = this.editor
          const {
            imageFallbackUrl: n,
            imageSources: i,
            imageTextAlternative: o
          } = t.attributes
          e.execute('insertImage', { source: { src: n, sources: i, alt: o } })
        }
        _insertLink(t, e) {
          const n = this.editor
          const i = n.model
          const o = i.document.selection
          const { linkName: r, linkHref: s } = t.attributes
          if (o.isCollapsed) {
            const t = hl(o.getAttributes())
            const n = e.createText(r, t)
            const s = i.insertContent(n)
            e.setSelection(s)
          }
          n.execute('link', s)
        }
      }
      function nD({
        assets: t,
        origin: e,
        token: n,
        isImageAllowed: i,
        isLinkAllowed: o
      }) {
        return t
          .map((t) => ({
            id: t.data.id,
            type: oD(t) ? 'image' : 'link',
            attributes: iD(t, n, e)
          }))
          .filter((t) => (t.type === 'image' ? i : o))
      }
      function iD(t, e, n) {
        if (oD(t)) {
          const { imageFallbackUrl: i, imageSources: o } = KE({
            token: e,
            origin: n,
            id: t.data.id,
            width: t.data.metadata.width,
            extension: t.data.extension
          })
          return {
            imageFallbackUrl: i,
            imageSources: o,
            imageTextAlternative: t.data.metadata.description || ''
          }
        }
        return { linkName: t.data.name, linkHref: rD(t, e, n) }
      }
      function oD(t) {
        const e = t.data.metadata
        if (!e) {
          return false
        }
        return e.width && e.height
      }
      function rD(t, e, n) {
        const i = QE(e)
        const o = new URL(`${i}/assets/${t.data.id}/file`, n)
        o.searchParams.set('download', 'true')
        return o.toString()
      }
      class sD extends ht() {
        constructor() {
          super()
          const t = new window.FileReader()
          this._reader = t
          this._data = undefined
          this.set('loaded', 0)
          t.onprogress = (t) => {
            this.loaded = t.loaded
          }
        }
        get error() {
          return this._reader.error
        }
        get data() {
          return this._data
        }
        read(t) {
          const e = this._reader
          this.total = t.size
          return new Promise((n, i) => {
            e.onload = () => {
              const t = e.result
              this._data = t
              n(t)
            }
            e.onerror = () => {
              i('error')
            }
            e.onabort = () => {
              i('aborted')
            }
            this._reader.readAsDataURL(t)
          })
        }
        abort() {
          this._reader.abort()
        }
      }
      class aD extends Kd {
        static get pluginName() {
          return 'FileRepository'
        }
        static get requires() {
          return [uv]
        }
        init() {
          this.loaders = new al()
          this.loaders.on('change', () => this._updatePendingAction())
          this._loadersMap = new Map()
          this._pendingAction = null
          this.set('uploaded', 0)
          this.set('uploadTotal', null)
          this.bind('uploadedPercent').to(
            this,
            'uploaded',
            this,
            'uploadTotal',
            (t, e) => (e ? (t / e) * 100 : 0)
          )
        }
        getLoader(t) {
          return this._loadersMap.get(t) || null
        }
        createLoader(t) {
          if (!this.createUploadAdapter) {
            P('filerepository-no-upload-adapter')
            return null
          }
          const e = new cD(Promise.resolve(t), this.createUploadAdapter)
          this.loaders.add(e)
          this._loadersMap.set(t, e)
          if (t instanceof Promise) {
            e.file
              .then((t) => {
                this._loadersMap.set(t, e)
              })
              .catch(() => {})
          }
          e.on('change:uploaded', () => {
            let t = 0
            for (const e of this.loaders) {
              t += e.uploaded
            }
            this.uploaded = t
          })
          e.on('change:uploadTotal', () => {
            let t = 0
            for (const e of this.loaders) {
              if (e.uploadTotal) {
                t += e.uploadTotal
              }
            }
            this.uploadTotal = t
          })
          return e
        }
        destroyLoader(t) {
          const e = t instanceof cD ? t : this.getLoader(t)
          e._destroy()
          this.loaders.remove(e)
          this._loadersMap.forEach((t, n) => {
            if (t === e) {
              this._loadersMap.delete(n)
            }
          })
        }
        _updatePendingAction() {
          const t = this.editor.plugins.get(uv)
          if (this.loaders.length) {
            if (!this._pendingAction) {
              const e = this.editor.t
              const n = (t) => `${e('Upload in progress')} ${parseInt(t)}%.`
              this._pendingAction = t.add(n(this.uploadedPercent))
              this._pendingAction.bind('message').to(this, 'uploadedPercent', n)
            }
          } else {
            t.remove(this._pendingAction)
            this._pendingAction = null
          }
        }
      }
      class cD extends ht() {
        constructor(t, e) {
          super()
          this.id = T()
          this._filePromiseWrapper = this._createFilePromiseWrapper(t)
          this._adapter = e(this)
          this._reader = new sD()
          this.set('status', 'idle')
          this.set('uploaded', 0)
          this.set('uploadTotal', null)
          this.bind('uploadedPercent').to(
            this,
            'uploaded',
            this,
            'uploadTotal',
            (t, e) => (e ? (t / e) * 100 : 0)
          )
          this.set('uploadResponse', null)
        }
        get file() {
          if (!this._filePromiseWrapper) {
            return Promise.resolve(null)
          } else {
            return this._filePromiseWrapper.promise.then((t) =>
              this._filePromiseWrapper ? t : null
            )
          }
        }
        get data() {
          return this._reader.data
        }
        read() {
          if (this.status != 'idle') {
            throw new N('filerepository-read-wrong-status', this)
          }
          this.status = 'reading'
          return this.file
            .then((t) => this._reader.read(t))
            .then((t) => {
              if (this.status !== 'reading') {
                throw this.status
              }
              this.status = 'idle'
              return t
            })
            .catch((t) => {
              if (t === 'aborted') {
                this.status = 'aborted'
                throw 'aborted'
              }
              this.status = 'error'
              throw this._reader.error ? this._reader.error : t
            })
        }
        upload() {
          if (this.status != 'idle') {
            throw new N('filerepository-upload-wrong-status', this)
          }
          this.status = 'uploading'
          return this.file
            .then(() => this._adapter.upload())
            .then((t) => {
              this.uploadResponse = t
              this.status = 'idle'
              return t
            })
            .catch((t) => {
              if (this.status === 'aborted') {
                throw 'aborted'
              }
              this.status = 'error'
              throw t
            })
        }
        abort() {
          const t = this.status
          this.status = 'aborted'
          if (!this._filePromiseWrapper.isFulfilled) {
            this._filePromiseWrapper.promise.catch(() => {})
            this._filePromiseWrapper.rejecter('aborted')
          } else if (t == 'reading') {
            this._reader.abort()
          } else if (t == 'uploading' && this._adapter.abort) {
            this._adapter.abort()
          }
          this._destroy()
        }
        _destroy() {
          this._filePromiseWrapper = undefined
          this._reader = undefined
          this._adapter = undefined
          this.uploadResponse = undefined
        }
        _createFilePromiseWrapper(t) {
          const e = {}
          e.promise = new Promise((n, i) => {
            e.rejecter = i
            e.isFulfilled = false
            t.then((t) => {
              e.isFulfilled = true
              n(t)
            }).catch((t) => {
              e.isFulfilled = true
              i(t)
            })
          })
          return e
        }
      }
      class lD extends Sl {
        constructor(t) {
          super(t)
          this.buttonView = new pd(t)
          this._fileInputView = new dD(t)
          this._fileInputView.bind('acceptedType').to(this)
          this._fileInputView.bind('allowMultipleFiles').to(this)
          this._fileInputView.delegate('done').to(this)
          this.setTemplate({
            tag: 'span',
            attributes: { class: 'ck-file-dialog-button' },
            children: [this.buttonView, this._fileInputView]
          })
          this.buttonView.on('execute', () => {
            this._fileInputView.open()
          })
        }
        focus() {
          this.buttonView.focus()
        }
      }
      class dD extends Sl {
        constructor(t) {
          super(t)
          this.set('acceptedType', undefined)
          this.set('allowMultipleFiles', false)
          const e = this.bindTemplate
          this.setTemplate({
            tag: 'input',
            attributes: {
              class: ['ck-hidden'],
              type: 'file',
              tabindex: '-1',
              accept: e.to('acceptedType'),
              multiple: e.to('allowMultipleFiles')
            },
            on: {
              change: e.to(() => {
                if (
                  this.element &&
                  this.element.files &&
                  this.element.files.length
                ) {
                  this.fire('done', this.element.files)
                }
                this.element.value = ''
              })
            }
          })
        }
        open() {
          this.element.click()
        }
      }
      class uD extends (null && Plugin) {
        static get requires() {
          return [FileRepository]
        }
        static get pluginName() {
          return 'Base64UploadAdapter'
        }
        init() {
          this.editor.plugins.get(FileRepository).createUploadAdapter = (t) =>
            new hD(t)
        }
      }
      class hD {
        constructor(t) {
          this.loader = t
        }
        upload() {
          return new Promise((t, e) => {
            const n = (this.reader = new window.FileReader())
            n.addEventListener('load', () => {
              t({ default: n.result })
            })
            n.addEventListener('error', (t) => {
              e(t)
            })
            n.addEventListener('abort', () => {
              e()
            })
            this.loader.file.then((t) => {
              n.readAsDataURL(t)
            })
          })
        }
        abort() {
          this.reader.abort()
        }
      }
      class fD extends (null && Plugin) {
        static get requires() {
          return [FileRepository]
        }
        static get pluginName() {
          return 'SimpleUploadAdapter'
        }
        init() {
          const t = this.editor.config.get('simpleUpload')
          if (!t) {
            return
          }
          if (!t.uploadUrl) {
            logWarning('simple-upload-adapter-missing-uploadurl')
            return
          }
          this.editor.plugins.get(FileRepository).createUploadAdapter = (e) =>
            new mD(e, t)
        }
      }
      class mD {
        constructor(t, e) {
          this.loader = t
          this.options = e
        }
        upload() {
          return this.loader.file.then(
            (t) =>
              new Promise((e, n) => {
                this._initRequest()
                this._initListeners(e, n, t)
                this._sendRequest(t)
              })
          )
        }
        abort() {
          if (this.xhr) {
            this.xhr.abort()
          }
        }
        _initRequest() {
          const t = (this.xhr = new XMLHttpRequest())
          t.open('POST', this.options.uploadUrl, true)
          t.responseType = 'json'
        }
        _initListeners(t, e, n) {
          const i = this.xhr
          const o = this.loader
          const r = `Couldn't upload file: ${n.name}.`
          i.addEventListener('error', () => e(r))
          i.addEventListener('abort', () => e())
          i.addEventListener('load', () => {
            const n = i.response
            if (!n || n.error) {
              return e(n && n.error && n.error.message ? n.error.message : r)
            }
            const o = n.url ? { default: n.url } : n.urls
            t({ ...n, urls: o })
          })
          if (i.upload) {
            i.upload.addEventListener('progress', (t) => {
              if (t.lengthComputable) {
                o.uploadTotal = t.total
                o.uploaded = t.loaded
              }
            })
          }
        }
        _sendRequest(t) {
          const e = this.options.headers || {}
          const n = this.options.withCredentials || false
          for (const t of Object.keys(e)) {
            this.xhr.setRequestHeader(t, e[t])
          }
          this.xhr.withCredentials = n
          const i = new FormData()
          i.append('upload', t)
          this.xhr.send(i)
        }
      }
      class gD extends Kd {
        static get requires() {
          return ['ImageUploadEditing', 'ImageUploadProgress', aD, kD]
        }
        static get pluginName() {
          return 'CKBoxUploadAdapter'
        }
        async afterInit() {
          const t = this.editor
          const e = !!t.config.get('ckbox')
          const n = !!window.CKBox
          if (!e && !n) {
            return
          }
          const i = t.plugins.get(aD)
          const o = t.plugins.get(kD)
          i.createUploadAdapter = (e) => new pD(e, o.getToken(), t)
          const r = !t.config.get('ckbox.ignoreDataId')
          const s = t.plugins.get('ImageUploadEditing')
          if (r) {
            s.on('uploadComplete', (e, { imageElement: n, data: i }) => {
              t.model.change((t) => {
                t.setAttribute('ckboxImageId', i.ckboxImageId, n)
              })
            })
          }
        }
      }
      class pD {
        constructor(t, e, n) {
          this.loader = t
          this.token = e
          this.editor = n
          this.controller = new AbortController()
          this.serviceOrigin = n.config.get('ckbox.serviceOrigin')
          this.assetsOrigin = n.config.get('ckbox.assetsOrigin')
        }
        async getAvailableCategories(t = 0) {
          const e = 50
          const n = new URL('categories', this.serviceOrigin)
          n.searchParams.set('limit', e.toString())
          n.searchParams.set('offset', t.toString())
          return this._sendHttpRequest({ url: n })
            .then(async (n) => {
              const i = n.totalCount - (t + e)
              if (i > 0) {
                const i = await this.getAvailableCategories(t + e)
                return [...n.items, ...i]
              }
              return n.items
            })
            .catch(() => {
              this.controller.signal.throwIfAborted()
              z('ckbox-fetch-category-http-error')
            })
        }
        async getCategoryIdForFile(t) {
          const e = bD(t.name)
          const n = await this.getAvailableCategories()
          if (!n) {
            return null
          }
          const i = this.editor.config.get('ckbox.defaultUploadCategories')
          if (i) {
            const t = Object.keys(i).find((t) => i[t].includes(e))
            if (t) {
              const e = n.find((e) => e.id === t || e.name === t)
              if (!e) {
                return null
              }
              return e.id
            }
          }
          const o = n.find((t) => t.extensions.includes(e))
          if (!o) {
            return null
          }
          return o.id
        }
        async upload() {
          const t = this.editor.t
          const e = t('Cannot determine a category for the uploaded file.')
          const n = await this.loader.file
          const i = await this.getCategoryIdForFile(n)
          if (!i) {
            return Promise.reject(e)
          }
          const o = new URL('assets', this.serviceOrigin)
          const r = new FormData()
          r.append('categoryId', i)
          r.append('file', n)
          const s = {
            method: 'POST',
            url: o,
            data: r,
            onUploadProgress: (t) => {
              if (t.lengthComputable) {
                this.loader.uploadTotal = t.total
                this.loader.uploaded = t.loaded
              }
            }
          }
          return this._sendHttpRequest(s)
            .then(async (t) => {
              const e = await this._getImageWidth()
              const i = bD(n.name)
              const o = KE({
                token: this.token,
                id: t.id,
                origin: this.assetsOrigin,
                width: e,
                extension: i
              })
              return {
                ckboxImageId: t.id,
                default: o.imageFallbackUrl,
                sources: o.imageSources
              }
            })
            .catch(() => {
              const e = t('Cannot upload file:') + ` ${n.name}.`
              return Promise.reject(e)
            })
        }
        abort() {
          this.controller.abort()
        }
        _sendHttpRequest(t) {
          const { url: e, data: n, onUploadProgress: i } = t
          const o = t.method || 'GET'
          const r = this.controller.signal
          const s = new XMLHttpRequest()
          s.open(o, e.toString(), true)
          s.setRequestHeader('Authorization', this.token.value)
          s.setRequestHeader('CKBox-Version', 'CKEditor 5')
          s.responseType = 'json'
          const a = () => {
            s.abort()
          }
          return new Promise((t, e) => {
            r.addEventListener('abort', a)
            s.addEventListener('loadstart', () => {
              r.addEventListener('abort', a)
            })
            s.addEventListener('loadend', () => {
              r.removeEventListener('abort', a)
            })
            s.addEventListener('error', () => {
              e()
            })
            s.addEventListener('abort', () => {
              e()
            })
            s.addEventListener('load', async () => {
              const n = s.response
              if (!n || n.statusCode >= 400) {
                return e(n && n.message)
              }
              return t(n)
            })
            if (i) {
              s.upload.addEventListener('progress', (t) => {
                i(t)
              })
            }
            s.send(n)
          })
        }
        _getImageWidth() {
          return new Promise((t) => {
            const e = new Image()
            e.onload = () => {
              URL.revokeObjectURL(e.src)
              t(e.width)
            }
            e.src = this.loader.data
          })
        }
      }
      function bD(t) {
        const e = /\.(?<ext>[^.]+)$/
        const n = t.match(e)
        return n.groups.ext
      }
      class kD extends Kd {
        static get pluginName() {
          return 'CKBoxEditing'
        }
        static get requires() {
          return ['CloudServices', 'LinkEditing', 'PictureEditing', gD]
        }
        async init() {
          const t = this.editor
          const e = !!t.config.get('ckbox')
          const n = !!window.CKBox
          if (!e && !n) {
            return
          }
          this._initConfig()
          const i = t.plugins.get('CloudServicesCore')
          const o = t.config.get('ckbox.tokenUrl')
          const r = t.config.get('cloudServices.tokenUrl')
          if (o === r) {
            this._token = t.plugins.get('CloudServices').token
          } else {
            this._token = await i.createToken(o).init()
          }
          if (!t.config.get('ckbox.ignoreDataId')) {
            this._initSchema()
            this._initConversion()
            this._initFixers()
          }
          if (n) {
            t.commands.add('ckbox', new eD(t))
          }
        }
        getToken() {
          return this._token
        }
        _initConfig() {
          const t = this.editor
          t.config.define('ckbox', {
            serviceOrigin: 'https://api.ckbox.io',
            assetsOrigin: 'https://ckbox.cloud',
            defaultUploadCategories: null,
            ignoreDataId: false,
            language: t.locale.uiLanguage,
            theme: 'default',
            tokenUrl: t.config.get('cloudServices.tokenUrl')
          })
          const e = t.config.get('ckbox.tokenUrl')
          if (!e) {
            throw new N('ckbox-plugin-missing-token-url', this)
          }
          if (
            !t.plugins.has('ImageBlockEditing') &&
            !t.plugins.has('ImageInlineEditing')
          ) {
            z('ckbox-plugin-image-feature-missing', t)
          }
        }
        _initSchema() {
          const t = this.editor
          const e = t.model.schema
          e.extend('$text', { allowAttributes: 'ckboxLinkId' })
          if (e.isRegistered('imageBlock')) {
            e.extend('imageBlock', {
              allowAttributes: ['ckboxImageId', 'ckboxLinkId']
            })
          }
          if (e.isRegistered('imageInline')) {
            e.extend('imageInline', {
              allowAttributes: ['ckboxImageId', 'ckboxLinkId']
            })
          }
          e.addAttributeCheck((t, e) => {
            const n = !!t.last.getAttribute('linkHref')
            if (!n && e === 'ckboxLinkId') {
              return false
            }
          })
        }
        _initConversion() {
          const t = this.editor
          t.conversion.for('downcast').add((t) => {
            t.on(
              'attribute:ckboxLinkId:imageBlock',
              (t, e, n) => {
                const { writer: i, mapper: o, consumable: r } = n
                if (!r.consume(e.item, t.name)) {
                  return
                }
                const s = o.toViewElement(e.item)
                const a = [...s.getChildren()].find((t) => t.name === 'a')
                if (!a) {
                  return
                }
                if (e.item.hasAttribute('ckboxLinkId')) {
                  i.setAttribute(
                    'data-ckbox-resource-id',
                    e.item.getAttribute('ckboxLinkId'),
                    a
                  )
                } else {
                  i.removeAttribute('data-ckbox-resource-id', a)
                }
              },
              { priority: 'low' }
            )
            t.on(
              'attribute:ckboxLinkId',
              (t, e, n) => {
                const { writer: i, mapper: o, consumable: r } = n
                if (!r.consume(e.item, t.name)) {
                  return
                }
                if (e.attributeOldValue) {
                  const t = vD(i, e.attributeOldValue)
                  i.unwrap(o.toViewRange(e.range), t)
                }
                if (e.attributeNewValue) {
                  const t = vD(i, e.attributeNewValue)
                  if (e.item.is('selection')) {
                    const e = i.document.selection
                    i.wrap(e.getFirstRange(), t)
                  } else {
                    i.wrap(o.toViewRange(e.range), t)
                  }
                }
              },
              { priority: 'low' }
            )
          })
          t.conversion.for('upcast').add((t) => {
            t.on(
              'element:a',
              (t, e, n) => {
                const { writer: i, consumable: o } = n
                if (!e.viewItem.getAttribute('href')) {
                  return
                }
                const r = { attributes: ['data-ckbox-resource-id'] }
                if (!o.consume(e.viewItem, r)) {
                  return
                }
                const s = e.viewItem.getAttribute('data-ckbox-resource-id')
                if (!s) {
                  return
                }
                if (e.modelRange) {
                  for (let t of e.modelRange.getItems()) {
                    if (t.is('$textProxy')) {
                      t = t.textNode
                    }
                    if (CD(t)) {
                      i.setAttribute('ckboxLinkId', s, t)
                    }
                  }
                } else {
                  const t = e.modelCursor.nodeBefore || e.modelCursor.parent
                  i.setAttribute('ckboxLinkId', s, t)
                }
              },
              { priority: 'low' }
            )
          })
          t.conversion
            .for('downcast')
            .attributeToAttribute({
              model: 'ckboxImageId',
              view: 'data-ckbox-resource-id'
            })
          t.conversion
            .for('upcast')
            .elementToAttribute({
              model: {
                key: 'ckboxImageId',
                value: (t) => t.getAttribute('data-ckbox-resource-id')
              },
              view: { attributes: { 'data-ckbox-resource-id': /[\s\S]+/ } }
            })
        }
        _initFixers() {
          const t = this.editor
          const e = t.model
          const n = e.document.selection
          e.document.registerPostFixer(wD(t))
          e.document.registerPostFixer(_D(n))
        }
      }
      function wD(t) {
        return (e) => {
          let n = false
          const i = t.model
          const o = t.commands.get('ckbox')
          if (!o) {
            return n
          }
          for (const t of i.document.differ.getChanges()) {
            if (t.type !== 'insert' && t.type !== 'attribute') {
              continue
            }
            const i =
              t.type === 'insert'
                ? new Jp(t.position, t.position.getShiftedBy(t.length))
                : t.range
            const r =
              t.type === 'attribute' &&
              t.attributeKey === 'linkHref' &&
              t.attributeNewValue === null
            for (const t of i.getItems()) {
              if (r && t.hasAttribute('ckboxLinkId')) {
                e.removeAttribute('ckboxLinkId', t)
                n = true
                continue
              }
              const i = AD(t, o._chosenAssets)
              for (const o of i) {
                const i = o.type === 'image' ? 'ckboxImageId' : 'ckboxLinkId'
                if (o.id === t.getAttribute(i)) {
                  continue
                }
                e.setAttribute(i, o.id, t)
                n = true
              }
            }
          }
          return n
        }
      }
      function _D(t) {
        return (e) => {
          const n = !t.hasAttribute('linkHref') && t.hasAttribute('ckboxLinkId')
          if (n) {
            e.removeSelectionAttribute('ckboxLinkId')
          }
        }
      }
      function AD(t, e) {
        const n =
          t.is('element', 'imageInline') || t.is('element', 'imageBlock')
        const i = t.hasAttribute('linkHref')
        return [...e].filter((e) => {
          if (e.type === 'image' && n) {
            return e.attributes.imageFallbackUrl === t.getAttribute('src')
          }
          if (e.type === 'link' && i) {
            return e.attributes.linkHref === t.getAttribute('linkHref')
          }
        })
      }
      function vD(t, e) {
        const n = t.createAttributeElement(
          'a',
          { 'data-ckbox-resource-id': e },
          { priority: 5 }
        )
        t.setCustomProperty('link', true, n)
        return n
      }
      function CD(t) {
        if (t.is('$text')) {
          return true
        }
        if (t.is('element', 'imageInline') || t.is('element', 'imageBlock')) {
          return true
        }
        return false
      }
      class yD extends Kd {
        static get pluginName() {
          return 'CKBox'
        }
        static get requires() {
          return [kD, qE]
        }
      }
      const xD = { autoRefresh: true }
      const ED = 36e5
      class DD {
        constructor(t, e = xD) {
          if (!t) {
            throw new N('token-missing-token-url', this)
          }
          if (e.initValue) {
            this._validateTokenValue(e.initValue)
          }
          this.set('value', e.initValue)
          if (typeof t === 'function') {
            this._refresh = t
          } else {
            this._refresh = () => TD(t)
          }
          this._options = Object.assign({}, xD, e)
        }
        init() {
          return new Promise((t, e) => {
            if (!this.value) {
              this.refreshToken().then(t).catch(e)
              return
            }
            if (this._options.autoRefresh) {
              this._registerRefreshTokenTimeout()
            }
            t(this)
          })
        }
        refreshToken() {
          return this._refresh()
            .then((t) => {
              this._validateTokenValue(t)
              this.set('value', t)
              if (this._options.autoRefresh) {
                this._registerRefreshTokenTimeout()
              }
            })
            .then(() => this)
        }
        destroy() {
          clearTimeout(this._tokenRefreshTimeout)
        }
        _validateTokenValue(t) {
          const e = typeof t === 'string'
          const n = !/^".*"$/.test(t)
          const i = e && t.split('.').length === 3
          if (!(n && i)) {
            throw new N('token-not-in-jwt-format', this)
          }
        }
        _registerRefreshTokenTimeout() {
          const t = this._getTokenRefreshTimeoutTime()
          clearTimeout(this._tokenRefreshTimeout)
          this._tokenRefreshTimeout = setTimeout(() => {
            this.refreshToken()
          }, t)
        }
        _getTokenRefreshTimeoutTime() {
          try {
            const [, t] = this.value.split('.')
            const { exp: e } = JSON.parse(atob(t))
            if (!e) {
              return ED
            }
            const n = Math.floor((e * 1e3 - Date.now()) / 2)
            return n
          } catch (t) {
            return ED
          }
        }
        static create(t, e = xD) {
          const n = new DD(t, e)
          return n.init()
        }
      }
      C(DD, ht)
      function TD(t) {
        return new Promise((e, n) => {
          const i = new XMLHttpRequest()
          i.open('GET', t)
          i.addEventListener('load', () => {
            const t = i.status
            const o = i.response
            if (t < 200 || t > 299) {
              return n(new N('token-cannot-download-new-token', null))
            }
            return e(o)
          })
          i.addEventListener('error', () => n(new Error('Network Error')))
          i.addEventListener('abort', () => n(new Error('Abort')))
          i.send()
        })
      }
      const MD = DD
      const ID = /^data:(\S*?);base64,/
      class SD {
        constructor(t, e, n) {
          if (!t) {
            throw new N('fileuploader-missing-file', null)
          }
          if (!e) {
            throw new N('fileuploader-missing-token', null)
          }
          if (!n) {
            throw new N('fileuploader-missing-api-address', null)
          }
          this.file = ND(t) ? BD(t) : t
          this._token = e
          this._apiAddress = n
        }
        onProgress(t) {
          this.on('progress', (e, n) => t(n))
          return this
        }
        onError(t) {
          this.once('error', (e, n) => t(n))
          return this
        }
        abort() {
          this.xhr.abort()
        }
        send() {
          this._prepareRequest()
          this._attachXHRListeners()
          return this._sendRequest()
        }
        _prepareRequest() {
          const t = new XMLHttpRequest()
          t.open('POST', this._apiAddress)
          t.setRequestHeader('Authorization', this._token.value)
          t.responseType = 'json'
          this.xhr = t
        }
        _attachXHRListeners() {
          const t = this
          const e = this.xhr
          e.addEventListener('error', n('Network Error'))
          e.addEventListener('abort', n('Abort'))
          if (e.upload) {
            e.upload.addEventListener('progress', (t) => {
              if (t.lengthComputable) {
                this.fire('progress', { total: t.total, uploaded: t.loaded })
              }
            })
          }
          e.addEventListener('load', () => {
            const t = e.status
            const n = e.response
            if (t < 200 || t > 299) {
              return this.fire('error', n.message || n.error)
            }
          })
          function n(e) {
            return () => t.fire('error', e)
          }
        }
        _sendRequest() {
          const t = new FormData()
          const e = this.xhr
          t.append('file', this.file)
          return new Promise((n, i) => {
            e.addEventListener('load', () => {
              const t = e.status
              const o = e.response
              if (t < 200 || t > 299) {
                if (o.message) {
                  return i(
                    new N('fileuploader-uploading-data-failed', this, {
                      message: o.message
                    })
                  )
                }
                return i(o.error)
              }
              return n(o)
            })
            e.addEventListener('error', () => i(new Error('Network Error')))
            e.addEventListener('abort', () => i(new Error('Abort')))
            e.send(t)
          })
        }
      }
      C(SD, $)
      function BD(t, e = 512) {
        try {
          const n = t.match(ID)[1]
          const i = atob(t.replace(ID, ''))
          const o = []
          for (let t = 0; t < i.length; t += e) {
            const n = i.slice(t, t + e)
            const r = new Array(n.length)
            for (let t = 0; t < n.length; t++) {
              r[t] = n.charCodeAt(t)
            }
            o.push(new Uint8Array(r))
          }
          return new Blob(o, { type: n })
        } catch (t) {
          throw new N('fileuploader-decoding-image-data-error', null)
        }
      }
      function ND(t) {
        if (typeof t !== 'string') {
          return false
        }
        const e = t.match(ID)
        return !!(e && e.length)
      }
      class PD {
        constructor(t, e) {
          if (!t) {
            throw new N('uploadgateway-missing-token', null)
          }
          if (!e) {
            throw new N('uploadgateway-missing-api-address', null)
          }
          this._token = t
          this._apiAddress = e
        }
        upload(t) {
          return new SD(t, this._token, this._apiAddress)
        }
      }
      class zD extends nu {
        static get pluginName() {
          return 'CloudServicesCore'
        }
        createToken(t, e) {
          return new MD(t, e)
        }
        createUploadGateway(t, e) {
          return new PD(t, e)
        }
      }
      class LD extends nu {
        static get pluginName() {
          return 'CloudServices'
        }
        static get requires() {
          return [zD]
        }
        init() {
          const t = this.context.config
          const e = t.get('cloudServices') || {}
          for (const t in e) {
            this[t] = e[t]
          }
          this._tokens = new Map()
          if (!this.tokenUrl) {
            this.token = null
            return
          }
          this.token = this.context.plugins
            .get('CloudServicesCore')
            .createToken(this.tokenUrl)
          this._tokens.set(this.tokenUrl, this.token)
          return this.token.init()
        }
        registerTokenUrl(t) {
          if (this._tokens.has(t)) {
            return Promise.resolve(this.getTokenFor(t))
          }
          const e = this.context.plugins.get('CloudServicesCore').createToken(t)
          this._tokens.set(t, e)
          return e.init()
        }
        getTokenFor(t) {
          const e = this._tokens.get(t)
          if (!e) {
            throw new N('cloudservices-token-not-registered', this)
          }
          return e
        }
        destroy() {
          super.destroy()
          for (const t of this._tokens.values()) {
            t.destroy()
          }
        }
      }
      class OD extends ig {
        constructor(t) {
          super(t)
          const e = this.document
          this.domEventType = [
            'paste',
            'copy',
            'cut',
            'drop',
            'dragover',
            'dragstart',
            'dragend',
            'dragenter',
            'dragleave'
          ]
          this.listenTo(e, 'paste', n('clipboardInput'), { priority: 'low' })
          this.listenTo(e, 'drop', n('clipboardInput'), { priority: 'low' })
          this.listenTo(e, 'dragover', n('dragging'), { priority: 'low' })
          function n(t) {
            return (n, i) => {
              i.preventDefault()
              const o = i.dropRange ? [i.dropRange] : null
              const r = new E(e, t)
              e.fire(r, {
                dataTransfer: i.dataTransfer,
                method: n.name,
                targetRanges: o,
                target: i.target
              })
              if (r.stop.called) {
                i.stopPropagation()
              }
            }
          }
        }
        onDomEvent(t) {
          const e = {
            dataTransfer: new Ip(
              'clipboardData' in t ? t.clipboardData : t.dataTransfer
            )
          }
          if (t.type == 'drop' || t.type == 'dragover') {
            e.dropRange = RD(this.view, t)
          }
          this.fire(t.type, t, e)
        }
      }
      function RD(t, e) {
        const n = e.target.ownerDocument
        const i = e.clientX
        const o = e.clientY
        let r
        if (n.caretRangeFromPoint && n.caretRangeFromPoint(i, o)) {
          r = n.caretRangeFromPoint(i, o)
        } else if (e.rangeParent) {
          r = n.createRange()
          r.setStart(e.rangeParent, e.rangeOffset)
          r.collapse(true)
        }
        if (r) {
          return t.domConverter.domRangeToView(r)
        }
        return null
      }
      function jD(t) {
        t = t
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/\r?\n\r?\n/g, '</p><p>')
          .replace(/\r?\n/g, '<br>')
          .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;')
          .replace(/^\s/, '&nbsp;')
          .replace(/\s$/, '&nbsp;')
          .replace(/\s\s/g, ' &nbsp;')
        if (t.includes('</p><p>') || t.includes('<br>')) {
          t = `<p>${t}</p>`
        }
        return t
      }
      function FD(t) {
        return t
          .replace(
            /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,
            (t, e) => {
              if (e.length == 1) {
                return ' '
              }
              return e
            }
          )
          .replace(/<!--[\s\S]*?-->/g, '')
      }
      const VD = ['figcaption', 'li']
      function HD(t) {
        let e = ''
        if (t.is('$text') || t.is('$textProxy')) {
          e = t.data
        } else if (t.is('element', 'img') && t.hasAttribute('alt')) {
          e = t.getAttribute('alt')
        } else if (t.is('element', 'br')) {
          e = '\n'
        } else {
          let n = null
          for (const i of t.getChildren()) {
            const t = HD(i)
            if (n && (n.is('containerElement') || i.is('containerElement'))) {
              if (VD.includes(n.name) || VD.includes(i.name)) {
                e += '\n'
              } else {
                e += '\n\n'
              }
            }
            e += t
            n = i
          }
        }
        return e
      }
      class UD extends Kd {
        static get pluginName() {
          return 'ClipboardPipeline'
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          e.addObserver(OD)
          this._setupPasteDrop()
          this._setupCopyCut()
        }
        _setupPasteDrop() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          const i = n.document
          this.listenTo(
            i,
            'clipboardInput',
            (e) => {
              if (t.isReadOnly) {
                e.stop()
              }
            },
            { priority: 'highest' }
          )
          this.listenTo(
            i,
            'clipboardInput',
            (t, e) => {
              const i = e.dataTransfer
              let o
              if (e.content) {
                o = e.content
              } else {
                let t = ''
                if (i.getData('text/html')) {
                  t = FD(i.getData('text/html'))
                } else if (i.getData('text/plain')) {
                  t = jD(i.getData('text/plain'))
                }
                o = this.editor.data.htmlProcessor.toView(t)
              }
              const r = new E(this, 'inputTransformation')
              this.fire(r, {
                content: o,
                dataTransfer: i,
                targetRanges: e.targetRanges,
                method: e.method
              })
              if (r.stop.called) {
                t.stop()
              }
              n.scrollToTheSelection()
            },
            { priority: 'low' }
          )
          this.listenTo(
            this,
            'inputTransformation',
            (t, n) => {
              if (n.content.isEmpty) {
                return
              }
              const i = this.editor.data
              const o = i.toModel(n.content, '$clipboardHolder')
              if (o.childCount == 0) {
                return
              }
              t.stop()
              e.change(() => {
                this.fire('contentInsertion', {
                  content: o,
                  method: n.method,
                  dataTransfer: n.dataTransfer,
                  targetRanges: n.targetRanges
                })
              })
            },
            { priority: 'low' }
          )
          this.listenTo(
            this,
            'contentInsertion',
            (t, n) => {
              n.resultRange = e.insertContent(n.content)
            },
            { priority: 'low' }
          )
        }
        _setupCopyCut() {
          const t = this.editor
          const e = t.model.document
          const n = t.editing.view
          const i = n.document
          const o = (n, o) => {
            const r = o.dataTransfer
            o.preventDefault()
            const s = t.data.toView(t.model.getSelectedContent(e.selection))
            i.fire('clipboardOutput', {
              dataTransfer: r,
              content: s,
              method: n.name
            })
          }
          this.listenTo(i, 'copy', o, { priority: 'low' })
          this.listenTo(
            i,
            'cut',
            (e, n) => {
              if (t.isReadOnly) {
                n.preventDefault()
              } else {
                o(e, n)
              }
            },
            { priority: 'low' }
          )
          this.listenTo(
            i,
            'clipboardOutput',
            (n, i) => {
              if (!i.content.isEmpty) {
                i.dataTransfer.setData(
                  'text/html',
                  this.editor.data.htmlProcessor.toData(i.content)
                )
                i.dataTransfer.setData('text/plain', HD(i.content))
              }
              if (i.method == 'cut') {
                t.model.deleteContent(e.selection)
              }
            },
            { priority: 'low' }
          )
        }
      }
      class WD extends $() {
        constructor() {
          super()
          this._stack = []
        }
        add(t, e) {
          const n = this._stack
          const i = n[0]
          this._insertDescriptor(t)
          const o = n[0]
          if (i !== o && !qD(i, o)) {
            this.fire('change:top', {
              oldDescriptor: i,
              newDescriptor: o,
              writer: e
            })
          }
        }
        remove(t, e) {
          const n = this._stack
          const i = n[0]
          this._removeDescriptor(t)
          const o = n[0]
          if (i !== o && !qD(i, o)) {
            this.fire('change:top', {
              oldDescriptor: i,
              newDescriptor: o,
              writer: e
            })
          }
        }
        _insertDescriptor(t) {
          const e = this._stack
          const n = e.findIndex((e) => e.id === t.id)
          if (qD(t, e[n])) {
            return
          }
          if (n > -1) {
            e.splice(n, 1)
          }
          let i = 0
          while (e[i] && $D(e[i], t)) {
            i++
          }
          e.splice(i, 0, t)
        }
        _removeDescriptor(t) {
          const e = this._stack
          const n = e.findIndex((e) => e.id === t)
          if (n > -1) {
            e.splice(n, 1)
          }
        }
      }
      function qD(t, e) {
        return (
          t && e && t.priority == e.priority && GD(t.classes) == GD(e.classes)
        )
      }
      function $D(t, e) {
        if (t.priority > e.priority) {
          return true
        } else if (t.priority < e.priority) {
          return false
        }
        return GD(t.classes) > GD(e.classes)
      }
      function GD(t) {
        return Array.isArray(t) ? t.sort().join(',') : t
      }
      const YD =
        '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>'
      const KD = 'ck-widget'
      const QD = 'ck-widget_selected'
      function ZD(t) {
        if (!t.is('element')) {
          return false
        }
        return !!t.getCustomProperty('widget')
      }
      function JD(t, e, n = {}) {
        if (!t.is('containerElement')) {
          throw new N('widget-to-widget-wrong-element-type', null, {
            element: t
          })
        }
        e.setAttribute('contenteditable', 'false', t)
        e.addClass(KD, t)
        e.setCustomProperty('widget', true, t)
        t.getFillerOffset = aT
        e.setCustomProperty('widgetLabel', [], t)
        if (n.label) {
          nT(t, n.label)
        }
        if (n.hasSelectionHandle) {
          cT(t, e)
        }
        eT(t, e)
        return t
      }
      function XD(t, e, n) {
        if (e.classes) {
          n.addClass(Zc(e.classes), t)
        }
        if (e.attributes) {
          for (const i in e.attributes) {
            n.setAttribute(i, e.attributes[i], t)
          }
        }
      }
      function tT(t, e, n) {
        if (e.classes) {
          n.removeClass(Zc(e.classes), t)
        }
        if (e.attributes) {
          for (const i in e.attributes) {
            n.removeAttribute(i, t)
          }
        }
      }
      function eT(t, e, n = XD, i = tT) {
        const o = new WD()
        o.on('change:top', (e, o) => {
          if (o.oldDescriptor) {
            i(t, o.oldDescriptor, o.writer)
          }
          if (o.newDescriptor) {
            n(t, o.newDescriptor, o.writer)
          }
        })
        const r = (t, e, n) => o.add(e, n)
        const s = (t, e, n) => o.remove(e, n)
        e.setCustomProperty('addHighlight', r, t)
        e.setCustomProperty('removeHighlight', s, t)
      }
      function nT(t, e) {
        const n = t.getCustomProperty('widgetLabel')
        n.push(e)
      }
      function iT(t) {
        const e = t.getCustomProperty('widgetLabel')
        return e.reduce((t, e) => {
          if (typeof e === 'function') {
            return t ? t + '. ' + e() : e()
          } else {
            return t ? t + '. ' + e : e
          }
        }, '')
      }
      function oT(t, e, n = {}) {
        e.addClass(['ck-editor__editable', 'ck-editor__nested-editable'], t)
        e.setAttribute('role', 'textbox', t)
        if (n.label) {
          e.setAttribute('aria-label', n.label, t)
        }
        e.setAttribute('contenteditable', t.isReadOnly ? 'false' : 'true', t)
        t.on('change:isReadOnly', (n, i, o) => {
          e.setAttribute('contenteditable', o ? 'false' : 'true', t)
        })
        t.on('change:isFocused', (n, i, o) => {
          if (o) {
            e.addClass('ck-editor__nested-editable_focused', t)
          } else {
            e.removeClass('ck-editor__nested-editable_focused', t)
          }
        })
        eT(t, e)
        return t
      }
      function rT(t, e) {
        const n = t.getSelectedElement()
        if (n) {
          const i = mT(t)
          if (i) {
            return e.createRange(e.createPositionAt(n, i))
          }
        }
        return J_(t, e)
      }
      function sT(t, e) {
        return (n, i) => {
          const { mapper: o, viewPosition: r } = i
          const s = o.findMappedViewAncestor(r)
          if (!e(s)) {
            return
          }
          const a = o.toModelElement(s)
          i.modelPosition = t.createPositionAt(
            a,
            r.isAtStart ? 'before' : 'after'
          )
        }
      }
      function aT() {
        return null
      }
      function cT(t, e) {
        const n = e.createUIElement(
          'div',
          { class: 'ck ck-widget__selection-handle' },
          function (t) {
            const e = this.toDomElement(t)
            const n = new ud()
            n.set('content', YD)
            n.render()
            e.appendChild(n.element)
            return e
          }
        )
        e.insert(e.createPositionAt(t, 0), n)
        e.addClass(['ck-widget_with-selection-handle'], t)
      }
      const lT = 'widget-type-around'
      function dT(t, e, n) {
        return !!t && ZD(t) && !n.isInline(e)
      }
      function uT(t) {
        return t.closest('.ck-widget__type-around__button')
      }
      function hT(t) {
        return t.classList.contains('ck-widget__type-around__button_before')
          ? 'before'
          : 'after'
      }
      function fT(t, e) {
        const n = t.closest('.ck-widget')
        return e.mapDomToView(n)
      }
      function mT(t) {
        return t.getAttribute(lT)
      }
      const gT =
        '<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>'
      var pT = __webpack_require__(5137)
      var bT = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      bT.insert = 'head'
      bT.singleton = true
      var kT = El()(pT.Z, bT)
      const wT = pT.Z.locals || {}
      const _T = ['before', 'after']
      const AT = new DOMParser().parseFromString(gT, 'image/svg+xml').firstChild
      const vT = 'ck-widget__type-around_disabled'
      class CT extends Kd {
        static get pluginName() {
          return 'WidgetTypeAround'
        }
        static get requires() {
          return [_E, Lx]
        }
        constructor(t) {
          super(t)
          this._currentFakeCaretModelElement = null
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          this.on('change:isEnabled', (n, i, o) => {
            e.change((t) => {
              for (const n of e.document.roots) {
                if (o) {
                  t.removeClass(vT, n)
                } else {
                  t.addClass(vT, n)
                }
              }
            })
            if (!o) {
              t.model.change((t) => {
                t.removeSelectionAttribute(lT)
              })
            }
          })
          this._enableTypeAroundUIInjection()
          this._enableInsertingParagraphsOnButtonClick()
          this._enableInsertingParagraphsOnEnterKeypress()
          this._enableInsertingParagraphsOnTypingKeystroke()
          this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows()
          this._enableDeleteIntegration()
          this._enableInsertContentIntegration()
          this._enableInsertObjectIntegration()
          this._enableDeleteContentIntegration()
        }
        destroy() {
          super.destroy()
          this._currentFakeCaretModelElement = null
        }
        _insertParagraph(t, e) {
          const n = this.editor
          const i = n.editing.view
          const o = n.model.schema.getAttributesWithProperty(
            t,
            'copyOnReplace',
            true
          )
          n.execute('insertParagraph', {
            position: n.model.createPositionAt(t, e),
            attributes: o
          })
          i.focus()
          i.scrollToTheSelection()
        }
        _listenToIfEnabled(t, e, n, i) {
          this.listenTo(
            t,
            e,
            (...t) => {
              if (this.isEnabled) {
                n(...t)
              }
            },
            i
          )
        }
        _insertParagraphAccordingToFakeCaretPosition() {
          const t = this.editor
          const e = t.model
          const n = e.document.selection
          const i = mT(n)
          if (!i) {
            return false
          }
          const o = n.getSelectedElement()
          this._insertParagraph(o, i)
          return true
        }
        _enableTypeAroundUIInjection() {
          const t = this.editor
          const e = t.model.schema
          const n = t.locale.t
          const i = {
            before: n('Insert paragraph before block'),
            after: n('Insert paragraph after block')
          }
          t.editing.downcastDispatcher.on(
            'insert',
            (t, o, r) => {
              const s = r.mapper.toViewElement(o.item)
              if (!s) {
                return
              }
              if (dT(s, o.item, e)) {
                yT(r.writer, i, s)
                const t = s.getCustomProperty('widgetLabel')
                t.push(() =>
                  this.isEnabled
                    ? n(
                        'Press Enter to type after or press Shift + Enter to type before the widget'
                      )
                    : ''
                )
              }
            },
            { priority: 'low' }
          )
        }
        _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
          const t = this.editor
          const e = t.model
          const n = e.document.selection
          const i = e.schema
          const o = t.editing.view
          this._listenToIfEnabled(
            o.document,
            'arrowKey',
            (t, e) => {
              this._handleArrowKeyPress(t, e)
            },
            { context: [ZD, '$text'], priority: 'high' }
          )
          this._listenToIfEnabled(n, 'change:range', (e, n) => {
            if (!n.directChange) {
              return
            }
            t.model.change((t) => {
              t.removeSelectionAttribute(lT)
            })
          })
          this._listenToIfEnabled(e.document, 'change:data', () => {
            const e = n.getSelectedElement()
            if (e) {
              const n = t.editing.mapper.toViewElement(e)
              if (dT(n, e, i)) {
                return
              }
            }
            t.model.change((t) => {
              t.removeSelectionAttribute(lT)
            })
          })
          this._listenToIfEnabled(
            t.editing.downcastDispatcher,
            'selection',
            (t, e, n) => {
              const o = n.writer
              if (this._currentFakeCaretModelElement) {
                const t = n.mapper.toViewElement(
                  this._currentFakeCaretModelElement
                )
                if (t) {
                  o.removeClass(_T.map(r), t)
                  this._currentFakeCaretModelElement = null
                }
              }
              const s = e.selection.getSelectedElement()
              if (!s) {
                return
              }
              const a = n.mapper.toViewElement(s)
              if (!dT(a, s, i)) {
                return
              }
              const c = mT(e.selection)
              if (!c) {
                return
              }
              o.addClass(r(c), a)
              this._currentFakeCaretModelElement = s
            }
          )
          this._listenToIfEnabled(
            t.ui.focusTracker,
            'change:isFocused',
            (e, n, i) => {
              if (!i) {
                t.model.change((t) => {
                  t.removeSelectionAttribute(lT)
                })
              }
            }
          )
          function r(t) {
            return `ck-widget_type-around_show-fake-caret_${t}`
          }
        }
        _handleArrowKeyPress(t, e) {
          const n = this.editor
          const i = n.model
          const o = i.document.selection
          const r = i.schema
          const s = n.editing.view
          const a = e.keyCode
          const c = Yc(a, n.locale.contentLanguageDirection)
          const l = s.document.selection.getSelectedElement()
          const d = n.editing.mapper.toModelElement(l)
          let u
          if (dT(l, d, r)) {
            u = this._handleArrowKeyPressOnSelectedWidget(c)
          } else if (o.isCollapsed) {
            u = this._handleArrowKeyPressWhenSelectionNextToAWidget(c)
          } else if (!e.shiftKey) {
            u = this._handleArrowKeyPressWhenNonCollapsedSelection(c)
          }
          if (u) {
            e.preventDefault()
            t.stop()
          }
        }
        _handleArrowKeyPressOnSelectedWidget(t) {
          const e = this.editor
          const n = e.model
          const i = n.document.selection
          const o = mT(i)
          return n.change((e) => {
            if (o) {
              const n = o === (t ? 'after' : 'before')
              if (!n) {
                e.removeSelectionAttribute(lT)
                return true
              }
            } else {
              e.setSelectionAttribute(lT, t ? 'after' : 'before')
              return true
            }
            return false
          })
        }
        _handleArrowKeyPressWhenSelectionNextToAWidget(t) {
          const e = this.editor
          const n = e.model
          const i = n.schema
          const o = e.plugins.get('Widget')
          const r = o._getObjectElementNextToSelection(t)
          const s = e.editing.mapper.toViewElement(r)
          if (dT(s, r, i)) {
            n.change((e) => {
              o._setSelectionOverElement(r)
              e.setSelectionAttribute(lT, t ? 'before' : 'after')
            })
            return true
          }
          return false
        }
        _handleArrowKeyPressWhenNonCollapsedSelection(t) {
          const e = this.editor
          const n = e.model
          const i = n.schema
          const o = e.editing.mapper
          const r = n.document.selection
          const s = t
            ? r.getLastPosition().nodeBefore
            : r.getFirstPosition().nodeAfter
          const a = o.toViewElement(s)
          if (dT(a, s, i)) {
            n.change((e) => {
              e.setSelection(s, 'on')
              e.setSelectionAttribute(lT, t ? 'after' : 'before')
            })
            return true
          }
          return false
        }
        _enableInsertingParagraphsOnButtonClick() {
          const t = this.editor
          const e = t.editing.view
          this._listenToIfEnabled(e.document, 'mousedown', (n, i) => {
            const o = uT(i.domTarget)
            if (!o) {
              return
            }
            const r = hT(o)
            const s = fT(o, e.domConverter)
            const a = t.editing.mapper.toModelElement(s)
            this._insertParagraph(a, r)
            i.preventDefault()
            n.stop()
          })
        }
        _enableInsertingParagraphsOnEnterKeypress() {
          const t = this.editor
          const e = t.model.document.selection
          const n = t.editing.view
          this._listenToIfEnabled(
            n.document,
            'enter',
            (n, i) => {
              if (n.eventPhase != 'atTarget') {
                return
              }
              const o = e.getSelectedElement()
              const r = t.editing.mapper.toViewElement(o)
              const s = t.model.schema
              let a
              if (this._insertParagraphAccordingToFakeCaretPosition()) {
                a = true
              } else if (dT(r, o, s)) {
                this._insertParagraph(o, i.isSoft ? 'before' : 'after')
                a = true
              }
              if (a) {
                i.preventDefault()
                n.stop()
              }
            },
            { context: ZD }
          )
        }
        _enableInsertingParagraphsOnTypingKeystroke() {
          const t = this.editor
          const e = t.editing.view.document
          this._listenToIfEnabled(
            e,
            'insertText',
            (t, n) => {
              if (this._insertParagraphAccordingToFakeCaretPosition()) {
                n.selection = e.selection
              }
            },
            { priority: 'high' }
          )
          if (a.isAndroid) {
            this._listenToIfEnabled(e, 'keydown', (t, e) => {
              if (e.keyCode == 229) {
                this._insertParagraphAccordingToFakeCaretPosition()
              }
            })
          } else {
            this._listenToIfEnabled(
              e,
              'compositionstart',
              () => {
                this._insertParagraphAccordingToFakeCaretPosition()
              },
              { priority: 'high' }
            )
          }
        }
        _enableDeleteIntegration() {
          const t = this.editor
          const e = t.editing.view
          const n = t.model
          const i = n.schema
          this._listenToIfEnabled(
            e.document,
            'delete',
            (e, o) => {
              if (e.eventPhase != 'atTarget') {
                return
              }
              const r = mT(n.document.selection)
              if (!r) {
                return
              }
              const s = o.direction
              const a = n.document.selection.getSelectedElement()
              const c = r === 'before'
              const l = s == 'forward'
              const d = c === l
              if (d) {
                t.execute('delete', { selection: n.createSelection(a, 'on') })
              } else {
                const e = i.getNearestSelectionRange(
                  n.createPositionAt(a, r),
                  s
                )
                if (e) {
                  if (!e.isCollapsed) {
                    n.change((n) => {
                      n.setSelection(e)
                      t.execute(l ? 'deleteForward' : 'delete')
                    })
                  } else {
                    const o = n.createSelection(e.start)
                    n.modifySelection(o, { direction: s })
                    if (!o.focus.isEqual(e.start)) {
                      n.change((n) => {
                        n.setSelection(e)
                        t.execute(l ? 'deleteForward' : 'delete')
                      })
                    } else {
                      const t = DT(i, e.start.parent)
                      n.deleteContent(n.createSelection(t, 'on'), {
                        doNotAutoparagraph: true
                      })
                    }
                  }
                }
              }
              o.preventDefault()
              e.stop()
            },
            { context: ZD }
          )
        }
        _enableInsertContentIntegration() {
          const t = this.editor
          const e = this.editor.model
          const n = e.document.selection
          this._listenToIfEnabled(
            t.model,
            'insertContent',
            (t, [i, o]) => {
              if (o && !o.is('documentSelection')) {
                return
              }
              const r = mT(n)
              if (!r) {
                return
              }
              t.stop()
              return e.change((t) => {
                const o = n.getSelectedElement()
                const s = e.createPositionAt(o, r)
                const a = t.createSelection(s)
                const c = e.insertContent(i, a)
                t.setSelection(a)
                return c
              })
            },
            { priority: 'high' }
          )
        }
        _enableInsertObjectIntegration() {
          const t = this.editor
          const e = this.editor.model
          const n = e.document.selection
          this._listenToIfEnabled(
            t.model,
            'insertObject',
            (t, e) => {
              const [, i, , o = {}] = e
              if (i && !i.is('documentSelection')) {
                return
              }
              const r = mT(n)
              if (!r) {
                return
              }
              o.findOptimalPosition = r
              e[3] = o
            },
            { priority: 'high' }
          )
        }
        _enableDeleteContentIntegration() {
          const t = this.editor
          const e = this.editor.model
          const n = e.document.selection
          this._listenToIfEnabled(
            t.model,
            'deleteContent',
            (t, [e]) => {
              if (e && !e.is('documentSelection')) {
                return
              }
              const i = mT(n)
              if (i) {
                t.stop()
              }
            },
            { priority: 'high' }
          )
        }
      }
      function yT(t, e, n) {
        const i = t.createUIElement(
          'div',
          { class: 'ck ck-reset_all ck-widget__type-around' },
          function (t) {
            const n = this.toDomElement(t)
            xT(n, e)
            ET(n)
            return n
          }
        )
        t.insert(t.createPositionAt(n, 'end'), i)
      }
      function xT(t, e) {
        for (const n of _T) {
          const i = new Nl({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-widget__type-around__button',
                `ck-widget__type-around__button_${n}`
              ],
              title: e[n],
              'aria-hidden': 'true'
            },
            children: [t.ownerDocument.importNode(AT, true)]
          })
          t.appendChild(i.render())
        }
      }
      function ET(t) {
        const e = new Nl({
          tag: 'div',
          attributes: { class: ['ck', 'ck-widget__type-around__fake-caret'] }
        })
        t.appendChild(e.render())
      }
      function DT(t, e) {
        let n = e
        for (const i of e.getAncestors({ parentFirst: true })) {
          if (i.childCount > 1 || t.isLimit(i)) {
            break
          }
          n = i
        }
        return n
      }
      function TT(t) {
        const e = t.model
        return (n, i) => {
          const o = i.keyCode == Fc.arrowup
          const r = i.keyCode == Fc.arrowdown
          const s = i.shiftKey
          const a = e.document.selection
          if (!o && !r) {
            return
          }
          const c = r
          if (s && NT(a, c)) {
            return
          }
          const l = MT(t, a, c)
          if (!l) {
            return
          }
          if (l.isCollapsed) {
            if (a.isCollapsed) {
              return
            } else if (s) {
              return
            }
          }
          if (l.isCollapsed || BT(t, l, c)) {
            e.change((t) => {
              const n = c ? l.end : l.start
              if (s) {
                const i = e.createSelection(a.anchor)
                i.setFocus(n)
                t.setSelection(i)
              } else {
                t.setSelection(n)
              }
            })
            n.stop()
            i.preventDefault()
            i.stopPropagation()
          }
        }
      }
      function MT(t, e, n) {
        const i = t.model
        if (n) {
          const t = e.isCollapsed ? e.focus : e.getLastPosition()
          const n = IT(i, t, 'forward')
          if (!n) {
            return null
          }
          const o = i.createRange(t, n)
          const r = ST(i.schema, o, 'backward')
          if (r) {
            return i.createRange(t, r)
          }
          return null
        } else {
          const t = e.isCollapsed ? e.focus : e.getFirstPosition()
          const n = IT(i, t, 'backward')
          if (!n) {
            return null
          }
          const o = i.createRange(n, t)
          const r = ST(i.schema, o, 'forward')
          if (r) {
            return i.createRange(r, t)
          }
          return null
        }
      }
      function IT(t, e, n) {
        const i = t.schema
        const o = t.createRangeIn(e.root)
        const r = n == 'forward' ? 'elementStart' : 'elementEnd'
        for (const { previousPosition: t, item: s, type: a } of o.getWalker({
          startPosition: e,
          direction: n
        })) {
          if (i.isLimit(s) && !i.isInline(s)) {
            return t
          }
          if (a == r && i.isBlock(s)) {
            return null
          }
        }
        return null
      }
      function ST(t, e, n) {
        const i = n == 'backward' ? e.end : e.start
        if (t.checkChild(i, '$text')) {
          return i
        }
        for (const { nextPosition: i } of e.getWalker({ direction: n })) {
          if (t.checkChild(i, '$text')) {
            return i
          }
        }
        return null
      }
      function BT(t, e, n) {
        const i = t.model
        const o = t.view.domConverter
        if (n) {
          const t = i.createSelection(e.start)
          i.modifySelection(t)
          if (!t.focus.isAtEnd && !e.start.isEqual(t.focus)) {
            e = i.createRange(t.focus, e.end)
          }
        }
        const r = t.mapper.toViewRange(e)
        const s = o.viewRangeToDom(r)
        const a = cc.getDomRangeRects(s)
        let c
        for (const t of a) {
          if (c === undefined) {
            c = Math.round(t.bottom)
            continue
          }
          if (Math.round(t.top) >= c) {
            return false
          }
          c = Math.max(c, Math.round(t.bottom))
        }
        return true
      }
      function NT(t, e) {
        return !t.isCollapsed && t.isBackward == e
      }
      var PT = __webpack_require__(6507)
      var zT = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      zT.insert = 'head'
      zT.singleton = true
      var LT = El()(PT.Z, zT)
      const OT = PT.Z.locals || {}
      class RT extends Kd {
        static get pluginName() {
          return 'Widget'
        }
        static get requires() {
          return [CT, Lx]
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          this._previouslySelected = new Set()
          this.editor.editing.downcastDispatcher.on('selection', (e, n, i) => {
            const o = i.writer
            const r = n.selection
            if (r.isCollapsed) {
              return
            }
            const s = r.getSelectedElement()
            if (!s) {
              return
            }
            const a = t.editing.mapper.toViewElement(s)
            if (!ZD(a)) {
              return
            }
            if (!i.consumable.consume(r, 'selection')) {
              return
            }
            o.setSelection(o.createRangeOn(a), { fake: true, label: iT(a) })
          })
          this.editor.editing.downcastDispatcher.on(
            'selection',
            (t, e, n) => {
              this._clearPreviouslySelectedWidgets(n.writer)
              const i = n.writer
              const o = i.document.selection
              let r = null
              for (const t of o.getRanges()) {
                for (const e of t) {
                  const t = e.item
                  if (ZD(t) && !FT(t, r)) {
                    i.addClass(QD, t)
                    this._previouslySelected.add(t)
                    r = t
                  }
                }
              }
            },
            { priority: 'low' }
          )
          e.addObserver(uA)
          this.listenTo(n, 'mousedown', (...t) => this._onMousedown(...t))
          this.listenTo(
            n,
            'arrowKey',
            (...t) => {
              this._handleSelectionChangeOnArrowKeyPress(...t)
            },
            { context: [ZD, '$text'] }
          )
          this.listenTo(
            n,
            'arrowKey',
            (...t) => {
              this._preventDefaultOnArrowKeyPress(...t)
            },
            { context: '$root' }
          )
          this.listenTo(n, 'arrowKey', TT(this.editor.editing), {
            context: '$text'
          })
          this.listenTo(
            n,
            'delete',
            (t, e) => {
              if (this._handleDelete(e.direction == 'forward')) {
                e.preventDefault()
                t.stop()
              }
            },
            { context: '$root' }
          )
        }
        _onMousedown(t, e) {
          const n = this.editor
          const i = n.editing.view
          const o = i.document
          let r = e.target
          if (jT(r)) {
            if ((a.isSafari || a.isGecko) && e.domEvent.detail >= 3) {
              const t = n.editing.mapper
              const i = r.is('attributeElement')
                ? r.findAncestor((t) => !t.is('attributeElement'))
                : r
              const o = t.toModelElement(i)
              e.preventDefault()
              this.editor.model.change((t) => {
                t.setSelection(o, 'in')
              })
            }
            return
          }
          if (!ZD(r)) {
            r = r.findAncestor(ZD)
            if (!r) {
              return
            }
          }
          if (a.isAndroid) {
            e.preventDefault()
          }
          if (!o.isFocused) {
            i.focus()
          }
          const s = n.editing.mapper.toModelElement(r)
          this._setSelectionOverElement(s)
        }
        _handleSelectionChangeOnArrowKeyPress(t, e) {
          const n = e.keyCode
          const i = this.editor.model
          const o = i.schema
          const r = i.document.selection
          const s = r.getSelectedElement()
          const a = $c(n, this.editor.locale.contentLanguageDirection)
          const c = a == 'down' || a == 'right'
          const l = a == 'up' || a == 'down'
          if (s && o.isObject(s)) {
            const n = c ? r.getLastPosition() : r.getFirstPosition()
            const s = o.getNearestSelectionRange(n, c ? 'forward' : 'backward')
            if (s) {
              i.change((t) => {
                t.setSelection(s)
              })
              e.preventDefault()
              t.stop()
            }
            return
          }
          if (!r.isCollapsed && !e.shiftKey) {
            const n = r.getFirstPosition()
            const s = r.getLastPosition()
            const a = n.nodeAfter
            const l = s.nodeBefore
            if ((a && o.isObject(a)) || (l && o.isObject(l))) {
              i.change((t) => {
                t.setSelection(c ? s : n)
              })
              e.preventDefault()
              t.stop()
            }
            return
          }
          if (!r.isCollapsed) {
            return
          }
          const d = this._getObjectElementNextToSelection(c)
          if (d && o.isObject(d)) {
            if (o.isInline(d) && l) {
              return
            }
            this._setSelectionOverElement(d)
            e.preventDefault()
            t.stop()
          }
        }
        _preventDefaultOnArrowKeyPress(t, e) {
          const n = this.editor.model
          const i = n.schema
          const o = n.document.selection.getSelectedElement()
          if (o && i.isObject(o)) {
            e.preventDefault()
            t.stop()
          }
        }
        _handleDelete(t) {
          if (this.editor.isReadOnly) {
            return
          }
          const e = this.editor.model.document
          const n = e.selection
          if (!n.isCollapsed) {
            return
          }
          const i = this._getObjectElementNextToSelection(t)
          if (i) {
            this.editor.model.change((t) => {
              let e = n.anchor.parent
              while (e.isEmpty) {
                const n = e
                e = n.parent
                t.remove(n)
              }
              this._setSelectionOverElement(i)
            })
            return true
          }
        }
        _setSelectionOverElement(t) {
          this.editor.model.change((e) => {
            e.setSelection(e.createRangeOn(t))
          })
        }
        _getObjectElementNextToSelection(t) {
          const e = this.editor.model
          const n = e.schema
          const i = e.document.selection
          const o = e.createSelection(i)
          e.modifySelection(o, { direction: t ? 'forward' : 'backward' })
          if (o.isEqual(i)) {
            return null
          }
          const r = t ? o.focus.nodeBefore : o.focus.nodeAfter
          if (!!r && n.isObject(r)) {
            return r
          }
          return null
        }
        _clearPreviouslySelectedWidgets(t) {
          for (const e of this._previouslySelected) {
            t.removeClass(QD, e)
          }
          this._previouslySelected.clear()
        }
      }
      function jT(t) {
        let e = t
        while (e) {
          if (e.is('editableElement') && !e.is('rootElement')) {
            return true
          }
          if (ZD(e)) {
            return false
          }
          e = e.parent
        }
        return false
      }
      function FT(t, e) {
        if (!e) {
          return false
        }
        return Array.from(t.getAncestors()).includes(e)
      }
      class VT extends Kd {
        static get requires() {
          return [Wy]
        }
        static get pluginName() {
          return 'WidgetToolbarRepository'
        }
        init() {
          const t = this.editor
          if (t.plugins.has('BalloonToolbar')) {
            const e = t.plugins.get('BalloonToolbar')
            this.listenTo(
              e,
              'show',
              (e) => {
                if (WT(t.editing.view.document.selection)) {
                  e.stop()
                }
              },
              { priority: 'high' }
            )
          }
          this._toolbarDefinitions = new Map()
          this._balloon = this.editor.plugins.get('ContextualBalloon')
          this.on('change:isEnabled', () => {
            this._updateToolbarsVisibility()
          })
          this.listenTo(t.ui, 'update', () => {
            this._updateToolbarsVisibility()
          })
          this.listenTo(
            t.ui.focusTracker,
            'change:isFocused',
            () => {
              this._updateToolbarsVisibility()
            },
            { priority: 'low' }
          )
        }
        destroy() {
          super.destroy()
          for (const t of this._toolbarDefinitions.values()) {
            t.view.destroy()
          }
        }
        register(
          t,
          {
            ariaLabel: e,
            items: n,
            getRelatedElement: i,
            balloonClassName: o = 'ck-toolbar-container'
          }
        ) {
          if (!n.length) {
            P('widget-toolbar-no-items', { toolbarId: t })
            return
          }
          const r = this.editor
          const s = r.t
          const a = new Xv(r.locale)
          a.ariaLabel = e || s('Widget toolbar')
          if (this._toolbarDefinitions.has(t)) {
            throw new N('widget-toolbar-duplicated', this, { toolbarId: t })
          }
          const c = {
            view: a,
            getRelatedElement: i,
            balloonClassName: o,
            itemsConfig: n,
            initialized: false
          }
          r.ui.addToolbar(a, {
            isContextual: true,
            beforeFocus: () => {
              const t = i(r.editing.view.document.selection)
              if (t) {
                this._showToolbar(c, t)
              }
            },
            afterBlur: () => {
              this._hideToolbar(c)
            }
          })
          this._toolbarDefinitions.set(t, c)
        }
        _updateToolbarsVisibility() {
          let t = 0
          let e = null
          let n = null
          for (const i of this._toolbarDefinitions.values()) {
            const o = i.getRelatedElement(
              this.editor.editing.view.document.selection
            )
            if (!this.isEnabled || !o) {
              if (this._isToolbarInBalloon(i)) {
                this._hideToolbar(i)
              }
            } else if (!this.editor.ui.focusTracker.isFocused) {
              if (this._isToolbarVisible(i)) {
                this._hideToolbar(i)
              }
            } else {
              const r = o.getAncestors().length
              if (r > t) {
                t = r
                e = o
                n = i
              }
            }
          }
          if (n) {
            this._showToolbar(n, e)
          }
        }
        _hideToolbar(t) {
          this._balloon.remove(t.view)
          this.stopListening(this._balloon, 'change:visibleView')
        }
        _showToolbar(t, e) {
          if (this._isToolbarVisible(t)) {
            HT(this.editor, e)
          } else if (!this._isToolbarInBalloon(t)) {
            if (!t.initialized) {
              t.initialized = true
              t.view.fillFromConfig(
                t.itemsConfig,
                this.editor.ui.componentFactory
              )
            }
            this._balloon.add({
              view: t.view,
              position: UT(this.editor, e),
              balloonClassName: t.balloonClassName
            })
            this.listenTo(this._balloon, 'change:visibleView', () => {
              for (const t of this._toolbarDefinitions.values()) {
                if (this._isToolbarVisible(t)) {
                  const e = t.getRelatedElement(
                    this.editor.editing.view.document.selection
                  )
                  HT(this.editor, e)
                }
              }
            })
          }
        }
        _isToolbarVisible(t) {
          return this._balloon.visibleView === t.view
        }
        _isToolbarInBalloon(t) {
          return this._balloon.hasView(t.view)
        }
      }
      function HT(t, e) {
        const n = t.plugins.get('ContextualBalloon')
        const i = UT(t, e)
        n.updatePosition(i)
      }
      function UT(t, e) {
        const n = t.editing.view
        const i = OC.defaultPositions
        return {
          target: n.domConverter.mapViewToDom(e),
          positions: [
            i.northArrowSouth,
            i.northArrowSouthWest,
            i.northArrowSouthEast,
            i.southArrowNorth,
            i.southArrowNorthWest,
            i.southArrowNorthEast,
            i.viewportStickyNorth
          ]
        }
      }
      function WT(t) {
        const e = t.getSelectedElement()
        return !!(e && ZD(e))
      }
      class qT extends ht() {
        constructor(t) {
          super()
          this.set('activeHandlePosition', null)
          this.set('proposedWidthPercents', null)
          this.set('proposedWidth', null)
          this.set('proposedHeight', null)
          this.set('proposedHandleHostWidth', null)
          this.set('proposedHandleHostHeight', null)
          this._options = t
          this._referenceCoordinates = null
        }
        get originalWidth() {
          return this._originalWidth
        }
        get originalHeight() {
          return this._originalHeight
        }
        get originalWidthPercents() {
          return this._originalWidthPercents
        }
        get aspectRatio() {
          return this._aspectRatio
        }
        begin(t, e, n) {
          const i = new Rect(e)
          this.activeHandlePosition = KT(t)
          this._referenceCoordinates = GT(e, QT(this.activeHandlePosition))
          this._originalWidth = i.width
          this._originalHeight = i.height
          this._aspectRatio = i.width / i.height
          const o = n.style.width
          if (o && o.match(/^\d+(\.\d*)?%$/)) {
            this._originalWidthPercents = parseFloat(o)
          } else {
            this._originalWidthPercents = $T(n, i)
          }
        }
        update(t) {
          this.proposedWidth = t.width
          this.proposedHeight = t.height
          this.proposedWidthPercents = t.widthPercents
          this.proposedHandleHostWidth = t.handleHostWidth
          this.proposedHandleHostHeight = t.handleHostHeight
        }
      }
      function $T(t, e) {
        const n = t.parentElement
        const i = parseFloat(
          n.ownerDocument.defaultView.getComputedStyle(n).width
        )
        return (e.width / i) * 100
      }
      function GT(t, e) {
        const n = new Rect(t)
        const i = e.split('-')
        const o = {
          x: i[1] == 'right' ? n.right : n.left,
          y: i[0] == 'bottom' ? n.bottom : n.top
        }
        o.x += t.ownerDocument.defaultView.scrollX
        o.y += t.ownerDocument.defaultView.scrollY
        return o
      }
      function YT(t) {
        return `ck-widget__resizer__handle-${t}`
      }
      function KT(t) {
        const e = ['top-left', 'top-right', 'bottom-right', 'bottom-left']
        for (const n of e) {
          if (t.classList.contains(YT(n))) {
            return n
          }
        }
      }
      function QT(t) {
        const e = t.split('-')
        const n = { top: 'bottom', bottom: 'top', left: 'right', right: 'left' }
        return `${n[e[0]]}-${n[e[1]]}`
      }
      class ZT extends (null && View) {
        constructor() {
          super()
          const t = this.bindTemplate
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: [
                'ck',
                'ck-size-view',
                t.to('_viewPosition', (t) => (t ? `ck-orientation-${t}` : ''))
              ],
              style: { display: t.if('_isVisible', 'none', (t) => !t) }
            },
            children: [{ text: t.to('_label') }]
          })
        }
        _bindToState(t, e) {
          this.bind('_isVisible').to(
            e,
            'proposedWidth',
            e,
            'proposedHeight',
            (t, e) => t !== null && e !== null
          )
          this.bind('_label').to(
            e,
            'proposedHandleHostWidth',
            e,
            'proposedHandleHostHeight',
            e,
            'proposedWidthPercents',
            (e, n, i) => {
              if (t.unit === 'px') {
                return `${e}×${n}`
              } else {
                return `${i}%`
              }
            }
          )
          this.bind('_viewPosition').to(
            e,
            'activeHandlePosition',
            e,
            'proposedHandleHostWidth',
            e,
            'proposedHandleHostHeight',
            (t, e, n) => (e < 50 || n < 50 ? 'above-center' : t)
          )
        }
        _dismiss() {
          this.unbind()
          this._isVisible = false
        }
      }
      class JT extends ht() {
        constructor(t) {
          super()
          this._options = t
          this._viewResizerWrapper = null
          this.set('isEnabled', true)
          this.set('isSelected', false)
          this.bind('isVisible').to(
            this,
            'isEnabled',
            this,
            'isSelected',
            (t, e) => t && e
          )
          this.decorate('begin')
          this.decorate('cancel')
          this.decorate('commit')
          this.decorate('updateSize')
          this.on(
            'commit',
            (t) => {
              if (
                !this.state.proposedWidth &&
                !this.state.proposedWidthPercents
              ) {
                this._cleanup()
                t.stop()
              }
            },
            { priority: 'high' }
          )
        }
        get state() {
          return this._state
        }
        show() {
          const t = this._options.editor.editing.view
          t.change((t) => {
            t.removeClass('ck-hidden', this._viewResizerWrapper)
          })
        }
        hide() {
          const t = this._options.editor.editing.view
          t.change((t) => {
            t.addClass('ck-hidden', this._viewResizerWrapper)
          })
        }
        attach() {
          const t = this
          const e = this._options.viewElement
          const n = this._options.editor.editing.view
          n.change((n) => {
            const i = n.createUIElement(
              'div',
              { class: 'ck ck-reset_all ck-widget__resizer' },
              function (e) {
                const n = this.toDomElement(e)
                t._appendHandles(n)
                t._appendSizeUI(n)
                return n
              }
            )
            n.insert(n.createPositionAt(e, 'end'), i)
            n.addClass('ck-widget_with-resizer', e)
            this._viewResizerWrapper = i
            if (!this.isVisible) {
              this.hide()
            }
          })
          this.on('change:isVisible', () => {
            if (this.isVisible) {
              this.show()
              this.redraw()
            } else {
              this.hide()
            }
          })
        }
        begin(t) {
          this._state = new ResizeState(this._options)
          this._sizeView._bindToState(this._options, this.state)
          this._initialViewWidth = this._options.viewElement.getStyle('width')
          this.state.begin(t, this._getHandleHost(), this._getResizeHost())
        }
        updateSize(t) {
          const e = this._proposeNewSize(t)
          const n = this._options.editor.editing.view
          n.change((t) => {
            const n = this._options.unit || '%'
            const i = (n === '%' ? e.widthPercents : e.width) + n
            t.setStyle('width', i, this._options.viewElement)
          })
          const i = this._getHandleHost()
          const o = new Rect(i)
          const r = Math.round(o.width)
          const s = Math.round(o.height)
          const a = new Rect(i)
          e.width = Math.round(a.width)
          e.height = Math.round(a.height)
          this.redraw(o)
          this.state.update({ ...e, handleHostWidth: r, handleHostHeight: s })
        }
        commit() {
          const t = this._options.unit || '%'
          const e =
            (t === '%'
              ? this.state.proposedWidthPercents
              : this.state.proposedWidth) + t
          this._options.editor.editing.view.change(() => {
            this._cleanup()
            this._options.onCommit(e)
          })
        }
        cancel() {
          this._cleanup()
        }
        destroy() {
          this.cancel()
        }
        redraw(t) {
          const e = this._domResizerWrapper
          if (!eM(e)) {
            return
          }
          const n = e.parentElement
          const i = this._getHandleHost()
          const o = this._viewResizerWrapper
          const r = [
            o.getStyle('width'),
            o.getStyle('height'),
            o.getStyle('left'),
            o.getStyle('top')
          ]
          let s
          if (n.isSameNode(i)) {
            const e = t || new Rect(i)
            s = [e.width + 'px', e.height + 'px', undefined, undefined]
          } else {
            s = [
              i.offsetWidth + 'px',
              i.offsetHeight + 'px',
              i.offsetLeft + 'px',
              i.offsetTop + 'px'
            ]
          }
          if (compareArrays(r, s) !== 'same') {
            this._options.editor.editing.view.change((t) => {
              t.setStyle(
                { width: s[0], height: s[1], left: s[2], top: s[3] },
                o
              )
            })
          }
        }
        containsHandle(t) {
          return this._domResizerWrapper.contains(t)
        }
        static isResizeHandle(t) {
          return t.classList.contains('ck-widget__resizer__handle')
        }
        _cleanup() {
          this._sizeView._dismiss()
          const t = this._options.editor.editing.view
          t.change((t) => {
            t.setStyle(
              'width',
              this._initialViewWidth,
              this._options.viewElement
            )
          })
        }
        _proposeNewSize(t) {
          const e = this.state
          const n = tM(t)
          const i = this._options.isCentered
            ? this._options.isCentered(this)
            : true
          const o = {
            x: e._referenceCoordinates.x - (n.x + e.originalWidth),
            y: n.y - e.originalHeight - e._referenceCoordinates.y
          }
          if (i && e.activeHandlePosition.endsWith('-right')) {
            o.x = n.x - (e._referenceCoordinates.x + e.originalWidth)
          }
          if (i) {
            o.x *= 2
          }
          let r = Math.abs(e.originalWidth + o.x)
          let s = Math.abs(e.originalHeight + o.y)
          const a = r / e.aspectRatio > s ? 'width' : 'height'
          if (a == 'width') {
            s = r / e.aspectRatio
          } else {
            r = s * e.aspectRatio
          }
          return {
            width: Math.round(r),
            height: Math.round(s),
            widthPercents: Math.min(
              Math.round(
                (e.originalWidthPercents / e.originalWidth) * r * 100
              ) / 100,
              100
            )
          }
        }
        _getResizeHost() {
          const t = this._domResizerWrapper.parentElement
          return this._options.getResizeHost(t)
        }
        _getHandleHost() {
          const t = this._domResizerWrapper.parentElement
          return this._options.getHandleHost(t)
        }
        get _domResizerWrapper() {
          return this._options.editor.editing.view.domConverter.mapViewToDom(
            this._viewResizerWrapper
          )
        }
        _appendHandles(t) {
          const e = ['top-left', 'top-right', 'bottom-right', 'bottom-left']
          for (const n of e) {
            t.appendChild(
              new Template({
                tag: 'div',
                attributes: { class: `ck-widget__resizer__handle ${XT(n)}` }
              }).render()
            )
          }
        }
        _appendSizeUI(t) {
          this._sizeView = new SizeView()
          this._sizeView.render()
          t.appendChild(this._sizeView.element)
        }
      }
      function XT(t) {
        return `ck-widget__resizer__handle-${t}`
      }
      function tM(t) {
        return { x: t.pageX, y: t.pageY }
      }
      function eM(t) {
        return t && t.ownerDocument && t.ownerDocument.contains(t)
      }
      var nM = __webpack_require__(2263)
      var iM = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      iM.insert = 'head'
      iM.singleton = true
      var oM = El()(nM.Z, iM)
      const rM = nM.Z.locals || {}
      class sM extends (null && Plugin) {
        static get pluginName() {
          return 'WidgetResize'
        }
        init() {
          const t = this.editor.editing
          const e = global.window.document
          this.set('selectedResizer', null)
          this.set('_activeResizer', null)
          this._resizers = new Map()
          t.view.addObserver(MouseObserver)
          this._observer = new (DomEmitterMixin())()
          this.listenTo(
            t.view.document,
            'mousedown',
            this._mouseDownListener.bind(this),
            { priority: 'high' }
          )
          this._observer.listenTo(
            e,
            'mousemove',
            this._mouseMoveListener.bind(this)
          )
          this._observer.listenTo(
            e,
            'mouseup',
            this._mouseUpListener.bind(this)
          )
          this._redrawSelectedResizerThrottled = throttle(
            () => this.redrawSelectedResizer(),
            200
          )
          this.editor.ui.on('update', this._redrawSelectedResizerThrottled)
          this.editor.model.document.on(
            'change',
            () => {
              for (const [t, e] of this._resizers) {
                if (!t.isAttached()) {
                  this._resizers.delete(t)
                  e.destroy()
                }
              }
            },
            { priority: 'lowest' }
          )
          this._observer.listenTo(
            global.window,
            'resize',
            this._redrawSelectedResizerThrottled
          )
          const n = this.editor.editing.view.document.selection
          n.on('change', () => {
            const t = n.getSelectedElement()
            const e = this.getResizerByViewElement(t) || null
            if (e) {
              this.select(e)
            } else {
              this.deselect()
            }
          })
        }
        redrawSelectedResizer() {
          if (this.selectedResizer && this.selectedResizer.isVisible) {
            this.selectedResizer.redraw()
          }
        }
        destroy() {
          super.destroy()
          this._observer.stopListening()
          for (const t of this._resizers.values()) {
            t.destroy()
          }
          this._redrawSelectedResizerThrottled.cancel()
        }
        select(t) {
          this.deselect()
          this.selectedResizer = t
          this.selectedResizer.isSelected = true
        }
        deselect() {
          if (this.selectedResizer) {
            this.selectedResizer.isSelected = false
          }
          this.selectedResizer = null
        }
        attachTo(t) {
          const e = new Resizer(t)
          const n = this.editor.plugins
          e.attach()
          if (n.has('WidgetToolbarRepository')) {
            const t = n.get('WidgetToolbarRepository')
            e.on(
              'begin',
              () => {
                t.forceDisabled('resize')
              },
              { priority: 'lowest' }
            )
            e.on(
              'cancel',
              () => {
                t.clearForceDisabled('resize')
              },
              { priority: 'highest' }
            )
            e.on(
              'commit',
              () => {
                t.clearForceDisabled('resize')
              },
              { priority: 'highest' }
            )
          }
          this._resizers.set(t.viewElement, e)
          const i = this.editor.editing.view.document.selection
          const o = i.getSelectedElement()
          if (this.getResizerByViewElement(o) == e) {
            this.select(e)
          }
          return e
        }
        getResizerByViewElement(t) {
          return this._resizers.get(t)
        }
        _getResizerByHandle(t) {
          for (const e of this._resizers.values()) {
            if (e.containsHandle(t)) {
              return e
            }
          }
        }
        _mouseDownListener(t, e) {
          const n = e.domTarget
          if (!Resizer.isResizeHandle(n)) {
            return
          }
          this._activeResizer = this._getResizerByHandle(n) || null
          if (this._activeResizer) {
            this._activeResizer.begin(n)
            t.stop()
            e.preventDefault()
          }
        }
        _mouseMoveListener(t, e) {
          if (this._activeResizer) {
            this._activeResizer.updateSize(e)
          }
        }
        _mouseUpListener() {
          if (this._activeResizer) {
            this._activeResizer.commit()
            this._activeResizer = null
          }
        }
      }
      var aM = 'Expected a function'
      function cM(t, e, n) {
        var i = true,
          o = true
        if (typeof t != 'function') {
          throw new TypeError(aM)
        }
        if (rt(n)) {
          i = 'leading' in n ? !!n.leading : i
          o = 'trailing' in n ? !!n.trailing : o
        }
        return yg(t, e, { leading: i, maxWait: e, trailing: o })
      }
      const lM = cM
      var dM = __webpack_require__(390)
      var uM = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      uM.insert = 'head'
      uM.singleton = true
      var hM = El()(dM.Z, uM)
      const fM = dM.Z.locals || {}
      class mM extends Kd {
        static get pluginName() {
          return 'DragDrop'
        }
        static get requires() {
          return [UD, RT]
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          this._draggedRange = null
          this._draggingUid = ''
          this._draggableElement = null
          this._updateDropMarkerThrottled = lM(
            (t) => this._updateDropMarker(t),
            40
          )
          this._removeDropMarkerDelayed = vM(() => this._removeDropMarker(), 40)
          this._clearDraggableAttributesDelayed = vM(
            () => this._clearDraggableAttributes(),
            40
          )
          e.addObserver(OD)
          e.addObserver(uA)
          this._setupDragging()
          this._setupContentInsertionIntegration()
          this._setupClipboardInputIntegration()
          this._setupDropMarker()
          this._setupDraggableAttributeHandling()
          this.listenTo(t, 'change:isReadOnly', (t, e, n) => {
            if (n) {
              this.forceDisabled('readOnlyMode')
            } else {
              this.clearForceDisabled('readOnlyMode')
            }
          })
          this.on('change:isEnabled', (t, e, n) => {
            if (!n) {
              this._finalizeDragging(false)
            }
          })
          if (a.isAndroid) {
            this.forceDisabled('noAndroidSupport')
          }
        }
        destroy() {
          if (this._draggedRange) {
            this._draggedRange.detach()
            this._draggedRange = null
          }
          this._updateDropMarkerThrottled.cancel()
          this._removeDropMarkerDelayed.cancel()
          this._clearDraggableAttributesDelayed.cancel()
          return super.destroy()
        }
        _setupDragging() {
          const t = this.editor
          const e = t.model
          const n = e.document
          const i = t.editing.view
          const o = i.document
          this.listenTo(
            o,
            'dragstart',
            (i, r) => {
              const s = n.selection
              if (r.target && r.target.is('editableElement')) {
                r.preventDefault()
                return
              }
              const a = r.target ? CM(r.target) : null
              if (a) {
                const n = t.editing.mapper.toModelElement(a)
                this._draggedRange = hb.fromRange(e.createRangeOn(n))
                if (t.plugins.has('WidgetToolbarRepository')) {
                  t.plugins
                    .get('WidgetToolbarRepository')
                    .forceDisabled('dragDrop')
                }
              } else if (!o.selection.isCollapsed) {
                const t = o.selection.getSelectedElement()
                if (!t || !ZD(t)) {
                  this._draggedRange = hb.fromRange(s.getFirstRange())
                }
              }
              if (!this._draggedRange) {
                r.preventDefault()
                return
              }
              this._draggingUid = T()
              r.dataTransfer.effectAllowed = this.isEnabled
                ? 'copyMove'
                : 'copy'
              r.dataTransfer.setData(
                'application/ckeditor5-dragging-uid',
                this._draggingUid
              )
              const c = e.createSelection(this._draggedRange.toRange())
              const l = t.data.toView(e.getSelectedContent(c))
              o.fire('clipboardOutput', {
                dataTransfer: r.dataTransfer,
                content: l,
                method: 'dragstart'
              })
              if (!this.isEnabled) {
                this._draggedRange.detach()
                this._draggedRange = null
                this._draggingUid = ''
              }
            },
            { priority: 'low' }
          )
          this.listenTo(
            o,
            'dragend',
            (t, e) => {
              this._finalizeDragging(
                !e.dataTransfer.isCanceled &&
                  e.dataTransfer.dropEffect == 'move'
              )
            },
            { priority: 'low' }
          )
          this.listenTo(o, 'dragenter', () => {
            if (!this.isEnabled) {
              return
            }
            i.focus()
          })
          this.listenTo(o, 'dragleave', () => {
            this._removeDropMarkerDelayed()
          })
          this.listenTo(
            o,
            'dragging',
            (e, n) => {
              if (!this.isEnabled) {
                n.dataTransfer.dropEffect = 'none'
                return
              }
              this._removeDropMarkerDelayed.cancel()
              const i = gM(t, n.targetRanges, n.target)
              if (!this._draggedRange) {
                n.dataTransfer.dropEffect = 'copy'
              }
              if (!a.isGecko) {
                if (n.dataTransfer.effectAllowed == 'copy') {
                  n.dataTransfer.dropEffect = 'copy'
                } else if (
                  ['all', 'copyMove'].includes(n.dataTransfer.effectAllowed)
                ) {
                  n.dataTransfer.dropEffect = 'move'
                }
              }
              if (i) {
                this._updateDropMarkerThrottled(i)
              }
            },
            { priority: 'low' }
          )
        }
        _setupClipboardInputIntegration() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          this.listenTo(
            n,
            'clipboardInput',
            (e, n) => {
              if (n.method != 'drop') {
                return
              }
              const i = gM(t, n.targetRanges, n.target)
              this._removeDropMarker()
              if (!i) {
                this._finalizeDragging(false)
                e.stop()
                return
              }
              if (
                this._draggedRange &&
                this._draggingUid !=
                  n.dataTransfer.getData('application/ckeditor5-dragging-uid')
              ) {
                this._draggedRange.detach()
                this._draggedRange = null
                this._draggingUid = ''
              }
              const o = AM(n.dataTransfer) == 'move'
              if (
                o &&
                this._draggedRange &&
                this._draggedRange.containsRange(i, true)
              ) {
                this._finalizeDragging(false)
                e.stop()
                return
              }
              n.targetRanges = [t.editing.mapper.toViewRange(i)]
            },
            { priority: 'high' }
          )
        }
        _setupContentInsertionIntegration() {
          const t = this.editor.plugins.get(UD)
          t.on(
            'contentInsertion',
            (t, e) => {
              if (!this.isEnabled || e.method !== 'drop') {
                return
              }
              const n = e.targetRanges.map((t) =>
                this.editor.editing.mapper.toModelRange(t)
              )
              this.editor.model.change((t) => t.setSelection(n))
            },
            { priority: 'high' }
          )
          t.on(
            'contentInsertion',
            (t, e) => {
              if (!this.isEnabled || e.method !== 'drop') {
                return
              }
              const n = AM(e.dataTransfer) == 'move'
              const i = !e.resultRange || !e.resultRange.isCollapsed
              this._finalizeDragging(i && n)
            },
            { priority: 'lowest' }
          )
        }
        _setupDraggableAttributeHandling() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          this.listenTo(n, 'mousedown', (i, o) => {
            if (a.isAndroid || !o) {
              return
            }
            this._clearDraggableAttributesDelayed.cancel()
            let r = CM(o.target)
            if (a.isBlink && !t.isReadOnly && !r && !n.selection.isCollapsed) {
              const t = n.selection.getSelectedElement()
              if (!t || !ZD(t)) {
                r = n.selection.editableElement
              }
            }
            if (r) {
              e.change((t) => {
                t.setAttribute('draggable', 'true', r)
              })
              this._draggableElement = t.editing.mapper.toModelElement(r)
            }
          })
          this.listenTo(n, 'mouseup', () => {
            if (!a.isAndroid) {
              this._clearDraggableAttributesDelayed()
            }
          })
        }
        _clearDraggableAttributes() {
          const t = this.editor.editing
          t.view.change((e) => {
            if (
              this._draggableElement &&
              this._draggableElement.root.rootName != '$graveyard'
            ) {
              e.removeAttribute(
                'draggable',
                t.mapper.toViewElement(this._draggableElement)
              )
            }
            this._draggableElement = null
          })
        }
        _setupDropMarker() {
          const t = this.editor
          t.conversion
            .for('editingDowncast')
            .markerToHighlight({
              model: 'drop-target',
              view: { classes: ['ck-clipboard-drop-target-range'] }
            })
          t.conversion.for('editingDowncast').markerToElement({
            model: 'drop-target',
            view: (e, { writer: n }) => {
              const i = t.model.schema.checkChild(e.markerRange.start, '$text')
              if (!i) {
                return
              }
              return n.createUIElement(
                'span',
                { class: 'ck ck-clipboard-drop-target-position' },
                function (t) {
                  const e = this.toDomElement(t)
                  e.append('⁠', t.createElement('span'), '⁠')
                  return e
                }
              )
            }
          })
        }
        _updateDropMarker(t) {
          const e = this.editor
          const n = e.model.markers
          e.model.change((e) => {
            if (n.has('drop-target')) {
              if (!n.get('drop-target').getRange().isEqual(t)) {
                e.updateMarker('drop-target', { range: t })
              }
            } else {
              e.addMarker('drop-target', {
                range: t,
                usingOperation: false,
                affectsData: false
              })
            }
          })
        }
        _removeDropMarker() {
          const t = this.editor.model
          this._removeDropMarkerDelayed.cancel()
          this._updateDropMarkerThrottled.cancel()
          if (t.markers.has('drop-target')) {
            t.change((t) => {
              t.removeMarker('drop-target')
            })
          }
        }
        _finalizeDragging(t) {
          const e = this.editor
          const n = e.model
          this._removeDropMarker()
          this._clearDraggableAttributes()
          if (e.plugins.has('WidgetToolbarRepository')) {
            e.plugins
              .get('WidgetToolbarRepository')
              .clearForceDisabled('dragDrop')
          }
          this._draggingUid = ''
          if (!this._draggedRange) {
            return
          }
          if (t && this.isEnabled) {
            n.deleteContent(n.createSelection(this._draggedRange), {
              doNotAutoparagraph: true
            })
          }
          this._draggedRange.detach()
          this._draggedRange = null
        }
      }
      function gM(t, e, n) {
        const i = t.model
        const o = t.editing.mapper
        let r = null
        const s = e ? e[0].start : null
        if (n.is('uiElement')) {
          n = n.parent
        }
        r = pM(t, n)
        if (r) {
          return r
        }
        const c = _M(t, n)
        const l = s ? o.toModelPosition(s) : null
        if (!l) {
          return bM(t, c)
        }
        r = kM(t, l, c)
        if (r) {
          return r
        }
        r = i.schema.getNearestSelectionRange(
          l,
          a.isGecko ? 'forward' : 'backward'
        )
        if (r) {
          return r
        }
        return wM(t, l.parent)
      }
      function pM(t, e) {
        const n = t.model
        const i = t.editing.mapper
        if (ZD(e)) {
          return n.createRangeOn(i.toModelElement(e))
        }
        if (!e.is('editableElement')) {
          const t = e.findAncestor((t) => ZD(t) || t.is('editableElement'))
          if (ZD(t)) {
            return n.createRangeOn(i.toModelElement(t))
          }
        }
        return null
      }
      function bM(t, e) {
        const n = t.model
        const i = n.schema
        const o = n.createPositionAt(e, 0)
        return i.getNearestSelectionRange(o, 'forward')
      }
      function kM(t, e, n) {
        const i = t.model
        if (!i.schema.checkChild(n, '$block')) {
          return null
        }
        const o = i.createPositionAt(n, 0)
        const r = e.path.slice(0, o.path.length)
        const s = i.createPositionFromPath(e.root, r)
        const a = s.nodeAfter
        if (a && i.schema.isObject(a)) {
          return i.createRangeOn(a)
        }
        return null
      }
      function wM(t, e) {
        const n = t.model
        let i = e
        while (i) {
          if (n.schema.isObject(i)) {
            return n.createRangeOn(i)
          }
          i = i.parent
        }
        return null
      }
      function _M(t, e) {
        const n = t.editing.mapper
        const i = t.editing.view
        const o = n.toModelElement(e)
        if (o) {
          return o
        }
        const r = i.createPositionBefore(e)
        const s = n.findMappedViewAncestor(r)
        return n.toModelElement(s)
      }
      function AM(t) {
        if (a.isGecko) {
          return t.dropEffect
        }
        return ['all', 'copyMove'].includes(t.effectAllowed) ? 'move' : 'copy'
      }
      function vM(t, e) {
        let n
        function i(...o) {
          i.cancel()
          n = setTimeout(() => t(...o), e)
        }
        i.cancel = () => {
          clearTimeout(n)
        }
        return i
      }
      function CM(t) {
        if (t.is('editableElement')) {
          return null
        }
        if (t.hasClass('ck-widget__selection-handle')) {
          return t.findAncestor(ZD)
        }
        if (ZD(t)) {
          return t
        }
        const e = t.findAncestor((t) => ZD(t) || t.is('editableElement'))
        if (ZD(e)) {
          return e
        }
        return null
      }
      class yM extends Kd {
        static get pluginName() {
          return 'PastePlainText'
        }
        static get requires() {
          return [UD]
        }
        init() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          const i = n.document
          const o = e.document.selection
          let r = false
          n.addObserver(OD)
          this.listenTo(i, 'keydown', (t, e) => {
            r = e.shiftKey
          })
          t.plugins.get(UD).on('contentInsertion', (t, n) => {
            if (!r && !xM(n.content, e.schema)) {
              return
            }
            e.change((t) => {
              const i = Array.from(o.getAttributes()).filter(
                ([t]) => e.schema.getAttributeProperties(t).isFormatting
              )
              if (!o.isCollapsed) {
                e.deleteContent(o, { doNotAutoparagraph: true })
              }
              i.push(...o.getAttributes())
              const r = t.createRangeIn(n.content)
              for (const e of r.getItems()) {
                if (e.is('$textProxy')) {
                  t.setAttributes(i, e)
                }
              }
            })
          })
        }
      }
      function xM(t, e) {
        if (t.childCount > 1) {
          return false
        }
        const n = t.getChild(0)
        if (e.isObject(n)) {
          return false
        }
        return Array.from(n.getAttributeKeys()).length == 0
      }
      class EM extends Kd {
        static get pluginName() {
          return 'Clipboard'
        }
        static get requires() {
          return [UD, mM, yM]
        }
      }
      class DM extends Zd {
        constructor(t) {
          super(t)
          this.affectsData = false
        }
        execute() {
          const t = this.editor.model
          const e = t.document.selection
          let n = t.schema.getLimitElement(e)
          if (e.containsEntireContent(n) || !TM(t.schema, n)) {
            do {
              n = n.parent
              if (!n) {
                return
              }
            } while (!TM(t.schema, n))
          }
          t.change((t) => {
            t.setSelection(n, 'in')
          })
        }
      }
      function TM(t, e) {
        return (
          t.isLimit(e) &&
          (t.checkChild(e, '$text') || t.checkChild(e, 'paragraph'))
        )
      }
      const MM = Uc('Ctrl+A')
      class IM extends Kd {
        static get pluginName() {
          return 'SelectAllEditing'
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          t.commands.add('selectAll', new DM(t))
          this.listenTo(n, 'keydown', (e, n) => {
            if (Hc(n) === MM) {
              t.execute('selectAll')
              n.preventDefault()
            }
          })
        }
      }
      const SM =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>'
      class BM extends Kd {
        static get pluginName() {
          return 'SelectAllUI'
        }
        init() {
          const t = this.editor
          t.ui.componentFactory.add('selectAll', (e) => {
            const n = t.commands.get('selectAll')
            const i = new pd(e)
            const o = e.t
            i.set({
              label: o('Select all'),
              icon: SM,
              keystroke: 'Ctrl+A',
              tooltip: true
            })
            i.bind('isEnabled').to(n, 'isEnabled')
            this.listenTo(i, 'execute', () => {
              t.execute('selectAll')
              t.editing.view.focus()
            })
            return i
          })
        }
      }
      class NM extends Kd {
        static get requires() {
          return [IM, BM]
        }
        static get pluginName() {
          return 'SelectAll'
        }
      }
      class PM extends Zd {
        constructor(t) {
          super(t)
          this._stack = []
          this._createdBatches = new WeakSet()
          this.refresh()
          this.listenTo(
            t.data,
            'set',
            (t, e) => {
              e[1] = { ...e[1] }
              const n = e[1]
              if (!n.batchType) {
                n.batchType = { isUndoable: false }
              }
            },
            { priority: 'high' }
          )
          this.listenTo(t.data, 'set', (t, e) => {
            const n = e[1]
            if (!n.batchType.isUndoable) {
              this.clearStack()
            }
          })
        }
        refresh() {
          this.isEnabled = this._stack.length > 0
        }
        addBatch(t) {
          const e = this.editor.model.document.selection
          const n = {
            ranges: e.hasOwnRange ? Array.from(e.getRanges()) : [],
            isBackward: e.isBackward
          }
          this._stack.push({ batch: t, selection: n })
          this.refresh()
        }
        clearStack() {
          this._stack = []
          this.refresh()
        }
        _restoreSelection(t, e, n) {
          const i = this.editor.model
          const o = i.document
          const r = []
          const s = t.map((t) => t.getTransformedByOperations(n))
          const a = s.flat()
          for (const t of s) {
            const e = t
              .filter((t) => t.root != o.graveyard)
              .filter((t) => !LM(t, a))
            if (!e.length) {
              continue
            }
            zM(e)
            r.push(e[0])
          }
          if (r.length) {
            i.change((t) => {
              t.setSelection(r, { backward: e })
            })
          }
        }
        _undo(t, e) {
          const n = this.editor.model
          const i = n.document
          this._createdBatches.add(e)
          const o = t.operations.slice().filter((t) => t.isDocumentOperation)
          o.reverse()
          for (const t of o) {
            const o = t.baseVersion + 1
            const r = Array.from(i.history.getOperations(o))
            const s = $w([t.getReversed()], r, {
              useRelations: true,
              document: this.editor.model.document,
              padWithNoOps: false,
              forceWeakRemove: true
            })
            const a = s.operationsA
            for (const o of a) {
              e.addOperation(o)
              n.applyOperation(o)
              i.history.setOperationAsUndone(t, o)
            }
          }
        }
      }
      function zM(t) {
        t.sort((t, e) => (t.start.isBefore(e.start) ? -1 : 1))
        for (let e = 1; e < t.length; e++) {
          const n = t[e - 1]
          const i = n.getJoined(t[e], true)
          if (i) {
            e--
            t.splice(e, 2, i)
          }
        }
      }
      function LM(t, e) {
        return e.some((e) => e !== t && e.containsRange(t, true))
      }
      class OM extends PM {
        execute(t = null) {
          const e = t
            ? this._stack.findIndex((e) => e.batch == t)
            : this._stack.length - 1
          const n = this._stack.splice(e, 1)[0]
          const i = this.editor.model.createBatch({ isUndo: true })
          this.editor.model.enqueueChange(i, () => {
            this._undo(n.batch, i)
            const t = this.editor.model.document.history.getOperations(
              n.batch.baseVersion
            )
            this._restoreSelection(
              n.selection.ranges,
              n.selection.isBackward,
              t
            )
            this.fire('revert', n.batch, i)
          })
          this.refresh()
        }
      }
      class RM extends PM {
        execute() {
          const t = this._stack.pop()
          const e = this.editor.model.createBatch({ isUndo: true })
          this.editor.model.enqueueChange(e, () => {
            const n = t.batch.operations[t.batch.operations.length - 1]
            const i = n.baseVersion + 1
            const o = this.editor.model.document.history.getOperations(i)
            this._restoreSelection(
              t.selection.ranges,
              t.selection.isBackward,
              o
            )
            this._undo(t.batch, e)
          })
          this.refresh()
        }
      }
      class jM extends Kd {
        static get pluginName() {
          return 'UndoEditing'
        }
        constructor(t) {
          super(t)
          this._batchRegistry = new WeakSet()
        }
        init() {
          const t = this.editor
          this._undoCommand = new OM(t)
          this._redoCommand = new RM(t)
          t.commands.add('undo', this._undoCommand)
          t.commands.add('redo', this._redoCommand)
          this.listenTo(
            t.model,
            'applyOperation',
            (t, e) => {
              const n = e[0]
              if (!n.isDocumentOperation) {
                return
              }
              const i = n.batch
              const o = this._redoCommand._createdBatches.has(i)
              const r = this._undoCommand._createdBatches.has(i)
              const s = this._batchRegistry.has(i)
              if (s) {
                return
              }
              this._batchRegistry.add(i)
              if (!i.isUndoable) {
                return
              }
              if (o) {
                this._undoCommand.addBatch(i)
              } else if (!r) {
                this._undoCommand.addBatch(i)
                this._redoCommand.clearStack()
              }
            },
            { priority: 'highest' }
          )
          this.listenTo(this._undoCommand, 'revert', (t, e, n) => {
            this._redoCommand.addBatch(n)
          })
          t.keystrokes.set('CTRL+Z', 'undo')
          t.keystrokes.set('CTRL+Y', 'redo')
          t.keystrokes.set('CTRL+SHIFT+Z', 'redo')
        }
      }
      const FM =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>'
      const VM =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>'
      class HM extends Kd {
        static get pluginName() {
          return 'UndoUI'
        }
        init() {
          const t = this.editor
          const e = t.locale
          const n = t.t
          const i = e.uiLanguageDirection == 'ltr' ? FM : VM
          const o = e.uiLanguageDirection == 'ltr' ? VM : FM
          this._addButton('undo', n('Undo'), 'CTRL+Z', i)
          this._addButton('redo', n('Redo'), 'CTRL+Y', o)
        }
        _addButton(t, e, n, i) {
          const o = this.editor
          o.ui.componentFactory.add(t, (r) => {
            const s = o.commands.get(t)
            const a = new pd(r)
            a.set({ label: e, icon: i, keystroke: n, tooltip: true })
            a.bind('isEnabled').to(s, 'isEnabled')
            this.listenTo(a, 'execute', () => {
              o.execute(t)
              o.editing.view.focus()
            })
            return a
          })
        }
      }
      class UM extends Kd {
        static get requires() {
          return [jM, HM]
        }
        static get pluginName() {
          return 'Undo'
        }
      }
      class WM extends Kd {
        static get requires() {
          return [EM, _E, NM, EE, Ox, UM]
        }
        static get pluginName() {
          return 'Essentials'
        }
      }
      class qM extends Zd {
        refresh() {
          const t = this.editor.model
          const e = t.document
          const n = cl(e.selection.getSelectedBlocks())
          this.value = !!n && n.is('element', 'paragraph')
          this.isEnabled = !!n && $M(n, t.schema)
        }
        execute(t = {}) {
          const e = this.editor.model
          const n = e.document
          e.change((i) => {
            const o = (t.selection || n.selection).getSelectedBlocks()
            for (const t of o) {
              if (!t.is('element', 'paragraph') && $M(t, e.schema)) {
                i.rename(t, 'paragraph')
              }
            }
          })
        }
      }
      function $M(t, e) {
        return e.checkChild(t.parent, 'paragraph') && !e.isObject(t)
      }
      class GM extends Zd {
        execute(t) {
          const e = this.editor.model
          const n = t.attributes
          let i = t.position
          e.change((t) => {
            const o = t.createElement('paragraph')
            if (n) {
              e.schema.setAllowedAttributes(o, n, t)
            }
            if (!e.schema.checkChild(i.parent, o)) {
              const n = e.schema.findAllowedParent(i, o)
              if (!n) {
                return
              }
              i = t.split(i, n).position
            }
            e.insertContent(o, i)
            t.setSelection(o, 'in')
          })
        }
      }
      class YM extends Kd {
        static get pluginName() {
          return 'Paragraph'
        }
        init() {
          const t = this.editor
          const e = t.model
          t.commands.add('paragraph', new qM(t))
          t.commands.add('insertParagraph', new GM(t))
          e.schema.register('paragraph', { inheritAllFrom: '$block' })
          t.conversion.elementToElement({ model: 'paragraph', view: 'p' })
          t.conversion.for('upcast').elementToElement({
            model: (t, { writer: e }) => {
              if (!YM.paragraphLikeElements.has(t.name)) {
                return null
              }
              if (t.isEmpty) {
                return null
              }
              return e.createElement('paragraph')
            },
            view: /.+/,
            converterPriority: 'low'
          })
        }
      }
      YM.paragraphLikeElements = new Set([
        'blockquote',
        'dd',
        'div',
        'dt',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'li',
        'p',
        'td',
        'th'
      ])
      const KM = $v.paragraph
      class QM extends (null && Plugin) {
        static get requires() {
          return [Paragraph]
        }
        init() {
          const t = this.editor
          const e = t.t
          t.ui.componentFactory.add('paragraph', (n) => {
            const i = new ButtonView(n)
            const o = t.commands.get('paragraph')
            i.label = e('Paragraph')
            i.icon = KM
            i.tooltip = true
            i.isToggleable = true
            i.bind('isEnabled').to(o)
            i.bind('isOn').to(o, 'value')
            i.on('execute', () => {
              t.execute('paragraph')
            })
            return i
          })
        }
      }
      class ZM extends Zd {
        constructor(t, e) {
          super(t)
          this.modelElements = e
        }
        refresh() {
          const t = cl(this.editor.model.document.selection.getSelectedBlocks())
          this.value = !!t && this.modelElements.includes(t.name) && t.name
          this.isEnabled =
            !!t &&
            this.modelElements.some((e) => JM(t, e, this.editor.model.schema))
        }
        execute(t) {
          const e = this.editor.model
          const n = e.document
          const i = t.value
          e.change((t) => {
            const o = Array.from(n.selection.getSelectedBlocks()).filter((t) =>
              JM(t, i, e.schema)
            )
            for (const e of o) {
              if (!e.is('element', i)) {
                t.rename(e, i)
              }
            }
          })
        }
      }
      function JM(t, e, n) {
        return n.checkChild(t.parent, e) && !n.isObject(t)
      }
      const XM = 'paragraph'
      class tI extends Kd {
        static get pluginName() {
          return 'HeadingEditing'
        }
        constructor(t) {
          super(t)
          t.config.define('heading', {
            options: [
              {
                model: 'paragraph',
                title: 'Paragraph',
                class: 'ck-heading_paragraph'
              },
              {
                model: 'heading1',
                view: 'h2',
                title: 'Heading 1',
                class: 'ck-heading_heading1'
              },
              {
                model: 'heading2',
                view: 'h3',
                title: 'Heading 2',
                class: 'ck-heading_heading2'
              },
              {
                model: 'heading3',
                view: 'h4',
                title: 'Heading 3',
                class: 'ck-heading_heading3'
              }
            ]
          })
        }
        static get requires() {
          return [YM]
        }
        init() {
          const t = this.editor
          const e = t.config.get('heading.options')
          const n = []
          for (const i of e) {
            if (i.model === 'paragraph') {
              continue
            }
            t.model.schema.register(i.model, { inheritAllFrom: '$block' })
            t.conversion.elementToElement(i)
            n.push(i.model)
          }
          this._addDefaultH1Conversion(t)
          t.commands.add('heading', new ZM(t, n))
        }
        afterInit() {
          const t = this.editor
          const e = t.commands.get('enter')
          const n = t.config.get('heading.options')
          if (e) {
            this.listenTo(e, 'afterExecute', (e, i) => {
              const o = t.model.document.selection.getFirstPosition().parent
              const r = n.some((t) => o.is('element', t.model))
              if (r && !o.is('element', XM) && o.childCount === 0) {
                i.writer.rename(o, XM)
              }
            })
          }
        }
        _addDefaultH1Conversion(t) {
          t.conversion
            .for('upcast')
            .elementToElement({
              model: 'heading1',
              view: 'h1',
              converterPriority: I.get('low') + 1
            })
        }
      }
      function eI(t) {
        const e = t.t
        const n = {
          Paragraph: e('Paragraph'),
          'Heading 1': e('Heading 1'),
          'Heading 2': e('Heading 2'),
          'Heading 3': e('Heading 3'),
          'Heading 4': e('Heading 4'),
          'Heading 5': e('Heading 5'),
          'Heading 6': e('Heading 6')
        }
        return t.config.get('heading.options').map((t) => {
          const e = n[t.title]
          if (e && e != t.title) {
            t.title = e
          }
          return t
        })
      }
      var nI = __webpack_require__(3230)
      var iI = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      iI.insert = 'head'
      iI.singleton = true
      var oI = El()(nI.Z, iI)
      const rI = nI.Z.locals || {}
      class sI extends Kd {
        static get pluginName() {
          return 'HeadingUI'
        }
        init() {
          const t = this.editor
          const e = t.t
          const n = eI(t)
          const i = e('Choose heading')
          const o = e('Heading')
          t.ui.componentFactory.add('heading', (e) => {
            const r = {}
            const s = new al()
            const a = t.commands.get('heading')
            const c = t.commands.get('paragraph')
            const l = [a]
            for (const t of n) {
              const e = {
                type: 'button',
                model: new By({
                  label: t.title,
                  class: t.class,
                  withText: true
                })
              }
              if (t.model === 'paragraph') {
                e.model.bind('isOn').to(c, 'value')
                e.model.set('commandName', 'paragraph')
                l.push(c)
              } else {
                e.model.bind('isOn').to(a, 'value', (e) => e === t.model)
                e.model.set({ commandName: 'heading', commandValue: t.model })
              }
              s.add(e)
              r[t.model] = t.title
            }
            const d = kC(e)
            AC(d, s)
            d.buttonView.set({ isOn: false, withText: true, tooltip: o })
            d.extendTemplate({ attributes: { class: ['ck-heading-dropdown'] } })
            d.bind('isEnabled').toMany(l, 'isEnabled', (...t) =>
              t.some((t) => t)
            )
            d.buttonView.bind('label').to(a, 'value', c, 'value', (t, e) => {
              const n = t || (e && 'paragraph')
              if (typeof n === 'boolean') {
                return i
              }
              if (!r[n]) {
                return i
              }
              return r[n]
            })
            this.listenTo(d, 'execute', (e) => {
              const { commandName: n, commandValue: i } = e.source
              t.execute(n, i ? { value: i } : undefined)
              t.editing.view.focus()
            })
            return d
          })
        }
      }
      class aI extends Kd {
        static get requires() {
          return [tI, sI]
        }
        static get pluginName() {
          return 'Heading'
        }
      }
      class cI extends Zd {
        refresh() {
          const t = this.editor
          const e = t.plugins.get('ImageUtils')
          const n = e.getClosestSelectedImageElement(
            this.editor.model.document.selection
          )
          this.isEnabled = !!n
          if (this.isEnabled && n.hasAttribute('alt')) {
            this.value = n.getAttribute('alt')
          } else {
            this.value = false
          }
        }
        execute(t) {
          const e = this.editor
          const n = e.plugins.get('ImageUtils')
          const i = e.model
          const o = n.getClosestSelectedImageElement(i.document.selection)
          i.change((e) => {
            e.setAttribute('alt', t.newValue, o)
          })
        }
      }
      function lI(t) {
        return t.createContainerElement(
          'span',
          { class: 'image-inline' },
          t.createEmptyElement('img')
        )
      }
      function dI(t) {
        return t.createContainerElement('figure', { class: 'image' }, [
          t.createEmptyElement('img'),
          t.createSlot()
        ])
      }
      function uI(t, e) {
        const n = t.plugins.get('ImageUtils')
        const i =
          t.plugins.has('ImageInlineEditing') &&
          t.plugins.has('ImageBlockEditing')
        return (t) => {
          if (!n.isInlineImageView(t)) {
            return null
          }
          if (!i) {
            return o(t)
          }
          const r =
            t.getStyle('display') == 'block' ||
            t.findAncestor(n.isBlockImageView)
              ? 'imageBlock'
              : 'imageInline'
          if (r !== e) {
            return null
          }
          return o(t)
        }
        function o(t) {
          const e = { name: true }
          if (t.hasAttribute('src')) {
            e.attributes = ['src']
          }
          return e
        }
      }
      function hI(t, e) {
        const n = cl(e.getSelectedBlocks())
        if (!n || t.isObject(n)) {
          return 'imageBlock'
        }
        if (n.isEmpty && n.name != 'listItem') {
          return 'imageBlock'
        }
        return 'imageInline'
      }
      class fI extends Kd {
        static get pluginName() {
          return 'ImageUtils'
        }
        isImage(t) {
          return this.isInlineImage(t) || this.isBlockImage(t)
        }
        isInlineImageView(t) {
          return !!t && t.is('element', 'img')
        }
        isBlockImageView(t) {
          return !!t && t.is('element', 'figure') && t.hasClass('image')
        }
        insertImage(t = {}, e = null, n = null) {
          const i = this.editor
          const o = i.model
          const r = o.document.selection
          n = bI(i, e || r, n)
          t = { ...Object.fromEntries(r.getAttributes()), ...t }
          for (const e in t) {
            if (!o.schema.checkAttribute(n, e)) {
              delete t[e]
            }
          }
          return o.change((i) => {
            const r = i.createElement(n, t)
            o.insertObject(r, e, null, {
              setSelection: 'on',
              findOptimalPosition: !e && n != 'imageInline'
            })
            if (r.parent) {
              return r
            }
            return null
          })
        }
        getClosestSelectedImageWidget(t) {
          const e = t.getFirstPosition()
          if (!e) {
            return null
          }
          const n = t.getSelectedElement()
          if (n && this.isImageWidget(n)) {
            return n
          }
          let i = e.parent
          while (i) {
            if (i.is('element') && this.isImageWidget(i)) {
              return i
            }
            i = i.parent
          }
          return null
        }
        getClosestSelectedImageElement(t) {
          const e = t.getSelectedElement()
          return this.isImage(e)
            ? e
            : t.getFirstPosition().findAncestor('imageBlock')
        }
        isImageAllowed() {
          const t = this.editor.model
          const e = t.document.selection
          return mI(this.editor, e) && gI(e)
        }
        toImageWidget(t, e, n) {
          e.setCustomProperty('image', true, t)
          const i = () => {
            const e = this.findViewImgElement(t)
            const i = e.getAttribute('alt')
            return i ? `${i} ${n}` : n
          }
          return JD(t, e, { label: i })
        }
        isImageWidget(t) {
          return !!t.getCustomProperty('image') && ZD(t)
        }
        isBlockImage(t) {
          return !!t && t.is('element', 'imageBlock')
        }
        isInlineImage(t) {
          return !!t && t.is('element', 'imageInline')
        }
        findViewImgElement(t) {
          if (this.isInlineImageView(t)) {
            return t
          }
          const e = this.editor.editing.view
          for (const { item: n } of e.createRangeIn(t)) {
            if (this.isInlineImageView(n)) {
              return n
            }
          }
        }
      }
      function mI(t, e) {
        const n = bI(t, e)
        if (n == 'imageBlock') {
          const n = pI(e, t.model)
          if (t.model.schema.checkChild(n, 'imageBlock')) {
            return true
          }
        } else if (t.model.schema.checkChild(e.focus, 'imageInline')) {
          return true
        }
        return false
      }
      function gI(t) {
        return [...t.focus.getAncestors()].every(
          (t) => !t.is('element', 'imageBlock')
        )
      }
      function pI(t, e) {
        const n = rT(t, e)
        const i = n.start.parent
        if (i.isEmpty && !i.is('element', '$root')) {
          return i.parent
        }
        return i
      }
      function bI(t, e, n) {
        const i = t.model.schema
        const o = t.config.get('image.insert.type')
        if (!t.plugins.has('ImageBlockEditing')) {
          return 'imageInline'
        }
        if (!t.plugins.has('ImageInlineEditing')) {
          return 'imageBlock'
        }
        if (n) {
          return n
        }
        if (o === 'inline') {
          return 'imageInline'
        }
        if (o === 'block') {
          return 'imageBlock'
        }
        if (e.is('selection')) {
          return hI(i, e)
        }
        return i.checkChild(e, 'imageInline') ? 'imageInline' : 'imageBlock'
      }
      class kI extends Kd {
        static get requires() {
          return [fI]
        }
        static get pluginName() {
          return 'ImageTextAlternativeEditing'
        }
        init() {
          this.editor.commands.add('imageTextAlternative', new cI(this.editor))
        }
      }
      var wI = __webpack_require__(6831)
      var _I = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      _I.insert = 'head'
      _I.singleton = true
      var AI = El()(wI.Z, _I)
      const vI = wI.Z.locals || {}
      var CI = __webpack_require__(1590)
      var yI = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      yI.insert = 'head'
      yI.singleton = true
      var xI = El()(CI.Z, yI)
      const EI = CI.Z.locals || {}
      class DI extends Sl {
        constructor(t) {
          super(t)
          const n = this.locale.t
          this.focusTracker = new ll()
          this.keystrokes = new dl()
          this.labeledInput = this._createLabeledInputView()
          this.saveButtonView = this._createButton(
            n('Save'),
            $v.check,
            'ck-button-save'
          )
          this.saveButtonView.type = 'submit'
          this.cancelButtonView = this._createButton(
            n('Cancel'),
            $v.cancel,
            'ck-button-cancel',
            'cancel'
          )
          this._focusables = new Cl()
          this._focusCycler = new Ud({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' }
          })
          this.setTemplate({
            tag: 'form',
            attributes: {
              class: ['ck', 'ck-text-alternative-form', 'ck-responsive-form'],
              tabindex: '-1'
            },
            children: [
              this.labeledInput,
              this.saveButtonView,
              this.cancelButtonView
            ]
          })
          e(this)
        }
        render() {
          super.render()
          this.keystrokes.listenTo(this.element)
          n({ view: this })
          ;[
            this.labeledInput,
            this.saveButtonView,
            this.cancelButtonView
          ].forEach((t) => {
            this._focusables.add(t)
            this.focusTracker.add(t.element)
          })
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
        }
        _createButton(t, e, n, i) {
          const o = new pd(this.locale)
          o.set({ label: t, icon: e, tooltip: true })
          o.extendTemplate({ attributes: { class: n } })
          if (i) {
            o.delegate('execute').to(this, i)
          }
          return o
        }
        _createLabeledInputView() {
          const t = this.locale.t
          const e = new Dy(this.locale, Ty)
          e.label = t('Text alternative')
          return e
        }
      }
      function TI(t) {
        const e = t.plugins.get('ContextualBalloon')
        if (
          t.plugins
            .get('ImageUtils')
            .getClosestSelectedImageWidget(t.editing.view.document.selection)
        ) {
          const n = MI(t)
          e.updatePosition(n)
        }
      }
      function MI(t) {
        const e = t.editing.view
        const n = OC.defaultPositions
        const i = t.plugins.get('ImageUtils')
        return {
          target: e.domConverter.mapViewToDom(
            i.getClosestSelectedImageWidget(e.document.selection)
          ),
          positions: [
            n.northArrowSouth,
            n.northArrowSouthWest,
            n.northArrowSouthEast,
            n.southArrowNorth,
            n.southArrowNorthWest,
            n.southArrowNorthEast,
            n.viewportStickyNorth
          ]
        }
      }
      class II extends Kd {
        static get requires() {
          return [Wy]
        }
        static get pluginName() {
          return 'ImageTextAlternativeUI'
        }
        init() {
          this._createButton()
        }
        destroy() {
          super.destroy()
          if (this._form) {
            this._form.destroy()
          }
        }
        _createButton() {
          const t = this.editor
          const e = t.t
          t.ui.componentFactory.add('imageTextAlternative', (n) => {
            const i = t.commands.get('imageTextAlternative')
            const o = new pd(n)
            o.set({
              label: e('Change image text alternative'),
              icon: $v.lowVision,
              tooltip: true
            })
            o.bind('isEnabled').to(i, 'isEnabled')
            o.bind('isOn').to(i, 'value', (t) => !!t)
            this.listenTo(o, 'execute', () => {
              this._showForm()
            })
            return o
          })
        }
        _createForm() {
          const e = this.editor
          const n = e.editing.view
          const i = n.document
          const o = e.plugins.get('ImageUtils')
          this._balloon = this.editor.plugins.get('ContextualBalloon')
          this._form = new DI(e.locale)
          this._form.render()
          this.listenTo(this._form, 'submit', () => {
            e.execute('imageTextAlternative', {
              newValue: this._form.labeledInput.fieldView.element.value
            })
            this._hideForm(true)
          })
          this.listenTo(this._form, 'cancel', () => {
            this._hideForm(true)
          })
          this._form.keystrokes.set('Esc', (t, e) => {
            this._hideForm(true)
            e()
          })
          this.listenTo(e.ui, 'update', () => {
            if (!o.getClosestSelectedImageWidget(i.selection)) {
              this._hideForm(true)
            } else if (this._isVisible) {
              TI(e)
            }
          })
          t({
            emitter: this._form,
            activator: () => this._isVisible,
            contextElements: () => [this._balloon.view.element],
            callback: () => this._hideForm()
          })
        }
        _showForm() {
          if (this._isVisible) {
            return
          }
          if (!this._form) {
            this._createForm()
          }
          const t = this.editor
          const e = t.commands.get('imageTextAlternative')
          const n = this._form.labeledInput
          this._form.disableCssTransitions()
          if (!this._isInBalloon) {
            this._balloon.add({ view: this._form, position: MI(t) })
          }
          n.fieldView.value = n.fieldView.element.value = e.value || ''
          this._form.labeledInput.fieldView.select()
          this._form.enableCssTransitions()
        }
        _hideForm(t) {
          if (!this._isInBalloon) {
            return
          }
          if (this._form.focusTracker.isFocused) {
            this._form.saveButtonView.focus()
          }
          this._balloon.remove(this._form)
          if (t) {
            this.editor.editing.view.focus()
          }
        }
        get _isVisible() {
          return !!this._balloon && this._balloon.visibleView === this._form
        }
        get _isInBalloon() {
          return !!this._balloon && this._balloon.hasView(this._form)
        }
      }
      class SI extends Kd {
        static get requires() {
          return [kI, II]
        }
        static get pluginName() {
          return 'ImageTextAlternative'
        }
      }
      function BI(t) {
        return (t) => {
          t.on('element:figure', e)
        }
        function e(e, n, i) {
          if (
            !i.consumable.test(n.viewItem, { name: true, classes: 'image' })
          ) {
            return
          }
          const o = t.findViewImgElement(n.viewItem)
          if (!o || !i.consumable.test(o, { name: true })) {
            return
          }
          i.consumable.consume(n.viewItem, { name: true, classes: 'image' })
          const r = i.convertItem(o, n.modelCursor)
          const s = cl(r.modelRange.getItems())
          if (!s) {
            i.consumable.revert(n.viewItem, { name: true, classes: 'image' })
            return
          }
          i.convertChildren(n.viewItem, s)
          i.updateConversionResult(s, n)
        }
      }
      function NI(t) {
        const e = ['srcset', 'media', 'type', 'sizes']
        return (t) => {
          t.on('element:picture', n)
        }
        function n(n, i, o) {
          const r = i.viewItem
          if (!o.consumable.test(r, { name: true })) {
            return
          }
          const s = new Map()
          for (const t of r.getChildren()) {
            if (t.is('element', 'source')) {
              const n = {}
              for (const i of e) {
                if (t.hasAttribute(i)) {
                  if (o.consumable.test(t, { attributes: i })) {
                    n[i] = t.getAttribute(i)
                  }
                }
              }
              if (Object.keys(n).length) {
                s.set(t, n)
              }
            }
          }
          const a = t.findViewImgElement(r)
          if (!a) {
            return
          }
          let c = i.modelCursor.parent
          if (!c.is('element', 'imageBlock')) {
            const t = o.convertItem(a, i.modelCursor)
            i.modelRange = t.modelRange
            i.modelCursor = t.modelCursor
            c = cl(t.modelRange.getItems())
          }
          o.consumable.consume(r, { name: true })
          for (const [t, e] of s) {
            o.consumable.consume(t, { attributes: Object.keys(e) })
          }
          if (s.size) {
            o.writer.setAttribute('sources', Array.from(s.values()), c)
          }
          o.convertChildren(r, c)
        }
      }
      function PI(t, e) {
        return (t) => {
          t.on(`attribute:srcset:${e}`, n)
        }
        function n(e, n, i) {
          if (!i.consumable.consume(n.item, e.name)) {
            return
          }
          const o = i.writer
          const r = i.mapper.toViewElement(n.item)
          const s = t.findViewImgElement(r)
          if (n.attributeNewValue === null) {
            const t = n.attributeOldValue
            if (t.data) {
              o.removeAttribute('srcset', s)
              o.removeAttribute('sizes', s)
              if (t.width) {
                o.removeAttribute('width', s)
              }
            }
          } else {
            const t = n.attributeNewValue
            if (t.data) {
              o.setAttribute('srcset', t.data, s)
              o.setAttribute('sizes', '100vw', s)
              if (t.width) {
                o.setAttribute('width', t.width, s)
              }
            }
          }
        }
      }
      function zI(t) {
        return (t) => {
          t.on('attribute:sources:imageBlock', e)
          t.on('attribute:sources:imageInline', e)
        }
        function e(e, n, i) {
          if (!i.consumable.consume(n.item, e.name)) {
            return
          }
          const o = i.writer
          const r = i.mapper.toViewElement(n.item)
          const s = t.findViewImgElement(r)
          if (n.attributeNewValue && n.attributeNewValue.length) {
            const t = o.createContainerElement(
              'picture',
              null,
              n.attributeNewValue.map((t) => o.createEmptyElement('source', t))
            )
            const e = []
            let i = s.parent
            while (i && i.is('attributeElement')) {
              const t = i.parent
              o.unwrap(o.createRangeOn(s), i)
              e.unshift(i)
              i = t
            }
            o.insert(o.createPositionBefore(s), t)
            o.move(o.createRangeOn(s), o.createPositionAt(t, 'end'))
            for (const n of e) {
              o.wrap(o.createRangeOn(t), n)
            }
          } else if (s.parent.is('element', 'picture')) {
            const t = s.parent
            o.move(o.createRangeOn(s), o.createPositionBefore(t))
            o.remove(t)
          }
        }
      }
      function LI(t, e, n) {
        return (t) => {
          t.on(`attribute:${n}:${e}`, i)
        }
        function i(e, n, i) {
          if (!i.consumable.consume(n.item, e.name)) {
            return
          }
          const o = i.writer
          const r = i.mapper.toViewElement(n.item)
          const s = t.findViewImgElement(r)
          o.setAttribute(n.attributeKey, n.attributeNewValue || '', s)
        }
      }
      class OI extends Xm {
        observe(t) {
          this.listenTo(
            t,
            'load',
            (t, e) => {
              const n = e.target
              if (this.checkShouldIgnoreEventFromTarget(n)) {
                return
              }
              if (n.tagName == 'IMG') {
                this._fireEvents(e)
              }
            },
            { useCapture: true }
          )
        }
        _fireEvents(t) {
          if (this.isEnabled) {
            this.document.fire('layoutChanged')
            this.document.fire('imageLoaded', t)
          }
        }
      }
      class RI extends Zd {
        constructor(t) {
          super(t)
          const e = t.config.get('image.insert.type')
          if (!t.plugins.has('ImageBlockEditing')) {
            if (e === 'block') {
              P('image-block-plugin-required')
            }
          }
          if (!t.plugins.has('ImageInlineEditing')) {
            if (e === 'inline') {
              P('image-inline-plugin-required')
            }
          }
        }
        refresh() {
          this.isEnabled = this.editor.plugins
            .get('ImageUtils')
            .isImageAllowed()
        }
        execute(t) {
          const e = Zc(t.source)
          const n = this.editor.model.document.selection
          const i = this.editor.plugins.get('ImageUtils')
          const o = Object.fromEntries(n.getAttributes())
          e.forEach((t, e) => {
            const r = n.getSelectedElement()
            if (typeof t === 'string') {
              t = { src: t }
            }
            if (e && r && i.isImage(r)) {
              const e = this.editor.model.createPositionAfter(r)
              i.insertImage({ ...t, ...o }, e)
            } else {
              i.insertImage({ ...t, ...o })
            }
          })
        }
      }
      class jI extends Zd {
        refresh() {
          const t = this.editor
          const e = t.plugins.get('ImageUtils')
          const n = this.editor.model.document.selection.getSelectedElement()
          this.isEnabled = e.isImage(n)
          this.value = this.isEnabled ? n.getAttribute('src') : null
        }
        execute(t) {
          const e = this.editor.model.document.selection.getSelectedElement()
          this.editor.model.change((n) => {
            n.setAttribute('src', t.source, e)
            n.removeAttribute('srcset', e)
            n.removeAttribute('sizes', e)
          })
        }
      }
      class FI extends Kd {
        static get requires() {
          return [fI]
        }
        static get pluginName() {
          return 'ImageEditing'
        }
        init() {
          const t = this.editor
          const e = t.conversion
          t.editing.view.addObserver(OI)
          e.for('upcast')
            .attributeToAttribute({
              view: { name: 'img', key: 'alt' },
              model: 'alt'
            })
            .attributeToAttribute({
              view: { name: 'img', key: 'srcset' },
              model: {
                key: 'srcset',
                value: (t) => {
                  const e = { data: t.getAttribute('srcset') }
                  if (t.hasAttribute('width')) {
                    e.width = t.getAttribute('width')
                  }
                  return e
                }
              }
            })
          const n = new RI(t)
          const i = new jI(t)
          t.commands.add('insertImage', n)
          t.commands.add('replaceImageSource', i)
          t.commands.add('imageInsert', n)
        }
      }
      class VI extends Zd {
        constructor(t, e) {
          super(t)
          this._modelElementName = e
        }
        refresh() {
          const t = this.editor
          const e = t.plugins.get('ImageUtils')
          const n = e.getClosestSelectedImageElement(
            this.editor.model.document.selection
          )
          if (this._modelElementName === 'imageBlock') {
            this.isEnabled = e.isInlineImage(n)
          } else {
            this.isEnabled = e.isBlockImage(n)
          }
        }
        execute() {
          const t = this.editor
          const e = this.editor.model
          const n = t.plugins.get('ImageUtils')
          const i = n.getClosestSelectedImageElement(e.document.selection)
          const o = Object.fromEntries(i.getAttributes())
          if (!o.src && !o.uploadId) {
            return null
          }
          return e.change((t) => {
            const r = Array.from(e.markers).filter((t) =>
              t.getRange().containsItem(i)
            )
            const s = n.insertImage(
              o,
              e.createSelection(i, 'on'),
              this._modelElementName
            )
            if (!s) {
              return null
            }
            const a = t.createRangeOn(s)
            for (const e of r) {
              const n = e.getRange()
              const i =
                n.root.rootName != '$graveyard' ? n.getJoined(a, true) : a
              t.updateMarker(e, { range: i })
            }
            return { oldElement: i, newElement: s }
          })
        }
      }
      class HI extends Kd {
        static get requires() {
          return [FI, fI, UD]
        }
        static get pluginName() {
          return 'ImageBlockEditing'
        }
        init() {
          const t = this.editor
          const e = t.model.schema
          e.register('imageBlock', {
            inheritAllFrom: '$blockObject',
            allowAttributes: ['alt', 'src', 'srcset']
          })
          this._setupConversion()
          if (t.plugins.has('ImageInlineEditing')) {
            t.commands.add('imageTypeBlock', new VI(this.editor, 'imageBlock'))
            this._setupClipboardIntegration()
          }
        }
        _setupConversion() {
          const t = this.editor
          const e = t.t
          const n = t.conversion
          const i = t.plugins.get('ImageUtils')
          n.for('dataDowncast').elementToStructure({
            model: 'imageBlock',
            view: (t, { writer: e }) => dI(e)
          })
          n.for('editingDowncast').elementToStructure({
            model: 'imageBlock',
            view: (t, { writer: n }) =>
              i.toImageWidget(dI(n), n, e('image widget'))
          })
          n.for('downcast')
            .add(LI(i, 'imageBlock', 'src'))
            .add(LI(i, 'imageBlock', 'alt'))
            .add(PI(i, 'imageBlock'))
          n.for('upcast')
            .elementToElement({
              view: uI(t, 'imageBlock'),
              model: (t, { writer: e }) =>
                e.createElement(
                  'imageBlock',
                  t.hasAttribute('src') ? { src: t.getAttribute('src') } : null
                )
            })
            .add(BI(i))
        }
        _setupClipboardIntegration() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          const i = t.plugins.get('ImageUtils')
          this.listenTo(
            t.plugins.get('ClipboardPipeline'),
            'inputTransformation',
            (o, r) => {
              const s = Array.from(r.content.getChildren())
              let a
              if (!s.every(i.isInlineImageView)) {
                return
              }
              if (r.targetRanges) {
                a = t.editing.mapper.toModelRange(r.targetRanges[0])
              } else {
                a = e.document.selection.getFirstRange()
              }
              const c = e.createSelection(a)
              if (hI(e.schema, c) === 'imageBlock') {
                const t = new hA(n.document)
                const e = s.map((e) =>
                  t.createElement('figure', { class: 'image' }, e)
                )
                r.content = t.createDocumentFragment(e)
              }
            }
          )
        }
      }
      var UI = __webpack_require__(9048)
      var WI = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      WI.insert = 'head'
      WI.singleton = true
      var qI = El()(UI.Z, WI)
      const $I = UI.Z.locals || {}
      class GI extends Kd {
        static get requires() {
          return [HI, RT, SI]
        }
        static get pluginName() {
          return 'ImageBlock'
        }
      }
      class YI extends Kd {
        static get requires() {
          return [FI, fI, UD]
        }
        static get pluginName() {
          return 'ImageInlineEditing'
        }
        init() {
          const t = this.editor
          const e = t.model.schema
          e.register('imageInline', {
            inheritAllFrom: '$inlineObject',
            allowAttributes: ['alt', 'src', 'srcset']
          })
          e.addChildCheck((t, e) => {
            if (t.endsWith('caption') && e.name === 'imageInline') {
              return false
            }
          })
          this._setupConversion()
          if (t.plugins.has('ImageBlockEditing')) {
            t.commands.add(
              'imageTypeInline',
              new VI(this.editor, 'imageInline')
            )
            this._setupClipboardIntegration()
          }
        }
        _setupConversion() {
          const t = this.editor
          const e = t.t
          const n = t.conversion
          const i = t.plugins.get('ImageUtils')
          n.for('dataDowncast').elementToElement({
            model: 'imageInline',
            view: (t, { writer: e }) => e.createEmptyElement('img')
          })
          n.for('editingDowncast').elementToStructure({
            model: 'imageInline',
            view: (t, { writer: n }) =>
              i.toImageWidget(lI(n), n, e('image widget'))
          })
          n.for('downcast')
            .add(LI(i, 'imageInline', 'src'))
            .add(LI(i, 'imageInline', 'alt'))
            .add(PI(i, 'imageInline'))
          n.for('upcast').elementToElement({
            view: uI(t, 'imageInline'),
            model: (t, { writer: e }) =>
              e.createElement(
                'imageInline',
                t.hasAttribute('src') ? { src: t.getAttribute('src') } : null
              )
          })
        }
        _setupClipboardIntegration() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          const i = t.plugins.get('ImageUtils')
          this.listenTo(
            t.plugins.get('ClipboardPipeline'),
            'inputTransformation',
            (o, r) => {
              const s = Array.from(r.content.getChildren())
              let a
              if (!s.every(i.isBlockImageView)) {
                return
              }
              if (r.targetRanges) {
                a = t.editing.mapper.toModelRange(r.targetRanges[0])
              } else {
                a = e.document.selection.getFirstRange()
              }
              const c = e.createSelection(a)
              if (hI(e.schema, c) === 'imageInline') {
                const t = new hA(n.document)
                const e = s.map((e) => {
                  if (e.childCount === 1) {
                    Array.from(e.getAttributes()).forEach((n) =>
                      t.setAttribute(...n, i.findViewImgElement(e))
                    )
                    return e.getChild(0)
                  } else {
                    return e
                  }
                })
                r.content = t.createDocumentFragment(e)
              }
            }
          )
        }
      }
      class KI extends Kd {
        static get requires() {
          return [YI, RT, SI]
        }
        static get pluginName() {
          return 'ImageInline'
        }
      }
      class QI extends Kd {
        static get requires() {
          return [GI, KI]
        }
        static get pluginName() {
          return 'Image'
        }
      }
      class ZI extends Zd {
        refresh() {
          const t = this.editor
          const e = t.plugins.get('ImageCaptionUtils')
          if (!t.plugins.has(HI)) {
            this.isEnabled = false
            this.value = false
            return
          }
          const n = t.model.document.selection
          const i = n.getSelectedElement()
          if (!i) {
            const t = e.getCaptionFromModelSelection(n)
            this.isEnabled = !!t
            this.value = !!t
            return
          }
          this.isEnabled = this.editor.plugins.get('ImageUtils').isImage(i)
          if (!this.isEnabled) {
            this.value = false
          } else {
            this.value = !!e.getCaptionFromImageModelElement(i)
          }
        }
        execute(t = {}) {
          const { focusCaptionOnShow: e } = t
          this.editor.model.change((t) => {
            if (this.value) {
              this._hideImageCaption(t)
            } else {
              this._showImageCaption(t, e)
            }
          })
        }
        _showImageCaption(t, e) {
          const n = this.editor.model
          const i = n.document.selection
          const o = this.editor.plugins.get('ImageCaptionEditing')
          let r = i.getSelectedElement()
          const s = o._getSavedCaption(r)
          if (this.editor.plugins.get('ImageUtils').isInlineImage(r)) {
            this.editor.execute('imageTypeBlock')
            r = i.getSelectedElement()
          }
          const a = s || t.createElement('caption')
          t.append(a, r)
          if (e) {
            t.setSelection(a, 'in')
          }
        }
        _hideImageCaption(t) {
          const e = this.editor
          const n = e.model.document.selection
          const i = e.plugins.get('ImageCaptionEditing')
          const o = e.plugins.get('ImageCaptionUtils')
          let r = n.getSelectedElement()
          let s
          if (r) {
            s = o.getCaptionFromImageModelElement(r)
          } else {
            s = o.getCaptionFromModelSelection(n)
            r = s.parent
          }
          i._saveCaption(r, s)
          t.setSelection(r, 'on')
          t.remove(s)
        }
      }
      class JI extends Kd {
        static get pluginName() {
          return 'ImageCaptionUtils'
        }
        static get requires() {
          return [fI]
        }
        getCaptionFromImageModelElement(t) {
          for (const e of t.getChildren()) {
            if (!!e && e.is('element', 'caption')) {
              return e
            }
          }
          return null
        }
        getCaptionFromModelSelection(t) {
          const e = this.editor.plugins.get('ImageUtils')
          const n = t.getFirstPosition().findAncestor('caption')
          if (!n) {
            return null
          }
          if (e.isBlockImage(n.parent)) {
            return n
          }
          return null
        }
        matchImageCaptionViewElement(t) {
          const e = this.editor.plugins.get('ImageUtils')
          if (t.name == 'figcaption' && e.isBlockImageView(t.parent)) {
            return { name: true }
          }
          return null
        }
      }
      class XI extends Kd {
        static get requires() {
          return [fI, JI]
        }
        static get pluginName() {
          return 'ImageCaptionEditing'
        }
        constructor(t) {
          super(t)
          this._savedCaptionsMap = new WeakMap()
        }
        init() {
          const t = this.editor
          const e = t.model.schema
          if (!e.isRegistered('caption')) {
            e.register('caption', {
              allowIn: 'imageBlock',
              allowContentOf: '$block',
              isLimit: true
            })
          } else {
            e.extend('caption', { allowIn: 'imageBlock' })
          }
          t.commands.add('toggleImageCaption', new ZI(this.editor))
          this._setupConversion()
          this._setupImageTypeCommandsIntegration()
          this._registerCaptionReconversion()
        }
        _setupConversion() {
          const t = this.editor
          const e = t.editing.view
          const n = t.plugins.get('ImageUtils')
          const i = t.plugins.get('ImageCaptionUtils')
          const o = t.t
          t.conversion
            .for('upcast')
            .elementToElement({
              view: (t) => i.matchImageCaptionViewElement(t),
              model: 'caption'
            })
          t.conversion.for('dataDowncast').elementToElement({
            model: 'caption',
            view: (t, { writer: e }) => {
              if (!n.isBlockImage(t.parent)) {
                return null
              }
              return e.createContainerElement('figcaption')
            }
          })
          t.conversion.for('editingDowncast').elementToElement({
            model: 'caption',
            view: (t, { writer: i }) => {
              if (!n.isBlockImage(t.parent)) {
                return null
              }
              const r = i.createEditableElement('figcaption')
              i.setCustomProperty('imageCaption', true, r)
              cu({
                view: e,
                element: r,
                text: o('Enter image caption'),
                keepOnFocus: true
              })
              const s = t.parent.getAttribute('alt')
              const a = s
                ? o('Caption for image: %0', [s])
                : o('Caption for the image')
              return oT(r, i, { label: a })
            }
          })
        }
        _setupImageTypeCommandsIntegration() {
          const t = this.editor
          const e = t.plugins.get('ImageUtils')
          const n = t.plugins.get('ImageCaptionUtils')
          const i = t.commands.get('imageTypeInline')
          const o = t.commands.get('imageTypeBlock')
          const r = (t) => {
            if (!t.return) {
              return
            }
            const { oldElement: i, newElement: o } = t.return
            if (!i) {
              return
            }
            if (e.isBlockImage(i)) {
              const t = n.getCaptionFromImageModelElement(i)
              if (t) {
                this._saveCaption(o, t)
                return
              }
            }
            const r = this._getSavedCaption(i)
            if (r) {
              this._saveCaption(o, r)
            }
          }
          if (i) {
            this.listenTo(i, 'execute', r, { priority: 'low' })
          }
          if (o) {
            this.listenTo(o, 'execute', r, { priority: 'low' })
          }
        }
        _getSavedCaption(t) {
          const e = this._savedCaptionsMap.get(t)
          return e ? Vp.fromJSON(e) : null
        }
        _saveCaption(t, e) {
          this._savedCaptionsMap.set(t, e.toJSON())
        }
        _registerCaptionReconversion() {
          const t = this.editor
          const e = t.model
          const n = t.plugins.get('ImageUtils')
          const i = t.plugins.get('ImageCaptionUtils')
          e.document.on('change:data', () => {
            const o = e.document.differ.getChanges()
            for (const e of o) {
              if (e.attributeKey !== 'alt') {
                continue
              }
              const o = e.range.start.nodeAfter
              if (n.isBlockImage(o)) {
                const e = i.getCaptionFromImageModelElement(o)
                if (!e) {
                  return
                }
                t.editing.reconvertItem(e)
              }
            }
          })
        }
      }
      class tS extends Kd {
        static get requires() {
          return [JI]
        }
        static get pluginName() {
          return 'ImageCaptionUI'
        }
        init() {
          const t = this.editor
          const e = t.editing.view
          const n = t.plugins.get('ImageCaptionUtils')
          const i = t.t
          t.ui.componentFactory.add('toggleImageCaption', (o) => {
            const r = t.commands.get('toggleImageCaption')
            const s = new pd(o)
            s.set({ icon: $v.caption, tooltip: true, isToggleable: true })
            s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled')
            s.bind('label').to(r, 'value', (t) =>
              t ? i('Toggle caption off') : i('Toggle caption on')
            )
            this.listenTo(s, 'execute', () => {
              t.execute('toggleImageCaption', { focusCaptionOnShow: true })
              const i = n.getCaptionFromModelSelection(
                t.model.document.selection
              )
              if (i) {
                const n = t.editing.mapper.toViewElement(i)
                e.scrollToTheSelection()
                e.change((t) => {
                  t.addClass('image__caption_highlighted', n)
                })
              }
              t.editing.view.focus()
            })
            return s
          })
        }
      }
      var eS = __webpack_require__(8662)
      var nS = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      nS.insert = 'head'
      nS.singleton = true
      var iS = El()(eS.Z, nS)
      const oS = eS.Z.locals || {}
      class rS extends Kd {
        static get requires() {
          return [XI, tS]
        }
        static get pluginName() {
          return 'ImageCaption'
        }
      }
      class sS extends Zd {
        constructor(t, e) {
          super(t)
          this._defaultStyles = { imageBlock: false, imageInline: false }
          this._styles = new Map(
            e.map((t) => {
              if (t.isDefault) {
                for (const e of t.modelElements) {
                  this._defaultStyles[e] = t.name
                }
              }
              return [t.name, t]
            })
          )
        }
        refresh() {
          const t = this.editor
          const e = t.plugins.get('ImageUtils')
          const n = e.getClosestSelectedImageElement(
            this.editor.model.document.selection
          )
          this.isEnabled = !!n
          if (!this.isEnabled) {
            this.value = false
          } else if (n.hasAttribute('imageStyle')) {
            this.value = n.getAttribute('imageStyle')
          } else {
            this.value = this._defaultStyles[n.name]
          }
        }
        execute(t = {}) {
          const e = this.editor
          const n = e.model
          const i = e.plugins.get('ImageUtils')
          n.change((e) => {
            const o = t.value
            let r = i.getClosestSelectedImageElement(n.document.selection)
            if (o && this.shouldConvertImageType(o, r)) {
              this.editor.execute(
                i.isBlockImage(r) ? 'imageTypeInline' : 'imageTypeBlock'
              )
              r = i.getClosestSelectedImageElement(n.document.selection)
            }
            if (!o || this._styles.get(o).isDefault) {
              e.removeAttribute('imageStyle', r)
            } else {
              e.setAttribute('imageStyle', o, r)
            }
          })
        }
        shouldConvertImageType(t, e) {
          const n = this._styles.get(t).modelElements
          return !n.includes(e.name)
        }
      }
      const {
        objectFullWidth: aS,
        objectInline: cS,
        objectLeft: lS,
        objectRight: dS,
        objectCenter: uS,
        objectBlockLeft: hS,
        objectBlockRight: fS
      } = $v
      const mS = {
        get inline() {
          return {
            name: 'inline',
            title: 'In line',
            icon: cS,
            modelElements: ['imageInline'],
            isDefault: true
          }
        },
        get alignLeft() {
          return {
            name: 'alignLeft',
            title: 'Left aligned image',
            icon: lS,
            modelElements: ['imageBlock', 'imageInline'],
            className: 'image-style-align-left'
          }
        },
        get alignBlockLeft() {
          return {
            name: 'alignBlockLeft',
            title: 'Left aligned image',
            icon: hS,
            modelElements: ['imageBlock'],
            className: 'image-style-block-align-left'
          }
        },
        get alignCenter() {
          return {
            name: 'alignCenter',
            title: 'Centered image',
            icon: uS,
            modelElements: ['imageBlock'],
            className: 'image-style-align-center'
          }
        },
        get alignRight() {
          return {
            name: 'alignRight',
            title: 'Right aligned image',
            icon: dS,
            modelElements: ['imageBlock', 'imageInline'],
            className: 'image-style-align-right'
          }
        },
        get alignBlockRight() {
          return {
            name: 'alignBlockRight',
            title: 'Right aligned image',
            icon: fS,
            modelElements: ['imageBlock'],
            className: 'image-style-block-align-right'
          }
        },
        get block() {
          return {
            name: 'block',
            title: 'Centered image',
            icon: uS,
            modelElements: ['imageBlock'],
            isDefault: true
          }
        },
        get side() {
          return {
            name: 'side',
            title: 'Side image',
            icon: dS,
            modelElements: ['imageBlock'],
            className: 'image-style-side'
          }
        }
      }
      const gS = {
        full: aS,
        left: hS,
        right: fS,
        center: uS,
        inlineLeft: lS,
        inlineRight: dS,
        inline: cS
      }
      const pS = [
        {
          name: 'imageStyle:wrapText',
          title: 'Wrap text',
          defaultItem: 'imageStyle:alignLeft',
          items: ['imageStyle:alignLeft', 'imageStyle:alignRight']
        },
        {
          name: 'imageStyle:breakText',
          title: 'Break text',
          defaultItem: 'imageStyle:block',
          items: [
            'imageStyle:alignBlockLeft',
            'imageStyle:block',
            'imageStyle:alignBlockRight'
          ]
        }
      ]
      function bS(t) {
        const e = t.configuredStyles.options || []
        const n = e.map((t) => _S(t)).filter((e) => AS(e, t))
        return n
      }
      function kS(t, e) {
        if (t && e) {
          return {
            options: [
              'inline',
              'alignLeft',
              'alignRight',
              'alignCenter',
              'alignBlockLeft',
              'alignBlockRight',
              'block',
              'side'
            ]
          }
        } else if (t) {
          return { options: ['block', 'side'] }
        } else if (e) {
          return { options: ['inline', 'alignLeft', 'alignRight'] }
        }
        return {}
      }
      function wS(t) {
        if (t.has('ImageBlockEditing') && t.has('ImageInlineEditing')) {
          return [...pS]
        } else {
          return []
        }
      }
      function _S(t) {
        if (typeof t === 'string') {
          if (!mS[t]) {
            t = { name: t }
          } else {
            t = { ...mS[t] }
          }
        } else {
          t = vS(mS[t.name], t)
        }
        if (typeof t.icon === 'string') {
          t.icon = gS[t.icon] || t.icon
        }
        return t
      }
      function AS(t, { isBlockPluginLoaded: e, isInlinePluginLoaded: n }) {
        const { modelElements: i, name: o } = t
        if (!i || !i.length || !o) {
          CS({ style: t })
          return false
        } else {
          const o = [e ? 'imageBlock' : null, n ? 'imageInline' : null]
          if (!i.some((t) => o.includes(t))) {
            P('image-style-missing-dependency', {
              style: t,
              missingPlugins: i.map((t) =>
                t === 'imageBlock' ? 'ImageBlockEditing' : 'ImageInlineEditing'
              )
            })
            return false
          }
        }
        return true
      }
      function vS(t, e) {
        const n = { ...e }
        for (const i in t) {
          if (!Object.prototype.hasOwnProperty.call(e, i)) {
            n[i] = t[i]
          }
        }
        return n
      }
      function CS(t) {
        P('image-style-configuration-definition-invalid', t)
      }
      const yS = {
        normalizeStyles: bS,
        getDefaultStylesConfiguration: kS,
        getDefaultDropdownDefinitions: wS,
        warnInvalidStyle: CS,
        DEFAULT_OPTIONS: mS,
        DEFAULT_ICONS: gS,
        DEFAULT_DROPDOWN_DEFINITIONS: pS
      }
      function xS(t) {
        return (e, n, i) => {
          if (!i.consumable.consume(n.item, e.name)) {
            return
          }
          const o = DS(n.attributeNewValue, t)
          const r = DS(n.attributeOldValue, t)
          const s = i.mapper.toViewElement(n.item)
          const a = i.writer
          if (r) {
            a.removeClass(r.className, s)
          }
          if (o) {
            a.addClass(o.className, s)
          }
        }
      }
      function ES(t) {
        const e = {
          imageInline: t.filter(
            (t) => !t.isDefault && t.modelElements.includes('imageInline')
          ),
          imageBlock: t.filter(
            (t) => !t.isDefault && t.modelElements.includes('imageBlock')
          )
        }
        return (t, n, i) => {
          if (!n.modelRange) {
            return
          }
          const o = n.viewItem
          const r = cl(n.modelRange.getItems())
          if (!r) {
            return
          }
          if (!i.schema.checkAttribute(r, 'imageStyle')) {
            return
          }
          for (const t of e[r.name]) {
            if (i.consumable.consume(o, { classes: t.className })) {
              i.writer.setAttribute('imageStyle', t.name, r)
            }
          }
        }
      }
      function DS(t, e) {
        for (const n of e) {
          if (n.name === t) {
            return n
          }
        }
      }
      class TS extends Kd {
        static get pluginName() {
          return 'ImageStyleEditing'
        }
        static get requires() {
          return [fI]
        }
        init() {
          const { normalizeStyles: t, getDefaultStylesConfiguration: e } = yS
          const n = this.editor
          const i = n.plugins.has('ImageBlockEditing')
          const o = n.plugins.has('ImageInlineEditing')
          n.config.define('image.styles', e(i, o))
          this.normalizedStyles = t({
            configuredStyles: n.config.get('image.styles'),
            isBlockPluginLoaded: i,
            isInlinePluginLoaded: o
          })
          this._setupConversion(i, o)
          this._setupPostFixer()
          n.commands.add('imageStyle', new sS(n, this.normalizedStyles))
        }
        _setupConversion(t, e) {
          const n = this.editor
          const i = n.model.schema
          const o = xS(this.normalizedStyles)
          const r = ES(this.normalizedStyles)
          n.editing.downcastDispatcher.on('attribute:imageStyle', o)
          n.data.downcastDispatcher.on('attribute:imageStyle', o)
          if (t) {
            i.extend('imageBlock', { allowAttributes: 'imageStyle' })
            n.data.upcastDispatcher.on('element:figure', r, { priority: 'low' })
          }
          if (e) {
            i.extend('imageInline', { allowAttributes: 'imageStyle' })
            n.data.upcastDispatcher.on('element:img', r, { priority: 'low' })
          }
        }
        _setupPostFixer() {
          const t = this.editor
          const e = t.model.document
          const n = t.plugins.get(fI)
          const i = new Map(this.normalizedStyles.map((t) => [t.name, t]))
          e.registerPostFixer((t) => {
            let o = false
            for (const r of e.differ.getChanges()) {
              if (
                r.type == 'insert' ||
                (r.type == 'attribute' && r.attributeKey == 'imageStyle')
              ) {
                let e =
                  r.type == 'insert'
                    ? r.position.nodeAfter
                    : r.range.start.nodeAfter
                if (e && e.is('element', 'paragraph') && e.childCount > 0) {
                  e = e.getChild(0)
                }
                if (!n.isImage(e)) {
                  continue
                }
                const s = e.getAttribute('imageStyle')
                if (!s) {
                  continue
                }
                const a = i.get(s)
                if (!a || !a.modelElements.includes(e.name)) {
                  t.removeAttribute('imageStyle', e)
                  o = true
                }
              }
            }
            return o
          })
        }
      }
      var MS = __webpack_require__(4622)
      var IS = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      IS.insert = 'head'
      IS.singleton = true
      var SS = El()(MS.Z, IS)
      const BS = MS.Z.locals || {}
      class NS extends Kd {
        static get requires() {
          return [TS]
        }
        static get pluginName() {
          return 'ImageStyleUI'
        }
        get localizedDefaultStylesTitles() {
          const t = this.editor.t
          return {
            'Wrap text': t('Wrap text'),
            'Break text': t('Break text'),
            'In line': t('In line'),
            'Full size image': t('Full size image'),
            'Side image': t('Side image'),
            'Left aligned image': t('Left aligned image'),
            'Centered image': t('Centered image'),
            'Right aligned image': t('Right aligned image')
          }
        }
        init() {
          const t = this.editor.plugins
          const e = this.editor.config.get('image.toolbar') || []
          const n = PS(
            t.get('ImageStyleEditing').normalizedStyles,
            this.localizedDefaultStylesTitles
          )
          for (const t of n) {
            this._createButton(t)
          }
          const i = PS(
            [...e.filter(rt), ...yS.getDefaultDropdownDefinitions(t)],
            this.localizedDefaultStylesTitles
          )
          for (const t of i) {
            this._createDropdown(t, n)
          }
        }
        _createDropdown(t, e) {
          const n = this.editor.ui.componentFactory
          n.add(t.name, (i) => {
            let o
            const { defaultItem: r, items: s, title: a } = t
            const c = s
              .filter((t) => e.find(({ name: e }) => zS(e) === t))
              .map((t) => {
                const e = n.create(t)
                if (t === r) {
                  o = e
                }
                return e
              })
            if (s.length !== c.length) {
              yS.warnInvalidStyle({ dropdown: t })
            }
            const l = kC(i, Vd)
            const d = l.buttonView
            const u = d.arrowView
            wC(l, c, { enableActiveItemFocusOnDropdownOpen: true })
            d.set({ label: LS(a, o.label), class: null, tooltip: true })
            u.unbind('label')
            u.set({ label: a })
            d.bind('icon').toMany(c, 'isOn', (...t) => {
              const e = t.findIndex(Vh)
              return e < 0 ? o.icon : c[e].icon
            })
            d.bind('label').toMany(c, 'isOn', (...t) => {
              const e = t.findIndex(Vh)
              return LS(a, e < 0 ? o.label : c[e].label)
            })
            d.bind('isOn').toMany(c, 'isOn', (...t) => t.some(Vh))
            d.bind('class').toMany(c, 'isOn', (...t) =>
              t.some(Vh) ? 'ck-splitbutton_flatten' : null
            )
            d.on('execute', () => {
              if (!c.some(({ isOn: t }) => t)) {
                o.fire('execute')
              } else {
                l.isOpen = !l.isOpen
              }
            })
            l.bind('isEnabled').toMany(c, 'isEnabled', (...t) => t.some(Vh))
            this.listenTo(l, 'execute', () => {
              this.editor.editing.view.focus()
            })
            return l
          })
        }
        _createButton(t) {
          const e = t.name
          this.editor.ui.componentFactory.add(zS(e), (n) => {
            const i = this.editor.commands.get('imageStyle')
            const o = new pd(n)
            o.set({
              label: t.title,
              icon: t.icon,
              tooltip: true,
              isToggleable: true
            })
            o.bind('isEnabled').to(i, 'isEnabled')
            o.bind('isOn').to(i, 'value', (t) => t === e)
            o.on('execute', this._executeCommand.bind(this, e))
            return o
          })
        }
        _executeCommand(t) {
          this.editor.execute('imageStyle', { value: t })
          this.editor.editing.view.focus()
        }
      }
      function PS(t, e) {
        for (const n of t) {
          if (e[n.title]) {
            n.title = e[n.title]
          }
        }
        return t
      }
      function zS(t) {
        return `imageStyle:${t}`
      }
      function LS(t, e) {
        return (t ? t + ': ' : '') + e
      }
      class OS extends Kd {
        static get requires() {
          return [TS, NS]
        }
        static get pluginName() {
          return 'ImageStyle'
        }
      }
      class RS extends Kd {
        static get requires() {
          return [VT, fI]
        }
        static get pluginName() {
          return 'ImageToolbar'
        }
        afterInit() {
          const t = this.editor
          const e = t.t
          const n = t.plugins.get(VT)
          const i = t.plugins.get('ImageUtils')
          n.register('image', {
            ariaLabel: e('Image toolbar'),
            items: jS(t.config.get('image.toolbar') || []),
            getRelatedElement: (t) => i.getClosestSelectedImageWidget(t)
          })
        }
      }
      function jS(t) {
        return t.map((t) => (rt(t) ? t.name : t))
      }
      function FS(t) {
        const e = t.map((t) => t.replace('+', '\\+'))
        return new RegExp(`^image\\/(${e.join('|')})$`)
      }
      function VS(t) {
        return new Promise((e, n) => {
          const i = t.getAttribute('src')
          fetch(i)
            .then((t) => t.blob())
            .then((t) => {
              const n = US(t, i)
              const o = n.replace('image/', '')
              const r = `image.${o}`
              const s = new File([t], r, { type: n })
              e(s)
            })
            .catch((t) =>
              t && t.name === 'TypeError' ? WS(i).then(e).catch(n) : n(t)
            )
        })
      }
      function HS(t, e) {
        if (!t.isInlineImageView(e) || !e.getAttribute('src')) {
          return false
        }
        return (
          e.getAttribute('src').match(/^data:image\/\w+;base64,/g) ||
          e.getAttribute('src').match(/^blob:/g)
        )
      }
      function US(t, e) {
        if (t.type) {
          return t.type
        } else if (e.match(/data:(image\/\w+);base64/)) {
          return e.match(/data:(image\/\w+);base64/)[1].toLowerCase()
        } else {
          return 'image/jpeg'
        }
      }
      function WS(t) {
        return qS(t).then((e) => {
          const n = US(e, t)
          const i = n.replace('image/', '')
          const o = `image.${i}`
          return new File([e], o, { type: n })
        })
      }
      function qS(t) {
        return new Promise((e, n) => {
          const i = ec.document.createElement('img')
          i.addEventListener('load', () => {
            const t = ec.document.createElement('canvas')
            t.width = i.width
            t.height = i.height
            const o = t.getContext('2d')
            o.drawImage(i, 0, 0)
            t.toBlob((t) => (t ? e(t) : n()))
          })
          i.addEventListener('error', () => n())
          i.src = t
        })
      }
      class $S extends Kd {
        static get pluginName() {
          return 'ImageUploadUI'
        }
        init() {
          const t = this.editor
          const e = t.t
          const n = (n) => {
            const i = new lD(n)
            const o = t.commands.get('uploadImage')
            const r = t.config.get('image.upload.types')
            const s = FS(r)
            i.set({
              acceptedType: r.map((t) => `image/${t}`).join(','),
              allowMultipleFiles: true
            })
            i.buttonView.set({
              label: e('Insert image'),
              icon: $v.image,
              tooltip: true
            })
            i.buttonView.bind('isEnabled').to(o)
            i.on('done', (e, n) => {
              const i = Array.from(n).filter((t) => s.test(t.type))
              if (i.length) {
                t.execute('uploadImage', { file: i })
                t.editing.view.focus()
              }
            })
            return i
          }
          t.ui.componentFactory.add('uploadImage', n)
          t.ui.componentFactory.add('imageUpload', n)
        }
      }
      var GS = __webpack_require__(5870)
      var YS = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      YS.insert = 'head'
      YS.singleton = true
      var KS = El()(GS.Z, YS)
      const QS = GS.Z.locals || {}
      var ZS = __webpack_require__(9899)
      var JS = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      JS.insert = 'head'
      JS.singleton = true
      var XS = El()(ZS.Z, JS)
      const tB = ZS.Z.locals || {}
      var eB = __webpack_require__(9825)
      var nB = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      nB.insert = 'head'
      nB.singleton = true
      var iB = El()(eB.Z, nB)
      const oB = eB.Z.locals || {}
      class rB extends Kd {
        static get pluginName() {
          return 'ImageUploadProgress'
        }
        constructor(t) {
          super(t)
          this.placeholder =
            'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
        }
        init() {
          const t = this.editor
          if (t.plugins.has('ImageBlockEditing')) {
            t.editing.downcastDispatcher.on(
              'attribute:uploadStatus:imageBlock',
              (...t) => this.uploadStatusChange(...t)
            )
          }
          if (t.plugins.has('ImageInlineEditing')) {
            t.editing.downcastDispatcher.on(
              'attribute:uploadStatus:imageInline',
              (...t) => this.uploadStatusChange(...t)
            )
          }
        }
        uploadStatusChange(t, e, n) {
          const i = this.editor
          const o = e.item
          const r = o.getAttribute('uploadId')
          if (!n.consumable.consume(e.item, t.name)) {
            return
          }
          const s = i.plugins.get('ImageUtils')
          const a = i.plugins.get(aD)
          const c = r ? e.attributeNewValue : null
          const l = this.placeholder
          const d = i.editing.mapper.toViewElement(o)
          const u = n.writer
          if (c == 'reading') {
            sB(d, u)
            cB(s, l, d, u)
            return
          }
          if (c == 'uploading') {
            const t = a.loaders.get(r)
            sB(d, u)
            if (!t) {
              cB(s, l, d, u)
            } else {
              lB(d, u)
              dB(d, u, t, i.editing.view)
              bB(s, d, u, t)
            }
            return
          }
          if (c == 'complete' && a.loaders.get(r)) {
            hB(d, u, i.editing.view)
          }
          uB(d, u)
          lB(d, u)
          aB(d, u)
        }
      }
      function sB(t, e) {
        if (!t.hasClass('ck-appear')) {
          e.addClass('ck-appear', t)
        }
      }
      function aB(t, e) {
        e.removeClass('ck-appear', t)
      }
      function cB(t, e, n, i) {
        if (!n.hasClass('ck-image-upload-placeholder')) {
          i.addClass('ck-image-upload-placeholder', n)
        }
        const o = t.findViewImgElement(n)
        if (o.getAttribute('src') !== e) {
          i.setAttribute('src', e, o)
        }
        if (!gB(n, 'placeholder')) {
          i.insert(i.createPositionAfter(o), mB(i))
        }
      }
      function lB(t, e) {
        if (t.hasClass('ck-image-upload-placeholder')) {
          e.removeClass('ck-image-upload-placeholder', t)
        }
        pB(t, e, 'placeholder')
      }
      function dB(t, e, n, i) {
        const o = fB(e)
        e.insert(e.createPositionAt(t, 'end'), o)
        n.on('change:uploadedPercent', (t, e, n) => {
          i.change((t) => {
            t.setStyle('width', n + '%', o)
          })
        })
      }
      function uB(t, e) {
        pB(t, e, 'progressBar')
      }
      function hB(t, e, n) {
        const i = e.createUIElement('div', {
          class: 'ck-image-upload-complete-icon'
        })
        e.insert(e.createPositionAt(t, 'end'), i)
        setTimeout(() => {
          n.change((t) => t.remove(t.createRangeOn(i)))
        }, 3e3)
      }
      function fB(t) {
        const e = t.createUIElement('div', { class: 'ck-progress-bar' })
        t.setCustomProperty('progressBar', true, e)
        return e
      }
      function mB(t) {
        const e = t.createUIElement('div', {
          class: 'ck-upload-placeholder-loader'
        })
        t.setCustomProperty('placeholder', true, e)
        return e
      }
      function gB(t, e) {
        for (const n of t.getChildren()) {
          if (n.getCustomProperty(e)) {
            return n
          }
        }
      }
      function pB(t, e, n) {
        const i = gB(t, n)
        if (i) {
          e.remove(e.createRangeOn(i))
        }
      }
      function bB(t, e, n, i) {
        if (i.data) {
          const o = t.findViewImgElement(e)
          n.setAttribute('src', i.data, o)
        }
      }
      class kB extends Zd {
        refresh() {
          const t = this.editor
          const e = t.plugins.get('ImageUtils')
          const n = t.model.document.selection.getSelectedElement()
          this.isEnabled = e.isImageAllowed() || e.isImage(n)
        }
        execute(t) {
          const e = Zc(t.file)
          const n = this.editor.model.document.selection
          const i = this.editor.plugins.get('ImageUtils')
          const o = Object.fromEntries(n.getAttributes())
          e.forEach((t, e) => {
            const r = n.getSelectedElement()
            if (e && r && i.isImage(r)) {
              const e = this.editor.model.createPositionAfter(r)
              this._uploadImage(t, o, e)
            } else {
              this._uploadImage(t, o)
            }
          })
        }
        _uploadImage(t, e, n) {
          const i = this.editor
          const o = i.plugins.get(aD)
          const r = o.createLoader(t)
          const s = i.plugins.get('ImageUtils')
          if (!r) {
            return
          }
          s.insertImage({ ...e, uploadId: r.id }, n)
        }
      }
      class wB extends Kd {
        static get requires() {
          return [aD, Sy, UD, fI]
        }
        static get pluginName() {
          return 'ImageUploadEditing'
        }
        constructor(t) {
          super(t)
          t.config.define('image', {
            upload: { types: ['jpeg', 'png', 'gif', 'bmp', 'webp', 'tiff'] }
          })
          this._uploadImageElements = new Map()
        }
        init() {
          const t = this.editor
          const e = t.model.document
          const n = t.conversion
          const i = t.plugins.get(aD)
          const o = t.plugins.get('ImageUtils')
          const r = FS(t.config.get('image.upload.types'))
          const s = new kB(t)
          t.commands.add('uploadImage', s)
          t.commands.add('imageUpload', s)
          n.for('upcast').attributeToAttribute({
            view: { name: 'img', key: 'uploadId' },
            model: 'uploadId'
          })
          this.listenTo(t.editing.view.document, 'clipboardInput', (e, n) => {
            if (_B(n.dataTransfer)) {
              return
            }
            const i = Array.from(n.dataTransfer.files).filter((t) => {
              if (!t) {
                return false
              }
              return r.test(t.type)
            })
            if (!i.length) {
              return
            }
            e.stop()
            t.model.change((e) => {
              if (n.targetRanges) {
                e.setSelection(
                  n.targetRanges.map((e) => t.editing.mapper.toModelRange(e))
                )
              }
              t.model.enqueueChange(() => {
                t.execute('uploadImage', { file: i })
              })
            })
          })
          this.listenTo(
            t.plugins.get('ClipboardPipeline'),
            'inputTransformation',
            (e, n) => {
              const r = Array.from(t.editing.view.createRangeIn(n.content))
                .filter(
                  (t) =>
                    HS(o, t.item) && !t.item.getAttribute('uploadProcessed')
                )
                .map((t) => ({ promise: VS(t.item), imageElement: t.item }))
              if (!r.length) {
                return
              }
              const s = new hA(t.editing.view.document)
              for (const t of r) {
                s.setAttribute('uploadProcessed', true, t.imageElement)
                const e = i.createLoader(t.promise)
                if (e) {
                  s.setAttribute('src', '', t.imageElement)
                  s.setAttribute('uploadId', e.id, t.imageElement)
                }
              }
            }
          )
          t.editing.view.document.on('dragover', (t, e) => {
            e.preventDefault()
          })
          e.on('change', () => {
            const n = e.differ
              .getChanges({ includeChangesInGraveyard: true })
              .reverse()
            const o = new Set()
            for (const e of n) {
              if (e.type == 'insert' && e.name != '$text') {
                const n = e.position.nodeAfter
                const r = e.position.root.rootName == '$graveyard'
                for (const e of AB(t, n)) {
                  const t = e.getAttribute('uploadId')
                  if (!t) {
                    continue
                  }
                  const n = i.loaders.get(t)
                  if (!n) {
                    continue
                  }
                  if (r) {
                    if (!o.has(t)) {
                      n.abort()
                    }
                  } else {
                    o.add(t)
                    this._uploadImageElements.set(t, e)
                    if (n.status == 'idle') {
                      this._readAndUpload(n)
                    }
                  }
                }
              }
            }
          })
          this.on(
            'uploadComplete',
            (t, { imageElement: e, data: n }) => {
              const i = n.urls ? n.urls : n
              this.editor.model.change((t) => {
                t.setAttribute('src', i.default, e)
                this._parseAndSetSrcsetAttributeOnImage(i, e, t)
              })
            },
            { priority: 'low' }
          )
        }
        afterInit() {
          const t = this.editor.model.schema
          if (this.editor.plugins.has('ImageBlockEditing')) {
            t.extend('imageBlock', {
              allowAttributes: ['uploadId', 'uploadStatus']
            })
          }
          if (this.editor.plugins.has('ImageInlineEditing')) {
            t.extend('imageInline', {
              allowAttributes: ['uploadId', 'uploadStatus']
            })
          }
        }
        _readAndUpload(t) {
          const e = this.editor
          const n = e.model
          const i = e.locale.t
          const o = e.plugins.get(aD)
          const r = e.plugins.get(Sy)
          const s = e.plugins.get('ImageUtils')
          const c = this._uploadImageElements
          n.enqueueChange({ isUndoable: false }, (e) => {
            e.setAttribute('uploadStatus', 'reading', c.get(t.id))
          })
          return t
            .read()
            .then(() => {
              const i = t.upload()
              const o = c.get(t.id)
              if (a.isSafari) {
                const t = e.editing.mapper.toViewElement(o)
                const n = s.findViewImgElement(t)
                e.editing.view.once('render', () => {
                  if (!n.parent) {
                    return
                  }
                  const t = e.editing.view.domConverter.mapViewToDom(n.parent)
                  if (!t) {
                    return
                  }
                  const i = t.style.display
                  t.style.display = 'none'
                  t._ckHack = t.offsetHeight
                  t.style.display = i
                })
              }
              n.enqueueChange({ isUndoable: false }, (t) => {
                t.setAttribute('uploadStatus', 'uploading', o)
              })
              return i
            })
            .then((e) => {
              n.enqueueChange({ isUndoable: false }, (n) => {
                const i = c.get(t.id)
                n.setAttribute('uploadStatus', 'complete', i)
                this.fire('uploadComplete', { data: e, imageElement: i })
              })
              l()
            })
            .catch((e) => {
              if (t.status !== 'error' && t.status !== 'aborted') {
                throw e
              }
              if (t.status == 'error' && e) {
                r.showWarning(e, {
                  title: i('Upload failed'),
                  namespace: 'upload'
                })
              }
              n.enqueueChange({ isUndoable: false }, (e) => {
                e.remove(c.get(t.id))
              })
              l()
            })
          function l() {
            n.enqueueChange({ isUndoable: false }, (e) => {
              const n = c.get(t.id)
              e.removeAttribute('uploadId', n)
              e.removeAttribute('uploadStatus', n)
              c.delete(t.id)
            })
            o.destroyLoader(t)
          }
        }
        _parseAndSetSrcsetAttributeOnImage(t, e, n) {
          let i = 0
          const o = Object.keys(t)
            .filter((t) => {
              const e = parseInt(t, 10)
              if (!isNaN(e)) {
                i = Math.max(i, e)
                return true
              }
            })
            .map((e) => `${t[e]} ${e}w`)
            .join(', ')
          if (o != '') {
            n.setAttribute('srcset', { data: o, width: i }, e)
          }
        }
      }
      function _B(t) {
        return (
          Array.from(t.types).includes('text/html') &&
          t.getData('text/html') !== ''
        )
      }
      function AB(t, e) {
        const n = t.plugins.get('ImageUtils')
        return Array.from(t.model.createRangeOn(e))
          .filter((t) => n.isImage(t.item))
          .map((t) => t.item)
      }
      class vB extends Kd {
        static get pluginName() {
          return 'ImageUpload'
        }
        static get requires() {
          return [wB, $S, rB]
        }
      }
      class CB extends Kd {
        static get pluginName() {
          return 'IndentEditing'
        }
        init() {
          const t = this.editor
          t.commands.add('indent', new Xd(t))
          t.commands.add('outdent', new Xd(t))
        }
      }
      const yB =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>'
      const xB =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>'
      class EB extends Kd {
        static get pluginName() {
          return 'IndentUI'
        }
        init() {
          const t = this.editor
          const e = t.locale
          const n = t.t
          const i = e.uiLanguageDirection == 'ltr' ? yB : xB
          const o = e.uiLanguageDirection == 'ltr' ? xB : yB
          this._defineButton('indent', n('Increase indent'), i)
          this._defineButton('outdent', n('Decrease indent'), o)
        }
        _defineButton(t, e, n) {
          const i = this.editor
          i.ui.componentFactory.add(t, (o) => {
            const r = i.commands.get(t)
            const s = new pd(o)
            s.set({ label: e, icon: n, tooltip: true })
            s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled')
            this.listenTo(s, 'execute', () => {
              i.execute(t)
              i.editing.view.focus()
            })
            return s
          })
        }
      }
      class DB extends Kd {
        static get pluginName() {
          return 'Indent'
        }
        static get requires() {
          return [CB, EB]
        }
      }
      const TB = 'italic'
      class MB extends Kd {
        static get pluginName() {
          return 'ItalicEditing'
        }
        init() {
          const t = this.editor
          t.model.schema.extend('$text', { allowAttributes: TB })
          t.model.schema.setAttributeProperties(TB, {
            isFormatting: true,
            copyOnEnter: true
          })
          t.conversion.attributeToElement({
            model: TB,
            view: 'i',
            upcastAlso: ['em', { styles: { 'font-style': 'italic' } }]
          })
          t.commands.add(TB, new RE(t, TB))
          t.keystrokes.set('CTRL+I', TB)
        }
      }
      const IB =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>'
      const SB = 'italic'
      class BB extends Kd {
        static get pluginName() {
          return 'ItalicUI'
        }
        init() {
          const t = this.editor
          const e = t.t
          t.ui.componentFactory.add(SB, (n) => {
            const i = t.commands.get(SB)
            const o = new pd(n)
            o.set({
              label: e('Italic'),
              icon: IB,
              keystroke: 'CTRL+I',
              tooltip: true,
              isToggleable: true
            })
            o.bind('isOn', 'isEnabled').to(i, 'value', 'isEnabled')
            this.listenTo(o, 'execute', () => {
              t.execute(SB)
              t.editing.view.focus()
            })
            return o
          })
        }
      }
      class NB extends Kd {
        static get requires() {
          return [MB, BB]
        }
        static get pluginName() {
          return 'Italic'
        }
      }
      class PB {
        constructor() {
          this._definitions = new Set()
        }
        get length() {
          return this._definitions.size
        }
        add(t) {
          if (Array.isArray(t)) {
            t.forEach((t) => this._definitions.add(t))
          } else {
            this._definitions.add(t)
          }
        }
        getDispatcher() {
          return (t) => {
            t.on(
              'attribute:linkHref',
              (t, e, n) => {
                if (!n.consumable.test(e.item, 'attribute:linkHref')) {
                  return
                }
                if (!(e.item.is('selection') || n.schema.isInline(e.item))) {
                  return
                }
                const i = n.writer
                const o = i.document.selection
                for (const t of this._definitions) {
                  const r = i.createAttributeElement('a', t.attributes, {
                    priority: 5
                  })
                  if (t.classes) {
                    i.addClass(t.classes, r)
                  }
                  for (const e in t.styles) {
                    i.setStyle(e, t.styles[e], r)
                  }
                  i.setCustomProperty('link', true, r)
                  if (t.callback(e.attributeNewValue)) {
                    if (e.item.is('selection')) {
                      i.wrap(o.getFirstRange(), r)
                    } else {
                      i.wrap(n.mapper.toViewRange(e.range), r)
                    }
                  } else {
                    i.unwrap(n.mapper.toViewRange(e.range), r)
                  }
                }
              },
              { priority: 'high' }
            )
          }
        }
        getDispatcherForLinkedImage() {
          return (t) => {
            t.on(
              'attribute:linkHref:imageBlock',
              (t, e, { writer: n, mapper: i }) => {
                const o = i.toViewElement(e.item)
                const r = Array.from(o.getChildren()).find(
                  (t) => t.name === 'a'
                )
                for (const t of this._definitions) {
                  const i = hl(t.attributes)
                  if (t.callback(e.attributeNewValue)) {
                    for (const [t, e] of i) {
                      if (t === 'class') {
                        n.addClass(e, r)
                      } else {
                        n.setAttribute(t, e, r)
                      }
                    }
                    if (t.classes) {
                      n.addClass(t.classes, r)
                    }
                    for (const e in t.styles) {
                      n.setStyle(e, t.styles[e], r)
                    }
                  } else {
                    for (const [t, e] of i) {
                      if (t === 'class') {
                        n.removeClass(e, r)
                      } else {
                        n.removeAttribute(t, r)
                      }
                    }
                    if (t.classes) {
                      n.removeClass(t.classes, r)
                    }
                    for (const e in t.styles) {
                      n.removeStyle(e, r)
                    }
                  }
                }
              }
            )
          }
        }
      }
      function zB(t, e, n) {
        var i = t.length
        n = n === undefined ? i : n
        return !e && n >= i ? t : gh(t, e, n)
      }
      const LB = zB
      var OB = '\\ud800-\\udfff',
        RB = '\\u0300-\\u036f',
        jB = '\\ufe20-\\ufe2f',
        FB = '\\u20d0-\\u20ff',
        VB = RB + jB + FB,
        HB = '\\ufe0e\\ufe0f'
      var UB = '\\u200d'
      var WB = RegExp('[' + UB + OB + VB + HB + ']')
      function qB(t) {
        return WB.test(t)
      }
      const $B = qB
      function GB(t) {
        return t.split('')
      }
      const YB = GB
      var KB = '\\ud800-\\udfff',
        QB = '\\u0300-\\u036f',
        ZB = '\\ufe20-\\ufe2f',
        JB = '\\u20d0-\\u20ff',
        XB = QB + ZB + JB,
        tN = '\\ufe0e\\ufe0f'
      var eN = '[' + KB + ']',
        nN = '[' + XB + ']',
        iN = '\\ud83c[\\udffb-\\udfff]',
        oN = '(?:' + nN + '|' + iN + ')',
        rN = '[^' + KB + ']',
        sN = '(?:\\ud83c[\\udde6-\\uddff]){2}',
        aN = '[\\ud800-\\udbff][\\udc00-\\udfff]',
        cN = '\\u200d'
      var lN = oN + '?',
        dN = '[' + tN + ']?',
        uN = '(?:' + cN + '(?:' + [rN, sN, aN].join('|') + ')' + dN + lN + ')*',
        hN = dN + lN + uN,
        fN = '(?:' + [rN + nN + '?', nN, sN, aN, eN].join('|') + ')'
      var mN = RegExp(iN + '(?=' + iN + ')|' + fN + hN, 'g')
      function gN(t) {
        return t.match(mN) || []
      }
      const pN = gN
      function bN(t) {
        return $B(t) ? pN(t) : YB(t)
      }
      const kN = bN
      function wN(t) {
        return function (e) {
          e = oh(e)
          var n = $B(e) ? kN(e) : undefined
          var i = n ? n[0] : e.charAt(0)
          var o = n ? LB(n, 1).join('') : e.slice(1)
          return i[t]() + o
        }
      }
      const _N = wN
      var AN = _N('toUpperCase')
      const vN = AN
      const CN = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g
      const yN =
        /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i
      const xN =
        /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i
      const EN = /^((\w+:(\/{2,})?)|(\W))/i
      const DN = 'Ctrl+K'
      function TN(t) {
        return t.is('attributeElement') && !!t.getCustomProperty('link')
      }
      function MN(t, { writer: e }) {
        const n = e.createAttributeElement('a', { href: t }, { priority: 5 })
        e.setCustomProperty('link', true, n)
        return n
      }
      function IN(t) {
        t = String(t)
        return SN(t) ? t : '#'
      }
      function SN(t) {
        const e = t.replace(CN, '')
        return e.match(yN)
      }
      function BN(t, e) {
        const n = {
          'Open in a new tab': t('Open in a new tab'),
          Downloadable: t('Downloadable')
        }
        e.forEach((t) => {
          if (t.label && n[t.label]) {
            t.label = n[t.label]
          }
          return t
        })
        return e
      }
      function NN(t) {
        const e = []
        if (t) {
          for (const [n, i] of Object.entries(t)) {
            const t = Object.assign({}, i, { id: `link${vN(n)}` })
            e.push(t)
          }
        }
        return e
      }
      function PN(t, e) {
        if (!t) {
          return false
        }
        return e.checkAttribute(t.name, 'linkHref')
      }
      function zN(t) {
        return xN.test(t)
      }
      function LN(t, e) {
        const n = zN(t) ? 'mailto:' : e
        const i = !!n && !ON(t)
        return t && i ? n + t : t
      }
      function ON(t) {
        return EN.test(t)
      }
      function RN(t) {
        window.open(t, '_blank', 'noopener')
      }
      class jN extends Zd {
        constructor(t) {
          super(t)
          this.manualDecorators = new al()
          this.automaticDecorators = new PB()
        }
        restoreManualDecoratorStates() {
          for (const t of this.manualDecorators) {
            t.value = this._getDecoratorStateFromModel(t.id)
          }
        }
        refresh() {
          const t = this.editor.model
          const e = t.document.selection
          const n = e.getSelectedElement() || cl(e.getSelectedBlocks())
          if (PN(n, t.schema)) {
            this.value = n.getAttribute('linkHref')
            this.isEnabled = t.schema.checkAttribute(n, 'linkHref')
          } else {
            this.value = e.getAttribute('linkHref')
            this.isEnabled = t.schema.checkAttributeInSelection(e, 'linkHref')
          }
          for (const t of this.manualDecorators) {
            t.value = this._getDecoratorStateFromModel(t.id)
          }
        }
        execute(t, e = {}) {
          const n = this.editor.model
          const i = n.document.selection
          const o = []
          const r = []
          for (const t in e) {
            if (e[t]) {
              o.push(t)
            } else {
              r.push(t)
            }
          }
          n.change((e) => {
            if (i.isCollapsed) {
              const s = i.getFirstPosition()
              if (i.hasAttribute('linkHref')) {
                const a = sE(s, 'linkHref', i.getAttribute('linkHref'), n)
                e.setAttribute('linkHref', t, a)
                o.forEach((t) => {
                  e.setAttribute(t, true, a)
                })
                r.forEach((t) => {
                  e.removeAttribute(t, a)
                })
                e.setSelection(e.createPositionAfter(a.end.nodeBefore))
              } else if (t !== '') {
                const r = hl(i.getAttributes())
                r.set('linkHref', t)
                o.forEach((t) => {
                  r.set(t, true)
                })
                const { end: a } = n.insertContent(e.createText(t, r), s)
                e.setSelection(a)
              }
              ;['linkHref', ...o, ...r].forEach((t) => {
                e.removeSelectionAttribute(t)
              })
            } else {
              const s = n.schema.getValidRanges(i.getRanges(), 'linkHref')
              const a = []
              for (const t of i.getSelectedBlocks()) {
                if (n.schema.checkAttribute(t, 'linkHref')) {
                  a.push(e.createRangeOn(t))
                }
              }
              const c = a.slice()
              for (const t of s) {
                if (this._isRangeToUpdate(t, a)) {
                  c.push(t)
                }
              }
              for (const n of c) {
                e.setAttribute('linkHref', t, n)
                o.forEach((t) => {
                  e.setAttribute(t, true, n)
                })
                r.forEach((t) => {
                  e.removeAttribute(t, n)
                })
              }
            }
          })
        }
        _getDecoratorStateFromModel(t) {
          const e = this.editor.model
          const n = e.document.selection
          const i = n.getSelectedElement()
          if (PN(i, e.schema)) {
            return i.getAttribute(t)
          }
          return n.getAttribute(t)
        }
        _isRangeToUpdate(t, e) {
          for (const n of e) {
            if (n.containsRange(t)) {
              return false
            }
          }
          return true
        }
      }
      class FN extends Zd {
        refresh() {
          const t = this.editor.model
          const e = t.document.selection
          const n = e.getSelectedElement()
          if (PN(n, t.schema)) {
            this.isEnabled = t.schema.checkAttribute(n, 'linkHref')
          } else {
            this.isEnabled = t.schema.checkAttributeInSelection(e, 'linkHref')
          }
        }
        execute() {
          const t = this.editor
          const e = this.editor.model
          const n = e.document.selection
          const i = t.commands.get('link')
          e.change((t) => {
            const o = n.isCollapsed
              ? [
                  sE(
                    n.getFirstPosition(),
                    'linkHref',
                    n.getAttribute('linkHref'),
                    e
                  )
                ]
              : e.schema.getValidRanges(n.getRanges(), 'linkHref')
            for (const e of o) {
              t.removeAttribute('linkHref', e)
              if (i) {
                for (const n of i.manualDecorators) {
                  t.removeAttribute(n.id, e)
                }
              }
            }
          })
        }
      }
      class VN {
        constructor({
          id: t,
          label: e,
          attributes: n,
          classes: i,
          styles: o,
          defaultValue: r
        }) {
          this.id = t
          this.set('value')
          this.defaultValue = r
          this.label = e
          this.attributes = n
          this.classes = i
          this.styles = o
        }
        _createPattern() {
          return {
            attributes: this.attributes,
            classes: this.classes,
            styles: this.styles
          }
        }
      }
      C(VN, ht)
      var HN = __webpack_require__(399)
      var UN = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      UN.insert = 'head'
      UN.singleton = true
      var WN = El()(HN.Z, UN)
      const qN = HN.Z.locals || {}
      const $N = 'ck-link_selected'
      const GN = 'automatic'
      const YN = 'manual'
      const KN = /^(https?:)?\/\//
      class QN extends Kd {
        static get pluginName() {
          return 'LinkEditing'
        }
        static get requires() {
          return [Fx, yx, UD]
        }
        constructor(t) {
          super(t)
          t.config.define('link', { addTargetToExternalLinks: false })
        }
        init() {
          const t = this.editor
          t.model.schema.extend('$text', { allowAttributes: 'linkHref' })
          t.conversion
            .for('dataDowncast')
            .attributeToElement({ model: 'linkHref', view: MN })
          t.conversion
            .for('editingDowncast')
            .attributeToElement({
              model: 'linkHref',
              view: (t, e) => MN(IN(t), e)
            })
          t.conversion
            .for('upcast')
            .elementToAttribute({
              view: { name: 'a', attributes: { href: true } },
              model: { key: 'linkHref', value: (t) => t.getAttribute('href') }
            })
          t.commands.add('link', new jN(t))
          t.commands.add('unlink', new FN(t))
          const e = BN(t.t, NN(t.config.get('link.decorators')))
          this._enableAutomaticDecorators(e.filter((t) => t.mode === GN))
          this._enableManualDecorators(e.filter((t) => t.mode === YN))
          const n = t.plugins.get(Fx)
          n.registerAttribute('linkHref')
          cE(t, 'linkHref', 'a', $N)
          this._enableLinkOpen()
          this._enableInsertContentSelectionAttributesFixer()
          this._enableClickingAfterLink()
          this._enableTypingOverLink()
          this._handleDeleteContentAfterLink()
          this._enableClipboardIntegration()
        }
        _enableAutomaticDecorators(t) {
          const e = this.editor
          const n = e.commands.get('link')
          const i = n.automaticDecorators
          if (e.config.get('link.addTargetToExternalLinks')) {
            i.add({
              id: 'linkIsExternal',
              mode: GN,
              callback: (t) => KN.test(t),
              attributes: { target: '_blank', rel: 'noopener noreferrer' }
            })
          }
          i.add(t)
          if (i.length) {
            e.conversion.for('downcast').add(i.getDispatcher())
          }
        }
        _enableManualDecorators(t) {
          if (!t.length) {
            return
          }
          const e = this.editor
          const n = e.commands.get('link')
          const i = n.manualDecorators
          t.forEach((t) => {
            e.model.schema.extend('$text', { allowAttributes: t.id })
            t = new VN(t)
            i.add(t)
            e.conversion.for('downcast').attributeToElement({
              model: t.id,
              view: (e, { writer: n, schema: i }, { item: o }) => {
                if (!(o.is('selection') || i.isInline(o))) {
                  return
                }
                if (e) {
                  const e = n.createAttributeElement('a', t.attributes, {
                    priority: 5
                  })
                  if (t.classes) {
                    n.addClass(t.classes, e)
                  }
                  for (const i in t.styles) {
                    n.setStyle(i, t.styles[i], e)
                  }
                  n.setCustomProperty('link', true, e)
                  return e
                }
              }
            })
            e.conversion
              .for('upcast')
              .elementToAttribute({
                view: { name: 'a', ...t._createPattern() },
                model: { key: t.id }
              })
          })
        }
        _enableLinkOpen() {
          const t = this.editor
          const e = t.editing.view
          const n = e.document
          this.listenTo(
            n,
            'click',
            (t, e) => {
              const n = a.isMac ? e.domEvent.metaKey : e.domEvent.ctrlKey
              if (!n) {
                return
              }
              let i = e.domTarget
              if (i.tagName.toLowerCase() != 'a') {
                i = i.closest('a')
              }
              if (!i) {
                return
              }
              const o = i.getAttribute('href')
              if (!o) {
                return
              }
              t.stop()
              e.preventDefault()
              RN(o)
            },
            { context: '$capture' }
          )
          this.listenTo(n, 'keydown', (e, n) => {
            const i = t.commands.get('link').value
            const o = i && n.keyCode === Fc.enter && n.altKey
            if (!o) {
              return
            }
            e.stop()
            RN(i)
          })
        }
        _enableInsertContentSelectionAttributesFixer() {
          const t = this.editor
          const e = t.model
          const n = e.document.selection
          this.listenTo(
            e,
            'insertContent',
            () => {
              const t = n.anchor.nodeBefore
              const i = n.anchor.nodeAfter
              if (!n.hasAttribute('linkHref')) {
                return
              }
              if (!t) {
                return
              }
              if (!t.hasAttribute('linkHref')) {
                return
              }
              if (i && i.hasAttribute('linkHref')) {
                return
              }
              e.change((t) => {
                ZN(t, tP(e.schema))
              })
            },
            { priority: 'low' }
          )
        }
        _enableClickingAfterLink() {
          const t = this.editor
          const e = t.model
          t.editing.view.addObserver(uA)
          let n = false
          this.listenTo(t.editing.view.document, 'mousedown', () => {
            n = true
          })
          this.listenTo(t.editing.view.document, 'selectionChange', () => {
            if (!n) {
              return
            }
            n = false
            const t = e.document.selection
            if (!t.isCollapsed) {
              return
            }
            if (!t.hasAttribute('linkHref')) {
              return
            }
            const i = t.getFirstPosition()
            const o = sE(i, 'linkHref', t.getAttribute('linkHref'), e)
            if (i.isTouching(o.start) || i.isTouching(o.end)) {
              e.change((t) => {
                ZN(t, tP(e.schema))
              })
            }
          })
        }
        _enableTypingOverLink() {
          const t = this.editor
          const e = t.editing.view
          let n
          let i
          this.listenTo(
            e.document,
            'delete',
            () => {
              i = true
            },
            { priority: 'high' }
          )
          this.listenTo(
            t.model,
            'deleteContent',
            () => {
              const e = t.model.document.selection
              if (e.isCollapsed) {
                return
              }
              if (i) {
                i = false
                return
              }
              if (!XN(t)) {
                return
              }
              if (JN(t.model)) {
                n = e.getAttributes()
              }
            },
            { priority: 'high' }
          )
          this.listenTo(
            t.model,
            'insertContent',
            (e, [o]) => {
              i = false
              if (!XN(t)) {
                return
              }
              if (!n) {
                return
              }
              t.model.change((t) => {
                for (const [e, i] of n) {
                  t.setAttribute(e, i, o)
                }
              })
              n = null
            },
            { priority: 'high' }
          )
        }
        _handleDeleteContentAfterLink() {
          const t = this.editor
          const e = t.model
          const n = e.document.selection
          const i = t.editing.view
          let o = false
          let r = false
          this.listenTo(
            i.document,
            'delete',
            (t, e) => {
              r = e.direction === 'backward'
            },
            { priority: 'high' }
          )
          this.listenTo(
            e,
            'deleteContent',
            () => {
              o = false
              const t = n.getFirstPosition()
              const i = n.getAttribute('linkHref')
              if (!i) {
                return
              }
              const r = sE(t, 'linkHref', i, e)
              o = r.containsPosition(t) || r.end.isEqual(t)
            },
            { priority: 'high' }
          )
          this.listenTo(
            e,
            'deleteContent',
            () => {
              if (!r) {
                return
              }
              r = false
              if (o) {
                return
              }
              t.model.enqueueChange((t) => {
                ZN(t, tP(e.schema))
              })
            },
            { priority: 'low' }
          )
        }
        _enableClipboardIntegration() {
          const t = this.editor
          const e = t.model
          const n = this.editor.config.get('link.defaultProtocol')
          if (!n) {
            return
          }
          this.listenTo(
            t.plugins.get('ClipboardPipeline'),
            'contentInsertion',
            (t, i) => {
              e.change((t) => {
                const e = t.createRangeIn(i.content)
                for (const i of e.getItems()) {
                  if (i.hasAttribute('linkHref')) {
                    const e = LN(i.getAttribute('linkHref'), n)
                    t.setAttribute('linkHref', e, i)
                  }
                }
              })
            }
          )
        }
      }
      function ZN(t, e) {
        t.removeSelectionAttribute('linkHref')
        for (const n of e) {
          t.removeSelectionAttribute(n)
        }
      }
      function JN(t) {
        const e = t.document.selection
        const n = e.getFirstPosition()
        const i = e.getLastPosition()
        const o = n.nodeAfter
        if (!o) {
          return false
        }
        if (!o.is('$text')) {
          return false
        }
        if (!o.hasAttribute('linkHref')) {
          return false
        }
        const r = i.textNode || i.nodeBefore
        if (o === r) {
          return true
        }
        const s = sE(n, 'linkHref', o.getAttribute('linkHref'), t)
        return s.containsRange(t.createRange(n, i), true)
      }
      function XN(t) {
        const e = t.model.change((t) => t.batch)
        return e.isTyping
      }
      function tP(t) {
        const e = t.getDefinition('$text').allowAttributes
        return e.filter((t) => t.startsWith('link'))
      }
      var eP = __webpack_require__(4827)
      var nP = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      nP.insert = 'head'
      nP.singleton = true
      var iP = El()(eP.Z, nP)
      const oP = eP.Z.locals || {}
      class rP extends Sl {
        constructor(t, n) {
          super(t)
          const i = t.t
          this.focusTracker = new ll()
          this.keystrokes = new dl()
          this.urlInputView = this._createUrlInput()
          this.saveButtonView = this._createButton(
            i('Save'),
            $v.check,
            'ck-button-save'
          )
          this.saveButtonView.type = 'submit'
          this.cancelButtonView = this._createButton(
            i('Cancel'),
            $v.cancel,
            'ck-button-cancel',
            'cancel'
          )
          this._manualDecoratorSwitches = this._createManualDecoratorSwitches(n)
          this.children = this._createFormChildren(n.manualDecorators)
          this._focusables = new Cl()
          this._focusCycler = new Ud({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' }
          })
          const o = ['ck', 'ck-link-form', 'ck-responsive-form']
          if (n.manualDecorators.length) {
            o.push('ck-link-form_layout-vertical', 'ck-vertical-form')
          }
          this.setTemplate({
            tag: 'form',
            attributes: { class: o, tabindex: '-1' },
            children: this.children
          })
          e(this)
        }
        getDecoratorSwitchesState() {
          return Array.from(this._manualDecoratorSwitches).reduce((t, e) => {
            t[e.name] = e.isOn
            return t
          }, {})
        }
        render() {
          super.render()
          n({ view: this })
          const t = [
            this.urlInputView,
            ...this._manualDecoratorSwitches,
            this.saveButtonView,
            this.cancelButtonView
          ]
          t.forEach((t) => {
            this._focusables.add(t)
            this.focusTracker.add(t.element)
          })
          this.keystrokes.listenTo(this.element)
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
        }
        focus() {
          this._focusCycler.focusFirst()
        }
        _createUrlInput() {
          const t = this.locale.t
          const e = new Dy(this.locale, Ty)
          e.label = t('Link URL')
          return e
        }
        _createButton(t, e, n, i) {
          const o = new pd(this.locale)
          o.set({ label: t, icon: e, tooltip: true })
          o.extendTemplate({ attributes: { class: n } })
          if (i) {
            o.delegate('execute').to(this, i)
          }
          return o
        }
        _createManualDecoratorSwitches(t) {
          const e = this.createCollection()
          for (const n of t.manualDecorators) {
            const i = new Ad(this.locale)
            i.set({ name: n.id, label: n.label, withText: true })
            i.bind('isOn').toMany([n, t], 'value', (t, e) =>
              e === undefined && t === undefined ? n.defaultValue : t
            )
            i.on('execute', () => {
              n.set('value', !i.isOn)
            })
            e.add(i)
          }
          return e
        }
        _createFormChildren(t) {
          const e = this.createCollection()
          e.add(this.urlInputView)
          if (t.length) {
            const t = new Sl()
            t.setTemplate({
              tag: 'ul',
              children: this._manualDecoratorSwitches.map((t) => ({
                tag: 'li',
                children: [t],
                attributes: { class: ['ck', 'ck-list__item'] }
              })),
              attributes: { class: ['ck', 'ck-reset', 'ck-list'] }
            })
            e.add(t)
          }
          e.add(this.saveButtonView)
          e.add(this.cancelButtonView)
          return e
        }
      }
      var sP = __webpack_require__(9465)
      var aP = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      aP.insert = 'head'
      aP.singleton = true
      var cP = El()(sP.Z, aP)
      const lP = sP.Z.locals || {}
      const dP =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>'
      class uP extends Sl {
        constructor(t) {
          super(t)
          const e = t.t
          this.focusTracker = new ll()
          this.keystrokes = new dl()
          this.previewButtonView = this._createPreviewButton()
          this.unlinkButtonView = this._createButton(e('Unlink'), dP, 'unlink')
          this.editButtonView = this._createButton(
            e('Edit link'),
            $v.pencil,
            'edit'
          )
          this.set('href')
          this._focusables = new Cl()
          this._focusCycler = new Ud({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' }
          })
          this.setTemplate({
            tag: 'div',
            attributes: {
              class: ['ck', 'ck-link-actions', 'ck-responsive-form'],
              tabindex: '-1'
            },
            children: [
              this.previewButtonView,
              this.editButtonView,
              this.unlinkButtonView
            ]
          })
        }
        render() {
          super.render()
          const t = [
            this.previewButtonView,
            this.editButtonView,
            this.unlinkButtonView
          ]
          t.forEach((t) => {
            this._focusables.add(t)
            this.focusTracker.add(t.element)
          })
          this.keystrokes.listenTo(this.element)
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
        }
        focus() {
          this._focusCycler.focusFirst()
        }
        _createButton(t, e, n) {
          const i = new pd(this.locale)
          i.set({ label: t, icon: e, tooltip: true })
          i.delegate('execute').to(this, n)
          return i
        }
        _createPreviewButton() {
          const t = new pd(this.locale)
          const e = this.bindTemplate
          const n = this.t
          t.set({ withText: true, tooltip: n('Open link in new tab') })
          t.extendTemplate({
            attributes: {
              class: ['ck', 'ck-link-actions__preview'],
              href: e.to('href', (t) => t && IN(t)),
              target: '_blank',
              rel: 'noopener noreferrer'
            }
          })
          t.bind('label').to(
            this,
            'href',
            (t) => t || n('This link has no URL')
          )
          t.bind('isEnabled').to(this, 'href', (t) => !!t)
          t.template.tag = 'a'
          t.template.eventListeners = {}
          return t
        }
      }
      const hP =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>'
      const fP = 'link-ui'
      class mP extends Kd {
        static get requires() {
          return [Wy]
        }
        static get pluginName() {
          return 'LinkUI'
        }
        init() {
          const t = this.editor
          t.editing.view.addObserver(dA)
          this.actionsView = null
          this.formView = null
          this._balloon = t.plugins.get(Wy)
          this._createToolbarLinkButton()
          this._enableBalloonActivators()
          t.conversion
            .for('editingDowncast')
            .markerToHighlight({
              model: fP,
              view: { classes: ['ck-fake-link-selection'] }
            })
          t.conversion
            .for('editingDowncast')
            .markerToElement({
              model: fP,
              view: {
                name: 'span',
                classes: [
                  'ck-fake-link-selection',
                  'ck-fake-link-selection_collapsed'
                ]
              }
            })
        }
        destroy() {
          super.destroy()
          if (this.formView) {
            this.formView.destroy()
          }
          if (this.actionsView) {
            this.actionsView.destroy()
          }
        }
        _createViews() {
          this.actionsView = this._createActionsView()
          this.formView = this._createFormView()
          this._enableUserBalloonInteractions()
        }
        _createActionsView() {
          const t = this.editor
          const e = new uP(t.locale)
          const n = t.commands.get('link')
          const i = t.commands.get('unlink')
          e.bind('href').to(n, 'value')
          e.editButtonView.bind('isEnabled').to(n)
          e.unlinkButtonView.bind('isEnabled').to(i)
          this.listenTo(e, 'edit', () => {
            this._addFormView()
          })
          this.listenTo(e, 'unlink', () => {
            t.execute('unlink')
            this._hideUI()
          })
          e.keystrokes.set('Esc', (t, e) => {
            this._hideUI()
            e()
          })
          e.keystrokes.set(DN, (t, e) => {
            this._addFormView()
            e()
          })
          return e
        }
        _createFormView() {
          const t = this.editor
          const e = t.commands.get('link')
          const n = t.config.get('link.defaultProtocol')
          const i = new rP(t.locale, e)
          i.urlInputView.fieldView.bind('value').to(e, 'value')
          i.urlInputView.bind('isReadOnly').to(e, 'isEnabled', (t) => !t)
          i.saveButtonView.bind('isEnabled').to(e)
          this.listenTo(i, 'submit', () => {
            const { value: e } = i.urlInputView.fieldView.element
            const o = LN(e, n)
            t.execute('link', o, i.getDecoratorSwitchesState())
            this._closeFormView()
          })
          this.listenTo(i, 'cancel', () => {
            this._closeFormView()
          })
          i.keystrokes.set('Esc', (t, e) => {
            this._closeFormView()
            e()
          })
          return i
        }
        _createToolbarLinkButton() {
          const t = this.editor
          const e = t.commands.get('link')
          const n = t.t
          t.ui.componentFactory.add('link', (t) => {
            const i = new pd(t)
            i.isEnabled = true
            i.label = n('Link')
            i.icon = hP
            i.keystroke = DN
            i.tooltip = true
            i.isToggleable = true
            i.bind('isEnabled').to(e, 'isEnabled')
            i.bind('isOn').to(e, 'value', (t) => !!t)
            this.listenTo(i, 'execute', () => this._showUI(true))
            return i
          })
        }
        _enableBalloonActivators() {
          const t = this.editor
          const e = t.editing.view.document
          this.listenTo(e, 'click', () => {
            const t = this._getSelectedLinkElement()
            if (t) {
              this._showUI()
            }
          })
          t.keystrokes.set(DN, (e, n) => {
            n()
            if (t.commands.get('link').isEnabled) {
              this._showUI(true)
            }
          })
        }
        _enableUserBalloonInteractions() {
          this.editor.keystrokes.set(
            'Tab',
            (t, e) => {
              if (
                this._areActionsVisible &&
                !this.actionsView.focusTracker.isFocused
              ) {
                this.actionsView.focus()
                e()
              }
            },
            { priority: 'high' }
          )
          this.editor.keystrokes.set('Esc', (t, e) => {
            if (this._isUIVisible) {
              this._hideUI()
              e()
            }
          })
          t({
            emitter: this.formView,
            activator: () => this._isUIInPanel,
            contextElements: () => [this._balloon.view.element],
            callback: () => this._hideUI()
          })
        }
        _addActionsView() {
          if (!this.actionsView) {
            this._createViews()
          }
          if (this._areActionsInPanel) {
            return
          }
          this._balloon.add({
            view: this.actionsView,
            position: this._getBalloonPositionData()
          })
        }
        _addFormView() {
          if (!this.formView) {
            this._createViews()
          }
          if (this._isFormInPanel) {
            return
          }
          const t = this.editor
          const e = t.commands.get('link')
          this.formView.disableCssTransitions()
          this._balloon.add({
            view: this.formView,
            position: this._getBalloonPositionData()
          })
          if (this._balloon.visibleView === this.formView) {
            this.formView.urlInputView.fieldView.select()
          }
          this.formView.enableCssTransitions()
          this.formView.urlInputView.fieldView.element.value = e.value || ''
        }
        _closeFormView() {
          const t = this.editor.commands.get('link')
          t.restoreManualDecoratorStates()
          if (t.value !== undefined) {
            this._removeFormView()
          } else {
            this._hideUI()
          }
        }
        _removeFormView() {
          if (this._isFormInPanel) {
            this.formView.saveButtonView.focus()
            this._balloon.remove(this.formView)
            this.editor.editing.view.focus()
            this._hideFakeVisualSelection()
          }
        }
        _showUI(t = false) {
          if (!this.formView) {
            this._createViews()
          }
          if (!this._getSelectedLinkElement()) {
            this._showFakeVisualSelection()
            this._addActionsView()
            if (t) {
              this._balloon.showStack('main')
            }
            this._addFormView()
          } else {
            if (this._areActionsVisible) {
              this._addFormView()
            } else {
              this._addActionsView()
            }
            if (t) {
              this._balloon.showStack('main')
            }
          }
          this._startUpdatingUI()
        }
        _hideUI() {
          if (!this._isUIInPanel) {
            return
          }
          const t = this.editor
          this.stopListening(t.ui, 'update')
          this.stopListening(this._balloon, 'change:visibleView')
          t.editing.view.focus()
          this._removeFormView()
          this._balloon.remove(this.actionsView)
          this._hideFakeVisualSelection()
        }
        _startUpdatingUI() {
          const t = this.editor
          const e = t.editing.view.document
          let n = this._getSelectedLinkElement()
          let i = r()
          const o = () => {
            const t = this._getSelectedLinkElement()
            const e = r()
            if ((n && !t) || (!n && e !== i)) {
              this._hideUI()
            } else if (this._isUIVisible) {
              this._balloon.updatePosition(this._getBalloonPositionData())
            }
            n = t
            i = e
          }
          function r() {
            return e.selection.focus
              .getAncestors()
              .reverse()
              .find((t) => t.is('element'))
          }
          this.listenTo(t.ui, 'update', o)
          this.listenTo(this._balloon, 'change:visibleView', o)
        }
        get _isFormInPanel() {
          return this._balloon.hasView(this.formView)
        }
        get _areActionsInPanel() {
          return this._balloon.hasView(this.actionsView)
        }
        get _areActionsVisible() {
          return this._balloon.visibleView === this.actionsView
        }
        get _isUIInPanel() {
          return this._isFormInPanel || this._areActionsInPanel
        }
        get _isUIVisible() {
          const t = this._balloon.visibleView
          return t == this.formView || this._areActionsVisible
        }
        _getBalloonPositionData() {
          const t = this.editor.editing.view
          const e = this.editor.model
          const n = t.document
          let i = null
          if (e.markers.has(fP)) {
            const e = Array.from(
              this.editor.editing.mapper.markerNameToElements(fP)
            )
            const n = t.createRange(
              t.createPositionBefore(e[0]),
              t.createPositionAfter(e[e.length - 1])
            )
            i = t.domConverter.viewRangeToDom(n)
          } else {
            i = () => {
              const e = this._getSelectedLinkElement()
              return e
                ? t.domConverter.mapViewToDom(e)
                : t.domConverter.viewRangeToDom(n.selection.getFirstRange())
            }
          }
          return { target: i }
        }
        _getSelectedLinkElement() {
          const t = this.editor.editing.view
          const e = t.document.selection
          const n = e.getSelectedElement()
          if (e.isCollapsed || (n && ZD(n))) {
            return gP(e.getFirstPosition())
          } else {
            const n = e.getFirstRange().getTrimmed()
            const i = gP(n.start)
            const o = gP(n.end)
            if (!i || i != o) {
              return null
            }
            if (t.createRangeIn(i).getTrimmed().isEqual(n)) {
              return i
            } else {
              return null
            }
          }
        }
        _showFakeVisualSelection() {
          const t = this.editor.model
          t.change((e) => {
            const n = t.document.selection.getFirstRange()
            if (t.markers.has(fP)) {
              e.updateMarker(fP, { range: n })
            } else {
              if (n.start.isAtEnd) {
                const i = n.start.getLastMatchingPosition(
                  ({ item: e }) => !t.schema.isContent(e),
                  { boundaries: n }
                )
                e.addMarker(fP, {
                  usingOperation: false,
                  affectsData: false,
                  range: e.createRange(i, n.end)
                })
              } else {
                e.addMarker(fP, {
                  usingOperation: false,
                  affectsData: false,
                  range: n
                })
              }
            }
          })
        }
        _hideFakeVisualSelection() {
          const t = this.editor.model
          if (t.markers.has(fP)) {
            t.change((t) => {
              t.removeMarker(fP)
            })
          }
        }
      }
      function gP(t) {
        return t.getAncestors().find((t) => TN(t))
      }
      const pP = 4
      const bP = new RegExp(
        '(^|\\s)' +
          '(' +
          '(' +
          '(?:(?:(?:https?|ftp):)?\\/\\/)' +
          '(?:\\S+(?::\\S*)?@)?' +
          '(?:' +
          '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
          '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
          '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
          '|' +
          '(' +
          '((?!www\\.)|(www\\.))' +
          '(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+' +
          '(?:[a-z\\u00a1-\\uffff]{2,63})' +
          ')' +
          ')' +
          '(?::\\d{2,5})?' +
          '(?:[/?#]\\S*)?' +
          ')' +
          '|' +
          '(' +
          '(www.|(\\S+@))' +
          '((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+' +
          '(?:[a-z\\u00a1-\\uffff]{2,63})' +
          ')' +
          ')$',
        'i'
      )
      const kP = 2
      class wP extends Kd {
        static get requires() {
          return [Lx]
        }
        static get pluginName() {
          return 'AutoLink'
        }
        init() {
          const t = this.editor
          const e = t.model.document.selection
          e.on('change:range', () => {
            this.isEnabled = !e.anchor.parent.is('element', 'codeBlock')
          })
          this._enableTypingHandling()
        }
        afterInit() {
          this._enableEnterHandling()
          this._enableShiftEnterHandling()
        }
        _enableTypingHandling() {
          const t = this.editor
          const e = new jx(t.model, (t) => {
            if (!_P(t)) {
              return
            }
            const e = AP(t.substr(0, t.length - 1))
            if (e) {
              return { url: e }
            }
          })
          e.on('matched:data', (e, n) => {
            const { batch: i, range: o, url: r } = n
            if (!i.isTyping) {
              return
            }
            const s = o.end.getShiftedBy(-1)
            const a = s.getShiftedBy(-r.length)
            const c = t.model.createRange(a, s)
            this._applyAutoLink(r, c)
          })
          e.bind('isEnabled').to(this)
        }
        _enableEnterHandling() {
          const t = this.editor
          const e = t.model
          const n = t.commands.get('enter')
          if (!n) {
            return
          }
          n.on('execute', () => {
            const t = e.document.selection.getFirstPosition()
            if (!t.parent.previousSibling) {
              return
            }
            const n = e.createRangeIn(t.parent.previousSibling)
            this._checkAndApplyAutoLinkOnRange(n)
          })
        }
        _enableShiftEnterHandling() {
          const t = this.editor
          const e = t.model
          const n = t.commands.get('shiftEnter')
          if (!n) {
            return
          }
          n.on('execute', () => {
            const t = e.document.selection.getFirstPosition()
            const n = e.createRange(
              e.createPositionAt(t.parent, 0),
              t.getShiftedBy(-1)
            )
            this._checkAndApplyAutoLinkOnRange(n)
          })
        }
        _checkAndApplyAutoLinkOnRange(t) {
          const e = this.editor.model
          const { text: n, range: i } = Rx(t, e)
          const o = AP(n)
          if (o) {
            const t = e.createRange(i.end.getShiftedBy(-o.length), i.end)
            this._applyAutoLink(o, t)
          }
        }
        _applyAutoLink(t, e) {
          const n = this.editor.model
          const i = this.editor.config.get('link.defaultProtocol')
          const o = LN(t, i)
          if (!this.isEnabled || !vP(e, n) || !ON(o) || CP(e)) {
            return
          }
          this._persistAutoLink(o, e)
        }
        _persistAutoLink(t, e) {
          const n = this.editor.model
          const i = this.editor.plugins.get('Delete')
          n.enqueueChange((o) => {
            o.setAttribute('linkHref', t, e)
            n.enqueueChange(() => {
              i.requestUndoOnBackspace()
            })
          })
        }
      }
      function _P(t) {
        return (
          t.length > pP && t[t.length - 1] === ' ' && t[t.length - 2] !== ' '
        )
      }
      function AP(t) {
        const e = bP.exec(t)
        return e ? e[kP] : null
      }
      function vP(t, e) {
        return e.schema.checkAttributeInSelection(
          e.createSelection(t),
          'linkHref'
        )
      }
      function CP(t) {
        const e = t.start.nodeAfter
        return e && e.hasAttribute('linkHref')
      }
      class yP extends Kd {
        static get requires() {
          return [QN, mP, wP]
        }
        static get pluginName() {
          return 'Link'
        }
      }
      class xP extends Zd {
        constructor(t, e) {
          super(t)
          this.type = e
        }
        refresh() {
          this.value = this._getValue()
          this.isEnabled = this._checkEnabled()
        }
        execute(t = {}) {
          const e = this.editor.model
          const n = e.document
          const i = Array.from(n.selection.getSelectedBlocks()).filter((t) =>
            DP(t, e.schema)
          )
          const o = t.forceValue !== undefined ? !t.forceValue : this.value
          e.change((t) => {
            if (o) {
              let e = i[i.length - 1].nextSibling
              let n = Number.POSITIVE_INFINITY
              let o = []
              while (
                e &&
                e.name == 'listItem' &&
                e.getAttribute('listIndent') !== 0
              ) {
                const t = e.getAttribute('listIndent')
                if (t < n) {
                  n = t
                }
                const i = t - n
                o.push({ element: e, listIndent: i })
                e = e.nextSibling
              }
              o = o.reverse()
              for (const e of o) {
                t.setAttribute('listIndent', e.listIndent, e.element)
              }
            }
            if (!o) {
              let t = Number.POSITIVE_INFINITY
              for (const e of i) {
                if (
                  e.is('element', 'listItem') &&
                  e.getAttribute('listIndent') < t
                ) {
                  t = e.getAttribute('listIndent')
                }
              }
              t = t === 0 ? 1 : t
              EP(i, true, t)
              EP(i, false, t)
            }
            for (const e of i.reverse()) {
              if (o && e.name == 'listItem') {
                t.rename(e, 'paragraph')
              } else if (!o && e.name != 'listItem') {
                t.setAttributes({ listType: this.type, listIndent: 0 }, e)
                t.rename(e, 'listItem')
              } else if (
                !o &&
                e.name == 'listItem' &&
                e.getAttribute('listType') != this.type
              ) {
                t.setAttribute('listType', this.type, e)
              }
            }
            this.fire('_executeCleanup', i)
          })
        }
        _getValue() {
          const t = cl(this.editor.model.document.selection.getSelectedBlocks())
          return (
            !!t &&
            t.is('element', 'listItem') &&
            t.getAttribute('listType') == this.type
          )
        }
        _checkEnabled() {
          if (this.value) {
            return true
          }
          const t = this.editor.model.document.selection
          const e = this.editor.model.schema
          const n = cl(t.getSelectedBlocks())
          if (!n) {
            return false
          }
          return DP(n, e)
        }
      }
      function EP(t, e, n) {
        const i = e ? t[0] : t[t.length - 1]
        if (i.is('element', 'listItem')) {
          let o = i[e ? 'previousSibling' : 'nextSibling']
          let r = i.getAttribute('listIndent')
          while (
            o &&
            o.is('element', 'listItem') &&
            o.getAttribute('listIndent') >= n
          ) {
            if (r > o.getAttribute('listIndent')) {
              r = o.getAttribute('listIndent')
            }
            if (o.getAttribute('listIndent') == r) {
              t[e ? 'unshift' : 'push'](o)
            }
            o = o[e ? 'previousSibling' : 'nextSibling']
          }
        }
      }
      function DP(t, e) {
        return e.checkChild(t.parent, 'listItem') && !e.isObject(t)
      }
      class TP extends Zd {
        constructor(t, e) {
          super(t)
          this._indentBy = e == 'forward' ? 1 : -1
        }
        refresh() {
          this.isEnabled = this._checkEnabled()
        }
        execute() {
          const t = this.editor.model
          const e = t.document
          let n = Array.from(e.selection.getSelectedBlocks())
          t.change((t) => {
            const e = n[n.length - 1]
            let i = e.nextSibling
            while (
              i &&
              i.name == 'listItem' &&
              i.getAttribute('listIndent') > e.getAttribute('listIndent')
            ) {
              n.push(i)
              i = i.nextSibling
            }
            if (this._indentBy < 0) {
              n = n.reverse()
            }
            for (const e of n) {
              const n = e.getAttribute('listIndent') + this._indentBy
              if (n < 0) {
                t.rename(e, 'paragraph')
              } else {
                t.setAttribute('listIndent', n, e)
              }
            }
            this.fire('_executeCleanup', n)
          })
        }
        _checkEnabled() {
          const t = cl(this.editor.model.document.selection.getSelectedBlocks())
          if (!t || !t.is('element', 'listItem')) {
            return false
          }
          if (this._indentBy > 0) {
            const e = t.getAttribute('listIndent')
            const n = t.getAttribute('listType')
            let i = t.previousSibling
            while (
              i &&
              i.is('element', 'listItem') &&
              i.getAttribute('listIndent') >= e
            ) {
              if (i.getAttribute('listIndent') == e) {
                return i.getAttribute('listType') == n
              }
              i = i.previousSibling
            }
            return false
          }
          return true
        }
      }
      function MP(t) {
        const e = t.createContainerElement('li')
        e.getFillerOffset = HP
        return e
      }
      function IP(t, e) {
        const n = e.mapper
        const i = e.writer
        const o = t.getAttribute('listType') == 'numbered' ? 'ol' : 'ul'
        const r = MP(i)
        const s = i.createContainerElement(o, null)
        i.insert(i.createPositionAt(s, 0), r)
        n.bindElements(t, r)
        return r
      }
      function SP(t, e, n, i) {
        const o = e.parent
        const r = n.mapper
        const s = n.writer
        let a = r.toViewPosition(i.createPositionBefore(t))
        const c = PP(t.previousSibling, {
          sameIndent: true,
          smallerIndent: true,
          listIndent: t.getAttribute('listIndent')
        })
        const l = t.previousSibling
        if (c && c.getAttribute('listIndent') == t.getAttribute('listIndent')) {
          const t = r.toViewElement(c)
          a = s.breakContainer(s.createPositionAfter(t))
        } else {
          if (l && l.name == 'listItem') {
            a = r.toViewPosition(i.createPositionAt(l, 'end'))
            const t = r.findMappedViewAncestor(a)
            const e = LP(t)
            if (e) {
              a = s.createPositionBefore(e)
            } else {
              a = s.createPositionAt(t, 'end')
            }
          } else {
            a = r.toViewPosition(i.createPositionBefore(t))
          }
        }
        a = NP(a)
        s.insert(a, o)
        if (l && l.name == 'listItem') {
          const t = r.toViewElement(l)
          const n = s.createRange(s.createPositionAt(t, 0), a)
          const i = n.getWalker({ ignoreElementEnd: true })
          for (const t of i) {
            if (t.item.is('element', 'li')) {
              const n = s.breakContainer(s.createPositionBefore(t.item))
              const o = t.item.parent
              const r = s.createPositionAt(e, 'end')
              BP(s, r.nodeBefore, r.nodeAfter)
              s.move(s.createRangeOn(o), r)
              i.position = n
            }
          }
        } else {
          const n = o.nextSibling
          if (n && (n.is('element', 'ul') || n.is('element', 'ol'))) {
            let i = null
            for (const e of n.getChildren()) {
              const n = r.toModelElement(e)
              if (
                n &&
                n.getAttribute('listIndent') > t.getAttribute('listIndent')
              ) {
                i = e
              } else {
                break
              }
            }
            if (i) {
              s.breakContainer(s.createPositionAfter(i))
              s.move(s.createRangeOn(i.parent), s.createPositionAt(e, 'end'))
            }
          }
        }
        BP(s, o, o.nextSibling)
        BP(s, o.previousSibling, o)
      }
      function BP(t, e, n) {
        if (!e || !n || (e.name != 'ul' && e.name != 'ol')) {
          return null
        }
        if (
          e.name != n.name ||
          e.getAttribute('class') !== n.getAttribute('class')
        ) {
          return null
        }
        return t.mergeContainers(t.createPositionAfter(e))
      }
      function NP(t) {
        return t.getLastMatchingPosition((t) => t.item.is('uiElement'))
      }
      function PP(t, e) {
        const n = !!e.sameIndent
        const i = !!e.smallerIndent
        const o = e.listIndent
        let r = t
        while (r && r.name == 'listItem') {
          const t = r.getAttribute('listIndent')
          if ((n && o == t) || (i && o > t)) {
            return r
          }
          if (e.direction === 'forward') {
            r = r.nextSibling
          } else {
            r = r.previousSibling
          }
        }
        return null
      }
      function zP(t, e, n, i) {
        t.ui.componentFactory.add(e, (o) => {
          const r = t.commands.get(e)
          const s = new pd(o)
          s.set({ label: n, icon: i, tooltip: true, isToggleable: true })
          s.bind('isOn', 'isEnabled').to(r, 'value', 'isEnabled')
          s.on('execute', () => {
            t.execute(e)
            t.editing.view.focus()
          })
          return s
        })
      }
      function LP(t) {
        for (const e of t.getChildren()) {
          if (e.name == 'ul' || e.name == 'ol') {
            return e
          }
        }
        return null
      }
      function OP(t, e) {
        const n = []
        const i = t.parent
        const o = {
          ignoreElementEnd: false,
          startPosition: t,
          shallow: true,
          direction: e
        }
        const r = i.getAttribute('listIndent')
        const s = [...new Up(o)]
          .filter((t) => t.item.is('element'))
          .map((t) => t.item)
        for (const t of s) {
          if (!t.is('element', 'listItem')) {
            break
          }
          if (t.getAttribute('listIndent') < r) {
            break
          }
          if (t.getAttribute('listIndent') > r) {
            continue
          }
          if (t.getAttribute('listType') !== i.getAttribute('listType')) {
            break
          }
          if (t.getAttribute('listStyle') !== i.getAttribute('listStyle')) {
            break
          }
          if (
            t.getAttribute('listReversed') !== i.getAttribute('listReversed')
          ) {
            break
          }
          if (t.getAttribute('listStart') !== i.getAttribute('listStart')) {
            break
          }
          if (e === 'backward') {
            n.unshift(t)
          } else {
            n.push(t)
          }
        }
        return n
      }
      function RP(t) {
        const e = t.document
        let n = [...e.selection.getSelectedBlocks()]
          .filter((t) => t.is('element', 'listItem'))
          .map((e) => {
            const n = t.change((t) => t.createPositionAt(e, 0))
            return [...OP(n, 'backward'), ...OP(n, 'forward')]
          })
          .flat()
        n = [...new Set(n)]
        return n
      }
      const jP = ['disc', 'circle', 'square']
      const FP = [
        'decimal',
        'decimal-leading-zero',
        'lower-roman',
        'upper-roman',
        'lower-latin',
        'upper-latin'
      ]
      function VP(t) {
        if (jP.includes(t)) {
          return 'bulleted'
        }
        if (FP.includes(t)) {
          return 'numbered'
        }
        return null
      }
      function HP() {
        const t =
          !this.isEmpty &&
          (this.getChild(0).name == 'ul' || this.getChild(0).name == 'ol')
        if (this.isEmpty || t) {
          return 0
        }
        return Df.call(this)
      }
      class UP extends Kd {
        static get pluginName() {
          return 'ListUtils'
        }
        getListTypeFromListStyleType(t) {
          return VP(t)
        }
        getSelectedListItems(t) {
          return RP(t)
        }
        getSiblingNodes(t, e) {
          return OP(t, e)
        }
      }
      function WP(t) {
        return (e, n, i) => {
          const o = i.consumable
          if (
            !o.test(n.item, 'insert') ||
            !o.test(n.item, 'attribute:listType') ||
            !o.test(n.item, 'attribute:listIndent')
          ) {
            return
          }
          o.consume(n.item, 'insert')
          o.consume(n.item, 'attribute:listType')
          o.consume(n.item, 'attribute:listIndent')
          const r = n.item
          const s = IP(r, i)
          SP(r, s, i, t)
        }
      }
      function qP(t) {
        return (e, n, i) => {
          const o = i.mapper.toViewPosition(n.position)
          const r = o.getLastMatchingPosition(
            (t) => !t.item.is('element', 'li')
          )
          const s = r.nodeAfter
          const a = i.writer
          a.breakContainer(a.createPositionBefore(s))
          a.breakContainer(a.createPositionAfter(s))
          const c = s.parent
          const l = c.previousSibling
          const d = a.createRangeOn(c)
          const u = a.remove(d)
          if (l && l.nextSibling) {
            BP(a, l, l.nextSibling)
          }
          const h = i.mapper.toModelElement(s)
          sz(h.getAttribute('listIndent') + 1, n.position, d.start, s, i, t)
          for (const t of a.createRangeIn(u).getItems()) {
            i.mapper.unbindViewElement(t)
          }
          e.stop()
        }
      }
      const $P = (t, e, n) => {
        if (!n.consumable.test(e.item, t.name)) {
          return
        }
        const i = n.mapper.toViewElement(e.item)
        const o = n.writer
        o.breakContainer(o.createPositionBefore(i))
        o.breakContainer(o.createPositionAfter(i))
        const r = i.parent
        const s = e.attributeNewValue == 'numbered' ? 'ol' : 'ul'
        o.rename(s, r)
      }
      const GP = (t, e, n) => {
        n.consumable.consume(e.item, t.name)
        const i = n.mapper.toViewElement(e.item)
        const o = i.parent
        const r = n.writer
        BP(r, o, o.nextSibling)
        BP(r, o.previousSibling, o)
      }
      function YP(t) {
        return (e, n, i) => {
          if (!i.consumable.consume(n.item, 'attribute:listIndent')) {
            return
          }
          const o = i.mapper.toViewElement(n.item)
          const r = i.writer
          r.breakContainer(r.createPositionBefore(o))
          r.breakContainer(r.createPositionAfter(o))
          const s = o.parent
          const a = s.previousSibling
          const c = r.createRangeOn(s)
          r.remove(c)
          if (a && a.nextSibling) {
            BP(r, a, a.nextSibling)
          }
          sz(n.attributeOldValue + 1, n.range.start, c.start, o, i, t)
          SP(n.item, o, i, t)
          for (const t of n.item.getChildren()) {
            i.consumable.consume(t, 'insert')
          }
        }
      }
      const KP = (t, e, n) => {
        if (!n.consumable.test(e.item, t.name)) {
          return
        }
        if (e.item.name != 'listItem') {
          let t = n.mapper.toViewPosition(e.range.start)
          const i = n.writer
          const o = []
          while (t.parent.name == 'ul' || t.parent.name == 'ol') {
            t = i.breakContainer(t)
            if (t.parent.name != 'li') {
              break
            }
            const e = t
            const n = i.createPositionAt(t.parent, 'end')
            if (!e.isEqual(n)) {
              const t = i.remove(i.createRange(e, n))
              o.push(t)
            }
            t = i.createPositionAfter(t.parent)
          }
          if (o.length > 0) {
            for (let e = 0; e < o.length; e++) {
              const n = t.nodeBefore
              const r = i.insert(t, o[e])
              t = r.end
              if (e > 0) {
                const e = BP(i, n, n.nextSibling)
                if (e && e.parent == n) {
                  t.offset--
                }
              }
            }
            BP(i, t.nodeBefore, t.nodeAfter)
          }
        }
      }
      const QP = (t, e, n) => {
        const i = n.mapper.toViewPosition(e.position)
        const o = i.nodeBefore
        const r = i.nodeAfter
        BP(n.writer, o, r)
      }
      const ZP = (t, e, n) => {
        if (n.consumable.consume(e.viewItem, { name: true })) {
          const t = n.writer
          const i = t.createElement('listItem')
          const o = cz(e.viewItem)
          t.setAttribute('listIndent', o, i)
          const r =
            e.viewItem.parent && e.viewItem.parent.name == 'ol'
              ? 'numbered'
              : 'bulleted'
          t.setAttribute('listType', r, i)
          if (!n.safeInsert(i, e.modelCursor)) {
            return
          }
          const s = oz(i, e.viewItem.getChildren(), n)
          e.modelRange = t.createRange(e.modelCursor, s)
          n.updateConversionResult(i, e)
        }
      }
      const JP = (t, e, n) => {
        if (n.consumable.test(e.viewItem, { name: true })) {
          const t = Array.from(e.viewItem.getChildren())
          for (const e of t) {
            const t = !(e.is('element', 'li') || az(e))
            if (t) {
              e._remove()
            }
          }
        }
      }
      const XP = (t, e, n) => {
        if (n.consumable.test(e.viewItem, { name: true })) {
          if (e.viewItem.childCount === 0) {
            return
          }
          const t = [...e.viewItem.getChildren()]
          let n = false
          for (const e of t) {
            if (n && !az(e)) {
              e._remove()
            }
            if (az(e)) {
              n = true
            }
          }
        }
      }
      function tz(t) {
        return (e, n) => {
          if (n.isPhantom) {
            return
          }
          const i = n.modelPosition.nodeBefore
          if (i && i.is('element', 'listItem')) {
            const e = n.mapper.toViewElement(i)
            const o = e.getAncestors().find(az)
            const r = t.createPositionAt(e, 0).getWalker()
            for (const t of r) {
              if (t.type == 'elementStart' && t.item.is('element', 'li')) {
                n.viewPosition = t.previousPosition
                break
              } else if (t.type == 'elementEnd' && t.item == o) {
                n.viewPosition = t.nextPosition
                break
              }
            }
          }
        }
      }
      function ez(t) {
        return (e, n) => {
          const i = n.viewPosition
          const o = i.parent
          const r = n.mapper
          if (o.name == 'ul' || o.name == 'ol') {
            if (!i.isAtEnd) {
              const e = r.toModelElement(i.nodeAfter)
              n.modelPosition = t.createPositionBefore(e)
            } else {
              const e = r.toModelElement(i.nodeBefore)
              const o = r.getModelLength(i.nodeBefore)
              n.modelPosition = t.createPositionBefore(e).getShiftedBy(o)
            }
            e.stop()
          } else if (
            o.name == 'li' &&
            i.nodeBefore &&
            (i.nodeBefore.name == 'ul' || i.nodeBefore.name == 'ol')
          ) {
            const s = r.toModelElement(o)
            let a = 1
            let c = i.nodeBefore
            while (c && az(c)) {
              a += r.getModelLength(c)
              c = c.previousSibling
            }
            n.modelPosition = t.createPositionBefore(s).getShiftedBy(a)
            e.stop()
          }
        }
      }
      function nz(t, e) {
        const n = t.document.differ.getChanges()
        const i = new Map()
        let o = false
        for (const i of n) {
          if (i.type == 'insert' && i.name == 'listItem') {
            r(i.position)
          } else if (i.type == 'insert' && i.name != 'listItem') {
            if (i.name != '$text') {
              const n = i.position.nodeAfter
              if (n.hasAttribute('listIndent')) {
                e.removeAttribute('listIndent', n)
                o = true
              }
              if (n.hasAttribute('listType')) {
                e.removeAttribute('listType', n)
                o = true
              }
              if (n.hasAttribute('listStyle')) {
                e.removeAttribute('listStyle', n)
                o = true
              }
              if (n.hasAttribute('listReversed')) {
                e.removeAttribute('listReversed', n)
                o = true
              }
              if (n.hasAttribute('listStart')) {
                e.removeAttribute('listStart', n)
                o = true
              }
              for (const e of Array.from(t.createRangeIn(n)).filter((t) =>
                t.item.is('element', 'listItem')
              )) {
                r(e.previousPosition)
              }
            }
            const n = i.position.getShiftedBy(i.length)
            r(n)
          } else if (i.type == 'remove' && i.name == 'listItem') {
            r(i.position)
          } else if (i.type == 'attribute' && i.attributeKey == 'listIndent') {
            r(i.range.start)
          } else if (i.type == 'attribute' && i.attributeKey == 'listType') {
            r(i.range.start)
          }
        }
        for (const t of i.values()) {
          s(t)
          a(t)
        }
        return o
        function r(t) {
          const e = t.nodeBefore
          if (!e || !e.is('element', 'listItem')) {
            const e = t.nodeAfter
            if (e && e.is('element', 'listItem')) {
              i.set(e, e)
            }
          } else {
            let t = e
            if (i.has(t)) {
              return
            }
            for (
              let e = t.previousSibling;
              e && e.is('element', 'listItem');
              e = t.previousSibling
            ) {
              t = e
              if (i.has(t)) {
                return
              }
            }
            i.set(e, t)
          }
        }
        function s(t) {
          let n = 0
          let i = null
          while (t && t.is('element', 'listItem')) {
            const r = t.getAttribute('listIndent')
            if (r > n) {
              let s
              if (i === null) {
                i = r - n
                s = n
              } else {
                if (i > r) {
                  i = r
                }
                s = r - i
              }
              e.setAttribute('listIndent', s, t)
              o = true
            } else {
              i = null
              n = t.getAttribute('listIndent') + 1
            }
            t = t.nextSibling
          }
        }
        function a(t) {
          let n = []
          let i = null
          while (t && t.is('element', 'listItem')) {
            const r = t.getAttribute('listIndent')
            if (i && i.getAttribute('listIndent') > r) {
              n = n.slice(0, r + 1)
            }
            if (r != 0) {
              if (n[r]) {
                const i = n[r]
                if (t.getAttribute('listType') != i) {
                  e.setAttribute('listType', i, t)
                  o = true
                }
              } else {
                n[r] = t.getAttribute('listType')
              }
            }
            i = t
            t = t.nextSibling
          }
        }
      }
      const iz = function (t, [e, n, i]) {
        const o = this
        let r = e.is('documentFragment') ? e.getChild(0) : e
        let s
        if (!n) {
          s = o.document.selection
        } else {
          s = o.createSelection(n, i)
        }
        if (r && r.is('element', 'listItem')) {
          const t = s.getFirstPosition()
          let e = null
          if (t.parent.is('element', 'listItem')) {
            e = t.parent
          } else if (t.nodeBefore && t.nodeBefore.is('element', 'listItem')) {
            e = t.nodeBefore
          }
          if (e) {
            const t = e.getAttribute('listIndent')
            if (t > 0) {
              while (r && r.is('element', 'listItem')) {
                r._setAttribute('listIndent', r.getAttribute('listIndent') + t)
                r = r.nextSibling
              }
            }
          }
        }
      }
      function oz(t, e, n) {
        const { writer: i, schema: o } = n
        let r = i.createPositionAfter(t)
        for (const s of e) {
          if (s.name == 'ul' || s.name == 'ol') {
            r = n.convertItem(s, r).modelCursor
          } else {
            const e = n.convertItem(s, i.createPositionAt(t, 'end'))
            const a = e.modelRange.start.nodeAfter
            const c = a && a.is('element') && !o.checkChild(t, a.name)
            if (c) {
              if (e.modelCursor.parent.is('element', 'listItem')) {
                t = e.modelCursor.parent
              } else {
                t = rz(e.modelCursor)
              }
              r = i.createPositionAfter(t)
            }
          }
        }
        return r
      }
      function rz(t) {
        const e = new Up({ startPosition: t })
        let n
        do {
          n = e.next()
        } while (!n.value.item.is('element', 'listItem'))
        return n.value.item
      }
      function sz(t, e, n, i, o, r) {
        const s = PP(e.nodeBefore, {
          sameIndent: true,
          smallerIndent: true,
          listIndent: t
        })
        const a = o.mapper
        const c = o.writer
        const l = s ? s.getAttribute('listIndent') : null
        let d
        if (!s) {
          d = n
        } else if (l == t) {
          const t = a.toViewElement(s).parent
          d = c.createPositionAfter(t)
        } else {
          const t = r.createPositionAt(s, 'end')
          d = a.toViewPosition(t)
        }
        d = NP(d)
        for (const t of [...i.getChildren()]) {
          if (az(t)) {
            d = c.move(c.createRangeOn(t), d).end
            BP(c, t, t.nextSibling)
            BP(c, t.previousSibling, t)
          }
        }
      }
      function az(t) {
        return t.is('element', 'ol') || t.is('element', 'ul')
      }
      function cz(t) {
        let e = 0
        let n = t.parent
        while (n) {
          if (n.is('element', 'li')) {
            e++
          } else {
            const t = n.previousSibling
            if (t && t.is('element', 'li')) {
              e++
            }
          }
          n = n.parent
        }
        return e
      }
      var lz = __webpack_require__(9989)
      var dz = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      dz.insert = 'head'
      dz.singleton = true
      var uz = El()(lz.Z, dz)
      const hz = lz.Z.locals || {}
      class fz extends Kd {
        static get pluginName() {
          return 'ListEditing'
        }
        static get requires() {
          return [_E, Lx, UP]
        }
        init() {
          const t = this.editor
          t.model.schema.register('listItem', {
            inheritAllFrom: '$block',
            allowAttributes: ['listType', 'listIndent']
          })
          const e = t.data
          const n = t.editing
          t.model.document.registerPostFixer((e) => nz(t.model, e))
          n.mapper.registerViewToModelLength('li', mz)
          e.mapper.registerViewToModelLength('li', mz)
          n.mapper.on('modelToViewPosition', tz(n.view))
          n.mapper.on('viewToModelPosition', ez(t.model))
          e.mapper.on('modelToViewPosition', tz(n.view))
          t.conversion.for('editingDowncast').add((e) => {
            e.on('insert', KP, { priority: 'high' })
            e.on('insert:listItem', WP(t.model))
            e.on('attribute:listType:listItem', $P, { priority: 'high' })
            e.on('attribute:listType:listItem', GP, { priority: 'low' })
            e.on('attribute:listIndent:listItem', YP(t.model))
            e.on('remove:listItem', qP(t.model))
            e.on('remove', QP, { priority: 'low' })
          })
          t.conversion.for('dataDowncast').add((e) => {
            e.on('insert', KP, { priority: 'high' })
            e.on('insert:listItem', WP(t.model))
          })
          t.conversion.for('upcast').add((t) => {
            t.on('element:ul', JP, { priority: 'high' })
            t.on('element:ol', JP, { priority: 'high' })
            t.on('element:li', XP, { priority: 'high' })
            t.on('element:li', ZP)
          })
          t.model.on('insertContent', iz, { priority: 'high' })
          t.commands.add('numberedList', new xP(t, 'numbered'))
          t.commands.add('bulletedList', new xP(t, 'bulleted'))
          t.commands.add('indentList', new TP(t, 'forward'))
          t.commands.add('outdentList', new TP(t, 'backward'))
          const i = n.view.document
          this.listenTo(
            i,
            'enter',
            (t, e) => {
              const n = this.editor.model.document
              const i = n.selection.getLastPosition().parent
              if (
                n.selection.isCollapsed &&
                i.name == 'listItem' &&
                i.isEmpty
              ) {
                this.editor.execute('outdentList')
                e.preventDefault()
                t.stop()
              }
            },
            { context: 'li' }
          )
          this.listenTo(
            i,
            'delete',
            (t, e) => {
              if (e.direction !== 'backward') {
                return
              }
              const n = this.editor.model.document.selection
              if (!n.isCollapsed) {
                return
              }
              const i = n.getFirstPosition()
              if (!i.isAtStart) {
                return
              }
              const o = i.parent
              if (o.name !== 'listItem') {
                return
              }
              const r =
                o.previousSibling && o.previousSibling.name === 'listItem'
              if (r) {
                return
              }
              this.editor.execute('outdentList')
              e.preventDefault()
              t.stop()
            },
            { context: 'li' }
          )
          this.listenTo(
            t.editing.view.document,
            'tab',
            (e, n) => {
              const i = n.shiftKey ? 'outdentList' : 'indentList'
              const o = this.editor.commands.get(i)
              if (o.isEnabled) {
                t.execute(i)
                n.stopPropagation()
                n.preventDefault()
                e.stop()
              }
            },
            { context: 'li' }
          )
        }
        afterInit() {
          const t = this.editor.commands
          const e = t.get('indent')
          const n = t.get('outdent')
          if (e) {
            e.registerChildCommand(t.get('indentList'))
          }
          if (n) {
            n.registerChildCommand(t.get('outdentList'))
          }
        }
      }
      function mz(t) {
        let e = 1
        for (const n of t.getChildren()) {
          if (n.name == 'ul' || n.name == 'ol') {
            for (const t of n.getChildren()) {
              e += mz(t)
            }
          }
        }
        return e
      }
      const gz =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'
      const pz =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>'
      class bz extends Kd {
        static get pluginName() {
          return 'ListUI'
        }
        init() {
          const t = this.editor.t
          zP(this.editor, 'numberedList', t('Numbered List'), gz)
          zP(this.editor, 'bulletedList', t('Bulleted List'), pz)
        }
      }
      class kz extends Kd {
        static get requires() {
          return [fz, bz]
        }
        static get pluginName() {
          return 'List'
        }
      }
      class wz {
        constructor(t, e = {}) {
          this.skipComments = true
          this.namespaces = e.namespaces || []
          this.domParser = new DOMParser()
          this.domConverter = new Gm(t, { renderingMode: 'data' })
          this.htmlWriter = new hw()
        }
        toData(t) {
          const e = this.domConverter.viewToDom(t)
          return this.htmlWriter.getHtml(e)
        }
        toView(t) {
          const e = this._toDom(t)
          return this.domConverter.domToView(e, {
            keepOriginalCase: true,
            skipComments: this.skipComments
          })
        }
        registerRawContentMatcher(t) {
          this.domConverter.registerRawContentMatcher(t)
        }
        useFillerType(t) {
          this.domConverter.blockFillerMode =
            t == 'marked' ? 'markedNbsp' : 'nbsp'
        }
        _toDom(t) {
          const e = this.namespaces.map((t) => `xmlns:${t}="nsp"`).join(' ')
          t = `<xml ${e}>${t}</xml>`
          const n = this.domParser.parseFromString(t, 'text/xml')
          const i = n.querySelector('parsererror')
          if (i) {
            throw new Error('Parse error - ' + i.textContent)
          }
          const o = n.createDocumentFragment()
          const r = n.documentElement.childNodes
          while (r.length > 0) {
            o.appendChild(r[0])
          }
          return o
        }
      }
      var _z = __webpack_require__(7856)
      var Az = __webpack_require__.n(_z)
      class vz {
        static get safeXmlCharactersEntities() {
          return {
            tagOpener: '&laquo;',
            tagCloser: '&raquo;',
            doubleQuote: '&uml;',
            realDoubleQuote: '&quot;'
          }
        }
        static get safeBadBlackboardCharacters() {
          return {
            ltElement: '«mo»<«/mo»',
            gtElement: '«mo»>«/mo»',
            ampElement: '«mo»&«/mo»'
          }
        }
        static get safeGoodBlackboardCharacters() {
          return {
            ltElement: '«mo»§lt;«/mo»',
            gtElement: '«mo»§gt;«/mo»',
            ampElement: '«mo»§amp;«/mo»'
          }
        }
        static get xmlCharacters() {
          return {
            id: 'xmlCharacters',
            tagOpener: '<',
            tagCloser: '>',
            doubleQuote: '"',
            ampersand: '&',
            quote: "'"
          }
        }
        static get safeXmlCharacters() {
          return {
            id: 'safeXmlCharacters',
            tagOpener: '«',
            tagCloser: '»',
            doubleQuote: '¨',
            ampersand: '§',
            quote: '`',
            realDoubleQuote: '¨'
          }
        }
      }
      class Cz {
        static isMathmlInAttribute(t, e) {
          const n = '[\'"][\\s]*=[\\s]*[\\w-]+'
          const i = '"[^"]*"|\'[^\']*\''
          const o = `[\\s]*(${i})[\\s]*=[\\s]*[\\w-]+[\\s]*`
          const r = `('${o}')*`
          const s = `^${n}${r}[\\s]+gmi<`
          const a = new RegExp(s)
          const c = t.substring(0, e)
          const l = c.split('').reverse().join('')
          const d = a.test(l)
          return d
        }
        static safeXmlDecode(t) {
          let { tagOpener: e } = vz.safeXmlCharactersEntities
          let { tagCloser: n } = vz.safeXmlCharactersEntities
          let { doubleQuote: i } = vz.safeXmlCharactersEntities
          let { realDoubleQuote: o } = vz.safeXmlCharactersEntities
          t = t.split(e).join(vz.safeXmlCharacters.tagOpener)
          t = t.split(n).join(vz.safeXmlCharacters.tagCloser)
          t = t.split(i).join(vz.safeXmlCharacters.doubleQuote)
          t = t.split(o).join(vz.safeXmlCharacters.realDoubleQuote)
          const { ltElement: r } = vz.safeBadBlackboardCharacters
          const { gtElement: s } = vz.safeBadBlackboardCharacters
          const { ampElement: a } = vz.safeBadBlackboardCharacters
          if ('_wrs_blackboard' in window && window._wrs_blackboard) {
            t = t.split(r).join(vz.safeGoodBlackboardCharacters.ltElement)
            t = t.split(s).join(vz.safeGoodBlackboardCharacters.gtElement)
            t = t.split(a).join(vz.safeGoodBlackboardCharacters.ampElement)
          }
          ;({ tagOpener: e } = vz.safeXmlCharacters)
          ;({ tagCloser: n } = vz.safeXmlCharacters)
          ;({ doubleQuote: i } = vz.safeXmlCharacters)
          ;({ realDoubleQuote: o } = vz.safeXmlCharacters)
          const { ampersand: c } = vz.safeXmlCharacters
          const { quote: l } = vz.safeXmlCharacters
          t = t.split(e).join(vz.xmlCharacters.tagOpener)
          t = t.split(n).join(vz.xmlCharacters.tagCloser)
          t = t.split(i).join(vz.xmlCharacters.doubleQuote)
          t = t.split(c).join(vz.xmlCharacters.ampersand)
          t = t.split(l).join(vz.xmlCharacters.quote)
          let d = ''
          let u = null
          for (let e = 0; e < t.length; e += 1) {
            const n = t.charAt(e)
            if (u == null) {
              if (n === '$') {
                u = ''
              } else {
                d += n
              }
            } else if (n === ';') {
              d += `&${u}`
              u = null
            } else if (n.match(/([a-zA-Z0-9#._-] | '-')/)) {
              u += n
            } else {
              d += `$${u}`
              u = null
              e -= 1
            }
          }
          return d
        }
        static safeXmlEncode(t) {
          const { tagOpener: e } = vz.xmlCharacters
          const { tagCloser: n } = vz.xmlCharacters
          const { doubleQuote: i } = vz.xmlCharacters
          const { ampersand: o } = vz.xmlCharacters
          const { quote: r } = vz.xmlCharacters
          t = t.split(e).join(vz.safeXmlCharacters.tagOpener)
          t = t.split(n).join(vz.safeXmlCharacters.tagCloser)
          t = t.split(i).join(vz.safeXmlCharacters.doubleQuote)
          t = t.split(o).join(vz.safeXmlCharacters.ampersand)
          t = t.split(r).join(vz.safeXmlCharacters.quote)
          return t
        }
        static mathMLEntities(t) {
          let e = ''
          for (let n = 0; n < t.length; n += 1) {
            const i = t.charAt(n)
            if (t.codePointAt(n) > 128) {
              e += `&#${t.codePointAt(n)};`
              if (t.codePointAt(n) > 65535) {
                n += 1
              }
            } else if (i === '&') {
              const o = t.indexOf(';', n + 1)
              if (o >= 0) {
                const i = document.createElement('span')
                i.innerHTML = t.substring(n, o + 1)
                e += `&#${Sz.fixedCharCodeAt(i.textContent || i.innerText, 0)};`
                n = o
              } else {
                e += i
              }
            } else {
              e += i
            }
          }
          return e
        }
        static addCustomEditorClassAttribute(t, e) {
          let n = ''
          const i = t.indexOf('<math')
          if (i === 0) {
            const o = t.indexOf('>')
            if (t.indexOf('class') === -1) {
              n = `${t.substr(i, o)} class="wrs_${e}">`
              n += t.substr(o + 1, t.length)
              return n
            }
          }
          return t
        }
        static removeCustomEditorClassAttribute(t, e) {
          if (t.indexOf('class') === -1 || t.indexOf(`wrs_${e}`) === -1) {
            return t
          }
          if (t.indexOf(`class="wrs_${e}"`) !== -1) {
            return t.replace(`class="wrs_${e}"`, '')
          }
          return t.replace(`wrs_${e}`, '')
        }
        static addAnnotation(t, e, n) {
          const i = t.indexOf('<annotation')
          let o = ''
          if (i !== -1) {
            const i = t.indexOf('</semantics>')
            o = `${t.substring(
              0,
              i
            )}<annotation encoding="${n}">${e}</annotation>${t.substring(i)}`
          } else if (Cz.isEmpty(t)) {
            const i = t.indexOf('/>')
            const r = t.indexOf('>')
            const s = r === i ? i : r
            o = `${t.substring(
              0,
              s
            )}><semantics><annotation encoding="${n}">${e}</annotation></semantics></math>`
          } else {
            const i = t.indexOf('>') + 1
            const r = t.lastIndexOf('</math>')
            const s = t.substring(i, r)
            o = `${t.substring(
              0,
              i
            )}<semantics><mrow>${s}</mrow><annotation encoding="${n}">${e}</annotation></semantics></math>`
          }
          return o
        }
        static removeAnnotation(t, e) {
          let n = t
          const i = `<annotation encoding="${e}">`
          const o = '</annotation>'
          const r = t.indexOf(i)
          if (r !== -1) {
            let e = false
            let i = t.indexOf('<annotation')
            while (i !== -1) {
              if (i !== r) {
                e = true
              }
              i = t.indexOf('<annotation', i + 1)
            }
            if (e) {
              const e = t.indexOf(o, r)
              const i = e + o.length
              const s = t.substring(0, r)
              n = s + t.substring(i)
            } else {
              n = Cz.removeSemantics(t)
            }
          }
          return n
        }
        static removeSemantics(t) {
          const e = '</math>'
          const n = '<semantics>'
          const i = '<annotation'
          let o = t
          const r = t.indexOf(n)
          if (r !== -1) {
            const s = t.indexOf(i, r + n.length)
            if (s !== -1) {
              o = t.substring(0, r) + t.substring(r + n.length, s) + e
            }
          }
          return o
        }
        static removeSemanticsOcurrences(t, e = vz.xmlCharacters) {
          const n = `${e.tagOpener}math`
          const i = `${e.tagOpener}/math${e.tagCloser}`
          const o = `/${e.tagCloser}`
          const { tagCloser: r } = e
          const s = `${e.tagOpener}semantics${e.tagCloser}`
          const a = `${e.tagOpener}annotation encoding=`
          let c = ''
          let l = t.indexOf(n)
          let d = 0
          while (l !== -1) {
            c += t.substring(d, l)
            const e = t.indexOf(i, l)
            const u = t.indexOf(o, l)
            const h = t.indexOf(r, l)
            if (e !== -1) {
              d = e
            } else if (u === h - 1) {
              d = u
            }
            const f = t.indexOf(s, l)
            if (f !== -1) {
              const e = t.substring(l, f)
              const o = t.indexOf(a, l)
              if (o !== -1) {
                const r = f + s.length
                const a = t.substring(r, o)
                c += e + a + i
                l = t.indexOf(n, l + n.length)
                d += i.length
              } else {
                d = l
                l = t.indexOf(n, l + n.length)
              }
            } else {
              d = l
              l = t.indexOf(n, l + n.length)
            }
          }
          c += t.substring(d, t.length)
          return c
        }
        static containClass(t, e) {
          const n = t.indexOf('class')
          if (n === -1) {
            return false
          }
          const i = t.indexOf('>', n)
          const o = t.substring(n, i)
          if (o.indexOf(e) !== -1) {
            return true
          }
          return false
        }
        static isEmpty(t) {
          const e = '>'
          const n = '/>'
          const i = t.indexOf(e)
          const o = t.indexOf(n)
          let r = false
          if (o !== -1) {
            if (o === i - 1) {
              r = true
            }
          }
          if (!r) {
            const e = new RegExp('</(.+:)?math>')
            const n = e.exec(t)
            if (n) {
              r = i + 1 === n.index
            }
          }
          return r
        }
        static encodeProperties(t) {
          const e = /\w+=".*?"/g
          const n = (t) => {
            const e = t.indexOf('"')
            const n = t.substring(e + 1, t.length - 1)
            const i = Sz.htmlEntities(n)
            const o = `${t.substring(0, e + 1)}${i}"`
            return o
          }
          const i = t.replace(e, n)
          return i
        }
      }
      class yz {
        static addConfiguration(t) {
          Object.assign(yz.properties, t)
        }
        static get properties() {
          return yz._properties
        }
        static set properties(t) {
          yz._properties = t
        }
        static get(t) {
          if (!Object.prototype.hasOwnProperty.call(yz.properties, t)) {
            if (
              Object.prototype.hasOwnProperty.call(yz.properties, '_wrs_conf_')
            ) {
              return yz.properties[`_wrs_conf_${t}`]
            }
            return false
          }
          return yz.properties[t]
        }
        static set(t, e) {
          yz.properties[t] = e
        }
        static update(t, e) {
          if (!yz.get(t)) {
            yz.set(t, e)
          } else {
            const n = Object.assign(yz.get(t), e)
            yz.set(t, n)
          }
        }
      }
      yz._properties = {}
      class xz {
        constructor() {
          this.cache = []
        }
        populate(t, e) {
          this.cache[t] = e
        }
        get(t) {
          if (Object.prototype.hasOwnProperty.call(this.cache, t)) {
            return this.cache[t]
          }
          return false
        }
      }
      class Ez {
        constructor() {
          this.listeners = []
        }
        add(t) {
          this.listeners.push(t)
        }
        fire(t, e) {
          for (let n = 0; n < this.listeners.length && !e.cancelled; n += 1) {
            if (this.listeners[n].eventName === t) {
              this.listeners[n].callback(e)
            }
          }
          return e.defaultPrevented
        }
        static newListener(t, e) {
          const n = {}
          n.eventName = t
          n.callback = e
          return n
        }
      }
      class Dz {
        static get listeners() {
          return Dz._listeners
        }
        static addListener(t) {
          Dz.listeners.add(t)
        }
        static fireEvent(t, e) {
          Dz.listeners.fire(t, e)
        }
        static get parameters() {
          return Dz._parameters
        }
        static set parameters(t) {
          Dz._parameters = t
        }
        static get servicePaths() {
          return Dz._servicePaths
        }
        static set servicePaths(t) {
          Dz._servicePaths = t
        }
        static setServicePath(t, e) {
          Dz.servicePaths[t] = e
        }
        static getServicePath(t) {
          return Dz.servicePaths[t]
        }
        static get integrationPath() {
          return Dz._integrationPath
        }
        static set integrationPath(t) {
          Dz._integrationPath = t
        }
        static getServerURL() {
          const t = window.location.href
          const e = t.split('/')
          const n = `${e[0]}//${e[2]}`
          return n
        }
        static init(t) {
          Dz.parameters = t
          let e = Dz.createServiceURI('configurationjs')
          let n = Dz.createServiceURI('createimage')
          let i = Dz.createServiceURI('showimage')
          let o = Dz.createServiceURI('getmathml')
          let r = Dz.createServiceURI('service')
          if (Dz.parameters.URI.indexOf('/') === 0) {
            const t = Dz.getServerURL()
            e = t + e
            i = t + i
            n = t + n
            o = t + o
            r = t + r
          }
          Dz.setServicePath('configurationjs', e)
          Dz.setServicePath('showimage', i)
          Dz.setServicePath('createimage', n)
          Dz.setServicePath('service', r)
          Dz.setServicePath('getmathml', o)
          Dz.setServicePath('configurationjs', e)
          Dz.listeners.fire('onInit', {})
        }
        static getUrl(t, e) {
          const n = window.location
            .toString()
            .substr(0, window.location.toString().lastIndexOf('/') + 1)
          const i = Sz.createHttpRequest()
          if (i) {
            if (typeof e === 'undefined' || typeof e === 'undefined') {
              i.open('GET', t, false)
            } else if (
              t.substr(0, 1) === '/' ||
              t.substr(0, 7) === 'http://' ||
              t.substr(0, 8) === 'https://'
            ) {
              i.open('POST', t, false)
            } else {
              i.open('POST', n + t, false)
            }
            if (typeof e !== 'undefined' && e) {
              i.setRequestHeader(
                'Content-type',
                'application/x-www-form-urlencoded; charset=UTF-8'
              )
              i.send(Sz.httpBuildQuery(e))
            } else {
              i.send(null)
            }
            return i.responseText
          }
          return ''
        }
        static getService(t, e, n) {
          let i
          if (n === true) {
            const n = e ? `?${e}` : ''
            const o = `${Dz.getServicePath(t)}${n}`
            i = Dz.getUrl(o)
          } else {
            const n = Dz.getServicePath(t)
            i = Dz.getUrl(n, e)
          }
          return i
        }
        static getServerLanguageFromService(t) {
          if (t.indexOf('.php') !== -1) {
            return 'php'
          }
          if (t.indexOf('.aspx') !== -1) {
            return 'aspx'
          }
          if (t.indexOf('wirispluginengine') !== -1) {
            return 'ruby'
          }
          return 'java'
        }
        static createServiceURI(t) {
          const e = Dz.serverExtension()
          return Sz.concatenateUrl(Dz.parameters.URI, t) + e
        }
        static serverExtension() {
          if (Dz.parameters.server.indexOf('php') !== -1) {
            return '.php'
          }
          if (Dz.parameters.server.indexOf('aspx') !== -1) {
            return '.aspx'
          }
          return ''
        }
      }
      Dz._servicePaths = {}
      Dz._integrationPath = ''
      Dz._listeners = new Ez()
      Dz._parameters = {}
      class Tz {
        static get cache() {
          return Tz._cache
        }
        static set cache(t) {
          Tz._cache = t
        }
        static getLatexFromMathML(t) {
          const e = Cz.removeSemantics(t)
          const { cache: n } = Tz
          const i = { service: 'mathml2latex', mml: e }
          const o = JSON.parse(Dz.getService('service', i))
          let r = ''
          if (o.status === 'ok') {
            r = o.result.text
            const e = Sz.htmlEntities(r)
            const i = Cz.addAnnotation(t, e, 'LaTeX')
            n.populate(r, i)
          }
          return r
        }
        static getMathMLFromLatex(t, e) {
          const n = Tz.cache
          if (Tz.cache.get(t)) {
            return Tz.cache.get(t)
          }
          const i = { service: 'latex2mathml', latex: t }
          if (e) {
            i.saveLatex = ''
          }
          const o = JSON.parse(Dz.getService('service', i))
          let r
          if (o.status === 'ok') {
            let e = o.result.text
            e = e.split('\r').join('').split('\n').join(' ')
            if (
              e.indexOf('semantics') === -1 &&
              e.indexOf('annotation') === -1
            ) {
              const n = Sz.htmlEntities(t)
              e = Cz.addAnnotation(e, n, 'LaTeX')
              r = e
            } else {
              r = e
            }
            if (!n.get(t)) {
              n.populate(t, e)
            }
          } else {
            r = `$$${t}$$`
          }
          return r
        }
        static parseMathmlToLatex(t, e) {
          let n = ''
          const i = `${e.tagOpener}math`
          const o = `${e.tagOpener}/math${e.tagCloser}`
          const r = `${e.tagOpener}annotation encoding=${e.doubleQuote}LaTeX${e.doubleQuote}${e.tagCloser}`
          const s = `${e.tagOpener}/annotation${e.tagCloser}`
          let a = t.indexOf(i)
          let c = 0
          let l
          let d
          let u
          while (a !== -1) {
            n += t.substring(c, a)
            c = t.indexOf(o, a)
            if (c === -1) {
              c = t.length - 1
            } else {
              c += o.length
            }
            l = t.substring(a, c)
            d = l.indexOf(r)
            if (d !== -1) {
              d += r.length
              u = l.indexOf(s)
              let t = l.substring(d, u)
              if (e === vz.safeXmlCharacters) {
                t = Cz.safeXmlDecode(t)
              }
              n += `$$${t}$$`
              Tz.cache.populate(t, l)
            } else {
              n += l
            }
            a = t.indexOf(i, c)
          }
          n += t.substring(c, t.length)
          return n
        }
        static getLatexFromTextNode(t, e, n) {
          const i = { open: '$$', close: '$$' }
          if (typeof n === 'undefined' || n == null) {
            n = i
          }
          let o = t
          while (o.previousSibling && o.previousSibling.nodeType === 3) {
            o = o.previousSibling
          }
          function r(t, e, i) {
            let o = t.nodeValue.indexOf(i, e)
            while (o === -1) {
              t = t.nextSibling
              if (!t) {
                return null
              }
              o = t.nodeValue ? t.nodeValue.indexOf(n.close) : -1
            }
            return { node: t, position: o }
          }
          function s(t, e, n, i) {
            if (t === n) {
              return e <= i
            }
            while (t && t !== n) {
              t = t.nextSibling
            }
            return t === n
          }
          let a
          let c = { node: o, position: 0 }
          const l = n.open.length
          do {
            a = r(c.node, c.position, n.open)
            if (a == null || s(t, e, a.node, a.position)) {
              return null
            }
            c = r(a.node, a.position + l, n.close)
            if (c == null) {
              return null
            }
            c.position += l
          } while (s(c.node, c.position, t, e))
          let d
          if (a.node === c.node) {
            d = a.node.nodeValue.substring(a.position + l, c.position - l)
          } else {
            const t = a.position + l
            d = a.node.nodeValue.substring(t, a.node.nodeValue.length)
            let e = a.node
            do {
              e = e.nextSibling
              if (e === c.node) {
                d += c.node.nodeValue.substring(0, c.position - l)
              } else {
                d += e.nodeValue ? e.nodeValue : ''
              }
            } while (e !== c.node)
          }
          return {
            latex: d,
            startNode: a.node,
            startPosition: a.position,
            endNode: c.node,
            endPosition: c.position
          }
        }
      }
      Tz._cache = new xz()
      const Mz = JSON.parse(
        '{"ar":{"latex":"LaTeX","cancel":"إلغاء","accept":"إدراج","manual":"الدليل","insert_math":"إدراج صيغة رياضية - MathType","insert_chem":"إدراج صيغة كيميائية - ChemType","minimize":"تصغير","maximize":"تكبير","fullscreen":"ملء الشاشة","exit_fullscreen":"الخروج من ملء الشاشة","close":"إغلاق","mathtype":"MathType","title_modalwindow":"نافذة MathType مشروطة","close_modal_warning":"هل تريد المغادرة بالتأكيد؟ ستُفقد التغييرات التي أجريتها.","latex_name_label":"صيغة Latex","browser_no_compatible":"المستعرض غير متوافق مع تقنية AJAX. الرجاء استخدام أحدث إصدار من Mozilla Firefox.","error_convert_accessibility":"حدث خطأ أثناء التحويل من MathML إلى نص قابل للاستخدام.","exception_cross_site":"البرمجة النصية للمواقع المشتركة مسموح بها لـ HTTP فقط.","exception_high_surrogate":"المركّب المرتفع غير متبوع بمركّب منخفض في fixedCharCodeAt()‎","exception_string_length":"سلسلة غير صالحة. يجب أن يكون الطول من مضاعفات العدد 4","exception_key_nonobject":"Object.keys مستدعاة على غير كائن","exception_null_or_undefined":" هذا فارغ أو غير محدد","exception_not_function":" ليست دالة","exception_invalid_date_format":"تنسيق تاريخ غير صالح: ","exception_casting":"لا يمكن الصياغة ","exception_casting_to":" إلى "},"ca":{"latex":"LaTeX","cancel":"Cancel·lar","accept":"Inserir","manual":"Manual","insert_math":"Inserir fórmula matemàtica - MathType","insert_chem":"Inserir fórmula química - ChemType","minimize":"Minimitza","maximize":"Maximitza","fullscreen":"Pantalla completa","exit_fullscreen":"Sortir de la pantalla complera","close":"Tanca","mathtype":"MathType","title_modalwindow":" Finestra modal de MathType","close_modal_warning":"N\'estàs segur que vols sortir? Es perdran els canvis que has fet.","latex_name_label":"Fórmula en Latex","browser_no_compatible":"El teu navegador no és compatible amb AJAX. Si us plau, usa la darrera versió de Mozilla Firefox.","error_convert_accessibility":"Error en convertir de MathML a text accessible.","exception_cross_site":"Els scripts de llocs creuats només estan permesos per HTTP.","exception_high_surrogate":"Subrogat alt no seguit de subrogat baix a fixedCharCodeAt()","exception_string_length":"Cadena invàlida. La longitud ha de ser un múltiple de 4","exception_key_nonobject":"Object.keys anomenat a non-object","exception_null_or_undefined":" això és null o no definit","exception_not_function":" no és una funció","exception_invalid_date_format":"Format de data invàlid : ","exception_casting":"No es pot emetre ","exception_casting_to":" a "},"cs":{"latex":"LaTeX","cancel":"Storno","accept":"Vložit","manual":"Příručka","insert_math":"Vložit matematický vzorec - MathType","insert_chem":"Vložení chemického vzorce – ChemType","minimize":"Minimalizovat","maximize":"Maximalizovat","fullscreen":"Celá obrazovka","exit_fullscreen":"Opustit režim celé obrazovky","close":"Zavřít","mathtype":"MathType","title_modalwindow":"Modální okno MathType","close_modal_warning":"Opravdu chcete okno zavřít? Provedené změny budou ztraceny.","latex_name_label":"Vzorec v LaTeXu","browser_no_compatible":"Váš prohlížeč nepodporuje technologii AJAX. Použijte nejnovější verzi prohlížeče Mozilla Firefox.","error_convert_accessibility":"Při převodu kódu MathML na čitelný text došlo k chybě.","exception_cross_site":"Skriptování mezi více servery je povoleno jen v HTTP.","exception_high_surrogate":"Ve funkci fixedCharCodeAt() nenásleduje po první části kódu znaku druhá část","exception_string_length":"Neplatný řetězec. Délka musí být násobkem 4.","exception_key_nonobject":"Funkce Object.keys byla použita pro prvek, který není objektem","exception_null_or_undefined":" hodnota je null nebo není definovaná","exception_not_function":" není funkce","exception_invalid_date_format":"Neplatný formát data: ","exception_casting":"Nelze přetypovat ","exception_casting_to":" na "},"da":{"latex":"LaTeX","cancel":"Annuller","accept":"Indsæt","manual":"Brugervejledning","insert_math":"Indsæt matematisk formel - MathType","insert_chem":"Indsæt en kemisk formel - ChemType","minimize":"Minimer","maximize":"Maksimer","fullscreen":"Fuld skærm","exit_fullscreen":"Afslut Fuld skærm","close":"Luk","mathtype":"MathType","title_modalwindow":"MathType-modalvindue","close_modal_warning":"Er du sikker på, du vil lukke? Dine ændringer går tabt.","latex_name_label":"LaTex-formel","browser_no_compatible":"Din browser er ikke kompatibel med AJAX-teknologi. Brug den nyeste version af Mozilla Firefox.","error_convert_accessibility":"Fejl under konvertering fra MathML til tilgængelig tekst.","exception_cross_site":"Scripts på tværs af websteder er kun tilladt for HTTP.","exception_high_surrogate":"Et højt erstatningstegn er ikke fulgt af et lavt erstatningstegn i fixedCharCodeAt()","exception_string_length":"Ugyldig streng. Længden skal være et multiplum af 4","exception_key_nonobject":"Object.keys kaldet ved ikke-objekt","exception_null_or_undefined":" dette er nul eller ikke defineret","exception_not_function":" er ikke en funktion","exception_invalid_date_format":"Ugyldigt datoformat: ","exception_casting":"Kan ikke beregne ","exception_casting_to":" til "},"de":{"latex":"LaTeX","cancel":"Abbrechen","accept":"Einfügen","manual":"Handbuch","insert_math":"Mathematische Formel einfügen - MathType","insert_chem":"Eine chemische Formel einfügen – ChemType","minimize":"Verkleinern","maximize":"Vergrößern","fullscreen":"Vollbild","exit_fullscreen":"Vollbild schließen","close":"Schließen","mathtype":"MathType","title_modalwindow":"Modales MathType-Fenster","close_modal_warning":"Bist du sicher, dass du das Programm verlassen willst? Alle vorgenommenen Änderungen gehen damit verloren.","latex_name_label":"Latex-Formel","browser_no_compatible":"Dein Browser ist nicht mit der AJAX-Technologie kompatibel. Verwende bitte die neueste Version von Mozilla Firefox.","error_convert_accessibility":"Fehler beim Konvertieren von MathML in barrierefreien Text.","exception_cross_site":"Cross-Site-Scripting ist nur bei HTTP zulässig.","exception_high_surrogate":"Hoher Ersatz bei bei festerZeichenkodierungbei() nicht von niedrigem Ersatz befolgt.","exception_string_length":"Ungültige Zeichenfolge. Länge muss ein Vielfaches von 4 sein.","exception_key_nonobject":"Object.keys wurde für ein Nicht-Objekt aufgerufen.","exception_null_or_undefined":" Das ist Null oder nicht definiert.","exception_not_function":" ist keine Funktion","exception_invalid_date_format":"Ungültiges Datumsformat: ","exception_casting":"Umwandlung nicht möglich ","exception_casting_to":" zu "},"el":{"latex":"LaTeX","cancel":"Άκυρο","accept":"Εισαγωγή","manual":"Χειροκίνητα","insert_math":"Εισαγωγή μαθηματικού τύπου - MathType","insert_chem":"Εισαγωγή χημικού τύπου - ChemType","minimize":"Ελαχιστοποίηση","maximize":"Μεγιστοποίηση","fullscreen":"Πλήρης οθόνη","exit_fullscreen":"Έξοδος από πλήρη οθόνη","close":"Κλείσιμο","mathtype":"MathType","title_modalwindow":"Τροπικό παράθυρο MathType","close_modal_warning":"Επιθυμείτε σίγουρα αποχώρηση; Θα χαθούν οι αλλαγές που έχετε κάνει.","latex_name_label":"Τύπος LaTeX","browser_no_compatible":"Το πρόγραμμα περιήγησής σας δεν είναι συμβατό με την τεχνολογία AJAX. Χρησιμοποιήστε την πιο πρόσφατη έκδοση του Mozilla Firefox.","error_convert_accessibility":"Σφάλμα κατά τη μετατροπή από MathML σε προσβάσιμο κείμενο.","exception_cross_site":"Το XSS (Cross site scripting) επιτρέπεται μόνο για HTTP.","exception_high_surrogate":"Το υψηλό υποκατάστατο δεν ακολουθείται από χαμηλό υποκατάστατο στο fixedCharCodeAt()","exception_string_length":"Μη έγκυρη συμβολοσειρά. Το μήκος πρέπει να είναι πολλαπλάσιο του 4","exception_key_nonobject":"Έγινε κλήση του Object.keys σε μη αντικείμενο","exception_null_or_undefined":" αυτό είναι μηδενικό ή δεν έχει οριστεί","exception_not_function":" δεν είναι συνάρτηση","exception_invalid_date_format":"Μη έγκυρη μορφή ημερομηνίας: ","exception_casting":"Δεν είναι δυνατή η μετατροπή ","exception_casting_to":" σε "},"en":{"latex":"LaTeX","cancel":"Cancel","accept":"Insert","manual":"Manual","insert_math":"Insert a math equation - MathType","insert_chem":"Insert a chemistry formula - ChemType","minimize":"Minimize","maximize":"Maximize","fullscreen":"Full-screen","exit_fullscreen":"Exit full-screen","close":"Close","mathtype":"MathType","title_modalwindow":"MathType modal window","close_modal_warning":"Are you sure you want to leave? The changes you made will be lost.","latex_name_label":"Latex Formula","browser_no_compatible":"Your browser is not compatible with AJAX technology. Please, use the latest version of Mozilla Firefox.","error_convert_accessibility":"Error converting from MathML to accessible text.","exception_cross_site":"Cross site scripting is only allowed for HTTP.","exception_high_surrogate":"High surrogate not followed by low surrogate in fixedCharCodeAt()","exception_string_length":"Invalid string. Length must be a multiple of 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" this is null or not defined","exception_not_function":" is not a function","exception_invalid_date_format":"Invalid date format : ","exception_casting":"Cannot cast ","exception_casting_to":" to "},"es":{"latex":"LaTeX","cancel":"Cancelar","accept":"Insertar","manual":"Manual","insert_math":"Insertar fórmula matemática - MathType","insert_chem":"Insertar fórmula química - ChemType","minimize":"Minimizar","maximize":"Maximizar","fullscreen":"Pantalla completa","exit_fullscreen":"Salir de pantalla completa","close":"Cerrar","mathtype":"MathType","title_modalwindow":"Ventana modal de MathType","close_modal_warning":"Seguro que quieres cerrar? Los cambios que has hecho se perderán","latex_name_label":"Formula en Latex","browser_no_compatible":"Tu navegador no es complatible con AJAX. Por favor, usa la última version de Mozilla Firefox.","error_convert_accessibility":"Error conviertiendo una fórmula MathML a texto accesible.","exception_cross_site":"Cross site scripting solo está permitido para HTTP.","exception_high_surrogate":"Subrogado alto no seguido por subrogado bajo en fixedCharCodeAt()","exception_string_length":"Cadena no válida. La longitud debe ser múltiplo de 4","exception_key_nonobject":"Object.keys called on non-object","exception_null_or_undefined":" esto es null o no definido","exception_not_function":" no es una función","exception_invalid_date_format":"Formato de fecha inválido: ","exception_casting":"No se puede emitir","exception_casting_to":" a "},"et":{"latex":"LaTeX","cancel":"Loobu","accept":"Lisa","manual":"Käsiraamat","insert_math":"Lisa matemaatiline valem – WIRIS","insert_chem":"Lisa keemiline valem – ChemType","minimize":"Minimeeri","maximize":"Maksimeeri","fullscreen":"Täiskuva","exit_fullscreen":"Välju täiskuvalt","close":"Sule","mathtype":"MathType","title_modalwindow":"MathType\'i modaalaken","close_modal_warning":"Kas soovite kindlasti lahkuda? Tehtud muudatused lähevad kaduma.","latex_name_label":"Latexi valem","browser_no_compatible":"Teie brauser ei ühildu AJAXi tehnoloogiaga. Palun kasutage Mozilla Firefoxi uusimat versiooni.","error_convert_accessibility":"Tõrge teisendamisel MathML-ist muudetavaks tekstiks.","exception_cross_site":"Ristskriptimine on lubatud ainult HTTP kasutamisel.","exception_high_surrogate":"Funktsioonis fixedCharCodeAt() ei järgne kõrgemale asendusliikmele madalam asendusliige.","exception_string_length":"Vigane string. Pikkus peab olema 4 kordne.","exception_key_nonobject":"Protseduur Object.keys kutsuti mitteobjekti korral.","exception_null_or_undefined":" see on null või määramata","exception_not_function":" ei ole funktsioon","exception_invalid_date_format":"Sobimatu kuupäeva kuju: ","exception_casting":"Esitamine ei õnnestu ","exception_casting_to":" – "},"eu":{"latex":"LaTeX","cancel":"Ezeztatu","accept":"Txertatu","manual":"Gida","insert_math":"Txertatu matematikako formula - MathType","insert_chem":"Txertatu formula kimiko bat - ChemType","minimize":"Ikonotu","maximize":"Maximizatu","fullscreen":"Pantaila osoa","exit_fullscreen":"Irten pantaila osotik","close":"Itxi","mathtype":"MathType","title_modalwindow":"MathType leiho modala","close_modal_warning":"Ziur irten nahi duzula? Egiten dituzun aldaketak galdu egingo dira.","latex_name_label":"LaTex Formula","browser_no_compatible":"Zure arakatzailea ez da bateragarria AJAX teknologiarekin. Erabili Mozilla Firefoxen azken bertsioa.","error_convert_accessibility":"Errorea MathMLtik testu irisgarrira bihurtzean.","exception_cross_site":"Gune arteko scriptak HTTPrako soilik onartzen dira.","exception_high_surrogate":"Ordezko baxuak ez dio ordezko altuari jarraitzen, hemen: fixedCharCodeAt()","exception_string_length":"Kate baliogabea. Luzerak 4ren multiploa izan behar du","exception_key_nonobject":"Object.keys deitu zaio objektua ez den zerbaiti","exception_null_or_undefined":" nulua edo definitu gabea da","exception_not_function":" ez da funtzio bat","exception_invalid_date_format":"Data-formatu baliogabea : ","exception_casting":"Ezin da igorri ","exception_casting_to":" honi "},"fi":{"latex":"LaTeX","cancel":"Peruuta","accept":"Lisää","manual":"Manual","insert_math":"Liitä matemaattinen kaava - MathType","insert_chem":"Lisää kemian kaava - ChemType","minimize":"Pienennä","maximize":"Suurenna","fullscreen":"Koko ruutu","exit_fullscreen":"Poistu koko ruudun tilasta","close":"Sulje","mathtype":"MathType","title_modalwindow":"MathTypen modaalinen ikkuna","close_modal_warning":"Oletko varma, että haluat poistua? Menetät tekemäsi muutokset.","latex_name_label":"Latex-kaava","browser_no_compatible":"Selaimesi ei tue AJAX-tekniikkaa. Ole hyvä ja käytä uusinta Firefox-versiota.","error_convert_accessibility":"Virhe muunnettaessa MathML:stä tekstiksi.","exception_cross_site":"Cross site scripting sallitaan vain HTTP:llä.","exception_high_surrogate":"fixedCharCodeAt(): yläsijaismerkkiä ei seurannut alasijaismerkki","exception_string_length":"Epäkelpo merkkijono. Pituuden on oltava 4:n kerrannainen","exception_key_nonobject":"Object.keys kutsui muuta kuin oliota","exception_null_or_undefined":" tämä on null tai ei määritelty","exception_not_function":" ei ole funktio","exception_invalid_date_format":"Virheellinen päivämäärämuoto : ","exception_casting":"Ei voida muuntaa tyyppiä ","exception_casting_to":" tyyppiin "},"fr":{"latex":"LaTeX","cancel":"Annuler","accept":"Insérer","manual":"Manuel","insert_math":"Insérer une formule mathématique - MathType","insert_chem":"Insérer une formule chimique - ChemType","minimize":"Minimiser","maximize":"Maximiser","fullscreen":"Plein écran","exit_fullscreen":"Quitter le plein écran","close":"Fermer","mathtype":"MathType","title_modalwindow":"Fenêtre modale MathType","close_modal_warning":"Confirmez-vous vouloir fermer ? Les changements effectués seront perdus.","latex_name_label":"Formule LaTeX","browser_no_compatible":"Votre navigateur n’est pas compatible avec la technologie AJAX. Veuillez utiliser la dernière version de Mozilla Firefox.","error_convert_accessibility":"Une erreur de conversion du format MathML en texte accessible est survenue.","exception_cross_site":"Le cross-site scripting n’est autorisé que pour HTTP.","exception_high_surrogate":"Substitut élevé non suivi d’un substitut inférieur dans fixedCharCodeAt()","exception_string_length":"Chaîne non valide. Longueur limitée aux multiples de 4","exception_key_nonobject":"Object.keys appelé sur un non-objet","exception_null_or_undefined":" nul ou non défini","exception_not_function":" n’est pas une fonction","exception_invalid_date_format":"Format de date non valide : ","exception_casting":"Impossible de convertir ","exception_casting_to":" sur "},"gl":{"latex":"LaTeX","cancel":"Cancelar","accept":"Inserir","manual":"Manual","insert_math":"Inserir unha fórmula matemática - MathType","insert_chem":"Inserir unha fórmula química - ChemType","minimize":"Minimizar","maximize":"Maximizar","fullscreen":"Pantalla completa","exit_fullscreen":"Saír da pantalla completa","close":"Pechar","mathtype":"MathType","title_modalwindow":"Ventá modal de MathType","close_modal_warning":"Seguro que quere saír? Perderanse os cambios realizados.","latex_name_label":"Fórmula Latex","browser_no_compatible":"O seu explorador non é compatible coa tecnoloxía AJAX. Use a versión máis recente de Mozilla Firefox.","error_convert_accessibility":"Erro ao converter de MathML a texto accesible.","exception_cross_site":"Os scripts de sitios só se permiten para HTTP.","exception_high_surrogate":"Suplente superior non seguido por suplente inferior en fixedCharCodeAt()","exception_string_length":"Cadea non válida. A lonxitude debe ser un múltiplo de 4","exception_key_nonobject":"Claves de obxecto chamadas en non obxecto","exception_null_or_undefined":" nulo ou non definido","exception_not_function":" non é unha función","exception_invalid_date_format":"Formato de data non válido: ","exception_casting":"Non se pode converter ","exception_casting_to":" a "},"he":{"latex":"LaTeX","cancel":"ביטול","accept":"עדכון","manual":"ידני","insert_math":"הוספת נוסחה מתמטית - MathType","insert_chem":"הוספת כתיבה כימית - ChemType","minimize":"מזערי","maximize":"מרבי","fullscreen":"מסך מלא","exit_fullscreen":"יציאה ממצב מסך מלא","close":"סגירה","mathtype":"MathType","title_modalwindow":"חלון מודאלי של MathType","close_modal_warning":"האם לצאת? שינויים אשר בוצעו ימחקו.","latex_name_label":"נוסחת Latex","browser_no_compatible":"הדפדפן שלך אינו תואם לטכנולוגיית AJAX. יש להשתמש בגרסה העדכנית ביותר של Mozilla Firefox.","error_convert_accessibility":"שגיאה בהמרה מ-MathML לטקסט נגיש.","exception_cross_site":"סקריפטינג חוצה-אתרים מורשה עבור HTTP בלבד.","exception_high_surrogate":"ערך ממלא מקום גבוה אינו מופיע אחרי ערך ממלא מקום נמוך ב-fixedCharCodeAt()‎","exception_string_length":"מחרוזת לא חוקית. האורך חייב להיות כפולה של 4","exception_key_nonobject":"בוצעה קריאה אל Object.keys ברכיב שאינו אובייקט","exception_null_or_undefined":" הוא Null או לא מוגדר","exception_not_function":"איננה פונקציה","exception_invalid_date_format":"תסדיר תאריך אינו תקין : ","exception_casting":"לא ניתן להמיר ","exception_casting_to":" ל "},"hr":{"latex":"LaTeX","cancel":"Poništi","accept":"Umetni","manual":"Priručnik","insert_math":"Umetnite matematičku formulu - MathType","insert_chem":"Umetnite kemijsku formulu - ChemType","minimize":"Minimiziraj","maximize":"Maksimiziraj","fullscreen":"Cijeli zaslon","exit_fullscreen":"Izlaz iz prikaza na cijelom zaslonu","close":"Zatvori","mathtype":"MathType","title_modalwindow":"MathType modalni prozor","close_modal_warning":"Sigurno želite zatvoriti? Izgubit će se unesene promjene.","latex_name_label":"Latex formula","browser_no_compatible":"Vaš preglednik nije kompatibilan s AJAX tehnologijom. Upotrijebite najnoviju verziju Mozilla Firefoxa.","error_convert_accessibility":"Pogreška konverzije iz MathML-a u dostupni tekst.","exception_cross_site":"Skriptiranje na različitim web-mjestima dopušteno je samo za HTTP.","exception_high_surrogate":"Iza visoke zamjene ne slijedi niska zamjena u fixedCharCodeAt()","exception_string_length":"Nevažeći niz. Duljina mora biti višekratnik broja 4","exception_key_nonobject":"Object.keys pozvano na ne-objekt","exception_null_or_undefined":" ovo je nula ili nije definirano","exception_not_function":" nije funkcija","exception_invalid_date_format":"Nevažeći format datuma : ","exception_casting":"Ne može se poslati ","exception_casting_to":" na "},"hu":{"latex":"LaTeX","cancel":"Mégsem","accept":"Beszúrás","manual":"Kézikönyv","insert_math":"Matematikai képlet beszúrása - MathType","insert_chem":"Kémiai képet beillesztése - ChemType","minimize":"Kis méret","maximize":"Nagy méret","fullscreen":"Teljes képernyő","exit_fullscreen":"Teljes képernyő elhagyása","close":"Bezárás","mathtype":"MathType","title_modalwindow":"MathType modális ablak","close_modal_warning":"Biztosan kilép? A módosítások el fognak veszni.","latex_name_label":"Latex képlet","browser_no_compatible":"A böngészője nem kompatibilis az AJAX technológiával. Használja a Mozilla Firefox legújabb verzióját.","error_convert_accessibility":"Hiba lépett fel a MathML szöveggé történő konvertálása során.","exception_cross_site":"Az oldalak közti scriptelés csak HTTP esetén engedélyezett.","exception_high_surrogate":"A magas helyettesítő karaktert nem alacsony helyettesítő karakter követi a fixedCharCodeAt() esetében","exception_string_length":"Érvénytelen karakterlánc. A hossznak a 4 többszörösének kell lennie","exception_key_nonobject":"Az Object.keys egy nem objektumra került meghívásra","exception_null_or_undefined":" null vagy nem definiált","exception_not_function":" nem függvény","exception_invalid_date_format":"Érvénytelen dátumformátum: ","exception_casting":"Nem alkalmazható ","exception_casting_to":" erre "},"id":{"latex":"LaTeX","cancel":"Membatalkan","accept":"Masukkan","manual":"Manual","insert_math":"Masukkan rumus matematika - MathType","insert_chem":"Masukkan rumus kimia - ChemType","minimize":"Minikan","maximize":"Perbesar","fullscreen":"Layar penuh","exit_fullscreen":"Keluar layar penuh","close":"Tutup","mathtype":"MathType","title_modalwindow":"Jendela modal MathType","close_modal_warning":"Anda yakin ingin keluar? Anda akan kehilangan perubahan yang Anda buat.","latex_name_label":"Rumus Latex","browser_no_compatible":"Penjelajah Anda tidak kompatibel dengan teknologi AJAX. Harap gunakan Mozilla Firefox versi terbaru.","error_convert_accessibility":"Kesalahan konversi dari MathML menjadi teks yang dapat diakses.","exception_cross_site":"Skrip lintas situs hanya diizinkan untuk HTTP.","exception_high_surrogate":"Pengganti tinggi tidak diikuti oleh pengganti rendah di fixedCharCodeAt()","exception_string_length":"String tidak valid. Panjang harus kelipatan 4","exception_key_nonobject":"Object.keys meminta nonobjek","exception_null_or_undefined":" ini tidak berlaku atau tidak didefinisikan","exception_not_function":" bukan sebuah fungsi","exception_invalid_date_format":"Format tanggal tidak valid : ","exception_casting":"Tidak dapat mentransmisikan ","exception_casting_to":" untuk "},"it":{"latex":"LaTeX","cancel":"Annulla","accept":"Inserisci","manual":"Manuale","insert_math":"Inserisci una formula matematica - MathType","insert_chem":"Inserisci una formula chimica - ChemType","minimize":"Riduci a icona","maximize":"Ingrandisci","fullscreen":"Schermo intero","exit_fullscreen":"Esci da schermo intero","close":"Chiudi","mathtype":"MathType","title_modalwindow":"Finestra modale di MathType","close_modal_warning":"Confermi di voler uscire? Le modifiche effettuate andranno perse.","latex_name_label":"Formula LaTeX","browser_no_compatible":"Il tuo browser non è compatibile con la tecnologia AJAX. Utilizza la versione più recente di Mozilla Firefox.","error_convert_accessibility":"Errore durante la conversione da MathML in testo accessibile.","exception_cross_site":"Lo scripting tra siti è consentito solo per HTTP.","exception_high_surrogate":"Surrogato alto non seguito da surrogato basso in fixedCharCodeAt()","exception_string_length":"Stringa non valida. La lunghezza deve essere un multiplo di 4","exception_key_nonobject":"Metodo Object.keys richiamato in un elemento non oggetto","exception_null_or_undefined":" questo è un valore null o non definito","exception_not_function":" non è una funzione","exception_invalid_date_format":"Formato di data non valido: ","exception_casting":"Impossibile eseguire il cast ","exception_casting_to":" a "},"ja":{"latex":"LaTeX","cancel":"キャンセル","accept":"挿入","manual":"マニュアル","insert_math":"数式を挿入 - MathType","insert_chem":"化学式を挿入 - ChemType","minimize":"最小化","maximize":"最大化","fullscreen":"全画面表示","exit_fullscreen":"全画面表示を解除","close":"閉じる","mathtype":"MathType","title_modalwindow":"MathType モードウィンドウ","close_modal_warning":"このページから移動してもよろしいですか？変更内容は失われます。","latex_name_label":"LaTeX 数式","browser_no_compatible":"お使いのブラウザは、AJAX 技術と互換性がありません。Mozilla Firefox の最新バージョンをご使用ください。","error_convert_accessibility":"MathML からアクセシブルなテキストへの変換中にエラーが発生しました。","exception_cross_site":"クロスサイトスクリプティングは、HTTP のみに許可されています。","exception_high_surrogate":"fixedCharCodeAt（）で上位サロゲートの後に下位サロゲートがありません","exception_string_length":"無効な文字列です。長さは4の倍数である必要があります","exception_key_nonobject":"Object.keys が非オブジェクトで呼び出されました","exception_null_or_undefined":" null であるか、定義されていません","exception_not_function":" は関数ではありません","exception_invalid_date_format":"無効な日付形式: ","exception_casting":"次にキャスト ","exception_casting_to":" できません "},"ko":{"latex":"LaTeX","cancel":"취소","accept":"삽입","manual":"설명서","insert_math":"수학 공식 삽입 - MathType","insert_chem":"화학 공식 입력하기 - ChemType","minimize":"최소화","maximize":"최대화","fullscreen":"전체 화면","exit_fullscreen":"전체 화면 나가기","close":"닫기","mathtype":"MathType","title_modalwindow":"MathType 모달 창","close_modal_warning":"정말로 나가시겠습니까? 변경 사항이 손실됩니다.","latex_name_label":"Latex 공식","browser_no_compatible":"사용자의 브라우저는 AJAX 기술과 호환되지 않습니다. Mozilla Firefox 최신 버전을 사용하십시오.","error_convert_accessibility":"MathML로부터 접근 가능한 텍스트로 오류 변환.","exception_cross_site":"사이트 교차 스크립팅은 HTTP 환경에서만 사용할 수 있습니다.","exception_high_surrogate":"fixedCharCodeAt()에서는 상위 서러게이트 뒤에 하위 서러게이트가 붙지 않습니다","exception_string_length":"유효하지 않은 스트링입니다. 길이는 4의 배수여야 합니다","exception_key_nonobject":"Object.keys가 non-object를 요청하였습니다","exception_null_or_undefined":" Null값이거나 정의되지 않았습니다","exception_not_function":" 함수가 아닙니다","exception_invalid_date_format":"유효하지 않은 날짜 포맷 : ","exception_casting":"캐스팅할 수 없습니다 ","exception_casting_to":" (으)로 "},"nl":{"latex":"LaTeX","cancel":"Annuleren","insert_chem":"Een scheikundige formule invoegen - ChemType","minimize":"Minimaliseer","maximize":"Maximaliseer","fullscreen":"Schermvullend","exit_fullscreen":"Verlaat volledig scherm","close":"Sluit","mathtype":"MathType","title_modalwindow":"Modaal venster MathType","close_modal_warning":"Weet je zeker dat je de app wilt sluiten? De gemaakte wijzigingen gaan verloren.","latex_name_label":"LaTeX-formule","browser_no_compatible":"Je browser is niet compatibel met AJAX-technologie. Gebruik de meest recente versie van Mozilla Firefox.","error_convert_accessibility":"Fout bij conversie van MathML naar toegankelijke tekst.","exception_cross_site":"Cross-site scripting is alleen toegestaan voor HTTP.","exception_high_surrogate":"Hoog surrogaat niet gevolgd door laag surrogaat in fixedCharCodeAt()","exception_string_length":"Ongeldige tekenreeks. Lengte moet een veelvoud van 4 zijn","exception_key_nonobject":"Object.keys opgeroepen voor niet-object","exception_null_or_undefined":" dit is nul of niet gedefinieerd","exception_not_function":" is geen functie","exception_invalid_date_format":"Ongeldige datumnotatie: ","exception_casting":"Kan niet weergeven ","exception_casting_to":" op "},"no":{"latex":"LaTeX","cancel":"Avbryt","accept":"Set inn","manual":"Håndbok","insert_math":"Sett inn matematikkformel - MathType","insert_chem":"Set inn ein kjemisk formel – ChemType","minimize":"Minimer","maximize":"Maksimer","fullscreen":"Fullskjerm","exit_fullscreen":"Avslutt fullskjerm","close":"Lukk","mathtype":"MathType","title_modalwindow":"Modalt MathType-vindu","close_modal_warning":"Er du sikker på at du vil gå ut? Endringane du har gjort, vil gå tapt.","latex_name_label":"LaTeX-formel","browser_no_compatible":"Nettlesaren er ikkje kompatibel med AJAX-teknologien. Bruk den nyaste versjonen av Mozilla Firefox.","error_convert_accessibility":"Feil under konvertering frå MathML til tilgjengeleg tekst.","exception_cross_site":"Skripting på tvers av nettstadar er bere tillaten med HTTP.","exception_high_surrogate":"Høgt surrogat er ikkje etterfølgt av lågt surrogat i fixedCharCodeAt()","exception_string_length":"Ugyldig streng. Lengda må vera deleleg på 4","exception_key_nonobject":"Object.keys kalla på eit ikkje-objekt","exception_null_or_undefined":" dette er null eller ikkje definert","exception_not_function":" er ikkje ein funksjon","exception_invalid_date_format":"Ugyldig datoformat: ","exception_casting":"Kan ikkje bruka casting ","exception_casting_to":" til "},"nb":{"latex":"LaTeX","cancel":"Avbryt","accept":"Insert","manual":"Håndbok","insert_math":"Sett inn matematikkformel - MathType","insert_chem":"Sett inn en kjemisk formel – ChemType","minimize":"Minimer","maximize":"Maksimer","fullscreen":"Fullskjerm","exit_fullscreen":"Avslutt fullskjerm","close":"Lukk","mathtype":"MathType","title_modalwindow":"Modalt MathType-vindu","close_modal_warning":"Er du sikker på at du vil gå ut? Endringene du har gjort, vil gå tapt.","latex_name_label":"LaTeX-formel","browser_no_compatible":"Nettleseren er ikke kompatibel med AJAX-teknologien. Bruk den nyeste versjonen av Mozilla Firefox.","error_convert_accessibility":"Feil under konvertering fra MathML til tilgjengelig tekst.","exception_cross_site":"Skripting på tvers av nettsteder er bare tillatt med HTTP.","exception_high_surrogate":"Høyt surrogat etterfølges ikke av lavt surrogat i fixedCharCodeAt()","exception_string_length":"Ugyldig streng. Lengden må være delelig på 4","exception_key_nonobject":"Object.keys kalte på et ikke-objekt","exception_null_or_undefined":" dette er null eller ikke definert","exception_not_function":" er ikke en funksjon","exception_invalid_date_format":"Ugyldig datoformat: ","exception_casting":"Kan ikke bruke casting ","exception_casting_to":" til "},"nn":{"latex":"LaTeX","cancel":"Avbryt","accept":"Set inn","manual":"Håndbok","insert_math":"Sett inn matematikkformel - MathType","insert_chem":"Set inn ein kjemisk formel – ChemType","minimize":"Minimer","maximize":"Maksimer","fullscreen":"Fullskjerm","exit_fullscreen":"Avslutt fullskjerm","close":"Lukk","mathtype":"MathType","title_modalwindow":"Modalt MathType-vindu","close_modal_warning":"Er du sikker på at du vil gå ut? Endringane du har gjort, vil gå tapt.","latex_name_label":"LaTeX-formel","browser_no_compatible":"Nettlesaren er ikkje kompatibel med AJAX-teknologien. Bruk den nyaste versjonen av Mozilla Firefox.","error_convert_accessibility":"Feil under konvertering frå MathML til tilgjengeleg tekst.","exception_cross_site":"Skripting på tvers av nettstadar er bere tillaten med HTTP.","exception_high_surrogate":"Høgt surrogat er ikkje etterfølgt av lågt surrogat i fixedCharCodeAt()","exception_string_length":"Ugyldig streng. Lengda må vera deleleg på 4","exception_key_nonobject":"Object.keys kalla på eit ikkje-objekt","exception_null_or_undefined":" dette er null eller ikkje definert","exception_not_function":" er ikkje ein funksjon","exception_invalid_date_format":"Ugyldig datoformat: ","exception_casting":"Kan ikkje bruka casting ","exception_casting_to":" til "},"pl":{"latex":"LaTeX","cancel":"Anuluj","accept":"Wstaw","manual":"Instrukcja","insert_math":"Wstaw formułę matematyczną - MathType","insert_chem":"Wstaw wzór chemiczny — ChemType","minimize":"Minimalizuj","maximize":"Maksymalizuj","fullscreen":"Pełny ekran","exit_fullscreen":"Opuść tryb pełnoekranowy","close":"Zamknij","mathtype":"MathType","title_modalwindow":"Okno modalne MathType","close_modal_warning":"Czy na pewno chcesz zamknąć? Wprowadzone zmiany zostaną utracone.","latex_name_label":"Wzór Latex","browser_no_compatible":"Twoja przeglądarka jest niezgodna z technologią AJAX Użyj najnowszej wersji Mozilla Firefox.","error_convert_accessibility":"Błąd podczas konwertowania z formatu MathML na dostępny tekst.","exception_cross_site":"Krzyżowanie skryptów witryny jest dozwolone tylko dla HTTP.","exception_high_surrogate":"Brak niskiego surogatu po wysokim surogacie w fixedCharCodeAt()","exception_string_length":"Niewłaściwy ciąg znaków. Długość musi być wielokrotnością liczby 4.","exception_key_nonobject":"Argumentem wywołanej funkcji Object.key nie jest obiekt.","exception_null_or_undefined":" jest zerowy lub niezdefiniowany","exception_not_function":" nie jest funkcją","exception_invalid_date_format":"Nieprawidłowy format daty: ","exception_casting":"Nie można rzutować ","exception_casting_to":" na "},"pt":{"latex":"LaTeX","cancel":"Cancelar","accept":"Inserir","manual":"Manual","insert_math":"Inserir fórmula matemática - MathType","insert_chem":"Inserir uma fórmula química - ChemType","minimize":"Minimizar","maximize":"Maximizar","fullscreen":"Ecrã completo","exit_fullscreen":"Sair do ecrã completo","close":"Fechar","mathtype":"MathType","title_modalwindow":"Janela modal do MathType","close_modal_warning":"Pretende sair? As alterações efetuadas serão perdidas.","latex_name_label":"Fórmula Latex","browser_no_compatible":"O seu navegador não é compatível com a tecnologia AJAX. Utilize a versão mais recente do Mozilla Firefox.","error_convert_accessibility":"Erro ao converter de MathML para texto acessível.","exception_cross_site":"O processamento de scripts em vários sites só é permitido para HTTP.","exception_high_surrogate":"Substituto alto não seguido por um substituto baixo em fixedCharCodeAt()","exception_string_length":"Cadeia inválida. O comprimento tem de ser um múltiplo de 4","exception_key_nonobject":"Object.keys chamou um não-objeto","exception_null_or_undefined":" é nulo ou não está definido","exception_not_function":" não é uma função","exception_invalid_date_format":"Formato de data inválido: ","exception_casting":"Não é possível adicionar ","exception_casting_to":" até "},"pt_br":{"latex":"LaTeX","cancel":"Cancelar","accept":"Inserir","manual":"Manual","insert_math":"Inserir fórmula matemática - MathType","insert_chem":"Insira uma fórmula química - ChemType","minimize":"Minimizar","maximize":"Maximizar","fullscreen":"Tela cheia","exit_fullscreen":"Sair de tela cheia","close":"Fechar","mathtype":"MathType","title_modalwindow":"Janela modal do MathType","close_modal_warning":"Tem certeza de que deseja sair? Todas as alterações serão perdidas.","latex_name_label":"Fórmula LaTeX","browser_no_compatible":"O navegador não é compatível com a tecnologia AJAX. Use a versão mais recente do Mozilla Firefox.","error_convert_accessibility":"Erro ao converter de MathML para texto acessível.","exception_cross_site":"O uso de scripts entre sites só é permitido para HTTP.","exception_high_surrogate":"High surrogate não seguido de low surrogate em fixedCharCodeAt()","exception_string_length":"String inválida. O comprimento deve ser um múltiplo de 4","exception_key_nonobject":"Object.keys chamados em não objeto","exception_null_or_undefined":" isto é nulo ou não definido","exception_not_function":" não é uma função","exception_invalid_date_format":"Formato de data inválido: ","exception_casting":"Não é possível transmitir ","exception_casting_to":" para "},"ro":{"latex":"LaTeX","cancel":"Anulare","accept":"Inserați","manual":"Ghid","insert_math":"Inserați o formulă matematică - MathType","insert_chem":"Inserați o formulă chimică - ChemType","minimize":"Minimizați","maximize":"Maximizați","fullscreen":"Afișați pe tot ecranul","exit_fullscreen":"Opriți afișarea pe tot ecranul","close":"Închideți","mathtype":"MathType","title_modalwindow":"Fereastră modală MathType","close_modal_warning":"Sigur doriți să ieșiți? Modificările realizate se vor pierde.","latex_name_label":"Formulă Latex","browser_no_compatible":"Browserul dvs. nu este compatibil cu tehnologia AJAX. Utilizați cea mai recentă versiune de Mozilla Firefox.","error_convert_accessibility":"Eroare la convertirea din MathML în text accesibil.","exception_cross_site":"Scriptarea între site‑uri este permisă doar pentru HTTP.","exception_high_surrogate":"Surogatul superior nu este urmat de un surogat inferior în fixedCharCodeAt()","exception_string_length":"Șir nevalid. Lungimea trebuie să fie multiplu de 4","exception_key_nonobject":"Object.keys a apelat un non-obiect","exception_null_or_undefined":" este null sau nu este definit","exception_not_function":" nu este funcție","exception_invalid_date_format":"Format de dată nevalid: ","exception_casting":"nu se poate difuza ","exception_casting_to":" către "},"ru":{"latex":"LaTeX","cancel":"отмена","accept":"Вставка","manual":"вручную","insert_math":"Вставить математическую формулу: WIRIS","insert_chem":"Вставить химическую формулу — ChemType","minimize":"Свернуть","maximize":"Развернуть","fullscreen":"На весь экран","exit_fullscreen":"Выйти из полноэкранного режима","close":"Закрыть","mathtype":"MathType","title_modalwindow":"Режимное окно MathType","close_modal_warning":"Вы уверены, что хотите выйти? Все внесенные изменения будут утрачены.","latex_name_label":"Формула Latex","browser_no_compatible":"Ваш браузер несовместим с технологией AJAX. Используйте последнюю версию Mozilla Firefox.","error_convert_accessibility":"При преобразовании формулы в текст допустимого формата произошла ошибка.","exception_cross_site":"Межсайтовые сценарии доступны только для HTTP.","exception_high_surrogate":"Младший символ-заместитель не сопровождает старший символ-заместитель в исправленном методе CharCodeAt()","exception_string_length":"Недопустимая строка. Длинна должна быть кратной 4.","exception_key_nonobject":"Метод Object.keys вызван не для объекта","exception_null_or_undefined":" значение пустое или не определено","exception_not_function":" не функция","exception_invalid_date_format":"Недопустимый формат даты: ","exception_casting":"Не удается привести ","exception_casting_to":" к "},"sv":{"latex":"LaTeX","cancel":"Avbryt","accept":"Infoga","manual":"Bruksanvisning","insert_math":"Infoga matematisk formel - MathType","insert_chem":"Infoga en kemiformel – ChemType","minimize":"Minimera","maximize":"Maximera","fullscreen":"Helskärm","exit_fullscreen":"Stäng helskärm","close":"Stäng","mathtype":"MathType","title_modalwindow":"MathType modulfönster","close_modal_warning":"Vill du avsluta? Inga ändringar kommer att sparas.","latex_name_label":"Latex-formel","browser_no_compatible":"Din webbläsare är inte kompatibel med AJAX-teknik. Använd den senaste versionen av Mozilla Firefox.","error_convert_accessibility":"Det uppstod ett fel vid konvertering från MathML till åtkomlig text.","exception_cross_site":"Skriptkörning över flera sajter är endast tillåtet för HTTP.","exception_high_surrogate":"Hög surrogat följs inte av låg surrogat i fixedCharCodeAt()","exception_string_length":"Ogiltig sträng. Längden måste vara en multipel av 4","exception_key_nonobject":"Object.keys anropade icke-objekt","exception_null_or_undefined":" det är null eller inte definierat","exception_not_function":" är inte en funktion","exception_invalid_date_format":"Ogiltigt datumformat: ","exception_casting":"Går inte att konvertera ","exception_casting_to":" till "},"tr":{"latex":"LaTeX","cancel":"Vazgeç","accept":"Ekle","manual":"Kılavuz","insert_math":"Matematik formülü ekle - MathType","insert_chem":"Kimya formülü ekleyin - ChemType","minimize":"Simge Durumuna Küçült","maximize":"Ekranı Kapla","fullscreen":"Tam Ekran","exit_fullscreen":"Tam Ekrandan Çık","close":"Kapat","mathtype":"MathType","title_modalwindow":"MathType kalıcı penceresi","close_modal_warning":"Çıkmak istediğinizden emin misiniz? Yaptığınız değişiklikler kaybolacak.","latex_name_label":"Latex Formülü","browser_no_compatible":"Tarayıcınız AJAX teknolojisiyle uyumlu değil. Lütfen en güncel Mozilla Firefox sürümünü kullanın.","error_convert_accessibility":"MathML biçiminden erişilebilir metne dönüştürme hatası.","exception_cross_site":"Siteler arası komut dosyası yazma işlemine yalnızca HTTP için izin verilir.","exception_high_surrogate":"fixedCharCodeAt() fonksiyonunda üst vekilin ardından alt vekil gelmiyor","exception_string_length":"Geçersiz dizgi. Uzunluk, 4\'ün katlarından biri olmalıdır","exception_key_nonobject":"Nesne olmayan öğe üzerinde Object.keys çağrıldı","exception_null_or_undefined":" bu değer boş veya tanımlanmamış","exception_not_function":" bir fonksiyon değil","exception_invalid_date_format":"Geçersiz tarih biçimi: ","exception_casting":"Tür dönüştürülemiyor ","exception_casting_to":" hedef: "},"zh":{"latex":"LaTeX","cancel":"取消","accept":"插入","manual":"手册","insert_math":"插入数学公式 - MathType","insert_chem":"插入化学分子式 - ChemType","minimize":"最小化","maximize":"最大化","fullscreen":"全屏幕","exit_fullscreen":"退出全屏幕","close":"关闭","mathtype":"MathType","title_modalwindow":"MathType 模式窗口","close_modal_warning":"您确定要离开吗？您所做的修改将丢失。","latex_name_label":"Latex 分子式","browser_no_compatible":"您的浏览器不兼容 AJAX 技术。请使用最新版 Mozilla Firefox。","error_convert_accessibility":"将 MathML 转换为可访问文本时出错。","exception_cross_site":"仅 HTTP 允许跨站脚本。","exception_high_surrogate":"fixedCharCodeAt() 中的高位代理之后未跟随低位代理","exception_string_length":"无效字符串。长度必须是 4 的倍数","exception_key_nonobject":"非对象调用了 Object.keys","exception_null_or_undefined":" 该值为空或未定义","exception_not_function":" 不是一个函数","exception_invalid_date_format":"无效日期格式： ","exception_casting":"无法转换 ","exception_casting_to":" 为 "},"":{}}'
      )
      class Iz {
        constructor() {
          throw new Error('Static class StringManager can not be instantiated.')
        }
        static get(t, e) {
          let { language: n } = this
          if (e) {
            n = e
          }
          if (n && n.length > 2) {
            n = n.slice(0, 2)
          }
          if (!this.strings.hasOwnProperty(n)) {
            console.warn(`Unknown language ${n} set in StringManager.`)
            n = 'en'
          }
          if (!this.strings[n].hasOwnProperty(t)) {
            console.warn(`Unknown key ${t} for language ${n} in StringManager.`)
            return t
          }
          return this.strings[n][t]
        }
      }
      Iz.strings = Mz
      Iz.language = 'en'
      class Sz {
        static fireEvent(t, e) {
          if (document.createEvent) {
            const n = document.createEvent('HTMLEvents')
            n.initEvent(e, true, true)
            return !t.dispatchEvent(n)
          }
          const n = document.createEventObject()
          return t.fireEvent(`on${e}`, n)
        }
        static addEvent(t, e, n) {
          if (t.addEventListener) {
            t.addEventListener(e, n, true)
          } else if (t.attachEvent) {
            t.attachEvent(`on${e}`, n)
          }
        }
        static removeEvent(t, e, n) {
          if (t.removeEventListener) {
            t.removeEventListener(e, n, true)
          } else if (t.detachEvent) {
            t.detachEvent(`on${e}`, n)
          }
        }
        static addElementEvents(t, e, n, i) {
          if (e) {
            this.callbackDblclick = (t) => {
              const n = t || window.event
              const i = n.srcElement ? n.srcElement : n.target
              e(i, n)
            }
            Sz.addEvent(t, 'dblclick', this.callbackDblclick)
          }
          if (n) {
            this.callbackMousedown = (t) => {
              const e = t || window.event
              const i = e.srcElement ? e.srcElement : e.target
              n(i, e)
            }
            Sz.addEvent(t, 'mousedown', this.callbackMousedown)
          }
          if (i) {
            this.callbackMouseup = (t) => {
              const e = t || window.event
              const n = e.srcElement ? e.srcElement : e.target
              i(n, e)
            }
            Sz.addEvent(document, 'mouseup', this.callbackMouseup)
            Sz.addEvent(t, 'mouseup', this.callbackMouseup)
          }
        }
        static removeElementEvents(t) {
          Sz.removeEvent(t, 'dblclick', this.callbackDblclick)
          Sz.removeEvent(t, 'mousedown', this.callbackMousedown)
          Sz.removeEvent(document, 'mouseup', this.callbackMouseup)
          Sz.removeEvent(t, 'mouseup', this.callbackMouseup)
        }
        static addClass(t, e) {
          if (!Sz.containsClass(t, e)) {
            t.className += ` ${e}`
          }
        }
        static containsClass(t, e) {
          if (t == null || !('className' in t)) {
            return false
          }
          const n = t.className.split(' ')
          for (let t = n.length - 1; t >= 0; t -= 1) {
            if (n[t] === e) {
              return true
            }
          }
          return false
        }
        static removeClass(t, e) {
          let n = ''
          const i = t.className.split(' ')
          for (let t = 0; t < i.length; t += 1) {
            if (i[t] !== e) {
              n += `${i[t]} `
            }
          }
          t.className = n.trim()
        }
        static convertOldXmlinitialtextAttribute(t) {
          const e = 'value='
          const n = t.indexOf('xmlinitialtext')
          const i = t.indexOf(e, n)
          const o = t.charAt(i + e.length)
          const r = i + e.length + 1
          const s = t.indexOf(o, r)
          const a = t.substring(r, s)
          let c = a.split('«').join('§lt;')
          c = c.split('»').join('§gt;')
          c = c.split('&').join('§')
          c = c.split('¨').join('§quot;')
          t = t.split(a).join(c)
          return t
        }
        static createElement(t, e, n) {
          if (e === undefined) {
            e = {}
          }
          if (n === undefined) {
            n = document
          }
          let i
          try {
            let o = `<${t}`
            Object.keys(e).forEach((t) => {
              o += ` ${t}="${Sz.htmlEntities(e[t])}"`
            })
            o += '>'
            i = n.createElement(o)
          } catch (o) {
            i = n.createElement(t)
            Object.keys(e).forEach((t) => {
              i.setAttribute(t, e[t])
            })
          }
          return i
        }
        static createObject(t, e) {
          if (e === undefined) {
            e = document
          }
          t = t
            .split('<applet ')
            .join('<span wirisObject="WirisApplet" ')
            .split('<APPLET ')
            .join('<span wirisObject="WirisApplet" ')
          t = t
            .split('</applet>')
            .join('</span>')
            .split('</APPLET>')
            .join('</span>')
          t = t
            .split('<param ')
            .join('<br wirisObject="WirisParam" ')
            .split('<PARAM ')
            .join('<br wirisObject="WirisParam" ')
          t = t.split('</param>').join('</br>').split('</PARAM>').join('</br>')
          const n = Sz.createElement('div', {}, e)
          n.innerHTML = t
          function i(t) {
            if (
              t.getAttribute &&
              t.getAttribute('wirisObject') === 'WirisParam'
            ) {
              const n = {}
              for (let e = 0; e < t.attributes.length; e += 1) {
                if (t.attributes[e].nodeValue !== null) {
                  n[t.attributes[e].nodeName] = t.attributes[e].nodeValue
                }
              }
              const i = Sz.createElement('param', n, e)
              if (i.NAME) {
                i.name = i.NAME
                i.value = i.VALUE
              }
              i.removeAttribute('wirisObject')
              t.parentNode.replaceChild(i, t)
            } else if (
              t.getAttribute &&
              t.getAttribute('wirisObject') === 'WirisApplet'
            ) {
              const n = {}
              for (let e = 0; e < t.attributes.length; e += 1) {
                if (t.attributes[e].nodeValue !== null) {
                  n[t.attributes[e].nodeName] = t.attributes[e].nodeValue
                }
              }
              const o = Sz.createElement('applet', n, e)
              o.removeAttribute('wirisObject')
              for (let e = 0; e < t.childNodes.length; e += 1) {
                i(t.childNodes[e])
                if (t.childNodes[e].nodeName.toLowerCase() === 'param') {
                  o.appendChild(t.childNodes[e])
                  e -= 1
                }
              }
              t.parentNode.replaceChild(o, t)
            } else {
              for (let e = 0; e < t.childNodes.length; e += 1) {
                i(t.childNodes[e])
              }
            }
          }
          i(n)
          return n.firstChild
        }
        static createObjectCode(t) {
          if (typeof t === 'undefined' || t === null) {
            return null
          }
          if (t.nodeType === 1) {
            let e = `<${t.tagName}`
            for (let n = 0; n < t.attributes.length; n += 1) {
              if (t.attributes[n].specified) {
                e += ` ${t.attributes[n].name}="${Sz.htmlEntities(
                  t.attributes[n].value
                )}"`
              }
            }
            if (t.childNodes.length > 0) {
              e += '>'
              for (let n = 0; n < t.childNodes.length; n += 1) {
                e += Sz.createObject(t.childNodes[n])
              }
              e += `</${t.tagName}>`
            } else if (t.nodeName === 'DIV' || t.nodeName === 'SCRIPT') {
              e += `></${t.tagName}>`
            } else {
              e += '/>'
            }
            return e
          }
          if (t.nodeType === 3) {
            return Sz.htmlEntities(t.nodeValue)
          }
          return ''
        }
        static concatenateUrl(t, e) {
          let n = ''
          if (t.indexOf('/') !== t.length && e.indexOf('/') !== 0) {
            n = '/'
          }
          return (t + n + e).replace(/([^:]\/)\/+/g, '$1')
        }
        static htmlEntities(t) {
          return t
            .split('&')
            .join('&amp;')
            .split('<')
            .join('&lt;')
            .split('>')
            .join('&gt;')
            .split('"')
            .join('&quot;')
        }
        static htmlSanitize(t) {
          return Az().sanitize(t)
        }
        static htmlEntitiesDecode(t) {
          const e = document.createElement('textarea')
          e.innerHTML = t
          return e.value
        }
        static createHttpRequest() {
          const t = window.location
            .toString()
            .substr(0, window.location.toString().lastIndexOf('/') + 1)
          if (t.substr(0, 7) === 'file://') {
            throw Iz.get('exception_cross_site')
          }
          if (typeof XMLHttpRequest !== 'undefined') {
            return new XMLHttpRequest()
          }
          try {
            return new ActiveXObject('Msxml2.XMLHTTP')
          } catch (t) {
            try {
              return new ActiveXObject('Microsoft.XMLHTTP')
            } catch (t) {
              return null
            }
          }
        }
        static httpBuildQuery(t) {
          let e = ''
          Object.keys(t).forEach((n) => {
            if (t[n] != null) {
              e += `${Sz.urlEncode(n)}=${Sz.urlEncode(t[n])}&`
            }
          })
          if (e.substring(e.length - 1) === '&') {
            e = e.substring(0, e.length - 1)
          }
          return e
        }
        static propertiesToString(t) {
          const e = []
          Object.keys(t).forEach((n) => {
            if (Object.prototype.hasOwnProperty.call(t, n)) {
              e.push(n)
            }
          })
          const n = e.length
          for (let t = 0; t < n; t += 1) {
            for (let i = t + 1; i < n; i += 1) {
              const n = e[t]
              const o = e[i]
              if (Sz.compareStrings(n, o) > 0) {
                e[t] = o
                e[i] = n
              }
            }
          }
          let i = ''
          for (let o = 0; o < n; o += 1) {
            const n = e[o]
            i += n
            i += '='
            let r = t[n]
            r = r.replace('\\', '\\\\')
            r = r.replace('\n', '\\n')
            r = r.replace('\r', '\\r')
            r = r.replace('\t', '\\t')
            i += r
            i += '\n'
          }
          return i
        }
        static compareStrings(t, e) {
          let n
          const i = t.length
          const o = e.length
          const r = i > o ? o : i
          for (n = 0; n < r; n += 1) {
            const i = Sz.fixedCharCodeAt(t, n) - Sz.fixedCharCodeAt(e, n)
            if (i !== 0) {
              return i
            }
          }
          return t.length - e.length
        }
        static fixedCharCodeAt(t, e) {
          e = e || 0
          const n = t.charCodeAt(e)
          let i
          let o
          if (n >= 55296 && n <= 56319) {
            i = n
            o = t.charCodeAt(e + 1)
            if (Number.isNaN(o)) {
              throw Iz.get('exception_high_surrogate')
            }
            return (i - 55296) * 1024 + (o - 56320) + 65536
          }
          if (n >= 56320 && n <= 57343) {
            return false
          }
          return n
        }
        static urlToAssArray(t) {
          let e
          e = t.indexOf('?')
          if (e > 0) {
            const n = t.substring(e + 1)
            const i = n.split('&')
            const o = {}
            for (e = 0; e < i.length; e += 1) {
              const t = i[e]
              const n = t.split('=')
              if (n.length > 1) {
                o[n[0]] = decodeURIComponent(n[1].replace(/\+/g, ' '))
              }
            }
            return o
          }
          return {}
        }
        static urlEncode(t) {
          let e = ''
          e = encodeURIComponent(t)
          return e
        }
        static getWIRISImageOutput(t, e, n) {
          const i = Sz.createObject(t)
          if (i) {
            if (
              i.className === yz.get('imageClassName') ||
              i.getAttribute(yz.get('imageMathmlAttribute'))
            ) {
              if (!e) {
                return t
              }
              const o = i.getAttribute(yz.get('imageMathmlAttribute'))
              let r = Cz.safeXmlDecode(o)
              if (!yz.get('saveHandTraces')) {
                r = Cz.removeAnnotation(r, 'application/json')
              }
              if (r == null) {
                r = i.getAttribute('alt')
              }
              if (n) {
                const t = Cz.safeXmlEncode(r)
                return t
              }
              return r
            }
          }
          return t
        }
        static getNodeLength(t) {
          const e = { IMG: 1, BR: 1 }
          if (t.nodeType === 3) {
            return t.nodeValue.length
          }
          if (t.nodeType === 1) {
            let n = e[t.nodeName.toUpperCase()]
            if (n === undefined) {
              n = 0
            }
            for (let e = 0; e < t.childNodes.length; e += 1) {
              n += Sz.getNodeLength(t.childNodes[e])
            }
            return n
          }
          return 0
        }
        static getSelectedItem(t, e, n) {
          let i
          if (e) {
            i = t.contentWindow
            i.focus()
          } else {
            i = window
            t.focus()
          }
          if (document.selection && !n) {
            const n = i.document.selection.createRange()
            if (n.parentElement) {
              if (n.htmlText.length > 0) {
                if (n.text.length === 0) {
                  return Sz.getSelectedItem(t, e, true)
                }
                return null
              }
              i.document.execCommand('InsertImage', false, '#')
              let o = n.parentElement()
              if (o.nodeName.toUpperCase() !== 'IMG') {
                n.pasteHTML(
                  '<span id="wrs_openEditorWindow_temporalObject"></span>'
                )
                o = i.document.getElementById(
                  'wrs_openEditorWindow_temporalObject'
                )
              }
              let r
              let s
              if (o.nextSibling && o.nextSibling.nodeType === 3) {
                r = o.nextSibling
                s = 0
              } else if (
                o.previousSibling &&
                o.previousSibling.nodeType === 3
              ) {
                r = o.previousSibling
                s = r.nodeValue.length
              } else {
                r = i.document.createTextNode('')
                o.parentNode.insertBefore(r, o)
                s = 0
              }
              o.parentNode.removeChild(o)
              return { node: r, caretPosition: s }
            }
            if (n.length > 1) {
              return null
            }
            return { node: n.item(0) }
          }
          if (i.getSelection) {
            let t
            const e = i.getSelection()
            try {
              t = e.getRangeAt(0)
            } catch (e) {
              t = i.document.createRange()
            }
            const n = t.startContainer
            if (n.nodeType === 3) {
              return { node: n, caretPosition: t.startOffset }
            }
            if (n !== t.endContainer) {
              return null
            }
            if (n.nodeType === 1) {
              const e = t.startOffset
              if (n.childNodes[e]) {
                return { node: n.childNodes[e] }
              }
            }
          }
          return null
        }
        static getSelectedItemOnTextarea(t) {
          const e = document.createTextNode(t.value)
          const n = Tz.getLatexFromTextNode(e, t.selectionStart)
          if (n === null) {
            return null
          }
          return {
            node: e,
            caretPosition: t.selectionStart,
            startPosition: n.startPosition,
            endPosition: n.endPosition
          }
        }
        static getElementsByNameFromString(t, e, n) {
          const i = []
          t = t.toLowerCase()
          e = e.toLowerCase()
          let o = t.indexOf(`<${e} `)
          while (o !== -1) {
            let r
            if (n) {
              r = '>'
            } else {
              r = `</${e}>`
            }
            let s = t.indexOf(r, o)
            if (s !== -1) {
              s += r.length
              i.push({ start: o, end: s })
            } else {
              s = o + 1
            }
            o = t.indexOf(`<${e} `, s)
          }
          return i
        }
        static decode64(t) {
          const e = '+'.charCodeAt(0)
          const n = '/'.charCodeAt(0)
          const i = '0'.charCodeAt(0)
          const o = 'a'.charCodeAt(0)
          const r = 'A'.charCodeAt(0)
          const s = '-'.charCodeAt(0)
          const a = '_'.charCodeAt(0)
          const c = t.charCodeAt(0)
          if (c === e || c === s) {
            return 62
          }
          if (c === n || c === a) {
            return 63
          }
          if (c < i) {
            return -1
          }
          if (c < i + 10) {
            return c - i + 26 + 26
          }
          if (c < r + 26) {
            return c - r
          }
          if (c < o + 26) {
            return c - o + 26
          }
          return null
        }
        static b64ToByteArray(t, e) {
          let n
          if (t.length % 4 > 0) {
            throw new Error('Invalid string. Length must be a multiple of 4')
          }
          const i = []
          let o
          let r
          if (!e) {
            if (t.charAt(t.length - 2) === '=') {
              r = 2
            } else if (t.charAt(t.length - 1) === '=') {
              r = 1
            } else {
              r = 0
            }
            o = r > 0 ? t.length - 4 : t.length
          } else {
            o = e
          }
          let s
          for (s = 0; s < o; s += 4) {
            n =
              (Sz.decode64(t.charAt(s)) << 18) |
              (Sz.decode64(t.charAt(s + 1)) << 12) |
              (Sz.decode64(t.charAt(s + 2)) << 6) |
              Sz.decode64(t.charAt(s + 3))
            i.push((n >> 16) & 255)
            i.push((n >> 8) & 255)
            i.push(n & 255)
          }
          if (r) {
            if (r === 2) {
              n =
                (Sz.decode64(t.charAt(s)) << 2) |
                (Sz.decode64(t.charAt(s + 1)) >> 4)
              i.push(n & 255)
            } else if (r === 1) {
              n =
                (Sz.decode64(t.charAt(s)) << 10) |
                (Sz.decode64(t.charAt(s + 1)) << 4) |
                (Sz.decode64(t.charAt(s + 2)) >> 2)
              i.push((n >> 8) & 255)
              i.push(n & 255)
            }
          }
          return i
        }
        static readInt32(t) {
          if (t.length < 4) {
            return false
          }
          const e = t.splice(0, 4)
          return (e[0] << 24) | (e[1] << 16) | (e[2] << 8) | (e[3] << 0)
        }
        static readByte(t) {
          return t.shift() << 0
        }
        static readBytes(t, e, n) {
          return t.splice(e, n)
        }
        static updateTextArea(t, e) {
          if (t && e) {
            t.focus()
            if (t.selectionStart != null) {
              const { selectionEnd: n } = t
              const i = t.value.substring(0, t.selectionStart)
              const o = t.value.substring(n, t.value.length)
              t.value = i + e + o
              t.selectionEnd = n + e.length
            } else {
              const t = document.selection.createRange()
              t.text = e
            }
          }
        }
        static updateExistingTextOnTextarea(t, e, n, i) {
          t.focus()
          const o = t.value.substring(0, n)
          t.value = o + e + t.value.substring(i, t.value.length)
          t.selectionEnd = n + e.length
        }
        static addArgument(t, e, n) {
          let i
          if (t.indexOf('?') > 0) {
            i = '&'
          } else {
            i = '?'
          }
          return `${t + i + e}=${n}`
        }
      }
      class Bz {
        static removeImgDataAttributes(t) {
          const e = []
          const { attributes: n } = t
          Object.keys(n).forEach((t) => {
            const i = n[t]
            if (
              i !== undefined &&
              i.name !== undefined &&
              i.name.indexOf('data-') === 0
            ) {
              e.push(i.name)
            }
          })
          e.forEach((e) => {
            t.removeAttribute(e)
          })
        }
        static clone(t, e) {
          const n = yz.get('imageCustomEditorName')
          if (!t.hasAttribute(n)) {
            e.removeAttribute(n)
          }
          const i = yz.get('imageMathmlAttribute')
          const o = [i, n, 'alt', 'height', 'width', 'style', 'src', 'role']
          o.forEach((n) => {
            const i = t.getAttribute(n)
            if (i) {
              e.setAttribute(n, i)
            }
          })
        }
        static setImgSize(t, e, n) {
          let i
          let o
          let r
          let s
          if (n) {
            if (yz.get('imageFormat') === 'svg') {
              if (yz.get('saveMode') !== 'base64') {
                i = Bz.getMetricsFromSvgString(e)
              } else {
                o = t.src.substr(t.src.indexOf('base64,') + 7, t.src.length)
                s = ''
                r = Sz.b64ToByteArray(o, o.length)
                for (let t = 0; t < r.length; t += 1) {
                  s += String.fromCharCode(r[t])
                }
                i = Bz.getMetricsFromSvgString(s)
              }
            } else {
              o = t.src.substr(t.src.indexOf('base64,') + 7, t.src.length)
              r = Sz.b64ToByteArray(o, 88)
              i = Bz.getMetricsFromBytes(r)
            }
          } else {
            i = Sz.urlToAssArray(e)
          }
          let a = i.cw
          if (!a) {
            return
          }
          let c = i.ch
          let l = i.cb
          const { dpi: d } = i
          if (d) {
            a = (a * 96) / d
            c = (c * 96) / d
            l = (l * 96) / d
          }
          t.width = a
          t.height = c
          t.style.verticalAlign = `-${c - l}px`
        }
        static fixAfterResize(t) {
          t.removeAttribute('style')
          t.removeAttribute('width')
          t.removeAttribute('height')
          t.style.maxWidth = 'none'
          if (t.src.indexOf('data:image') !== -1) {
            if (yz.get('imageFormat') === 'svg') {
              const e = decodeURIComponent(t.src.substring(32, t.src.length))
              Bz.setImgSize(t, e, true)
            } else {
              const e = t.src.substring(22, t.src.length)
              Bz.setImgSize(t, e, true)
            }
          } else {
            Bz.setImgSize(t, t.src)
          }
        }
        static getMetricsFromSvgString(t) {
          let e = t.indexOf('height="')
          let n = t.indexOf('"', e + 8, t.length)
          const i = t.substring(e + 8, n)
          e = t.indexOf('width="')
          n = t.indexOf('"', e + 7, t.length)
          const o = t.substring(e + 7, n)
          e = t.indexOf('wrs:baseline="')
          n = t.indexOf('"', e + 14, t.length)
          const r = t.substring(e + 14, n)
          if (typeof o !== 'undefined') {
            const t = []
            t.cw = o
            t.ch = i
            if (typeof r !== 'undefined') {
              t.cb = r
            }
            return t
          }
          return []
        }
        static getMetricsFromBytes(t) {
          Sz.readBytes(t, 0, 8)
          let e
          let n
          let i
          let o
          let r
          while (t.length >= 4) {
            i = Sz.readInt32(t)
            if (i === 1229472850) {
              e = Sz.readInt32(t)
              n = Sz.readInt32(t)
              Sz.readInt32(t)
              Sz.readByte(t)
            } else if (i === 1650545477) {
              o = Sz.readInt32(t)
            } else if (i === 1883789683) {
              r = Sz.readInt32(t)
              r = Math.round(r / 39.37)
              Sz.readInt32(t)
              Sz.readByte(t)
            }
            Sz.readInt32(t)
          }
          if (typeof e !== 'undefined') {
            const t = []
            t.cw = e
            t.ch = n
            t.dpi = r
            if (o) {
              t.cb = o
            }
            return t
          }
          return []
        }
      }
      class Nz {
        static get cache() {
          return Nz._cache
        }
        static set cache(t) {
          Nz._cache = t
        }
        static mathMLToAccessible(t, e, n) {
          if (typeof e === 'undefined') {
            e = 'en'
          }
          if (Cz.containClass(t, 'wrs_chemistry')) {
            n.mode = 'chemistry'
          }
          n.ignoreStyles = true
          let i = ''
          if (Nz.cache.get(t)) {
            i = Nz.cache.get(t)
          } else {
            n.service = 'mathml2accessible'
            n.lang = e
            const o = JSON.parse(Dz.getService('service', n))
            if (o.status !== 'error') {
              i = o.result.text
              Nz.cache.populate(t, i)
            } else {
              i = Iz.get('error_convert_accessibility')
            }
          }
          return i
        }
      }
      Nz._cache = new xz()
      var Pz = __webpack_require__(6209)
      class zz {
        static mathmlToImgObject(t, e, n, i) {
          const o = t.createElement('img')
          o.align = 'middle'
          o.style.maxWidth = 'none'
          let r = n || {}
          const s = yz.get('editorParameters')
          r = { ...s, ...r }
          r.mml = e
          r.lang = i
          r.metrics = 'true'
          r.centerbaseline = 'false'
          if (
            yz.get('saveMode') === 'base64' &&
            yz.get('base64savemode') === 'default'
          ) {
            r.base64 = true
          }
          o.className = yz.get('imageClassName')
          if (e.indexOf('class="') !== -1) {
            let t = e.substring(
              e.indexOf('class="') + 'class="'.length,
              e.length
            )
            t = t.substring(0, t.indexOf('"'))
            t = t.substring(4, t.length)
            o.setAttribute(yz.get('imageCustomEditorName'), t)
          }
          if (
            yz.get('wirisPluginPerformance') &&
            (yz.get('saveMode') === 'xml' || yz.get('saveMode') === 'safeXml')
          ) {
            let t = JSON.parse(zz.createShowImageSrc(r, i))
            if (t.status === 'warning') {
              try {
                t = JSON.parse(Dz.getService('showimage', r))
              } catch (t) {
                return null
              }
            }
            ;({ result: t } = t)
            if (t.format === 'png') {
              o.src = `data:image/png;base64,${t.content}`
            } else {
              o.src = `data:image/svg+xml;charset=utf8,${Sz.urlEncode(
                t.content
              )}`
            }
            o.setAttribute(yz.get('imageMathmlAttribute'), Cz.safeXmlEncode(e))
            Bz.setImgSize(o, t.content, true)
            if (yz.get('enableAccessibility')) {
              if (typeof t.alt === 'undefined') {
                o.alt = Nz.mathMLToAccessible(e, i, r)
              } else {
                o.alt = t.alt
              }
            }
          } else {
            const t = zz.createImageSrc(e, r)
            o.setAttribute(yz.get('imageMathmlAttribute'), Cz.safeXmlEncode(e))
            o.src = t
            Bz.setImgSize(
              o,
              t,
              yz.get('saveMode') === 'base64' &&
                yz.get('base64savemode') === 'default'
            )
            if (yz.get('enableAccessibility')) {
              o.alt = Nz.mathMLToAccessible(e, i, r)
            }
          }
          if (typeof zz.observer !== 'undefined') {
            zz.observer.observe(o)
          }
          o.setAttribute('role', 'math')
          return o
        }
        static createImageSrc(t, e) {
          if (
            yz.get('saveMode') === 'base64' &&
            yz.get('base64savemode') === 'default'
          ) {
            e.base64 = true
          }
          let n = Dz.getService('createimage', e)
          if (n.indexOf('@BASE@') !== -1) {
            const t = Dz.getServicePath('createimage').split('/')
            t.pop()
            n = n.split('@BASE@').join(t.join('/'))
          }
          return n
        }
        static initParse(t, e) {
          t = zz.initParseSaveMode(t, e)
          return zz.initParseEditMode(t)
        }
        static initParseSaveMode(t, e) {
          if (yz.get('saveMode')) {
            t = Tz.parseMathmlToLatex(t, vz.safeXmlCharacters)
            t = Tz.parseMathmlToLatex(t, vz.xmlCharacters)
            t = zz.parseMathmlToImg(t, vz.safeXmlCharacters, e)
            t = zz.parseMathmlToImg(t, vz.xmlCharacters, e)
            if (
              yz.get('saveMode') === 'base64' &&
              yz.get('base64savemode') === 'image'
            ) {
              t = zz.codeImgTransform(t, 'base642showimage')
            }
          }
          return t
        }
        static initParseEditMode(t) {
          if (yz.get('parseModes').indexOf('latex') !== -1) {
            const e = Sz.getElementsByNameFromString(t, 'img', true)
            const n = 'encoding="LaTeX">'
            let i = 0
            for (let o = 0; o < e.length; o += 1) {
              const r = t.substring(e[o].start + i, e[o].end + i)
              if (r.indexOf(` class="${yz.get('imageClassName')}"`) !== -1) {
                let s = ` ${yz.get('imageMathmlAttribute')}="`
                let a = r.indexOf(s)
                if (a === -1) {
                  s = ' alt="'
                  a = r.indexOf(s)
                }
                if (a !== -1) {
                  a += s.length
                  const c = r.indexOf('"', a)
                  const l = Sz.htmlSanitize(Cz.safeXmlDecode(r.substring(a, c)))
                  let d = l.indexOf(n)
                  if (d !== -1) {
                    d += n.length
                    const r = l.indexOf('</annotation>', d)
                    const s = l.substring(d, r)
                    const a = `$$${Sz.htmlEntitiesDecode(s)}$$`
                    const c = t.substring(0, e[o].start + i)
                    const u = t.substring(e[o].end + i)
                    t = c + a + u
                    i += a.length - (e[o].end - e[o].start)
                  }
                }
              }
            }
          }
          return t
        }
        static endParse(t) {
          const e = zz.endParseEditMode(t)
          const n = zz.endParseSaveMode(e)
          return n
        }
        static endParseEditMode(t) {
          if (yz.get('parseModes').indexOf('latex') !== -1) {
            let e = ''
            let n = 0
            let i = t.indexOf('$$')
            while (i !== -1) {
              e += t.substring(n, i)
              n = t.indexOf('$$', i + 2)
              if (n !== -1) {
                const o = t.substring(i + 2, n)
                const r = Sz.htmlEntitiesDecode(o)
                let s = Sz.htmlSanitize(Tz.getMathMLFromLatex(r, true))
                if (!yz.get('saveHandTraces')) {
                  s = Cz.removeAnnotation(s, 'application/json')
                }
                e += s
                n += 2
              } else {
                e += '$$'
                n = i + 2
              }
              i = t.indexOf('$$', n)
            }
            e += t.substring(n, t.length)
            t = e
          }
          return t
        }
        static endParseSaveMode(t) {
          if (yz.get('saveMode')) {
            if (yz.get('saveMode') === 'safeXml') {
              t = zz.codeImgTransform(t, 'img2mathml')
            } else if (yz.get('saveMode') === 'xml') {
              t = zz.codeImgTransform(t, 'img2mathml')
            } else if (
              yz.get('saveMode') === 'base64' &&
              yz.get('base64savemode') === 'image'
            ) {
              t = zz.codeImgTransform(t, 'img264')
            }
          }
          return t
        }
        static createShowImageSrc(t, e) {
          const n = {}
          const i = [
            'mml',
            'color',
            'centerbaseline',
            'zoom',
            'dpi',
            'fontSize',
            'fontFamily',
            'defaultStretchy',
            'backgroundColor',
            'format'
          ]
          i.forEach((e) => {
            if (typeof t[e] !== 'undefined') {
              n[e] = t[e]
            }
          })
          const o = {}
          Object.keys(t).forEach((e) => {
            if (e !== 'mml') {
              o[e] = t[e]
            }
          })
          o.formula = com.wiris.js.JsPluginTools.md5encode(
            Sz.propertiesToString(n)
          )
          o.lang = typeof e === 'undefined' ? 'en' : e
          o.version = yz.get('version')
          const r = Dz.getService('showimage', Sz.httpBuildQuery(o), true)
          return r
        }
        static codeImgTransform(t, e) {
          let n = ''
          let i = 0
          const o = /<img/gi
          const r = o.source.length
          while (o.test(t)) {
            const s = o.lastIndex - r
            n += t.substring(i, s)
            let a = s + 1
            while (a < t.length && i <= s) {
              const e = t.charAt(a)
              if (e === '"' || e === "'") {
                const n = t.indexOf(e, a + 1)
                if (n === -1) {
                  a = t.length
                } else {
                  a = n
                }
              } else if (e === '>') {
                i = a + 1
              }
              a += 1
            }
            if (i < s) {
              n += t.substring(s, t.length)
              return n
            }
            let c = t.substring(s, i)
            const l = Sz.createObject(c)
            let d = l.getAttribute(yz.get('imageMathmlAttribute'))
            let u
            let h
            if (e === 'base642showimage') {
              if (d == null) {
                d = l.getAttribute('alt')
              }
              d = Cz.safeXmlDecode(d)
              c = zz.mathmlToImgObject(document, d, null, null)
              n += Sz.createObjectCode(c)
            } else if (e === 'img2mathml') {
              if (yz.get('saveMode')) {
                if (yz.get('saveMode') === 'safeXml') {
                  u = true
                  h = true
                } else if (yz.get('saveMode') === 'xml') {
                  u = true
                  h = false
                }
              }
              n += Sz.getWIRISImageOutput(c, u, h)
            } else if (e === 'img264') {
              if (d === null) {
                d = l.getAttribute('alt')
              }
              d = Cz.safeXmlDecode(d)
              const t = {}
              t.base64 = 'true'
              c = zz.mathmlToImgObject(document, d, t, null)
              Bz.setImgSize(c, c.src, true)
              n += Sz.createObjectCode(c)
            }
          }
          n += t.substring(i, t.length)
          return n
        }
        static parseMathmlToImg(t, e, n) {
          let i = ''
          const o = `${e.tagOpener}math`
          const r = `${e.tagOpener}/math${e.tagCloser}`
          let s = t.indexOf(o)
          let a = 0
          while (s !== -1) {
            i += t.substring(a, s)
            const c = t.indexOf(yz.get('imageMathmlAttribute'))
            a = t.indexOf(r, s)
            if (a === -1) {
              a = t.length - 1
            } else if (c !== -1) {
              a += t.indexOf('/>', s)
            } else {
              a += r.length
            }
            if (!Cz.isMathmlInAttribute(t, s) && c === -1) {
              let o = t.substring(s, a)
              o =
                e.id === vz.safeXmlCharacters.id
                  ? Cz.safeXmlDecode(o)
                  : Cz.mathMLEntities(o)
              i += Sz.createObjectCode(
                zz.mathmlToImgObject(document, o, null, n)
              )
            } else {
              i += t.substring(s, a)
            }
            s = t.indexOf(o, a)
          }
          i += t.substring(a, t.length)
          return i
        }
      }
      if (typeof MutationObserver !== 'undefined') {
        const t = new MutationObserver((t) => {
          t.forEach((t) => {
            if (
              t.oldValue === yz.get('imageClassName') &&
              t.attributeName === 'class' &&
              t.target.className.indexOf(yz.get('imageClassName')) === -1
            ) {
              t.target.className = yz.get('imageClassName')
            }
          })
        })
        zz.observer = Object.create(t)
        zz.observer.Config = { attributes: true, attributeOldValue: true }
        zz.observer.observe = function (t) {
          Object.getPrototypeOf(this).observe(t, this.Config)
        }
      }
      class Lz {
        constructor() {
          this.isContentChanged = false
          this.waitingForChanges = false
        }
        setIsContentChanged(t) {
          this.isContentChanged = t
        }
        getIsContentChanged() {
          return this.isContentChanged
        }
        setWaitingForChanges(t) {
          this.waitingForChanges = t
        }
        caretPositionChanged(t) {}
        clipboardChanged(t) {}
        contentChanged(t) {
          if (
            this.waitingForChanges === true &&
            this.isContentChanged === false
          ) {
            this.isContentChanged = true
          }
        }
        styleChanged(t) {}
        transformationReceived(t) {}
      }
      class Oz {
        constructor(t) {
          this.editorAttributes = {}
          if ('editorAttributes' in t) {
            this.editorAttributes = t.editorAttributes
          } else {
            throw new Error(
              'ContentManager constructor error: editorAttributes property missed.'
            )
          }
          this.customEditors = null
          if ('customEditors' in t) {
            this.customEditors = t.customEditors
          }
          this.environment = {}
          if ('environment' in t) {
            this.environment = t.environment
          } else {
            throw new Error(
              'ContentManager constructor error: environment property missed'
            )
          }
          this.language = ''
          if ('language' in t) {
            this.language = t.language
          } else {
            throw new Error(
              'ContentManager constructor error: language property missed'
            )
          }
          this.editorListener = new Lz()
          this.editor = null
          this.ua = navigator.userAgent.toLowerCase()
          this.deviceProperties = {}
          this.deviceProperties.isAndroid = this.ua.indexOf('android') > -1
          this.deviceProperties.isIOS = Oz.isIOS()
          this.toolbar = null
          this.modalDialogInstance = null
          this.listeners = new Ez()
          this.mathML = null
          this.isNewElement = true
          this.integrationModel = null
        }
        addListener(t) {
          this.listeners.add(t)
        }
        setIntegrationModel(t) {
          this.integrationModel = t
        }
        setModalDialogInstance(t) {
          this.modalDialogInstance = t
        }
        insert() {
          this.updateTitle(this.modalDialogInstance)
          this.insertEditor(this.modalDialogInstance)
        }
        insertEditor() {
          if (Oz.isEditorLoaded()) {
            this.editor = window.com.wiris.jsEditor.JsEditor.newInstance(
              this.editorAttributes
            )
            this.editor.insertInto(this.modalDialogInstance.contentContainer)
            this.editor.focus()
            if (this.modalDialogInstance.rtl) {
              this.editor.action('rtl')
            }
            if (this.editor.getEditorModel().isRTL()) {
              this.editor.element.style.direction = 'rtl'
            }
            this.editor.getEditorModel().addEditorListener(this.editorListener)
            if (this.modalDialogInstance.deviceProperties.isIOS) {
              setTimeout(function () {
                if (this.hasOwnProperty('modalDialogInstance'))
                  this.modalDialogInstance.hideKeyboard()
              }, 400)
              const t = document.getElementsByClassName('wrs_formulaDisplay')[0]
              Sz.addEvent(
                t,
                'focus',
                this.modalDialogInstance.handleOpenedIosSoftkeyboard
              )
              Sz.addEvent(
                t,
                'blur',
                this.modalDialogInstance.handleClosedIosSoftkeyboard
              )
            }
            this.listeners.fire('onLoad', {})
          } else {
            setTimeout(Oz.prototype.insertEditor.bind(this), 100)
          }
        }
        init() {
          if (!Oz.isEditorLoaded()) {
            this.addEditorAsExternalDependency()
          }
        }
        addEditorAsExternalDependency() {
          const t = document.createElement('script')
          t.type = 'text/javascript'
          let e = yz.get('editorUrl')
          const n = document.createElement('a')
          Oz.setHrefToAnchorElement(n, e)
          Oz.setProtocolToAnchorElement(n)
          e = Oz.getURLFromAnchorElement(n)
          const i = this.getEditorStats()
          t.src = `${e}?lang=${this.language}&stats-editor=${i.editor}&stats-mode=${i.mode}&stats-version=${i.version}`
          document.getElementsByTagName('head')[0].appendChild(t)
        }
        static setHrefToAnchorElement(t, e) {
          t.href = e
        }
        static setProtocolToAnchorElement(t) {
          if (window.location.href.indexOf('https://') === 0) {
            if (t.protocol === 'http:') {
              t.protocol = 'https:'
            }
          }
        }
        static getURLFromAnchorElement(t) {
          const e = t.port === '80' || t.port === '443' || t.port === ''
          return `${t.protocol}//${t.hostname}${e ? '' : `:${t.port}`}${
            t.pathname.startsWith('/') ? t.pathname : `/${t.pathname}`
          }`
        }
        getEditorStats() {
          const t = {}
          if ('editor' in this.environment) {
            t.editor = this.environment.editor
          } else {
            t.editor = 'unknown'
          }
          if ('mode' in this.environment) {
            t.mode = this.environment.mode
          } else {
            t.mode = yz.get('saveMode')
          }
          if ('version' in this.environment) {
            t.version = this.environment.version
          } else {
            t.version = yz.get('version')
          }
          return t
        }
        static isIOS() {
          return (
            [
              'iPad Simulator',
              'iPhone Simulator',
              'iPod Simulator',
              'iPad',
              'iPhone',
              'iPod'
            ].includes(navigator.platform) ||
            (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
          )
        }
        static isEditorLoaded() {
          return (
            window.com &&
            window.com.wiris &&
            window.com.wiris.jsEditor &&
            window.com.wiris.jsEditor.JsEditor &&
            window.com.wiris.jsEditor.JsEditor.newInstance
          )
        }
        setInitialContent() {
          if (!this.isNewElement) {
            this.setMathML(this.mathML)
          }
        }
        setMathML(t, e) {
          if (typeof e === 'undefined') {
            e = false
          }
          this.editor.setMathMLWithCallback(t, () => {
            this.editorListener.setWaitingForChanges(true)
          })
          setTimeout(() => {
            this.editorListener.setIsContentChanged(false)
          }, 500)
          if (!e) {
            this.onFocus()
          }
        }
        onFocus() {
          if (typeof this.editor !== 'undefined' && this.editor != null) {
            this.editor.focus()
          }
        }
        submitAction() {
          if (!this.editor.isFormulaEmpty()) {
            let t = this.editor.getMathMLWithSemantics()
            if (this.customEditors.getActiveEditor() !== null) {
              const { toolbar: e } = this.customEditors.getActiveEditor()
              t = Cz.addCustomEditorClassAttribute(t, e)
            } else {
              Object.keys(this.customEditors.editors).forEach((e) => {
                t = Cz.removeCustomEditorClassAttribute(t, e)
              })
            }
            const e = Cz.mathMLEntities(t)
            this.integrationModel.updateFormula(e)
          } else {
            this.integrationModel.updateFormula(null)
          }
          this.customEditors.disable()
          this.integrationModel.notifyWindowClosed()
          this.setEmptyMathML()
          this.customEditors.disable()
        }
        setEmptyMathML() {
          if (this.deviceProperties.isAndroid || this.deviceProperties.isIOS) {
            if (this.editor.getEditorModel().isRTL()) {
              this.setMathML(
                '<math dir="rtl"><semantics><annotation encoding="application/json">[]</annotation></semantics></math>',
                true
              )
            } else {
              this.setMathML(
                '<math><semantics><annotation encoding="application/json">[]</annotation></semantics></math>',
                true
              )
            }
          } else if (this.editor.getEditorModel().isRTL()) {
            this.setMathML('<math dir="rtl"/>', true)
          } else {
            this.setMathML('<math/>', true)
          }
        }
        onOpen() {
          if (this.isNewElement) {
            this.setEmptyMathML()
          } else {
            this.setMathML(this.mathML)
          }
          this.updateToolbar()
          this.onFocus()
          if (this.deviceProperties.isIOS) {
            const t = document.documentElement.clientWidth / window.innerWidth
            if (t !== 1) {
              this.setKeyboardMode()
            }
          }
        }
        setKeyboardMode() {
          const t = document.getElementsByClassName(
            'wrs_handOpen wrs_disablePalette'
          )[0]
          if (t) {
            t.classList.remove('wrs_handOpen')
            t.classList.remove('wrs_disablePalette')
          } else {
            setTimeout(Oz.prototype.setKeyboardMode.bind(this), 100)
          }
        }
        updateToolbar() {
          this.updateTitle(this.modalDialogInstance)
          const t = this.customEditors.getActiveEditor()
          if (t) {
            const e = t.toolbar ? t.toolbar : _wrs_int_wirisProperties.toolbar
            if (this.toolbar == null || this.toolbar !== e) {
              this.setToolbar(e)
            }
          } else {
            const t = this.getToolbar()
            if (this.toolbar == null || this.toolbar !== t) {
              this.setToolbar(t)
              this.customEditors.disable()
            }
          }
        }
        updateTitle() {
          const t = this.customEditors.getActiveEditor()
          if (t) {
            this.modalDialogInstance.setTitle(t.title)
          } else {
            this.modalDialogInstance.setTitle('MathType')
          }
        }
        getToolbar() {
          let t = 'general'
          if ('toolbar' in this.editorAttributes) {
            ;({ toolbar: t } = this.editorAttributes)
          }
          if (t === 'general') {
            t =
              typeof _wrs_int_wirisProperties === 'undefined' ||
              typeof _wrs_int_wirisProperties.toolbar === 'undefined'
                ? 'general'
                : _wrs_int_wirisProperties.toolbar
          }
          return t
        }
        setToolbar(t) {
          this.toolbar = t
          this.editor.setParams({ toolbar: this.toolbar })
        }
        hasChanges() {
          return (
            !this.editor.isFormulaEmpty() &&
            this.editorListener.getIsContentChanged()
          )
        }
        onKeyDown(t) {
          if (t.key !== undefined && t.repeat === false) {
            if (t.key === 'Escape' || t.key === 'Esc') {
              let e = document.getElementsByClassName(
                'wrs_expandButton wrs_expandButtonFor3RowsLayout wrs_pressed'
              )
              if (e.length === 0) {
                e = document.getElementsByClassName(
                  'wrs_expandButton wrs_expandButtonFor2RowsLayout wrs_pressed'
                )
                if (e.length === 0) {
                  e = document.getElementsByClassName('wrs_select wrs_pressed')
                  if (e.length === 0) {
                    this.modalDialogInstance.cancelAction()
                    t.stopPropagation()
                    t.preventDefault()
                  }
                }
              }
            } else if (t.shiftKey && t.key === 'Tab') {
              if (
                document.activeElement === this.modalDialogInstance.submitButton
              ) {
                this.editor.focus()
                t.stopPropagation()
                t.preventDefault()
              } else {
                const e = document.querySelector('[title="Manual"]')
                if (document.activeElement === e) {
                  this.modalDialogInstance.cancelButton.focus()
                  t.stopPropagation()
                  t.preventDefault()
                }
              }
            } else if (t.key === 'Tab') {
              if (
                document.activeElement === this.modalDialogInstance.cancelButton
              ) {
                const e = document.querySelector('[title="Manual"]')
                e.focus()
                t.stopPropagation()
                t.preventDefault()
              } else {
                const e =
                  document.getElementsByClassName('wrs_formulaDisplay')[0]
                if (
                  e.getAttribute('class') === 'wrs_formulaDisplay wrs_focused'
                ) {
                  this.modalDialogInstance.submitButton.focus()
                  t.stopPropagation()
                  t.preventDefault()
                }
              }
            }
          }
        }
      }
      class Rz {
        constructor() {
          this.editors = []
          this.activeEditor = 'default'
        }
        addEditor(t, e) {
          const n = {}
          n.name = e.name
          n.toolbar = e.toolbar
          n.icon = e.icon
          n.confVariable = e.confVariable
          n.title = e.title
          n.tooltip = e.tooltip
          this.editors[t] = n
        }
        enable(t) {
          this.activeEditor = t
        }
        disable() {
          this.activeEditor = 'default'
        }
        getActiveEditor() {
          if (this.activeEditor !== 'default') {
            return this.editors[this.activeEditor]
          }
          return null
        }
      }
      const jz = {
        imageCustomEditorName: 'data-custom-editor',
        imageClassName: 'Wirisformula',
        CASClassName: 'Wiriscas'
      }
      const Fz = jz
      class Vz {
        constructor() {
          this.cancelled = false
          this.defaultPrevented = false
        }
        cancel() {
          this.cancelled = true
        }
        preventDefault() {
          this.defaultPrevented = true
        }
      }
      class Hz {
        constructor(t) {
          this.overlayElement = t.overlayElement
          this.callbacks = t.callbacks
          this.overlayWrapper = this.overlayElement.appendChild(
            document.createElement('div')
          )
          this.overlayWrapper.setAttribute(
            'class',
            'wrs_popupmessage_overlay_envolture'
          )
          this.message = this.overlayWrapper.appendChild(
            document.createElement('div')
          )
          this.message.id = 'wrs_popupmessage'
          this.message.setAttribute('class', 'wrs_popupmessage_panel')
          this.message.setAttribute('role', 'dialog')
          this.message.setAttribute('aria-describedby', 'description_txt')
          const e = document.createElement('p')
          const n = document.createTextNode(t.strings.message)
          e.appendChild(n)
          e.id = 'description_txt'
          this.message.appendChild(e)
          const i = this.overlayWrapper.appendChild(
            document.createElement('div')
          )
          i.setAttribute('class', 'wrs_popupmessage_overlay')
          i.addEventListener('click', this.cancelAction.bind(this))
          this.buttonArea = this.message.appendChild(
            document.createElement('div')
          )
          this.buttonArea.setAttribute('class', 'wrs_popupmessage_button_area')
          this.buttonArea.id = 'wrs_popup_button_area'
          const o = {
            class: 'wrs_button_accept',
            innerHTML: t.strings.submitString,
            id: 'wrs_popup_accept_button'
          }
          this.closeButton = this.createButton(o, this.closeAction.bind(this))
          this.buttonArea.appendChild(this.closeButton)
          const r = {
            class: 'wrs_button_cancel',
            innerHTML: t.strings.cancelString,
            id: 'wrs_popup_cancel_button'
          }
          this.cancelButton = this.createButton(r, this.cancelAction.bind(this))
          this.buttonArea.appendChild(this.cancelButton)
        }
        createButton(t, e) {
          let n = {}
          n = document.createElement('button')
          n.setAttribute('id', t.id)
          n.setAttribute('class', t.class)
          n.innerHTML = t.innerHTML
          n.addEventListener('click', e)
          return n
        }
        show() {
          if (this.overlayWrapper.style.display !== 'block') {
            document.activeElement.blur()
            this.overlayWrapper.style.display = 'block'
            this.closeButton.focus()
          } else {
            this.overlayWrapper.style.display = 'none'
          }
        }
        cancelAction() {
          this.overlayWrapper.style.display = 'none'
          if (typeof this.callbacks.cancelCallback !== 'undefined') {
            this.callbacks.cancelCallback()
            CL.setActionsOnCancelButtons()
          }
        }
        closeAction() {
          this.cancelAction()
          if (typeof this.callbacks.closeCallback !== 'undefined') {
            this.callbacks.closeCallback()
          }
        }
        onKeyDown(t) {
          if (t.key !== undefined) {
            if (t.key === 'Escape' || t.key === 'Esc') {
              this.cancelAction()
              t.stopPropagation()
              t.preventDefault()
            } else if (t.key === 'Tab') {
              if (document.activeElement === this.closeButton) {
                this.cancelButton.focus()
              } else {
                this.closeButton.focus()
              }
              t.stopPropagation()
              t.preventDefault()
            }
          }
        }
      }
      var Uz
      var Wz = new Uint8Array(16)
      function qz() {
        if (!Uz) {
          Uz =
            (typeof crypto !== 'undefined' &&
              crypto.getRandomValues &&
              crypto.getRandomValues.bind(crypto)) ||
            (typeof msCrypto !== 'undefined' &&
              typeof msCrypto.getRandomValues === 'function' &&
              msCrypto.getRandomValues.bind(msCrypto))
          if (!Uz) {
            throw new Error(
              'crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported'
            )
          }
        }
        return Uz(Wz)
      }
      const $z =
        /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i
      function Gz(t) {
        return typeof t === 'string' && $z.test(t)
      }
      const Yz = Gz
      var Kz = []
      for (var Qz = 0; Qz < 256; ++Qz) {
        Kz.push((Qz + 256).toString(16).substr(1))
      }
      function Zz(t) {
        var e =
          arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0
        var n = (
          Kz[t[e + 0]] +
          Kz[t[e + 1]] +
          Kz[t[e + 2]] +
          Kz[t[e + 3]] +
          '-' +
          Kz[t[e + 4]] +
          Kz[t[e + 5]] +
          '-' +
          Kz[t[e + 6]] +
          Kz[t[e + 7]] +
          '-' +
          Kz[t[e + 8]] +
          Kz[t[e + 9]] +
          '-' +
          Kz[t[e + 10]] +
          Kz[t[e + 11]] +
          Kz[t[e + 12]] +
          Kz[t[e + 13]] +
          Kz[t[e + 14]] +
          Kz[t[e + 15]]
        ).toLowerCase()
        if (!Yz(n)) {
          throw TypeError('Stringified UUID is invalid')
        }
        return n
      }
      const Jz = Zz
      function Xz(t, e, n) {
        t = t || {}
        var i = t.random || (t.rng || qz)()
        i[6] = (i[6] & 15) | 64
        i[8] = (i[8] & 63) | 128
        if (e) {
          n = n || 0
          for (var o = 0; o < 16; ++o) {
            e[n + o] = i[o]
          }
          return e
        }
        return Jz(i)
      }
      const tL = Xz
      const eL = 'wiris_telemetry_mathtype_web_senderid'
      const nL = 60 * 60 * 24 * 365 * 10
      const iL = {
        local: 'http://localhost:4000',
        production: 'https://telemetry.wiris.net'
      }
      class oL {
        constructor() {
          throw new Error('Static class StringManager can not be instantiated.')
        }
        static get senderId() {
          if (!this._senderId) {
            const t = document.cookie.split(';').map((t) => t.trim().split('='))
            for (const [e, n] of t) {
              if (e === eL) {
                this._senderId = n
                break
              }
            }
            if (!this._senderId) {
              this._senderId = oL.composeUUID()
              document.cookie = this.composeCookie(eL, this._senderId, nL)
            }
          }
          return this._senderId
        }
        static get sessionId() {
          if (!this._sessionId) {
            this._sessionId = oL.composeUUID()
          }
          return this._sessionId
        }
        static send(t) {
          const e = {
            method: 'POST',
            cache: 'no-cache',
            headers: {
              'Content-Type': 'application/json',
              'X-Api-Key': 'CK20op1pOx2LAUjPFP7kB2UPveHZRidG51UJE26m',
              'Accept-Version': '1'
            },
            body: JSON.stringify(oL.composeBody(t))
          }
          return fetch(oL.endpoint, e)
            .then((t) => t)
            .catch((t) => {
              console.warn(t)
            })
        }
        static get session() {
          return { id: oL.sessionId, page: 0 }
        }
        static get sender() {
          return {
            id: oL.senderId,
            os: navigator.oscpu,
            user_agent: window.navigator.userAgent,
            domain: window.location.hostname,
            deployment: oL.deployment,
            editor_version: WirisPlugin.currentInstance.environment
              .editorVersion
              ? WirisPlugin.currentInstance.environment.editorVersion
              : '',
            language: WirisPlugin.currentInstance.language,
            product_version: WirisPlugin.currentInstance.version,
            backend: WirisPlugin.currentInstance.serviceProviderProperties
              .server
              ? WirisPlugin.currentInstance.serviceProviderProperties.server
              : ''
          }
        }
        static get deployment() {
          const { editor: t } = WirisPlugin.currentInstance.environment
          const e = 'mathtype-web-plugin-'
          let n = ''
          if (/Generic/.test(t)) {
            n = 'generic'
          } else if (/Froala/.test(t)) {
            n = 'froala'
          } else if (/CKEditor/.test(t)) {
            n = 'ckeditor'
          } else if (/TinyMCE/.test(t)) {
            n = 'tinymce'
          }
          return `${e}${n}`
        }
        static composeBody(t) {
          const e = { messages: t, sender: oL.sender, session: oL.session }
          return e
        }
        static composeUUID() {
          return tL()
        }
        static composeSenderUUID() {
          return this.composeUUID()
        }
        static composeCookie(t, e, n) {
          const i = n == null ? '' : `; max-age=${n}`
          return `${t}=${e}${i}`
        }
      }
      oL.endpoint = iL.production
      oL._senderId = ''
      oL._sessionId = ''
      const rL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3783"\n   version="1.1">\n  <metadata\n     id="metadata3789">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3787" />\n  <image\n     y="0"\n     x="0"\n     id="image3791"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB\nvklEQVRYw83Z23GDMBAF0AsNhBIowSVQgjuISnAJKSEdZNOBS6CDOBUkqSC4gs2PyGhAQg92se4M\n4w8bccYW2hVumBmRdAB6ADfopQcw2SOYNoIkAL8APgB8AzgLI0/2S/iy1xkt3B9m9h0dM9/YHxM4\nJ/c4MfPkGX+y763OyYVKgUPQTXAJdC84Bg2CS6Gl4FSoF7wHmgvOhbrgzsW+8L4YJegccrEj749R\ngs7ZXGdz8wbAeNbREcDTzrHvblEgBbAUFACuy6JALJeL0E/P9sbvmBnNojcgAM+oJ58AhrlnWM5Z\nA+C9RmiokakBvIJuNTLSc7hojqY0Mo8EB6Ep2CPBm9BU7BHgKDQHqwlOguZiNcDJ0JLe4FV4iaLY\nJjF16dLqnoob+EdDs8A1QJPBtUCTwDVBo+DaoJvgNvBIR6rDl9wirbA1QIPgVgl6VwHb+dAr7Jkk\nS/Pg3mCkVOslxxV9yBFqSqTA/3N2Utkzye3pftw5OxzQ5tHeddcdzGj3o4VgClUwowgtAVOs3BpF\naA6YUnsDowhNAVNu12UUoVtgCn2+ifxp1wO42Ner4KPR5dJ2tsse2ZLvTQxbVf4AmC2z7WnSvpIA\nAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const sL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg2"\n   version="1.1">\n  <metadata\n     id="metadata8">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs6" />\n  <image\n     y="0"\n     x="0"\n     id="image10"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB\n2ElEQVRYw9XZoXPCMBTH8S+5KfDzQ29606CH3/SmQTO96aGHHn/F0Himh8eDZSblQknSJH2F0DtE\nQw8+12vyfulr7XY7LuW4qvj+DugD18AC+AE2woa+/mz07y9cF7Y8d7YPDEtjK2AsCB4BvdLYHPi0\nXawioAA3wAfQaQiKHhuFYl1QSbAL6gWrSKgEuArqBKsEaB1wKNQKVsasHybcpRhwLNQED0zsoMbz\nFwJOhWL6Cmzd2e0D14Wi1/k9di2wFNnAEtBifd9jv4GtIPgaeBOCAkzLFayr/6idWSSY6DJ8sHT9\n6VK6zRFqKwo5gQ+grnKbA/gI6gsy5wRboT7sucBOaBX21GAvNAR7KnAlNBTbNDgIGoMtwO/C0Gko\nNBZbN525tk+dJrAj4F4YGxXgVQS019DkCgarM0OjwCoDaDBYZQINAquMoJVglRnUC1YZQp1g1RB0\nJryn65jYJ0HoRGPHguDX8hsZ6VAiGX4eUrJBbHqSArdN7LLBmCcBnpvYWfHWo6E8Wge8Ar7Kj8E4\nARwcnBPBB20BE7uJBMdAU8BH/YvyBAsFp0BjwNZGi201qALXgYaAnR0hX2upAzwDj/p8raFL5I4u\n8ALc6vNfvc+ztq5al9Rh/AfwZZ/LmlMllAAAAABJRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const aL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3793"\n   version="1.1">\n  <metadata\n     id="metadata3799">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3797" />\n  <image\n     y="0"\n     x="0"\n     id="image3801"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAG4SURBVFhHvZnhUYNAEEbRBkwH2oGUkA40FWgJ\nKSEdaAmxA0vQDmIHKSFWgPuAHZkEAnd8y5v5kuNHMm+WY1mSm6qqCiGlZdUspXzxopY9Wu6bpZQf\nSxlRWapwVx9p2dy2CxUHy9ryWx9pKdWyECYcIQshwlGyIBeOlAWpcLQsyISXkAWEX5tlPkvJwnP7\nns1SsnvLS7PMZwlZiShEy8pEIVJWKgpRsnJRiJBNFf2wbCzjfZgRUZi9JYWDxT9bWk6WIXbKym4t\nKRVloObO5oze6ZClWX9a5jyOcOrfmuUkXPRUH/1zVRhZpvsnCxN+jnDqHh0SdQaFu9vg0ZIqrBZ1\neoXP92yKcJSocyHcd4FNEY4WdbrCR1rGrukMF9BWVhZvLZ7U9rS2nH9HVvoq63iFu+RUlOpIuCYL\nCCPIqVjq1A9j5R3aBnMY2kKzMlbZHPQVbVHLhomCUjZUFFSy35ZQUVDIMo+Gi4JCltFwERSy75Y5\n4+VkFLLcKHLHyyRUF1jOeJmMShbChZWy0Df8yFDLgg8/cpCN6I9cdHJhZHmy7X2anAnCtDUZ/j/Y\ng2X2j709MHhTDAFF8QdK9SRpUl2yFgAAAABJRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const cL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg12"\n   version="1.1">\n  <metadata\n     id="metadata18">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs16" />\n  <image\n     y="0"\n     x="0"\n     id="image20"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAGMSURBVFhHvdk7TsNAFIVhQ0l6elLDJqCGngXQ\nU7MA6rALahZATQ81C6APrXP/jEaKHD/i8TnzS1eaICF/2I4f4qxt20bYOmaVlrK2Mb8s1Nj3mIu0\nlPYZszlPa1kvMf9pKe02Zq3Gcrhc4JUaSzawA0sWsAtLcrATS1KwG0sycA0sAd6kZXm1sNzVHtOy\nvBpYoK8xV/tPC3JjZVByYqVQcmHlUHJgLVBSY0ugPP7xO5PXYSW2FMr19ytm8sahxD7ElEBzk3c6\nsFysn/afymKPvsXMueh3oblRMNibmPuYZ34wsyWHfqhB8OFpwKvDHLADmusFd8/ZU8FOaO4I3PcF\nmwLXgOYOwVtexdnwdUy3vg2UQPnD2eji+vZsrruHS/eoBEpjWMpgrhi1Dv1gY6fBkuRQmtqzJVmg\npMbaoKTEWqGkwtqhpMBWgZICWwVKCuwpzxKSFNi5T2vFqb5gVcAqLNnBSixZwWos2cBg/9JSmgUM\n9iMt5QFe8tZ8VP6n3WXMHQtxPzHfabm0ptkBwWhpthzMp7YAAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const lL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3813"\n   version="1.1">\n  <metadata\n     id="metadata3819">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3817" />\n  <image\n     y="0"\n     x="0"\n     id="image3821"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\nnUlEQVRYw+3Z0QnCMBSF4T/FATqCG1g3cISO0NE6iiPoCE5gneD40ohPvgkJ/AcC9/EjHELgliT0\nkoGOIlasWLFixYoVK1asWLFixYoVK1bsjxy+5hlYgLEx47ofSEKSJW1nTUJJMgLPDlpwHoCpk8rO\nvgZixf4Zu3Vi3cq+WroBp4ahL+BYa3AB7o1CH7vvc7M1U4N/g2sdSk8bxjfDaMNdr+hmAQAAAABJ\nRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const dL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg32"\n   version="1.1">\n  <metadata\n     id="metadata38">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs36" />\n  <image\n     y="0"\n     x="0"\n     id="image40"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\npklEQVRYw+3ZLQ4CMRCG4bcbFOvXg99T7FG4BafAw1VALx7dWyy2mIoGgSOZJu/n6p70ZybppFIK\nvWSgo4gVK1asWLFixYoVK1asWLFixYoV+yO7r/UMHIAxiO8FZGBrsUfgDEwBN/QNXIA11S/PW1Bo\nCz4N9ein4Nd1Dyw9PbDR0iVW7J+xudax6HkOtZVdg0MfQE7N0G4GlmANYgNW4A6QepowfgDMXB26\nb1V6LAAAAABJRU5ErkJggg==\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const uL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg3823"\n   version="1.1">\n  <metadata\n     id="metadata3829">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3827" />\n  <image\n     y="0"\n     x="0"\n     id="image3831"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAHOSURBVFhH1ZiLUcMwEEQNDcQl0AEuISVABZhO\nUkroICVAB6ECoINQgdmVfR5FlmQrkZzjzezEzsc8NPqcdNd1XfVfuB9ec3NAmv4yiRo5ImzBlm+c\nwZYtEHJCGsT3eSgHxKZFxs/tL+aMkCK8R3yMwu4PcsVmiXBIVDDCvh/miEtMeE5UaEsNMJcN8o64\ng26PvPSXs9S+/zRHQtgtvLRFCb9blZpnYw/9Rb6RR3M3zxtiprFbyKYwipK1+uwlnIkSrbITUaJR\n1itKtMkGRYk2WRZAQbTNBpzWtggrrwnaWja00hk0DrCgsEZZ4hXWKksmwjLAHobkgOv+V3+ZhXHQ\niWxKqXYLKNyILDdqbPKlldASPhA+Mxc7uwatkSOSix1iP//q2APshLBvfJo7hbizgQj/mDtl+KYu\nCj8h7NSqCM2zXJvZwqqEY4uCOuGYLKEwJ3kVzMlyscg5915FTFbdqhaSVbn8+mTV1gmurOqCxpZN\nEeUu9BlZd1obioTkQ7IhPGTjYZuPIoUMK/GUFrX39asuHJTlH3w1d3FCBxCrCUufZX+NCUdPSsAq\nwu4A8wnPiQrFhW1Z4govFRWKCoeOjzjoZF92CdwpZy6AquoPvJRHJxB8bJ8AAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const hL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.76 13.76"\n   height="13.76"\n   width="13.76"\n   id="svg42"\n   version="1.1">\n  <metadata\n     id="metadata48">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs46" />\n  <image\n     y="0"\n     x="0"\n     id="image50"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAAAXNSR0IArs4c6QAAAARnQU1BAACx\njwv8YQUAAAAJcEhZcwAALiMAAC4jAXilP3YAAAG/SURBVFhH1ZgxUsMwEEUNJRyAGmp6qKGn5xRQ\nQ08NNfRQQw11DpAaanIAWrMv8WaELSlexhLLm/mRnImiF48jr7zVtm3zX9ju2ik5llxLdpdHNg4k\nT5I7yWB8Cdl9yZHkRmIRRpQxOxK+YzC+hKwSnTBBKKoMxpeUBSbkksgRE1V+CJeWhUPJ5ao7ICeq\nrIVryMKJpC88RlTZk1SThVDYIvoluZIsSqyz511SfEg4UxbRdw5qnlmFa9AsCn8hO4aBKHiUjYqC\nN9mkKHiSzYqCJ9lPSVIUPMmySqTudEu8XbOxO90ab7KQFPYoC1Fhr7IwENbagMLCUtXnoCTM1QZW\n3iS3dFT2mRfHvEjuVfZUckFnQh67dgqo1GYqC1MLn3XtZIR/sFcJW2C39FcD18KxpcutcGqddSmc\nuykg/LDq+iAnC/OudUFOVrfLbkjJWvb11YjJuhSFvqxbUQhlXYuCylpE2YXy2SkLlVEgaxVluzyT\nIEutWQ1kKZYtouF2maK4mjCyFN6bJsw9gKgmrNdsbsKNT0qEKsIqC7EJx4gqxYVDWQgntIgqRYXD\nbY3CLpcVgmdPC974BYy3/MgRNM03hR9ubFTHT48AAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.76" />\n</svg>\n'
      const fL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.44 13.76"\n   height="13.76"\n   width="13.44"\n   id="svg3803"\n   version="1.1">\n  <metadata\n     id="metadata3809">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs3807" />\n  <image\n     y="0"\n     x="0"\n     id="image3811"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAArCAYAAAAOnxr+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\nvElEQVRYw+3ZSw0CMRSF4b8T9iAFB4wDkDAWcICEkTA4GAeAA3AADurgsCkbAgsSMrmFczZNd1/a\n3vSVJFFDGipJNdBZaRdAB2wC2TIwAgNAkrQEjsA86GBegDZJGoF18JnfJtVR9idXvaGGGmrod/b6\nV9kD14k9LbD6FDqUM8CU2b2Deo0aaqihhhpqqKGGGhr1hH/wiP469FaBMzflEhc9PZKQ1CtmsqRO\nEunpHbeNNN3A+dFJ/mf6V+gduGPIoUgKLbAAAAAASUVORK5CYII=\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.44" />\n</svg>\n'
      const mL =
        '<?xml version="1.0" encoding="UTF-8" standalone="no"?>\n<svg\n   xmlns:dc="http://purl.org/dc/elements/1.1/"\n   xmlns:cc="http://creativecommons.org/ns#"\n   xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"\n   xmlns:svg="http://www.w3.org/2000/svg"\n   xmlns="http://www.w3.org/2000/svg"\n   xmlns:xlink="http://www.w3.org/1999/xlink"\n   viewBox="0 0 13.44 13.76"\n   height="13.76"\n   width="13.44"\n   id="svg22"\n   version="1.1">\n  <metadata\n     id="metadata28">\n    <rdf:RDF>\n      <cc:Work\n         rdf:about="">\n        <dc:format>image/svg+xml</dc:format>\n        <dc:type\n           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />\n        <dc:title></dc:title>\n      </cc:Work>\n    </rdf:RDF>\n  </metadata>\n  <defs\n     id="defs26" />\n  <image\n     y="0"\n     x="0"\n     id="image30"\n     xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAArCAYAAAAOnxr+AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA\nvUlEQVRYw+3ZsQ3CMBCF4d8WFekZgBqWIDUDZACmYBQWYIn0pGYAegZIexROERHRIBTdhXeVy08+\nyT4/JzMjQmWCVBjoarSugK0z3/0degKODjeyBy5Am8ysARrnnT8nM7sCa+fQLgdAAlQ6ngQVVFBB\nfzeUTK6t8VAwU328ztV6QQUVVFBBBRVUUEG9Ds41sJvZs/8GelDrlw7tAjhvmZLo9o6RD4bEGUp+\nX1My/I0T4HN4rrcASf9M/wp9ASNzIKYYz2hAAAAAAElFTkSuQmCC\n"\n     style="image-rendering:optimizeQuality"\n     preserveAspectRatio="none"\n     height="13.76"\n     width="13.44" />\n</svg>\n'
      class gL {
        constructor(t) {
          this.attributes = t
          const e = navigator.userAgent.toLowerCase()
          const n = e.indexOf('android') > -1
          const i = Oz.isIOS()
          this.iosSoftkeyboardOpened = false
          this.iosMeasureUnit = e.indexOf('crios') === -1 ? '%' : 'vh'
          this.iosDivHeight = `100%${this.iosMeasureUnit}`
          const o = window.outerWidth
          const r = window.outerHeight
          const s = o > r
          const a = o < r
          const c = s && this.attributes.height > r
          const l = a && this.attributes.width > o
          const d = c || l
          this.instanceId = document.getElementsByClassName(
            'wrs_modal_dialogContainer'
          ).length
          this.deviceProperties = {
            orientation: s ? 'landscape' : 'portait',
            isAndroid: n,
            isIOS: i,
            isMobile: d,
            isDesktop: !d && !i && !n
          }
          this.properties = {
            created: false,
            state: '',
            previousState: '',
            position: { bottom: 0, right: 10 },
            size: { height: 338, width: 580 }
          }
          this.websiteBeforeLockParameters = null
          let u = {}
          u.class = 'wrs_modal_overlay'
          u.id = this.getElementId(u.class)
          this.overlay = Sz.createElement('div', u)
          u = {}
          u.class = 'wrs_modal_title_bar'
          u.id = this.getElementId(u.class)
          this.titleBar = Sz.createElement('div', u)
          u = {}
          u.class = 'wrs_modal_title'
          u.id = this.getElementId(u.class)
          this.title = Sz.createElement('div', u)
          this.title.innerHTML = ''
          u = {}
          u.class = 'wrs_modal_close_button'
          u.id = this.getElementId(u.class)
          u.title = Iz.get('close')
          u.style = {}
          this.closeDiv = Sz.createElement('a', u)
          this.closeDiv.setAttribute('role', 'button')
          let h = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
            rL
          )})`
          let f = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
            sL
          )})`
          this.closeDiv.setAttribute('style', h)
          this.closeDiv.setAttribute('onmouseover', `this.style = "${f}";`)
          this.closeDiv.setAttribute('onmouseout', `this.style = "${h}";`)
          u = {}
          u.class = 'wrs_modal_stack_button'
          u.id = this.getElementId(u.class)
          u.title = Iz.get('exit_fullscreen')
          this.stackDiv = Sz.createElement('a', u)
          this.stackDiv.setAttribute('role', 'button')
          h = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
            uL
          )})`
          f = `background-size: 10px; background-image: url(data:image/svg+xml;base64,${window.btoa(
            hL
          )})`
          this.stackDiv.setAttribute('style', h)
          this.stackDiv.setAttribute('onmouseover', `this.style = "${f}";`)
          this.stackDiv.setAttribute('onmouseout', `this.style = "${h}";`)
          u = {}
          u.class = 'wrs_modal_maximize_button'
          u.id = this.getElementId(u.class)
          u.title = Iz.get('fullscreen')
          this.maximizeDiv = Sz.createElement('a', u)
          this.maximizeDiv.setAttribute('role', 'button')
          h = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            aL
          )})`
          f = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            cL
          )})`
          this.maximizeDiv.setAttribute('style', h)
          this.maximizeDiv.setAttribute('onmouseover', `this.style = "${f}";`)
          this.maximizeDiv.setAttribute('onmouseout', `this.style = "${h}";`)
          u = {}
          u.class = 'wrs_modal_minimize_button'
          u.id = this.getElementId(u.class)
          u.title = Iz.get('minimize')
          this.minimizeDiv = Sz.createElement('a', u)
          this.minimizeDiv.setAttribute('role', 'button')
          h = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            lL
          )})`
          f = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            dL
          )})`
          this.minimizeDiv.setAttribute('style', h)
          this.minimizeDiv.setAttribute('onmouseover', `this.style = "${f}";`)
          this.minimizeDiv.setAttribute('onmouseout', `this.style = "${h}";`)
          u = {}
          u.class = 'wrs_modal_dialogContainer'
          u.id = this.getElementId(u.class)
          u.role = 'dialog'
          this.container = Sz.createElement('div', u)
          this.container.setAttribute('aria-labeledby', 'wrs_modal_title[0]')
          u = {}
          u.class = 'wrs_modal_wrapper'
          u.id = this.getElementId(u.class)
          this.wrapper = Sz.createElement('div', u)
          u = {}
          u.class = 'wrs_content_container'
          u.id = this.getElementId(u.class)
          this.contentContainer = Sz.createElement('div', u)
          u = {}
          u.class = 'wrs_modal_controls'
          u.id = this.getElementId(u.class)
          this.controls = Sz.createElement('div', u)
          u = {}
          u.class = 'wrs_modal_buttons_container'
          u.id = this.getElementId(u.class)
          this.buttonContainer = Sz.createElement('div', u)
          this.submitButton = this.createSubmitButton(
            {
              id: this.getElementId('wrs_modal_button_accept'),
              class: 'wrs_modal_button_accept',
              innerHTML: Iz.get('accept')
            },
            this.submitAction.bind(this)
          )
          this.cancelButton = this.createSubmitButton(
            {
              id: this.getElementId('wrs_modal_button_cancel'),
              class: 'wrs_modal_button_cancel',
              innerHTML: Iz.get('cancel')
            },
            this.cancelAction.bind(this)
          )
          this.contentManager = null
          const m = {
            cancelString: Iz.get('cancel'),
            submitString: Iz.get('close'),
            message: Iz.get('close_modal_warning')
          }
          const g = {
            closeCallback: () => {
              this.close()
            },
            cancelCallback: () => {
              this.focus()
            }
          }
          const p = { overlayElement: this.container, callbacks: g, strings: m }
          this.popup = new Hz(p)
          this.rtl = false
          if ('rtl' in this.attributes) {
            this.rtl = this.attributes.rtl
          }
          this.handleOpenedIosSoftkeyboard =
            this.handleOpenedIosSoftkeyboard.bind(this)
          this.handleClosedIosSoftkeyboard =
            this.handleClosedIosSoftkeyboard.bind(this)
        }
        setContentManager(t) {
          this.contentManager = t
        }
        getContentManager() {
          return this.contentManager
        }
        submitAction() {
          if (typeof this.contentManager.submitAction !== 'undefined') {
            this.contentManager.submitAction()
          }
          this.close()
        }
        cancelAction() {
          if (typeof this.contentManager.hasChanges === 'undefined') {
            CL.setActionsOnCancelButtons()
            this.close()
          } else if (!this.contentManager.hasChanges()) {
            CL.setActionsOnCancelButtons()
            this.close()
          } else {
            this.showPopUpMessage()
          }
        }
        createSubmitButton(t, e) {
          class n {
            constructor() {
              this.element = document.createElement('button')
              this.element.id = t.id
              this.element.className = t.class
              this.element.innerHTML = t.innerHTML
              Sz.addEvent(this.element, 'click', e)
            }
            getElement() {
              return this.element
            }
          }
          return new n(t, e).getElement()
        }
        create() {
          this.titleBar.appendChild(this.closeDiv)
          this.titleBar.appendChild(this.stackDiv)
          this.titleBar.appendChild(this.maximizeDiv)
          this.titleBar.appendChild(this.minimizeDiv)
          this.titleBar.appendChild(this.title)
          if (this.deviceProperties.isDesktop) {
            this.container.appendChild(this.titleBar)
          }
          this.wrapper.appendChild(this.contentContainer)
          this.wrapper.appendChild(this.controls)
          this.controls.appendChild(this.buttonContainer)
          this.buttonContainer.appendChild(this.submitButton)
          this.buttonContainer.appendChild(this.cancelButton)
          this.container.appendChild(this.wrapper)
          this.recalculateScrollBar()
          document.body.appendChild(this.container)
          document.body.appendChild(this.overlay)
          if (this.deviceProperties.isDesktop) {
            this.createModalWindowDesktop()
            this.createResizeButtons()
            this.addListeners()
            if (yz.get('modalWindowFullScreen')) {
              this.maximize()
            }
          } else if (this.deviceProperties.isAndroid) {
            this.createModalWindowAndroid()
          } else if (this.deviceProperties.isIOS) {
            this.createModalWindowIos()
          }
          if (this.contentManager != null) {
            this.contentManager.insert(this)
          }
          this.properties.open = true
          this.properties.created = true
          if (this.isRTL()) {
            this.container.style.right = `${
              window.innerWidth -
              this.scrollbarWidth -
              this.container.offsetWidth
            }px`
            this.container.className += ' wrs_modal_rtl'
          }
        }
        createResizeButtons() {
          this.resizerBR = document.createElement('div')
          this.resizerBR.className = 'wrs_bottom_right_resizer'
          this.resizerBR.innerHTML = '◢'
          this.resizerTL = document.createElement('div')
          this.resizerTL.className = 'wrs_bottom_left_resizer'
          this.container.appendChild(this.resizerBR)
          this.titleBar.appendChild(this.resizerTL)
          Sz.addEvent(
            this.resizerBR,
            'mousedown',
            this.activateResizeStateBR.bind(this)
          )
          Sz.addEvent(
            this.resizerTL,
            'mousedown',
            this.activateResizeStateTL.bind(this)
          )
        }
        activateResizeStateBR(t) {
          this.initializeResizeProperties(t, false)
        }
        activateResizeStateTL(t) {
          this.initializeResizeProperties(t, true)
        }
        initializeResizeProperties(t, e) {
          Sz.addClass(document.body, 'wrs_noselect')
          Sz.addClass(this.overlay, 'wrs_overlay_active')
          this.resizeDataObject = {
            x: this.eventClient(t).X,
            y: this.eventClient(t).Y
          }
          this.initialWidth = parseInt(this.container.style.width, 10)
          this.initialHeight = parseInt(this.container.style.height, 10)
          if (!e) {
            this.initialRight = parseInt(this.container.style.right, 10)
            this.initialBottom = parseInt(this.container.style.bottom, 10)
          } else {
            this.leftScale = true
          }
          if (!this.initialRight) {
            this.initialRight = 0
          }
          if (!this.initialBottom) {
            this.initialBottom = 0
          }
          document.body.style['user-select'] = 'none'
        }
        open() {
          try {
            oL.send([
              {
                timestamp: new Date().toJSON(),
                topic: '0',
                level: 'info',
                message: 'HELO telemetry.wiris.net'
              }
            ]).then((t) => {})
          } catch (t) {}
          this.removeClass('wrs_closed')
          const { isIOS: t } = this.deviceProperties
          const { isAndroid: e } = this.deviceProperties
          const { isMobile: n } = this.deviceProperties
          if (t || e || n) {
            this.restoreWebsiteScale()
            this.lockWebsiteScroll()
            setTimeout(() => {
              this.hideKeyboard()
            }, 400)
          }
          if (!this.properties.created) {
            this.create()
          } else {
            if (!this.properties.open) {
              this.properties.open = true
              if (
                !this.deviceProperties.isAndroid &&
                !this.deviceProperties.isIOS
              ) {
                this.restoreState()
              }
            }
            if (
              this.deviceProperties.isDesktop &&
              yz.get('modalWindowFullScreen')
            ) {
              this.maximize()
            }
            if (this.deviceProperties.isIOS) {
              this.iosSoftkeyboardOpened = false
              this.setContainerHeight(`${100 + this.iosMeasureUnit}`)
            }
          }
          if (!Oz.isEditorLoaded()) {
            const t = Ez.newListener('onLoad', () => {
              this.contentManager.onOpen(this)
            })
            this.contentManager.addListener(t)
          } else {
            this.contentManager.onOpen(this)
          }
        }
        close() {
          this.removeClass('wrs_maximized')
          this.removeClass('wrs_minimized')
          this.removeClass('wrs_stack')
          this.addClass('wrs_closed')
          this.saveModalProperties()
          this.unlockWebsiteScroll()
          this.properties.open = false
        }
        restoreWebsiteScale() {
          let t = document.querySelector('meta[name=viewport]')
          const e = ['initial-scale=', 'minimum-scale=', 'maximum-scale=']
          const n = ['1.0', '1.0', '1.0']
          const i = (t, e) => {
            const i = t.getAttribute('content')
            if (i) {
              const o = i.split(',')
              let r = ''
              const s = []
              for (let t = 0; t < o.length; t += 1) {
                let n = false
                let i = 0
                while (!n && i < e.length) {
                  if (o[t].indexOf(e[i])) {
                    n = true
                  }
                  i += 1
                }
                if (!n) {
                  s.push(o[t])
                }
              }
              for (let t = 0; t < e.length; t += 1) {
                const i = e[t] + n[t]
                r += t === 0 ? i : `,${i}`
              }
              for (let t = 0; t < s.length; t += 1) {
                r += `,${s[t]}`
              }
              t.setAttribute('content', r)
              t.setAttribute('content', '')
              t.setAttribute('content', i)
            } else {
              t.setAttribute(
                'content',
                'initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0'
              )
              t.removeAttribute('content')
            }
          }
          if (!t) {
            t = document.createElement('meta')
            document.getElementsByTagName('head')[0].appendChild(t)
            i(t, e, n)
            t.remove()
          } else {
            i(t, e, n)
          }
        }
        lockWebsiteScroll() {
          this.websiteBeforeLockParameters = {
            bodyStylePosition: document.body.style.position
              ? document.body.style.position
              : '',
            bodyStyleOverflow: document.body.style.overflow
              ? document.body.style.overflow
              : '',
            htmlStyleOverflow: document.documentElement.style.overflow
              ? document.documentElement.style.overflow
              : '',
            windowScrollX: window.scrollX,
            windowScrollY: window.scrollY
          }
        }
        unlockWebsiteScroll() {
          if (this.websiteBeforeLockParameters) {
            document.body.style.position =
              this.websiteBeforeLockParameters.bodyStylePosition
            document.body.style.overflow =
              this.websiteBeforeLockParameters.bodyStyleOverflow
            document.documentElement.style.overflow =
              this.websiteBeforeLockParameters.htmlStyleOverflow
            const { windowScrollX: t } = this.websiteBeforeLockParameters
            const { windowScrollY: e } = this.websiteBeforeLockParameters
            window.scrollTo(t, e)
            this.websiteBeforeLockParameters = null
          }
        }
        isIE11() {
          if (
            navigator.userAgent.search('Msie/') >= 0 ||
            navigator.userAgent.search('Trident/') >= 0 ||
            navigator.userAgent.search('Edge/') >= 0
          ) {
            return true
          }
          return false
        }
        isRTL() {
          if (
            this.attributes.language === 'ar' ||
            this.attributes.language === 'he'
          ) {
            return true
          }
          return this.rtl
        }
        addClass(t) {
          Sz.addClass(this.overlay, t)
          Sz.addClass(this.titleBar, t)
          Sz.addClass(this.overlay, t)
          Sz.addClass(this.container, t)
          Sz.addClass(this.contentContainer, t)
          Sz.addClass(this.stackDiv, t)
          Sz.addClass(this.minimizeDiv, t)
          Sz.addClass(this.maximizeDiv, t)
          Sz.addClass(this.wrapper, t)
        }
        removeClass(t) {
          Sz.removeClass(this.overlay, t)
          Sz.removeClass(this.titleBar, t)
          Sz.removeClass(this.overlay, t)
          Sz.removeClass(this.container, t)
          Sz.removeClass(this.contentContainer, t)
          Sz.removeClass(this.stackDiv, t)
          Sz.removeClass(this.minimizeDiv, t)
          Sz.removeClass(this.maximizeDiv, t)
          Sz.removeClass(this.wrapper, t)
        }
        createModalWindowDesktop() {
          this.addClass('wrs_modal_desktop')
          this.stack()
        }
        createModalWindowAndroid() {
          this.addClass('wrs_modal_android')
          window.addEventListener(
            'resize',
            this.orientationChangeAndroidSoftkeyboard.bind(this)
          )
        }
        createModalWindowIos() {
          this.addClass('wrs_modal_ios')
          window.addEventListener(
            'resize',
            this.orientationChangeIosSoftkeyboard.bind(this)
          )
        }
        restoreState() {
          if (this.properties.state === 'maximized') {
            this.maximize()
          } else if (this.properties.state === 'minimized') {
            this.properties.state = this.properties.previousState
            this.properties.previousState = ''
            this.minimize()
          } else {
            this.stack()
          }
        }
        stack() {
          this.properties.previousState = this.properties.state
          this.properties.state = 'stack'
          this.removeClass('wrs_maximized')
          this.minimizeDiv.title = Iz.get('minimize')
          this.removeClass('wrs_minimized')
          this.addClass('wrs_stack')
          const t = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            lL
          )})`
          const e = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            dL
          )})`
          this.minimizeDiv.setAttribute('style', t)
          this.minimizeDiv.setAttribute('onmouseover', `this.style = "${e}";`)
          this.minimizeDiv.setAttribute('onmouseout', `this.style = "${t}";`)
          this.restoreModalProperties()
          if (
            typeof this.resizerBR !== 'undefined' &&
            typeof this.resizerTL !== 'undefined'
          ) {
            this.setResizeButtonsVisibility()
          }
          this.recalculateScrollBar()
          this.recalculatePosition()
          this.recalculateScale()
          this.focus()
        }
        minimize() {
          this.saveModalProperties()
          this.title.style.cursor = 'pointer'
          if (
            this.properties.state === 'minimized' &&
            this.properties.previousState === 'stack'
          ) {
            this.stack()
          } else if (
            this.properties.state === 'minimized' &&
            this.properties.previousState === 'maximized'
          ) {
            this.maximize()
          } else {
            this.container.style.height = '30px'
            this.container.style.width = '250px'
            this.container.style.bottom = '0px'
            this.container.style.right = '10px'
            this.removeListeners()
            this.properties.previousState = this.properties.state
            this.properties.state = 'minimized'
            this.setResizeButtonsVisibility()
            this.minimizeDiv.title = Iz.get('maximize')
            if (Sz.containsClass(this.overlay, 'wrs_stack')) {
              this.removeClass('wrs_stack')
            } else {
              this.removeClass('wrs_maximized')
            }
            this.addClass('wrs_minimized')
            const t = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
              fL
            )})`
            const e = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
              mL
            )})`
            this.minimizeDiv.setAttribute('style', t)
            this.minimizeDiv.setAttribute('onmouseover', `this.style = "${e}";`)
            this.minimizeDiv.setAttribute('onmouseout', `this.style = "${t}";`)
          }
        }
        maximize() {
          this.saveModalProperties()
          if (this.properties.state !== 'maximized') {
            this.properties.previousState = this.properties.state
            this.properties.state = 'maximized'
          }
          this.setResizeButtonsVisibility()
          if (Sz.containsClass(this.overlay, 'wrs_minimized')) {
            this.minimizeDiv.title = Iz.get('minimize')
            this.removeClass('wrs_minimized')
          } else if (Sz.containsClass(this.overlay, 'wrs_stack')) {
            this.container.style.left = null
            this.container.style.top = null
            this.removeClass('wrs_stack')
          }
          this.addClass('wrs_maximized')
          const t = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            lL
          )})`
          const e = `background-size: 10px; background-repeat: no-repeat; background-image: url(data:image/svg+xml;base64,${window.btoa(
            dL
          )})`
          this.minimizeDiv.setAttribute('style', t)
          this.minimizeDiv.setAttribute('onmouseover', `this.style = "${e}";`)
          this.minimizeDiv.setAttribute('onmouseout', `this.style = "${t}";`)
          this.setSize(
            parseInt(window.innerHeight * 0.8, 10),
            parseInt(window.innerWidth * 0.8, 10)
          )
          if (this.container.clientHeight > 700) {
            this.container.style.height = '700px'
          }
          if (this.container.clientWidth > 1200) {
            this.container.style.width = '1200px'
          }
          const { innerHeight: n } = window
          const { innerWidth: i } = window
          const { offsetHeight: o } = this.container
          const { offsetWidth: r } = this.container
          const s = n / 2 - o / 2
          const a = i / 2 - r / 2
          this.setPosition(s, a)
          this.recalculateScale()
          this.recalculatePosition()
          this.recalculateSize()
          this.focus()
        }
        reExpand() {
          if (this.properties.state === 'minimized') {
            if (this.properties.previousState === 'maximized') {
              this.maximize()
            } else {
              this.stack()
            }
            this.title.style.cursor = ''
          }
        }
        setSize(t, e) {
          this.container.style.height = `${t}px`
          this.container.style.width = `${e}px`
          this.recalculateSize()
        }
        setPosition(t, e) {
          this.container.style.bottom = `${t}px`
          this.container.style.right = `${e}px`
        }
        saveModalProperties() {
          if (this.properties.state === 'stack') {
            this.properties.position.bottom = parseInt(
              this.container.style.bottom,
              10
            )
            this.properties.position.right = parseInt(
              this.container.style.right,
              10
            )
            this.properties.size.width = parseInt(
              this.container.style.width,
              10
            )
            this.properties.size.height = parseInt(
              this.container.style.height,
              10
            )
          }
        }
        restoreModalProperties() {
          if (this.properties.state === 'stack') {
            this.setPosition(
              this.properties.position.bottom,
              this.properties.position.right
            )
            this.setSize(
              this.properties.size.height,
              this.properties.size.width
            )
          }
        }
        recalculateSize() {
          this.wrapper.style.width = `${this.container.clientWidth - 12}px`
          this.wrapper.style.height = `${this.container.clientHeight - 38}px`
          this.contentContainer.style.height = `${parseInt(
            this.wrapper.offsetHeight - 50,
            10
          )}px`
        }
        setResizeButtonsVisibility() {
          if (this.properties.state === 'stack') {
            this.resizerTL.style.visibility = 'visible'
            this.resizerBR.style.visibility = 'visible'
          } else {
            this.resizerTL.style.visibility = 'hidden'
            this.resizerBR.style.visibility = 'hidden'
          }
        }
        addListeners() {
          this.maximizeDiv.addEventListener(
            'click',
            this.maximize.bind(this),
            true
          )
          this.stackDiv.addEventListener('click', this.stack.bind(this), true)
          this.minimizeDiv.addEventListener(
            'click',
            this.minimize.bind(this),
            true
          )
          this.closeDiv.addEventListener('click', this.cancelAction.bind(this))
          this.title.addEventListener('click', this.reExpand.bind(this))
          this.overlay.addEventListener('click', this.cancelAction.bind(this))
          Sz.addEvent(window, 'mousedown', this.startDrag.bind(this))
          Sz.addEvent(window, 'mouseup', this.stopDrag.bind(this))
          Sz.addEvent(window, 'mousemove', this.drag.bind(this))
          Sz.addEvent(window, 'resize', this.onWindowResize.bind(this))
          Sz.addEvent(this.container, 'keydown', this.onKeyDown.bind(this))
        }
        removeListeners() {
          Sz.removeEvent(window, 'mousedown', this.startDrag)
          Sz.removeEvent(window, 'mouseup', this.stopDrag)
          Sz.removeEvent(window, 'mousemove', this.drag)
          Sz.removeEvent(window, 'resize', this.onWindowResize)
          Sz.removeEvent(this.container, 'keydown', this.onKeyDown)
        }
        eventClient(t) {
          if (typeof t.clientX === 'undefined' && t.changedTouches) {
            const e = {
              X: t.changedTouches[0].clientX,
              Y: t.changedTouches[0].clientY
            }
            return e
          }
          const e = { X: t.clientX, Y: t.clientY }
          return e
        }
        startDrag(t) {
          if (this.properties.state === 'minimized') {
            return
          }
          if (t.target === this.title) {
            if (
              typeof this.dragDataObject === 'undefined' ||
              this.dragDataObject === null
            ) {
              this.dragDataObject = {
                x: this.eventClient(t).X,
                y: this.eventClient(t).Y
              }
              this.lastDrag = { x: '0px', y: '0px' }
              if (this.container.style.right === '') {
                this.container.style.right = '0px'
              }
              if (this.container.style.bottom === '') {
                this.container.style.bottom = '0px'
              }
              if (this.isIE11()) {
              }
              Sz.addClass(document.body, 'wrs_noselect')
              Sz.addClass(this.overlay, 'wrs_overlay_active')
              this.limitWindow = this.getLimitWindow()
            }
          }
        }
        drag(t) {
          if (this.dragDataObject) {
            t.preventDefault()
            let e = Math.min(
              this.eventClient(t).Y,
              this.limitWindow.minPointer.y
            )
            e = Math.max(this.limitWindow.maxPointer.y, e)
            let n = Math.min(
              this.eventClient(t).X,
              this.limitWindow.minPointer.x
            )
            n = Math.max(this.limitWindow.maxPointer.x, n)
            const i = `${n - this.dragDataObject.x}px`
            const o = `${e - this.dragDataObject.y}px`
            this.lastDrag = { x: i, y: o }
            this.container.style.transform = `translate3d(${i},${o},0)`
          }
          if (this.resizeDataObject) {
            const { innerWidth: e } = window
            const { innerHeight: n } = window
            let i = Math.min(this.eventClient(t).X, e - this.scrollbarWidth - 7)
            let o = Math.min(this.eventClient(t).Y, n - 7)
            if (i < 0) {
              i = 0
            }
            if (o < 0) {
              o = 0
            }
            let r
            if (this.leftScale) {
              r = -1
            } else {
              r = 1
            }
            this.container.style.width = `${
              this.initialWidth + r * (i - this.resizeDataObject.x)
            }px`
            this.container.style.height = `${
              this.initialHeight + r * (o - this.resizeDataObject.y)
            }px`
            if (!this.leftScale) {
              if (this.resizeDataObject.x - i - this.initialWidth < -580) {
                this.container.style.right = `${
                  this.initialRight - (i - this.resizeDataObject.x)
                }px`
              } else {
                this.container.style.right = `${
                  this.initialRight + this.initialWidth - 580
                }px`
                this.container.style.width = '580px'
              }
              if (this.resizeDataObject.y - o < this.initialHeight - 338) {
                this.container.style.bottom = `${
                  this.initialBottom - (o - this.resizeDataObject.y)
                }px`
              } else {
                this.container.style.bottom = `${
                  this.initialBottom + this.initialHeight - 338
                }px`
                this.container.style.height = '338px'
              }
            }
            this.recalculateScale()
            this.recalculatePosition()
          }
        }
        getLimitWindow() {
          const t = window.innerWidth
          const e = window.innerHeight
          const { offsetHeight: n } = this.container
          const i = parseInt(this.container.style.bottom, 10)
          const o = parseInt(this.container.style.right, 10)
          const { pageXOffset: r } = window
          const s = this.dragDataObject.y
          const a = this.dragDataObject.x
          const c = n + i - (e - (s - r))
          const l = t - this.scrollbarWidth - (a - r) - o
          const d = e - this.container.offsetHeight + c
          const u = this.title.offsetHeight - (this.title.offsetHeight - c)
          const h = t - l - this.scrollbarWidth
          const f = this.container.offsetWidth - l
          const m = { x: h, y: d }
          const g = { x: f, y: u }
          return { minPointer: m, maxPointer: g }
        }
        getScrollBarWidth() {
          const t = document.createElement('p')
          t.style.width = '100%'
          t.style.height = '200px'
          const e = document.createElement('div')
          e.style.position = 'absolute'
          e.style.top = '0px'
          e.style.left = '0px'
          e.style.visibility = 'hidden'
          e.style.width = '200px'
          e.style.height = '150px'
          e.style.overflow = 'hidden'
          e.appendChild(t)
          document.body.appendChild(e)
          const n = t.offsetWidth
          e.style.overflow = 'scroll'
          let i = t.offsetWidth
          if (n === i) {
            i = e.clientWidth
          }
          document.body.removeChild(e)
          return n - i
        }
        stopDrag() {
          if (this.dragDataObject || this.resizeDataObject) {
            this.container.style.transform = ''
            if (this.dragDataObject) {
              this.container.style.right = `${
                parseInt(this.container.style.right, 10) -
                parseInt(this.lastDrag.x, 10)
              }px`
              this.container.style.bottom = `${
                parseInt(this.container.style.bottom, 10) -
                parseInt(this.lastDrag.y, 10)
              }px`
            }
            this.focus()
            document.body.style['user-select'] = ''
            if (this.isIE11()) {
            }
            Sz.removeClass(document.body, 'wrs_noselect')
            Sz.removeClass(this.overlay, 'wrs_overlay_active')
          }
          this.dragDataObject = null
          this.resizeDataObject = null
          this.initialWidth = null
          this.leftScale = null
        }
        onWindowResize() {
          this.recalculateScrollBar()
          this.recalculatePosition()
          this.recalculateScale()
        }
        onKeyDown(t) {
          if (t.key !== undefined) {
            if (this.popup.overlayWrapper.style.display !== 'block') {
              if (t.key === 'Escape' || t.key === 'Esc') {
                if (this.properties.open) {
                  this.contentManager.onKeyDown(t)
                }
              } else if (t.shiftKey && t.key === 'Tab') {
                if (document.activeElement === this.cancelButton) {
                  this.submitButton.focus()
                  t.stopPropagation()
                  t.preventDefault()
                } else {
                  this.contentManager.onKeyDown(t)
                }
              } else if (t.key === 'Tab') {
                if (document.activeElement === this.submitButton) {
                  this.cancelButton.focus()
                  t.stopPropagation()
                  t.preventDefault()
                } else {
                  this.contentManager.onKeyDown(t)
                }
              }
            } else {
              this.popup.onKeyDown(t)
            }
          }
        }
        recalculatePosition() {
          this.container.style.right = `${Math.min(
            parseInt(this.container.style.right, 10),
            window.innerWidth - this.scrollbarWidth - this.container.offsetWidth
          )}px`
          if (parseInt(this.container.style.right, 10) < 0) {
            this.container.style.right = '0px'
          }
          this.container.style.bottom = `${Math.min(
            parseInt(this.container.style.bottom, 10),
            window.innerHeight - this.container.offsetHeight
          )}px`
          if (parseInt(this.container.style.bottom, 10) < 0) {
            this.container.style.bottom = '0px'
          }
        }
        recalculateScale() {
          let t = false
          if (parseInt(this.container.style.width, 10) > 580) {
            this.container.style.width = `${Math.min(
              parseInt(this.container.style.width, 10),
              window.innerWidth - this.scrollbarWidth
            )}px`
            t = true
          } else {
            this.container.style.width = '580px'
            t = true
          }
          if (parseInt(this.container.style.height, 10) > 338) {
            this.container.style.height = `${Math.min(
              parseInt(this.container.style.height, 10),
              window.innerHeight
            )}px`
            t = true
          } else {
            this.container.style.height = '338px'
            t = true
          }
          if (t) {
            this.recalculateSize()
          }
        }
        recalculateScrollBar() {
          this.hasScrollBar =
            window.innerWidth > document.documentElement.clientWidth
          if (this.hasScrollBar) {
            this.scrollbarWidth = this.getScrollBarWidth()
          } else {
            this.scrollbarWidth = 0
          }
        }
        hideKeyboard() {
          const t = document.createElement('input')
          this.container.appendChild(t)
          t.focus()
          t.blur()
          t.remove()
        }
        focus() {
          if (
            this.contentManager != null &&
            typeof this.contentManager.onFocus !== 'undefined'
          ) {
            this.contentManager.onFocus()
          }
        }
        portraitMode() {
          return window.innerHeight > window.innerWidth
        }
        handleOpenedIosSoftkeyboard() {
          if (
            !this.iosSoftkeyboardOpened &&
            this.iosDivHeight != null &&
            this.iosDivHeight === `100${this.iosMeasureUnit}`
          ) {
            if (this.portraitMode()) {
              this.setContainerHeight(`63${this.iosMeasureUnit}`)
            } else {
              this.setContainerHeight(`40${this.iosMeasureUnit}`)
            }
          }
          this.iosSoftkeyboardOpened = true
        }
        handleClosedIosSoftkeyboard() {
          this.iosSoftkeyboardOpened = false
          this.setContainerHeight(`100${this.iosMeasureUnit}`)
        }
        orientationChangeIosSoftkeyboard() {
          if (this.iosSoftkeyboardOpened) {
            if (this.portraitMode()) {
              this.setContainerHeight(`63${this.iosMeasureUnit}`)
            } else {
              this.setContainerHeight(`40${this.iosMeasureUnit}`)
            }
          } else {
            this.setContainerHeight(`100${this.iosMeasureUnit}`)
          }
        }
        orientationChangeAndroidSoftkeyboard() {
          this.setContainerHeight('100%')
        }
        setContainerHeight(t) {
          this.iosDivHeight = t
          this.wrapper.style.height = t
        }
        showPopUpMessage() {
          if (this.properties.state === 'minimized') {
            this.stack()
          }
          this.popup.show()
        }
        setTitle(t) {
          this.title.innerHTML = t
        }
        getElementId(t) {
          return `${t}[${this.instanceId}]`
        }
      }
      var pL
      const bL = null && pL
      /*! http://mths.be/codepointat v0.1.0 by @mathias */ if (
        !String.prototype.codePointAt
      ) {
        ;(function () {
          'use strict'
          var t = function (t) {
            if (this == null) {
              throw TypeError()
            }
            var e = String(this)
            var n = e.length
            var i = t ? Number(t) : 0
            if (i != i) {
              i = 0
            }
            if (i < 0 || i >= n) {
              return undefined
            }
            var o = e.charCodeAt(i)
            var r
            if (o >= 55296 && o <= 56319 && n > i + 1) {
              r = e.charCodeAt(i + 1)
              if (r >= 56320 && r <= 57343) {
                return (o - 55296) * 1024 + r - 56320 + 65536
              }
            }
            return o
          }
          if (Object.defineProperty) {
            Object.defineProperty(String.prototype, 'codePointAt', {
              value: t,
              configurable: true,
              writable: true
            })
          } else {
            String.prototype.codePointAt = t
          }
        })()
      }
      if (typeof Object.assign != 'function') {
        Object.defineProperty(Object, 'assign', {
          value: function t(e, n) {
            'use strict'
            if (e == null) {
              throw new TypeError('Cannot convert undefined or null to object')
            }
            var i = Object(e)
            for (var o = 1; o < arguments.length; o++) {
              var r = arguments[o]
              if (r != null) {
                for (var s in r) {
                  if (Object.prototype.hasOwnProperty.call(r, s)) {
                    i[s] = r[s]
                  }
                }
              }
            }
            return i
          },
          writable: true,
          configurable: true
        })
      }
      if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
          value: function (t, e) {
            if (this == null) {
              throw new TypeError('"this" s null or is not defined')
            }
            var n = Object(this)
            var i = n.length >>> 0
            if (i === 0) {
              return false
            }
            var o = e | 0
            var r = Math.max(o >= 0 ? o : i - Math.abs(o), 0)
            function s(t, e) {
              return (
                t === e ||
                (typeof t === 'number' &&
                  typeof e === 'number' &&
                  isNaN(t) &&
                  isNaN(e))
              )
            }
            while (r < i) {
              if (s(n[r], t)) {
                return true
              }
              r++
            }
            return false
          }
        })
      }
      if (!String.prototype.includes) {
        String.prototype.includes = function (t, e) {
          'use strict'
          if (t instanceof RegExp) {
            throw TypeError('first argument must not be a RegExp')
          }
          if (e === undefined) {
            e = 0
          }
          return this.indexOf(t, e) !== -1
        }
      }
      if (!String.prototype.startsWith) {
        Object.defineProperty(String.prototype, 'startsWith', {
          value: function (t, e) {
            var n = e > 0 ? e | 0 : 0
            return this.substring(n, n + t.length) === t
          }
        })
      }
      var kL = __webpack_require__(7546)
      var wL = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      wL.insert = 'head'
      wL.singleton = true
      var _L = El()(kL.Z, wL)
      const AL = kL.Z.locals || {}
      class vL {
        constructor(t) {
          this.language = 'en'
          this.editMode = 'images'
          this.modalDialog = null
          this.customEditors = new Rz()
          const e = {
            name: 'Chemistry',
            toolbar: 'chemistry',
            icon: 'chem.png',
            confVariable: 'chemEnabled',
            title: 'ChemType',
            tooltip: 'Insert a chemistry formula - ChemType'
          }
          this.customEditors.addEditor('chemistry', e)
          this.environment = {}
          this.editionProperties = {}
          this.editionProperties.isNewElement = true
          this.editionProperties.temporalImage = null
          this.editionProperties.latexRange = null
          this.editionProperties.range = null
          this.integrationModel = null
          this.contentManager = null
          this.browser = (() => {
            const t = navigator.userAgent
            let e = 'none'
            if (t.search('Edge/') >= 0) {
              e = 'EDGE'
            } else if (t.search('Chrome/') >= 0) {
              e = 'CHROME'
            } else if (t.search('Trident/') >= 0) {
              e = 'IE'
            } else if (t.search('Firefox/') >= 0) {
              e = 'FIREFOX'
            } else if (t.search('Safari/') >= 0) {
              e = 'SAFARI'
            }
            return e
          })()
          this.listeners = new Ez()
          this.serviceProviderProperties = {}
          if ('serviceProviderProperties' in t) {
            this.serviceProviderProperties = t.serviceProviderProperties
          } else {
            throw new Error('serviceProviderProperties property missing.')
          }
        }
        static get globalListeners() {
          return vL._globalListeners
        }
        static set globalListeners(t) {
          vL._globalListeners = t
        }
        static get initialized() {
          return vL._initialized
        }
        static set initialized(t) {
          vL._initialized = t
        }
        setIntegrationModel(t) {
          this.integrationModel = t
        }
        setEnvironment(t) {
          if ('editor' in t) {
            this.environment.editor = t.editor
          }
          if ('mode' in t) {
            this.environment.mode = t.mode
          }
          if ('version' in t) {
            this.environment.version = t.version
          }
        }
        getModalDialog() {
          return this.modalDialog
        }
        init() {
          if (!vL.initialized) {
            const t = Ez.newListener('onInit', () => {
              const t = Dz.getService('configurationjs', '', 'get')
              const e = JSON.parse(t)
              yz.addConfiguration(e)
              yz.addConfiguration(Fz)
              Iz.language = this.language
              this.listeners.fire('onLoad', {})
            })
            Dz.addListener(t)
            Dz.init(this.serviceProviderProperties)
            vL.initialized = true
          } else {
            this.listeners.fire('onLoad', {})
          }
        }
        addListener(t) {
          this.listeners.add(t)
        }
        static addGlobalListener(t) {
          vL.globalListeners.add(t)
        }
        beforeUpdateFormula(t, e) {
          const n = new Vz()
          n.mathml = t
          n.wirisProperties = {}
          if (e != null) {
            Object.keys(e).forEach((t) => {
              n.wirisProperties[t] = e[t]
            })
          }
          n.language = this.language
          n.editMode = this.editMode
          if (this.listeners.fire('onBeforeFormulaInsertion', n)) {
            return {}
          }
          if (vL.globalListeners.fire('onBeforeFormulaInsertion', n)) {
            return {}
          }
          return { mathml: n.mathml, wirisProperties: n.wirisProperties }
        }
        insertFormula(t, e, n, i) {
          const o = {}
          if (!n) {
            this.insertElementOnSelection(null, t, e)
          } else if (this.editMode === 'latex') {
            o.latex = Tz.getLatexFromMathML(n)
            if (!!this.integrationModel.fillNonLatexNode && !o.latex) {
              const i = new Vz()
              i.editMode = this.editMode
              i.windowTarget = e
              i.focusElement = t
              i.latex = o.latex
              this.integrationModel.fillNonLatexNode(i, e, n)
            } else {
              o.node = e.document.createTextNode(`$$${o.latex}$$`)
            }
            this.insertElementOnSelection(o.node, t, e)
          } else {
            o.node = zz.mathmlToImgObject(e.document, n, i, this.language)
            this.insertElementOnSelection(o.node, t, e)
          }
          return o
        }
        afterUpdateFormula(t, e, n, i) {
          const o = new Vz()
          o.editMode = this.editMode
          o.windowTarget = e
          o.focusElement = t
          o.node = n
          o.latex = i
          if (this.listeners.fire('onAfterFormulaInsertion', o)) {
            return {}
          }
          if (vL.globalListeners.fire('onAfterFormulaInsertion', o)) {
            return {}
          }
          return {}
        }
        placeCaretAfterNode(t) {
          this.integrationModel.getSelection()
          const e = t.ownerDocument
          if (typeof e.getSelection !== 'undefined' && !!t.parentElement) {
            const n = e.createRange()
            n.setStartAfter(t)
            n.collapse(true)
            const i = e.getSelection()
            i.removeAllRanges()
            i.addRange(n)
            e.body.focus()
          }
        }
        insertElementOnSelection(t, e, n) {
          if (this.editionProperties.isNewElement) {
            if (t) {
              if (e.type === 'textarea') {
                Sz.updateTextArea(e, t.textContent)
              } else if (document.selection && document.getSelection === 0) {
                let e = n.document.selection.createRange()
                n.document.execCommand('InsertImage', false, t.src)
                if (!('parentElement' in e)) {
                  n.document.execCommand('delete', false)
                  e = n.document.selection.createRange()
                  n.document.execCommand('InsertImage', false, t.src)
                }
                if ('parentElement' in e) {
                  const n = e.parentElement()
                  if (n.nodeName.toUpperCase() === 'IMG') {
                    n.parentNode.replaceChild(t, n)
                  } else {
                    e.pasteHTML(Sz.createObjectCode(t))
                  }
                }
              } else {
                const e = this.integrationModel.getSelection()
                let n = null
                if (this.editionProperties.range) {
                  ;({ range: n } = this.editionProperties)
                  this.editionProperties.range = null
                } else {
                  n = e.getRangeAt(0)
                }
                n.deleteContents()
                let i = n.startContainer
                const o = n.startOffset
                if (i.nodeType === 3) {
                  i = i.splitText(o)
                  i.parentNode.insertBefore(t, i)
                } else if (i.nodeType === 1) {
                  i.insertBefore(t, i.childNodes[o])
                }
                this.placeCaretAfterNode(t)
              }
            } else if (e.type === 'textarea') {
              e.focus()
            } else {
              const t = this.integrationModel.getSelection()
              t.removeAllRanges()
              if (this.editionProperties.range) {
                const { range: e } = this.editionProperties
                this.editionProperties.range = null
                t.addRange(e)
              }
            }
          } else if (this.editionProperties.latexRange) {
            if (document.selection && document.getSelection === 0) {
              this.editionProperties.isNewElement = true
              this.editionProperties.latexRange.select()
              this.insertElementOnSelection(t, e, n)
            } else {
              this.editionProperties.latexRange.deleteContents()
              this.editionProperties.latexRange.insertNode(t)
              this.placeCaretAfterNode(t)
            }
          } else if (e.type === 'textarea') {
            let n
            if (typeof this.integrationModel.getSelectedItem !== 'undefined') {
              n = this.integrationModel.getSelectedItem(e, false)
            } else {
              n = Sz.getSelectedItemOnTextarea(e)
            }
            Sz.updateExistingTextOnTextarea(
              e,
              t.textContent,
              n.startPosition,
              n.endPosition
            )
          } else {
            if (t && t.nodeName.toLowerCase() === 'img') {
              Bz.removeImgDataAttributes(this.editionProperties.temporalImage)
              Bz.clone(t, this.editionProperties.temporalImage)
            } else {
              this.editionProperties.temporalImage.remove()
            }
            this.placeCaretAfterNode(this.editionProperties.temporalImage)
          }
        }
        openModalDialog(t, e) {
          this.editMode = 'images'
          try {
            if (e) {
              t.contentWindow.focus()
              const e = t.contentWindow.getSelection()
              this.editionProperties.range = e.getRangeAt(0)
            } else {
              t.focus()
              const e = getSelection()
              this.editionProperties.range = e.getRangeAt(0)
            }
          } catch (t) {
            this.editionProperties.range = null
          }
          if (e === undefined) {
            e = true
          }
          this.editionProperties.latexRange = null
          if (t) {
            let n
            if (typeof this.integrationModel.getSelectedItem !== 'undefined') {
              n = this.integrationModel.getSelectedItem(t, e)
            } else {
              n = Sz.getSelectedItem(t, e)
            }
            if (n) {
              if (
                !n.caretPosition &&
                Sz.containsClass(n.node, yz.get('imageClassName'))
              ) {
                this.editionProperties.temporalImage = n.node
                this.editionProperties.isNewElement = false
              } else if (n.node.nodeType === 3) {
                if (this.integrationModel.getMathmlFromTextNode) {
                  const t = this.integrationModel.getMathmlFromTextNode(
                    n.node,
                    n.caretPosition
                  )
                  if (t) {
                    this.editMode = 'latex'
                    this.editionProperties.isNewElement = false
                    this.editionProperties.temporalImage =
                      document.createElement('img')
                    this.editionProperties.temporalImage.setAttribute(
                      yz.get('imageMathmlAttribute'),
                      Cz.safeXmlEncode(t)
                    )
                  }
                } else {
                  const i = Tz.getLatexFromTextNode(n.node, n.caretPosition)
                  if (i) {
                    const n = Tz.getMathMLFromLatex(i.latex)
                    this.editMode = 'latex'
                    this.editionProperties.isNewElement = false
                    this.editionProperties.temporalImage =
                      document.createElement('img')
                    this.editionProperties.temporalImage.setAttribute(
                      yz.get('imageMathmlAttribute'),
                      Cz.safeXmlEncode(n)
                    )
                    const o = e ? t.contentWindow : window
                    if (t.tagName.toLowerCase() !== 'textarea') {
                      if (document.selection) {
                        let t = 0
                        let e = i.startNode.previousSibling
                        while (e) {
                          t += Sz.getNodeLength(e)
                          e = e.previousSibling
                        }
                        this.editionProperties.latexRange =
                          o.document.selection.createRange()
                        this.editionProperties.latexRange.moveToElementText(
                          i.startNode.parentNode
                        )
                        this.editionProperties.latexRange.move(
                          'character',
                          t + i.startPosition
                        )
                        this.editionProperties.latexRange.moveEnd(
                          'character',
                          i.latex.length + 4
                        )
                      } else {
                        this.editionProperties.latexRange =
                          o.document.createRange()
                        this.editionProperties.latexRange.setStart(
                          i.startNode,
                          i.startPosition
                        )
                        this.editionProperties.latexRange.setEnd(
                          i.endNode,
                          i.endPosition
                        )
                      }
                    }
                  }
                }
              }
            } else if (t.tagName.toLowerCase() === 'textarea') {
              this.editMode = 'latex'
            }
          }
          const n = yz.get('editorAttributes').split(', ')
          const i = {}
          for (let t = 0, e = n.length; t < e; t += 1) {
            const e = n[t].split('=')
            const o = e[0]
            const r = e[1]
            i[o] = r
          }
          const o = {}
          const r = yz.get('editorParameters')
          const s = this.integrationModel.editorParameters
          Object.assign(o, i, r)
          Object.assign(o, i, s)
          o.language = this.language
          o.rtl = this.integrationModel.rtl
          const a = {}
          a.editorAttributes = o
          a.language = this.language
          a.customEditors = this.customEditors
          a.environment = this.environment
          if (this.modalDialog == null) {
            this.modalDialog = new gL(o)
            this.contentManager = new Oz(a)
            const t = Ez.newListener('onLoad', () => {
              this.contentManager.isNewElement =
                this.editionProperties.isNewElement
              if (this.editionProperties.temporalImage != null) {
                const t = Cz.safeXmlDecode(
                  this.editionProperties.temporalImage.getAttribute(
                    yz.get('imageMathmlAttribute')
                  )
                )
                this.contentManager.mathML = t
              }
            })
            this.contentManager.addListener(t)
            this.contentManager.init()
            this.modalDialog.setContentManager(this.contentManager)
            this.contentManager.setModalDialogInstance(this.modalDialog)
          } else {
            this.contentManager.isNewElement =
              this.editionProperties.isNewElement
            if (this.editionProperties.temporalImage != null) {
              const t = Cz.safeXmlDecode(
                this.editionProperties.temporalImage.getAttribute(
                  yz.get('imageMathmlAttribute')
                )
              )
              this.contentManager.mathML = t
            }
          }
          this.contentManager.setIntegrationModel(this.integrationModel)
          this.modalDialog.open()
        }
        getCustomEditors() {
          return this.customEditors
        }
      }
      vL._globalListeners = new Ez()
      vL._initialized = false
      class CL {
        constructor(t) {
          this.language = 'en'
          this.serviceProviderProperties = {}
          if ('serviceProviderProperties' in t) {
            this.serviceProviderProperties = t.serviceProviderProperties
          }
          this.configurationService = ''
          if ('configurationService' in t) {
            this.serviceProviderProperties.URI = t.configurationService
            console.warn(
              'Deprecated property configurationService. Use serviceParameters on instead.',
              [t.configurationService]
            )
          }
          this.version = 'version' in t ? t.version : ''
          this.target = null
          if ('target' in t) {
            this.target = t.target
          } else {
            throw new Error(
              'IntegrationModel constructor error: target property missed.'
            )
          }
          if ('scriptName' in t) {
            this.scriptName = t.scriptName
          }
          this.callbackMethodArguments = {}
          if ('callbackMethodArguments' in t) {
            this.callbackMethodArguments = t.callbackMethodArguments
          }
          this.environment = {}
          if ('environment' in t) {
            this.environment = t.environment
          }
          this.isIframe = false
          if (this.target != null) {
            this.isIframe = this.target.tagName.toUpperCase() === 'IFRAME'
          }
          this.editorObject = null
          if ('editorObject' in t) {
            this.editorObject = t.editorObject
          }
          this.rtl = false
          if ('rtl' in t) {
            this.rtl = t.rtl
          }
          this.managesLanguage = false
          if ('managesLanguage' in t) {
            this.managesLanguage = t.managesLanguage
          }
          this.temporalImageResizing = false
          this.core = null
          this.listeners = new Ez()
          if ('integrationParameters' in t) {
            CL.integrationParameters.forEach((e) => {
              if (e in t.integrationParameters) {
                const n = t.integrationParameters[e]
                if (Object.keys(n).length !== 0) {
                  this[e] = n
                }
              }
            })
          }
        }
        init() {
          this.language = this.getLanguage()
          const t = Ez.newListener('onLoad', () => {
            this.callbackFunction(this.callbackMethodArguments)
          })
          if (
            this.serviceProviderProperties.URI.indexOf('configuration') !== -1
          ) {
            const t = this.serviceProviderProperties.URI
            const e = Dz.getServerLanguageFromService(t)
            this.serviceProviderProperties.server = e
            const n =
              this.serviceProviderProperties.URI.indexOf('configuration')
            const i = this.serviceProviderProperties.URI.substring(0, n)
            this.serviceProviderProperties.URI = i
          }
          let e = this.serviceProviderProperties.URI
          e =
            e.indexOf('/') === 0 || e.indexOf('http') === 0
              ? e
              : Sz.concatenateUrl(this.getPath(), e)
          this.serviceProviderProperties.URI = e
          const n = {}
          n.serviceProviderProperties = this.serviceProviderProperties
          this.setCore(new vL(n))
          this.core.addListener(t)
          this.core.language = this.language
          this.core.init()
          this.core.setEnvironment(this.environment)
        }
        getPath() {
          if (typeof this.scriptName === 'undefined') {
            throw new Error('scriptName property needed for getPath.')
          }
          const t = document.getElementsByTagName('script')
          let e = ''
          for (let n = 0; n < t.length; n += 1) {
            const i = t[n].src.lastIndexOf(this.scriptName)
            if (i >= 0) {
              e = t[n].src.substr(0, i - 1)
            }
          }
          return e
        }
        getVersion() {
          return this.version
        }
        setLanguage(t) {
          this.language = t
        }
        setCore(t) {
          this.core = t
          t.setIntegrationModel(this)
        }
        getCore() {
          return this.core
        }
        setTarget(t) {
          this.target = t
          this.isIframe = this.target.tagName.toUpperCase() === 'IFRAME'
        }
        setEditorObject(t) {
          this.editorObject = t
        }
        openNewFormulaEditor() {
          this.core.editionProperties.isNewElement = true
          this.core.openModalDialog(this.target, this.isIframe)
        }
        openExistingFormulaEditor() {
          this.core.editionProperties.isNewElement = false
          this.core.openModalDialog(this.target, this.isIframe)
        }
        updateFormula(t) {
          if (this.editorParameters) {
            t = com.wiris.editor.util.EditorUtils.addAnnotation(
              t,
              'application/vnd.wiris.mtweb-params+json',
              JSON.stringify(this.editorParameters)
            )
          }
          let e
          let n
          const i = null
          if (this.isIframe) {
            e = this.target.contentWindow
            n = this.target.contentWindow
          } else {
            e = this.target
            n = window
          }
          let o = this.core.beforeUpdateFormula(t, i)
          if (!o) {
            return ''
          }
          o = this.insertFormula(e, n, o.mathml, o.wirisProperties)
          if (!o) {
            return ''
          }
          return this.core.afterUpdateFormula(
            o.focusElement,
            o.windowTarget,
            o.node,
            o.latex
          )
        }
        insertFormula(t, e, n, i) {
          return this.core.insertFormula(t, e, n, i)
        }
        getSelection() {
          if (this.isIframe) {
            this.target.contentWindow.focus()
            return this.target.contentWindow.getSelection()
          }
          this.target.focus()
          return window.getSelection()
        }
        addEvents() {
          const t = this.isIframe
            ? this.target.contentWindow.document
            : this.target
          Sz.addElementEvents(
            t,
            (t, e) => {
              this.doubleClickHandler(t, e)
            },
            (t, e) => {
              this.mousedownHandler(t, e)
            },
            (t, e) => {
              this.mouseupHandler(t, e)
            }
          )
        }
        removeEvents() {
          const t = this.isIframe
            ? this.target.contentWindow.document
            : this.target
          Sz.removeElementEvents(t)
        }
        doubleClickHandler(t) {
          if (t.nodeName.toLowerCase() === 'img') {
            this.core.getCustomEditors().disable()
            const e = yz.get('imageCustomEditorName')
            if (t.hasAttribute(e)) {
              const n = t.getAttribute(e)
              this.core.getCustomEditors().enable(n)
            }
            if (Sz.containsClass(t, yz.get('imageClassName'))) {
              this.core.editionProperties.temporalImage = t
              this.core.editionProperties.isNewElement = true
              this.openExistingFormulaEditor()
            }
          }
        }
        mouseupHandler() {
          if (this.temporalImageResizing) {
            setTimeout(() => {
              Bz.fixAfterResize(this.temporalImageResizing)
            }, 10)
          }
        }
        mousedownHandler(t) {
          if (t.nodeName.toLowerCase() === 'img') {
            if (Sz.containsClass(t, yz.get('imageClassName'))) {
              this.temporalImageResizing = t
            }
          }
        }
        getLanguage() {
          return this.getBrowserLanguage()
        }
        getBrowserLanguage() {
          let t = 'en'
          if (navigator.userLanguage) {
            t = navigator.userLanguage.substring(0, 2)
          } else if (navigator.language) {
            t = navigator.language.substring(0, 2)
          } else {
            t = 'en'
          }
          return t
        }
        callbackFunction() {
          const t = Ez.newListener('onTargetReady', () => {
            this.addEvents(this.target)
          })
          this.listeners.add(t)
        }
        notifyWindowClosed() {}
        getMathmlFromTextNode(t, e) {}
        fillNonLatexNode(t, e, n) {}
        getSelectedItem(t, e) {}
        static setActionsOnCancelButtons() {
          if (WirisPlugin.currentInstance) {
            WirisPlugin.currentInstance.core.editionProperties.temporalImage =
              null
          }
          const t = WirisPlugin.currentInstance
          const e = t.getSelection()
          e.removeAllRanges()
          if (t.core.editionProperties.range) {
            const { range: n } = t.core.editionProperties
            t.core.editionProperties.range = null
            e.addRange(n)
          }
        }
      }
      CL.prototype.getMathmlFromTextNode = undefined
      CL.prototype.fillNonLatexNode = undefined
      CL.prototype.getSelectedItem = undefined
      CL.integrationParameters = [
        'serviceProviderProperties',
        'editorParameters'
      ]
      class yL extends CL {
        constructor(t) {
          const e = t.editorObject
          if (
            typeof e.config !== 'undefined' &&
            typeof e.config.get('mathTypeParameters') !== 'undefined'
          ) {
            t.integrationParameters = e.config.get('mathTypeParameters')
          }
          super(t)
          this.integrationFolderName = 'ckeditor_wiris'
        }
        getLanguage() {
          try {
            return this.editorParameters.language
          } catch (t) {
            console.error()
          }
          const t = this.editorObject.config.get('language')
          if (t != null) {
            if (typeof t === 'object') {
              if (t.hasOwnProperty('ui')) {
                return t.ui
              }
              return t
            }
            return t
          }
          return super.getLanguage()
        }
        addEditorListeners() {
          const t = this.editorObject
          if (
            typeof t.config.wirislistenersdisabled === 'undefined' ||
            !t.config.wirislistenersdisabled
          ) {
            this.checkElement()
          }
        }
        checkElement() {
          const t = this.editorObject
          const e = t.sourceElement
          if (!e.wirisActive) {
            this.setTarget(e)
            this.addEvents()
            e.wirisActive = true
          }
        }
        doubleClickHandler(t, e) {
          if (this.editorObject.isReadOnly === false) {
            if (t.nodeName.toLowerCase() === 'img') {
              if (Sz.containsClass(t, yz.get('imageClassName'))) {
                if (typeof e.stopPropagation !== 'undefined') {
                  e.stopPropagation()
                } else {
                  e.returnValue = false
                }
                this.core.getCustomEditors().disable()
                const n = t.getAttribute(yz.get('imageCustomEditorName'))
                if (n) {
                  this.core.getCustomEditors().enable(n)
                }
                this.core.editionProperties.temporalImage = t
                this.openExistingFormulaEditor()
              }
            }
          }
        }
        static getCorePath() {
          return null
        }
        callbackFunction() {
          super.callbackFunction()
          this.addEditorListeners()
        }
        openNewFormulaEditor() {
          this.core.editionProperties.selection =
            this.editorObject.editing.view.document.selection
          return super.openNewFormulaEditor()
        }
        insertMathml(t) {
          return this.editorObject.model.change((e) => {
            const n = this.getCore()
            const i = e.createElement('mathml', { formula: t })
            i.data = t
            if (n.editionProperties.isNewElement) {
              if (!t) return
              const n =
                this.core.editionProperties.selection ||
                this.editorObject.editing.view.document.selection
              const o = this.editorObject.editing.mapper.toModelPosition(
                n.getLastPosition()
              )
              e.insert(i, o)
              if (!n.isCollapsed) {
                for (const t of n.getRanges()) {
                  e.remove(this.editorObject.editing.mapper.toModelRange(t))
                }
              }
              const r = this.editorObject.model.createPositionAfter(i)
              e.setSelection(r)
            } else {
              const o = n.editionProperties.temporalImage
              const r =
                this.editorObject.editing.view.domConverter.domToView(o).parent
              const s = this.editorObject.editing.mapper.toModelElement(r)
              const a = this.editorObject.model.createPositionBefore(s)
              if (t) {
                e.insert(i, a)
              }
              e.remove(s)
            }
            return i
          })
        }
        findText(t) {
          let e = t
          let n
          while (!n) {
            n = this.editorObject.editing.mapper.toModelElement(
              this.editorObject.editing.view.domConverter.domToView(e)
            )
            e = e.parentElement
          }
          const i = this.editorObject.model.createRangeIn(n)
          const o = Array.from(i.getItems())
          for (const e of o) {
            if (
              e.is('textProxy') &&
              e.data === t.data.replace(String.fromCharCode(160), ' ')
            ) {
              return e.textNode
            }
          }
        }
        insertFormula(t, e, n, i) {
          const o = {}
          if (!n) {
            this.insertMathml('')
          } else if (this.core.editMode === 'latex') {
            o.latex = Tz.getLatexFromMathML(n)
            o.node = e.document.createTextNode(`$$${o.latex}$$`)
            this.editorObject.model.change((t) => {
              const { latexRange: e } = this.core.editionProperties
              const n = this.findText(e.startContainer)
              const i = this.findText(e.endContainer)
              const r = t.createPositionAt(
                n.parent,
                n.startOffset + e.startOffset
              )
              const s = t.createPositionAt(
                i.parent,
                i.startOffset + e.endOffset
              )
              const a = t.createRange(r, s)
              t.remove(a)
              t.insertText(`$$${o.latex}$$`, n.getAttributes(), r)
            })
          } else {
            try {
              o.node = this.editorObject.editing.view.domConverter.viewToDom(
                this.editorObject.editing.mapper.toViewElement(
                  this.insertMathml(n)
                ),
                e.document
              )
            } catch (t) {
              const e = t.toString()
              if (
                e.includes(
                  "CKEditorError: Cannot read property 'parent' of undefined"
                )
              ) {
                this.core.modalDialog.cancelAction()
              }
            }
          }
          return o
        }
        notifyWindowClosed() {
          this.editorObject.editing.view.focus()
        }
      }
      class xL extends Zd {
        execute(t = {}) {
          if (
            !t.hasOwnProperty('integration') ||
            !(t.integration instanceof yL)
          ) {
            throw 'Must pass a valid CKEditor5Integration instance as attribute "integration" of options'
          }
          this.integration = t.integration
          this.setEditor()
          this.openEditor()
        }
        setEditor() {
          this.integration.core.getCustomEditors().disable()
        }
        openEditor() {
          const t = this._getSelectedImage()
          if (
            typeof t !== 'undefined' &&
            t !== null &&
            t.classList.contains(
              WirisPlugin.Configuration.get('imageClassName')
            )
          ) {
            this.integration.core.editionProperties.temporalImage = t
            this.integration.openExistingFormulaEditor()
          } else {
            this.integration.openNewFormulaEditor()
          }
        }
        _getSelectedImage() {
          const { selection: t } = this.editor.editing.view.document
          if (t.isCollapsed || t.rangeCount !== 1) {
            return
          }
          const e = t.getFirstRange()
          let n
          for (const t of e) {
            if (t.item.name !== 'span') {
              return
            }
            n = t.item.getChild(0)
            break
          }
          if (!n) {
            return
          }
          return this.editor.editing.view.domConverter.mapViewToDom(n)
        }
      }
      class EL extends xL {
        setEditor() {
          this.integration.core.getCustomEditors().enable('chemistry')
        }
      }
      const DL =
        '<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 300 261.7" style="enable-background:new 0 0 300 261.7;" xml:space="preserve">\n<style type="text/css">\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#EF4A5F;}\n\t.st2{fill:#C8202F;}\n</style>\n<path class="st0" d="M300,32.8c0-16.4-13.4-29.7-29.9-29.7c-2.9,0-7.2,0.8-7.2,0.8c-37.9,9.1-71.3,14-112,14c-0.3,0-0.6,0-1,0\n\tc-16.5,0-29.9,13.3-29.9,29.7c0,16.4,13.4,29.7,29.9,29.7l0,0c45.3,0,83.1-5.3,125.3-15.3h0C289.3,59.5,300,47.4,300,32.8"/>\n<path class="st0" d="M90.2,257.7c-11.4,0-21.9-6.4-27-16.7l-60-119.9c-7.5-14.9-1.4-33.1,13.5-40.5c14.9-7.5,33.1-1.4,40.5,13.5\n\tl27.3,54.7L121.1,39c5.3-15.8,22.4-24.4,38.2-19.1c15.8,5.3,24.4,22.4,19.1,38.2l-59.6,179c-3.9,11.6-14.3,19.7-26.5,20.6\n\tC91.6,257.7,90.9,257.7,90.2,257.7"/>\n<g>\n\t<g>\n\t\t<path class="st1" d="M90.2,257.7c-11.4,0-21.9-6.4-27-16.7l-60-119.9c-7.5-14.9-1.4-33.1,13.5-40.5c14.9-7.5,33.1-1.4,40.5,13.5\n\t\t\tl27.3,54.7L121.1,39c5.3-15.8,22.4-24.4,38.2-19.1c15.8,5.3,24.4,22.4,19.1,38.2l-59.6,179c-3.9,11.6-14.3,19.7-26.5,20.6\n\t\t\tC91.6,257.7,90.9,257.7,90.2,257.7"/>\n\t</g>\n</g>\n<g>\n\t<g>\n\t\t<path class="st2" d="M300,32.8c0-16.4-13.4-29.7-29.9-29.7c-2.9,0-7.2,0.8-7.2,0.8c-37.9,9.1-71.3,14-112,14c-0.3,0-0.6,0-1,0\n\t\t\tc-16.5,0-29.9,13.3-29.9,29.7c0,16.4,13.4,29.7,29.9,29.7l0,0c45.3,0,83.1-5.3,125.3-15.3h0C289.3,59.5,300,47.4,300,32.8"/>\n\t</g>\n</g>\n</svg>\n'
      const TL =
        '<?xml version="1.0" encoding="utf-8"?>\n\x3c!-- Generator: Adobe Illustrator 22.0.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  --\x3e\n<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n\t viewBox="0 0 40.3 49.5" style="enable-background:new 0 0 40.3 49.5;" xml:space="preserve">\n<style type="text/css">\n\t.st0{fill:#A4CF61;}\n</style>\n<path class="st0" d="M39.2,12.1c0-1.9-1.1-3.6-2.7-4.4L24.5,0.9l0,0c-0.7-0.4-1.5-0.6-2.4-0.6c-0.9,0-1.7,0.2-2.4,0.6l0,0L2.3,10.8\n\tl0,0C0.9,11.7,0,13.2,0,14.9h0v19.6h0c0,1.7,0.9,3.3,2.3,4.1l0,0l17.4,9.9l0,0c0.7,0.4,1.5,0.6,2.4,0.6c0.9,0,1.7-0.2,2.4-0.6l0,0\n\tl12.2-6.9h0c1.5-0.8,2.6-2.5,2.6-4.3c0-2.7-2.2-4.9-4.9-4.9c-0.9,0-1.8,0.3-2.5,0.7l0,0l-9.7,5.6l-12.3-7V17.8l12.3-7l9.9,5.7l0,0\n\tc0.7,0.4,1.5,0.6,2.4,0.6C37,17,39.2,14.8,39.2,12.1"/>\n</svg>\n'
      let ML = null
      class IL extends Kd {
        static get requires() {
          return [RT]
        }
        static get pluginName() {
          return 'MathType'
        }
        init() {
          const t = this._addIntegration()
          ML = t
          this._addCommands()
          this._addViews(t)
          this._addSchema()
          this._addConverters()
          this._exposeWiris()
        }
        destroy() {
          ML.removeEvents()
        }
        _addIntegration() {
          const { editor: t } = this
          const e = {}
          e.environment = {}
          e.environment.editor = 'CKEditor5'
          e.environment.editorVersion = '5.x'
          e.editorObject = t
          e.serviceProviderProperties = {}
          e.serviceProviderProperties.URI =
            'https://www.wiris.net/demo/plugins/app'
          e.serviceProviderProperties.server = 'java'
          e.target = t.sourceElement
          e.scriptName = 'bundle.js'
          e.managesLanguage = true
          let n
          if (e.target) {
            n = new yL(e)
            n.init()
            n.listeners.fire('onTargetReady', {})
            n.checkElement()
            this.listenTo(
              t.editing.view.document,
              'click',
              (t, e) => {
                if (e.domEvent.detail === 2) {
                  n.doubleClickHandler(e.domTarget, e.domEvent)
                  t.stop()
                }
              },
              { priority: 'highest' }
            )
          }
          return n
        }
        _addCommands() {
          const { editor: t } = this
          t.commands.add('MathType', new xL(t))
          t.commands.add('ChemType', new EL(t))
        }
        _addViews(t) {
          const { editor: e } = this
          if (yz.get('editorEnabled')) {
            e.ui.componentFactory.add('MathType', (n) => {
              const i = new pd(n)
              i.bind('isEnabled').to(e.commands.get('MathType'), 'isEnabled')
              i.set({
                label: Iz.get('insert_math', e.config.get('language')),
                icon: DL,
                tooltip: true
              })
              i.on('execute', () => {
                e.execute('MathType', { integration: t })
              })
              return i
            })
          }
          if (yz.get('chemEnabled')) {
            e.ui.componentFactory.add('ChemType', (n) => {
              const i = new pd(n)
              i.bind('isEnabled').to(e.commands.get('ChemType'), 'isEnabled')
              i.set({
                label: Iz.get('insert_chem', e.config.get('language')),
                icon: TL,
                tooltip: true
              })
              i.on('execute', () => {
                e.execute('ChemType', { integration: t })
              })
              return i
            })
          }
          e.editing.view.addObserver(dA)
        }
        _addSchema() {
          const { schema: t } = this.editor.model
          t.register('mathml', {
            allowWhere: '$text',
            isObject: true,
            isInline: true,
            allowAttributes: ['formula']
          })
        }
        _addConverters() {
          const { editor: t } = this
          t.conversion.for('upcast').elementToElement({
            view: { name: 'span', classes: 'ck-math-widget' },
            model: (t, { writer: e }) => {
              const n = Cz.safeXmlDecode(
                t.getChild(0).getAttribute('data-mathml')
              )
              return e.createElement('mathml', { formula: n })
            }
          })
          t.data.upcastDispatcher.on('element:math', (n, i, o) => {
            const { consumable: r, writer: s } = o
            const { viewItem: a } = i
            if (!r.test(a, { name: true })) {
              return
            }
            const c = e(a)
            const l = new wz(t.editing.view.document)
            const d = new hA(t.editing.view.document)
            const u = d.createDocumentFragment(a.getChildren())
            const h = [...a.getAttributes()]
              .map(([t, e]) => ` ${t}="${e}"`)
              .join('')
            let f = l.toData(u) || ''
            f = Sz.htmlSanitize(`<math${h}>${f}</math>`)
            const m = c
              ? s.createText(zz.initParse(f, t.config.get('language')))
              : s.createElement('mathml', { formula: f })
            const g = o.splitToAllowedParent(m, i.modelCursor)
            if (!g) {
              return
            }
            o.writer.insert(m, g.position)
            r.consume(a, { name: true })
            const p = o.getSplitParts(m)
            i.modelRange = s.createRange(
              o.writer.createPositionBefore(m),
              o.writer.createPositionAfter(p[p.length - 1])
            )
            if (g.cursorParent) {
              i.modelCursor = o.writer.createPositionAt(g.cursorParent, 0)
            } else {
              i.modelCursor = i.modelRange.end
            }
          })
          function e(t) {
            const e = t.getChild(0)
            if (!e || e.name !== 'semantics') return false
            for (const t of e.getChildren()) {
              if (
                t.name === 'annotation' &&
                t.getAttribute('encoding') === 'LaTeX'
              ) {
                return true
              }
            }
            return false
          }
          function n(t, { writer: e }) {
            const n = e.createContainerElement('span', {
              class: 'ck-math-widget'
            })
            const o = i(t, { writer: e })
            if (o) {
              e.insert(e.createPositionAt(n, 0), o)
            }
            return JD(n, e)
          }
          function i(e, { writer: n }) {
            const i = new fw(n.document)
            const o = e.getAttribute('formula')
            const r = zz.initParse(o, t.config.get('language'))
            const s = i.toView(r).getChild(0)
            if (s) {
              return n.createEmptyElement('img', s.getAttributes(), {
                renderUnsafeAttributes: ['src']
              })
            }
            return null
          }
          t.conversion
            .for('editingDowncast')
            .elementToElement({ model: 'mathml', view: n })
          t.conversion
            .for('dataDowncast')
            .elementToElement({ model: 'mathml', view: r })
          function o(t, e) {
            if (e.is('text')) {
              return t.createText(e.data)
            }
            if (e.is('element')) {
              if (e.is('emptyElement')) {
                return t.createEmptyElement(e.name, e.getAttributes())
              }
              const n = t.createContainerElement(e.name, e.getAttributes())
              for (const i of e.getChildren()) {
                t.insert(t.createPositionAt(n, 'end'), o(t, i))
              }
              return n
            }
            throw new Exception('Given node has unsupported type.')
          }
          function r(t, { writer: e }) {
            const n = new fw(e.document)
            let i = zz.endParseSaveMode(t.getAttribute('formula'))
            if (!yz.get('saveHandTraces')) {
              i = Cz.removeAnnotation(i, 'application/json')
            }
            const r = n.toView(i).getChild(0)
            return o(e, r)
          }
          t.editing.mapper.on(
            'viewToModelPosition',
            sT(t.model, (t) => t.hasClass('ck-math-widget'))
          )
          const { get: s } = t.data
          t.data.get = (e) => {
            const n = s.bind(t.data)(e)
            return zz.endParse(n)
          }
        }
        _exposeWiris() {
          window.WirisPlugin = {
            Core: vL,
            Parser: zz,
            Image: Bz,
            MathML: Cz,
            Util: Sz,
            Configuration: yz,
            Listeners: Ez,
            IntegrationModel: CL,
            currentInstance: ML,
            Latex: Tz
          }
        }
      }
      function SL(t, e) {
        return (t) => {
          t.on('attribute:url:media', n)
        }
        function n(n, i, o) {
          if (!o.consumable.consume(i.item, n.name)) {
            return
          }
          const r = i.attributeNewValue
          const s = o.writer
          const a = o.mapper.toViewElement(i.item)
          const c = [...a.getChildren()].find((t) =>
            t.getCustomProperty('media-content')
          )
          s.remove(c)
          const l = t.getMediaViewElement(s, r, e)
          s.insert(s.createPositionAt(a, 0), l)
        }
      }
      function BL(t, e, n) {
        e.setCustomProperty('media', true, t)
        return JD(t, e, { label: n })
      }
      function NL(t) {
        const e = t.getSelectedElement()
        if (e && PL(e)) {
          return e
        }
        return null
      }
      function PL(t) {
        return !!t.getCustomProperty('media') && isWidget(t)
      }
      function zL(t, e, n, i) {
        return t.createContainerElement('figure', { class: 'media' }, [
          e.getMediaViewElement(t, n, i),
          t.createSlot()
        ])
      }
      function LL(t) {
        const e = t.getSelectedElement()
        if (e && e.is('element', 'media')) {
          return e
        }
        return null
      }
      function OL(t, e, n, i) {
        t.change((o) => {
          const r = o.createElement('media', { url: e })
          t.insertObject(r, n, null, {
            setSelection: 'on',
            findOptimalPosition: i
          })
        })
      }
      class RL extends Zd {
        refresh() {
          const t = this.editor.model
          const e = t.document.selection
          const n = LL(e)
          this.value = n ? n.getAttribute('url') : null
          this.isEnabled = FL(e) || jL(e, t)
        }
        execute(t) {
          const e = this.editor.model
          const n = e.document.selection
          const i = LL(n)
          if (i) {
            e.change((e) => {
              e.setAttribute('url', t, i)
            })
          } else {
            OL(e, t, n, true)
          }
        }
      }
      function jL(t, e) {
        const n = rT(t, e)
        let i = n.start.parent
        if (i.isEmpty && !e.schema.isLimit(i)) {
          i = i.parent
        }
        return e.schema.checkChild(i, 'media')
      }
      function FL(t) {
        const e = t.getSelectedElement()
        return !!e && e.name === 'media'
      }
      const VL =
        '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>'
      const HL = '0 0 64 42'
      class UL {
        constructor(t, e) {
          const n = e.providers
          const i = e.extraProviders || []
          const o = new Set(e.removeProviders)
          const r = n.concat(i).filter((t) => {
            const e = t.name
            if (!e) {
              P('media-embed-no-provider-name', { provider: t })
              return false
            }
            return !o.has(e)
          })
          this.locale = t
          this.providerDefinitions = r
        }
        hasMedia(t) {
          return !!this._getMedia(t)
        }
        getMediaViewElement(t, e, n) {
          return this._getMedia(e).getViewElement(t, n)
        }
        _getMedia(t) {
          if (!t) {
            return new WL(this.locale)
          }
          t = t.trim()
          for (const e of this.providerDefinitions) {
            const n = e.html
            const i = Zc(e.url)
            for (const e of i) {
              const i = this._getUrlMatches(t, e)
              if (i) {
                return new WL(this.locale, t, i, n)
              }
            }
          }
          return null
        }
        _getUrlMatches(t, e) {
          let n = t.match(e)
          if (n) {
            return n
          }
          let i = t.replace(/^https?:\/\//, '')
          n = i.match(e)
          if (n) {
            return n
          }
          i = i.replace(/^www\./, '')
          n = i.match(e)
          if (n) {
            return n
          }
          return null
        }
      }
      class WL {
        constructor(t, e, n, i) {
          this.url = this._getValidUrl(e)
          this._locale = t
          this._match = n
          this._previewRenderer = i
        }
        getViewElement(t, e) {
          const n = {}
          let i
          if (
            e.renderForEditingView ||
            (e.renderMediaPreview && this.url && this._previewRenderer)
          ) {
            if (this.url) {
              n['data-oembed-url'] = this.url
            }
            if (e.renderForEditingView) {
              n.class = 'ck-media__wrapper'
            }
            const o = this._getPreviewHtml(e)
            i = t.createRawElement('div', n, (t, e) => {
              e.setContentOf(t, o)
            })
          } else {
            if (this.url) {
              n.url = this.url
            }
            i = t.createEmptyElement(e.elementName, n)
          }
          t.setCustomProperty('media-content', true, i)
          return i
        }
        _getPreviewHtml(t) {
          if (this._previewRenderer) {
            return this._previewRenderer(this._match)
          } else {
            if (this.url && t.renderForEditingView) {
              return this._getPlaceholderHtml()
            }
            return ''
          }
        }
        _getPlaceholderHtml() {
          const t = new ud()
          const e = this._locale.t
          t.content = VL
          t.viewBox = HL
          const n = new Nl({
            tag: 'div',
            attributes: { class: 'ck ck-reset_all ck-media__placeholder' },
            children: [
              {
                tag: 'div',
                attributes: { class: 'ck-media__placeholder__icon' },
                children: [t]
              },
              {
                tag: 'a',
                attributes: {
                  class: 'ck-media__placeholder__url',
                  target: '_blank',
                  rel: 'noopener noreferrer',
                  href: this.url,
                  'data-cke-tooltip-text': e('Open media in new tab')
                },
                children: [
                  {
                    tag: 'span',
                    attributes: { class: 'ck-media__placeholder__url__text' },
                    children: [this.url]
                  }
                ]
              }
            ]
          }).render()
          return n.outerHTML
        }
        _getValidUrl(t) {
          if (!t) {
            return null
          }
          if (t.match(/^https?/)) {
            return t
          }
          return 'https://' + t
        }
      }
      var qL = __webpack_require__(952)
      var $L = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      $L.insert = 'head'
      $L.singleton = true
      var GL = El()(qL.Z, $L)
      const YL = qL.Z.locals || {}
      class KL extends Kd {
        static get pluginName() {
          return 'MediaEmbedEditing'
        }
        constructor(t) {
          super(t)
          t.config.define('mediaEmbed', {
            elementName: 'oembed',
            providers: [
              {
                name: 'dailymotion',
                url: /^dailymotion\.com\/video\/(\w+)/,
                html: (t) => {
                  const e = t[1]
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; ">' +
                    `<iframe src="https://www.dailymotion.com/embed/video/${e}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" width="480" height="270" allowfullscreen allow="autoplay">' +
                    '</iframe>' +
                    '</div>'
                  )
                }
              },
              {
                name: 'spotify',
                url: [
                  /^open\.spotify\.com\/(artist\/\w+)/,
                  /^open\.spotify\.com\/(album\/\w+)/,
                  /^open\.spotify\.com\/(track\/\w+)/
                ],
                html: (t) => {
                  const e = t[1]
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;">' +
                    `<iframe src="https://open.spotify.com/embed/${e}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allowtransparency="true" allow="encrypted-media">' +
                    '</iframe>' +
                    '</div>'
                  )
                }
              },
              {
                name: 'youtube',
                url: [
                  /^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/,
                  /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/,
                  /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/,
                  /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/
                ],
                html: (t) => {
                  const e = t[1]
                  const n = t[2]
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
                    `<iframe src="https://www.youtube.com/embed/${e}${
                      n ? `?start=${n}` : ''
                    }" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' +
                    '</iframe>' +
                    '</div>'
                  )
                }
              },
              {
                name: 'vimeo',
                url: [
                  /^vimeo\.com\/(\d+)/,
                  /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/,
                  /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/,
                  /^vimeo\.com\/channels\/[^/]+\/(\d+)/,
                  /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/,
                  /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/,
                  /^player\.vimeo\.com\/video\/(\d+)/
                ],
                html: (t) => {
                  const e = t[1]
                  return (
                    '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' +
                    `<iframe src="https://player.vimeo.com/video/${e}" ` +
                    'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' +
                    'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>' +
                    '</iframe>' +
                    '</div>'
                  )
                }
              },
              { name: 'instagram', url: /^instagram\.com\/p\/(\w+)/ },
              { name: 'twitter', url: /^twitter\.com/ },
              {
                name: 'googleMaps',
                url: [
                  /^google\.com\/maps/,
                  /^goo\.gl\/maps/,
                  /^maps\.google\.com/,
                  /^maps\.app\.goo\.gl/
                ]
              },
              { name: 'flickr', url: /^flickr\.com/ },
              { name: 'facebook', url: /^facebook\.com/ }
            ]
          })
          this.registry = new UL(t.locale, t.config.get('mediaEmbed'))
        }
        init() {
          const t = this.editor
          const e = t.model.schema
          const n = t.t
          const i = t.conversion
          const o = t.config.get('mediaEmbed.previewsInData')
          const r = t.config.get('mediaEmbed.elementName')
          const s = this.registry
          t.commands.add('mediaEmbed', new RL(t))
          e.register('media', {
            inheritAllFrom: '$blockObject',
            allowAttributes: ['url']
          })
          i.for('dataDowncast').elementToStructure({
            model: 'media',
            view: (t, { writer: e }) => {
              const n = t.getAttribute('url')
              return zL(e, s, n, { elementName: r, renderMediaPreview: n && o })
            }
          })
          i.for('dataDowncast').add(
            SL(s, { elementName: r, renderMediaPreview: o })
          )
          i.for('editingDowncast').elementToStructure({
            model: 'media',
            view: (t, { writer: e }) => {
              const i = t.getAttribute('url')
              const o = zL(e, s, i, {
                elementName: r,
                renderForEditingView: true
              })
              return BL(o, e, n('media widget'))
            }
          })
          i.for('editingDowncast').add(
            SL(s, { elementName: r, renderForEditingView: true })
          )
          i.for('upcast')
            .elementToElement({
              view: (t) =>
                ['oembed', r].includes(t.name) && t.getAttribute('url')
                  ? { name: true }
                  : null,
              model: (t, { writer: e }) => {
                const n = t.getAttribute('url')
                if (s.hasMedia(n)) {
                  return e.createElement('media', { url: n })
                }
              }
            })
            .elementToElement({
              view: { name: 'div', attributes: { 'data-oembed-url': true } },
              model: (t, { writer: e }) => {
                const n = t.getAttribute('data-oembed-url')
                if (s.hasMedia(n)) {
                  return e.createElement('media', { url: n })
                }
              }
            })
            .add((t) => {
              t.on('element:figure', e)
              function e(t, e, n) {
                if (
                  !n.consumable.consume(e.viewItem, {
                    name: true,
                    classes: 'media'
                  })
                ) {
                  return
                }
                const { modelRange: i, modelCursor: o } = n.convertChildren(
                  e.viewItem,
                  e.modelCursor
                )
                e.modelRange = i
                e.modelCursor = o
                const r = cl(i.getItems())
                if (!r) {
                  n.consumable.revert(e.viewItem, {
                    name: true,
                    classes: 'media'
                  })
                }
              }
            })
        }
      }
      const QL = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/
      class ZL extends Kd {
        static get requires() {
          return [EM, Lx, UM]
        }
        static get pluginName() {
          return 'AutoMediaEmbed'
        }
        constructor(t) {
          super(t)
          this._timeoutId = null
          this._positionToInsert = null
        }
        init() {
          const t = this.editor
          const e = t.model.document
          this.listenTo(
            t.plugins.get('ClipboardPipeline'),
            'inputTransformation',
            () => {
              const t = e.selection.getFirstRange()
              const n = t_.fromPosition(t.start)
              n.stickiness = 'toPrevious'
              const i = t_.fromPosition(t.end)
              i.stickiness = 'toNext'
              e.once(
                'change:data',
                () => {
                  this._embedMediaBetweenPositions(n, i)
                  n.detach()
                  i.detach()
                },
                { priority: 'high' }
              )
            }
          )
          t.commands.get('undo').on(
            'execute',
            () => {
              if (this._timeoutId) {
                ec.window.clearTimeout(this._timeoutId)
                this._positionToInsert.detach()
                this._timeoutId = null
                this._positionToInsert = null
              }
            },
            { priority: 'high' }
          )
        }
        _embedMediaBetweenPositions(t, e) {
          const n = this.editor
          const i = n.plugins.get(KL).registry
          const o = new hb(t, e)
          const r = o.getWalker({ ignoreElementEnd: true })
          let s = ''
          for (const t of r) {
            if (t.item.is('$textProxy')) {
              s += t.item.data
            }
          }
          s = s.trim()
          if (!s.match(QL)) {
            o.detach()
            return
          }
          if (!i.hasMedia(s)) {
            o.detach()
            return
          }
          const a = n.commands.get('mediaEmbed')
          if (!a.isEnabled) {
            o.detach()
            return
          }
          this._positionToInsert = t_.fromPosition(t)
          this._timeoutId = ec.window.setTimeout(() => {
            n.model.change((t) => {
              this._timeoutId = null
              t.remove(o)
              o.detach()
              let e
              if (this._positionToInsert.root.rootName !== '$graveyard') {
                e = this._positionToInsert
              }
              OL(n.model, s, e, false)
              this._positionToInsert.detach()
              this._positionToInsert = null
            })
            n.plugins.get('Delete').requestUndoOnBackspace()
          }, 100)
        }
      }
      var JL = __webpack_require__(3525)
      var XL = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      XL.insert = 'head'
      XL.singleton = true
      var tO = El()(JL.Z, XL)
      const eO = JL.Z.locals || {}
      class nO extends Sl {
        constructor(t, n) {
          super(n)
          const i = n.t
          this.focusTracker = new ll()
          this.keystrokes = new dl()
          this.set('mediaURLInputValue', '')
          this.urlInputView = this._createUrlInput()
          this.saveButtonView = this._createButton(
            i('Save'),
            $v.check,
            'ck-button-save'
          )
          this.saveButtonView.type = 'submit'
          this.saveButtonView
            .bind('isEnabled')
            .to(this, 'mediaURLInputValue', (t) => !!t)
          this.cancelButtonView = this._createButton(
            i('Cancel'),
            $v.cancel,
            'ck-button-cancel',
            'cancel'
          )
          this._focusables = new Cl()
          this._focusCycler = new Ud({
            focusables: this._focusables,
            focusTracker: this.focusTracker,
            keystrokeHandler: this.keystrokes,
            actions: { focusPrevious: 'shift + tab', focusNext: 'tab' }
          })
          this._validators = t
          this.setTemplate({
            tag: 'form',
            attributes: {
              class: ['ck', 'ck-media-form', 'ck-responsive-form'],
              tabindex: '-1'
            },
            children: [
              this.urlInputView,
              this.saveButtonView,
              this.cancelButtonView
            ]
          })
          e(this)
        }
        render() {
          super.render()
          n({ view: this })
          const t = [
            this.urlInputView,
            this.saveButtonView,
            this.cancelButtonView
          ]
          t.forEach((t) => {
            this._focusables.add(t)
            this.focusTracker.add(t.element)
          })
          this.keystrokes.listenTo(this.element)
          const e = (t) => t.stopPropagation()
          this.keystrokes.set('arrowright', e)
          this.keystrokes.set('arrowleft', e)
          this.keystrokes.set('arrowup', e)
          this.keystrokes.set('arrowdown', e)
          this.listenTo(
            this.urlInputView.element,
            'selectstart',
            (t, e) => {
              e.stopPropagation()
            },
            { priority: 'high' }
          )
        }
        destroy() {
          super.destroy()
          this.focusTracker.destroy()
          this.keystrokes.destroy()
        }
        focus() {
          this._focusCycler.focusFirst()
        }
        get url() {
          return this.urlInputView.fieldView.element.value.trim()
        }
        set url(t) {
          this.urlInputView.fieldView.element.value = t.trim()
        }
        isValid() {
          this.resetFormStatus()
          for (const t of this._validators) {
            const e = t(this)
            if (e) {
              this.urlInputView.errorText = e
              return false
            }
          }
          return true
        }
        resetFormStatus() {
          this.urlInputView.errorText = null
          this.urlInputView.infoText = this._urlInputViewInfoDefault
        }
        _createUrlInput() {
          const t = this.locale.t
          const e = new Dy(this.locale, Ty)
          const n = e.fieldView
          this._urlInputViewInfoDefault = t('Paste the media URL in the input.')
          this._urlInputViewInfoTip = t(
            'Tip: Paste the URL into the content to embed faster.'
          )
          e.label = t('Media URL')
          e.infoText = this._urlInputViewInfoDefault
          n.on('input', () => {
            e.infoText = n.element.value
              ? this._urlInputViewInfoTip
              : this._urlInputViewInfoDefault
            this.mediaURLInputValue = n.element.value.trim()
          })
          return e
        }
        _createButton(t, e, n, i) {
          const o = new pd(this.locale)
          o.set({ label: t, icon: e, tooltip: true })
          o.extendTemplate({ attributes: { class: n } })
          if (i) {
            o.delegate('execute').to(this, i)
          }
          return o
        }
      }
      const iO =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>'
      class oO extends Kd {
        static get requires() {
          return [KL]
        }
        static get pluginName() {
          return 'MediaEmbedUI'
        }
        init() {
          const t = this.editor
          const e = t.commands.get('mediaEmbed')
          t.ui.componentFactory.add('mediaEmbed', (t) => {
            const n = kC(t)
            this._setUpDropdown(n, e)
            return n
          })
        }
        _setUpDropdown(t, e) {
          const n = this.editor
          const i = n.t
          const o = t.buttonView
          const r = n.plugins.get(KL).registry
          t.once('change:isOpen', () => {
            const i = new nO(rO(n.t, r), n.locale)
            t.panelView.children.add(i)
            o.on(
              'open',
              () => {
                i.disableCssTransitions()
                i.url = e.value || ''
                i.urlInputView.fieldView.select()
                i.enableCssTransitions()
              },
              { priority: 'low' }
            )
            t.on('submit', () => {
              if (i.isValid()) {
                n.execute('mediaEmbed', i.url)
                n.editing.view.focus()
              }
            })
            t.on('change:isOpen', () => i.resetFormStatus())
            t.on('cancel', () => {
              n.editing.view.focus()
            })
            i.delegate('submit', 'cancel').to(t)
            i.urlInputView.bind('value').to(e, 'value')
            i.urlInputView.bind('isReadOnly').to(e, 'isEnabled', (t) => !t)
          })
          t.bind('isEnabled').to(e)
          o.set({ label: i('Insert media'), icon: iO, tooltip: true })
        }
      }
      function rO(t, e) {
        return [
          (e) => {
            if (!e.url.length) {
              return t('The URL must not be empty.')
            }
          },
          (n) => {
            if (!e.hasMedia(n.url)) {
              return t('This media URL is not supported.')
            }
          }
        ]
      }
      var sO = __webpack_require__(5777)
      var aO = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      aO.insert = 'head'
      aO.singleton = true
      var cO = El()(sO.Z, aO)
      const lO = sO.Z.locals || {}
      class dO extends Kd {
        static get requires() {
          return [KL, oO, ZL, RT]
        }
        static get pluginName() {
          return 'MediaEmbed'
        }
      }
      function uO(t, e) {
        for (const n of t.getChildren()) {
          if (n.is('element', 'b') && n.getStyle('font-weight') === 'normal') {
            const i = t.getChildIndex(n)
            e.remove(n)
            e.insertChild(i, n.getChildren(), t)
          }
        }
      }
      function hO(t, e) {
        const n = new qf(e.document.stylesProcessor)
        const i = new Gm(n, { renderingMode: 'data' })
        const o = i.blockElements
        const r = i.inlineObjectElements
        const s = []
        for (const n of e.createRangeIn(t)) {
          const t = n.item
          if (t.is('element', 'br')) {
            const n = fO(t, 'forward', e, {
              blockElements: o,
              inlineObjectElements: r
            })
            const i = fO(t, 'backward', e, {
              blockElements: o,
              inlineObjectElements: r
            })
            const a = mO(n, o)
            const c = mO(i, o)
            if (c || a) {
              s.push(t)
            }
          }
        }
        for (const t of s) {
          if (t.hasClass('Apple-interchange-newline')) {
            e.remove(t)
          } else {
            e.replace(t, e.createElement('p'))
          }
        }
      }
      function fO(t, e, n, { blockElements: i, inlineObjectElements: o }) {
        let r = n.createPositionAt(t, e == 'forward' ? 'after' : 'before')
        r = r.getLastMatchingPosition(
          ({ item: t }) =>
            t.is('element') && !i.includes(t.name) && !o.includes(t.name),
          { direction: e }
        )
        return e == 'forward' ? r.nodeAfter : r.nodeBefore
      }
      function mO(t, e) {
        return !!t && t.is('element') && e.includes(t.name)
      }
      function gO(t, e) {
        if (!t.childCount) {
          return
        }
        const n = new hA(t.document)
        const i = bO(t, n)
        if (!i.length) {
          return
        }
        let o = null
        let r = 1
        i.forEach((t, s) => {
          const a = EO(i[s - 1], t)
          const c = a ? null : i[s - 1]
          const l = TO(c, t)
          if (a) {
            o = null
            r = 1
          }
          if (!o || l !== 0) {
            const i = kO(t, e)
            if (!o) {
              o = vO(i, t.element, n)
            } else if (t.indent > r) {
              const t = o.getChild(o.childCount - 1)
              const e = t.getChild(t.childCount - 1)
              o = vO(i, e, n)
              r += 1
            } else if (t.indent < r) {
              const e = r - t.indent
              o = MO(o, e)
              r = t.indent
            }
            if (t.indent <= r) {
              if (!o.is('element', i.type)) {
                o = n.rename(i.type, o)
              }
            }
          }
          const d = CO(t.element, n)
          n.appendChild(d, o)
        })
      }
      function pO(t, e) {
        for (const n of e.createRangeIn(t)) {
          const t = n.item
          if (t.is('element', 'li')) {
            const n = t.getChild(0)
            if (n && n.is('element', 'p')) {
              e.unwrapElement(n)
            }
          }
        }
      }
      function bO(t, e) {
        const n = e.createRangeIn(t)
        const i = new Cu({ name: /^p|h\d+$/, styles: { 'mso-list': /.*/ } })
        const o = []
        for (const t of n) {
          if (t.type === 'elementStart' && i.match(t.item)) {
            const e = yO(t.item)
            o.push({
              element: t.item,
              id: e.id,
              order: e.order,
              indent: e.indent
            })
          }
        }
        return o
      }
      function kO(t, e) {
        const n = new RegExp(
          `@list l${t.id}:level${t.indent}\\s*({[^}]*)`,
          'gi'
        )
        const i = /mso-level-number-format:([^;]{0,100});/gi
        const o = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi
        const r = n.exec(e)
        let s = 'decimal'
        let a = 'ol'
        let c = null
        if (r && r[1]) {
          const e = i.exec(r[1])
          if (e && e[1]) {
            s = e[1].trim()
            a = s !== 'bullet' && s !== 'image' ? 'ol' : 'ul'
          }
          if (s === 'bullet') {
            const e = wO(t.element)
            if (e) {
              s = e
            }
          } else {
            const t = o.exec(r[1])
            if (t && t[1]) {
              c = parseInt(t[1])
            }
          }
        }
        return { type: a, startIndex: c, style: AO(s) }
      }
      function wO(t) {
        const e = _O(t)
        if (!e) {
          return null
        }
        const n = e._data
        if (n === 'o') {
          return 'circle'
        } else if (n === '·') {
          return 'disc'
        } else if (n === '§') {
          return 'square'
        }
        return null
      }
      function _O(t) {
        if (t.getChild(0).is('$text')) {
          return null
        }
        for (const e of t.getChildren()) {
          if (!e.is('element', 'span')) {
            continue
          }
          const t = e.getChild(0)
          if (t.is('$text')) {
            return t
          }
          return t.getChild(0)
        }
        return null
      }
      function AO(t) {
        if (t.startsWith('arabic-leading-zero')) {
          return 'decimal-leading-zero'
        }
        switch (t) {
          case 'alpha-upper':
            return 'upper-alpha'
          case 'alpha-lower':
            return 'lower-alpha'
          case 'roman-upper':
            return 'upper-roman'
          case 'roman-lower':
            return 'lower-roman'
          case 'circle':
          case 'disc':
          case 'square':
            return t
          default:
            return null
        }
      }
      function vO(t, e, n) {
        const i = e.parent
        const o = n.createElement(t.type)
        const r = i.getChildIndex(e) + 1
        n.insertChild(r, o, i)
        if (t.style) {
          n.setStyle('list-style-type', t.style, o)
        }
        if (t.startIndex && t.startIndex > 1) {
          n.setAttribute('start', t.startIndex, o)
        }
        return o
      }
      function CO(t, e) {
        xO(t, e)
        return e.rename('li', t)
      }
      function yO(t) {
        const e = {}
        const n = t.getStyle('mso-list')
        if (n) {
          const t = n.match(/(^|\s{1,100})l(\d+)/i)
          const i = n.match(/\s{0,100}lfo(\d+)/i)
          const o = n.match(/\s{0,100}level(\d+)/i)
          if (t && i && o) {
            e.id = t[2]
            e.order = i[1]
            e.indent = parseInt(o[1])
          }
        }
        return e
      }
      function xO(t, e) {
        const n = new Cu({ name: 'span', styles: { 'mso-list': 'Ignore' } })
        const i = e.createRangeIn(t)
        for (const t of i) {
          if (t.type === 'elementStart' && n.match(t.item)) {
            e.remove(t.item)
          }
        }
      }
      function EO(t, e) {
        if (!t) {
          return true
        }
        if (t.id !== e.id) {
          if (e.indent - t.indent === 1) {
            return false
          }
          return true
        }
        const n = e.element.previousSibling
        if (!n) {
          return true
        }
        return !DO(n)
      }
      function DO(t) {
        return t.is('element', 'ol') || t.is('element', 'ul')
      }
      function TO(t, e) {
        return t ? e.indent - t.indent : e.indent - 1
      }
      function MO(t, e) {
        const n = t.getAncestors({ parentFirst: true })
        let i = null
        let o = 0
        for (const t of n) {
          if (t.is('element', 'ul') || t.is('element', 'ol')) {
            o++
          }
          if (o === e) {
            i = t
            break
          }
        }
        return i
      }
      const IO = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i
      class SO {
        constructor(t) {
          this.document = t
        }
        isActive(t) {
          return IO.test(t)
        }
        execute(t) {
          const e = new hA(this.document)
          const { body: n } = t._parsedData
          uO(n, e)
          pO(n, e)
          hO(n, e)
          t.content = n
        }
      }
      function BO(t, e) {
        if (!t.childCount) {
          return
        }
        const n = new hA(t.document)
        const i = PO(t, n)
        zO(i, t, n)
        OO(i, t, n)
        LO(t, n)
        const o = RO(t, n)
        if (o.length) {
          FO(o, jO(e), n)
        }
      }
      function NO(t) {
        return btoa(
          t
            .match(/\w{2}/g)
            .map((t) => String.fromCharCode(parseInt(t, 16)))
            .join('')
        )
      }
      function PO(t, e) {
        const n = e.createRangeIn(t)
        const i = new Cu({ name: /v:(.+)/ })
        const o = []
        for (const t of n) {
          if (t.type != 'elementStart') {
            continue
          }
          const e = t.item
          const n = e.previousSibling
          const r = n && n.is('element') ? n.name : null
          if (
            i.match(e) &&
            e.getAttribute('o:gfxdata') &&
            r !== 'v:shapetype'
          ) {
            o.push(t.item.getAttribute('id'))
          }
        }
        return o
      }
      function zO(t, e, n) {
        const i = n.createRangeIn(e)
        const o = new Cu({ name: 'img' })
        const r = []
        for (const e of i) {
          if (e.item.is('element') && o.match(e.item)) {
            const n = e.item
            const i = n.getAttribute('v:shapes')
              ? n.getAttribute('v:shapes').split(' ')
              : []
            if (i.length && i.every((e) => t.indexOf(e) > -1)) {
              r.push(n)
            } else if (!n.getAttribute('src')) {
              r.push(n)
            }
          }
        }
        for (const t of r) {
          n.remove(t)
        }
      }
      function LO(t, e) {
        const n = e.createRangeIn(t)
        const i = new Cu({ name: /v:(.+)/ })
        const o = []
        for (const t of n) {
          if (t.type == 'elementStart' && i.match(t.item)) {
            o.push(t.item)
          }
        }
        for (const t of o) {
          e.remove(t)
        }
      }
      function OO(t, e, n) {
        const i = n.createRangeIn(e)
        const o = []
        for (const e of i) {
          if (e.type == 'elementStart' && e.item.is('element', 'v:shape')) {
            const n = e.item.getAttribute('id')
            if (t.includes(n)) {
              continue
            }
            if (!r(e.item.parent.getChildren(), n)) {
              o.push(e.item)
            }
          }
        }
        for (const t of o) {
          const e = { src: s(t) }
          if (t.hasAttribute('alt')) {
            e.alt = t.getAttribute('alt')
          }
          const i = n.createElement('img', e)
          n.insertChild(t.index + 1, i, t.parent)
        }
        function r(t, e) {
          for (const n of t) {
            if (n.is('element')) {
              if (n.name == 'img' && n.getAttribute('v:shapes') == e) {
                return true
              }
              if (r(n.getChildren(), e)) {
                return true
              }
            }
          }
          return false
        }
        function s(t) {
          for (const e of t.getChildren()) {
            if (e.is('element') && e.getAttribute('src')) {
              return e.getAttribute('src')
            }
          }
        }
      }
      function RO(t, e) {
        const n = e.createRangeIn(t)
        const i = new Cu({ name: 'img' })
        const o = []
        for (const t of n) {
          if (t.item.is('element') && i.match(t.item)) {
            if (t.item.getAttribute('src').startsWith('file://')) {
              o.push(t.item)
            }
          }
        }
        return o
      }
      function jO(t) {
        if (!t) {
          return []
        }
        const e =
          /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/
        const n = new RegExp('(?:(' + e.source + '))([\\da-fA-F\\s]+)\\}', 'g')
        const i = t.match(n)
        const o = []
        if (i) {
          for (const t of i) {
            let n = false
            if (t.includes('\\pngblip')) {
              n = 'image/png'
            } else if (t.includes('\\jpegblip')) {
              n = 'image/jpeg'
            }
            if (n) {
              o.push({
                hex: t.replace(e, '').replace(/[^\da-fA-F]/g, ''),
                type: n
              })
            }
          }
        }
        return o
      }
      function FO(t, e, n) {
        if (t.length === e.length) {
          for (let i = 0; i < t.length; i++) {
            const o = `data:${e[i].type};base64,${NO(e[i].hex)}`
            n.setAttribute('src', o, t[i])
          }
        }
      }
      const VO =
        /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i
      const HO = /xmlns:o="urn:schemas-microsoft-com/i
      class UO {
        constructor(t) {
          this.document = t
        }
        isActive(t) {
          return VO.test(t) || HO.test(t)
        }
        execute(t) {
          const { body: e, stylesString: n } = t._parsedData
          gO(e, n)
          BO(e, t.dataTransfer.getData('text/rtf'))
          t.content = e
        }
      }
      function WO(t) {
        return $O($O(t))
          .replace(
            /(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g,
            '$1$2'
          )
          .replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, '')
          .replace(/ <\//g, ' </')
          .replace(/ <o:p><\/o:p>/g, ' <o:p></o:p>')
          .replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, '')
          .replace(/>([^\S\r\n]*[\r\n]\s*)</g, '><')
      }
      function qO(t) {
        t.querySelectorAll('span[style*=spacerun]').forEach((t) => {
          const e = t
          const n = e.innerText.length || 0
          e.innerText = Array(n + 1)
            .join('  ')
            .substr(0, n)
        })
      }
      function $O(t) {
        return t.replace(
          /<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g,
          (t, e) =>
            e.length === 1
              ? ' '
              : Array(e.length + 1)
                  .join('  ')
                  .substr(0, e.length)
        )
      }
      function GO(t, e) {
        const n = new DOMParser()
        t = t.replace(/<!--\[if gte vml 1]>/g, '')
        const i = WO(QO(t))
        const o = n.parseFromString(i, 'text/html')
        qO(o)
        const r = o.body.innerHTML
        const s = YO(o, e)
        const a = KO(o)
        return {
          body: s,
          bodyString: r,
          styles: a.styles,
          stylesString: a.stylesString
        }
      }
      function YO(t, e) {
        const n = new qf(e)
        const i = new Gm(n, { renderingMode: 'data' })
        const o = t.createDocumentFragment()
        const r = t.body.childNodes
        while (r.length > 0) {
          o.appendChild(r[0])
        }
        return i.domToView(o, { skipComments: true })
      }
      function KO(t) {
        const e = []
        const n = []
        const i = Array.from(t.getElementsByTagName('style'))
        for (const t of i) {
          if (t.sheet && t.sheet.cssRules && t.sheet.cssRules.length) {
            e.push(t.sheet)
            n.push(t.innerHTML)
          }
        }
        return { styles: e, stylesString: n.join(' ') }
      }
      function QO(t) {
        const e = '</body>'
        const n = '</html>'
        const i = t.indexOf(e)
        if (i < 0) {
          return t
        }
        const o = t.indexOf(n, i + e.length)
        return t.substring(0, i + e.length) + (o >= 0 ? t.substring(o) : '')
      }
      class ZO extends Kd {
        static get pluginName() {
          return 'PasteFromOffice'
        }
        static get requires() {
          return [UD]
        }
        init() {
          const t = this.editor
          const e = t.editing.view.document
          const n = []
          n.push(new UO(e))
          n.push(new SO(e))
          t.plugins.get('ClipboardPipeline').on(
            'inputTransformation',
            (i, o) => {
              if (o._isTransformedWithPasteFromOffice) {
                return
              }
              const r = t.model.document.selection.getFirstPosition().parent
              if (r.is('element', 'codeBlock')) {
                return
              }
              const s = o.dataTransfer.getData('text/html')
              const a = n.find((t) => t.isActive(s))
              if (a) {
                o._parsedData = GO(s, e.stylesProcessor)
                a.execute(o)
                o._isTransformedWithPasteFromOffice = true
              }
            },
            { priority: 'high' }
          )
        }
      }
      class JO extends Kd {
        static get requires() {
          return [FI, fI]
        }
        static get pluginName() {
          return 'PictureEditing'
        }
        afterInit() {
          const t = this.editor
          if (t.plugins.has('ImageBlockEditing')) {
            t.model.schema.extend('imageBlock', {
              allowAttributes: ['sources']
            })
          }
          if (t.plugins.has('ImageInlineEditing')) {
            t.model.schema.extend('imageInline', {
              allowAttributes: ['sources']
            })
          }
          this._setupConversion()
          this._setupImageUploadEditingIntegration()
        }
        _setupConversion() {
          const t = this.editor
          const e = t.conversion
          const n = t.plugins.get('ImageUtils')
          e.for('upcast').add(NI(n))
          e.for('downcast').add(zI(n))
        }
        _setupImageUploadEditingIntegration() {
          const t = this.editor
          if (!t.plugins.has('ImageUploadEditing')) {
            return
          }
          this.listenTo(
            t.plugins.get('ImageUploadEditing'),
            'uploadComplete',
            (e, { imageElement: n, data: i }) => {
              const o = i.sources
              if (!o) {
                return
              }
              t.model.change((t) => {
                t.setAttributes({ sources: o }, n)
              })
            }
          )
        }
      }
      function XO(t, e, n, i, o = 1) {
        if (e > o) {
          i.setAttribute(t, e, n)
        } else {
          i.removeAttribute(t, n)
        }
      }
      function tR(t, e, n = {}) {
        const i = t.createElement('tableCell', n)
        t.insertElement('paragraph', i)
        t.insert(i, e)
        return i
      }
      function eR(t, e) {
        const n = e.parent.parent
        const i = parseInt(n.getAttribute('headingColumns') || 0)
        const { column: o } = t.getCellLocation(e)
        return !!i && o < i
      }
      function nR(t, e, n) {
        const { modelAttribute: i } = n
        t.extend('tableCell', { allowAttributes: [i] })
        upcastStyleToAttribute(e, { viewElement: /^(td|th)$/, ...n })
        downcastAttributeToStyle(e, { modelElement: 'tableCell', ...n })
      }
      function iR() {
        return (t) => {
          t.on('element:figure', (t, e, n) => {
            if (
              !n.consumable.test(e.viewItem, { name: true, classes: 'table' })
            ) {
              return
            }
            const i = aR(e.viewItem)
            if (!i || !n.consumable.test(i, { name: true })) {
              return
            }
            n.consumable.consume(e.viewItem, { name: true, classes: 'table' })
            const o = n.convertItem(i, e.modelCursor)
            const r = cl(o.modelRange.getItems())
            if (!r) {
              n.consumable.revert(e.viewItem, { name: true, classes: 'table' })
              return
            }
            n.convertChildren(e.viewItem, n.writer.createPositionAt(r, 'end'))
            n.updateConversionResult(r, e)
          })
        }
      }
      function oR() {
        return (t) => {
          t.on('element:table', (t, e, n) => {
            const i = e.viewItem
            if (!n.consumable.test(i, { name: true })) {
              return
            }
            const { rows: o, headingRows: r, headingColumns: s } = cR(i)
            const a = {}
            if (s) {
              a.headingColumns = s
            }
            if (r) {
              a.headingRows = r
            }
            const c = n.writer.createElement('table', a)
            if (!n.safeInsert(c, e.modelCursor)) {
              return
            }
            n.consumable.consume(i, { name: true })
            o.forEach((t) =>
              n.convertItem(t, n.writer.createPositionAt(c, 'end'))
            )
            n.convertChildren(i, n.writer.createPositionAt(c, 'end'))
            if (c.isEmpty) {
              const t = n.writer.createElement('tableRow')
              n.writer.insert(t, n.writer.createPositionAt(c, 'end'))
              tR(n.writer, n.writer.createPositionAt(t, 'end'))
            }
            n.updateConversionResult(c, e)
          })
        }
      }
      function rR() {
        return (t) => {
          t.on(
            'element:tr',
            (t, e) => {
              if (e.viewItem.isEmpty && e.modelCursor.index == 0) {
                t.stop()
              }
            },
            { priority: 'high' }
          )
        }
      }
      function sR(t) {
        return (e) => {
          e.on(
            `element:${t}`,
            (t, e, { writer: n }) => {
              if (!e.modelRange) {
                return
              }
              const i = e.modelRange.start.nodeAfter
              const o = n.createPositionAt(i, 0)
              if (e.viewItem.isEmpty) {
                n.insertElement('paragraph', o)
                return
              }
              const r = Array.from(i.getChildren())
              if (r.every((t) => t.is('element', '$marker'))) {
                const t = n.createElement('paragraph')
                n.insert(t, n.createPositionAt(i, 0))
                for (const e of r) {
                  n.move(n.createRangeOn(e), n.createPositionAt(t, 'end'))
                }
              }
            },
            { priority: 'low' }
          )
        }
      }
      function aR(t) {
        for (const e of t.getChildren()) {
          if (e.is('element', 'table')) {
            return e
          }
        }
      }
      function cR(t) {
        const e = { headingRows: 0, headingColumns: 0 }
        const n = []
        const i = []
        let o
        for (const r of Array.from(t.getChildren())) {
          if (r.name === 'tbody' || r.name === 'thead' || r.name === 'tfoot') {
            if (r.name === 'thead' && !o) {
              o = r
            }
            const t = Array.from(r.getChildren()).filter((t) =>
              t.is('element', 'tr')
            )
            for (const r of t) {
              if (r.parent.name === 'thead' && r.parent === o) {
                e.headingRows++
                n.push(r)
              } else {
                i.push(r)
                const t = lR(r, e, o)
                if (t > e.headingColumns) {
                  e.headingColumns = t
                }
              }
            }
          }
        }
        e.rows = [...n, ...i]
        return e
      }
      function lR(t) {
        let e = 0
        let n = 0
        const i = Array.from(t.getChildren()).filter(
          (t) => t.name === 'th' || t.name === 'td'
        )
        while (n < i.length && i[n].name === 'th') {
          const t = i[n]
          const o = parseInt(t.getAttribute('colspan') || 1)
          e = e + o
          n++
        }
        return e
      }
      class dR {
        constructor(t, e = {}) {
          this._table = t
          this._startRow = e.row !== undefined ? e.row : e.startRow || 0
          this._endRow = e.row !== undefined ? e.row : e.endRow
          this._startColumn =
            e.column !== undefined ? e.column : e.startColumn || 0
          this._endColumn = e.column !== undefined ? e.column : e.endColumn
          this._includeAllSlots = !!e.includeAllSlots
          this._skipRows = new Set()
          this._row = 0
          this._rowIndex = 0
          this._column = 0
          this._cellIndex = 0
          this._spannedCells = new Map()
          this._nextCellAtColumn = -1
        }
        [Symbol.iterator]() {
          return this
        }
        next() {
          const t = this._table.getChild(this._rowIndex)
          if (!t || this._isOverEndRow()) {
            return { done: true }
          }
          if (!t.is('element', 'tableRow')) {
            this._rowIndex++
            return this.next()
          }
          if (this._isOverEndColumn()) {
            return this._advanceToNextRow()
          }
          let e = null
          const n = this._getSpanned()
          if (n) {
            if (this._includeAllSlots && !this._shouldSkipSlot()) {
              e = this._formatOutValue(n.cell, n.row, n.column)
            }
          } else {
            const n = t.getChild(this._cellIndex)
            if (!n) {
              return this._advanceToNextRow()
            }
            const i = parseInt(n.getAttribute('colspan') || 1)
            const o = parseInt(n.getAttribute('rowspan') || 1)
            if (i > 1 || o > 1) {
              this._recordSpans(n, o, i)
            }
            if (!this._shouldSkipSlot()) {
              e = this._formatOutValue(n)
            }
            this._nextCellAtColumn = this._column + i
          }
          this._column++
          if (this._column == this._nextCellAtColumn) {
            this._cellIndex++
          }
          return e || this.next()
        }
        skipRow(t) {
          this._skipRows.add(t)
        }
        _advanceToNextRow() {
          this._row++
          this._rowIndex++
          this._column = 0
          this._cellIndex = 0
          this._nextCellAtColumn = -1
          return this.next()
        }
        _isOverEndRow() {
          return this._endRow !== undefined && this._row > this._endRow
        }
        _isOverEndColumn() {
          return this._endColumn !== undefined && this._column > this._endColumn
        }
        _formatOutValue(t, e = this._row, n = this._column) {
          return { done: false, value: new uR(this, t, e, n) }
        }
        _shouldSkipSlot() {
          const t = this._skipRows.has(this._row)
          const e = this._row < this._startRow
          const n = this._column < this._startColumn
          const i =
            this._endColumn !== undefined && this._column > this._endColumn
          return t || e || n || i
        }
        _getSpanned() {
          const t = this._spannedCells.get(this._row)
          if (!t) {
            return null
          }
          return t.get(this._column) || null
        }
        _recordSpans(t, e, n) {
          const i = { cell: t, row: this._row, column: this._column }
          for (let t = this._row; t < this._row + e; t++) {
            for (let e = this._column; e < this._column + n; e++) {
              if (t != this._row || e != this._column) {
                this._markSpannedCell(t, e, i)
              }
            }
          }
        }
        _markSpannedCell(t, e, n) {
          if (!this._spannedCells.has(t)) {
            this._spannedCells.set(t, new Map())
          }
          const i = this._spannedCells.get(t)
          i.set(e, n)
        }
      }
      class uR {
        constructor(t, e, n, i) {
          this.cell = e
          this.row = t._row
          this.column = t._column
          this.cellAnchorRow = n
          this.cellAnchorColumn = i
          this._cellIndex = t._cellIndex
          this._rowIndex = t._rowIndex
          this._table = t._table
        }
        get isAnchor() {
          return (
            this.row === this.cellAnchorRow &&
            this.column === this.cellAnchorColumn
          )
        }
        get cellWidth() {
          return parseInt(this.cell.getAttribute('colspan') || 1)
        }
        get cellHeight() {
          return parseInt(this.cell.getAttribute('rowspan') || 1)
        }
        get rowIndex() {
          return this._rowIndex
        }
        getPositionBefore() {
          const t = this._table.root.document.model
          return t.createPositionAt(
            this._table.getChild(this.row),
            this._cellIndex
          )
        }
      }
      function hR(t, e = {}) {
        return (n, { writer: i }) => {
          const o = n.getAttribute('headingRows') || 0
          const r = []
          if (o > 0) {
            r.push(
              i.createContainerElement(
                'thead',
                null,
                i.createSlot((t) => t.is('element', 'tableRow') && t.index < o)
              )
            )
          }
          if (o < t.getRows(n)) {
            r.push(
              i.createContainerElement(
                'tbody',
                null,
                i.createSlot((t) => t.is('element', 'tableRow') && t.index >= o)
              )
            )
          }
          const s = i.createContainerElement('figure', { class: 'table' }, [
            i.createContainerElement('table', null, r),
            i.createSlot((t) => !t.is('element', 'tableRow'))
          ])
          return e.asWidget ? bR(s, i) : s
        }
      }
      function fR() {
        return (t, { writer: e }) =>
          t.isEmpty
            ? e.createEmptyElement('tr')
            : e.createContainerElement('tr')
      }
      function mR(t = {}) {
        return (e, { writer: n }) => {
          const i = e.parent
          const o = i.parent
          const r = o.getChildIndex(i)
          const s = new dR(o, { row: r })
          const a = o.getAttribute('headingRows') || 0
          const c = o.getAttribute('headingColumns') || 0
          for (const i of s) {
            if (i.cell == e) {
              const e = i.row < a || i.column < c
              const o = e ? 'th' : 'td'
              return t.asWidget
                ? oT(n.createEditableElement(o), n)
                : n.createContainerElement(o)
            }
          }
        }
      }
      function gR(t = {}) {
        return (e, { writer: n }) => {
          if (!e.parent.is('element', 'tableCell')) {
            return
          }
          if (!pR(e)) {
            return
          }
          if (t.asWidget) {
            return n.createContainerElement('span', {
              class: 'ck-table-bogus-paragraph'
            })
          } else {
            const t = n.createContainerElement('p')
            n.setCustomProperty('dataPipeline:transparentRendering', true, t)
            return t
          }
        }
      }
      function pR(t) {
        const e = t.parent
        const n = e.childCount == 1
        return n && !kR(t)
      }
      function bR(t, e) {
        e.setCustomProperty('table', true, t)
        return JD(t, e, { hasSelectionHandle: true })
      }
      function kR(t) {
        return !![...t.getAttributeKeys()].length
      }
      class wR extends Zd {
        refresh() {
          const t = this.editor.model
          const e = t.document.selection
          const n = t.schema
          this.isEnabled = _R(e, n)
        }
        execute(t = {}) {
          const e = this.editor.model
          const n = this.editor.plugins.get('TableUtils')
          const i = this.editor.config.get('table')
          const o = i.defaultHeadings.rows
          const r = i.defaultHeadings.columns
          if (t.headingRows === undefined && o) {
            t.headingRows = o
          }
          if (t.headingColumns === undefined && r) {
            t.headingColumns = r
          }
          e.change((i) => {
            const o = n.createTable(i, t)
            e.insertObject(o, null, null, { findOptimalPosition: 'auto' })
            i.setSelection(i.createPositionAt(o.getNodeByPath([0, 0, 0]), 0))
          })
        }
      }
      function _R(t, e) {
        const n = t.getFirstPosition().parent
        const i = n === n.root ? n : n.parent
        return e.checkChild(i, 'table')
      }
      class AR extends Zd {
        constructor(t, e = {}) {
          super(t)
          this.order = e.order || 'below'
        }
        refresh() {
          const t = this.editor.model.document.selection
          const e = this.editor.plugins.get('TableUtils')
          const n = !!e.getSelectionAffectedTableCells(t).length
          this.isEnabled = n
        }
        execute() {
          const t = this.editor
          const e = t.model.document.selection
          const n = t.plugins.get('TableUtils')
          const i = this.order === 'above'
          const o = n.getSelectionAffectedTableCells(e)
          const r = n.getRowIndexes(o)
          const s = i ? r.first : r.last
          const a = o[0].findAncestor('table')
          n.insertRows(a, { at: i ? s : s + 1, copyStructureFromAbove: !i })
        }
      }
      class vR extends Zd {
        constructor(t, e = {}) {
          super(t)
          this.order = e.order || 'right'
        }
        refresh() {
          const t = this.editor.model.document.selection
          const e = this.editor.plugins.get('TableUtils')
          const n = !!e.getSelectionAffectedTableCells(t).length
          this.isEnabled = n
        }
        execute() {
          const t = this.editor
          const e = t.model.document.selection
          const n = t.plugins.get('TableUtils')
          const i = this.order === 'left'
          const o = n.getSelectionAffectedTableCells(e)
          const r = n.getColumnIndexes(o)
          const s = i ? r.first : r.last
          const a = o[0].findAncestor('table')
          n.insertColumns(a, { columns: 1, at: i ? s : s + 1 })
        }
      }
      class CR extends Zd {
        constructor(t, e = {}) {
          super(t)
          this.direction = e.direction || 'horizontally'
        }
        refresh() {
          const t = this.editor.plugins.get('TableUtils')
          const e = t.getSelectionAffectedTableCells(
            this.editor.model.document.selection
          )
          this.isEnabled = e.length === 1
        }
        execute() {
          const t = this.editor.plugins.get('TableUtils')
          const e = t.getSelectionAffectedTableCells(
            this.editor.model.document.selection
          )[0]
          const n = this.direction === 'horizontally'
          if (n) {
            t.splitCellHorizontally(e, 2)
          } else {
            t.splitCellVertically(e, 2)
          }
        }
      }
      function yR(t, e, n) {
        const { startRow: i, startColumn: o, endRow: r, endColumn: s } = e
        const a = n.createElement('table')
        const c = r - i + 1
        for (let t = 0; t < c; t++) {
          n.insertElement('tableRow', a, 'end')
        }
        const l = [
          ...new dR(t, {
            startRow: i,
            endRow: r,
            startColumn: o,
            endColumn: s,
            includeAllSlots: true
          })
        ]
        for (const {
          row: t,
          column: e,
          cell: c,
          isAnchor: d,
          cellAnchorRow: u,
          cellAnchorColumn: h
        } of l) {
          const l = t - i
          const f = a.getChild(l)
          if (!d) {
            if (u < i || h < o) {
              tR(n, n.createPositionAt(f, 'end'))
            }
          } else {
            const i = n.cloneElement(c)
            n.append(i, f)
            MR(i, t, e, r, s, n)
          }
        }
        IR(a, t, i, o, n)
        return a
      }
      function xR(t, e, n = 0) {
        const i = []
        const o = new dR(t, { startRow: n, endRow: e - 1 })
        for (const t of o) {
          const { row: n, cellHeight: o } = t
          const r = n + o - 1
          if (n < e && e <= r) {
            i.push(t)
          }
        }
        return i
      }
      function ER(t, e, n) {
        const i = t.parent
        const o = i.parent
        const r = i.index
        const s = parseInt(t.getAttribute('rowspan'))
        const a = e - r
        const c = {}
        const l = s - a
        if (l > 1) {
          c.rowspan = l
        }
        const d = parseInt(t.getAttribute('colspan') || 1)
        if (d > 1) {
          c.colspan = d
        }
        const u = r
        const h = u + a
        const f = [
          ...new dR(o, { startRow: u, endRow: h, includeAllSlots: true })
        ]
        let m = null
        let g
        for (const e of f) {
          const { row: i, column: o, cell: r } = e
          if (r === t && g === undefined) {
            g = o
          }
          if (g !== undefined && g === o && i === h) {
            m = tR(n, e.getPositionBefore(), c)
          }
        }
        XO('rowspan', a, t, n)
        return m
      }
      function DR(t, e) {
        const n = []
        const i = new dR(t)
        for (const t of i) {
          const { column: i, cellWidth: o } = t
          const r = i + o - 1
          if (i < e && e <= r) {
            n.push(t)
          }
        }
        return n
      }
      function TR(t, e, n, i) {
        const o = parseInt(t.getAttribute('colspan'))
        const r = n - e
        const s = {}
        const a = o - r
        if (a > 1) {
          s.colspan = a
        }
        const c = parseInt(t.getAttribute('rowspan') || 1)
        if (c > 1) {
          s.rowspan = c
        }
        const l = tR(i, i.createPositionAfter(t), s)
        XO('colspan', r, t, i)
        return l
      }
      function MR(t, e, n, i, o, r) {
        const s = parseInt(t.getAttribute('colspan') || 1)
        const a = parseInt(t.getAttribute('rowspan') || 1)
        const c = n + s - 1
        if (c > o) {
          const e = o - n + 1
          XO('colspan', e, t, r, 1)
        }
        const l = e + a - 1
        if (l > i) {
          const n = i - e + 1
          XO('rowspan', n, t, r, 1)
        }
      }
      function IR(t, e, n, i, o) {
        const r = parseInt(e.getAttribute('headingRows') || 0)
        if (r > 0) {
          const e = r - n
          XO('headingRows', e, t, o, 0)
        }
        const s = parseInt(e.getAttribute('headingColumns') || 0)
        if (s > 0) {
          const e = s - i
          XO('headingColumns', e, t, o, 0)
        }
      }
      function SR(t, e) {
        const n = e.getColumns(t)
        const i = new Array(n).fill(0)
        for (const { column: e } of new dR(t)) {
          i[e]++
        }
        const o = i.reduce((t, e, n) => (e ? t : [...t, n]), [])
        if (o.length > 0) {
          const n = o[o.length - 1]
          e.removeColumns(t, { at: n })
          return true
        }
        return false
      }
      function BR(t, e) {
        const n = []
        const i = e.getRows(t)
        for (let e = 0; e < i; e++) {
          const i = t.getChild(e)
          if (i.isEmpty) {
            n.push(e)
          }
        }
        if (n.length > 0) {
          const i = n[n.length - 1]
          e.removeRows(t, { at: i })
          return true
        }
        return false
      }
      function NR(t, e) {
        const n = SR(t, e)
        if (!n) {
          BR(t, e)
        }
      }
      function PR(t, e) {
        const n = Array.from(
          new dR(t, {
            startColumn: e.firstColumn,
            endColumn: e.lastColumn,
            row: e.lastRow
          })
        )
        const i = n.every(({ cellHeight: t }) => t === 1)
        if (i) {
          return e.lastRow
        }
        const o = n[0].cellHeight - 1
        return e.lastRow + o
      }
      function zR(t, e) {
        const n = Array.from(
          new dR(t, {
            startRow: e.firstRow,
            endRow: e.lastRow,
            column: e.lastColumn
          })
        )
        const i = n.every(({ cellWidth: t }) => t === 1)
        if (i) {
          return e.lastColumn
        }
        const o = n[0].cellWidth - 1
        return e.lastColumn + o
      }
      class LR extends Zd {
        constructor(t, e) {
          super(t)
          this.direction = e.direction
          this.isHorizontal =
            this.direction == 'right' || this.direction == 'left'
        }
        refresh() {
          const t = this._getMergeableCell()
          this.value = t
          this.isEnabled = !!t
        }
        execute() {
          const t = this.editor.model
          const e = t.document
          const n = this.editor.plugins.get('TableUtils')
          const i = n.getTableCellsContainingSelection(e.selection)[0]
          const o = this.value
          const r = this.direction
          t.change((t) => {
            const e = r == 'right' || r == 'down'
            const n = e ? i : o
            const s = e ? o : i
            const a = s.parent
            jR(s, n, t)
            const c = this.isHorizontal ? 'colspan' : 'rowspan'
            const l = parseInt(i.getAttribute(c) || 1)
            const d = parseInt(o.getAttribute(c) || 1)
            t.setAttribute(c, l + d, n)
            t.setSelection(t.createRangeIn(n))
            const u = this.editor.plugins.get('TableUtils')
            const h = a.findAncestor('table')
            NR(h, u)
          })
        }
        _getMergeableCell() {
          const t = this.editor.model
          const e = t.document
          const n = this.editor.plugins.get('TableUtils')
          const i = n.getTableCellsContainingSelection(e.selection)[0]
          if (!i) {
            return
          }
          const o = this.isHorizontal
            ? OR(i, this.direction, n)
            : RR(i, this.direction, n)
          if (!o) {
            return
          }
          const r = this.isHorizontal ? 'rowspan' : 'colspan'
          const s = parseInt(i.getAttribute(r) || 1)
          const a = parseInt(o.getAttribute(r) || 1)
          if (a === s) {
            return o
          }
        }
      }
      function OR(t, e, n) {
        const i = t.parent
        const o = i.parent
        const r = e == 'right' ? t.nextSibling : t.previousSibling
        const s = (o.getAttribute('headingColumns') || 0) > 0
        if (!r) {
          return
        }
        const a = e == 'right' ? t : r
        const c = e == 'right' ? r : t
        const { column: l } = n.getCellLocation(a)
        const { column: d } = n.getCellLocation(c)
        const u = parseInt(a.getAttribute('colspan') || 1)
        const h = eR(n, a, o)
        const f = eR(n, c, o)
        if (s && h != f) {
          return
        }
        const m = l + u === d
        return m ? r : undefined
      }
      function RR(t, e, n) {
        const i = t.parent
        const o = i.parent
        const r = o.getChildIndex(i)
        if ((e == 'down' && r === n.getRows(o) - 1) || (e == 'up' && r === 0)) {
          return
        }
        const s = parseInt(t.getAttribute('rowspan') || 1)
        const a = o.getAttribute('headingRows') || 0
        const c = e == 'down' && r + s === a
        const l = e == 'up' && r === a
        if (a && (c || l)) {
          return
        }
        const d = parseInt(t.getAttribute('rowspan') || 1)
        const u = e == 'down' ? r + d : r
        const h = [...new dR(o, { endRow: u })]
        const f = h.find((e) => e.cell === t)
        const m = f.column
        const g = h.find(({ row: t, cellHeight: n, column: i }) => {
          if (i !== m) {
            return false
          }
          if (e == 'down') {
            return t === u
          } else {
            return u === t + n
          }
        })
        return g && g.cell
      }
      function jR(t, e, n) {
        if (!FR(t)) {
          if (FR(e)) {
            n.remove(n.createRangeIn(e))
          }
          n.move(n.createRangeIn(t), n.createPositionAt(e, 'end'))
        }
        n.remove(t)
      }
      function FR(t) {
        return (
          t.childCount == 1 &&
          t.getChild(0).is('element', 'paragraph') &&
          t.getChild(0).isEmpty
        )
      }
      class VR extends Zd {
        refresh() {
          const t = this.editor.plugins.get('TableUtils')
          const e = t.getSelectionAffectedTableCells(
            this.editor.model.document.selection
          )
          const n = e[0]
          if (n) {
            const i = n.findAncestor('table')
            const o = this.editor.plugins.get('TableUtils').getRows(i)
            const r = o - 1
            const s = t.getRowIndexes(e)
            const a = s.first === 0 && s.last === r
            this.isEnabled = !a
          } else {
            this.isEnabled = false
          }
        }
        execute() {
          const t = this.editor.model
          const e = this.editor.plugins.get('TableUtils')
          const n = e.getSelectionAffectedTableCells(t.document.selection)
          const i = e.getRowIndexes(n)
          const o = n[0]
          const r = o.findAncestor('table')
          const s = e.getCellLocation(o).column
          t.change((t) => {
            const n = i.last - i.first + 1
            e.removeRows(r, { at: i.first, rows: n })
            const o = HR(r, i.first, s, e.getRows(r))
            t.setSelection(t.createPositionAt(o, 0))
          })
        }
      }
      function HR(t, e, n, i) {
        const o = t.getChild(Math.min(e, i - 1))
        let r = o.getChild(0)
        let s = 0
        for (const t of o.getChildren()) {
          if (s > n) {
            return r
          }
          r = t
          s += parseInt(t.getAttribute('colspan') || 1)
        }
        return r
      }
      class UR extends Zd {
        refresh() {
          const t = this.editor.plugins.get('TableUtils')
          const e = t.getSelectionAffectedTableCells(
            this.editor.model.document.selection
          )
          const n = e[0]
          if (n) {
            const i = n.findAncestor('table')
            const o = t.getColumns(i)
            const { first: r, last: s } = t.getColumnIndexes(e)
            this.isEnabled = s - r < o - 1
          } else {
            this.isEnabled = false
          }
        }
        execute() {
          const t = this.editor.plugins.get('TableUtils')
          const [e, n] = qR(this.editor.model.document.selection, t)
          const i = e.parent.parent
          const o = [...new dR(i)]
          const r = {
            first: o.find((t) => t.cell === e).column,
            last: o.find((t) => t.cell === n).column
          }
          const s = WR(o, e, n, r)
          this.editor.model.change((t) => {
            const e = r.last - r.first + 1
            this.editor.plugins
              .get('TableUtils')
              .removeColumns(i, { at: r.first, columns: e })
            t.setSelection(t.createPositionAt(s, 0))
          })
        }
      }
      function WR(t, e, n, i) {
        const o = parseInt(n.getAttribute('colspan') || 1)
        if (o > 1) {
          return n
        } else if (e.previousSibling || n.nextSibling) {
          return n.nextSibling || e.previousSibling
        } else {
          if (i.first) {
            return t.reverse().find(({ column: t }) => t < i.first).cell
          } else {
            return t.reverse().find(({ column: t }) => t > i.last).cell
          }
        }
      }
      function qR(t, e) {
        const n = e.getSelectionAffectedTableCells(t)
        const i = n[0]
        const o = n.pop()
        const r = [i, o]
        return i.isBefore(o) ? r : r.reverse()
      }
      class $R extends Zd {
        refresh() {
          const t = this.editor.plugins.get('TableUtils')
          const e = this.editor.model
          const n = t.getSelectionAffectedTableCells(e.document.selection)
          const i = n.length > 0
          this.isEnabled = i
          this.value =
            i && n.every((t) => this._isInHeading(t, t.parent.parent))
        }
        execute(t = {}) {
          if (t.forceValue === this.value) {
            return
          }
          const e = this.editor.plugins.get('TableUtils')
          const n = this.editor.model
          const i = e.getSelectionAffectedTableCells(n.document.selection)
          const o = i[0].findAncestor('table')
          const { first: r, last: s } = e.getRowIndexes(i)
          const a = this.value ? r : s + 1
          const c = o.getAttribute('headingRows') || 0
          n.change((t) => {
            if (a) {
              const e = a > c ? c : 0
              const n = xR(o, a, e)
              for (const { cell: e } of n) {
                ER(e, a, t)
              }
            }
            XO('headingRows', a, o, t, 0)
          })
        }
        _isInHeading(t, e) {
          const n = parseInt(e.getAttribute('headingRows') || 0)
          return !!n && t.parent.index < n
        }
      }
      class GR extends Zd {
        refresh() {
          const t = this.editor.model
          const e = this.editor.plugins.get('TableUtils')
          const n = e.getSelectionAffectedTableCells(t.document.selection)
          const i = n.length > 0
          this.isEnabled = i
          this.value = i && n.every((t) => eR(e, t))
        }
        execute(t = {}) {
          if (t.forceValue === this.value) {
            return
          }
          const e = this.editor.plugins.get('TableUtils')
          const n = this.editor.model
          const i = e.getSelectionAffectedTableCells(n.document.selection)
          const o = i[0].findAncestor('table')
          const { first: r, last: s } = e.getColumnIndexes(i)
          const a = this.value ? r : s + 1
          n.change((t) => {
            if (a) {
              const e = DR(o, a)
              for (const { cell: n, column: i } of e) {
                TR(n, i, a, t)
              }
            }
            XO('headingColumns', a, o, t, 0)
          })
        }
      }
      class YR extends Kd {
        static get pluginName() {
          return 'TableUtils'
        }
        init() {
          this.decorate('insertColumns')
          this.decorate('insertRows')
        }
        getCellLocation(t) {
          const e = t.parent
          const n = e.parent
          const i = n.getChildIndex(e)
          const o = new dR(n, { row: i })
          for (const { cell: e, row: n, column: i } of o) {
            if (e === t) {
              return { row: n, column: i }
            }
          }
        }
        createTable(t, e) {
          const n = t.createElement('table')
          const i = parseInt(e.rows) || 2
          const o = parseInt(e.columns) || 2
          KR(t, n, 0, i, o)
          if (e.headingRows) {
            XO('headingRows', Math.min(e.headingRows, i), n, t, 0)
          }
          if (e.headingColumns) {
            XO('headingColumns', Math.min(e.headingColumns, o), n, t, 0)
          }
          return n
        }
        insertRows(t, e = {}) {
          const n = this.editor.model
          const i = e.at || 0
          const o = e.rows || 1
          const r = e.copyStructureFromAbove !== undefined
          const s = e.copyStructureFromAbove ? i - 1 : i
          const a = this.getRows(t)
          const c = this.getColumns(t)
          if (i > a) {
            throw new N('tableutils-insertrows-insert-out-of-range', this, {
              options: e
            })
          }
          n.change((e) => {
            const n = t.getAttribute('headingRows') || 0
            if (n > i) {
              XO('headingRows', n + o, t, e, 0)
            }
            if (!r && (i === 0 || i === a)) {
              KR(e, t, i, o, c)
              return
            }
            const l = r ? Math.max(i, s) : i
            const d = new dR(t, { endRow: l })
            const u = new Array(c).fill(1)
            for (const {
              row: t,
              column: n,
              cellHeight: a,
              cellWidth: c,
              cell: l
            } of d) {
              const d = t + a - 1
              const h = t < i && i <= d
              const f = t <= s && s <= d
              if (h) {
                e.setAttribute('rowspan', a + o, l)
                u[n] = -c
              } else if (r && f) {
                u[n] = c
              }
            }
            for (let n = 0; n < o; n++) {
              const n = e.createElement('tableRow')
              e.insert(n, t, i)
              for (let t = 0; t < u.length; t++) {
                const i = u[t]
                const o = e.createPositionAt(n, 'end')
                if (i > 0) {
                  tR(e, o, i > 1 ? { colspan: i } : null)
                }
                t += Math.abs(i) - 1
              }
            }
          })
        }
        insertColumns(t, e = {}) {
          const n = this.editor.model
          const i = e.at || 0
          const o = e.columns || 1
          n.change((e) => {
            const n = t.getAttribute('headingColumns')
            if (i < n) {
              e.setAttribute('headingColumns', n + o, t)
            }
            const r = this.getColumns(t)
            if (i === 0 || r === i) {
              for (const n of t.getChildren()) {
                if (!n.is('element', 'tableRow')) {
                  continue
                }
                QR(o, e, e.createPositionAt(n, i ? 'end' : 0))
              }
              return
            }
            const s = new dR(t, { column: i, includeAllSlots: true })
            for (const t of s) {
              const {
                row: n,
                cell: r,
                cellAnchorColumn: a,
                cellAnchorRow: c,
                cellWidth: l,
                cellHeight: d
              } = t
              if (a < i) {
                e.setAttribute('colspan', l + o, r)
                const t = c + d - 1
                for (let e = n; e <= t; e++) {
                  s.skipRow(e)
                }
              } else {
                QR(o, e, t.getPositionBefore())
              }
            }
          })
        }
        removeRows(t, e) {
          const n = this.editor.model
          const i = e.rows || 1
          const o = this.getRows(t)
          const r = e.at
          const s = r + i - 1
          if (s > o - 1) {
            throw new N('tableutils-removerows-row-index-out-of-range', this, {
              table: t,
              options: e
            })
          }
          n.change((e) => {
            const { cellsToMove: n, cellsToTrim: i } = tj(t, r, s)
            if (n.size) {
              const i = s + 1
              ej(t, i, n, e)
            }
            for (let n = s; n >= r; n--) {
              e.remove(t.getChild(n))
            }
            for (const { rowspan: t, cell: n } of i) {
              XO('rowspan', t, n, e)
            }
            XR(t, r, s, e)
            if (!SR(t, this)) {
              BR(t, this)
            }
          })
        }
        removeColumns(t, e) {
          const n = this.editor.model
          const i = e.at
          const o = e.columns || 1
          const r = e.at + o - 1
          n.change((e) => {
            JR(t, { first: i, last: r }, e)
            for (let n = r; n >= i; n--) {
              for (const { cell: i, column: o, cellWidth: r } of [
                ...new dR(t)
              ]) {
                if (o <= n && r > 1 && o + r > n) {
                  XO('colspan', r - 1, i, e)
                } else if (o === n) {
                  e.remove(i)
                }
              }
            }
            if (!BR(t, this)) {
              SR(t, this)
            }
          })
        }
        splitCellVertically(t, e = 2) {
          const n = this.editor.model
          const i = t.parent
          const o = i.parent
          const r = parseInt(t.getAttribute('rowspan') || 1)
          const s = parseInt(t.getAttribute('colspan') || 1)
          n.change((n) => {
            if (s > 1) {
              const { newCellsSpan: i, updatedSpan: o } = ZR(s, e)
              XO('colspan', o, t, n)
              const a = {}
              if (i > 1) {
                a.colspan = i
              }
              if (r > 1) {
                a.rowspan = r
              }
              const c = s > e ? e - 1 : s - 1
              QR(c, n, n.createPositionAfter(t), a)
            }
            if (s < e) {
              const i = e - s
              const a = [...new dR(o)]
              const { column: c } = a.find(({ cell: e }) => e === t)
              const l = a.filter(({ cell: e, cellWidth: n, column: i }) => {
                const o = e !== t && i === c
                const r = i < c && i + n > c
                return o || r
              })
              for (const { cell: t, cellWidth: e } of l) {
                n.setAttribute('colspan', e + i, t)
              }
              const d = {}
              if (r > 1) {
                d.rowspan = r
              }
              QR(i, n, n.createPositionAfter(t), d)
              const u = o.getAttribute('headingColumns') || 0
              if (u > c) {
                XO('headingColumns', u + i, o, n)
              }
            }
          })
        }
        splitCellHorizontally(t, e = 2) {
          const n = this.editor.model
          const i = t.parent
          const o = i.parent
          const r = o.getChildIndex(i)
          const s = parseInt(t.getAttribute('rowspan') || 1)
          const a = parseInt(t.getAttribute('colspan') || 1)
          n.change((n) => {
            if (s > 1) {
              const i = [
                ...new dR(o, {
                  startRow: r,
                  endRow: r + s - 1,
                  includeAllSlots: true
                })
              ]
              const { newCellsSpan: c, updatedSpan: l } = ZR(s, e)
              XO('rowspan', l, t, n)
              const { column: d } = i.find(({ cell: e }) => e === t)
              const u = {}
              if (c > 1) {
                u.rowspan = c
              }
              if (a > 1) {
                u.colspan = a
              }
              for (const t of i) {
                const { column: e, row: i } = t
                const o = i >= r + l
                const s = e === d
                const a = (i + r + l) % c === 0
                if (o && s && a) {
                  QR(1, n, t.getPositionBefore(), u)
                }
              }
            }
            if (s < e) {
              const i = e - s
              const c = [...new dR(o, { startRow: 0, endRow: r })]
              for (const { cell: e, cellHeight: o, row: s } of c) {
                if (e !== t && s + o > r) {
                  const t = o + i
                  n.setAttribute('rowspan', t, e)
                }
              }
              const l = {}
              if (a > 1) {
                l.colspan = a
              }
              KR(n, o, r + 1, i, 1, l)
              const d = o.getAttribute('headingRows') || 0
              if (d > r) {
                XO('headingRows', d + i, o, n)
              }
            }
          })
        }
        getColumns(t) {
          const e = t.getChild(0)
          return [...e.getChildren()].reduce((t, e) => {
            const n = parseInt(e.getAttribute('colspan') || 1)
            return t + n
          }, 0)
        }
        getRows(t) {
          return Array.from(t.getChildren()).reduce(
            (t, e) => (e.is('element', 'tableRow') ? t + 1 : t),
            0
          )
        }
        createTableWalker(t, e = {}) {
          return new dR(t, e)
        }
        getSelectedTableCells(t) {
          const e = []
          for (const n of this.sortRanges(t.getRanges())) {
            const t = n.getContainedElement()
            if (t && t.is('element', 'tableCell')) {
              e.push(t)
            }
          }
          return e
        }
        getTableCellsContainingSelection(t) {
          const e = []
          for (const n of t.getRanges()) {
            const t = n.start.findAncestor('tableCell')
            if (t) {
              e.push(t)
            }
          }
          return e
        }
        getSelectionAffectedTableCells(t) {
          const e = this.getSelectedTableCells(t)
          if (e.length) {
            return e
          }
          return this.getTableCellsContainingSelection(t)
        }
        getRowIndexes(t) {
          const e = t.map((t) => t.parent.index)
          return this._getFirstLastIndexesObject(e)
        }
        getColumnIndexes(t) {
          const e = t[0].findAncestor('table')
          const n = [...new dR(e)]
          const i = n.filter((e) => t.includes(e.cell)).map((t) => t.column)
          return this._getFirstLastIndexesObject(i)
        }
        isSelectionRectangular(t) {
          if (t.length < 2 || !this._areCellInTheSameTableSection(t)) {
            return false
          }
          const e = new Set()
          const n = new Set()
          let i = 0
          for (const o of t) {
            const { row: t, column: r } = this.getCellLocation(o)
            const s = parseInt(o.getAttribute('rowspan') || 1)
            const a = parseInt(o.getAttribute('colspan') || 1)
            e.add(t)
            n.add(r)
            if (s > 1) {
              e.add(t + s - 1)
            }
            if (a > 1) {
              n.add(r + a - 1)
            }
            i += s * a
          }
          const o = ij(e, n)
          return o == i
        }
        sortRanges(t) {
          return Array.from(t).sort(nj)
        }
        _getFirstLastIndexesObject(t) {
          const e = t.sort((t, e) => t - e)
          const n = e[0]
          const i = e[e.length - 1]
          return { first: n, last: i }
        }
        _areCellInTheSameTableSection(t) {
          const e = t[0].findAncestor('table')
          const n = this.getRowIndexes(t)
          const i = parseInt(e.getAttribute('headingRows') || 0)
          if (!this._areIndexesInSameSection(n, i)) {
            return false
          }
          const o = parseInt(e.getAttribute('headingColumns') || 0)
          const r = this.getColumnIndexes(t)
          return this._areIndexesInSameSection(r, o)
        }
        _areIndexesInSameSection({ first: t, last: e }, n) {
          const i = t < n
          const o = e < n
          return i === o
        }
      }
      function KR(t, e, n, i, o, r = {}) {
        for (let s = 0; s < i; s++) {
          const i = t.createElement('tableRow')
          t.insert(i, e, n)
          QR(o, t, t.createPositionAt(i, 'end'), r)
        }
      }
      function QR(t, e, n, i = {}) {
        for (let o = 0; o < t; o++) {
          tR(e, n, i)
        }
      }
      function ZR(t, e) {
        if (t < e) {
          return { newCellsSpan: 1, updatedSpan: 1 }
        }
        const n = Math.floor(t / e)
        const i = t - n * e + n
        return { newCellsSpan: n, updatedSpan: i }
      }
      function JR(t, e, n) {
        const i = t.getAttribute('headingColumns') || 0
        if (i && e.first < i) {
          const o = Math.min(i - 1, e.last) - e.first + 1
          n.setAttribute('headingColumns', i - o, t)
        }
      }
      function XR(t, e, n, i) {
        const o = t.getAttribute('headingRows') || 0
        if (e < o) {
          const r = n < o ? o - (n - e + 1) : e
          XO('headingRows', r, t, i, 0)
        }
      }
      function tj(t, e, n) {
        const i = new Map()
        const o = []
        for (const { row: r, column: s, cellHeight: a, cell: c } of new dR(t, {
          endRow: n
        })) {
          const t = r + a - 1
          const l = r >= e && r <= n && t > n
          if (l) {
            const t = n - r + 1
            const e = a - t
            i.set(s, { cell: c, rowspan: e })
          }
          const d = r < e && t >= e
          if (d) {
            let i
            if (t >= n) {
              i = n - e + 1
            } else {
              i = t - e + 1
            }
            o.push({ cell: c, rowspan: a - i })
          }
        }
        return { cellsToMove: i, cellsToTrim: o }
      }
      function ej(t, e, n, i) {
        const o = new dR(t, { includeAllSlots: true, row: e })
        const r = [...o]
        const s = t.getChild(e)
        let a
        for (const { column: t, cell: e, isAnchor: o } of r) {
          if (n.has(t)) {
            const { cell: e, rowspan: o } = n.get(t)
            const r = a ? i.createPositionAfter(a) : i.createPositionAt(s, 0)
            i.move(i.createRangeOn(e), r)
            XO('rowspan', o, e, i)
            a = e
          } else if (o) {
            a = e
          }
        }
      }
      function nj(t, e) {
        const n = t.start
        const i = e.start
        return n.isBefore(i) ? -1 : 1
      }
      function ij(t, e) {
        const n = Array.from(t.values())
        const i = Array.from(e.values())
        const o = Math.max(...n)
        const r = Math.min(...n)
        const s = Math.max(...i)
        const a = Math.min(...i)
        return (o - r + 1) * (s - a + 1)
      }
      class oj extends Zd {
        refresh() {
          const t = this.editor.plugins.get(YR)
          const e = t.getSelectedTableCells(
            this.editor.model.document.selection
          )
          this.isEnabled = t.isSelectionRectangular(
            e,
            this.editor.plugins.get(YR)
          )
        }
        execute() {
          const t = this.editor.model
          const e = this.editor.plugins.get(YR)
          t.change((n) => {
            const i = e.getSelectedTableCells(t.document.selection)
            const o = i.shift()
            const { mergeWidth: r, mergeHeight: s } = aj(o, i, e)
            XO('colspan', r, o, n)
            XO('rowspan', s, o, n)
            for (const t of i) {
              rj(t, o, n)
            }
            const a = o.findAncestor('table')
            NR(a, e)
            n.setSelection(o, 'in')
          })
        }
      }
      function rj(t, e, n) {
        if (!sj(t)) {
          if (sj(e)) {
            n.remove(n.createRangeIn(e))
          }
          n.move(n.createRangeIn(t), n.createPositionAt(e, 'end'))
        }
        n.remove(t)
      }
      function sj(t) {
        return (
          t.childCount == 1 &&
          t.getChild(0).is('element', 'paragraph') &&
          t.getChild(0).isEmpty
        )
      }
      function aj(t, e, n) {
        let i = 0
        let o = 0
        for (const t of e) {
          const { row: e, column: r } = n.getCellLocation(t)
          i = cj(t, r, i, 'colspan')
          o = cj(t, e, o, 'rowspan')
        }
        const { row: r, column: s } = n.getCellLocation(t)
        const a = i - s
        const c = o - r
        return { mergeWidth: a, mergeHeight: c }
      }
      function cj(t, e, n, i) {
        const o = parseInt(t.getAttribute(i) || 1)
        return Math.max(n, e + o)
      }
      class lj extends Zd {
        constructor(t) {
          super(t)
          this.affectsData = false
        }
        refresh() {
          const t = this.editor.plugins.get('TableUtils')
          const e = t.getSelectionAffectedTableCells(
            this.editor.model.document.selection
          )
          this.isEnabled = e.length > 0
        }
        execute() {
          const t = this.editor.model
          const e = this.editor.plugins.get('TableUtils')
          const n = e.getSelectionAffectedTableCells(t.document.selection)
          const i = e.getRowIndexes(n)
          const o = n[0].findAncestor('table')
          const r = []
          for (let e = i.first; e <= i.last; e++) {
            for (const n of o.getChild(e).getChildren()) {
              r.push(t.createRangeOn(n))
            }
          }
          t.change((t) => {
            t.setSelection(r)
          })
        }
      }
      class dj extends Zd {
        constructor(t) {
          super(t)
          this.affectsData = false
        }
        refresh() {
          const t = this.editor.plugins.get('TableUtils')
          const e = t.getSelectionAffectedTableCells(
            this.editor.model.document.selection
          )
          this.isEnabled = e.length > 0
        }
        execute() {
          const t = this.editor.plugins.get('TableUtils')
          const e = this.editor.model
          const n = t.getSelectionAffectedTableCells(e.document.selection)
          const i = n[0]
          const o = n.pop()
          const r = i.findAncestor('table')
          const s = t.getCellLocation(i)
          const a = t.getCellLocation(o)
          const c = Math.min(s.column, a.column)
          const l = Math.max(s.column, a.column)
          const d = []
          for (const t of new dR(r, { startColumn: c, endColumn: l })) {
            d.push(e.createRangeOn(t.cell))
          }
          e.change((t) => {
            t.setSelection(d)
          })
        }
      }
      function uj(t) {
        t.document.registerPostFixer((e) => hj(e, t))
      }
      function hj(t, e) {
        const n = e.document.differ.getChanges()
        let i = false
        const o = new Set()
        for (const e of n) {
          let n
          if (e.name == 'table' && e.type == 'insert') {
            n = e.position.nodeAfter
          }
          if (e.name == 'tableRow' || e.name == 'tableCell') {
            n = e.position.findAncestor('table')
          }
          if (bj(e)) {
            n = e.range.start.findAncestor('table')
          }
          if (n && !o.has(n)) {
            i = fj(n, t) || i
            i = mj(n, t) || i
            o.add(n)
          }
        }
        return i
      }
      function fj(t, e) {
        let n = false
        const i = gj(t)
        if (i.length) {
          n = true
          for (const t of i) {
            XO('rowspan', t.rowspan, t.cell, e, 1)
          }
        }
        return n
      }
      function mj(t, e) {
        let n = false
        const i = pj(t)
        const o = []
        for (const [e, n] of i.entries()) {
          if (!n && t.getChild(e).is('element', 'tableRow')) {
            o.push(e)
          }
        }
        if (o.length) {
          n = true
          for (const n of o.reverse()) {
            e.remove(t.getChild(n))
            i.splice(n, 1)
          }
        }
        const r = i.filter((e, n) => t.getChild(n).is('element', 'tableRow'))
        const s = r[0]
        const a = r.every((t) => t === s)
        if (!a) {
          const i = r.reduce((t, e) => (e > t ? e : t), 0)
          for (const [o, s] of r.entries()) {
            const r = i - s
            if (r) {
              for (let n = 0; n < r; n++) {
                tR(e, e.createPositionAt(t.getChild(o), 'end'))
              }
              n = true
            }
          }
        }
        return n
      }
      function gj(t) {
        const e = parseInt(t.getAttribute('headingRows') || 0)
        const n = Array.from(t.getChildren()).reduce(
          (t, e) => (e.is('element', 'tableRow') ? t + 1 : t),
          0
        )
        const i = []
        for (const { row: o, cell: r, cellHeight: s } of new dR(t)) {
          if (s < 2) {
            continue
          }
          const t = o < e
          const a = t ? e : n
          if (o + s > a) {
            const t = a - o
            i.push({ cell: r, rowspan: t })
          }
        }
        return i
      }
      function pj(t) {
        const e = new Array(t.childCount).fill(0)
        for (const { rowIndex: n } of new dR(t, { includeAllSlots: true })) {
          e[n]++
        }
        return e
      }
      function bj(t) {
        const e = t.type === 'attribute'
        const n = t.attributeKey
        return e && (n === 'headingRows' || n === 'colspan' || n === 'rowspan')
      }
      function kj(t) {
        t.document.registerPostFixer((e) => wj(e, t))
      }
      function wj(t, e) {
        const n = e.document.differ.getChanges()
        let i = false
        for (const e of n) {
          if (e.type == 'insert' && e.name == 'table') {
            i = _j(e.position.nodeAfter, t) || i
          }
          if (e.type == 'insert' && e.name == 'tableRow') {
            i = Aj(e.position.nodeAfter, t) || i
          }
          if (e.type == 'insert' && e.name == 'tableCell') {
            i = vj(e.position.nodeAfter, t) || i
          }
          if (Cj(e)) {
            i = vj(e.position.parent, t) || i
          }
        }
        return i
      }
      function _j(t, e) {
        let n = false
        for (const i of t.getChildren()) {
          if (i.is('element', 'tableRow')) {
            n = Aj(i, e) || n
          }
        }
        return n
      }
      function Aj(t, e) {
        let n = false
        for (const i of t.getChildren()) {
          n = vj(i, e) || n
        }
        return n
      }
      function vj(t, e) {
        if (t.childCount == 0) {
          e.insertElement('paragraph', t)
          return true
        }
        const n = Array.from(t.getChildren()).filter((t) => t.is('$text'))
        for (const t of n) {
          e.wrap(e.createRangeOn(t), 'paragraph')
        }
        return !!n.length
      }
      function Cj(t) {
        if (!t.position || !t.position.parent.is('element', 'tableCell')) {
          return false
        }
        return (t.type == 'insert' && t.name == '$text') || t.type == 'remove'
      }
      function yj(t, e) {
        const n = t.document.differ
        for (const t of n.getChanges()) {
          let n
          let i = false
          if (t.type == 'attribute') {
            const e = t.range.start.nodeAfter
            if (!e || !e.is('element', 'table')) {
              continue
            }
            if (
              t.attributeKey != 'headingRows' &&
              t.attributeKey != 'headingColumns'
            ) {
              continue
            }
            n = e
            i = t.attributeKey == 'headingRows'
          } else if (t.name == 'tableRow' || t.name == 'tableCell') {
            n = t.position.findAncestor('table')
            i = t.name == 'tableRow'
          }
          if (!n) {
            continue
          }
          const o = n.getAttribute('headingRows') || 0
          const r = n.getAttribute('headingColumns') || 0
          const s = new dR(n)
          for (const t of s) {
            const n = t.row < o || t.column < r
            const s = n ? 'th' : 'td'
            const a = e.mapper.toViewElement(t.cell)
            if (a && a.is('element') && a.name != s) {
              e.reconvertItem(i ? t.cell.parent : t.cell)
            }
          }
        }
      }
      function xj(t, e) {
        const n = t.document.differ
        const i = new Set()
        for (const t of n.getChanges()) {
          const e =
            t.type == 'attribute' ? t.range.start.parent : t.position.parent
          if (e.is('element', 'tableCell')) {
            i.add(e)
          }
        }
        for (const t of i.values()) {
          const n = Array.from(t.getChildren()).filter((t) => Ej(t, e.mapper))
          for (const t of n) {
            e.reconvertItem(t)
          }
        }
      }
      function Ej(t, e) {
        if (!t.is('element', 'paragraph')) {
          return false
        }
        const n = e.toViewElement(t)
        if (!n) {
          return false
        }
        return pR(t) !== n.is('element', 'span')
      }
      var Dj = __webpack_require__(4777)
      var Tj = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Tj.insert = 'head'
      Tj.singleton = true
      var Mj = El()(Dj.Z, Tj)
      const Ij = Dj.Z.locals || {}
      class Sj extends Kd {
        static get pluginName() {
          return 'TableEditing'
        }
        static get requires() {
          return [YR]
        }
        init() {
          const t = this.editor
          const e = t.model
          const n = e.schema
          const i = t.conversion
          const o = t.plugins.get(YR)
          n.register('table', {
            inheritAllFrom: '$blockObject',
            allowAttributes: ['headingRows', 'headingColumns']
          })
          n.register('tableRow', { allowIn: 'table', isLimit: true })
          n.register('tableCell', {
            allowContentOf: '$container',
            allowIn: 'tableRow',
            allowAttributes: ['colspan', 'rowspan'],
            isLimit: true,
            isSelectable: true
          })
          i.for('upcast').add(iR())
          i.for('upcast').add(oR())
          i.for('editingDowncast').elementToStructure({
            model: { name: 'table', attributes: ['headingRows'] },
            view: hR(o, { asWidget: true })
          })
          i.for('dataDowncast').elementToStructure({
            model: { name: 'table', attributes: ['headingRows'] },
            view: hR(o)
          })
          i.for('upcast').elementToElement({ model: 'tableRow', view: 'tr' })
          i.for('upcast').add(rR())
          i.for('downcast').elementToElement({ model: 'tableRow', view: fR() })
          i.for('upcast').elementToElement({ model: 'tableCell', view: 'td' })
          i.for('upcast').elementToElement({ model: 'tableCell', view: 'th' })
          i.for('upcast').add(sR('td'))
          i.for('upcast').add(sR('th'))
          i.for('editingDowncast').elementToElement({
            model: 'tableCell',
            view: mR({ asWidget: true })
          })
          i.for('dataDowncast').elementToElement({
            model: 'tableCell',
            view: mR()
          })
          i.for('editingDowncast').elementToElement({
            model: 'paragraph',
            view: gR({ asWidget: true }),
            converterPriority: 'high'
          })
          i.for('dataDowncast').elementToElement({
            model: 'paragraph',
            view: gR(),
            converterPriority: 'high'
          })
          i.for('downcast').attributeToAttribute({
            model: 'colspan',
            view: 'colspan'
          })
          i.for('upcast').attributeToAttribute({
            model: { key: 'colspan', value: Bj('colspan') },
            view: 'colspan'
          })
          i.for('downcast').attributeToAttribute({
            model: 'rowspan',
            view: 'rowspan'
          })
          i.for('upcast').attributeToAttribute({
            model: { key: 'rowspan', value: Bj('rowspan') },
            view: 'rowspan'
          })
          t.config.define('table.defaultHeadings.rows', 0)
          t.config.define('table.defaultHeadings.columns', 0)
          t.commands.add('insertTable', new wR(t))
          t.commands.add('insertTableRowAbove', new AR(t, { order: 'above' }))
          t.commands.add('insertTableRowBelow', new AR(t, { order: 'below' }))
          t.commands.add('insertTableColumnLeft', new vR(t, { order: 'left' }))
          t.commands.add(
            'insertTableColumnRight',
            new vR(t, { order: 'right' })
          )
          t.commands.add('removeTableRow', new VR(t))
          t.commands.add('removeTableColumn', new UR(t))
          t.commands.add(
            'splitTableCellVertically',
            new CR(t, { direction: 'vertically' })
          )
          t.commands.add(
            'splitTableCellHorizontally',
            new CR(t, { direction: 'horizontally' })
          )
          t.commands.add('mergeTableCells', new oj(t))
          t.commands.add(
            'mergeTableCellRight',
            new LR(t, { direction: 'right' })
          )
          t.commands.add('mergeTableCellLeft', new LR(t, { direction: 'left' }))
          t.commands.add('mergeTableCellDown', new LR(t, { direction: 'down' }))
          t.commands.add('mergeTableCellUp', new LR(t, { direction: 'up' }))
          t.commands.add('setTableColumnHeader', new GR(t))
          t.commands.add('setTableRowHeader', new $R(t))
          t.commands.add('selectTableRow', new lj(t))
          t.commands.add('selectTableColumn', new dj(t))
          uj(e)
          kj(e)
          this.listenTo(e.document, 'change:data', () => {
            yj(e, t.editing)
            xj(e, t.editing)
          })
        }
      }
      function Bj(t) {
        return (e) => {
          const n = parseInt(e.getAttribute(t))
          if (Number.isNaN(n) || n <= 0) {
            return null
          }
          return n
        }
      }
      var Nj = __webpack_require__(8085)
      var Pj = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      Pj.insert = 'head'
      Pj.singleton = true
      var zj = El()(Nj.Z, Pj)
      const Lj = Nj.Z.locals || {}
      class Oj extends Sl {
        constructor(t) {
          super(t)
          const e = this.bindTemplate
          this.items = this._createGridCollection()
          this.keystrokes = new dl()
          this.focusTracker = new ll()
          this.set('rows', 0)
          this.set('columns', 0)
          this.bind('label').to(
            this,
            'columns',
            this,
            'rows',
            (t, e) => `${e} × ${t}`
          )
          this.setTemplate({
            tag: 'div',
            attributes: { class: ['ck'] },
            children: [
              {
                tag: 'div',
                attributes: { class: ['ck-insert-table-dropdown__grid'] },
                on: {
                  'mouseover@.ck-insert-table-dropdown-grid-box':
                    e.to('boxover')
                },
                children: this.items
              },
              {
                tag: 'div',
                attributes: {
                  class: ['ck', 'ck-insert-table-dropdown__label'],
                  'aria-hidden': true
                },
                children: [{ text: e.to('label') }]
              }
            ],
            on: {
              mousedown: e.to((t) => {
                t.preventDefault()
              }),
              click: e.to(() => {
                this.fire('execute')
              })
            }
          })
          this.on('boxover', (t, e) => {
            const { row: n, column: i } = e.target.dataset
            this.items
              .get((parseInt(n, 10) - 1) * 10 + (parseInt(i, 10) - 1))
              .focus()
          })
          this.focusTracker.on('change:focusedElement', (t, e, n) => {
            if (!n) {
              return
            }
            const { row: i, column: o } = n.dataset
            this.set({ rows: parseInt(i), columns: parseInt(o) })
          })
          this.on('change:columns', () => this._highlightGridBoxes())
          this.on('change:rows', () => this._highlightGridBoxes())
        }
        render() {
          super.render()
          i({
            keystrokeHandler: this.keystrokes,
            focusTracker: this.focusTracker,
            gridItems: this.items,
            numberOfColumns: 10,
            uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
          })
          for (const t of this.items) {
            this.focusTracker.add(t.element)
          }
          this.keystrokes.listenTo(this.element)
        }
        focus() {
          this.items.get(0).focus()
        }
        focusLast() {
          this.items.get(0).focus()
        }
        _highlightGridBoxes() {
          const t = this.rows
          const e = this.columns
          this.items.map((n, i) => {
            const o = Math.floor(i / 10)
            const r = i % 10
            const s = o < t && r < e
            n.set('isOn', s)
          })
        }
        _createGridButton(t, e, n, i) {
          const o = new pd(t)
          o.set({ label: i, class: 'ck-insert-table-dropdown-grid-box' })
          o.extendTemplate({ attributes: { 'data-row': e, 'data-column': n } })
          return o
        }
        _createGridCollection() {
          const t = []
          for (let e = 0; e < 100; e++) {
            const n = Math.floor(e / 10)
            const i = e % 10
            const o = `${n + 1} × ${i + 1}`
            t.push(this._createGridButton(this.locale, n + 1, i + 1, o))
          }
          return this.createCollection(t)
        }
      }
      const Rj =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>'
      const jj =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>'
      const Fj =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>'
      const Vj =
        '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>'
      class Hj extends Kd {
        static get pluginName() {
          return 'TableUI'
        }
        init() {
          const t = this.editor
          const e = this.editor.t
          const n = t.locale.contentLanguageDirection
          const i = n === 'ltr'
          t.ui.componentFactory.add('insertTable', (n) => {
            const i = t.commands.get('insertTable')
            const o = kC(n)
            o.bind('isEnabled').to(i)
            o.buttonView.set({
              icon: Rj,
              label: e('Insert table'),
              tooltip: true
            })
            let r
            o.on('change:isOpen', () => {
              if (r) {
                return
              }
              r = new Oj(n)
              o.panelView.children.add(r)
              r.delegate('execute').to(o)
              o.on('execute', () => {
                t.execute('insertTable', { rows: r.rows, columns: r.columns })
                t.editing.view.focus()
              })
            })
            return o
          })
          t.ui.componentFactory.add('tableColumn', (t) => {
            const n = [
              {
                type: 'switchbutton',
                model: {
                  commandName: 'setTableColumnHeader',
                  label: e('Header column'),
                  bindIsOn: true
                }
              },
              { type: 'separator' },
              {
                type: 'button',
                model: {
                  commandName: i
                    ? 'insertTableColumnLeft'
                    : 'insertTableColumnRight',
                  label: e('Insert column left')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: i
                    ? 'insertTableColumnRight'
                    : 'insertTableColumnLeft',
                  label: e('Insert column right')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: 'removeTableColumn',
                  label: e('Delete column')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: 'selectTableColumn',
                  label: e('Select column')
                }
              }
            ]
            return this._prepareDropdown(e('Column'), jj, n, t)
          })
          t.ui.componentFactory.add('tableRow', (t) => {
            const n = [
              {
                type: 'switchbutton',
                model: {
                  commandName: 'setTableRowHeader',
                  label: e('Header row'),
                  bindIsOn: true
                }
              },
              { type: 'separator' },
              {
                type: 'button',
                model: {
                  commandName: 'insertTableRowAbove',
                  label: e('Insert row above')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: 'insertTableRowBelow',
                  label: e('Insert row below')
                }
              },
              {
                type: 'button',
                model: { commandName: 'removeTableRow', label: e('Delete row') }
              },
              {
                type: 'button',
                model: { commandName: 'selectTableRow', label: e('Select row') }
              }
            ]
            return this._prepareDropdown(e('Row'), Fj, n, t)
          })
          t.ui.componentFactory.add('mergeTableCells', (t) => {
            const n = [
              {
                type: 'button',
                model: {
                  commandName: 'mergeTableCellUp',
                  label: e('Merge cell up')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: i ? 'mergeTableCellRight' : 'mergeTableCellLeft',
                  label: e('Merge cell right')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: 'mergeTableCellDown',
                  label: e('Merge cell down')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: i ? 'mergeTableCellLeft' : 'mergeTableCellRight',
                  label: e('Merge cell left')
                }
              },
              { type: 'separator' },
              {
                type: 'button',
                model: {
                  commandName: 'splitTableCellVertically',
                  label: e('Split cell vertically')
                }
              },
              {
                type: 'button',
                model: {
                  commandName: 'splitTableCellHorizontally',
                  label: e('Split cell horizontally')
                }
              }
            ]
            return this._prepareMergeSplitButtonDropdown(
              e('Merge cells'),
              Vj,
              n,
              t
            )
          })
        }
        _prepareDropdown(t, e, n, i) {
          const o = this.editor
          const r = kC(i)
          const s = this._fillDropdownWithListOptions(r, n)
          r.buttonView.set({ label: t, icon: e, tooltip: true })
          r.bind('isEnabled').toMany(s, 'isEnabled', (...t) => t.some((t) => t))
          this.listenTo(r, 'execute', (t) => {
            o.execute(t.source.commandName)
            if (!(t.source instanceof Ad)) {
              o.editing.view.focus()
            }
          })
          return r
        }
        _prepareMergeSplitButtonDropdown(t, e, n, i) {
          const o = this.editor
          const r = kC(i, Vd)
          const s = 'mergeTableCells'
          const a = o.commands.get(s)
          const c = this._fillDropdownWithListOptions(r, n)
          r.buttonView.set({
            label: t,
            icon: e,
            tooltip: true,
            isEnabled: true
          })
          r.bind('isEnabled').toMany([a, ...c], 'isEnabled', (...t) =>
            t.some((t) => t)
          )
          this.listenTo(r.buttonView, 'execute', () => {
            o.execute(s)
            o.editing.view.focus()
          })
          this.listenTo(r, 'execute', (t) => {
            o.execute(t.source.commandName)
            o.editing.view.focus()
          })
          return r
        }
        _fillDropdownWithListOptions(t, e) {
          const n = this.editor
          const i = []
          const o = new al()
          for (const t of e) {
            Uj(t, n, i, o)
          }
          AC(t, o)
          return i
        }
      }
      function Uj(t, e, n, i) {
        const o = (t.model = new By(t.model))
        const { commandName: r, bindIsOn: s } = t.model
        if (t.type === 'button' || t.type === 'switchbutton') {
          const t = e.commands.get(r)
          n.push(t)
          o.set({ commandName: r })
          o.bind('isEnabled').to(t)
          if (s) {
            o.bind('isOn').to(t, 'value')
          }
        }
        o.set({ withText: true })
        i.add(t)
      }
      var Wj = __webpack_require__(5593)
      var qj = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      qj.insert = 'head'
      qj.singleton = true
      var $j = El()(Wj.Z, qj)
      const Gj = Wj.Z.locals || {}
      class Yj extends Kd {
        static get pluginName() {
          return 'TableSelection'
        }
        static get requires() {
          return [YR, YR]
        }
        init() {
          const t = this.editor
          const e = t.model
          const n = t.editing.view
          this.listenTo(
            e,
            'deleteContent',
            (t, e) => this._handleDeleteContent(t, e),
            { priority: 'high' }
          )
          this.listenTo(
            n.document,
            'insertText',
            (t, e) => this._handleInsertTextEvent(t, e),
            { priority: 'high' }
          )
          this._defineSelectionConverter()
          this._enablePluginDisabling()
        }
        getSelectedTableCells() {
          const t = this.editor.plugins.get(YR)
          const e = this.editor.model.document.selection
          const n = t.getSelectedTableCells(e)
          if (n.length == 0) {
            return null
          }
          return n
        }
        getSelectionAsFragment() {
          const t = this.editor.plugins.get(YR)
          const e = this.getSelectedTableCells()
          if (!e) {
            return null
          }
          return this.editor.model.change((n) => {
            const i = n.createDocumentFragment()
            const { first: o, last: r } = t.getColumnIndexes(e)
            const { first: s, last: a } = t.getRowIndexes(e)
            const c = e[0].findAncestor('table')
            let l = a
            let d = r
            if (t.isSelectionRectangular(e)) {
              const t = {
                firstColumn: o,
                lastColumn: r,
                firstRow: s,
                lastRow: a
              }
              l = PR(c, t)
              d = zR(c, t)
            }
            const u = { startRow: s, startColumn: o, endRow: l, endColumn: d }
            const h = yR(c, u, n)
            n.insert(h, i, 0)
            return i
          })
        }
        setCellSelection(t, e) {
          const n = this._getCellsToSelect(t, e)
          this.editor.model.change((t) => {
            t.setSelection(
              n.cells.map((e) => t.createRangeOn(e)),
              { backward: n.backward }
            )
          })
        }
        getFocusCell() {
          const t = this.editor.model.document.selection
          const e = [...t.getRanges()].pop()
          const n = e.getContainedElement()
          if (n && n.is('element', 'tableCell')) {
            return n
          }
          return null
        }
        getAnchorCell() {
          const t = this.editor.model.document.selection
          const e = cl(t.getRanges())
          const n = e.getContainedElement()
          if (n && n.is('element', 'tableCell')) {
            return n
          }
          return null
        }
        _defineSelectionConverter() {
          const t = this.editor
          const e = new Set()
          t.conversion.for('editingDowncast').add((t) =>
            t.on(
              'selection',
              (t, i, o) => {
                const r = o.writer
                n(r)
                const s = this.getSelectedTableCells()
                if (!s) {
                  return
                }
                for (const t of s) {
                  const n = o.mapper.toViewElement(t)
                  r.addClass('ck-editor__editable_selected', n)
                  e.add(n)
                }
                const a = o.mapper.toViewElement(s[s.length - 1])
                r.setSelection(a, 0)
              },
              { priority: 'lowest' }
            )
          )
          function n(t) {
            for (const n of e) {
              t.removeClass('ck-editor__editable_selected', n)
            }
            e.clear()
          }
        }
        _enablePluginDisabling() {
          const t = this.editor
          this.on('change:isEnabled', () => {
            if (!this.isEnabled) {
              const e = this.getSelectedTableCells()
              if (!e) {
                return
              }
              t.model.change((n) => {
                const i = n.createPositionAt(e[0], 0)
                const o = t.model.schema.getNearestSelectionRange(i)
                n.setSelection(o)
              })
            }
          })
        }
        _handleDeleteContent(t, e) {
          const n = this.editor.plugins.get(YR)
          const [i, o] = e
          const r = this.editor.model
          const s = !o || o.direction == 'backward'
          const a = n.getSelectedTableCells(i)
          if (!a.length) {
            return
          }
          t.stop()
          r.change((t) => {
            const e = a[s ? a.length - 1 : 0]
            r.change((t) => {
              for (const e of a) {
                r.deleteContent(t.createSelection(e, 'in'))
              }
            })
            const n = r.schema.getNearestSelectionRange(
              t.createPositionAt(e, 0)
            )
            if (i.is('documentSelection')) {
              t.setSelection(n)
            } else {
              i.setTo(n)
            }
          })
        }
        _handleInsertTextEvent(t, e) {
          const n = this.editor
          const i = n.model
          const o = i.document.selection
          const r = this.getSelectedTableCells(o)
          if (!r) {
            return
          }
          const s = n.editing.view
          const a = n.editing.mapper
          const c = r.map((t) => s.createRangeOn(a.toViewElement(t)))
          e.selection = s.createSelection(c)
        }
        _getCellsToSelect(t, e) {
          const n = this.editor.plugins.get('TableUtils')
          const i = n.getCellLocation(t)
          const o = n.getCellLocation(e)
          const r = Math.min(i.row, o.row)
          const s = Math.max(i.row, o.row)
          const a = Math.min(i.column, o.column)
          const c = Math.max(i.column, o.column)
          const l = new Array(s - r + 1).fill(null).map(() => [])
          const d = { startRow: r, endRow: s, startColumn: a, endColumn: c }
          for (const { row: e, cell: n } of new dR(
            t.findAncestor('table'),
            d
          )) {
            l[e - r].push(n)
          }
          const u = o.row < i.row
          const h = o.column < i.column
          if (u) {
            l.reverse()
          }
          if (h) {
            l.forEach((t) => t.reverse())
          }
          return { cells: l.flat(), backward: u || h }
        }
      }
      class Kj extends Kd {
        static get pluginName() {
          return 'TableClipboard'
        }
        static get requires() {
          return [Yj, YR]
        }
        init() {
          const t = this.editor
          const e = t.editing.view.document
          this.listenTo(e, 'copy', (t, e) => this._onCopyCut(t, e))
          this.listenTo(e, 'cut', (t, e) => this._onCopyCut(t, e))
          this.listenTo(
            t.model,
            'insertContent',
            (t, e) => this._onInsertContent(t, ...e),
            { priority: 'high' }
          )
          this.decorate('_replaceTableSlotCell')
        }
        _onCopyCut(t, e) {
          const n = this.editor.plugins.get(Yj)
          if (!n.getSelectedTableCells()) {
            return
          }
          if (t.name == 'cut' && this.editor.isReadOnly) {
            return
          }
          e.preventDefault()
          t.stop()
          const i = this.editor.data
          const o = this.editor.editing.view.document
          const r = i.toView(n.getSelectionAsFragment())
          o.fire('clipboardOutput', {
            dataTransfer: e.dataTransfer,
            content: r,
            method: t.name
          })
        }
        _onInsertContent(t, e, n) {
          if (n && !n.is('documentSelection')) {
            return
          }
          const i = this.editor.model
          const o = this.editor.plugins.get(YR)
          let r = Qj(e, i)
          if (!r) {
            return
          }
          const s = o.getSelectionAffectedTableCells(i.document.selection)
          if (!s.length) {
            NR(r, o)
            return
          }
          t.stop()
          i.change((t) => {
            const e = { width: o.getColumns(r), height: o.getRows(r) }
            const n = Zj(s, e, t, o)
            const i = n.lastRow - n.firstRow + 1
            const a = n.lastColumn - n.firstColumn + 1
            const c = {
              startRow: 0,
              startColumn: 0,
              endRow: Math.min(i, e.height) - 1,
              endColumn: Math.min(a, e.width) - 1
            }
            r = yR(r, c, t)
            const l = s[0].findAncestor('table')
            const d = this._replaceSelectedCellsWithPasted(r, e, l, n, t)
            if (this.editor.plugins.get('TableSelection').isEnabled) {
              const e = o.sortRanges(d.map((e) => t.createRangeOn(e)))
              t.setSelection(e)
            } else {
              t.setSelection(d[0], 0)
            }
          })
        }
        _replaceSelectedCellsWithPasted(t, e, n, i, o) {
          const { width: r, height: s } = e
          const a = Xj(t, r, s)
          const c = [
            ...new dR(n, {
              startRow: i.firstRow,
              endRow: i.lastRow,
              startColumn: i.firstColumn,
              endColumn: i.lastColumn,
              includeAllSlots: true
            })
          ]
          const l = []
          let d
          for (const t of c) {
            const { row: e, column: n } = t
            if (n === i.firstColumn) {
              d = t.getPositionBefore()
            }
            const c = e - i.firstRow
            const u = n - i.firstColumn
            const h = a[c % s][u % r]
            const f = h ? o.cloneElement(h) : null
            const m = this._replaceTableSlotCell(t, f, d, o)
            if (!m) {
              continue
            }
            MR(m, e, n, i.lastRow, i.lastColumn, o)
            l.push(m)
            d = o.createPositionAfter(m)
          }
          const u = parseInt(n.getAttribute('headingRows') || 0)
          const h = parseInt(n.getAttribute('headingColumns') || 0)
          const f = i.firstRow < u && u <= i.lastRow
          const m = i.firstColumn < h && h <= i.lastColumn
          if (f) {
            const t = { first: i.firstColumn, last: i.lastColumn }
            const e = eF(n, u, t, o, i.firstRow)
            l.push(...e)
          }
          if (m) {
            const t = { first: i.firstRow, last: i.lastRow }
            const e = nF(n, h, t, o)
            l.push(...e)
          }
          return l
        }
        _replaceTableSlotCell(t, e, n, i) {
          const { cell: o, isAnchor: r } = t
          if (r) {
            i.remove(o)
          }
          if (!e) {
            return null
          }
          i.insert(e, n)
          return e
        }
        getTableIfOnlyTableInContent(t, e) {
          return Qj(t, e)
        }
      }
      function Qj(t, e) {
        if (!t.is('documentFragment') && !t.is('element')) {
          return null
        }
        if (t.is('element', 'table')) {
          return t
        }
        if (t.childCount == 1 && t.getChild(0).is('element', 'table')) {
          return t.getChild(0)
        }
        const n = e.createRangeIn(t)
        for (const t of n.getItems()) {
          if (t.is('element', 'table')) {
            const i = e.createRange(n.start, e.createPositionBefore(t))
            if (e.hasContent(i, { ignoreWhitespaces: true })) {
              return null
            }
            const o = e.createRange(e.createPositionAfter(t), n.end)
            if (e.hasContent(o, { ignoreWhitespaces: true })) {
              return null
            }
            return t
          }
        }
        return null
      }
      function Zj(t, e, n, i) {
        const o = t[0].findAncestor('table')
        const r = i.getColumnIndexes(t)
        const s = i.getRowIndexes(t)
        const a = {
          firstColumn: r.first,
          lastColumn: r.last,
          firstRow: s.first,
          lastRow: s.last
        }
        const c = t.length === 1
        if (c) {
          a.lastRow += e.height - 1
          a.lastColumn += e.width - 1
          Jj(o, a.lastRow + 1, a.lastColumn + 1, i)
        }
        if (c || !i.isSelectionRectangular(t)) {
          tF(o, a, n)
        } else {
          a.lastRow = PR(o, a)
          a.lastColumn = zR(o, a)
        }
        return a
      }
      function Jj(t, e, n, i) {
        const o = i.getColumns(t)
        const r = i.getRows(t)
        if (n > o) {
          i.insertColumns(t, { at: o, columns: n - o })
        }
        if (e > r) {
          i.insertRows(t, { at: r, rows: e - r })
        }
      }
      function Xj(t, e, n) {
        const i = new Array(n).fill(null).map(() => new Array(e).fill(null))
        for (const { column: e, row: n, cell: o } of new dR(t)) {
          i[n][e] = o
        }
        return i
      }
      function tF(t, e, n) {
        const { firstRow: i, lastRow: o, firstColumn: r, lastColumn: s } = e
        const a = { first: i, last: o }
        const c = { first: r, last: s }
        nF(t, r, a, n)
        nF(t, s + 1, a, n)
        eF(t, i, c, n)
        eF(t, o + 1, c, n, i)
      }
      function eF(t, e, n, i, o = 0) {
        if (e < 1) {
          return
        }
        const r = xR(t, e, o)
        const s = r.filter(({ column: t, cellWidth: e }) => iF(t, e, n))
        return s.map(({ cell: t }) => ER(t, e, i))
      }
      function nF(t, e, n, i) {
        if (e < 1) {
          return
        }
        const o = DR(t, e)
        const r = o.filter(({ row: t, cellHeight: e }) => iF(t, e, n))
        return r.map(({ cell: t, column: n }) => TR(t, n, e, i))
      }
      function iF(t, e, n) {
        const i = t + e - 1
        const { first: o, last: r } = n
        const s = t >= o && t <= r
        const a = t < o && i >= o
        return s || a
      }
      class oF extends Kd {
        static get pluginName() {
          return 'TableKeyboard'
        }
        static get requires() {
          return [Yj, YR]
        }
        init() {
          const t = this.editor.editing.view
          const e = t.document
          this.listenTo(e, 'arrowKey', (...t) => this._onArrowKey(...t), {
            context: 'table'
          })
          this.listenTo(
            e,
            'tab',
            (...t) => this._handleTabOnSelectedTable(...t),
            { context: 'figure' }
          )
          this.listenTo(e, 'tab', (...t) => this._handleTab(...t), {
            context: ['th', 'td']
          })
        }
        _handleTabOnSelectedTable(t, e) {
          const n = this.editor
          const i = n.model.document.selection
          const o = i.getSelectedElement()
          if (!o || !o.is('element', 'table')) {
            return
          }
          e.preventDefault()
          e.stopPropagation()
          t.stop()
          n.model.change((t) => {
            t.setSelection(t.createRangeIn(o.getChild(0).getChild(0)))
          })
        }
        _handleTab(t, e) {
          const n = this.editor
          const i = this.editor.plugins.get(YR)
          const o = n.model.document.selection
          const r = !e.shiftKey
          let s = i.getTableCellsContainingSelection(o)[0]
          if (!s) {
            s = this.editor.plugins.get('TableSelection').getFocusCell()
          }
          if (!s) {
            return
          }
          e.preventDefault()
          e.stopPropagation()
          t.stop()
          const a = s.parent
          const c = a.parent
          const l = c.getChildIndex(a)
          const d = a.getChildIndex(s)
          const u = d === 0
          if (!r && u && l === 0) {
            n.model.change((t) => {
              t.setSelection(t.createRangeOn(c))
            })
            return
          }
          const h = d === a.childCount - 1
          const f = l === i.getRows(c) - 1
          if (r && f && h) {
            n.execute('insertTableRowBelow')
            if (l === i.getRows(c) - 1) {
              n.model.change((t) => {
                t.setSelection(t.createRangeOn(c))
              })
              return
            }
          }
          let m
          if (r && h) {
            const t = c.getChild(l + 1)
            m = t.getChild(0)
          } else if (!r && u) {
            const t = c.getChild(l - 1)
            m = t.getChild(t.childCount - 1)
          } else {
            m = a.getChild(d + (r ? 1 : -1))
          }
          n.model.change((t) => {
            t.setSelection(t.createRangeIn(m))
          })
        }
        _onArrowKey(t, e) {
          const n = this.editor
          const i = e.keyCode
          const o = $c(i, n.locale.contentLanguageDirection)
          const r = this._handleArrowKeys(o, e.shiftKey)
          if (r) {
            e.preventDefault()
            e.stopPropagation()
            t.stop()
          }
        }
        _handleArrowKeys(t, e) {
          const n = this.editor.plugins.get(YR)
          const i = this.editor.model
          const o = i.document.selection
          const r = ['right', 'down'].includes(t)
          const s = n.getSelectedTableCells(o)
          if (s.length) {
            let n
            if (e) {
              n = this.editor.plugins.get('TableSelection').getFocusCell()
            } else {
              n = r ? s[s.length - 1] : s[0]
            }
            this._navigateFromCellInDirection(n, t, e)
            return true
          }
          const a = o.focus.findAncestor('tableCell')
          if (!a) {
            return false
          }
          if (!o.isCollapsed) {
            if (e) {
              if (o.isBackward == r && !o.containsEntireContent(a)) {
                return false
              }
            } else {
              const t = o.getSelectedElement()
              if (!t || !i.schema.isObject(t)) {
                return false
              }
            }
          }
          if (this._isSelectionAtCellEdge(o, a, r)) {
            this._navigateFromCellInDirection(a, t, e)
            return true
          }
          return false
        }
        _isSelectionAtCellEdge(t, e, n) {
          const i = this.editor.model
          const o = this.editor.model.schema
          const r = n ? t.getLastPosition() : t.getFirstPosition()
          if (!o.getLimitElement(r).is('element', 'tableCell')) {
            const t = i.createPositionAt(e, n ? 'end' : 0)
            return t.isTouching(r)
          }
          const s = i.createSelection(r)
          i.modifySelection(s, { direction: n ? 'forward' : 'backward' })
          return r.isEqual(s.focus)
        }
        _navigateFromCellInDirection(t, e, n = false) {
          const i = this.editor.model
          const o = t.findAncestor('table')
          const r = [...new dR(o, { includeAllSlots: true })]
          const { row: s, column: a } = r[r.length - 1]
          const c = r.find(({ cell: e }) => e == t)
          let { row: l, column: d } = c
          switch (e) {
            case 'left':
              d--
              break
            case 'up':
              l--
              break
            case 'right':
              d += c.cellWidth
              break
            case 'down':
              l += c.cellHeight
              break
          }
          const u = l < 0 || l > s
          const h = d < 0 && l <= 0
          const f = d > a && l >= s
          if (u || h || f) {
            i.change((t) => {
              t.setSelection(t.createRangeOn(o))
            })
            return
          }
          if (d < 0) {
            d = n ? 0 : a
            l--
          } else if (d > a) {
            d = n ? a : 0
            l++
          }
          const m = r.find((t) => t.row == l && t.column == d).cell
          const g = ['right', 'down'].includes(e)
          const p = this.editor.plugins.get('TableSelection')
          if (n && p.isEnabled) {
            const e = p.getAnchorCell() || t
            p.setCellSelection(e, m)
          } else {
            const t = i.createPositionAt(m, g ? 0 : 'end')
            i.change((e) => {
              e.setSelection(t)
            })
          }
        }
      }
      class rF extends ig {
        constructor(t) {
          super(t)
          this.domEventType = ['mousemove', 'mouseleave']
        }
        onDomEvent(t) {
          this.fire(t.type, t)
        }
      }
      class sF extends Kd {
        static get pluginName() {
          return 'TableMouse'
        }
        static get requires() {
          return [Yj, YR]
        }
        init() {
          const t = this.editor
          t.editing.view.addObserver(rF)
          this._enableShiftClickSelection()
          this._enableMouseDragSelection()
        }
        _enableShiftClickSelection() {
          const t = this.editor
          const e = t.plugins.get(YR)
          let n = false
          const i = t.plugins.get(Yj)
          this.listenTo(t.editing.view.document, 'mousedown', (o, r) => {
            const s = t.model.document.selection
            if (!this.isEnabled || !i.isEnabled) {
              return
            }
            if (!r.domEvent.shiftKey) {
              return
            }
            const a =
              i.getAnchorCell() || e.getTableCellsContainingSelection(s)[0]
            if (!a) {
              return
            }
            const c = this._getModelTableCellFromDomEvent(r)
            if (c && aF(a, c)) {
              n = true
              i.setCellSelection(a, c)
              r.preventDefault()
            }
          })
          this.listenTo(t.editing.view.document, 'mouseup', () => {
            n = false
          })
          this.listenTo(
            t.editing.view.document,
            'selectionChange',
            (t) => {
              if (n) {
                t.stop()
              }
            },
            { priority: 'highest' }
          )
        }
        _enableMouseDragSelection() {
          const t = this.editor
          let e, n
          let i = false
          let o = false
          const r = t.plugins.get(Yj)
          this.listenTo(t.editing.view.document, 'mousedown', (t, n) => {
            if (!this.isEnabled || !r.isEnabled) {
              return
            }
            if (
              n.domEvent.shiftKey ||
              n.domEvent.ctrlKey ||
              n.domEvent.altKey
            ) {
              return
            }
            e = this._getModelTableCellFromDomEvent(n)
          })
          this.listenTo(t.editing.view.document, 'mousemove', (t, s) => {
            if (!s.domEvent.buttons) {
              return
            }
            if (!e) {
              return
            }
            const a = this._getModelTableCellFromDomEvent(s)
            if (a && aF(e, a)) {
              n = a
              if (!i && n != e) {
                i = true
              }
            }
            if (!i) {
              return
            }
            o = true
            r.setCellSelection(e, n)
            s.preventDefault()
          })
          this.listenTo(t.editing.view.document, 'mouseup', () => {
            i = false
            o = false
            e = null
            n = null
          })
          this.listenTo(
            t.editing.view.document,
            'selectionChange',
            (t) => {
              if (o) {
                t.stop()
              }
            },
            { priority: 'highest' }
          )
        }
        _getModelTableCellFromDomEvent(t) {
          const e = t.target
          const n = this.editor.editing.view.createPositionAt(e, 0)
          const i = this.editor.editing.mapper.toModelPosition(n)
          const o = i.parent
          return o.findAncestor('tableCell', { includeSelf: true })
        }
      }
      function aF(t, e) {
        return t.parent.parent == e.parent.parent
      }
      var cF = __webpack_require__(4104)
      var lF = {
        injectType: 'singletonStyleTag',
        attributes: { 'data-cke': true }
      }
      lF.insert = 'head'
      lF.singleton = true
      var dF = El()(cF.Z, lF)
      const uF = cF.Z.locals || {}
      class hF extends Kd {
        static get requires() {
          return [Sj, Hj, Yj, sF, oF, Kj, RT]
        }
        static get pluginName() {
          return 'Table'
        }
      }
      function fF(t) {
        const e = t.getSelectedElement()
        if (e && gF(e)) {
          return e
        }
        return null
      }
      function mF(t) {
        const e = t.getFirstPosition()
        if (!e) {
          return null
        }
        let n = e.parent
        while (n) {
          if (n.is('element') && gF(n)) {
            return n
          }
          n = n.parent
        }
        return null
      }
      function gF(t) {
        return !!t.getCustomProperty('table') && ZD(t)
      }
      class pF extends Kd {
        static get requires() {
          return [VT]
        }
        static get pluginName() {
          return 'TableToolbar'
        }
        afterInit() {
          const t = this.editor
          const e = t.t
          const n = t.plugins.get(VT)
          const i = t.config.get('table.contentToolbar')
          const o = t.config.get('table.tableToolbar')
          if (i) {
            n.register('tableContent', {
              ariaLabel: e('Table toolbar'),
              items: i,
              getRelatedElement: mF
            })
          }
          if (o) {
            n.register('table', {
              ariaLabel: e('Table toolbar'),
              items: o,
              getRelatedElement: fF
            })
          }
        }
      }
      class bF extends bx {}
      bF.builtinPlugins = [
        fE,
        OE,
        UE,
        yD,
        LD,
        WM,
        aI,
        QI,
        rS,
        OS,
        RS,
        vB,
        DB,
        NB,
        yP,
        kz,
        IL,
        dO,
        YM,
        ZO,
        JO,
        hF,
        pF,
        Xx
      ]
      bF.defaultConfig = {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            '|',
            'outdent',
            'indent',
            '|',
            'imageUpload',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'undo',
            'redo'
          ]
        },
        language: 'en',
        image: {
          toolbar: [
            'imageTextAlternative',
            'toggleImageCaption',
            'imageStyle:inline',
            'imageStyle:block',
            'imageStyle:side'
          ]
        },
        table: {
          contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
        }
      }
      const kF = bF
    })()
    __webpack_exports__ = __webpack_exports__['default']
    return __webpack_exports__
  })()
)
//# sourceMappingURL=ckeditor.js.map
